
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb7c5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb7c5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5hfm1", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $d03dbe8a2e59fe5b$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "proxyPrototype", function () { return $d03dbe8a2e59fe5b$export$2a489b3f92f4996a; });
$parcel$export(module.exports, "toHyphenCase", function () { return $d03dbe8a2e59fe5b$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $d03dbe8a2e59fe5b$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $d03dbe8a2e59fe5b$export$89912e019eef22aa; });
$parcel$export(module.exports, "likeArray", function () { return $d03dbe8a2e59fe5b$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $d03dbe8a2e59fe5b$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "splitArray", function () { return $d03dbe8a2e59fe5b$export$697c3df919c0e61a; });
$parcel$export(module.exports, "countBy", function () { return $d03dbe8a2e59fe5b$export$1d012a0dff3dab06; });
$parcel$export(module.exports, "createAsyncIterator", function () { return $d03dbe8a2e59fe5b$export$86c18c6347f4a8c4; });
$parcel$export(module.exports, "ByteSize", function () { return $d03dbe8a2e59fe5b$export$271f7c16f175f804; });
$parcel$export(module.exports, "Second", function () { return $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a; });
$parcel$export(module.exports, "parseJSON", function () { return $d03dbe8a2e59fe5b$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseDOM", function () { return $d03dbe8a2e59fe5b$export$d66b332881d9723f; });
$parcel$export(module.exports, "stringifyDOM", function () { return $d03dbe8a2e59fe5b$export$b0709844452f8b6b; });
$parcel$export(module.exports, "formToJSON", function () { return $d03dbe8a2e59fe5b$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $d03dbe8a2e59fe5b$export$d635d04af3887bbe; });
function $d03dbe8a2e59fe5b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $d03dbe8a2e59fe5b$export$61cc6ed0f143570b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $d03dbe8a2e59fe5b$export$dd1bc94b04021eeb;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $d03dbe8a2e59fe5b$export$a09f818797e212c4;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $d03dbe8a2e59fe5b$export$170f4e08cad8229d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $d03dbe8a2e59fe5b$export$2a489b3f92f4996a;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $d03dbe8a2e59fe5b$export$67a6ce548ae77071;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $d03dbe8a2e59fe5b$export$a48f0734ac7c2329;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $d03dbe8a2e59fe5b$export$3f34ca2fef821bbd;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $d03dbe8a2e59fe5b$export$86f54f62aa7a7514;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $d03dbe8a2e59fe5b$export$89912e019eef22aa;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $d03dbe8a2e59fe5b$export$8fb536984ec8b4d7;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "toBase64", function() {
    return $d03dbe8a2e59fe5b$export$37cc283d8fbd3462;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $d03dbe8a2e59fe5b$export$94fdf11bafc8de6b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $d03dbe8a2e59fe5b$export$1c8ba402144543e5;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $d03dbe8a2e59fe5b$export$2ddabb89308e1a22;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $d03dbe8a2e59fe5b$export$14527669107aa301;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $d03dbe8a2e59fe5b$export$3f063810d7bf01bd;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $d03dbe8a2e59fe5b$export$b5a4d6f439a5044d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $d03dbe8a2e59fe5b$export$b119cc7e1840e59c;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $d03dbe8a2e59fe5b$export$7b85fd78dd236198;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $d03dbe8a2e59fe5b$export$697c3df919c0e61a;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $d03dbe8a2e59fe5b$export$1d012a0dff3dab06;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $d03dbe8a2e59fe5b$export$e6b5ff3168b5942b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $d03dbe8a2e59fe5b$export$9cd59f9826255e47;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $d03dbe8a2e59fe5b$export$fbc9cd6af26fa64f;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $d03dbe8a2e59fe5b$export$69a3209f1a06c04d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $d03dbe8a2e59fe5b$export$86c18c6347f4a8c4;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $d03dbe8a2e59fe5b$export$dce9414bed0662c;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $d03dbe8a2e59fe5b$export$271f7c16f175f804;
});
var $d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "sum", function() {
    return $d03dbe8a2e59fe5b$export$8a63f25cc62965f1;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $d03dbe8a2e59fe5b$export$e1f36757ecda301d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $d03dbe8a2e59fe5b$export$8e694e1eafd55acb;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $d03dbe8a2e59fe5b$export$57d7c52a66287430;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $d03dbe8a2e59fe5b$export$2b4693832ca3ce16;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $d03dbe8a2e59fe5b$export$5b784e078da1ce6;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $d03dbe8a2e59fe5b$export$17ec9c9f4f23588c;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $d03dbe8a2e59fe5b$export$595dbf49c602a1f;
});
function $d03dbe8a2e59fe5b$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $d03dbe8a2e59fe5b$export$e1f36757ecda301d(...data) {
    return $d03dbe8a2e59fe5b$export$8a63f25cc62965f1(...data) / data.length;
}
function $d03dbe8a2e59fe5b$export$8e694e1eafd55acb(data, sample = false) {
    const average = $d03dbe8a2e59fe5b$export$e1f36757ecda301d(...data);
    const summary = $d03dbe8a2e59fe5b$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $d03dbe8a2e59fe5b$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($d03dbe8a2e59fe5b$export$8e694e1eafd55acb(data, sample));
}
function $d03dbe8a2e59fe5b$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($d03dbe8a2e59fe5b$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $d03dbe8a2e59fe5b$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $d03dbe8a2e59fe5b$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $d03dbe8a2e59fe5b$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $d03dbe8a2e59fe5b$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $d03dbe8a2e59fe5b$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $d03dbe8a2e59fe5b$export$dd1bc94b04021eeb = (value)=>$d03dbe8a2e59fe5b$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $d03dbe8a2e59fe5b$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $d03dbe8a2e59fe5b$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $d03dbe8a2e59fe5b$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $d03dbe8a2e59fe5b$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $d03dbe8a2e59fe5b$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $d03dbe8a2e59fe5b$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $d03dbe8a2e59fe5b$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $d03dbe8a2e59fe5b$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $d03dbe8a2e59fe5b$export$8fb536984ec8b4d7 = (input)=>new TextEncoder().encode(input).toBase64();
async function $d03dbe8a2e59fe5b$export$37cc283d8fbd3462(input) {
    if (typeof input === 'string') return $d03dbe8a2e59fe5b$export$8fb536984ec8b4d7(input);
    if (input instanceof Blob) input = await input.arrayBuffer();
    return new Uint8Array(input).toBase64();
}
const $d03dbe8a2e59fe5b$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.fromBase64(input));
const $d03dbe8a2e59fe5b$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $d03dbe8a2e59fe5b$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $d03dbe8a2e59fe5b$export$14527669107aa301(oldList, newList) {
    const oldSet = new Set(oldList), newSet = new Set(newList);
    const map = {};
    for (const item of oldSet.difference(newSet))map[item] = -1;
    for (const item of oldSet.intersection(newSet))map[item] = 0;
    for (const item of newSet.difference(oldSet))map[item] = 1;
    return {
        map: map,
        group: $d03dbe8a2e59fe5b$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $d03dbe8a2e59fe5b$export$b5a4d6f439a5044d(data) {
    if ($d03dbe8a2e59fe5b$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $d03dbe8a2e59fe5b$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $d03dbe8a2e59fe5b$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($d03dbe8a2e59fe5b$export$61cc6ed0f143570b(data)) return Array();
    if ($d03dbe8a2e59fe5b$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $d03dbe8a2e59fe5b$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $d03dbe8a2e59fe5b$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $d03dbe8a2e59fe5b$export$1d012a0dff3dab06(list, iteratee) {
    const group = $d03dbe8a2e59fe5b$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $d03dbe8a2e59fe5b$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $d03dbe8a2e59fe5b$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $d03dbe8a2e59fe5b$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $d03dbe8a2e59fe5b$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $d03dbe8a2e59fe5b$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $d03dbe8a2e59fe5b$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $d03dbe8a2e59fe5b$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $d03dbe8a2e59fe5b$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $d03dbe8a2e59fe5b$export$271f7c16f175f804 extends $d03dbe8a2e59fe5b$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $d03dbe8a2e59fe5b$export$cbd942915f33be50;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $d03dbe8a2e59fe5b$export$9b886f8493244014;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $d03dbe8a2e59fe5b$export$e99cbb807a5bb10d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $d03dbe8a2e59fe5b$export$fca4f8121099df57;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $d03dbe8a2e59fe5b$export$6ce2f08d515512;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $d03dbe8a2e59fe5b$export$951c8378cdfec6e6;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $d03dbe8a2e59fe5b$export$1a4097b876a13bf7;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $d03dbe8a2e59fe5b$export$d9bcbd5e1ff81430;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $d03dbe8a2e59fe5b$export$506c8e8f8c8edda;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $d03dbe8a2e59fe5b$export$3ae94a2503e890a1;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $d03dbe8a2e59fe5b$export$7e1c707225b48c34;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $d03dbe8a2e59fe5b$export$62ad822b3a5fd9a0;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $d03dbe8a2e59fe5b$export$9e85258502147ffb;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $d03dbe8a2e59fe5b$export$3c1f2e5bc03748e2;
});
const $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a = 1000;
const $d03dbe8a2e59fe5b$export$cbd942915f33be50 = $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a * 60;
const $d03dbe8a2e59fe5b$export$9b886f8493244014 = $d03dbe8a2e59fe5b$export$cbd942915f33be50 * 15;
const $d03dbe8a2e59fe5b$export$e99cbb807a5bb10d = $d03dbe8a2e59fe5b$export$9b886f8493244014 * 4;
const $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20 = $d03dbe8a2e59fe5b$export$e99cbb807a5bb10d * 24;
const $d03dbe8a2e59fe5b$export$fca4f8121099df57 = $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20 * 7;
const $d03dbe8a2e59fe5b$export$6ce2f08d515512 = $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20 * 365;
const $d03dbe8a2e59fe5b$export$951c8378cdfec6e6 = $d03dbe8a2e59fe5b$export$6ce2f08d515512 / 12;
const $d03dbe8a2e59fe5b$export$1a4097b876a13bf7 = $d03dbe8a2e59fe5b$export$951c8378cdfec6e6 * 3;
class $d03dbe8a2e59fe5b$export$d9bcbd5e1ff81430 extends $d03dbe8a2e59fe5b$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $d03dbe8a2e59fe5b$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $d03dbe8a2e59fe5b$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $d03dbe8a2e59fe5b$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $d03dbe8a2e59fe5b$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $d03dbe8a2e59fe5b$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $d03dbe8a2e59fe5b$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $d03dbe8a2e59fe5b$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $d03dbe8a2e59fe5b$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(time);
    const localDate = new Date(+date - date.getTimezoneOffset() * $d03dbe8a2e59fe5b$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = localDate.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $d03dbe8a2e59fe5b$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $d03dbe8a2e59fe5b$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $d03dbe8a2e59fe5b$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $d03dbe8a2e59fe5b$export$9e85258502147ffb = (date, unit, delta)=>unit === $d03dbe8a2e59fe5b$export$6ce2f08d515512 ? $d03dbe8a2e59fe5b$export$7e1c707225b48c34(date, delta) : unit === $d03dbe8a2e59fe5b$export$951c8378cdfec6e6 ? $d03dbe8a2e59fe5b$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $d03dbe8a2e59fe5b$export$6ce2f08d515512,
    7: $d03dbe8a2e59fe5b$export$951c8378cdfec6e6,
    10: $d03dbe8a2e59fe5b$export$7a9a31a911eb9a20,
    13: $d03dbe8a2e59fe5b$export$e99cbb807a5bb10d,
    16: $d03dbe8a2e59fe5b$export$cbd942915f33be50,
    19: $d03dbe8a2e59fe5b$export$c489aa6f7fd82b1a
};
function $d03dbe8a2e59fe5b$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $d03dbe8a2e59fe5b$export$9e85258502147ffb(startedAt, $d03dbe8a2e59fe5b$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $d03dbe8a2e59fe5b$export$27924e57e9afff7f;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $d03dbe8a2e59fe5b$export$7ea17d45ecdcf634;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $d03dbe8a2e59fe5b$export$bf304e455230454a;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $d03dbe8a2e59fe5b$export$bb8626e4916f587b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $d03dbe8a2e59fe5b$export$88182f6768071c72;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $d03dbe8a2e59fe5b$export$2427785258f88523;
});
function $d03dbe8a2e59fe5b$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $d03dbe8a2e59fe5b$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(raw) {
    const parsed = $d03dbe8a2e59fe5b$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $d03dbe8a2e59fe5b$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $d03dbe8a2e59fe5b$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$d03dbe8a2e59fe5b$export$1c8ba402144543e5(row, data[0]));
}
const $d03dbe8a2e59fe5b$export$88182f6768071c72 = async (raw)=>Array.fromAsync($d03dbe8a2e59fe5b$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $d03dbe8a2e59fe5b$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $d03dbe8a2e59fe5b$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $d03dbe8a2e59fe5b$export$1c8ba402144543e5(row, headerRow) : row;
}
var $d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $d03dbe8a2e59fe5b$export$71e6483fc2b024eb;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $d03dbe8a2e59fe5b$export$eb9b2aadbe449a20;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $d03dbe8a2e59fe5b$export$13397a83aa5915d6;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $d03dbe8a2e59fe5b$export$fd89523fba250fa4;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $d03dbe8a2e59fe5b$export$504fbde693c1771c;
});
const $d03dbe8a2e59fe5b$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $d03dbe8a2e59fe5b$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($d03dbe8a2e59fe5b$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $d03dbe8a2e59fe5b$export$b5a4d6f439a5044d(value) ? $d03dbe8a2e59fe5b$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $d03dbe8a2e59fe5b$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$d03dbe8a2e59fe5b$export$dd1bc94b04021eeb(value) && [
            key,
            $d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $d03dbe8a2e59fe5b$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $d03dbe8a2e59fe5b$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $d03dbe8a2e59fe5b$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    return new Blob([
        base64 ? Uint8Array.fromBase64(data) : data
    ], {
        type: type
    });
}
var $d03dbe8a2e59fe5b$var$$d677628cc2ac1e37$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $d03dbe8a2e59fe5b$export$d0eaf3e94be578f6;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $d03dbe8a2e59fe5b$export$110700823644f4a6;
});
const $d03dbe8a2e59fe5b$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $d03dbe8a2e59fe5b$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $d03dbe8a2e59fe5b$var$$50872bf213056663$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $d03dbe8a2e59fe5b$export$1b9ac4d3de3ffd2e;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$50872bf213056663$exports, "makeSHA", function() {
    return $d03dbe8a2e59fe5b$export$d51f3b55e8d1aa73;
});
const $d03dbe8a2e59fe5b$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $d03dbe8a2e59fe5b$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $d03dbe8a2e59fe5b$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-expect-error — msCrypto is a non-standard API
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    // @ts-expect-error — webkitSubtle is a non-standard API
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $d03dbe8a2e59fe5b$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return new Uint8Array(buffer).toHex();
}
var $d03dbe8a2e59fe5b$var$$93a3089d2937b23f$exports = {};
var $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $d03dbe8a2e59fe5b$export$f5a4056b78c72efa;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $d03dbe8a2e59fe5b$export$2ee022bbbc550b25;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $d03dbe8a2e59fe5b$export$a549dd5cef7f8327;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $d03dbe8a2e59fe5b$export$8eece510bcb9c62c;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $d03dbe8a2e59fe5b$export$b8a1af58c024fefd;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $d03dbe8a2e59fe5b$export$a2cf0d4bb6e06de4;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $d03dbe8a2e59fe5b$export$d66b332881d9723f;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $d03dbe8a2e59fe5b$export$b0709844452f8b6b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $d03dbe8a2e59fe5b$export$5118471ee5d5453b;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $d03dbe8a2e59fe5b$export$6e196edbcc00e5bc;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $d03dbe8a2e59fe5b$export$be4650432daa84fd;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $d03dbe8a2e59fe5b$export$578e38b4a3e0b255;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $d03dbe8a2e59fe5b$export$7cd14c57bbb84350;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $d03dbe8a2e59fe5b$export$5100419dfae0456d;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $d03dbe8a2e59fe5b$export$28d9d24a8cd0ffc2;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $d03dbe8a2e59fe5b$export$3f99968195accfaf;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $d03dbe8a2e59fe5b$export$eafdbaa868ea9975;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $d03dbe8a2e59fe5b$export$36a0c1ca2ae264fa;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $d03dbe8a2e59fe5b$export$86d7c59254d6a2c9;
});
const $d03dbe8a2e59fe5b$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$templateMap = {};
function $d03dbe8a2e59fe5b$export$2ee022bbbc550b25(tagName) {
    if ($d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $d03dbe8a2e59fe5b$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $d03dbe8a2e59fe5b$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $d03dbe8a2e59fe5b$export$8eece510bcb9c62c = (Class)=>$d03dbe8a2e59fe5b$export$170f4e08cad8229d(Class, HTMLElement);
const $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $d03dbe8a2e59fe5b$export$b8a1af58c024fefd(Class) {
    const name = $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $d03dbe8a2e59fe5b$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $d03dbe8a2e59fe5b$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $d03dbe8a2e59fe5b$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $d03dbe8a2e59fe5b$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $d03dbe8a2e59fe5b$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $d03dbe8a2e59fe5b$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($d03dbe8a2e59fe5b$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $d03dbe8a2e59fe5b$export$5118471ee5d5453b(node, type);
}
function $d03dbe8a2e59fe5b$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $d03dbe8a2e59fe5b$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $d03dbe8a2e59fe5b$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement?.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement?.getBoundingClientRect() ?? {};
        if (width && height) text += nodeValue?.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $d03dbe8a2e59fe5b$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $d03dbe8a2e59fe5b$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $d03dbe8a2e59fe5b$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$d03dbe8a2e59fe5b$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$d03dbe8a2e59fe5b$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $d03dbe8a2e59fe5b$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $d03dbe8a2e59fe5b$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $d03dbe8a2e59fe5b$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $d03dbe8a2e59fe5b$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $d03dbe8a2e59fe5b$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $d03dbe8a2e59fe5b$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(defaultValue);
                else if ($d03dbe8a2e59fe5b$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $d03dbe8a2e59fe5b$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $d03dbe8a2e59fe5b$export$7ea17d45ecdcf634(value);
        }
        const record = data;
        if (name in data) record[name] = [].concat(record[name], parsedValue);
        else record[name] = !(parsedValue instanceof Array) || !$d03dbe8a2e59fe5b$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $d03dbe8a2e59fe5b$var$$bb23e0c794fefbef$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $d03dbe8a2e59fe5b$export$e772c8ff12451969;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $d03dbe8a2e59fe5b$export$57207d71b8c929c8;
});
function $d03dbe8a2e59fe5b$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $d03dbe8a2e59fe5b$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $d03dbe8a2e59fe5b$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $d03dbe8a2e59fe5b$export$10b1921597150314;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $d03dbe8a2e59fe5b$export$3e2b244719956741;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $d03dbe8a2e59fe5b$export$1d1d2ed6b55cf67f;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $d03dbe8a2e59fe5b$export$2155c0b5a4b77fb8;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $d03dbe8a2e59fe5b$export$9d97473344489dfc;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $d03dbe8a2e59fe5b$export$d635d04af3887bbe;
});
function $d03dbe8a2e59fe5b$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $d03dbe8a2e59fe5b$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $d03dbe8a2e59fe5b$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $d03dbe8a2e59fe5b$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $d03dbe8a2e59fe5b$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $d03dbe8a2e59fe5b$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $d03dbe8a2e59fe5b$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $d03dbe8a2e59fe5b$export$1b88f6b6d432a52a;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $d03dbe8a2e59fe5b$export$b70f6380221b1350;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $d03dbe8a2e59fe5b$export$75d6cbe4503e149;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $d03dbe8a2e59fe5b$export$b2618d51188815c2;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $d03dbe8a2e59fe5b$export$490814474ddbb428;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $d03dbe8a2e59fe5b$export$3ea201dffb50dfef;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $d03dbe8a2e59fe5b$export$d1012c7198c6b460;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $d03dbe8a2e59fe5b$export$a35a418b7b17958e;
});
class $d03dbe8a2e59fe5b$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - (from.z ?? 0), 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = (to.z ?? 0) - (from.z ?? 0);
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $d03dbe8a2e59fe5b$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $d03dbe8a2e59fe5b$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $d03dbe8a2e59fe5b$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $d03dbe8a2e59fe5b$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $d03dbe8a2e59fe5b$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $d03dbe8a2e59fe5b$export$75d6cbe4503e149(type, element)))
    ]);
}
function $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $d03dbe8a2e59fe5b$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $d03dbe8a2e59fe5b$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $d03dbe8a2e59fe5b$export$490814474ddbb428(element, className, display = 'block') {
    return $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $d03dbe8a2e59fe5b$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $d03dbe8a2e59fe5b$export$d1012c7198c6b460(element, className, remove) {
    return $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $d03dbe8a2e59fe5b$export$a35a418b7b17958e(element, className, remove) {
    return $d03dbe8a2e59fe5b$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $d03dbe8a2e59fe5b$var$$69bd9f0117925302$exports = {};
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$69bd9f0117925302$exports, "describe", function() {
    return $d03dbe8a2e59fe5b$export$cd5450f3a47e3789;
});
$d03dbe8a2e59fe5b$var$$parcel$export($d03dbe8a2e59fe5b$var$$69bd9f0117925302$exports, "it", function() {
    return $d03dbe8a2e59fe5b$export$3486a10f30cf1ee4;
});
async function $d03dbe8a2e59fe5b$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $d03dbe8a2e59fe5b$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$d03dbe8a2e59fe5b$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});

parcelRegister("fyBkV", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $b536fe3ac75a9539$export$ef7acd7185315e22; });
$parcel$export(module.exports, "defineVaporAsyncComponent", function () { return (parcelRequire("clmPQ")).defineVaporAsyncComponent; });
/**
  * vue v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $7s0Ms = parcelRequire("7s0Ms");
parcelRequire("bmuEm");
var $3dLyd = parcelRequire("3dLyd");
var $bmuEm = parcelRequire("bmuEm");

var $clmPQ = parcelRequire("clmPQ");
//#region packages/vue/src/dev.ts
function $b536fe3ac75a9539$var$initDev() {
    (0, $3dLyd.initCustomFormatter)();
}
const $b536fe3ac75a9539$export$ef7acd7185315e22 = (_template)=>{
    return 0, $7s0Ms.NOOP;
};
$parcel$exportWildcard(module.exports, $bmuEm);
$parcel$exportWildcard(module.exports, $clmPQ);

});
parcelRegister("7s0Ms", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $56cbc0f248f96d9c$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $56cbc0f248f96d9c$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $56cbc0f248f96d9c$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $56cbc0f248f96d9c$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $56cbc0f248f96d9c$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $56cbc0f248f96d9c$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isNativeOn", function () { return $56cbc0f248f96d9c$export$2774642b69d5bf8f; });
$parcel$export(module.exports, "isModelListener", function () { return $56cbc0f248f96d9c$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $56cbc0f248f96d9c$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $56cbc0f248f96d9c$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $56cbc0f248f96d9c$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $56cbc0f248f96d9c$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $56cbc0f248f96d9c$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $56cbc0f248f96d9c$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $56cbc0f248f96d9c$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $56cbc0f248f96d9c$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $56cbc0f248f96d9c$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $56cbc0f248f96d9c$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $56cbc0f248f96d9c$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $56cbc0f248f96d9c$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $56cbc0f248f96d9c$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $56cbc0f248f96d9c$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $56cbc0f248f96d9c$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $56cbc0f248f96d9c$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInTag", function () { return $56cbc0f248f96d9c$export$185918b776d5e857; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $56cbc0f248f96d9c$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $56cbc0f248f96d9c$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $56cbc0f248f96d9c$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $56cbc0f248f96d9c$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $56cbc0f248f96d9c$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "getModifierPropName", function () { return $56cbc0f248f96d9c$export$9d73740db27a710b; });
$parcel$export(module.exports, "hasChanged", function () { return $56cbc0f248f96d9c$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $56cbc0f248f96d9c$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $56cbc0f248f96d9c$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $56cbc0f248f96d9c$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $56cbc0f248f96d9c$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $56cbc0f248f96d9c$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "canSetValueDirectly", function () { return $56cbc0f248f96d9c$export$65fab167189e647e; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $56cbc0f248f96d9c$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $56cbc0f248f96d9c$export$8756898546458274; });
$parcel$export(module.exports, "parseStringStyle", function () { return $56cbc0f248f96d9c$export$76a205ce979d066a; });
$parcel$export(module.exports, "stringifyStyle", function () { return $56cbc0f248f96d9c$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $56cbc0f248f96d9c$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $56cbc0f248f96d9c$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $56cbc0f248f96d9c$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $56cbc0f248f96d9c$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $56cbc0f248f96d9c$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $56cbc0f248f96d9c$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $56cbc0f248f96d9c$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $56cbc0f248f96d9c$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $56cbc0f248f96d9c$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $56cbc0f248f96d9c$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $56cbc0f248f96d9c$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "shouldSetAsAttr", function () { return $56cbc0f248f96d9c$export$49386760b68c7202; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $56cbc0f248f96d9c$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $56cbc0f248f96d9c$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $56cbc0f248f96d9c$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $56cbc0f248f96d9c$export$b5b1545233b45293; });
$parcel$export(module.exports, "getSequence", function () { return $56cbc0f248f96d9c$export$5c1e203ca018159a; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $56cbc0f248f96d9c$export$97fe3d6453ee2f5e; });
$parcel$export(module.exports, "isForwardedSlot", function () { return $56cbc0f248f96d9c$export$e021dc44d742adfc; });
$parcel$export(module.exports, "slotInheritsFallback", function () { return $56cbc0f248f96d9c$export$d569989f3511ae; });
$parcel$export(module.exports, "slotNotifiesBoundary", function () { return $56cbc0f248f96d9c$export$7cfa9a922d15a615; });
/**
  * @vue/shared v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ //#region packages/shared/src/makeMap.ts
/**
* Make a map and return a function for checking if a key
* is in that map.
* IMPORTANT: all calls of this function must be prefixed with
* \/\*#\_\_PURE\_\_\*\/
* So that they can be tree-shaken if necessary.
*/ /*@__NO_SIDE_EFFECTS__*/ function $56cbc0f248f96d9c$export$b41394a5437791c8(str) {
    const map = Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
//#endregion
//#region packages/shared/src/general.ts
const $56cbc0f248f96d9c$export$cf583d23ab39677c = {};
const $56cbc0f248f96d9c$export$6bd8558f433f1cc1 = [];
const $56cbc0f248f96d9c$export$5702a91a6f42969f = ()=>{};
/**
* Always return true.
*/ const $56cbc0f248f96d9c$export$a9bd5345eb50aac4 = ()=>true;
/**
* Always return false.
*/ const $56cbc0f248f96d9c$export$c01351c0af048e39 = ()=>false;
const $56cbc0f248f96d9c$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $56cbc0f248f96d9c$export$2774642b69d5bf8f = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $56cbc0f248f96d9c$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $56cbc0f248f96d9c$export$8b58be045bf06082 = Object.assign;
const $56cbc0f248f96d9c$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $56cbc0f248f96d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $56cbc0f248f96d9c$export$b5a638e9b3fff9f3 = (val, key)=>$56cbc0f248f96d9c$var$hasOwnProperty.call(val, key);
const $56cbc0f248f96d9c$export$43bee75e5e14138e = Array.isArray;
const $56cbc0f248f96d9c$export$5c90113a285f2241 = (val)=>$56cbc0f248f96d9c$export$1dccc787cc36538b(val) === "[object Map]";
const $56cbc0f248f96d9c$export$6750766a7c7ec627 = (val)=>$56cbc0f248f96d9c$export$1dccc787cc36538b(val) === "[object Set]";
const $56cbc0f248f96d9c$export$871608497c498473 = (val)=>$56cbc0f248f96d9c$export$1dccc787cc36538b(val) === "[object Date]";
const $56cbc0f248f96d9c$export$49841c62b9eff15 = (val)=>$56cbc0f248f96d9c$export$1dccc787cc36538b(val) === "[object RegExp]";
const $56cbc0f248f96d9c$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $56cbc0f248f96d9c$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $56cbc0f248f96d9c$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $56cbc0f248f96d9c$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $56cbc0f248f96d9c$export$4369c812aac99591 = (val)=>{
    return ($56cbc0f248f96d9c$export$a6cdc56e425d0d0a(val) || $56cbc0f248f96d9c$export$f6e2535fb5126e54(val)) && $56cbc0f248f96d9c$export$f6e2535fb5126e54(val.then) && $56cbc0f248f96d9c$export$f6e2535fb5126e54(val.catch);
};
const $56cbc0f248f96d9c$export$830c053460e5ddf6 = Object.prototype.toString;
const $56cbc0f248f96d9c$export$1dccc787cc36538b = (value)=>$56cbc0f248f96d9c$export$830c053460e5ddf6.call(value);
const $56cbc0f248f96d9c$export$5ad0a3c360b8fbb5 = (value)=>{
    return $56cbc0f248f96d9c$export$1dccc787cc36538b(value).slice(8, -1);
};
const $56cbc0f248f96d9c$export$53b83ca8eaab0383 = (val)=>$56cbc0f248f96d9c$export$1dccc787cc36538b(val) === "[object Object]";
const $56cbc0f248f96d9c$export$e2a2b93446ec9fe = (key)=>$56cbc0f248f96d9c$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $56cbc0f248f96d9c$export$bf7d3c0236f0aa85 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $56cbc0f248f96d9c$export$185918b776d5e857 = /*#__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("slot,component");
const $56cbc0f248f96d9c$export$a9c1fdb3030c2a6b = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $56cbc0f248f96d9c$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        return cache[str] || (cache[str] = fn(str));
    };
};
const $56cbc0f248f96d9c$var$camelizeRE = /-(\w)/g;
const $56cbc0f248f96d9c$var$camelizeReplacer = (_, c)=>c ? c.toUpperCase() : "";
/**
* @private
*/ const $56cbc0f248f96d9c$export$161d051f5dd25de7 = $56cbc0f248f96d9c$var$cacheStringFunction((str)=>str.replace($56cbc0f248f96d9c$var$camelizeRE, $56cbc0f248f96d9c$var$camelizeReplacer));
const $56cbc0f248f96d9c$var$hyphenateRE = /\B([A-Z])/g;
/**
* @private
*/ const $56cbc0f248f96d9c$export$6e6a0a3676c4b8bb = $56cbc0f248f96d9c$var$cacheStringFunction((str)=>str.replace($56cbc0f248f96d9c$var$hyphenateRE, "-$1").toLowerCase());
/**
* @private
*/ const $56cbc0f248f96d9c$export$9a00dee1beb8f576 = $56cbc0f248f96d9c$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
* @private
*/ const $56cbc0f248f96d9c$export$8c022799eeaaefcd = $56cbc0f248f96d9c$var$cacheStringFunction((str)=>{
    return str ? `on${$56cbc0f248f96d9c$export$9a00dee1beb8f576(str)}` : ``;
});
/**
* #13070 When v-model and v-model:model directives are used together,
* they will generate the same modelModifiers prop,
* so a `$` suffix is added to avoid conflicts.
* @private
*/ const $56cbc0f248f96d9c$export$9d73740db27a710b = (name)=>{
    return `${name === "modelValue" || name === "model-value" ? "model" : name}Modifiers${name === "model" ? "$" : ""}`;
};
const $56cbc0f248f96d9c$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $56cbc0f248f96d9c$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $56cbc0f248f96d9c$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
/**
* "123-foo" will be parsed to 123
* This is used for the .number modifier in v-model
*/ const $56cbc0f248f96d9c$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
/**
* Only concerns number-like strings
* "123-foo" will be returned as-is
*/ const $56cbc0f248f96d9c$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $56cbc0f248f96d9c$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $56cbc0f248f96d9c$var$_globalThis;
const $56cbc0f248f96d9c$export$ff5f2eeb11fc7e14 = ()=>{
    return $56cbc0f248f96d9c$var$_globalThis || ($56cbc0f248f96d9c$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $56cbc0f248f96d9c$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $56cbc0f248f96d9c$export$53d5e12f9a1d3cde(name) {
    return $56cbc0f248f96d9c$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $56cbc0f248f96d9c$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
function $56cbc0f248f96d9c$export$65fab167189e647e(tagName) {
    return tagName !== "PROGRESS" && !tagName.includes("-");
}
//#endregion
//#region packages/shared/src/patchFlags.ts
/**
* Patch flags are optimization hints generated by the compiler.
* when a block with dynamicChildren is encountered during diff, the algorithm
* enters "optimized mode". In this mode, we know that the vdom is produced by
* a render function generated by the compiler, so the algorithm only needs to
* handle updates explicitly marked by these patch flags.
*
* Patch flags can be combined using the | bitwise operator and can be checked
* using the & operator, e.g.
*
* ```js
* const flag = TEXT | CLASS
* if (flag & TEXT) { ... }
* ```
*
* Check the `patchElement` function in '../../runtime-core/src/renderer.ts' to see how the
* flags are handled during diff.
*/ const $56cbc0f248f96d9c$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
/**
* dev only flag -> name mapping
*/ const $56cbc0f248f96d9c$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
//#endregion
//#region packages/shared/src/shapeFlags.ts
const $56cbc0f248f96d9c$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
//#endregion
//#region packages/shared/src/slotFlags.ts
const $56cbc0f248f96d9c$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
/**
* Dev only
*/ const $56cbc0f248f96d9c$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $56cbc0f248f96d9c$export$f73b8c13b7f97ebf = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");
/** @deprecated use `isGloballyAllowed` instead */ const $56cbc0f248f96d9c$export$d6571a1911e4f27e = $56cbc0f248f96d9c$export$f73b8c13b7f97ebf;
//#endregion
//#region packages/shared/src/codeframe.ts
const $56cbc0f248f96d9c$var$range = 2;
function $56cbc0f248f96d9c$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $56cbc0f248f96d9c$var$range; j <= i + $56cbc0f248f96d9c$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
//#endregion
//#region packages/shared/src/normalizeProp.ts
function $56cbc0f248f96d9c$export$8756898546458274(value) {
    if ($56cbc0f248f96d9c$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $56cbc0f248f96d9c$export$844ec244b1367d54(item) ? $56cbc0f248f96d9c$export$76a205ce979d066a(item) : $56cbc0f248f96d9c$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($56cbc0f248f96d9c$export$844ec244b1367d54(value) || $56cbc0f248f96d9c$export$a6cdc56e425d0d0a(value)) return value;
}
const $56cbc0f248f96d9c$var$listDelimiterRE = /;(?![^(]*\))/g;
const $56cbc0f248f96d9c$var$propertyDelimiterRE = /:([^]+)/;
const $56cbc0f248f96d9c$var$styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $56cbc0f248f96d9c$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($56cbc0f248f96d9c$var$styleCommentRE, (match)=>match.startsWith("/*") ? "" : match).split($56cbc0f248f96d9c$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($56cbc0f248f96d9c$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $56cbc0f248f96d9c$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($56cbc0f248f96d9c$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($56cbc0f248f96d9c$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $56cbc0f248f96d9c$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $56cbc0f248f96d9c$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($56cbc0f248f96d9c$export$844ec244b1367d54(value)) res = value;
    else if ($56cbc0f248f96d9c$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $56cbc0f248f96d9c$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($56cbc0f248f96d9c$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $56cbc0f248f96d9c$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$56cbc0f248f96d9c$export$844ec244b1367d54(klass)) props.class = $56cbc0f248f96d9c$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $56cbc0f248f96d9c$export$8756898546458274(style);
    return props;
}
//#endregion
//#region packages/shared/src/domTagConfig.ts
const $56cbc0f248f96d9c$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $56cbc0f248f96d9c$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $56cbc0f248f96d9c$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $56cbc0f248f96d9c$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $56cbc0f248f96d9c$var$FORMATTING_TAGS = "a,b,big,code,em,font,i,nobr,s,small,strike,strong,tt,u";
const $56cbc0f248f96d9c$var$ALWAYS_CLOSE_TAGS = "title,style,script,noscript,template,object,table,button,textarea,select,iframe,fieldset";
const $56cbc0f248f96d9c$var$INLINE_TAGS = "a,abbr,acronym,b,bdi,bdo,big,br,button,canvas,cite,code,data,datalist,del,dfn,em,embed,i,iframe,img,input,ins,kbd,label,map,mark,meter,noscript,object,output,picture,progress,q,ruby,s,samp,script,select,small,span,strong,sub,sup,svg,textarea,time,u,tt,var,video";
const $56cbc0f248f96d9c$var$BLOCK_TAGS = "address,article,aside,blockquote,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,li,main,menu,nav,ol,p,pre,section,table,ul";
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$1ccf854a0984f890 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$HTML_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$6328ce7565ea1049 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$SVG_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$4a46ca4c5be17b20 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$MATH_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$e5f2d3d97d9367a4 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$VOID_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$f004a7b38a350495 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$FORMATTING_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$4afe2b5e8b3e6daf = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$ALWAYS_CLOSE_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$61e899969cd8bf24 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$INLINE_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ const $56cbc0f248f96d9c$export$fa426276c4a55e76 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$BLOCK_TAGS);
//#endregion
//#region packages/shared/src/domAttrConfig.ts
/**
* On the client we only need to offer special cases for boolean attributes that
* have different names from their corresponding dom properties:
* - itemscope -> N/A
* - allowfullscreen -> allowFullscreen
* - formnovalidate -> formNoValidate
* - ismap -> isMap
* - nomodule -> noModule
* - novalidate -> noValidate
* - readonly -> readOnly
*/ const $56cbc0f248f96d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $56cbc0f248f96d9c$export$d186f5eb2e810715 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$specialBooleanAttrs);
/**
* The full list is needed during SSR to produce the correct initial markup.
*/ const $56cbc0f248f96d9c$export$f763ba3b84e9cd8c = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8($56cbc0f248f96d9c$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
/**
* Boolean attributes should be included if the value is truthy or ''.
* e.g. `<select multiple>` compiles to `{ multiple: '' }`
*/ function $56cbc0f248f96d9c$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $56cbc0f248f96d9c$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $56cbc0f248f96d9c$var$attrValidationCache = {};
function $56cbc0f248f96d9c$export$d55ef77660f30d12(name) {
    if ($56cbc0f248f96d9c$var$attrValidationCache.hasOwnProperty(name)) return $56cbc0f248f96d9c$var$attrValidationCache[name];
    const isUnsafe = $56cbc0f248f96d9c$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $56cbc0f248f96d9c$var$attrValidationCache[name] = !isUnsafe;
}
const $56cbc0f248f96d9c$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
* Known attributes, this is used for stringification of runtime static nodes
* so that we don't stringify bindings that cannot be set from HTML.
* Don't also forget to allow `data-*` and `aria-*`!
* Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
*/ const $56cbc0f248f96d9c$export$f7e7a1cc7da8d5e9 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
/**
* Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
*/ const $56cbc0f248f96d9c$export$80da416f43933831 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
/**
* Generated from https://developer.mozilla.org/en-US/docs/Web/MathML/Attribute
*/ const $56cbc0f248f96d9c$export$fc0748a8e0014066 = /*@__PURE__*/ $56cbc0f248f96d9c$export$b41394a5437791c8("accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns");
/**
* Shared between server-renderer and runtime-core hydration logic
*/ function $56cbc0f248f96d9c$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
function $56cbc0f248f96d9c$export$49386760b68c7202(tagName, key) {
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return true;
    if (key === "form") return true;
    if (key === "list" && tagName === "INPUT") return true;
    if (key === "type" && tagName === "TEXTAREA") return true;
    if ((key === "width" || key === "height") && (tagName === "IMG" || tagName === "VIDEO" || tagName === "CANVAS" || tagName === "SOURCE")) return true;
    if (key === "sandbox" && tagName === "IFRAME") return true;
    return false;
}
//#endregion
//#region packages/shared/src/domNamespace.ts
const $56cbc0f248f96d9c$export$2f21297dc8e7cb72 = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
//#endregion
//#region packages/shared/src/escapeHtml.ts
const $56cbc0f248f96d9c$var$escapeRE = /["'&<>]/;
function $56cbc0f248f96d9c$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $56cbc0f248f96d9c$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $56cbc0f248f96d9c$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $56cbc0f248f96d9c$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($56cbc0f248f96d9c$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $56cbc0f248f96d9c$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $56cbc0f248f96d9c$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($56cbc0f248f96d9c$export$9320a7246b331080, (s)=>doubleEscape ? s === "\"" ? "\\\\\\\"" : `\\\\${s}` : `\\${s}`);
}
//#endregion
//#region packages/shared/src/looseEqual.ts
function $56cbc0f248f96d9c$var$looseCompareArrays(a, b, seen) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $56cbc0f248f96d9c$export$ae8015769846262c(a[i], b[i], seen);
    return equal;
}
function $56cbc0f248f96d9c$var$looseCompareCollections(a, b, seen) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $56cbc0f248f96d9c$export$ae8015769846262c(item, candidates[i], seen)) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $56cbc0f248f96d9c$var$looseCompareObjects(a, b, seen) {
    let aValidType = $56cbc0f248f96d9c$export$5c90113a285f2241(a);
    let bValidType = $56cbc0f248f96d9c$export$5c90113a285f2241(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $56cbc0f248f96d9c$var$looseCompareCollections(a, b, seen) : false;
    aValidType = $56cbc0f248f96d9c$export$6750766a7c7ec627(a);
    bValidType = $56cbc0f248f96d9c$export$6750766a7c7ec627(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $56cbc0f248f96d9c$var$looseCompareCollections(a, b, seen) : false;
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$56cbc0f248f96d9c$export$ae8015769846262c(a[key], b[key], seen)) return false;
    }
    return String(a) === String(b);
}
function $56cbc0f248f96d9c$var$looseCompareNested(a, b, seen, compare) {
    if (!seen) seen = [
        /* @__PURE__ */ new Map(),
        /* @__PURE__ */ new Map()
    ];
    const [seenA, seenB] = seen;
    if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
    seenA.set(a, b);
    seenB.set(b, a);
    const equal = compare(a, b, seen);
    seenA.delete(a);
    seenB.delete(b);
    return equal;
}
function $56cbc0f248f96d9c$export$ae8015769846262c(a, b, seen) {
    if (a === b) return true;
    let aValidType = $56cbc0f248f96d9c$export$871608497c498473(a);
    let bValidType = $56cbc0f248f96d9c$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $56cbc0f248f96d9c$export$a244864fd9645c7f(a);
    bValidType = $56cbc0f248f96d9c$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $56cbc0f248f96d9c$export$43bee75e5e14138e(a);
    bValidType = $56cbc0f248f96d9c$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $56cbc0f248f96d9c$var$looseCompareNested(a, b, seen, $56cbc0f248f96d9c$var$looseCompareArrays) : false;
    aValidType = $56cbc0f248f96d9c$export$a6cdc56e425d0d0a(a);
    bValidType = $56cbc0f248f96d9c$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        return $56cbc0f248f96d9c$var$looseCompareNested(a, b, seen, $56cbc0f248f96d9c$var$looseCompareObjects);
    }
    return String(a) === String(b);
}
function $56cbc0f248f96d9c$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$56cbc0f248f96d9c$export$ae8015769846262c(item, val));
}
//#endregion
//#region packages/shared/src/toDisplayString.ts
const $56cbc0f248f96d9c$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
/**
* For converting {{ interpolation }} values to displayed strings.
* @private
*/ const $56cbc0f248f96d9c$export$b5b1545233b45293 = (val)=>{
    switch(typeof val){
        case "string":
            return val;
        case "object":
            if (val) {
                if ($56cbc0f248f96d9c$var$isRef(val)) return $56cbc0f248f96d9c$export$b5b1545233b45293(val.value);
                else if ($56cbc0f248f96d9c$export$43bee75e5e14138e(val) || val.toString === $56cbc0f248f96d9c$export$830c053460e5ddf6 || !$56cbc0f248f96d9c$export$f6e2535fb5126e54(val.toString)) return JSON.stringify(val, $56cbc0f248f96d9c$var$replacer, 2);
            }
        default:
            return val == null ? "" : String(val);
    }
};
const $56cbc0f248f96d9c$var$replacer = (_key, val)=>{
    if ($56cbc0f248f96d9c$var$isRef(val)) return $56cbc0f248f96d9c$var$replacer(_key, val.value);
    else if ($56cbc0f248f96d9c$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val], i)=>{
            entries[$56cbc0f248f96d9c$var$stringifySymbol(key, i) + " =>"] = val;
            return entries;
        }, {})
    };
    else if ($56cbc0f248f96d9c$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$56cbc0f248f96d9c$var$stringifySymbol(v))
    };
    else if ($56cbc0f248f96d9c$export$a244864fd9645c7f(val)) return $56cbc0f248f96d9c$var$stringifySymbol(val);
    else if ($56cbc0f248f96d9c$export$a6cdc56e425d0d0a(val) && !$56cbc0f248f96d9c$export$43bee75e5e14138e(val) && !$56cbc0f248f96d9c$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $56cbc0f248f96d9c$var$stringifySymbol = (v, i = "")=>{
    var _description;
    return $56cbc0f248f96d9c$export$a244864fd9645c7f(v) ? `Symbol(${(_description = v.description) !== null && _description !== void 0 ? _description : i})` : v;
};
//#endregion
//#region packages/shared/src/subSequence.ts
function $56cbc0f248f96d9c$export$5c1e203ca018159a(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                c = u + v >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v = result[u - 1];
    while(u-- > 0){
        result[u] = v;
        v = p[v];
    }
    return result;
}
//#endregion
//#region packages/shared/src/cssVars.ts
/**
* Normalize CSS var value created by `v-bind` in `<style>` block
* See https://github.com/vuejs/core/pull/12461#issuecomment-2495804664
*/ function $56cbc0f248f96d9c$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}
//#endregion
//#region packages/shared/src/vaporFlags.ts
/**
* Flags to optimize vapor `createFor` runtime behavior, shared between the
* compiler and the runtime
*/ const $56cbc0f248f96d9c$export$ab45b86c1147712c = {
    "FAST_REMOVE": 1,
    "1": "FAST_REMOVE",
    "IS_COMPONENT": 2,
    "2": "IS_COMPONENT",
    "ONCE": 4,
    "4": "ONCE",
    "IS_SINGLE_NODE": 8,
    "8": "IS_SINGLE_NODE",
    "IS_FRAGMENT": 16,
    "16": "IS_FRAGMENT",
    "SLOT_ROOT": 32,
    "32": "SLOT_ROOT",
    "WRAPPED_ROWS": 64,
    "64": "WRAPPED_ROWS"
};
const $56cbc0f248f96d9c$export$61e61e9edff331f3 = {
    "EMPTY": 0,
    "0": "EMPTY",
    "SINGLE_ROOT": 1,
    "1": "SINGLE_ROOT",
    "MULTI_ROOT": 2,
    "2": "MULTI_ROOT"
};
/**
* Bit layout for vapor `createIf` flags.
*
* - bits 0-1: true branch VaporBlockShape
* - bits 2-3: false branch VaporBlockShape
* - bit 4: v-once
* - bit 5: true branch is static and can skip branch-owned EffectScope
* - bit 6: false branch is static and can skip branch-owned EffectScope
* - bit 7: v-if sits on a slot content/fallback root chain
* - bits 8+: branch index + 1 for keyed dynamic fragments
*
* Examples:
* - v-once, true single-root, no false branch: 1 | ONCE = 17
* - keyed index 0, true/false single-root: 1 | (1 << 2) | (1 << 8) = 261
*/ const $56cbc0f248f96d9c$export$86847347b977cccf = {
    "BLOCK_SHAPE": 15,
    "15": "BLOCK_SHAPE",
    "ONCE": 16,
    "16": "ONCE",
    "TRUE_NO_SCOPE": 32,
    "32": "TRUE_NO_SCOPE",
    "FALSE_NO_SCOPE": 64,
    "64": "FALSE_NO_SCOPE",
    "SLOT_ROOT": 128,
    "128": "SLOT_ROOT",
    "INDEX_SHIFT": 8,
    "8": "INDEX_SHIFT"
};
/**
* Flags used by vapor template factories, shared between the compiler and the
* runtime.
*/ const $56cbc0f248f96d9c$export$57e75f507d329f83 = {
    "ROOT": 1,
    "1": "ROOT",
    "STATIC": 2,
    "2": "STATIC"
};
/**
* Flags used by vapor slot outlets, shared between the compiler and the
* runtime.
*/ const $56cbc0f248f96d9c$export$4e0aa323b98da897 = {
    "NO_SLOTTED": 1,
    "1": "NO_SLOTTED",
    "ONCE": 2,
    "2": "ONCE",
    "FORWARDED": 4,
    "4": "FORWARDED",
    "SHARED_FALLBACK": 8,
    "8": "SHARED_FALLBACK"
};
function $56cbc0f248f96d9c$export$e021dc44d742adfc(flags) {
    return !!(flags & 12);
}
function $56cbc0f248f96d9c$export$d569989f3511ae(flags) {
    return $56cbc0f248f96d9c$export$e021dc44d742adfc(flags) && !(flags & 8);
}
function $56cbc0f248f96d9c$export$7cfa9a922d15a615(flags) {
    return $56cbc0f248f96d9c$export$e021dc44d742adfc(flags) && !(flags & 2);
}
/**
* Per-slot-function metadata attached by the compiler as `fn._`.
*/ const $56cbc0f248f96d9c$export$bda5b7b0e18bd833 = {
    "NON_STABLE": 1,
    "1": "NON_STABLE"
};
const $56cbc0f248f96d9c$export$782651ce5501a058 = {
    "SINGLE_ROOT": 1,
    "1": "SINGLE_ROOT",
    "ONCE": 2,
    "2": "ONCE",
    "SLOT_ROOT": 4,
    "4": "SLOT_ROOT",
    "NS_SVG": 8,
    "8": "NS_SVG",
    "NS_MATHML": 16,
    "16": "NS_MATHML"
};

});

parcelRegister("bmuEm", function(module, exports) {

$parcel$export(module.exports, "unsafeToTrustedHTML", function () { return $8459863c4d27aaf2$export$1fdf04608ac1d660; });
$parcel$export(module.exports, "svgNS", function () { return $8459863c4d27aaf2$export$4b7ca16c0c939865; });
$parcel$export(module.exports, "nodeOps", function () { return $8459863c4d27aaf2$export$de4fb7f5030605d3; });
$parcel$export(module.exports, "TransitionPropsValidators", function () { return $8459863c4d27aaf2$export$b899d57baa0167d5; });
$parcel$export(module.exports, "Transition", function () { return $8459863c4d27aaf2$export$be58926105124dd4; });
$parcel$export(module.exports, "resolveTransitionProps", function () { return $8459863c4d27aaf2$export$b349eeb6ed6a6d73; });
$parcel$export(module.exports, "forceReflow", function () { return $8459863c4d27aaf2$export$7d26bbb1236dafd6; });
$parcel$export(module.exports, "patchClass", function () { return $8459863c4d27aaf2$export$de1f6f779b5b44c; });
$parcel$export(module.exports, "vShowOriginalDisplay", function () { return $8459863c4d27aaf2$export$1ce4da46075779d5; });
$parcel$export(module.exports, "vShowHidden", function () { return $8459863c4d27aaf2$export$9899690c5a6aa34e; });
$parcel$export(module.exports, "vShow", function () { return $8459863c4d27aaf2$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "useCssVars", function () { return $8459863c4d27aaf2$export$ef28b76f07940108; });
$parcel$export(module.exports, "setVarsOnNode", function () { return $8459863c4d27aaf2$export$fb351f25830bd233; });
$parcel$export(module.exports, "patchStyle", function () { return $8459863c4d27aaf2$export$1648b8c99f3dead4; });
$parcel$export(module.exports, "xlinkNS", function () { return $8459863c4d27aaf2$export$2574309f616608d7; });
$parcel$export(module.exports, "parseEventName", function () { return $8459863c4d27aaf2$export$ad797ac1f0c6c291; });
$parcel$export(module.exports, "patchProp", function () { return $8459863c4d27aaf2$export$cd4aa0842d13df8b; });
$parcel$export(module.exports, "shouldSetAsProp", function () { return $8459863c4d27aaf2$export$11623ee7ce2794a7; });
$parcel$export(module.exports, "shouldSetAsPropForVueCE", function () { return $8459863c4d27aaf2$export$153823794abe328a; });
$parcel$export(module.exports, "defineCustomElement", function () { return $8459863c4d27aaf2$export$a00e2346eabbdbef; });
$parcel$export(module.exports, "VueElement", function () { return $8459863c4d27aaf2$export$b337c1a55163dbe3; });
$parcel$export(module.exports, "defineSSRCustomElement", function () { return $8459863c4d27aaf2$export$6debb2e68f212638; });
$parcel$export(module.exports, "createSSRApp", function () { return $8459863c4d27aaf2$export$35800275c0037383; });
$parcel$export(module.exports, "VueElementBase", function () { return $8459863c4d27aaf2$export$8aeafd20e0fdd5f4; });
$parcel$export(module.exports, "createApp", function () { return $8459863c4d27aaf2$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "render", function () { return $8459863c4d27aaf2$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "useHost", function () { return $8459863c4d27aaf2$export$da5acfe93a94e37d; });
$parcel$export(module.exports, "useShadowRoot", function () { return $8459863c4d27aaf2$export$64d45095031fa749; });
$parcel$export(module.exports, "useCssModule", function () { return $8459863c4d27aaf2$export$9300d5b90d56e3d1; });
$parcel$export(module.exports, "TransitionGroup", function () { return $8459863c4d27aaf2$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "hasCSSTransform", function () { return $8459863c4d27aaf2$export$6488e4a884389379; });
$parcel$export(module.exports, "callPendingCbs", function () { return $8459863c4d27aaf2$export$d5371ae309f51a37; });
$parcel$export(module.exports, "handleMovedChildren", function () { return $8459863c4d27aaf2$export$bb551b8c48d28521; });
$parcel$export(module.exports, "baseApplyTranslation", function () { return $8459863c4d27aaf2$export$61fb5edf31d9f0b8; });
$parcel$export(module.exports, "vModelText", function () { return $8459863c4d27aaf2$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelTextInit", function () { return $8459863c4d27aaf2$export$2d3637690b27facf; });
$parcel$export(module.exports, "vModelTextUpdate", function () { return $8459863c4d27aaf2$export$b171fe2fda8d060a; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $8459863c4d27aaf2$export$8847c2e532b35714; });
$parcel$export(module.exports, "vModelCheckboxInit", function () { return $8459863c4d27aaf2$export$10ad6c0b109fa494; });
$parcel$export(module.exports, "vModelCheckboxUpdate", function () { return $8459863c4d27aaf2$export$bf72bd412424aea; });
$parcel$export(module.exports, "vModelGetValue", function () { return $8459863c4d27aaf2$export$882b439d816257fa; });
$parcel$export(module.exports, "vModelRadio", function () { return $8459863c4d27aaf2$export$b4356c59b38b7aa9; });
$parcel$export(module.exports, "vModelSelect", function () { return $8459863c4d27aaf2$export$87d227567b51ca39; });
$parcel$export(module.exports, "vModelSelectInit", function () { return $8459863c4d27aaf2$export$6755e66381fe27bf; });
$parcel$export(module.exports, "vModelSetSelected", function () { return $8459863c4d27aaf2$export$ff95a38066b55f02; });
$parcel$export(module.exports, "vModelDynamic", function () { return $8459863c4d27aaf2$export$5ad5c0e01ff62c5; });
$parcel$export(module.exports, "withModifiers", function () { return $8459863c4d27aaf2$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $8459863c4d27aaf2$export$f691a8759658f782; });
$parcel$export(module.exports, "ensureRenderer", function () { return $8459863c4d27aaf2$export$a0bae4d3eba7c8a0; });
$parcel$export(module.exports, "ensureHydrationRenderer", function () { return $8459863c4d27aaf2$export$70a3ed9a5d6c0c60; });
$parcel$export(module.exports, "hydrate", function () { return $8459863c4d27aaf2$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "normalizeContainer", function () { return $8459863c4d27aaf2$export$fc6b59695d328a27; });
$parcel$export(module.exports, "initDirectivesForSSR", function () { return $8459863c4d27aaf2$export$800b28255aa678d9; });
/**
  * @vue/runtime-dom v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $3dLyd = parcelRequire("3dLyd");
var $7s0Ms = parcelRequire("7s0Ms");
var $SdEQh = parcelRequire("SdEQh");

var $7s0Ms = parcelRequire("7s0Ms");
//#region packages/runtime-dom/src/nodeOps.ts
let $8459863c4d27aaf2$var$policy = void 0;
const $8459863c4d27aaf2$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($8459863c4d27aaf2$var$tt) try {
    $8459863c4d27aaf2$var$policy = /*@__PURE__*/ $8459863c4d27aaf2$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $8459863c4d27aaf2$export$1fdf04608ac1d660 = $8459863c4d27aaf2$var$policy ? (val)=>$8459863c4d27aaf2$var$policy.createHTML(val) : (val)=>val;
const $8459863c4d27aaf2$export$4b7ca16c0c939865 = "http://www.w3.org/2000/svg";
const $8459863c4d27aaf2$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $8459863c4d27aaf2$var$doc = typeof document !== "undefined" ? document : null;
const $8459863c4d27aaf2$var$templateContainer = $8459863c4d27aaf2$var$doc && /*@__PURE__*/ $8459863c4d27aaf2$var$doc.createElement("template");
const $8459863c4d27aaf2$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $8459863c4d27aaf2$var$doc.createElementNS($8459863c4d27aaf2$export$4b7ca16c0c939865, tag) : namespace === "mathml" ? $8459863c4d27aaf2$var$doc.createElementNS($8459863c4d27aaf2$var$mathmlNS, tag) : is ? $8459863c4d27aaf2$var$doc.createElement(tag, {
            is: is
        }) : $8459863c4d27aaf2$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$8459863c4d27aaf2$var$doc.createTextNode(text),
    createComment: (text)=>$8459863c4d27aaf2$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$8459863c4d27aaf2$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $8459863c4d27aaf2$var$templateContainer.innerHTML = $8459863c4d27aaf2$export$1fdf04608ac1d660(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $8459863c4d27aaf2$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            before ? before.nextSibling : parent.firstChild,
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
//#endregion
//#region packages/runtime-dom/src/components/Transition.ts
const $8459863c4d27aaf2$var$TRANSITION = "transition";
const $8459863c4d27aaf2$var$ANIMATION = "animation";
const $8459863c4d27aaf2$var$vtcKey = Symbol("_vtc");
const $8459863c4d27aaf2$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $8459863c4d27aaf2$export$b899d57baa0167d5 = /*@__PURE__*/ (0, $7s0Ms.extend)({}, (0, $3dLyd.BaseTransitionPropsValidators), $8459863c4d27aaf2$var$DOMTransitionPropsValidators);
/**
* Wrap logic that attaches extra properties to Transition in a function
* so that it can be annotated as pure
*/ const $8459863c4d27aaf2$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $8459863c4d27aaf2$export$b899d57baa0167d5;
    return t;
};
/**
* DOM Transition is a higher-order-component based on the platform-agnostic
* base Transition component, with DOM-specific logic.
*/ const $8459863c4d27aaf2$export$be58926105124dd4 = /*@__PURE__*/ $8459863c4d27aaf2$var$decorate$1((props, { slots: slots })=>(0, $3dLyd.h)((0, $3dLyd.BaseTransition), $8459863c4d27aaf2$export$b349eeb6ed6a6d73(props), slots));
/**
* #3227 Incoming hooks may be merged into arrays when wrapping Transition
* with custom HOCs.
*/ const $8459863c4d27aaf2$var$callHook = (hook, args = [])=>{
    if ((0, $7s0Ms.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
* Check if a hook expects a callback (2nd arg), which means the user
* intends to explicitly control the end of the transition.
*/ const $8459863c4d27aaf2$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $7s0Ms.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $8459863c4d27aaf2$export$b349eeb6ed6a6d73(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $8459863c4d27aaf2$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $8459863c4d27aaf2$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $8459863c4d27aaf2$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $8459863c4d27aaf2$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $8459863c4d27aaf2$var$removeTransitionClass(el, leaveFromClass);
        $8459863c4d27aaf2$var$removeTransitionClass(el, leaveToClass);
        $8459863c4d27aaf2$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $8459863c4d27aaf2$var$callHook(hook, [
                el,
                resolve
            ]);
            $8459863c4d27aaf2$var$nextFrame(()=>{
                $8459863c4d27aaf2$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $8459863c4d27aaf2$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$8459863c4d27aaf2$var$hasExplicitCallback(hook)) $8459863c4d27aaf2$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $7s0Ms.extend)(baseProps, {
        onBeforeEnter (el) {
            $8459863c4d27aaf2$var$callHook(onBeforeEnter, [
                el
            ]);
            $8459863c4d27aaf2$var$addTransitionClass(el, enterFromClass);
            $8459863c4d27aaf2$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $8459863c4d27aaf2$var$callHook(onBeforeAppear, [
                el
            ]);
            $8459863c4d27aaf2$var$addTransitionClass(el, appearFromClass);
            $8459863c4d27aaf2$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $8459863c4d27aaf2$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $8459863c4d27aaf2$export$7d26bbb1236dafd6(el);
                $8459863c4d27aaf2$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $8459863c4d27aaf2$var$addTransitionClass(el, leaveActiveClass);
                $8459863c4d27aaf2$export$7d26bbb1236dafd6(el);
            }
            $8459863c4d27aaf2$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $8459863c4d27aaf2$var$removeTransitionClass(el, leaveFromClass);
                $8459863c4d27aaf2$var$addTransitionClass(el, leaveToClass);
                if (!$8459863c4d27aaf2$var$hasExplicitCallback(onLeave)) $8459863c4d27aaf2$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $8459863c4d27aaf2$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $8459863c4d27aaf2$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $8459863c4d27aaf2$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $8459863c4d27aaf2$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $8459863c4d27aaf2$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $7s0Ms.isObject)(duration)) return [
        $8459863c4d27aaf2$var$NumberOf(duration.enter),
        $8459863c4d27aaf2$var$NumberOf(duration.leave)
    ];
    else {
        const n = $8459863c4d27aaf2$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $8459863c4d27aaf2$var$NumberOf(val) {
    const res = (0, $7s0Ms.toNumber)(val);
    return res;
}
function $8459863c4d27aaf2$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$8459863c4d27aaf2$var$vtcKey] || (el[$8459863c4d27aaf2$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $8459863c4d27aaf2$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$8459863c4d27aaf2$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$8459863c4d27aaf2$var$vtcKey] = void 0;
    }
}
function $8459863c4d27aaf2$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $8459863c4d27aaf2$var$endId = 0;
function $8459863c4d27aaf2$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$8459863c4d27aaf2$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $8459863c4d27aaf2$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $8459863c4d27aaf2$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$8459863c4d27aaf2$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$8459863c4d27aaf2$var$TRANSITION}Duration`);
    const transitionTimeout = $8459863c4d27aaf2$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$8459863c4d27aaf2$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$8459863c4d27aaf2$var$ANIMATION}Duration`);
    const animationTimeout = $8459863c4d27aaf2$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $8459863c4d27aaf2$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $8459863c4d27aaf2$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $8459863c4d27aaf2$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $8459863c4d27aaf2$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $8459863c4d27aaf2$var$TRANSITION : $8459863c4d27aaf2$var$ANIMATION : null;
        propCount = type ? type === $8459863c4d27aaf2$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $8459863c4d27aaf2$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$8459863c4d27aaf2$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $8459863c4d27aaf2$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$8459863c4d27aaf2$var$toMs(d) + $8459863c4d27aaf2$var$toMs(delays[i])));
}
function $8459863c4d27aaf2$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $8459863c4d27aaf2$export$7d26bbb1236dafd6(el) {
    return (el ? el.ownerDocument : document).body.offsetHeight;
}
//#endregion
//#region packages/runtime-dom/src/modules/class.ts
function $8459863c4d27aaf2$export$de1f6f779b5b44c(el, value, isSVG) {
    const transitionClasses = el[$8459863c4d27aaf2$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
//#endregion
//#region packages/runtime-dom/src/directives/vShow.ts
const $8459863c4d27aaf2$export$1ce4da46075779d5 = Symbol("_vod");
const $8459863c4d27aaf2$export$9899690c5a6aa34e = Symbol("_vsh");
const $8459863c4d27aaf2$export$5cb4fcdc6937d7e1 = {
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$8459863c4d27aaf2$export$1ce4da46075779d5] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $8459863c4d27aaf2$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $8459863c4d27aaf2$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $8459863c4d27aaf2$var$setDisplay(el, false);
            });
        } else $8459863c4d27aaf2$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $8459863c4d27aaf2$var$setDisplay(el, value);
    }
};
function $8459863c4d27aaf2$var$setDisplay(el, value) {
    el.style.display = value ? el[$8459863c4d27aaf2$export$1ce4da46075779d5] : "none";
    el[$8459863c4d27aaf2$export$9899690c5a6aa34e] = !value;
}
function $8459863c4d27aaf2$var$initVShowForSSR() {
    $8459863c4d27aaf2$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
//#endregion
//#region packages/runtime-dom/src/helpers/useCssVars.ts
const $8459863c4d27aaf2$var$CSS_VAR_TEXT = Symbol("");
/**
* Runtime helper for SFC's CSS variable injection feature.
* @private
*/ function $8459863c4d27aaf2$export$ef28b76f07940108(getter) {
    const instance = (0, $3dLyd.getCurrentInstance)();
    /* v8 ignore start */ if (!instance) return;
    /* v8 ignore stop */ const getVars = ()=>getter(instance.proxy);
    const updateTeleports = instance.ut = (vars = getVars())=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$8459863c4d27aaf2$export$fb351f25830bd233(node, vars));
    };
    const applyCssVars = (vars = getVars())=>{
        if (instance.ce) $8459863c4d27aaf2$export$fb351f25830bd233(instance.ce, vars);
        else $8459863c4d27aaf2$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $3dLyd.onBeforeUpdate)(()=>{
        (0, $3dLyd.queuePostFlushCb)(applyCssVars);
    });
    (0, $3dLyd.onMounted)(()=>{
        (0, $3dLyd.watch)(()=>{
            const vars = getVars();
            (0, $7s0Ms.extend)({}, vars);
            applyCssVars(vars);
        }, (0, $7s0Ms.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(()=>applyCssVars());
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $3dLyd.onUnmounted)(()=>ob.disconnect());
    });
}
function $8459863c4d27aaf2$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $8459863c4d27aaf2$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component){
        const component = vnode.component;
        if (component.vapor) {
            component.appContext.vapor.applyCssVars(vnode, vars);
            return;
        }
        vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 && vnode.el) $8459863c4d27aaf2$export$fb351f25830bd233(vnode.el, vars);
    else if (vnode.type === (0, $3dLyd.Fragment)) vnode.children.forEach((c)=>$8459863c4d27aaf2$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $3dLyd.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $8459863c4d27aaf2$export$fb351f25830bd233(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
/**
* @internal
* shared between vdom and vapor
*/ function $8459863c4d27aaf2$export$fb351f25830bd233(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $7s0Ms.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$8459863c4d27aaf2$var$CSS_VAR_TEXT] = cssText;
    }
}
//#endregion
//#region packages/runtime-dom/src/modules/style.ts
const $8459863c4d27aaf2$var$displayRE = /(?:^|;)\s*display\s*:/;
function $8459863c4d27aaf2$export$1648b8c99f3dead4(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $7s0Ms.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $7s0Ms.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $8459863c4d27aaf2$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $8459863c4d27aaf2$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$8459863c4d27aaf2$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $7s0Ms.isString)(prev) && prev ? prev[key] : void 0, value)) $8459863c4d27aaf2$var$setStyle(style, key, value);
            } else $8459863c4d27aaf2$var$setStyle(style, key, "");
        }
    } else if (isCssString) {
        if (prev !== next) {
            const cssVarText = style[$8459863c4d27aaf2$var$CSS_VAR_TEXT];
            if (cssVarText) next += ";" + cssVarText;
            style.cssText = next;
            hasControlledDisplay = $8459863c4d27aaf2$var$displayRE.test(next);
        }
    } else if (prev) el.removeAttribute("style");
    if ($8459863c4d27aaf2$export$1ce4da46075779d5 in el) {
        el[$8459863c4d27aaf2$export$1ce4da46075779d5] = hasControlledDisplay ? style.display : "";
        if (el[$8459863c4d27aaf2$export$9899690c5a6aa34e]) style.display = "none";
    }
}
const $8459863c4d27aaf2$var$semicolonRE = /[^\\];\s*$/;
const $8459863c4d27aaf2$var$importantRE = /\s*!important$/;
function $8459863c4d27aaf2$var$setStyle(style, name, rawVal) {
    if ((0, $7s0Ms.isArray)(rawVal)) rawVal.forEach((v)=>$8459863c4d27aaf2$var$setStyle(style, name, v));
    else {
        const val = rawVal == null ? "" : String(rawVal);
        if (name.startsWith("--")) {
            if ($8459863c4d27aaf2$var$importantRE.test(val)) style.setProperty(name, val.replace($8459863c4d27aaf2$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $8459863c4d27aaf2$var$autoPrefix(style, name);
            if ($8459863c4d27aaf2$var$importantRE.test(val)) style.setProperty((0, $7s0Ms.hyphenate)(prefixed), val.replace($8459863c4d27aaf2$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $8459863c4d27aaf2$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $8459863c4d27aaf2$var$prefixCache = {};
function $8459863c4d27aaf2$var$autoPrefix(style, rawName) {
    const cached = $8459863c4d27aaf2$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $7s0Ms.camelize)(rawName);
    if (name !== "filter" && name in style) return $8459863c4d27aaf2$var$prefixCache[rawName] = name;
    name = (0, $7s0Ms.capitalize)(name);
    for(let i = 0; i < $8459863c4d27aaf2$var$prefixes.length; i++){
        const prefixed = $8459863c4d27aaf2$var$prefixes[i] + name;
        if (prefixed in style) return $8459863c4d27aaf2$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
/**
* Browsers update textarea width/height directly during native resize.
* Only special-case this common textarea path for now; other resize scenarios
* still follow normal vnode style patching.
*/ function $8459863c4d27aaf2$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $7s0Ms.isString)(next) && prev === next;
}
//#endregion
//#region packages/runtime-dom/src/modules/attrs.ts
const $8459863c4d27aaf2$export$2574309f616608d7 = "http://www.w3.org/1999/xlink";
function $8459863c4d27aaf2$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $7s0Ms.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($8459863c4d27aaf2$export$2574309f616608d7, key.slice(6, key.length));
        else el.setAttributeNS($8459863c4d27aaf2$export$2574309f616608d7, key, value);
    } else if (value == null || isBoolean && !(0, $7s0Ms.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $7s0Ms.isSymbol)(value) ? String(value) : value);
}
//#endregion
//#region packages/runtime-dom/src/modules/props.ts
function $8459863c4d27aaf2$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $8459863c4d27aaf2$export$1fdf04608ac1d660(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && (0, $7s0Ms.canSetValueDirectly)(tag)) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $7s0Ms.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
//#endregion
//#region packages/runtime-dom/src/modules/events.ts
function $8459863c4d27aaf2$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $8459863c4d27aaf2$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $8459863c4d27aaf2$var$veiKey = Symbol("_vei");
function $8459863c4d27aaf2$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$8459863c4d27aaf2$var$veiKey] || (el[$8459863c4d27aaf2$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $8459863c4d27aaf2$export$ad797ac1f0c6c291(rawName);
        if (nextValue) $8459863c4d27aaf2$var$addEventListener(el, name, invokers[rawName] = $8459863c4d27aaf2$var$createInvoker(nextValue, instance), options);
        else if (existingInvoker) {
            $8459863c4d27aaf2$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $8459863c4d27aaf2$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $8459863c4d27aaf2$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $8459863c4d27aaf2$export$ad797ac1f0c6c291(name) {
    let options;
    let m;
    while((m = name.match($8459863c4d27aaf2$var$optionsModifierRE)) && !$8459863c4d27aaf2$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    return [
        name[2] === ":" ? name.slice(3) : (0, $7s0Ms.hyphenate)(name.slice(2)),
        options
    ];
}
let $8459863c4d27aaf2$var$cachedNow = 0;
const $8459863c4d27aaf2$var$p = /*@__PURE__*/ Promise.resolve();
const $8459863c4d27aaf2$var$getNow = ()=>$8459863c4d27aaf2$var$cachedNow || ($8459863c4d27aaf2$var$p.then(()=>$8459863c4d27aaf2$var$cachedNow = 0), $8459863c4d27aaf2$var$cachedNow = Date.now());
function $8459863c4d27aaf2$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $7s0Ms.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $3dLyd.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $3dLyd.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $8459863c4d27aaf2$var$getNow();
    return invoker;
}
function $8459863c4d27aaf2$var$sanitizeEventValue(value, propName) {
    if ((0, $7s0Ms.isFunction)(value) || (0, $7s0Ms.isArray)(value)) return value;
    (0, $3dLyd.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ${typeof value}.`);
    return 0, $7s0Ms.NOOP;
}
//#endregion
//#region packages/runtime-dom/src/patchProp.ts
const $8459863c4d27aaf2$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $8459863c4d27aaf2$export$de1f6f779b5b44c(el, nextValue, isSVG);
    else if (key === "style") $8459863c4d27aaf2$export$1648b8c99f3dead4(el, prevValue, nextValue);
    else if ((0, $7s0Ms.isOn)(key)) {
        if (!(0, $7s0Ms.isModelListener)(key)) $8459863c4d27aaf2$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $8459863c4d27aaf2$export$11623ee7ce2794a7(el, key, nextValue, isSVG)) {
        $8459863c4d27aaf2$var$patchDOMProp(el, key, nextValue, parentComponent);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $8459863c4d27aaf2$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (el._isVueCE && ($8459863c4d27aaf2$export$153823794abe328a(el, key) || el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $7s0Ms.isString)(nextValue)))) $8459863c4d27aaf2$var$patchDOMProp(el, (0, $7s0Ms.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $8459863c4d27aaf2$var$patchAttr(el, key, nextValue, isSVG, parentComponent);
    }
};
function $8459863c4d27aaf2$export$11623ee7ce2794a7(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && (0, $7s0Ms.isNativeOn)(key) && (0, $7s0Ms.isFunction)(value)) return true;
        return false;
    }
    if ((0, $7s0Ms.shouldSetAsAttr)(el.tagName, key)) return false;
    if ((0, $7s0Ms.isNativeOn)(key) && (0, $7s0Ms.isString)(value)) return false;
    return key in el;
}
function $8459863c4d27aaf2$export$153823794abe328a(el, key) {
    const props = el._def.props;
    if (!props) return false;
    const camelKey = (0, $7s0Ms.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $7s0Ms.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $7s0Ms.camelize)(prop) === camelKey);
}
//#endregion
//#region packages/runtime-dom/src/apiCustomElement.ts
const $8459863c4d27aaf2$var$REMOVAL = {};
/*@__NO_SIDE_EFFECTS__*/ function $8459863c4d27aaf2$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $3dLyd.defineComponent)(options, extraOptions);
    if ((0, $7s0Ms.isPlainObject)(Comp)) Comp = (0, $7s0Ms.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $8459863c4d27aaf2$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $8459863c4d27aaf2$export$6debb2e68f212638 = (options, extraOptions)=>{
    return /* @__PURE__ */ $8459863c4d27aaf2$export$a00e2346eabbdbef(options, extraOptions, $8459863c4d27aaf2$export$35800275c0037383);
};
const $8459863c4d27aaf2$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
var $8459863c4d27aaf2$export$8aeafd20e0fdd5f4 = class VueElementBase extends $8459863c4d27aaf2$var$BaseClass {
    constructor(def, props = {}, createAppFn){
        super();
        this._isVueCE = true;
        this._instance = null;
        this._app = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._patching = false;
        this._dirty = false;
        this._ob = null;
        this._def = def;
        this._props = props;
        this._createApp = createAppFn;
        this._nonce = def.nonce;
        if (this._needsHydration()) this._root = this.shadowRoot;
        else if (def.shadowRoot !== false) {
            this.attachShadow((0, $7s0Ms.extend)({}, def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof VueElementBase) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mountComponent(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $3dLyd.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._unmount();
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _setParent(parent = this._parent) {
        if (parent && this._instance) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
	* resolve inner component definition (handle possible async component)
	*/ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $7s0Ms.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $7s0Ms.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[(0, $7s0Ms.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mountComponent(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            const { configureApp: configureApp } = this._def;
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = configureApp;
                this._def = def;
                resolve(def);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mountComponent(def) {
        this._mount(def);
        this._processExposed();
    }
    _processExposed() {
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $7s0Ms.hasOwn)(this, key)) Object.defineProperty(this, key, {
            get: ()=>(0, $SdEQh.unref)(exposed[key])
        });
    }
    _processInstance() {
        this._instance.ce = this;
        this._instance.isCE = true;
        var newStyles, s;
        const dispatch = (event, args)=>{
            this.dispatchEvent(new CustomEvent(event, (0, $7s0Ms.isPlainObject)(args[0]) ? (0, $7s0Ms.extend)({
                detail: args
            }, args[0]) : {
                detail: args
            }));
        };
        this._instance.emit = (event, ...args)=>{
            dispatch(event, args);
            if ((0, $7s0Ms.hyphenate)(event) !== event) dispatch((0, $7s0Ms.hyphenate)(event), args);
        };
        this._setParent();
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $7s0Ms.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $7s0Ms.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $8459863c4d27aaf2$var$REMOVAL;
        const camelKey = (0, $7s0Ms.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $7s0Ms.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
	* @internal
	*/ _getProp(key) {
        return this._props[key];
    }
    /**
	* @internal
	*/ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $8459863c4d27aaf2$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app && this._app._ceVNode) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $7s0Ms.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $7s0Ms.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $7s0Ms.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
	* Only called when shadowRoot is false
	*/ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
	* Only called when shadowRoot is false
	*/ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
	* @internal
	*/ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
	* @internal
	*/ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
	* @internal
	*/ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
	* @internal
	*/ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
	* @internal
	*/ _hasShadowRoot() {
        return this._root !== this;
    }
    /**
	* @internal
	*/ _removeChildStyle(comp) {
        var s;
    }
};
var $8459863c4d27aaf2$export$b337c1a55163dbe3 = class extends $8459863c4d27aaf2$export$8aeafd20e0fdd5f4 {
    constructor(def, props = {}, createAppFn = $8459863c4d27aaf2$export$4e373c34abfa8c68){
        super(def, props, createAppFn);
    }
    _needsHydration() {
        if (this.shadowRoot && this._createApp !== $8459863c4d27aaf2$export$4e373c34abfa8c68) return true;
        return false;
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
    }
    _update() {
        if (!this._app) return;
        const vnode = this._createVNode();
        vnode.appContext = this._app._context;
        $8459863c4d27aaf2$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _unmount() {
        if (this._app) this._app.unmount();
        if (this._instance && this._instance.ce) this._instance.ce = void 0;
        this._app = this._instance = null;
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $3dLyd.createVNode)(this._def, (0, $7s0Ms.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            this._processInstance();
        };
        return vnode;
    }
};
function $8459863c4d27aaf2$export$da5acfe93a94e37d(caller) {
    const { hasInstance: hasInstance, value: value } = (0, $3dLyd.useInstanceOption)("ce", true);
    const el = value;
    if (el) return el;
    else if (false) {
        if (!hasInstance) (0, $3dLyd.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $3dLyd.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
/**
* Retrieve the shadowRoot of the current custom element. Only usable in setup()
* of a `defineCustomElement` component.
*/ function $8459863c4d27aaf2$export$64d45095031fa749() {
    const el = $8459863c4d27aaf2$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
//#endregion
//#region packages/runtime-dom/src/helpers/useCssModule.ts
function $8459863c4d27aaf2$export$9300d5b90d56e3d1(name = "$style") {
    {
        const { hasInstance: hasInstance, value: type } = (0, $3dLyd.useInstanceOption)("type", true);
        if (!hasInstance) return 0, $7s0Ms.EMPTY_OBJ;
        const modules = type.__cssModules;
        if (!modules) return 0, $7s0Ms.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $7s0Ms.EMPTY_OBJ;
        return mod;
    }
}
//#endregion
//#region packages/runtime-dom/src/components/TransitionGroup.ts
const $8459863c4d27aaf2$var$positionMap = /* @__PURE__ */ new WeakMap();
const $8459863c4d27aaf2$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $8459863c4d27aaf2$var$moveCbKey = Symbol("_moveCb");
const $8459863c4d27aaf2$var$enterCbKey = Symbol("_enterCb");
/**
* Wrap logic that modifies TransitionGroup properties in a function
* so that it can be annotated as pure
*/ const $8459863c4d27aaf2$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $8459863c4d27aaf2$export$19ffa8f511f7bc2e = /* @__PURE__ */ $8459863c4d27aaf2$var$decorate({
    name: "TransitionGroup",
    props: /*@__PURE__*/ (0, $7s0Ms.extend)({}, $8459863c4d27aaf2$export$b899d57baa0167d5, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $3dLyd.getCurrentInstance)();
        const state = (0, $3dLyd.useTransitionState)();
        let prevChildren;
        let children;
        (0, $3dLyd.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$8459863c4d27aaf2$export$6488e4a884389379(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach((vnode)=>$8459863c4d27aaf2$export$d5371ae309f51a37(vnode.el));
            prevChildren.forEach($8459863c4d27aaf2$var$recordPosition);
            const movedChildren = prevChildren.filter($8459863c4d27aaf2$var$applyTranslation);
            $8459863c4d27aaf2$export$7d26bbb1236dafd6(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                $8459863c4d27aaf2$export$bb551b8c48d28521(el, moveClass);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $SdEQh.toRaw)(props);
            const cssTransitionProps = $8459863c4d27aaf2$export$b349eeb6ed6a6d73(rawProps);
            let tag = rawProps.tag || (0, $3dLyd.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && !child.el[$8459863c4d27aaf2$export$9899690c5a6aa34e]) {
                    prevChildren.push(child);
                    (0, $3dLyd.setTransitionHooks)(child, (0, $3dLyd.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $8459863c4d27aaf2$var$positionMap.set(child, $8459863c4d27aaf2$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $3dLyd.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $3dLyd.setTransitionHooks)(child, (0, $3dLyd.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $3dLyd.createVNode)(tag, null, children);
        };
    }
});
function $8459863c4d27aaf2$export$d5371ae309f51a37(el) {
    if (el[$8459863c4d27aaf2$var$moveCbKey]) el[$8459863c4d27aaf2$var$moveCbKey]();
    if (el[$8459863c4d27aaf2$var$enterCbKey]) el[$8459863c4d27aaf2$var$enterCbKey]();
}
function $8459863c4d27aaf2$var$recordPosition(c) {
    $8459863c4d27aaf2$var$newPositionMap.set(c, $8459863c4d27aaf2$var$getPosition(c.el));
}
function $8459863c4d27aaf2$var$applyTranslation(c) {
    if ($8459863c4d27aaf2$export$61fb5edf31d9f0b8($8459863c4d27aaf2$var$positionMap.get(c), $8459863c4d27aaf2$var$newPositionMap.get(c), c.el)) return c;
}
function $8459863c4d27aaf2$export$61fb5edf31d9f0b8(oldPos, newPos, el) {
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < .01) scaleX = 1;
        if (Math.abs(scaleY - 1) < .01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return true;
    }
    return false;
}
function $8459863c4d27aaf2$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $8459863c4d27aaf2$export$6488e4a884389379(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$8459863c4d27aaf2$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $8459863c4d27aaf2$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $8459863c4d27aaf2$export$bb551b8c48d28521 = (el, moveClass)=>{
    const style = el.style;
    $8459863c4d27aaf2$var$addTransitionClass(el, moveClass);
    style.transform = style.webkitTransform = style.transitionDuration = "";
    const cb = el[$8459863c4d27aaf2$var$moveCbKey] = (e)=>{
        if (e && e.target !== el) return;
        if (!e || e.propertyName.endsWith("transform")) {
            el.removeEventListener("transitionend", cb);
            el[$8459863c4d27aaf2$var$moveCbKey] = null;
            $8459863c4d27aaf2$var$removeTransitionClass(el, moveClass);
        }
    };
    el.addEventListener("transitionend", cb);
};
//#endregion
//#region packages/runtime-dom/src/directives/vModel.ts
const $8459863c4d27aaf2$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $7s0Ms.isArray)(fn) ? (value)=>(0, $7s0Ms.invokeArrayFns)(fn, value) : fn;
};
function $8459863c4d27aaf2$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $8459863c4d27aaf2$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $8459863c4d27aaf2$var$assignKey = Symbol("_assign");
const $8459863c4d27aaf2$var$initialValueKey = Symbol("_initialValue");
const $8459863c4d27aaf2$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$8459863c4d27aaf2$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$8459863c4d27aaf2$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        $8459863c4d27aaf2$export$2d3637690b27facf(el, trim, number || !!(vnode.props && vnode.props.type === "number"), lazy);
    },
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$8459863c4d27aaf2$var$initialValueKey];
        delete el[$8459863c4d27aaf2$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$8459863c4d27aaf2$var$assignKey]($8459863c4d27aaf2$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        $8459863c4d27aaf2$export$b171fe2fda8d060a(el, oldValue, value, trim, number, lazy);
    }
};
function $8459863c4d27aaf2$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $7s0Ms.looseToNumber)(value);
    return value;
}
/**
* @internal
*/ const $8459863c4d27aaf2$export$2d3637690b27facf = (el, trim, number, lazy, set)=>{
    $8459863c4d27aaf2$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
        if (e.target.composing) return;
        (set || el[$8459863c4d27aaf2$var$assignKey])($8459863c4d27aaf2$var$castValue(el.value, trim, number || el.type === "number"));
    });
    if (trim || number) $8459863c4d27aaf2$var$addEventListener(el, "change", ()=>{
        el.value = $8459863c4d27aaf2$var$castValue(el.value, trim, number || el.type === "number");
    });
    if (!lazy) {
        $8459863c4d27aaf2$var$addEventListener(el, "compositionstart", $8459863c4d27aaf2$var$onCompositionStart);
        $8459863c4d27aaf2$var$addEventListener(el, "compositionend", $8459863c4d27aaf2$var$onCompositionEnd);
        $8459863c4d27aaf2$var$addEventListener(el, "change", $8459863c4d27aaf2$var$onCompositionEnd);
    }
};
/**
* @internal
*/ const $8459863c4d27aaf2$export$b171fe2fda8d060a = (el, oldValue, value, trim, number, lazy)=>{
    if (el.composing) return;
    const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $7s0Ms.looseToNumber)(el.value) : el.value;
    const newValue = value == null ? "" : value;
    if (elValue === newValue) return;
    const rootNode = el.getRootNode();
    if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
        if (lazy && value === oldValue) return;
        if (trim && el.value.trim() === newValue) return;
    }
    el.value = newValue;
};
const $8459863c4d27aaf2$export$8847c2e532b35714 = {
    deep: true,
    created (el, _, vnode) {
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        $8459863c4d27aaf2$export$10ad6c0b109fa494(el);
    },
    mounted (el, binding, vnode) {
        $8459863c4d27aaf2$export$bf72bd412424aea(el, binding.oldValue, binding.value, vnode.props.value);
    },
    beforeUpdate (el, binding, vnode) {
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        $8459863c4d27aaf2$export$bf72bd412424aea(el, binding.oldValue, binding.value, vnode.props.value);
    }
};
/**
* @internal
*/ const $8459863c4d27aaf2$export$10ad6c0b109fa494 = (el, set)=>{
    $8459863c4d27aaf2$var$addEventListener(el, "change", ()=>{
        const assign = set || el[$8459863c4d27aaf2$var$assignKey];
        const modelValue = el._modelValue;
        const elementValue = $8459863c4d27aaf2$export$882b439d816257fa(el);
        const checked = el.checked;
        if ((0, $7s0Ms.isArray)(modelValue)) {
            const index = (0, $7s0Ms.looseIndexOf)(modelValue, elementValue);
            const found = index !== -1;
            if (checked && !found) assign(modelValue.concat(elementValue));
            else if (!checked && found) {
                const filtered = [
                    ...modelValue
                ];
                filtered.splice(index, 1);
                assign(filtered);
            }
        } else if ((0, $7s0Ms.isSet)(modelValue)) {
            const cloned = new Set(modelValue);
            if (checked) cloned.add(elementValue);
            else cloned.delete(elementValue);
            assign(cloned);
        } else assign($8459863c4d27aaf2$var$getCheckboxValue(el, checked));
    });
};
/**
* @internal
*/ const $8459863c4d27aaf2$export$bf72bd412424aea = (el, oldValue, value, rawValue = $8459863c4d27aaf2$export$882b439d816257fa(el))=>{
    el._modelValue = value;
    let checked;
    if ((0, $7s0Ms.isArray)(value)) checked = (0, $7s0Ms.looseIndexOf)(value, rawValue) > -1;
    else if ((0, $7s0Ms.isSet)(value)) checked = value.has(rawValue);
    else {
        if (value === oldValue) return;
        checked = (0, $7s0Ms.looseEqual)(value, $8459863c4d27aaf2$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
};
const $8459863c4d27aaf2$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $7s0Ms.looseEqual)(value, vnode.props.value);
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        $8459863c4d27aaf2$var$addEventListener(el, "change", ()=>{
            el[$8459863c4d27aaf2$var$assignKey]($8459863c4d27aaf2$export$882b439d816257fa(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $7s0Ms.looseEqual)(value, vnode.props.value);
    }
};
const $8459863c4d27aaf2$export$87d227567b51ca39 = {
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        $8459863c4d27aaf2$export$6755e66381fe27bf(el, value, number);
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
    },
    mounted (el, { value: value }) {
        $8459863c4d27aaf2$export$ff95a38066b55f02(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$8459863c4d27aaf2$var$assignKey] = $8459863c4d27aaf2$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $8459863c4d27aaf2$export$ff95a38066b55f02(el, value);
    }
};
/**
* @internal
*/ const $8459863c4d27aaf2$export$6755e66381fe27bf = (el, value, number, set)=>{
    el._modelValue = value;
    $8459863c4d27aaf2$var$addEventListener(el, "change", ()=>{
        const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $7s0Ms.looseToNumber)($8459863c4d27aaf2$export$882b439d816257fa(o)) : $8459863c4d27aaf2$export$882b439d816257fa(o));
        const multiple = el.multiple;
        const assignedValue = multiple ? (0, $7s0Ms.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
        const pending = el._pendingValue = [
            multiple,
            multiple ? (0, $7s0Ms.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
        ];
        try {
            (set || el[$8459863c4d27aaf2$var$assignKey])(assignedValue);
        } finally{
            (0, $3dLyd.nextTick)(()=>{
                if (el._pendingValue === pending) el._pendingValue = void 0;
            });
        }
    });
};
function $8459863c4d27aaf2$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $7s0Ms.looseEqual)(value, assignedValue);
    if ((0, $7s0Ms.isArray)(value)) return (0, $7s0Ms.looseEqual)(value, assignedValue);
    if ((0, $7s0Ms.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue)if (!value.has(item)) return false;
        return true;
    }
    return false;
}
/**
* @internal
*/ const $8459863c4d27aaf2$export$ff95a38066b55f02 = (el, value)=>{
    el._modelValue = value;
    const pending = el._pendingValue;
    el._pendingValue = void 0;
    if (pending && pending[0] === el.multiple && $8459863c4d27aaf2$var$isSameSelectValue(value, pending[1], pending[0])) return;
    $8459863c4d27aaf2$var$setSelected(el, value);
};
function $8459863c4d27aaf2$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $7s0Ms.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $7s0Ms.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $8459863c4d27aaf2$export$882b439d816257fa(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $7s0Ms.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $7s0Ms.looseEqual)($8459863c4d27aaf2$export$882b439d816257fa(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
/**
* @internal retrieve raw value set via :value bindings
*/ function $8459863c4d27aaf2$export$882b439d816257fa(el) {
    return "_value" in el ? el._value : el.value;
}
function $8459863c4d27aaf2$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    if (key in el) return el[key];
    const attr = checked ? "true-value" : "false-value";
    if (el.hasAttribute(attr)) return el.getAttribute(attr);
    return checked;
}
const $8459863c4d27aaf2$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $8459863c4d27aaf2$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $8459863c4d27aaf2$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $8459863c4d27aaf2$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $8459863c4d27aaf2$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $8459863c4d27aaf2$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $8459863c4d27aaf2$export$87d227567b51ca39;
        case "TEXTAREA":
            return $8459863c4d27aaf2$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $8459863c4d27aaf2$export$8847c2e532b35714;
                case "radio":
                    return $8459863c4d27aaf2$export$b4356c59b38b7aa9;
                default:
                    return $8459863c4d27aaf2$export$f1f88689f5728478;
            }
    }
}
function $8459863c4d27aaf2$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const fn = $8459863c4d27aaf2$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type)[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $8459863c4d27aaf2$var$initVModelForSSR() {
    $8459863c4d27aaf2$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $8459863c4d27aaf2$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $7s0Ms.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $8459863c4d27aaf2$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $7s0Ms.isArray)(value)) {
            if (vnode.props && (0, $7s0Ms.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $7s0Ms.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $8459863c4d27aaf2$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $8459863c4d27aaf2$var$resolveDynamicModel(vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
//#endregion
//#region packages/runtime-dom/src/directives/vOn.ts
const $8459863c4d27aaf2$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $8459863c4d27aaf2$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$8459863c4d27aaf2$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
* @private
*/ const $8459863c4d27aaf2$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $8459863c4d27aaf2$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $8459863c4d27aaf2$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
* @private
*/ const $8459863c4d27aaf2$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $7s0Ms.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $8459863c4d27aaf2$var$keyNames[k] === eventKey)) return fn(event);
    });
};
//#endregion
//#region packages/runtime-dom/src/index.ts
const $8459863c4d27aaf2$var$rendererOptions = /*@__PURE__*/ (0, $7s0Ms.extend)({
    patchProp: $8459863c4d27aaf2$export$cd4aa0842d13df8b
}, $8459863c4d27aaf2$export$de4fb7f5030605d3);
let $8459863c4d27aaf2$var$renderer;
let $8459863c4d27aaf2$var$enabledHydration = false;
function $8459863c4d27aaf2$export$a0bae4d3eba7c8a0() {
    return $8459863c4d27aaf2$var$renderer || ($8459863c4d27aaf2$var$renderer = (0, $3dLyd.createRenderer)($8459863c4d27aaf2$var$rendererOptions));
}
function $8459863c4d27aaf2$export$70a3ed9a5d6c0c60() {
    $8459863c4d27aaf2$var$renderer = $8459863c4d27aaf2$var$enabledHydration ? $8459863c4d27aaf2$var$renderer : (0, $3dLyd.createHydrationRenderer)($8459863c4d27aaf2$var$rendererOptions);
    $8459863c4d27aaf2$var$enabledHydration = true;
    return $8459863c4d27aaf2$var$renderer;
}
const $8459863c4d27aaf2$export$b3890eb0ae9dca99 = (...args)=>{
    $8459863c4d27aaf2$export$a0bae4d3eba7c8a0().render(...args);
};
const $8459863c4d27aaf2$export$fa8d919ba61d84db = (...args)=>{
    $8459863c4d27aaf2$export$70a3ed9a5d6c0c60().hydrate(...args);
};
const $8459863c4d27aaf2$export$4e373c34abfa8c68 = (...args)=>{
    const app = $8459863c4d27aaf2$export$a0bae4d3eba7c8a0().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $8459863c4d27aaf2$export$fc6b59695d328a27(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $7s0Ms.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $8459863c4d27aaf2$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $8459863c4d27aaf2$export$35800275c0037383 = (...args)=>{
    (0, $3dLyd.setIsHydratingEnabled)(true);
    const app = $8459863c4d27aaf2$export$70a3ed9a5d6c0c60().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $8459863c4d27aaf2$export$fc6b59695d328a27(containerOrSelector);
        if (container) return mount(container, true, $8459863c4d27aaf2$var$resolveRootNamespace(container));
    };
    return app;
};
function $8459863c4d27aaf2$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $8459863c4d27aaf2$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $7s0Ms.isHTMLTag)(tag) || (0, $7s0Ms.isSVGTag)(tag) || (0, $7s0Ms.isMathMLTag)(tag),
        writable: false
    });
}
function $8459863c4d27aaf2$var$injectCompilerOptionsCheck(app) {
    if ((0, $3dLyd.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $3dLyd.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = "The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka \"full build\"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader's `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc";
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $3dLyd.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $3dLyd.warn)(msg);
            }
        });
    }
}
/**
* @internal
*/ function $8459863c4d27aaf2$export$fc6b59695d328a27(container) {
    if ((0, $7s0Ms.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $8459863c4d27aaf2$var$ssrDirectiveInitialized = false;
/**
* @internal
*/ const $8459863c4d27aaf2$export$800b28255aa678d9 = ()=>{
    if (!$8459863c4d27aaf2$var$ssrDirectiveInitialized) {
        $8459863c4d27aaf2$var$ssrDirectiveInitialized = true;
        $8459863c4d27aaf2$var$initVModelForSSR();
        $8459863c4d27aaf2$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $3dLyd);

});
parcelRegister("3dLyd", function(module, exports) {

$parcel$export(module.exports, "pushWarningContext", function () { return $2587789e20bc75b6$export$eff0ee073d211f48; });
$parcel$export(module.exports, "popWarningContext", function () { return $2587789e20bc75b6$export$1f21d88a9fb0fa16; });
$parcel$export(module.exports, "isVNode", function () { return $2587789e20bc75b6$export$3868d13f8734ae81; });
$parcel$export(module.exports, "callWithErrorHandling", function () { return $2587789e20bc75b6$export$b22fcaf88446e9bf; });
$parcel$export(module.exports, "assertNumber", function () { return $2587789e20bc75b6$export$dfbcecb440255e4a; });
$parcel$export(module.exports, "ErrorCodes", function () { return $2587789e20bc75b6$export$10e8e1cf990558d7; });
$parcel$export(module.exports, "handleError", function () { return $2587789e20bc75b6$export$d3da1ecaf1206c58; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $2587789e20bc75b6$export$dae85862a8d94378; });
$parcel$export(module.exports, "SchedulerJobFlags", function () { return $2587789e20bc75b6$export$fdec56fe4e195399; });
$parcel$export(module.exports, "nextTick", function () { return $2587789e20bc75b6$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queueJob", function () { return $2587789e20bc75b6$export$fba1a0a20887772f; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $2587789e20bc75b6$export$59536a0199721cab; });
$parcel$export(module.exports, "flushOnAppMount", function () { return $2587789e20bc75b6$export$3ee27bfcb8f44b9d; });
$parcel$export(module.exports, "getComponentName", function () { return $2587789e20bc75b6$export$26727cfcc4d7e0fc; });
$parcel$export(module.exports, "registerHMR", function () { return $2587789e20bc75b6$export$2aad669127ef41b0; });
$parcel$export(module.exports, "unregisterHMR", function () { return $2587789e20bc75b6$export$5f6a3eaf04e860b3; });
$parcel$export(module.exports, "Fragment", function () { return $2587789e20bc75b6$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $2587789e20bc75b6$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $2587789e20bc75b6$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $2587789e20bc75b6$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "devtoolsComponentAdded", function () { return $2587789e20bc75b6$export$a76a9a73068a1a5e; });
$parcel$export(module.exports, "setCurrentRenderingInstance", function () { return $2587789e20bc75b6$export$824c074beef4c41b; });
$parcel$export(module.exports, "pushScopeId", function () { return $2587789e20bc75b6$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $2587789e20bc75b6$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withScopeId", function () { return $2587789e20bc75b6$export$15ba313e13f3dd04; });
$parcel$export(module.exports, "withCtx", function () { return $2587789e20bc75b6$export$694b237e827a3d23; });
$parcel$export(module.exports, "setBlockTracking", function () { return $2587789e20bc75b6$export$c20bee82f26f1e27; });
$parcel$export(module.exports, "withDirectives", function () { return $2587789e20bc75b6$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "invokeDirectiveHook", function () { return $2587789e20bc75b6$export$91e53aad4f01262; });
$parcel$export(module.exports, "provide", function () { return $2587789e20bc75b6$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "currentInstance", function () { return $2587789e20bc75b6$export$5d0c78f02672825; });
$parcel$export(module.exports, "inject", function () { return $2587789e20bc75b6$export$a976684a0efeb93f; });
$parcel$export(module.exports, "hasInjectionContext", function () { return $2587789e20bc75b6$export$caf6761f24fc571a; });
$parcel$export(module.exports, "ssrContextKey", function () { return $2587789e20bc75b6$export$f2549a27e18acf2d; });
$parcel$export(module.exports, "useSSRContext", function () { return $2587789e20bc75b6$export$6b1c54dc4befcda; });
$parcel$export(module.exports, "watchEffect", function () { return $2587789e20bc75b6$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $2587789e20bc75b6$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watchSyncEffect", function () { return $2587789e20bc75b6$export$2035654f31b0e555; });
$parcel$export(module.exports, "watch", function () { return $2587789e20bc75b6$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "queuePostRenderEffect", function () { return $2587789e20bc75b6$export$51ec8e020844a97a; });
$parcel$export(module.exports, "setCurrentInstance", function () { return $2587789e20bc75b6$export$a5e695a16aa0b6d4; });
$parcel$export(module.exports, "restoreCurrentInstance", function () { return $2587789e20bc75b6$export$95e96a1fb881e3e7; });
$parcel$export(module.exports, "isTeleportDisabled", function () { return $2587789e20bc75b6$export$44727b5035358778; });
$parcel$export(module.exports, "isTeleportDeferred", function () { return $2587789e20bc75b6$export$6f4d6f0c8744b47f; });
$parcel$export(module.exports, "resolveTeleportTarget", function () { return $2587789e20bc75b6$export$792b35e9a6a3f24c; });
$parcel$export(module.exports, "Teleport", function () { return $2587789e20bc75b6$export$76d55a0304a371f4; });
$parcel$export(module.exports, "leaveCbKey", function () { return $2587789e20bc75b6$export$6402c150d41fe6bc; });
$parcel$export(module.exports, "useTransitionState", function () { return $2587789e20bc75b6$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $2587789e20bc75b6$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $2587789e20bc75b6$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $2587789e20bc75b6$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $2587789e20bc75b6$export$f13e630aa3915748; });
$parcel$export(module.exports, "resolveTransitionChild", function () { return $2587789e20bc75b6$export$bacc260570b6d3ae; });
$parcel$export(module.exports, "checkTransitionMode", function () { return $2587789e20bc75b6$export$f7697b49c3204928; });
$parcel$export(module.exports, "prepareTransitionSwitch", function () { return $2587789e20bc75b6$export$aee04c50c0dfaf12; });
$parcel$export(module.exports, "BaseTransition", function () { return $2587789e20bc75b6$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $2587789e20bc75b6$export$76ac1779589cd824; });
$parcel$export(module.exports, "baseResolveTransitionHooks", function () { return $2587789e20bc75b6$export$52bce14e5b84ba5b; });
$parcel$export(module.exports, "isKeepAlive", function () { return $2587789e20bc75b6$export$a33216a979d8327a; });
$parcel$export(module.exports, "cloneVNode", function () { return $2587789e20bc75b6$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $2587789e20bc75b6$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "createCommentVNode", function () { return $2587789e20bc75b6$export$49553837c7236d3c; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $2587789e20bc75b6$export$7770a22486565649; });
$parcel$export(module.exports, "prepareTransitionLeave", function () { return $2587789e20bc75b6$export$750adf600c62558a; });
$parcel$export(module.exports, "defineComponent", function () { return $2587789e20bc75b6$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "useId", function () { return $2587789e20bc75b6$export$f680877a34711e37; });
$parcel$export(module.exports, "markAsyncBoundary", function () { return $2587789e20bc75b6$export$b9b0eeb564431e5e; });
$parcel$export(module.exports, "knownTemplateRefs", function () { return $2587789e20bc75b6$export$f55a8fa3b95033b5; });
$parcel$export(module.exports, "useTemplateRef", function () { return $2587789e20bc75b6$export$83a5dbc1f35517ca; });
$parcel$export(module.exports, "isTemplateRefKey", function () { return $2587789e20bc75b6$export$950f9ee44cd3c66; });
$parcel$export(module.exports, "setRef", function () { return $2587789e20bc75b6$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "isAsyncWrapper", function () { return $2587789e20bc75b6$export$4d0901d882427199; });
$parcel$export(module.exports, "createCanSetSetupRefChecker", function () { return $2587789e20bc75b6$export$6082a4aa7ed81817; });
$parcel$export(module.exports, "isHydratingEnabled", function () { return $2587789e20bc75b6$export$949522c94f173e7e; });
$parcel$export(module.exports, "setIsHydratingEnabled", function () { return $2587789e20bc75b6$export$fb2190d8f9a1a092; });
$parcel$export(module.exports, "isHydrating", function () { return $2587789e20bc75b6$export$454b4aa5c5ff33b6; });
$parcel$export(module.exports, "logMismatchError", function () { return $2587789e20bc75b6$export$7c36cdbb1b0f1a71; });
$parcel$export(module.exports, "getContainerType", function () { return $2587789e20bc75b6$export$acc6f3e19803b3dc; });
$parcel$export(module.exports, "isTemplateNode", function () { return $2587789e20bc75b6$export$f125a8a2b402ed89; });
$parcel$export(module.exports, "VaporSlot", function () { return $2587789e20bc75b6$export$c7c4a6890f1c1342; });
$parcel$export(module.exports, "createVNode", function () { return $2587789e20bc75b6$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $2587789e20bc75b6$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "isMismatchAllowed", function () { return $2587789e20bc75b6$export$89e0dff13906bb59; });
$parcel$export(module.exports, "normalizeVNode", function () { return $2587789e20bc75b6$export$a0e1465ad202d515; });
$parcel$export(module.exports, "isSetEqual", function () { return $2587789e20bc75b6$export$a8d0d0c8d1c5df64; });
$parcel$export(module.exports, "toClassSet", function () { return $2587789e20bc75b6$export$e64691051f3919e5; });
$parcel$export(module.exports, "toStyleMap", function () { return $2587789e20bc75b6$export$10b092b355df2060; });
$parcel$export(module.exports, "isMapEqual", function () { return $2587789e20bc75b6$export$71029b577818f2bb; });
$parcel$export(module.exports, "isValidHtmlOrSvgAttribute", function () { return $2587789e20bc75b6$export$92c55cf0d3a086c0; });
$parcel$export(module.exports, "getAttributeMismatch", function () { return $2587789e20bc75b6$export$1a5eb8a5128caad6; });
$parcel$export(module.exports, "warnPropMismatch", function () { return $2587789e20bc75b6$export$c6d1c9a52f0379ae; });
$parcel$export(module.exports, "MismatchTypes", function () { return $2587789e20bc75b6$export$92e7f8fbf145401a; });
$parcel$export(module.exports, "hydrateOnIdle", function () { return $2587789e20bc75b6$export$8bfca283fd254627; });
$parcel$export(module.exports, "hydrateOnVisible", function () { return $2587789e20bc75b6$export$2b04cd335e660930; });
$parcel$export(module.exports, "hydrateOnMediaQuery", function () { return $2587789e20bc75b6$export$804dbb6002787b74; });
$parcel$export(module.exports, "hydrateOnInteraction", function () { return $2587789e20bc75b6$export$288f5a9b4248e114; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return $2587789e20bc75b6$export$d75d499b4c16cf21; });
$parcel$export(module.exports, "createAsyncComponentContext", function () { return $2587789e20bc75b6$export$1e8f866142774b37; });
$parcel$export(module.exports, "performAsyncHydrate", function () { return $2587789e20bc75b6$export$49918ad629c39773; });
$parcel$export(module.exports, "useAsyncComponentState", function () { return $2587789e20bc75b6$export$c7a65c52b748d650; });
$parcel$export(module.exports, "onUnmounted", function () { return $2587789e20bc75b6$export$13348a43ccacfe58; });
$parcel$export(module.exports, "KeepAlive", function () { return $2587789e20bc75b6$export$70eb8a58709972df; });
$parcel$export(module.exports, "activate", function () { return $2587789e20bc75b6$export$234c45b355edd85b; });
$parcel$export(module.exports, "deactivate", function () { return $2587789e20bc75b6$export$e96c1edfdaf2d1db; });
$parcel$export(module.exports, "resetShapeFlag", function () { return $2587789e20bc75b6$export$e88525abd1b19421; });
$parcel$export(module.exports, "matches", function () { return $2587789e20bc75b6$export$de994efd351b291c; });
$parcel$export(module.exports, "onUpdated", function () { return $2587789e20bc75b6$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $2587789e20bc75b6$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $2587789e20bc75b6$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "invalidateMount", function () { return $2587789e20bc75b6$export$47f10f11906274f2; });
$parcel$export(module.exports, "onBeforeMount", function () { return $2587789e20bc75b6$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $2587789e20bc75b6$export$ab91988a13872e4c; });
$parcel$export(module.exports, "onServerPrefetch", function () { return $2587789e20bc75b6$export$ebf0c601f267bceb; });
$parcel$export(module.exports, "onRenderTriggered", function () { return $2587789e20bc75b6$export$898295a813d662eb; });
$parcel$export(module.exports, "onRenderTracked", function () { return $2587789e20bc75b6$export$2b41f4235363e921; });
$parcel$export(module.exports, "onErrorCaptured", function () { return $2587789e20bc75b6$export$6a3a15856e50ad19; });
$parcel$export(module.exports, "resolveComponent", function () { return $2587789e20bc75b6$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "NULL_DYNAMIC_COMPONENT", function () { return $2587789e20bc75b6$export$7d1f90a35714b16e; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $2587789e20bc75b6$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $2587789e20bc75b6$export$a1989e995cd481be; });
$parcel$export(module.exports, "renderList", function () { return $2587789e20bc75b6$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $2587789e20bc75b6$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "rawVaporSlotKey", function () { return $2587789e20bc75b6$export$3ab367ca01a03fcc; });
$parcel$export(module.exports, "vdomSlotFallbackKey", function () { return $2587789e20bc75b6$export$3d218eda79783141; });
$parcel$export(module.exports, "renderSlot", function () { return $2587789e20bc75b6$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $2587789e20bc75b6$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $2587789e20bc75b6$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "ensureValidVNode", function () { return $2587789e20bc75b6$export$9fc41f261330971f; });
$parcel$export(module.exports, "ensureVaporSlotFallback", function () { return $2587789e20bc75b6$export$48f2e51a96a1a702; });
$parcel$export(module.exports, "toHandlers", function () { return $2587789e20bc75b6$export$2fb94ff667a6a1a; });
$parcel$export(module.exports, "defineProps", function () { return $2587789e20bc75b6$export$80b33eababae110e; });
$parcel$export(module.exports, "defineEmits", function () { return $2587789e20bc75b6$export$51ecece22fc17ddc; });
$parcel$export(module.exports, "defineExpose", function () { return $2587789e20bc75b6$export$da25b65ca24b518a; });
$parcel$export(module.exports, "defineOptions", function () { return $2587789e20bc75b6$export$77e79129327f3d0d; });
$parcel$export(module.exports, "defineSlots", function () { return $2587789e20bc75b6$export$1b3acd4bb805b712; });
$parcel$export(module.exports, "defineModel", function () { return $2587789e20bc75b6$export$acd55aa037e791bb; });
$parcel$export(module.exports, "withDefaults", function () { return $2587789e20bc75b6$export$4df9c0969a9e0160; });
$parcel$export(module.exports, "useSlots", function () { return $2587789e20bc75b6$export$9203a8e84125433c; });
$parcel$export(module.exports, "useAttrs", function () { return $2587789e20bc75b6$export$75e29435042cd2ea; });
$parcel$export(module.exports, "mergeDefaults", function () { return $2587789e20bc75b6$export$ec60f47d4a8a2e7f; });
$parcel$export(module.exports, "mergeModels", function () { return $2587789e20bc75b6$export$ad4f724f587e6828; });
$parcel$export(module.exports, "createPropsRestProxy", function () { return $2587789e20bc75b6$export$7c343e855c563faa; });
$parcel$export(module.exports, "withAsyncContext", function () { return $2587789e20bc75b6$export$d6d6f7369f1fb104; });
$parcel$export(module.exports, "computed", function () { return $2587789e20bc75b6$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "createAppAPI", function () { return $2587789e20bc75b6$export$20a32069df128d70; });
$parcel$export(module.exports, "version", function () { return $2587789e20bc75b6$export$83d89fbfd8236492; });
$parcel$export(module.exports, "useModel", function () { return $2587789e20bc75b6$export$fb78bd113157f1a1; });
$parcel$export(module.exports, "defaultPropGetter", function () { return $2587789e20bc75b6$export$ea66d7ac9b8996b6; });
$parcel$export(module.exports, "baseEmit", function () { return $2587789e20bc75b6$export$15f4c4319e4e597d; });
$parcel$export(module.exports, "isEmitListener", function () { return $2587789e20bc75b6$export$bd525f5264ebdc33; });
$parcel$export(module.exports, "getFunctionalFallthrough", function () { return $2587789e20bc75b6$export$f83a77e4c783b3a2; });
$parcel$export(module.exports, "filterModelListeners", function () { return $2587789e20bc75b6$export$316c7e1847985a1d; });
$parcel$export(module.exports, "warnExtraneousAttributes", function () { return $2587789e20bc75b6$export$b82d7003bc568535; });
$parcel$export(module.exports, "isFunctionalFallthroughKey", function () { return $2587789e20bc75b6$export$80ff18eb01272c8e; });
$parcel$export(module.exports, "shouldUpdateComponent", function () { return $2587789e20bc75b6$export$225fd36bef19d8c6; });
$parcel$export(module.exports, "createInternalObject", function () { return $2587789e20bc75b6$export$1fa0ca5a6375b7; });
$parcel$export(module.exports, "resolvePropValue", function () { return $2587789e20bc75b6$export$ba06f8f07b4aa3a7; });
$parcel$export(module.exports, "baseNormalizePropsOptions", function () { return $2587789e20bc75b6$export$f0eb979c68386821; });
$parcel$export(module.exports, "validateProps", function () { return $2587789e20bc75b6$export$45855e0dd982478b; });
$parcel$export(module.exports, "startMeasure", function () { return $2587789e20bc75b6$export$b62aa2130c86b59b; });
$parcel$export(module.exports, "endMeasure", function () { return $2587789e20bc75b6$export$97a67d1a5c124236; });
$parcel$export(module.exports, "initFeatureFlags", function () { return $2587789e20bc75b6$export$f9d0db67c92b2ab2; });
$parcel$export(module.exports, "MoveType", function () { return $2587789e20bc75b6$export$be204faa7b4ee90a; });
$parcel$export(module.exports, "createRenderer", function () { return $2587789e20bc75b6$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $2587789e20bc75b6$export$200524cf0d997ff0; });
$parcel$export(module.exports, "performTransitionEnter", function () { return $2587789e20bc75b6$export$b65fa8a64a2e2d16; });
$parcel$export(module.exports, "getInheritedScopeIds", function () { return $2587789e20bc75b6$export$3390f5447109b373; });
$parcel$export(module.exports, "performTransitionLeave", function () { return $2587789e20bc75b6$export$6a096a74cfa9e795; });
$parcel$export(module.exports, "Suspense", function () { return $2587789e20bc75b6$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "createElementBlock", function () { return $2587789e20bc75b6$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $2587789e20bc75b6$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "transformVNodeArgs", function () { return $2587789e20bc75b6$export$83beccd3afeeb809; });
$parcel$export(module.exports, "normalizeRef", function () { return $2587789e20bc75b6$export$8e5958b67b6795b0; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $2587789e20bc75b6$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $2587789e20bc75b6$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $2587789e20bc75b6$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "simpleSetCurrentInstance", function () { return $2587789e20bc75b6$export$a1b5a29a1999a394; });
$parcel$export(module.exports, "useInstanceOption", function () { return $2587789e20bc75b6$export$f94b6c23bf914d02; });
$parcel$export(module.exports, "nextUid", function () { return $2587789e20bc75b6$export$be5627916a199b29; });
$parcel$export(module.exports, "validateComponentName", function () { return $2587789e20bc75b6$export$4fb1f2dc002bb2d3; });
$parcel$export(module.exports, "registerRuntimeCompiler", function () { return $2587789e20bc75b6$export$667bb5a67822b941; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $2587789e20bc75b6$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "expose", function () { return $2587789e20bc75b6$export$9b7f6e342a8cbd38; });
$parcel$export(module.exports, "h", function () { return $2587789e20bc75b6$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $2587789e20bc75b6$export$aed4979be6a60047; });
$parcel$export(module.exports, "withMemo", function () { return $2587789e20bc75b6$export$2a6d714a4d738ae; });
$parcel$export(module.exports, "isMemoSame", function () { return $2587789e20bc75b6$export$bf525184d622787c; });
$parcel$export(module.exports, "warn", function () { return $2587789e20bc75b6$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "ErrorTypeStrings", function () { return $2587789e20bc75b6$export$795e0ad4a0e2ed30; });
$parcel$export(module.exports, "devtools", function () { return $2587789e20bc75b6$export$6922d3b3a607469e; });
$parcel$export(module.exports, "setDevtoolsHook", function () { return $2587789e20bc75b6$export$b0c258b32c26c785; });
$parcel$export(module.exports, "ssrUtils", function () { return $2587789e20bc75b6$export$a9679033567b336d; });
$parcel$export(module.exports, "resolveFilter", function () { return $2587789e20bc75b6$export$83cf26e06ea620e1; });
$parcel$export(module.exports, "compatUtils", function () { return $2587789e20bc75b6$export$dc678eddf276286e; });
$parcel$export(module.exports, "DeprecationTypes", function () { return $2587789e20bc75b6$export$22072a82865312f6; });
$parcel$export(module.exports, "EffectScope", function () { return (parcelRequire("SdEQh")).EffectScope; });
$parcel$export(module.exports, "ReactiveEffect", function () { return (parcelRequire("SdEQh")).ReactiveEffect; });
$parcel$export(module.exports, "TrackOpTypes", function () { return (parcelRequire("SdEQh")).TrackOpTypes; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return (parcelRequire("SdEQh")).TriggerOpTypes; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("7s0Ms")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("7s0Ms")).capitalize; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("SdEQh")).customRef; });
$parcel$export(module.exports, "effect", function () { return (parcelRequire("SdEQh")).effect; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("SdEQh")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("SdEQh")).getCurrentScope; });
$parcel$export(module.exports, "getCurrentWatcher", function () { return (parcelRequire("SdEQh")).getCurrentWatcher; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("SdEQh")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("SdEQh")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("SdEQh")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("SdEQh")).isRef; });
$parcel$export(module.exports, "isShallow", function () { return (parcelRequire("SdEQh")).isShallow; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("SdEQh")).markRaw; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("7s0Ms")).normalizeClass; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("7s0Ms")).normalizeProps; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("7s0Ms")).normalizeStyle; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("SdEQh")).onScopeDispose; });
$parcel$export(module.exports, "onWatcherCleanup", function () { return (parcelRequire("SdEQh")).onWatcherCleanup; });
$parcel$export(module.exports, "proxyRefs", function () { return (parcelRequire("SdEQh")).proxyRefs; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("SdEQh")).reactive; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("SdEQh")).readonly; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("SdEQh")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("SdEQh")).shallowReactive; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("SdEQh")).shallowReadonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("SdEQh")).shallowRef; });
$parcel$export(module.exports, "stop", function () { return (parcelRequire("SdEQh")).stop; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("7s0Ms")).toDisplayString; });
$parcel$export(module.exports, "toHandlerKey", function () { return (parcelRequire("7s0Ms")).toHandlerKey; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("SdEQh")).toRaw; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("SdEQh")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("SdEQh")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("SdEQh")).toValue; });
$parcel$export(module.exports, "triggerRef", function () { return (parcelRequire("SdEQh")).triggerRef; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("SdEQh")).unref; });
/**
  * @vue/runtime-core v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $SdEQh = parcelRequire("SdEQh");

var $7s0Ms = parcelRequire("7s0Ms");
//#region packages/runtime-core/src/warning.ts
const $2587789e20bc75b6$var$stack = [];
/**
* @internal
*/ function $2587789e20bc75b6$export$eff0ee073d211f48(ctx) {
    $2587789e20bc75b6$var$stack.push(ctx);
}
/**
* @internal
*/ function $2587789e20bc75b6$export$1f21d88a9fb0fa16() {
    $2587789e20bc75b6$var$stack.pop();
}
let $2587789e20bc75b6$var$isWarning = false;
function $2587789e20bc75b6$var$warn$1(msg, ...args) {
    if ($2587789e20bc75b6$var$isWarning) return;
    $2587789e20bc75b6$var$isWarning = true;
    const prevSub = (0, $SdEQh.setActiveSub)();
    const entry = $2587789e20bc75b6$var$stack.length ? $2587789e20bc75b6$var$stack[$2587789e20bc75b6$var$stack.length - 1] : null;
    const instance = $2587789e20bc75b6$export$3868d13f8734ae81(entry) ? entry.component : entry;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $2587789e20bc75b6$var$getComponentTrace();
    if (appWarnHandler) $2587789e20bc75b6$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            const toString = a.toString;
            return toString == null ? JSON.stringify(a) : toString.call(a);
        }).join(""),
        instance && instance.proxy || instance,
        trace.map(({ ctx: ctx })=>`at <${$2587789e20bc75b6$var$formatComponentName(instance, ctx.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && true) /* v8 ignore next 2 */ warnArgs.push(`\n`, ...$2587789e20bc75b6$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $SdEQh.setActiveSub)(prevSub);
    $2587789e20bc75b6$var$isWarning = false;
}
function $2587789e20bc75b6$var$getComponentTrace() {
    let currentCtx = $2587789e20bc75b6$var$stack[$2587789e20bc75b6$var$stack.length - 1];
    if (!currentCtx) return [];
    const normalizedStack = [];
    while(currentCtx){
        const last = normalizedStack[0];
        if (last && last.ctx === currentCtx) last.recurseCount++;
        else normalizedStack.push({
            ctx: currentCtx,
            recurseCount: 0
        });
        if ($2587789e20bc75b6$export$3868d13f8734ae81(currentCtx)) {
            const parent = currentCtx.component && currentCtx.component.parent;
            currentCtx = parent && parent.vnode || parent;
        } else currentCtx = currentCtx.parent;
    }
    return normalizedStack;
}
/* v8 ignore start */ function $2587789e20bc75b6$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$2587789e20bc75b6$var$formatTraceEntry(entry));
    });
    return logs;
}
function $2587789e20bc75b6$var$formatTraceEntry({ ctx: ctx, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const instance = $2587789e20bc75b6$export$3868d13f8734ae81(ctx) ? ctx.component : ctx;
    const isRoot = instance ? instance.parent == null : false;
    const open = ` at <${$2587789e20bc75b6$var$formatComponentName(instance, ctx.type, isRoot)}`;
    const close = `>` + postfix;
    return ctx.props ? [
        open,
        ...$2587789e20bc75b6$var$formatProps(ctx.props),
        close
    ] : [
        open + close
    ];
}
function $2587789e20bc75b6$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$2587789e20bc75b6$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $2587789e20bc75b6$var$formatProp(key, value, raw) {
    if ((0, $7s0Ms.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $SdEQh.isRef)(value)) {
        value = $2587789e20bc75b6$var$formatProp(key, (0, $SdEQh.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $7s0Ms.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $SdEQh.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
/**
* @internal
*/ function $2587789e20bc75b6$export$dfbcecb440255e4a(val, type) {
    return;
}
/* v8 ignore stop */ //#endregion
//#region packages/runtime-core/src/errorHandling.ts
const $2587789e20bc75b6$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $2587789e20bc75b6$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $2587789e20bc75b6$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $2587789e20bc75b6$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $7s0Ms.isFunction)(fn)) {
        const res = $2587789e20bc75b6$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $7s0Ms.isPromise)(res)) res.catch((err)=>{
            $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $7s0Ms.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($2587789e20bc75b6$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $7s0Ms.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy || instance;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) {
                for(let i = 0; i < errorCapturedHooks.length; i++)if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            const prevSub = (0, $SdEQh.setActiveSub)();
            $2587789e20bc75b6$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $SdEQh.setActiveSub)(prevSub);
            return;
        }
    }
    $2587789e20bc75b6$var$logError(err, type, instance, throwInDev, throwUnhandledErrorInProduction);
}
function $2587789e20bc75b6$var$logError(err, type, instance, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
//#endregion
//#region packages/runtime-core/src/scheduler.ts
const $2587789e20bc75b6$export$fdec56fe4e195399 = {
    "QUEUED": 1,
    "1": "QUEUED",
    "ALLOW_RECURSE": 2,
    "2": "ALLOW_RECURSE",
    "DISPOSED": 4,
    "4": "DISPOSED",
    "REQUEUE_ON_SUSPENSE_DISCARD": 8,
    "8": "REQUEUE_ON_SUSPENSE_DISCARD"
};
const $2587789e20bc75b6$var$jobs = [];
let $2587789e20bc75b6$var$postJobs = [];
let $2587789e20bc75b6$var$activePostJobs = null;
let $2587789e20bc75b6$var$currentFlushPromise = null;
let $2587789e20bc75b6$var$jobsLength = 0;
let $2587789e20bc75b6$var$flushIndex = 0;
let $2587789e20bc75b6$var$postFlushIndex = 0;
const $2587789e20bc75b6$var$resolvedPromise = /*@__PURE__*/ Promise.resolve();
const $2587789e20bc75b6$var$RECURSION_LIMIT = 100;
function $2587789e20bc75b6$export$bdd553fddd433dcb(fn) {
    const p = $2587789e20bc75b6$var$currentFlushPromise || $2587789e20bc75b6$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $2587789e20bc75b6$var$findInsertionIndex(order, queue, start, end) {
    while(start < end){
        const middle = start + end >>> 1;
        if (queue[middle].order <= order) start = middle + 1;
        else end = middle;
    }
    return start;
}
/**
* @internal for runtime-vapor only
*/ function $2587789e20bc75b6$export$fba1a0a20887772f(job, id, isPre = false, order = 0) {
    if ($2587789e20bc75b6$var$queueJobWorker(job, id === void 0 ? isPre ? -2 : Infinity : isPre ? id * 2 : order ? id * 2 + 1 + order / (order + 1) : id * 2 + 1, $2587789e20bc75b6$var$jobs, $2587789e20bc75b6$var$jobsLength, $2587789e20bc75b6$var$flushIndex)) {
        $2587789e20bc75b6$var$jobsLength++;
        $2587789e20bc75b6$var$queueFlush();
    }
}
function $2587789e20bc75b6$var$queueJobWorker(job, order, queue, length, flushIndex) {
    const flags = job.flags;
    if (!(flags & 1)) {
        job.flags = flags | 1;
        job.order = order;
        if (flushIndex === length || order >= queue[length - 1].order) queue[length] = job;
        else queue.splice($2587789e20bc75b6$var$findInsertionIndex(order, queue, flushIndex, length), 0, job);
        return true;
    }
    return false;
}
const $2587789e20bc75b6$var$doFlushJobs = ()=>{
    try {
        $2587789e20bc75b6$var$flushJobs();
    } catch (e) {
        $2587789e20bc75b6$var$currentFlushPromise = null;
        if ($2587789e20bc75b6$var$jobsLength || $2587789e20bc75b6$var$postJobs.length) $2587789e20bc75b6$var$queueFlush();
        throw e;
    }
};
function $2587789e20bc75b6$var$queueFlush() {
    if (!$2587789e20bc75b6$var$currentFlushPromise) $2587789e20bc75b6$var$currentFlushPromise = $2587789e20bc75b6$var$resolvedPromise.then($2587789e20bc75b6$var$doFlushJobs);
}
function $2587789e20bc75b6$export$59536a0199721cab(jobs, id = Infinity) {
    if (!(0, $7s0Ms.isArray)(jobs)) {
        if ($2587789e20bc75b6$var$activePostJobs && id === -1) $2587789e20bc75b6$var$activePostJobs.splice($2587789e20bc75b6$var$postFlushIndex, 0, jobs);
        else $2587789e20bc75b6$var$queueJobWorker(jobs, id, $2587789e20bc75b6$var$postJobs, $2587789e20bc75b6$var$postJobs.length, 0);
    } else for(let i = 0; i < jobs.length; i++)$2587789e20bc75b6$var$queueJobWorker(jobs[i], id, $2587789e20bc75b6$var$postJobs, $2587789e20bc75b6$var$postJobs.length, 0);
    $2587789e20bc75b6$var$queueFlush();
}
function $2587789e20bc75b6$var$flushPreFlushCbs(instance, seen) {
    for(let i = $2587789e20bc75b6$var$flushIndex; i < $2587789e20bc75b6$var$jobsLength; i++){
        const cb = $2587789e20bc75b6$var$jobs[i];
        if (cb.order & 1 || cb.order === Infinity) continue;
        if (instance && cb.order !== instance.uid * 2) continue;
        $2587789e20bc75b6$var$jobs.splice(i, 1);
        i--;
        $2587789e20bc75b6$var$jobsLength--;
        if (cb.flags & 2) cb.flags &= -2;
        try {
            cb();
        } finally{
            if (!(cb.flags & 2)) cb.flags &= -2;
        }
    }
}
function $2587789e20bc75b6$var$flushPostFlushCbs(seen) {
    if ($2587789e20bc75b6$var$postJobs.length) {
        if ($2587789e20bc75b6$var$activePostJobs) {
            for(let i = 0; i < $2587789e20bc75b6$var$postJobs.length; i++)$2587789e20bc75b6$var$activePostJobs.push($2587789e20bc75b6$var$postJobs[i]);
            $2587789e20bc75b6$var$postJobs.length = 0;
            return;
        }
        $2587789e20bc75b6$var$activePostJobs = $2587789e20bc75b6$var$postJobs;
        $2587789e20bc75b6$var$postJobs = [];
        try {
            while($2587789e20bc75b6$var$postFlushIndex < $2587789e20bc75b6$var$activePostJobs.length){
                const cb = $2587789e20bc75b6$var$activePostJobs[$2587789e20bc75b6$var$postFlushIndex++];
                if (cb.flags & 2) cb.flags &= -2;
                if (!(cb.flags & 4)) try {
                    cb();
                } finally{
                    if (!(cb.flags & 2)) cb.flags &= -2;
                }
            }
        } finally{
            while($2587789e20bc75b6$var$postFlushIndex < $2587789e20bc75b6$var$activePostJobs.length)$2587789e20bc75b6$var$activePostJobs[$2587789e20bc75b6$var$postFlushIndex++].flags &= -2;
            $2587789e20bc75b6$var$activePostJobs = null;
            $2587789e20bc75b6$var$postFlushIndex = 0;
        }
    }
}
let $2587789e20bc75b6$var$isFlushing = false;
/**
* @internal
*/ function $2587789e20bc75b6$export$3ee27bfcb8f44b9d(instance) {
    if (!$2587789e20bc75b6$var$isFlushing) {
        $2587789e20bc75b6$var$isFlushing = true;
        try {
            $2587789e20bc75b6$var$flushPreFlushCbs(instance);
            $2587789e20bc75b6$var$flushPostFlushCbs();
        } finally{
            $2587789e20bc75b6$var$isFlushing = false;
        }
    }
}
function $2587789e20bc75b6$var$flushJobs(seen) {
    try {
        while($2587789e20bc75b6$var$flushIndex < $2587789e20bc75b6$var$jobsLength){
            const job = $2587789e20bc75b6$var$jobs[$2587789e20bc75b6$var$flushIndex];
            $2587789e20bc75b6$var$jobs[$2587789e20bc75b6$var$flushIndex++] = void 0;
            if (!(job.flags & 4)) {
                if (job.flags & 2) job.flags &= -2;
                try {
                    job();
                } catch (err) {
                    $2587789e20bc75b6$export$d3da1ecaf1206c58(err, job.i, job.i ? 15 : 14);
                } finally{
                    if (!(job.flags & 2)) job.flags &= -2;
                }
            }
        }
    } finally{
        while($2587789e20bc75b6$var$flushIndex < $2587789e20bc75b6$var$jobsLength){
            $2587789e20bc75b6$var$jobs[$2587789e20bc75b6$var$flushIndex].flags &= -2;
            $2587789e20bc75b6$var$jobs[$2587789e20bc75b6$var$flushIndex++] = void 0;
        }
        $2587789e20bc75b6$var$flushIndex = 0;
        $2587789e20bc75b6$var$jobsLength = 0;
        $2587789e20bc75b6$var$jobs.length = 0;
        $2587789e20bc75b6$var$flushPostFlushCbs(seen);
        if ($2587789e20bc75b6$var$jobsLength || $2587789e20bc75b6$var$postJobs.length) $2587789e20bc75b6$var$flushJobs(seen);
        else $2587789e20bc75b6$var$currentFlushPromise = null;
    }
}
function $2587789e20bc75b6$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $2587789e20bc75b6$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $2587789e20bc75b6$export$26727cfcc4d7e0fc(instance.type);
        $2587789e20bc75b6$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
//#endregion
//#region packages/runtime-core/src/hmr.ts
let $2587789e20bc75b6$var$isHmrUpdating = false;
const $2587789e20bc75b6$var$setHmrUpdating = (v1)=>{
    try {
        return $2587789e20bc75b6$var$isHmrUpdating;
    } finally{
        $2587789e20bc75b6$var$isHmrUpdating = v1;
    }
};
const $2587789e20bc75b6$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $2587789e20bc75b6$var$hmrDirtyComponentsMode = /* @__PURE__ */ new Map();
function $2587789e20bc75b6$var$runWithHmrUpdating(fn) {
    $2587789e20bc75b6$var$isHmrUpdating = true;
    let done = false;
    try {
        fn();
        done = true;
    } finally{
        if (done) $2587789e20bc75b6$export$bdd553fddd433dcb(()=>{
            $2587789e20bc75b6$var$isHmrUpdating = false;
        });
        else $2587789e20bc75b6$var$isHmrUpdating = false;
    }
}
const $2587789e20bc75b6$var$map = /* @__PURE__ */ new Map();
function $2587789e20bc75b6$export$2aad669127ef41b0(instance) {
    const id = instance.type.__hmrId;
    let record = $2587789e20bc75b6$var$map.get(id);
    if (!record) {
        $2587789e20bc75b6$var$createRecord(id, instance.type);
        record = $2587789e20bc75b6$var$map.get(id);
    }
    record.instances.add(instance);
}
function $2587789e20bc75b6$export$5f6a3eaf04e860b3(instance) {
    $2587789e20bc75b6$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $2587789e20bc75b6$var$createRecord(id, initialDef) {
    if ($2587789e20bc75b6$var$map.has(id)) return false;
    $2587789e20bc75b6$var$map.set(id, {
        initialDef: $2587789e20bc75b6$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $2587789e20bc75b6$var$normalizeClassComponent(component) {
    return $2587789e20bc75b6$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $2587789e20bc75b6$var$hasDirtyAncestor(instance, dirtyInstances) {
    let parent = instance.parent;
    while(parent){
        if (dirtyInstances.has(parent)) return true;
        parent = parent.parent;
    }
    return false;
}
function $2587789e20bc75b6$var$rerender(id, newRender) {
    const record = $2587789e20bc75b6$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $2587789e20bc75b6$var$normalizeClassComponent(instance.type).render = newRender;
        }
        $2587789e20bc75b6$var$runWithHmrUpdating(()=>{
            if (instance.vapor) {
                if (!instance.isUnmounted) instance.hmrRerender();
            } else {
                const i = instance;
                if (!(i.effect.flags & 1024)) {
                    i.renderCache = [];
                    i.effect.run();
                }
            }
        });
    });
}
function $2587789e20bc75b6$var$reload(id, newComp) {
    const record = $2587789e20bc75b6$var$map.get(id);
    if (!record) return;
    newComp = $2587789e20bc75b6$var$normalizeClassComponent(newComp);
    const isVapor = record.initialDef.__vapor;
    $2587789e20bc75b6$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    if (isVapor && newComp.__vapor && !instances.some((instance)=>instance.parent && !instance.parent.vapor) && !instances.some((i)=>i.ceReload)) {
        for (const instance of instances)if (instance.root && instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(instance.type);
        const dirtyInstances = new Set(instances);
        const rerenderedParents = /* @__PURE__ */ new Set();
        $2587789e20bc75b6$var$runWithHmrUpdating(()=>{
            for (const instance of instances){
                const parent = instance.parent;
                if (parent) {
                    if (!$2587789e20bc75b6$var$hasDirtyAncestor(instance, dirtyInstances) && !rerenderedParents.has(parent)) {
                        rerenderedParents.add(parent);
                        parent.hmrRerender();
                    }
                } else instance.hmrReload(newComp);
            }
        });
    } else {
        const parentUpdates = /* @__PURE__ */ new Map();
        const dirtyInstanceSet = new Set(instances);
        for (const instance of instances){
            const oldComp = $2587789e20bc75b6$var$normalizeClassComponent(instance.type);
            let dirtyInstances = $2587789e20bc75b6$var$hmrDirtyComponents.get(oldComp);
            if (!dirtyInstances) {
                if (oldComp !== record.initialDef) $2587789e20bc75b6$var$updateComponentDef(oldComp, newComp);
                $2587789e20bc75b6$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
            }
            dirtyInstances.add(instance);
            $2587789e20bc75b6$var$hmrDirtyComponentsMode.set(oldComp, !!isVapor);
            instance.appContext.propsCache.delete(instance.type);
            instance.appContext.emitsCache.delete(instance.type);
            instance.appContext.optionsCache.delete(instance.type);
            if (instance.ceReload) {
                dirtyInstances.add(instance);
                instance.ceReload(newComp.styles);
                dirtyInstances.delete(instance);
            } else if (instance.parent) {
                const parent = instance.parent;
                if (!$2587789e20bc75b6$var$hasDirtyAncestor(instance, dirtyInstanceSet)) {
                    let updates = parentUpdates.get(parent);
                    if (!updates) parentUpdates.set(parent, updates = []);
                    updates.push([
                        instance,
                        dirtyInstances
                    ]);
                }
            } else if (instance.appContext.reload) instance.appContext.reload();
            else if (typeof window !== "undefined") window.location.reload();
            else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
            if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
        }
        parentUpdates.forEach((updates, parent)=>{
            $2587789e20bc75b6$export$fba1a0a20887772f(()=>{
                try {
                    $2587789e20bc75b6$var$runWithHmrUpdating(()=>{
                        if (parent.vapor) parent.hmrRerender();
                        else {
                            const i = parent;
                            if (!(i.effect.flags & 1024)) {
                                i.renderCache = [];
                                i.effect.run();
                            }
                        }
                    });
                } finally{
                    updates.forEach(([instance, dirtyInstances])=>{
                        dirtyInstances.delete(instance);
                    });
                }
            });
        });
    }
    $2587789e20bc75b6$export$59536a0199721cab(()=>{
        $2587789e20bc75b6$var$hmrDirtyComponents.clear();
        $2587789e20bc75b6$var$hmrDirtyComponentsMode.clear();
    });
}
function $2587789e20bc75b6$var$updateComponentDef(oldComp, newComp) {
    (0, $7s0Ms.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $2587789e20bc75b6$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
//#endregion
//#region packages/runtime-core/src/devtools.ts
let $2587789e20bc75b6$var$devtools$1;
let $2587789e20bc75b6$var$buffer = [];
let $2587789e20bc75b6$var$devtoolsNotInstalled = false;
function $2587789e20bc75b6$var$emit$1(event, ...args) {
    if ($2587789e20bc75b6$var$devtools$1) $2587789e20bc75b6$var$devtools$1.emit(event, ...args);
    else if (!$2587789e20bc75b6$var$devtoolsNotInstalled) $2587789e20bc75b6$var$buffer.push({
        event: event,
        args: args
    });
}
function $2587789e20bc75b6$var$setDevtoolsHook$1(hook, target) {
    var _window$navigator;
    $2587789e20bc75b6$var$devtools$1 = hook;
    if ($2587789e20bc75b6$var$devtools$1) {
        $2587789e20bc75b6$var$devtools$1.enabled = true;
        $2587789e20bc75b6$var$buffer.forEach(({ event: event, args: args })=>$2587789e20bc75b6$var$devtools$1.emit(event, ...args));
        $2587789e20bc75b6$var$buffer = [];
    } else if (typeof window !== "undefined" && window.HTMLElement && !((_window$navigator = window.navigator) === null || _window$navigator === void 0 || (_window$navigator = _window$navigator.userAgent) === null || _window$navigator === void 0 ? void 0 : _window$navigator.includes("jsdom"))) {
        (target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((newHook)=>{
            $2587789e20bc75b6$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$2587789e20bc75b6$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $2587789e20bc75b6$var$devtoolsNotInstalled = true;
                $2587789e20bc75b6$var$buffer = [];
            }
        }, 3e3);
    } else {
        $2587789e20bc75b6$var$devtoolsNotInstalled = true;
        $2587789e20bc75b6$var$buffer = [];
    }
}
function $2587789e20bc75b6$var$devtoolsInitApp(app, version) {
    $2587789e20bc75b6$var$emit$1("app:init", app, version, {
        Fragment: $2587789e20bc75b6$export$ffb0004e005737fa,
        Text: $2587789e20bc75b6$export$5f1af8db9871e1d6,
        Comment: $2587789e20bc75b6$export$4d299b491347818a,
        Static: $2587789e20bc75b6$export$c1b9a1d3af45b7b6
    });
}
function $2587789e20bc75b6$var$devtoolsUnmountApp(app) {
    $2587789e20bc75b6$var$emit$1("app:unmount", app);
}
const $2587789e20bc75b6$export$a76a9a73068a1a5e = /*@__PURE__*/ $2587789e20bc75b6$var$createDevtoolsComponentHook("component:added");
const $2587789e20bc75b6$var$devtoolsComponentUpdated = /*@__PURE__*/ $2587789e20bc75b6$var$createDevtoolsComponentHook("component:updated");
const $2587789e20bc75b6$var$_devtoolsComponentRemoved = /*@__PURE__*/ $2587789e20bc75b6$var$createDevtoolsComponentHook("component:removed");
const $2587789e20bc75b6$var$devtoolsComponentRemoved = (component)=>{
    if ($2587789e20bc75b6$var$devtools$1 && typeof $2587789e20bc75b6$var$devtools$1.cleanupBuffer === "function" && !$2587789e20bc75b6$var$devtools$1.cleanupBuffer(component)) $2587789e20bc75b6$var$_devtoolsComponentRemoved(component);
};
/*@__NO_SIDE_EFFECTS__*/ function $2587789e20bc75b6$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $2587789e20bc75b6$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $2587789e20bc75b6$var$devtoolsPerfStart = /*@__PURE__*/ $2587789e20bc75b6$var$createDevtoolsPerformanceHook("perf:start");
const $2587789e20bc75b6$var$devtoolsPerfEnd = /*@__PURE__*/ $2587789e20bc75b6$var$createDevtoolsPerformanceHook("perf:end");
function $2587789e20bc75b6$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $2587789e20bc75b6$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $2587789e20bc75b6$var$devtoolsComponentEmit(component, event, params) {
    $2587789e20bc75b6$var$emit$1("component:emit", component.appContext.app, component, event, params);
}
//#endregion
//#region packages/runtime-core/src/componentRenderContext.ts
/**
* mark the current rendering instance for asset resolution (e.g.
* resolveComponent, resolveDirective) during render
*/ let $2587789e20bc75b6$var$currentRenderingInstance = null;
let $2587789e20bc75b6$var$currentScopeId = null;
/**
* Note: rendering calls maybe nested. The function returns the parent rendering
* instance if present, which should be restored after the render is done:
*
* ```js
* const prev = setCurrentRenderingInstance(i)
* // ...render
* setCurrentRenderingInstance(prev)
* ```
*/ function $2587789e20bc75b6$export$824c074beef4c41b(instance) {
    const prev = $2587789e20bc75b6$var$currentRenderingInstance;
    $2587789e20bc75b6$var$currentRenderingInstance = instance;
    $2587789e20bc75b6$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
* Set scope id when creating hoisted vnodes.
* @private compiler helper
*/ function $2587789e20bc75b6$export$ac020265ca2cc4cd(id) {
    $2587789e20bc75b6$var$currentScopeId = id;
}
/**
* Technically we no longer need this after 3.0.8 but we need to keep the same
* API for backwards compat w/ code generated by compilers.
* @private
*/ function $2587789e20bc75b6$export$f2dc6805dc11834e() {
    $2587789e20bc75b6$var$currentScopeId = null;
}
/**
* Only for backwards compat
* @private
*/ const $2587789e20bc75b6$export$15ba313e13f3dd04 = (_id)=>$2587789e20bc75b6$export$694b237e827a3d23;
/**
* Wrap a slot function to memoize current rendering instance
* @private compiler helper
*/ function $2587789e20bc75b6$export$694b237e827a3d23(fn, ctx = $2587789e20bc75b6$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $2587789e20bc75b6$export$c20bee82f26f1e27(-1);
        const prevInstance = $2587789e20bc75b6$export$824c074beef4c41b(ctx);
        const prevStackSize = $2587789e20bc75b6$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $2587789e20bc75b6$var$blockStack.length; i > prevStackSize; i--)$2587789e20bc75b6$var$closeBlock();
            $2587789e20bc75b6$export$824c074beef4c41b(prevInstance);
            if (renderFnWithContext._d) $2587789e20bc75b6$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
//#endregion
//#region packages/runtime-core/src/directives.ts
function $2587789e20bc75b6$var$validateDirectiveName(name) {
    if ((0, $7s0Ms.isBuiltInDirective)(name)) $2587789e20bc75b6$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
/**
* Adds directives to a VNode.
*/ function $2587789e20bc75b6$export$49729353e7c1e6c5(vnode, directives) {
    if ($2587789e20bc75b6$var$currentRenderingInstance === null) return vnode;
    const instance = $2587789e20bc75b6$var$getComponentPublicInstance($2587789e20bc75b6$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $7s0Ms.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $7s0Ms.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $SdEQh.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $2587789e20bc75b6$export$91e53aad4f01262(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            const prevSub = (0, $SdEQh.setActiveSub)();
            $2587789e20bc75b6$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $SdEQh.setActiveSub)(prevSub);
        }
    }
}
//#endregion
//#region packages/runtime-core/src/apiInject.ts
function $2587789e20bc75b6$export$abe1e183e22e10ad(key, value) {
    if ($2587789e20bc75b6$export$5d0c78f02672825) {
        let provides = $2587789e20bc75b6$export$5d0c78f02672825.provides;
        const parentProvides = $2587789e20bc75b6$export$5d0c78f02672825.parent && $2587789e20bc75b6$export$5d0c78f02672825.parent.provides;
        if (parentProvides === provides) provides = $2587789e20bc75b6$export$5d0c78f02672825.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $2587789e20bc75b6$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $2587789e20bc75b6$var$getCurrentGenericInstance();
    if (instance || $2587789e20bc75b6$var$currentApp) {
        let provides = $2587789e20bc75b6$var$currentApp ? $2587789e20bc75b6$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.appContext && instance.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $7s0Ms.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
/**
* Returns true if `inject()` can be used without warning about being called in the wrong place (e.g. outside of
* setup()). This is used by libraries that want to use `inject()` internally without triggering a warning to the end
* user. One example is `useRoute()` in `vue-router`.
*/ function $2587789e20bc75b6$export$caf6761f24fc571a() {
    return !!($2587789e20bc75b6$var$getCurrentGenericInstance() || $2587789e20bc75b6$var$currentApp);
}
//#endregion
//#region packages/runtime-core/src/helpers/useSsrContext.ts
const $2587789e20bc75b6$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $2587789e20bc75b6$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $2587789e20bc75b6$export$a976684a0efeb93f($2587789e20bc75b6$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
//#endregion
//#region packages/runtime-core/src/apiWatch.ts
function $2587789e20bc75b6$export$ede35fc0e5500309(effect, options) {
    return $2587789e20bc75b6$var$doWatch(effect, null, options);
}
function $2587789e20bc75b6$export$b7f27ea67102d543(effect, options) {
    return $2587789e20bc75b6$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $2587789e20bc75b6$export$2035654f31b0e555(effect, options) {
    return $2587789e20bc75b6$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $2587789e20bc75b6$export$3db5d71bdb2d5499(source, cb, options) {
    return $2587789e20bc75b6$var$doWatch(source, cb, options);
}
var $2587789e20bc75b6$var$RenderWatcherEffect = class extends (0, $SdEQh.WatcherEffect) {
    constructor(instance, source, cb, options, flush){
        super(source, cb, options);
        this.flush = flush;
        const job = ()=>{
            if (this.dirty) this.run();
        };
        if (cb) {
            this.flags |= 128;
            job.flags |= 2;
        }
        if (instance) job.i = instance;
        this.job = job;
    }
    notify() {
        if (!(this.flags & 256)) {
            const flush = this.flush;
            const job = this.job;
            if (flush === "post") $2587789e20bc75b6$export$51ec8e020844a97a(job, void 0, job.i ? job.i.suspense : null);
            else if (flush === "pre") $2587789e20bc75b6$export$fba1a0a20887772f(job, job.i ? job.i.uid : void 0, true);
            else job();
        }
    }
};
function $2587789e20bc75b6$var$doWatch(source, cb, options = (0, $7s0Ms.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush = "pre", once: once } = options;
    const baseWatchOptions = (0, $7s0Ms.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($2587789e20bc75b6$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $2587789e20bc75b6$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $7s0Ms.NOOP);
            watchStopHandle.resume = (0, $7s0Ms.NOOP);
            watchStopHandle.pause = (0, $7s0Ms.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $2587789e20bc75b6$export$5d0c78f02672825;
    baseWatchOptions.call = (fn, type, args)=>$2587789e20bc75b6$export$dae85862a8d94378(fn, instance, type, args);
    const effect = new $2587789e20bc75b6$var$RenderWatcherEffect(instance, source, cb, baseWatchOptions, flush);
    if (cb) effect.run(true);
    else if (flush === "post") $2587789e20bc75b6$export$51ec8e020844a97a(effect.job, void 0, instance && instance.suspense);
    else effect.run(true);
    const stop = effect.stop.bind(effect);
    stop.pause = effect.pause.bind(effect);
    stop.resume = effect.resume.bind(effect);
    stop.stop = stop;
    if ($2587789e20bc75b6$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(stop);
        else if (runsImmediately) stop();
    }
    return stop;
}
function $2587789e20bc75b6$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $7s0Ms.isString)(source) ? source.includes(".") ? $2587789e20bc75b6$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $7s0Ms.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const prev = $2587789e20bc75b6$export$a5e695a16aa0b6d4(this);
    const res = $2587789e20bc75b6$var$doWatch(getter, cb.bind(publicThis), options);
    $2587789e20bc75b6$export$95e96a1fb881e3e7(prev);
    return res;
}
function $2587789e20bc75b6$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
//#endregion
//#region packages/runtime-core/src/components/Teleport.ts
const $2587789e20bc75b6$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $2587789e20bc75b6$var$TeleportEndKey = Symbol("_vte");
const $2587789e20bc75b6$var$isTeleport = (type)=>type.__isTeleport;
const $2587789e20bc75b6$export$44727b5035358778 = (props)=>props && (props.disabled || props.disabled === "");
const $2587789e20bc75b6$export$6f4d6f0c8744b47f = (props)=>props && (props.defer || props.defer === "");
const $2587789e20bc75b6$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $2587789e20bc75b6$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $2587789e20bc75b6$export$792b35e9a6a3f24c = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $7s0Ms.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $2587789e20bc75b6$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $2587789e20bc75b6$export$44727b5035358778(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container, anchor)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled = $2587789e20bc75b6$export$44727b5035358778(vnode.props);
            const target = vnode.target = $2587789e20bc75b6$export$792b35e9a6a3f24c(vnode.props, querySelector);
            const targetAnchor = $2587789e20bc75b6$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $2587789e20bc75b6$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $2587789e20bc75b6$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled) {
                    mount(vnode, target, targetAnchor);
                    $2587789e20bc75b6$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($2587789e20bc75b6$var$pendingMounts.get(vnode) !== mountJob) return;
                $2587789e20bc75b6$var$pendingMounts.delete(vnode);
                if ($2587789e20bc75b6$export$44727b5035358778(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $2587789e20bc75b6$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $2587789e20bc75b6$var$pendingMounts.set(vnode, mountJob);
            $2587789e20bc75b6$export$51ec8e020844a97a(mountJob, void 0, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($2587789e20bc75b6$export$6f4d6f0c8744b47f(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $2587789e20bc75b6$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $2587789e20bc75b6$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 4;
                $2587789e20bc75b6$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $2587789e20bc75b6$export$44727b5035358778(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $2587789e20bc75b6$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $2587789e20bc75b6$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $2587789e20bc75b6$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $2587789e20bc75b6$var$moveTeleport(n2, container, mainAnchor, internals, parentComponent, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                const nextTarget = $2587789e20bc75b6$export$792b35e9a6a3f24c(n2.props, querySelector);
                if (nextTarget) {
                    n2.target = nextTarget;
                    $2587789e20bc75b6$var$moveTeleport(n2, nextTarget, null, internals, parentComponent, 0);
                }
            } else if (wasDisabled) $2587789e20bc75b6$var$moveTeleport(n2, target, targetAnchor, internals, parentComponent, 1);
            $2587789e20bc75b6$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $2587789e20bc75b6$export$44727b5035358778(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $2587789e20bc75b6$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 4;
            $2587789e20bc75b6$var$pendingMounts.delete(vnode);
        }
        if (targetStart) hostRemove(targetStart);
        if (targetAnchor) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $2587789e20bc75b6$var$moveTeleport,
    hydrate: $2587789e20bc75b6$var$hydrateTeleport
};
function $2587789e20bc75b6$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, parentComponent, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$2587789e20bc75b6$var$pendingMounts.has(vnode) && (!isReorder || $2587789e20bc75b6$export$44727b5035358778(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2, parentComponent);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $2587789e20bc75b6$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node, vnode) {
        vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $2587789e20bc75b6$export$792b35e9a6a3f24c(vnode.props, querySelector);
    const disabled = $2587789e20bc75b6$export$44727b5035358778(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $2587789e20bc75b6$var$prepareAnchor(target, vnode, createText, insert, parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $2587789e20bc75b6$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $2587789e20bc75b6$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $2587789e20bc75b6$export$76d55a0304a371f4 = $2587789e20bc75b6$var$TeleportImpl;
function $2587789e20bc75b6$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $2587789e20bc75b6$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$2587789e20bc75b6$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
//#endregion
//#region packages/runtime-core/src/components/BaseTransition.ts
const $2587789e20bc75b6$export$6402c150d41fe6bc = Symbol("_leaveCb");
const $2587789e20bc75b6$var$enterCbKey = Symbol("_enterCb");
function $2587789e20bc75b6$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingNodes: /* @__PURE__ */ new Map()
    };
    $2587789e20bc75b6$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $2587789e20bc75b6$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $2587789e20bc75b6$var$TransitionHookValidator = [
    Function,
    Array
];
const $2587789e20bc75b6$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: $2587789e20bc75b6$var$TransitionHookValidator,
    onEnter: $2587789e20bc75b6$var$TransitionHookValidator,
    onAfterEnter: $2587789e20bc75b6$var$TransitionHookValidator,
    onEnterCancelled: $2587789e20bc75b6$var$TransitionHookValidator,
    onBeforeLeave: $2587789e20bc75b6$var$TransitionHookValidator,
    onLeave: $2587789e20bc75b6$var$TransitionHookValidator,
    onAfterLeave: $2587789e20bc75b6$var$TransitionHookValidator,
    onLeaveCancelled: $2587789e20bc75b6$var$TransitionHookValidator,
    onBeforeAppear: $2587789e20bc75b6$var$TransitionHookValidator,
    onAppear: $2587789e20bc75b6$var$TransitionHookValidator,
    onAfterAppear: $2587789e20bc75b6$var$TransitionHookValidator,
    onAppearCancelled: $2587789e20bc75b6$var$TransitionHookValidator
};
const $2587789e20bc75b6$var$recursiveGetSubtree = (instance)=>{
    const subTree = $2587789e20bc75b6$var$isVaporComponent(instance.type) ? instance.block : instance.subTree;
    return subTree.component ? $2587789e20bc75b6$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $2587789e20bc75b6$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $2587789e20bc75b6$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $2587789e20bc75b6$export$f13e630aa3915748();
        const state = $2587789e20bc75b6$export$d2a0a1bc267c90f6();
        let resumeAfterLeave;
        return ()=>{
            const child = $2587789e20bc75b6$export$bacc260570b6d3ae(slots.default && slots.default(), !!instance.subTree);
            if (!child) return;
            const rawProps = (0, $SdEQh.toRaw)(props);
            const { mode: mode } = rawProps;
            $2587789e20bc75b6$export$f7697b49c3204928(mode);
            return $2587789e20bc75b6$export$aee04c50c0dfaf12(instance.subTree, child, rawProps, state, instance, mode === "out-in" ? resumeAfterLeave || (resumeAfterLeave = ()=>{
                if (!(instance.job.flags & 4)) instance.update();
            }) : (0, $7s0Ms.NOOP));
        };
    }
};
function $2587789e20bc75b6$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $2587789e20bc75b6$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $2587789e20bc75b6$export$abd95b5f5e8a8837 = $2587789e20bc75b6$var$BaseTransitionImpl;
function $2587789e20bc75b6$var$getLeavingNodesForType(state, vnode) {
    const { leavingNodes: leavingNodes } = state;
    let leavingVNodesCache = leavingNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $2587789e20bc75b6$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const key = String(vnode.key);
    const leavingVNodesCache = $2587789e20bc75b6$var$getLeavingNodesForType(state, vnode);
    return $2587789e20bc75b6$export$52bce14e5b84ba5b({
        isLeaving: ()=>leavingVNodesCache[key] === vnode,
        setLeavingNodeCache: ()=>{
            leavingVNodesCache[key] = vnode;
        },
        unsetLeavingNodeCache: ()=>{
            if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
        },
        earlyRemove: ()=>{
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $2587789e20bc75b6$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$2587789e20bc75b6$export$6402c150d41fe6bc]) leavingVNode.el[$2587789e20bc75b6$export$6402c150d41fe6bc]();
        },
        cloneHooks: (vnode)=>{
            const hooks = $2587789e20bc75b6$export$76ac1779589cd824(vnode, props, state, instance, postClone);
            if (postClone) postClone(hooks);
            return hooks;
        }
    }, props, state, instance);
}
function $2587789e20bc75b6$export$52bce14e5b84ba5b(context, props, state, instance) {
    const { isLeaving: isLeaving, setLeavingNodeCache: setLeavingNodeCache, unsetLeavingNodeCache: unsetLeavingNodeCache, earlyRemove: earlyRemove, cloneHooks: cloneHooks } = context;
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const callHook = (hook, args)=>{
        hook && $2587789e20bc75b6$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $7s0Ms.isArray)(hook)) {
            if (hook.every((hook)=>hook.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$2587789e20bc75b6$export$6402c150d41fe6bc]) el[$2587789e20bc75b6$export$6402c150d41fe6bc](true);
            earlyRemove();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$2587789e20bc75b6$var$isHmrUpdating && isLeaving()) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$2587789e20bc75b6$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$2587789e20bc75b6$var$enterCbKey] = void 0;
            };
            const done = el[$2587789e20bc75b6$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            if (el[$2587789e20bc75b6$var$enterCbKey]) el[$2587789e20bc75b6$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$2587789e20bc75b6$export$6402c150d41fe6bc] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$2587789e20bc75b6$export$6402c150d41fe6bc] = void 0;
                unsetLeavingNodeCache(el);
            };
            setLeavingNodeCache(el);
            const done = el[$2587789e20bc75b6$export$6402c150d41fe6bc].bind(null, false);
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (node) {
            return cloneHooks ? cloneHooks(node) : hooks;
        }
    };
    return hooks;
}
function $2587789e20bc75b6$var$emptyPlaceholder(vnode) {
    if ($2587789e20bc75b6$export$a33216a979d8327a(vnode)) {
        vnode = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $2587789e20bc75b6$var$getInnerChild$1(vnode) {
    if (!$2587789e20bc75b6$export$a33216a979d8327a(vnode)) {
        if ($2587789e20bc75b6$var$isTeleport(vnode.type) && vnode.children) return $2587789e20bc75b6$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $7s0Ms.isFunction)(children.default)) return children.default();
    }
}
function $2587789e20bc75b6$export$bacc260570b6d3ae(children, renderEmpty = false) {
    const branches = children && $2587789e20bc75b6$export$a67f9b1229c7c97a(children, true);
    return branches && branches.length ? $2587789e20bc75b6$var$findNonCommentChild(branches) : renderEmpty ? $2587789e20bc75b6$export$49553837c7236d3c() : void 0;
}
/**
* @internal
*/ function $2587789e20bc75b6$export$aee04c50c0dfaf12(previous, next, props, state, instance, resumeAfterLeave, delayedLeaveSource) {
    if (state.isLeaving) return $2587789e20bc75b6$var$emptyPlaceholder(next);
    const nextInner = $2587789e20bc75b6$var$getInnerChild$1(next);
    if (!nextInner) return $2587789e20bc75b6$var$emptyPlaceholder(next);
    let enterHooks = $2587789e20bc75b6$export$76ac1779589cd824(nextInner, props, state, instance, (hooks)=>{
        if (delayedLeaveSource) $2587789e20bc75b6$var$forwardDelayedLeave(hooks, delayedLeaveSource);
        enterHooks = hooks;
    });
    if (delayedLeaveSource) $2587789e20bc75b6$var$forwardDelayedLeave(enterHooks, delayedLeaveSource);
    if (nextInner.type !== $2587789e20bc75b6$export$4d299b491347818a) $2587789e20bc75b6$export$7770a22486565649(nextInner, enterHooks);
    const mode = props.mode;
    const previousInner = previous && $2587789e20bc75b6$var$getInnerChild$1(previous);
    if (previous && previousInner && previousInner.type !== $2587789e20bc75b6$export$4d299b491347818a && !$2587789e20bc75b6$var$isSameVNodeType(previousInner, nextInner) && (!previous.component || $2587789e20bc75b6$var$recursiveGetSubtree(previous.component).type !== $2587789e20bc75b6$export$4d299b491347818a)) {
        const leavingHooks = $2587789e20bc75b6$var$prepareLeavingTransitionHooks(previousInner, props, state, instance);
        if (nextInner.type !== $2587789e20bc75b6$export$4d299b491347818a && (mode === "out-in" || mode === "in-out") && $2587789e20bc75b6$var$applyTransitionModeSwitch(previousInner, leavingHooks, mode === "in-out" ? ()=>enterHooks : void 0, props, state, resumeAfterLeave)) return $2587789e20bc75b6$var$emptyPlaceholder(next);
    }
    return next;
}
function $2587789e20bc75b6$var$forwardDelayedLeave(hooks, source) {
    const delayedLeave = source && source.delayedLeave;
    if (!delayedLeave) return;
    hooks.delayedLeave = ()=>{
        if (source.delayedLeave === delayedLeave) delayedLeave();
        delete hooks.delayedLeave;
    };
}
/**
* Prepares an outgoing VNode when the incoming branch belongs to another
* renderer. Returns true when out-in must defer the incoming branch.
*
* @internal
*/ function $2587789e20bc75b6$export$750adf600c62558a(previous, enterHooks, props, state, instance, resumeAfterLeave) {
    const previousInner = $2587789e20bc75b6$var$getInnerChild$1(previous);
    if (!previousInner || previousInner.type === $2587789e20bc75b6$export$4d299b491347818a || previous.component && $2587789e20bc75b6$var$recursiveGetSubtree(previous.component).type === $2587789e20bc75b6$export$4d299b491347818a) return false;
    return $2587789e20bc75b6$var$applyTransitionModeSwitch(previousInner, $2587789e20bc75b6$var$prepareLeavingTransitionHooks(previousInner, props, state, instance), enterHooks ? ()=>enterHooks : void 0, props, state, resumeAfterLeave);
}
function $2587789e20bc75b6$var$prepareLeavingTransitionHooks(previousInner, props, state, instance) {
    return $2587789e20bc75b6$export$7770a22486565649(previousInner, $2587789e20bc75b6$export$76ac1779589cd824(previousInner, props, state, instance));
}
function $2587789e20bc75b6$var$applyTransitionModeSwitch(leavingVNode, leavingHooks, getEnterHooks, props, state, resumeAfterLeave) {
    if (props.mode === "out-in") {
        state.isLeaving = true;
        leavingHooks.afterLeave = ()=>{
            state.isLeaving = false;
            resumeAfterLeave();
            delete leavingHooks.afterLeave;
        };
        return true;
    } else if (props.mode === "in-out" && getEnterHooks) {
        let delayedLeavingVNode = leavingVNode;
        leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
            const enterHooks = getEnterHooks();
            if (!enterHooks) {
                delayedLeave();
                return;
            }
            const vnode = delayedLeavingVNode;
            const leavingVNodesCache = $2587789e20bc75b6$var$getLeavingNodesForType(state, vnode);
            leavingVNodesCache[String(vnode.key)] = vnode;
            el[$2587789e20bc75b6$export$6402c150d41fe6bc] = ()=>{
                earlyRemove();
                el[$2587789e20bc75b6$export$6402c150d41fe6bc] = void 0;
                delete enterHooks.delayedLeave;
                delayedLeavingVNode = void 0;
            };
            enterHooks.delayedLeave = ()=>{
                delayedLeave();
                delete enterHooks.delayedLeave;
                delayedLeavingVNode = void 0;
            };
        };
    }
    return false;
}
function $2587789e20bc75b6$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        if ($2587789e20bc75b6$var$isVaporComponent(vnode.type)) $2587789e20bc75b6$var$getVaporInterface(vnode.component, vnode).setTransitionHooks(vnode.component, hooks);
        else {
            const subTree = vnode.component.subTree;
            return $2587789e20bc75b6$export$7770a22486565649($2587789e20bc75b6$var$isTeleport(subTree.type) ? $2587789e20bc75b6$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
        }
    } else if (vnode.shapeFlag & 128) {
        const contentHooks = vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        const fallbackHooks = vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
        return vnode.suspense && vnode.suspense.activeBranch === vnode.ssFallback ? fallbackHooks : contentHooks;
    } else vnode.transition = hooks;
    return hooks;
}
function $2587789e20bc75b6$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $2587789e20bc75b6$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($2587789e20bc75b6$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $2587789e20bc75b6$export$4d299b491347818a) ret.push(key != null ? $2587789e20bc75b6$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/**
* dev-only
*/ function $2587789e20bc75b6$export$f7697b49c3204928(mode) {}
//#endregion
//#region packages/runtime-core/src/apiDefineComponent.ts
/*@__NO_SIDE_EFFECTS__*/ function $2587789e20bc75b6$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $7s0Ms.isFunction)(options) ? /*@__PURE__*/ (()=>(0, $7s0Ms.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
//#endregion
//#region packages/runtime-core/src/helpers/useId.ts
function $2587789e20bc75b6$export$f680877a34711e37() {
    const i = $2587789e20bc75b6$var$getCurrentGenericInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
/**
* There are 3 types of async boundaries:
* - async components
* - components with async setup()
* - components with serverPrefetch
*/ function $2587789e20bc75b6$export$b9b0eeb564431e5e(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
//#endregion
//#region packages/runtime-core/src/helpers/useTemplateRef.ts
const $2587789e20bc75b6$export$f55a8fa3b95033b5 = /* @__PURE__ */ new WeakSet();
function $2587789e20bc75b6$export$83a5dbc1f35517ca(key) {
    const i = $2587789e20bc75b6$var$getCurrentGenericInstance();
    const r = (0, $SdEQh.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $7s0Ms.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $2587789e20bc75b6$export$950f9ee44cd3c66(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
//#endregion
//#region packages/runtime-core/src/rendererTemplateRef.ts
const $2587789e20bc75b6$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
/**
* Function for handling a template ref
*/ function $2587789e20bc75b6$export$4bb192c7cacf928f(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $7s0Ms.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$2587789e20bc75b6$export$4bb192c7cacf928f(r, oldRawRef && ((0, $7s0Ms.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($2587789e20bc75b6$export$4d0901d882427199(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $2587789e20bc75b6$export$4bb192c7cacf928f(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $2587789e20bc75b6$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $7s0Ms.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const canSetSetupRef = $2587789e20bc75b6$export$6082a4aa7ed81817(setupState, refs);
    const canSetRef = (ref, key)=>{
        if (key && $2587789e20bc75b6$export$950f9ee44cd3c66(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $2587789e20bc75b6$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $7s0Ms.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $SdEQh.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $7s0Ms.isFunction)(ref)) $2587789e20bc75b6$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $7s0Ms.isString)(ref);
        const _isRef = (0, $SdEQh.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $7s0Ms.isArray)(existing) && (0, $7s0Ms.remove)(existing, refValue);
                    else if (!(0, $7s0Ms.isArray)(existing)) {
                        if (_isString) {
                            refs[ref] = [
                                refValue
                            ];
                            if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                        } else {
                            const newVal = [
                                refValue
                            ];
                            if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                            if (rawRef.k) refs[rawRef.k] = newVal;
                        }
                    } else if (!existing.includes(refValue)) existing.push(refValue);
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $2587789e20bc75b6$var$pendingSetRefMap.delete(rawRef);
                };
                $2587789e20bc75b6$var$pendingSetRefMap.set(rawRef, job);
                $2587789e20bc75b6$export$51ec8e020844a97a(job, -1, parentSuspense);
            } else {
                $2587789e20bc75b6$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $2587789e20bc75b6$export$6082a4aa7ed81817(setupState, refs) {
    const rawSetupState = (0, $SdEQh.toRaw)(setupState);
    return setupState === void 0 || setupState === (0, $7s0Ms.EMPTY_OBJ) ? (0, $7s0Ms.NO) : (key)=>{
        if ($2587789e20bc75b6$export$950f9ee44cd3c66(refs, key)) return false;
        return (0, $7s0Ms.hasOwn)(rawSetupState, key);
    };
}
function $2587789e20bc75b6$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $2587789e20bc75b6$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 4;
        $2587789e20bc75b6$var$pendingSetRefMap.delete(rawRef);
    }
}
//#endregion
//#region packages/runtime-core/src/hydration.ts
let $2587789e20bc75b6$export$949522c94f173e7e = false;
function $2587789e20bc75b6$export$fb2190d8f9a1a092(value) {
    $2587789e20bc75b6$export$949522c94f173e7e = value;
}
/**
* VDOM hydration state.
* Also used by vapor interop plugin for tree-shaking:
* In non-hydration builds, this is never set to true, so the logic in
* vaporInteropImpl's hydrate/hydrateSlot can be tree-shaken.
*/ let $2587789e20bc75b6$export$454b4aa5c5ff33b6 = false;
let $2587789e20bc75b6$var$hasLoggedMismatchError = false;
const $2587789e20bc75b6$export$7c36cdbb1b0f1a71 = ()=>{
    if ($2587789e20bc75b6$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $2587789e20bc75b6$var$hasLoggedMismatchError = true;
};
const $2587789e20bc75b6$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $2587789e20bc75b6$var$isMathMLContainer = (container)=>{
    if (!container.namespaceURI.includes("MathML")) return false;
    if (container.tagName !== "annotation-xml") return true;
    const encoding = container.getAttribute("encoding");
    return !encoding || !encoding.includes("html");
};
/**
* Resolve the element namespace a container's children should be created in.
* The live DOM is the source of truth, so this also covers containers that are
* only known at runtime (interop boundaries, teleport targets).
* @internal
*/ const $2587789e20bc75b6$export$acc6f3e19803b3dc = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($2587789e20bc75b6$var$isSVGContainer(container)) return "svg";
    if ($2587789e20bc75b6$var$isMathMLContainer(container)) return "mathml";
};
const $2587789e20bc75b6$var$isComment = (node)=>node.nodeType === 8;
function $2587789e20bc75b6$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!$2587789e20bc75b6$export$949522c94f173e7e) return;
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            $2587789e20bc75b6$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $2587789e20bc75b6$export$454b4aa5c5ff33b6 = true;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $2587789e20bc75b6$export$454b4aa5c5ff33b6 = false;
        $2587789e20bc75b6$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $2587789e20bc75b6$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $7s0Ms.def)(node, "__vnode", vnode, true);
            (0, $7s0Ms.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $2587789e20bc75b6$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1(`Hydration text mismatch in`, node.parentNode, `\n  - rendered on server: ${JSON.stringify(node.data)}\n  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $2587789e20bc75b6$export$4d299b491347818a:
                if ($2587789e20bc75b6$export$f125a8a2b402ed89(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $2587789e20bc75b6$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $2587789e20bc75b6$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            case $2587789e20bc75b6$export$c7c4a6890f1c1342:
                nextNode = $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).hydrateSlot(vnode, node, parentComponent, parentSuspense, slotScopeIds);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !$2587789e20bc75b6$export$f125a8a2b402ed89(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($2587789e20bc75b6$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    if (vnode.type.__vapor) {
                        const vnodeBeforeMountHook = !$2587789e20bc75b6$export$4d0901d882427199(vnode) && vnode.props && vnode.props.onVnodeBeforeMount;
                        $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).hydrate(vnode, node, container, nextNode, parentComponent, parentSuspense, ()=>{
                            if (vnode.dirs) {
                                $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "created");
                                $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
                            }
                        }, ()=>{
                            if (vnodeBeforeMountHook) $2587789e20bc75b6$var$invokeVNodeHook(vnodeBeforeMountHook, parentComponent, vnode);
                        });
                        if (vnode.dirs) $2587789e20bc75b6$var$queueEffectWithSuspense(()=>$2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "mounted"), void 0, parentSuspense);
                        const vnodeMountedHook = !$2587789e20bc75b6$export$4d0901d882427199(vnode) && vnode.props && vnode.props.onVnodeMounted;
                        if (vnodeMountedHook) $2587789e20bc75b6$var$queueEffectWithSuspense(()=>$2587789e20bc75b6$var$invokeVNodeHook(vnodeMountedHook, parentComponent, vnode), void 0, parentSuspense);
                    } else {
                        mountComponent(vnode, container, null, parentComponent, parentSuspense, $2587789e20bc75b6$export$acc6f3e19803b3dc(container), optimized);
                        const component = vnode.component;
                        if (!component.subTree && ($2587789e20bc75b6$export$4d0901d882427199(vnode) || component.asyncDep)) {
                            let subTree;
                            if (isFragmentStart) {
                                subTree = $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$c1b9a1d3af45b7b6);
                                subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                            } else subTree = node.nodeType === 3 ? $2587789e20bc75b6$export$22f9b5ffd89dac9("") : $2587789e20bc75b6$export$bf5c4cf060303d58(node.nodeType === 8 ? $2587789e20bc75b6$export$4d299b491347818a : "div");
                            subTree.el = node;
                            component.subTree = subTree;
                        }
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $2587789e20bc75b6$export$acc6f3e19803b3dc(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $2587789e20bc75b6$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $2587789e20bc75b6$export$4bb192c7cacf928f(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if ($2587789e20bc75b6$export$f125a8a2b402ed89(el)) {
                needCallTransitionHooks = $2587789e20bc75b6$var$needTransition(null, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$2587789e20bc75b6$export$89e0dff13906bb59(el, 1)) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1(`Hydration children mismatch on`, el, `\nServer rendered element contains more child nodes than client vdom.`);
                    $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$2587789e20bc75b6$export$89e0dff13906bb59(el, 0)) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1(`Hydration text content mismatch on`, el, `\n  - rendered on server: ${textContent}\n  - expected on client: ${clientText}`);
                        $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !(dirs && dirs.some((d)=>d.dir.created)) && $2587789e20bc75b6$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $7s0Ms.isOn)(key) && !(0, $7s0Ms.isReservedProp)(key) || key[0] === "." || isCustomElement && !(0, $7s0Ms.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($2587789e20bc75b6$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $SdEQh.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $2587789e20bc75b6$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "mounted");
            }, void 0, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $2587789e20bc75b6$export$a0e1465ad202d515(children[i]);
            const isText = vnode.type === $2587789e20bc75b6$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $2587789e20bc75b6$export$a0e1465ad202d515(children[i + 1]).type === $2587789e20bc75b6$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$2587789e20bc75b6$export$89e0dff13906bb59(container, 1)) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1(`Hydration children mismatch on`, container, `\nServer rendered element contains fewer child nodes than client vdom.`);
                        $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $2587789e20bc75b6$export$acc6f3e19803b3dc(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $2587789e20bc75b6$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$2587789e20bc75b6$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $2587789e20bc75b6$var$warn$1(`Hydration node mismatch:\n- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $2587789e20bc75b6$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `\n- expected on client:`, vnode.type);
            $2587789e20bc75b6$export$7c36cdbb1b0f1a71();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $2587789e20bc75b6$export$acc6f3e19803b3dc(container), slotScopeIds);
        if (parentComponent && parentComponent.vnode) {
            parentComponent.vnode.el = vnode.el;
            $2587789e20bc75b6$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $2587789e20bc75b6$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode = oldNode.parentNode;
        if (parentNode) parentNode.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode && parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $2587789e20bc75b6$export$f125a8a2b402ed89 = (node)=>{
    return node.nodeType === 1 && node.tagName === "TEMPLATE";
};
/**
* Dev only
*/ const $2587789e20bc75b6$var$resourceProps = /*@__PURE__*/ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $2587789e20bc75b6$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$2587789e20bc75b6$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $2587789e20bc75b6$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $7s0Ms.normalizeClass)(clientValue);
        if (!$2587789e20bc75b6$export$a8d0d0c8d1c5df64($2587789e20bc75b6$export$e64691051f3919e5(actual || ""), $2587789e20bc75b6$export$e64691051f3919e5(expected))) {
            mismatchType = 2;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $7s0Ms.isString)(clientValue) ? clientValue : (0, $7s0Ms.stringifyStyle)((0, $7s0Ms.normalizeStyle)(clientValue));
        const actualMap = $2587789e20bc75b6$export$10b092b355df2060(actual);
        const expectedMap = $2587789e20bc75b6$export$10b092b355df2060(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $2587789e20bc75b6$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$2587789e20bc75b6$export$71029b577818f2bb(actualMap, expectedMap)) {
            mismatchType = 3;
            mismatchKey = "style";
        }
    } else if ($2587789e20bc75b6$export$92c55cf0d3a086c0(el, key)) {
        ({ actual: actual, expected: expected } = $2587789e20bc75b6$export$1a5eb8a5128caad6(el, key, clientValue));
        if (actual !== expected) {
            mismatchType = 4;
            mismatchKey = key;
        }
    }
    return $2587789e20bc75b6$export$c6d1c9a52f0379ae(el, mismatchKey, mismatchType, actual, expected);
}
function $2587789e20bc75b6$export$1a5eb8a5128caad6(el, key, clientValue) {
    let actual;
    let expected;
    if (key === "hidden") {
        actual = $2587789e20bc75b6$var$normalizeHiddenValue(el.getAttribute(key));
        expected = $2587789e20bc75b6$var$normalizeHiddenValue(clientValue);
    } else if ((0, $7s0Ms.isBooleanAttr)(key)) {
        actual = el.hasAttribute(key);
        expected = (0, $7s0Ms.includeBooleanAttr)(clientValue);
    } else if (clientValue == null) {
        actual = el.hasAttribute(key);
        expected = false;
    } else {
        if (el.hasAttribute(key)) actual = el.getAttribute(key);
        else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
        else actual = false;
        expected = (0, $7s0Ms.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
    }
    return {
        actual: actual,
        expected: expected
    };
}
function $2587789e20bc75b6$export$92c55cf0d3a086c0(el, key) {
    return el instanceof SVGElement && (0, $7s0Ms.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $7s0Ms.isBooleanAttr)(key) || (0, $7s0Ms.isKnownHtmlAttr)(key));
}
function $2587789e20bc75b6$export$c6d1c9a52f0379ae(el, mismatchKey, mismatchType, actual, expected) {
    if (mismatchType != null && !$2587789e20bc75b6$export$89e0dff13906bb59(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        $2587789e20bc75b6$var$warn$1(`Hydration ${$2587789e20bc75b6$var$MismatchTypeString[mismatchType]} mismatch on`, el, `\n  - rendered on server: ${format(actual)}\n  - expected on client: ${format(expected)}\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch.`);
        return true;
    }
    return false;
}
function $2587789e20bc75b6$var$normalizeHiddenValue(value) {
    if (!(0, $7s0Ms.isRenderableAttrValue)(value)) return false;
    if ((0, $7s0Ms.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $7s0Ms.includeBooleanAttr)(value) ? "" : false;
}
function $2587789e20bc75b6$export$e64691051f3919e5(str) {
    return new Set(str.trim().split(/\s+/));
}
function $2587789e20bc75b6$export$a8d0d0c8d1c5df64(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a)if (!b.has(s)) return false;
    return true;
}
function $2587789e20bc75b6$export$10b092b355df2060(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $2587789e20bc75b6$export$71029b577818f2bb(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a)if (value !== b.get(key)) return false;
    return true;
}
function $2587789e20bc75b6$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $2587789e20bc75b6$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $7s0Ms.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $7s0Ms.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $2587789e20bc75b6$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $2587789e20bc75b6$var$allowMismatchAttr = "data-allow-mismatch";
const $2587789e20bc75b6$export$92e7f8fbf145401a = {
    "TEXT": 0,
    "0": "TEXT",
    "CHILDREN": 1,
    "1": "CHILDREN",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 3,
    "3": "STYLE",
    "ATTRIBUTE": 4,
    "4": "ATTRIBUTE"
};
const $2587789e20bc75b6$var$MismatchTypeString = {
    [0]: "text",
    [1]: "children",
    [2]: "class",
    [3]: "style",
    [4]: "attribute"
};
function $2587789e20bc75b6$export$89e0dff13906bb59(el, allowedType) {
    if (allowedType === 0 || allowedType === 1) while(el && !el.hasAttribute($2587789e20bc75b6$var$allowMismatchAttr))el = el.parentElement;
    return $2587789e20bc75b6$var$isMismatchAllowedByAttr(el && el.getAttribute($2587789e20bc75b6$var$allowMismatchAttr), allowedType);
}
function $2587789e20bc75b6$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 && list.includes("children")) return true;
        return list.includes($2587789e20bc75b6$var$MismatchTypeString[allowedType]);
    }
}
function $2587789e20bc75b6$var$isNodeMismatchAllowed(node, vnode) {
    return $2587789e20bc75b6$export$89e0dff13906bb59(node.parentElement, 1) || $2587789e20bc75b6$var$isMismatchAllowedByNode(node) || $2587789e20bc75b6$var$isMismatchAllowedByVNode(vnode);
}
function $2587789e20bc75b6$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $2587789e20bc75b6$var$isMismatchAllowedByAttr(node.getAttribute($2587789e20bc75b6$var$allowMismatchAttr), 1);
}
function $2587789e20bc75b6$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$2587789e20bc75b6$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $2587789e20bc75b6$var$isMismatchAllowedByAttr(allowedAttr, 1);
}
//#endregion
//#region packages/runtime-core/src/hydrationStrategies.ts
let $2587789e20bc75b6$var$requestIdleCallback;
let $2587789e20bc75b6$var$cancelIdleCallback;
function $2587789e20bc75b6$var$ensureIdleCallbacks() {
    if (!$2587789e20bc75b6$var$requestIdleCallback) {
        const g = (0, $7s0Ms.getGlobalThis)();
        $2587789e20bc75b6$var$requestIdleCallback = g.requestIdleCallback || ((cb)=>setTimeout(cb, 1));
        $2587789e20bc75b6$var$cancelIdleCallback = g.cancelIdleCallback || ((id)=>clearTimeout(id));
    }
}
const $2587789e20bc75b6$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        $2587789e20bc75b6$var$ensureIdleCallbacks();
        const id = $2587789e20bc75b6$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$2587789e20bc75b6$var$cancelIdleCallback(id);
    };
function $2587789e20bc75b6$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $2587789e20bc75b6$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($2587789e20bc75b6$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $2587789e20bc75b6$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $2587789e20bc75b6$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $7s0Ms.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                if (!(`$evt${e.type}` in e.target)) e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $2587789e20bc75b6$var$forEachElement(node, cb) {
    if ($2587789e20bc75b6$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                if (cb(next) === false) break;
            } else if ($2587789e20bc75b6$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
//#endregion
//#region packages/runtime-core/src/apiAsyncComponent.ts
const $2587789e20bc75b6$export$4d0901d882427199 = (i)=>!!i.type.__asyncLoader;
/*@__NO_SIDE_EFFECTS__*/ function $2587789e20bc75b6$export$d75d499b4c16cf21(source) {
    const { load: load, getResolvedComp: getResolvedComp, setPendingRequest: setPendingRequest, source: { loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay, hydrate: hydrateStrategy, timeout: timeout, suspensible: suspensible = true } } = $2587789e20bc75b6$export$1e8f866142774b37(source);
    return /* @__PURE__ */ $2587789e20bc75b6$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            $2587789e20bc75b6$export$49918ad629c39773(el, instance, hydrate, getResolvedComp, load, hydrateStrategy, true);
        },
        get __asyncResolved () {
            return getResolvedComp();
        },
        setup () {
            const instance = $2587789e20bc75b6$export$5d0c78f02672825;
            $2587789e20bc75b6$export$b9b0eeb564431e5e(instance);
            let resolvedComp = getResolvedComp();
            if (resolvedComp) return ()=>$2587789e20bc75b6$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                setPendingRequest(null);
                $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $2587789e20bc75b6$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$2587789e20bc75b6$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $2587789e20bc75b6$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const { loaded: loaded, error: error, delayed: delayed } = $2587789e20bc75b6$export$c7a65c52b748d650(delay, timeout, onError, instance);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && instance.parent.vnode && $2587789e20bc75b6$export$a33216a979d8327a(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    setPendingRequest(null);
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                resolvedComp = getResolvedComp();
                if (loaded.value && resolvedComp) return $2587789e20bc75b6$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $2587789e20bc75b6$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $2587789e20bc75b6$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $2587789e20bc75b6$var$createInnerComp(comp, parent) {
    const { ref: ref, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $2587789e20bc75b6$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
function $2587789e20bc75b6$export$1e8f866142774b37(source) {
    if ((0, $7s0Ms.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return {
        load: load,
        source: source,
        getResolvedComp: ()=>resolvedComp,
        setPendingRequest: (request)=>pendingRequest = request
    };
}
const $2587789e20bc75b6$export$c7a65c52b748d650 = (delay, timeout, onError, instance = $2587789e20bc75b6$export$5d0c78f02672825)=>{
    const loaded = (0, $SdEQh.ref)(false);
    const error = (0, $SdEQh.ref)();
    const delayed = (0, $SdEQh.ref)(!!delay);
    let timeoutTimer;
    let delayTimer;
    if (instance) $2587789e20bc75b6$export$13348a43ccacfe58(()=>{
        if (timeoutTimer != null) clearTimeout(timeoutTimer);
        if (delayTimer != null) clearTimeout(delayTimer);
    }, instance);
    if (delay) delayTimer = setTimeout(()=>{
        if (instance && instance.isUnmounted) return;
        delayed.value = false;
    }, delay);
    if (timeout != null) timeoutTimer = setTimeout(()=>{
        if (instance && instance.isUnmounted) return;
        if (!loaded.value && !error.value) {
            const err = /* @__PURE__ */ new Error(`Async component timed out after ${timeout}ms.`);
            onError(err);
            error.value = err;
        }
    }, timeout);
    return {
        loaded: loaded,
        error: error,
        delayed: delayed
    };
};
/**
* shared between core and vapor
* @internal
*/ function $2587789e20bc75b6$export$49918ad629c39773(el, instance, hydrate, getResolvedComp, load, hydrateStrategy, skipIfUpdated) {
    const wasConnected = el.isConnected;
    let patched = false;
    if (skipIfUpdated) (instance.bu || (instance.bu = [])).push(()=>patched = true);
    const performHydrate = ()=>{
        if (patched) return;
        if (!el.parentNode || wasConnected && !el.isConnected) return;
        hydrate();
    };
    const doHydrate = hydrateStrategy ? ()=>{
        const teardown = hydrateStrategy(performHydrate, (cb)=>$2587789e20bc75b6$var$forEachElement(el, cb));
        if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
    } : performHydrate;
    if (getResolvedComp()) doHydrate();
    else load().then(()=>!instance.isUnmounted && doHydrate());
}
//#endregion
//#region packages/runtime-core/src/components/KeepAlive.ts
const $2587789e20bc75b6$export$a33216a979d8327a = (vnode)=>vnode.type.__isKeepAlive;
const $2587789e20bc75b6$export$70eb8a58709972df = {
    name: `KeepAlive`,
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const keepAliveInstance = $2587789e20bc75b6$export$f13e630aa3915748();
        const sharedContext = keepAliveInstance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) keepAliveInstance.__v_cache = cache;
        const parentSuspense = keepAliveInstance.suspense;
        const { renderer: renderer } = sharedContext;
        const { um: _unmount, o: { createElement: createElement } } = renderer;
        const storageContainer = createElement("div");
        sharedContext.getStorageContainer = ()=>storageContainer;
        sharedContext.getCachedComponent = (vnode)=>{
            const key = vnode.key == null ? vnode.type : vnode.key;
            return cache.get(key);
        };
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            $2587789e20bc75b6$export$234c45b355edd85b(vnode, container, anchor, renderer, keepAliveInstance, parentSuspense, namespace, optimized);
        };
        sharedContext.deactivate = (vnode)=>{
            $2587789e20bc75b6$export$e96c1edfdaf2d1db(vnode, storageContainer, renderer, keepAliveInstance, parentSuspense);
        };
        function unmount(vnode) {
            $2587789e20bc75b6$export$e88525abd1b19421(vnode);
            _unmount(vnode, keepAliveInstance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $2587789e20bc75b6$export$26727cfcc4d7e0fc($2587789e20bc75b6$export$4d0901d882427199(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$2587789e20bc75b6$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $2587789e20bc75b6$export$e88525abd1b19421(current);
            cache.delete(key);
            keys.delete(key);
        }
        $2587789e20bc75b6$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$2587789e20bc75b6$export$de994efd351b291c(include, name));
            exclude && pruneCache((name)=>!$2587789e20bc75b6$export$de994efd351b291c(exclude, name));
        }, {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($2587789e20bc75b6$var$isSuspense(keepAliveInstance.subTree.type)) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                    const vnode = $2587789e20bc75b6$var$getInnerChild(keepAliveInstance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, void 0, keepAliveInstance.subTree.suspense);
                else cache.set(pendingCacheKey, $2587789e20bc75b6$var$getInnerChild(keepAliveInstance.subTree));
            }
        };
        $2587789e20bc75b6$export$6d1641039221b5cb(cacheSubtree);
        $2587789e20bc75b6$export$5876c47052fb88b1(cacheSubtree);
        $2587789e20bc75b6$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = keepAliveInstance;
                const vnode = $2587789e20bc75b6$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $2587789e20bc75b6$export$e88525abd1b19421(vnode);
                    const da = vnode.component.da;
                    da && $2587789e20bc75b6$export$51ec8e020844a97a(da, void 0, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$2587789e20bc75b6$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $2587789e20bc75b6$var$getInnerChild(rawVNode);
            if (vnode.type === $2587789e20bc75b6$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $2587789e20bc75b6$export$26727cfcc4d7e0fc($2587789e20bc75b6$export$4d0901d882427199(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$2587789e20bc75b6$export$de994efd351b291c(include, name)) || exclude && name && $2587789e20bc75b6$export$de994efd351b291c(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $2587789e20bc75b6$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $2587789e20bc75b6$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
function $2587789e20bc75b6$export$de994efd351b291c(pattern, name) {
    if ((0, $7s0Ms.isArray)(pattern)) return pattern.some((p)=>$2587789e20bc75b6$export$de994efd351b291c(p, name));
    else if ((0, $7s0Ms.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $7s0Ms.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    /* v8 ignore next */ return false;
}
function $2587789e20bc75b6$export$ba52d824b95a2154(hook, target) {
    $2587789e20bc75b6$var$registerKeepAliveHook(hook, "a", target);
}
function $2587789e20bc75b6$export$bf1440eeaf5fa709(hook, target) {
    $2587789e20bc75b6$var$registerKeepAliveHook(hook, "da", target);
}
function $2587789e20bc75b6$var$registerKeepAliveHook(hook, type, target = $2587789e20bc75b6$var$getCurrentGenericInstance()) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $2587789e20bc75b6$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            let parent = current.parent;
            if ($2587789e20bc75b6$export$a33216a979d8327a(parent.vapor ? parent : parent.vnode)) $2587789e20bc75b6$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $2587789e20bc75b6$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $2587789e20bc75b6$var$injectHook(type, hook, keepAliveRoot, true);
    $2587789e20bc75b6$export$13348a43ccacfe58(()=>{
        (0, $7s0Ms.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $2587789e20bc75b6$export$e88525abd1b19421(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $2587789e20bc75b6$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
/**
* shared between runtime-core and runtime-vapor
*/ function $2587789e20bc75b6$export$234c45b355edd85b(vnode, container, anchor, { p: patch, m: move }, parentComponent, parentSuspense, namespace, optimized) {
    const instance = vnode.component;
    move(vnode, container, anchor, 0, parentComponent, parentSuspense);
    patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, namespace, vnode.slotScopeIds, optimized);
    $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
        instance.isDeactivated = false;
        if (instance.a) (0, $7s0Ms.invokeArrayFns)(instance.a);
        const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
        if (vnodeHook) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$export$a76a9a73068a1a5e(instance);
}
/**
* shared between runtime-core and runtime-vapor
*/ function $2587789e20bc75b6$export$e96c1edfdaf2d1db(vnode, container, { m: move }, parentComponent, parentSuspense) {
    const instance = vnode.component;
    $2587789e20bc75b6$export$47f10f11906274f2(instance.m);
    $2587789e20bc75b6$export$47f10f11906274f2(instance.a);
    move(vnode, container, null, 1, parentComponent, parentSuspense);
    $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
        if (instance.da) (0, $7s0Ms.invokeArrayFns)(instance.da);
        const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
        if (vnodeHook) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
        instance.isDeactivated = true;
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$export$a76a9a73068a1a5e(instance);
}
//#endregion
//#region packages/runtime-core/src/apiLifecycle.ts
function $2587789e20bc75b6$var$injectHook(type, hook, target = $2587789e20bc75b6$export$5d0c78f02672825, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            const prevSub = (0, $SdEQh.setActiveSub)();
            const prev = $2587789e20bc75b6$export$a5e695a16aa0b6d4(target);
            try {
                return $2587789e20bc75b6$export$dae85862a8d94378(hook, target, type, args);
            } finally{
                $2587789e20bc75b6$export$95e96a1fb881e3e7(prev);
                (0, $SdEQh.setActiveSub)(prevSub);
            }
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $2587789e20bc75b6$var$createHook = /* @__NO_SIDE_EFFECTS__ */ (lifecycle)=>(hook, target = $2587789e20bc75b6$export$5d0c78f02672825)=>{
        if (!$2587789e20bc75b6$var$isInSSRComponentSetup || lifecycle === "sp") $2587789e20bc75b6$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $2587789e20bc75b6$export$23b7aeb0d671f804 = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("bm");
const $2587789e20bc75b6$export$6d1641039221b5cb = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("m");
const $2587789e20bc75b6$export$ab91988a13872e4c = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("bu");
const $2587789e20bc75b6$export$5876c47052fb88b1 = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("u");
const $2587789e20bc75b6$export$40c420df62d2614 = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("bum");
const $2587789e20bc75b6$export$13348a43ccacfe58 = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("um");
const $2587789e20bc75b6$export$ebf0c601f267bceb = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("sp");
const $2587789e20bc75b6$export$898295a813d662eb = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("rtg");
const $2587789e20bc75b6$export$2b41f4235363e921 = /* @__PURE__ */ $2587789e20bc75b6$var$createHook("rtc");
function $2587789e20bc75b6$export$6a3a15856e50ad19(hook, target = $2587789e20bc75b6$export$5d0c78f02672825) {
    $2587789e20bc75b6$var$injectHook("ec", hook, target);
}
const $2587789e20bc75b6$var$DIRECTIVES = "directives";
/**
* @private
*/ function $2587789e20bc75b6$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $2587789e20bc75b6$var$resolveAsset("components", name, true, maybeSelfReference) || name;
}
const $2587789e20bc75b6$export$7d1f90a35714b16e = Symbol.for("v-ndc");
/**
* @private
*/ function $2587789e20bc75b6$export$b44c564a05ca975(component) {
    if ((0, $7s0Ms.isString)(component)) return $2587789e20bc75b6$var$resolveAsset("components", component, false) || component;
    else return component || $2587789e20bc75b6$export$7d1f90a35714b16e;
}
/**
* @private
*/ function $2587789e20bc75b6$export$a1989e995cd481be(name) {
    return $2587789e20bc75b6$var$resolveAsset($2587789e20bc75b6$var$DIRECTIVES, name);
}
function $2587789e20bc75b6$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $2587789e20bc75b6$var$currentRenderingInstance || $2587789e20bc75b6$export$5d0c78f02672825;
    if (instance) {
        const Component = instance.type;
        if (type === "components") {
            const selfName = $2587789e20bc75b6$export$26727cfcc4d7e0fc(Component, false);
            if (selfName && (selfName === name || selfName === (0, $7s0Ms.camelize)(name) || selfName === (0, $7s0Ms.capitalize)((0, $7s0Ms.camelize)(name)))) return Component;
        }
        const res = $2587789e20bc75b6$var$resolve(instance[type] || Component[type], name) || $2587789e20bc75b6$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $2587789e20bc75b6$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $7s0Ms.camelize)(name)] || registry[(0, $7s0Ms.capitalize)((0, $7s0Ms.camelize)(name))]);
}
//#endregion
//#region packages/runtime-core/src/helpers/renderList.ts
/**
* Actual implementation
*/ function $2587789e20bc75b6$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $7s0Ms.isArray)(source);
    if (sourceIsArray || (0, $7s0Ms.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $SdEQh.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $SdEQh.isShallow)(source);
            isReadonlySource = (0, $SdEQh.isReadonly)(source);
            source = (0, $SdEQh.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $SdEQh.toReadonly)((0, $SdEQh.toReactive)(source[i])) : (0, $SdEQh.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $7s0Ms.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
//#endregion
//#region packages/runtime-core/src/helpers/createSlots.ts
/**
* Compiler runtime helper for creating dynamic slots object
* @private
*/ function $2587789e20bc75b6$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $7s0Ms.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
//#endregion
//#region packages/runtime-core/src/helpers/renderSlot.ts
/**
* Links a slot function to its raw vapor slot: a raw vapor slot carries
* itself, and the wrapper the interop slots proxy hands out carries the raw
* slot it wraps — one lookup answers both "is this a vapor slot" and
* "which one". Internal to vapor interop.
*/ const $2587789e20bc75b6$export$3ab367ca01a03fcc = Symbol(`rawVaporSlot`);
/**
* Marks a compiler-generated slot fallback as VDOM-rendered so the vapor
* interop fallback chain renders it through the VDOM renderer. Internal to
* vapor interop.
*/ const $2587789e20bc75b6$export$3d218eda79783141 = Symbol(`vdomSlotFallback`);
/**
* Compiler runtime helper for rendering `<slot/>`
* @private
*/ function $2587789e20bc75b6$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    let slot = slots[name];
    if (fallback) fallback[$2587789e20bc75b6$export$3d218eda79783141] = true;
    const vaporSlot = slot && slot[$2587789e20bc75b6$export$3ab367ca01a03fcc];
    if (vaporSlot) {
        const ret = ($2587789e20bc75b6$export$e7eaa45e502fe5cc(), $2587789e20bc75b6$export$9f2dfe8048dfb22b($2587789e20bc75b6$export$c7c4a6890f1c1342, props));
        ret.vs = {
            slot: vaporSlot,
            fallback: fallback
        };
        if (!noSlotted && ret.scopeId) ret.slotScopeIds = [
            ret.scopeId + "-s"
        ];
        return ret;
    }
    if ($2587789e20bc75b6$var$currentRenderingInstance && ($2587789e20bc75b6$var$currentRenderingInstance.ce || $2587789e20bc75b6$var$currentRenderingInstance.parent && $2587789e20bc75b6$export$4d0901d882427199($2587789e20bc75b6$var$currentRenderingInstance.parent) && $2587789e20bc75b6$var$currentRenderingInstance.parent.ce)) {
        const slotProps = branchKey != null && props.key == null ? (0, $7s0Ms.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $2587789e20bc75b6$export$e7eaa45e502fe5cc(), $2587789e20bc75b6$export$9f2dfe8048dfb22b($2587789e20bc75b6$export$ffb0004e005737fa, null, [
            $2587789e20bc75b6$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $2587789e20bc75b6$var$blockStack.length;
    $2587789e20bc75b6$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $2587789e20bc75b6$export$9fc41f261330971f(slot(props));
        $2587789e20bc75b6$export$48f2e51a96a1a702(validSlotContent, fallback);
        const slotKey = props.key || branchKey || validSlotContent && validSlotContent.key;
        rendered = $2587789e20bc75b6$export$9f2dfe8048dfb22b($2587789e20bc75b6$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $7s0Ms.isSymbol)(slotKey) ? slotKey : `_${name}`) + (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $2587789e20bc75b6$var$blockStack.length; i > prevStackSize; i--)$2587789e20bc75b6$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $2587789e20bc75b6$export$9fc41f261330971f(vnodes) {
    return vnodes.some((child)=>{
        if (!$2587789e20bc75b6$export$3868d13f8734ae81(child)) return true;
        if (child.type === $2587789e20bc75b6$export$4d299b491347818a) return false;
        if (child.type === $2587789e20bc75b6$export$ffb0004e005737fa && !$2587789e20bc75b6$export$9fc41f261330971f(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $2587789e20bc75b6$export$48f2e51a96a1a702(vnodes, fallback) {
    let vaporSlot;
    if (vnodes && vnodes.length === 1 && $2587789e20bc75b6$export$3868d13f8734ae81(vnodes[0]) && (vaporSlot = vnodes[0].vs)) vaporSlot.outletFallback = fallback;
}
//#endregion
//#region packages/runtime-core/src/helpers/toHandlers.ts
/**
* For prefixing keys in v-on="obj" with "on"
* @private
*/ function $2587789e20bc75b6$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $7s0Ms.toHandlerKey)(key)] = obj[key];
    return ret;
}
//#endregion
//#region packages/runtime-core/src/componentPublicInstance.ts
/**
* #2437 In Vue 3, functional components do not have a public instance proxy but
* they exist in the internal parent chain. For code that relies on traversing
* public $parent chains, skip functional ones and go to the parent instead.
*/ const $2587789e20bc75b6$var$getPublicInstance = (i)=>{
    if (!i || i.vapor) return null;
    if ($2587789e20bc75b6$var$isStatefulComponent(i)) return $2587789e20bc75b6$var$getComponentPublicInstance(i);
    return $2587789e20bc75b6$var$getPublicInstance(i.parent);
};
const $2587789e20bc75b6$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $2587789e20bc75b6$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $2587789e20bc75b6$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $2587789e20bc75b6$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
let $2587789e20bc75b6$var$publicPropertiesMap;
const $2587789e20bc75b6$var$getPublicPropertiesMap = ()=>{
    if (!$2587789e20bc75b6$var$publicPropertiesMap) $2587789e20bc75b6$var$publicPropertiesMap = (0, $7s0Ms.extend)(Object.create(null), {
        $: (i)=>i,
        $el: (i)=>(0, i.vnode.el),
        $data: (i)=>i.data,
        $props: (i)=>(0, i.props),
        $attrs: (i)=>(0, i.attrs),
        $slots: (i)=>(0, i.slots),
        $refs: (i)=>(0, i.refs),
        $parent: (i)=>$2587789e20bc75b6$var$getPublicInstance(i.parent),
        $root: (i)=>$2587789e20bc75b6$var$getPublicInstance(i.root),
        $host: (i)=>i.ce,
        $emit: (i)=>i.emit,
        $options: (i)=>__VUE_OPTIONS_API__ ? $2587789e20bc75b6$var$resolveMergedOptions(i) : i.type,
        $forceUpdate: (i)=>i.f || (i.f = ()=>{
                $2587789e20bc75b6$export$fba1a0a20887772f(i.update);
            }),
        $nextTick: (i)=>i.n || (i.n = $2587789e20bc75b6$export$bdd553fddd433dcb.bind(i.proxy)),
        $watch: (i)=>__VUE_OPTIONS_API__ ? $2587789e20bc75b6$var$instanceWatch.bind(i) : (0, $7s0Ms.NOOP)
    });
    return $2587789e20bc75b6$var$publicPropertiesMap;
};
const $2587789e20bc75b6$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $2587789e20bc75b6$var$hasSetupBinding = (state, key)=>state !== (0, $7s0Ms.EMPTY_OBJ) && !state.__isScriptSetup && (0, $7s0Ms.hasOwn)(state, key);
const $2587789e20bc75b6$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1:
                    return setupState[key];
                case 2:
                    return data[key];
                case 4:
                    return ctx[key];
                case 3:
                    return props[key];
            }
            else if ($2587789e20bc75b6$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $7s0Ms.EMPTY_OBJ) && (0, $7s0Ms.hasOwn)(data, key)) {
                accessCache[key] = 2;
                return data[key];
            } else if ((0, $7s0Ms.hasOwn)(props, key)) {
                accessCache[key] = 3;
                return props[key];
            } else if (ctx !== (0, $7s0Ms.EMPTY_OBJ) && (0, $7s0Ms.hasOwn)(ctx, key)) {
                accessCache[key] = 4;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $2587789e20bc75b6$var$shouldCacheAccess) accessCache[key] = 0;
        }
        const publicGetter = $2587789e20bc75b6$var$getPublicPropertiesMap()[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $SdEQh.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $7s0Ms.EMPTY_OBJ) && (0, $7s0Ms.hasOwn)(ctx, key)) {
            accessCache[key] = 4;
            return ctx[key];
        } else if (globalProperties = appContext.config.globalProperties, (0, $7s0Ms.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($2587789e20bc75b6$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $7s0Ms.EMPTY_OBJ) && (0, $7s0Ms.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $7s0Ms.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $7s0Ms.EMPTY_OBJ) && key[0] !== "$" && (0, $7s0Ms.hasOwn)(data, key) || $2587789e20bc75b6$var$hasSetupBinding(setupState, key) || (0, $7s0Ms.hasOwn)(props, key) || (0, $7s0Ms.hasOwn)(ctx, key) || (0, $7s0Ms.hasOwn)($2587789e20bc75b6$var$getPublicPropertiesMap(), key) || (0, $7s0Ms.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $7s0Ms.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $2587789e20bc75b6$var$target;
const $2587789e20bc75b6$var$RuntimeCompiledPublicInstanceProxyHandlers = /*@__PURE__*/ (0, $7s0Ms.extend)({}, $2587789e20bc75b6$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $2587789e20bc75b6$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $7s0Ms.isGloballyAllowed)(key);
        return has;
    }
});
function $2587789e20bc75b6$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($2587789e20bc75b6$var$getPublicPropertiesMap()).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$2587789e20bc75b6$var$getPublicPropertiesMap()[key](instance),
            set: (0, $7s0Ms.NOOP)
        });
    });
    return target;
}
function $2587789e20bc75b6$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $7s0Ms.NOOP)
        });
    });
}
function $2587789e20bc75b6$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $SdEQh.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($2587789e20bc75b6$var$isReservedPrefix(key[0])) {
                $2587789e20bc75b6$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $7s0Ms.NOOP)
            });
        }
    });
}
//#endregion
//#region packages/runtime-core/src/apiSetupHelpers.ts
const $2587789e20bc75b6$var$warnRuntimeUsage = (method)=>$2587789e20bc75b6$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $2587789e20bc75b6$export$80b33eababae110e() {
    return null;
}
function $2587789e20bc75b6$export$51ecece22fc17ddc() {
    return null;
}
/**
* Vue `<script setup>` compiler macro for declaring a component's exposed
* instance properties when it is accessed by a parent component via template
* refs.
*
* `<script setup>` components are closed by default - i.e. variables inside
* the `<script setup>` scope is not exposed to parent unless explicitly exposed
* via `defineExpose`.
*
* This is only usable inside `<script setup>`, is compiled away in the
* output and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineexpose}
*/ function $2587789e20bc75b6$export$da25b65ca24b518a(exposed) {}
/**
* Vue `<script setup>` compiler macro for declaring a component's additional
* options. This should be used only for options that cannot be expressed via
* Composition API - e.g. `inheritAttrs`.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineoptions}
*/ function $2587789e20bc75b6$export$77e79129327f3d0d(options) {}
/**
* Vue `<script setup>` compiler macro for providing type hints to IDEs for
* slot name and slot props type checking.
*
* Example usage:
* ```ts
* const slots = defineSlots<{
*   default(props: { msg: string }): any
* }>()
* ```
*
* This is only usable inside `<script setup>`, is compiled away in the
* output and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineslots}
*/ function $2587789e20bc75b6$export$1b3acd4bb805b712() {
    return null;
}
function $2587789e20bc75b6$export$acd55aa037e791bb() {}
/**
* Vue `<script setup>` compiler macro for providing props default values when
* using type-based `defineProps` declaration.
*
* Example usage:
* ```ts
* withDefaults(defineProps<{
*   size?: number
*   labels?: string[]
* }>(), {
*   size: 3,
*   labels: () => ['default label']
* })
* ```
*
* This is only usable inside `<script setup>`, is compiled away in the output
* and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/guide/typescript/composition-api.html#typing-component-props}
*/ function $2587789e20bc75b6$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $2587789e20bc75b6$export$9203a8e84125433c() {
    return $2587789e20bc75b6$var$getContext("useSlots").slots;
}
function $2587789e20bc75b6$export$75e29435042cd2ea() {
    return $2587789e20bc75b6$var$getContext("useAttrs").attrs;
}
function $2587789e20bc75b6$var$getContext(calledFunctionName) {
    const i = $2587789e20bc75b6$var$getCurrentGenericInstance();
    if (i.vapor) return i;
    else {
        const ii = i;
        return ii.setupContext || (ii.setupContext = $2587789e20bc75b6$var$createSetupContext(ii));
    }
}
/**
* @internal
*/ function $2587789e20bc75b6$var$normalizePropsOrEmits(props) {
    return (0, $7s0Ms.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
/**
* Runtime helper for merging default declarations. Imported by compiled code
* only.
* @internal
*/ function $2587789e20bc75b6$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $2587789e20bc75b6$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $7s0Ms.isArray)(opt) || (0, $7s0Ms.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
/**
* Runtime helper for merging model declarations.
* Imported by compiled code only.
* @internal
*/ function $2587789e20bc75b6$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $7s0Ms.isArray)(a) && (0, $7s0Ms.isArray)(b)) return a.concat(b);
    return (0, $7s0Ms.extend)({}, $2587789e20bc75b6$var$normalizePropsOrEmits(a), $2587789e20bc75b6$var$normalizePropsOrEmits(b));
}
/**
* Used to create a proxy for the rest element when destructuring props with
* defineProps().
* @internal
*/ function $2587789e20bc75b6$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
* `<script setup>` helper for persisting the current instance context over
* async/await flows.
*
* `@vue/compiler-sfc` converts the following:
*
* ```ts
* const x = await foo()
* ```
*
* into:
*
* ```ts
* let __temp, __restore
* const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
* ```
* @internal
*/ function $2587789e20bc75b6$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $2587789e20bc75b6$var$getCurrentGenericInstance();
    const inSSRSetup = $2587789e20bc75b6$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $2587789e20bc75b6$export$a5e695a16aa0b6d4(null, void 0);
    if (inSSRSetup) $2587789e20bc75b6$var$setInSSRSetupState(false);
    const restore = ()=>{
        const stoppedScope = ctx && !ctx.scope.active ? ctx.scope : void 0;
        $2587789e20bc75b6$export$a5e695a16aa0b6d4(ctx);
        if (inSSRSetup) $2587789e20bc75b6$var$setInSSRSetupState(true);
        return stoppedScope;
    };
    const cleanup = ()=>{
        $2587789e20bc75b6$export$a5e695a16aa0b6d4(null, void 0);
        if (inSSRSetup) $2587789e20bc75b6$var$setInSSRSetupState(false);
    };
    if ((0, $7s0Ms.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        const stoppedScope = restore();
        Promise.resolve().then(()=>Promise.resolve().then(()=>{
                if (stoppedScope) stoppedScope.reset();
                cleanup();
            }));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            const stoppedScope = restore();
            Promise.resolve().then(()=>{
                if (stoppedScope) stoppedScope.reset();
                cleanup();
            });
        }
    ];
}
//#endregion
//#region packages/runtime-core/src/componentOptions.ts
function $2587789e20bc75b6$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $2587789e20bc75b6$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $2587789e20bc75b6$var$shouldCacheAccess = true;
function $2587789e20bc75b6$var$applyOptions(instance) {
    const options = $2587789e20bc75b6$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $2587789e20bc75b6$var$shouldCacheAccess = false;
    if (options.beforeCreate) $2587789e20bc75b6$var$callHook(options.beforeCreate, instance, "bc");
    const { data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: expose, inheritAttrs: inheritAttrs, components: components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $2587789e20bc75b6$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $7s0Ms.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $7s0Ms.isObject)(data)) ;
        else instance.data = (0, $SdEQh.reactive)(data);
    }
    $2587789e20bc75b6$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $7s0Ms.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $7s0Ms.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $7s0Ms.NOOP);
        const set = !(0, $7s0Ms.isFunction)(opt) && (0, $7s0Ms.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $7s0Ms.NOOP);
        const c = $2587789e20bc75b6$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$2587789e20bc75b6$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $7s0Ms.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $2587789e20bc75b6$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $2587789e20bc75b6$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $7s0Ms.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($2587789e20bc75b6$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($2587789e20bc75b6$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($2587789e20bc75b6$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($2587789e20bc75b6$export$5876c47052fb88b1, updated);
    registerLifecycleHook($2587789e20bc75b6$export$ba52d824b95a2154, activated);
    registerLifecycleHook($2587789e20bc75b6$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($2587789e20bc75b6$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($2587789e20bc75b6$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($2587789e20bc75b6$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($2587789e20bc75b6$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($2587789e20bc75b6$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($2587789e20bc75b6$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $7s0Ms.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $7s0Ms.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $2587789e20bc75b6$export$b9b0eeb564431e5e(instance);
}
function $2587789e20bc75b6$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $7s0Ms.NOOP)) {
    if ((0, $7s0Ms.isArray)(injectOptions)) injectOptions = $2587789e20bc75b6$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $7s0Ms.isObject)(opt)) {
            if ("default" in opt) injected = $2587789e20bc75b6$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $2587789e20bc75b6$export$a976684a0efeb93f(opt.from || key);
        } else injected = $2587789e20bc75b6$export$a976684a0efeb93f(opt);
        if ((0, $SdEQh.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $2587789e20bc75b6$var$callHook(hook, instance, type) {
    $2587789e20bc75b6$export$dae85862a8d94378((0, $7s0Ms.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $2587789e20bc75b6$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $2587789e20bc75b6$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $7s0Ms.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $7s0Ms.isFunction)(handler)) $2587789e20bc75b6$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $7s0Ms.isFunction)(raw)) $2587789e20bc75b6$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $7s0Ms.isObject)(raw)) {
        if ((0, $7s0Ms.isArray)(raw)) raw.forEach((r)=>$2587789e20bc75b6$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $7s0Ms.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $7s0Ms.isFunction)(handler)) $2587789e20bc75b6$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
* Resolve merged options and cache it on the component.
* This is done only once per-component since the merging does not involve
* instances.
*/ function $2587789e20bc75b6$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$2587789e20bc75b6$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $2587789e20bc75b6$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $7s0Ms.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $2587789e20bc75b6$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $2587789e20bc75b6$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$2587789e20bc75b6$var$mergeOptions(to, m, strats, true));
    for(const key in from)if (asMixin && key === "expose") ;
    else {
        const strat = $2587789e20bc75b6$var$internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
    return to;
}
const $2587789e20bc75b6$var$internalOptionMergeStrats = {
    data: $2587789e20bc75b6$var$mergeDataFn,
    props: $2587789e20bc75b6$var$mergeEmitsOrPropsOptions,
    emits: $2587789e20bc75b6$var$mergeEmitsOrPropsOptions,
    methods: $2587789e20bc75b6$var$mergeObjectOptions,
    computed: $2587789e20bc75b6$var$mergeObjectOptions,
    beforeCreate: $2587789e20bc75b6$var$mergeAsArray,
    created: $2587789e20bc75b6$var$mergeAsArray,
    beforeMount: $2587789e20bc75b6$var$mergeAsArray,
    mounted: $2587789e20bc75b6$var$mergeAsArray,
    beforeUpdate: $2587789e20bc75b6$var$mergeAsArray,
    updated: $2587789e20bc75b6$var$mergeAsArray,
    beforeDestroy: $2587789e20bc75b6$var$mergeAsArray,
    beforeUnmount: $2587789e20bc75b6$var$mergeAsArray,
    destroyed: $2587789e20bc75b6$var$mergeAsArray,
    unmounted: $2587789e20bc75b6$var$mergeAsArray,
    activated: $2587789e20bc75b6$var$mergeAsArray,
    deactivated: $2587789e20bc75b6$var$mergeAsArray,
    errorCaptured: $2587789e20bc75b6$var$mergeAsArray,
    serverPrefetch: $2587789e20bc75b6$var$mergeAsArray,
    components: $2587789e20bc75b6$var$mergeObjectOptions,
    directives: $2587789e20bc75b6$var$mergeObjectOptions,
    watch: $2587789e20bc75b6$var$mergeWatchOptions,
    provide: $2587789e20bc75b6$var$mergeDataFn,
    inject: $2587789e20bc75b6$var$mergeInject
};
function $2587789e20bc75b6$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $7s0Ms.extend)((0, $7s0Ms.isFunction)(to) ? to.call(this, this) : to, (0, $7s0Ms.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $2587789e20bc75b6$var$mergeInject(to, from) {
    return $2587789e20bc75b6$var$mergeObjectOptions($2587789e20bc75b6$var$normalizeInject(to), $2587789e20bc75b6$var$normalizeInject(from));
}
function $2587789e20bc75b6$var$normalizeInject(raw) {
    if ((0, $7s0Ms.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $2587789e20bc75b6$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $2587789e20bc75b6$var$mergeObjectOptions(to, from) {
    return to ? (0, $7s0Ms.extend)(Object.create(null), to, from) : from;
}
function $2587789e20bc75b6$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $7s0Ms.isArray)(to) && (0, $7s0Ms.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $7s0Ms.extend)(Object.create(null), $2587789e20bc75b6$var$normalizePropsOrEmits(to), $2587789e20bc75b6$var$normalizePropsOrEmits(from !== null && from !== void 0 ? from : {}));
    } else return from;
}
function $2587789e20bc75b6$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $7s0Ms.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $2587789e20bc75b6$var$mergeAsArray(to[key], from[key]);
    return merged;
}
//#endregion
//#region packages/runtime-core/src/apiCreateApp.ts
function $2587789e20bc75b6$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $7s0Ms.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $2587789e20bc75b6$var$uid$1 = 0;
/**
* @internal
*/ function $2587789e20bc75b6$export$20a32069df128d70(mount, unmount, getPublicInstance, render) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $7s0Ms.isFunction)(rootComponent)) rootComponent = (0, $7s0Ms.extend)({}, rootComponent);
        if (rootProps != null && !(0, $7s0Ms.isObject)(rootProps)) rootProps = null;
        const context = $2587789e20bc75b6$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $2587789e20bc75b6$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $2587789e20bc75b6$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $7s0Ms.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $7s0Ms.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const instance = mount(app, rootContainer, isHydrate, namespace);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = instance;
                        $2587789e20bc75b6$var$devtoolsInitApp(app, $2587789e20bc75b6$export$83d89fbfd8236492);
                    }
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    return getPublicInstance(instance);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $2587789e20bc75b6$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    unmount(app);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $2587789e20bc75b6$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $2587789e20bc75b6$var$currentApp;
                $2587789e20bc75b6$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $2587789e20bc75b6$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
/**
* @internal Used to identify the current app when using `inject()` within
* `app.runWithContext()`.
*/ let $2587789e20bc75b6$var$currentApp = null;
//#endregion
//#region packages/runtime-core/src/helpers/useModel.ts
function $2587789e20bc75b6$export$fb78bd113157f1a1(props, name, options = (0, $7s0Ms.EMPTY_OBJ)) {
    const i = $2587789e20bc75b6$var$getCurrentGenericInstance();
    const camelizedName = (0, $7s0Ms.camelize)(name);
    const hyphenatedName = (0, $7s0Ms.hyphenate)(name);
    const modifiers = $2587789e20bc75b6$var$getModelModifiers(props, camelizedName, $2587789e20bc75b6$export$ea66d7ac9b8996b6);
    const res = (0, $SdEQh.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $7s0Ms.EMPTY_OBJ);
        let prevEmittedValue;
        $2587789e20bc75b6$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $7s0Ms.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $7s0Ms.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $7s0Ms.EMPTY_OBJ) && (0, $7s0Ms.hasChanged)(value, prevSetValue))) return;
                let rawPropKeys;
                let parentPassedModelValue = false;
                let parentPassedModelUpdater = false;
                if (i.rawKeys) rawPropKeys = i.rawKeys();
                else {
                    const rawProps = i.vnode.props;
                    rawPropKeys = rawProps && Object.keys(rawProps);
                }
                if (rawPropKeys) {
                    for (const key of rawPropKeys)if (key === name || key === camelizedName || key === hyphenatedName) parentPassedModelValue = true;
                    else if (key === `onUpdate:${name}` || key === `onUpdate:${camelizedName}` || key === `onUpdate:${hyphenatedName}`) parentPassedModelUpdater = true;
                }
                const hasVModel = parentPassedModelValue && parentPassedModelUpdater;
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $7s0Ms.hasChanged)(value, prevSetValue) && ((0, $7s0Ms.hasChanged)(value, emittedValue) && !(0, $7s0Ms.hasChanged)(emittedValue, prevEmittedValue) || hasVModel && prevSetValue !== (0, $7s0Ms.EMPTY_OBJ) && !(0, $7s0Ms.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i = 0;
        return {
            next () {
                if (i < 2) return {
                    value: i++ ? modifiers || (0, $7s0Ms.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $2587789e20bc75b6$var$getModelModifiers = (props, modelName, getter)=>{
    return getter(props, (0, $7s0Ms.getModifierPropName)(modelName)) || getter(props, `${(0, $7s0Ms.camelize)(modelName)}Modifiers`) || getter(props, `${(0, $7s0Ms.hyphenate)(modelName)}Modifiers`);
};
//#endregion
//#region packages/runtime-core/src/componentEmits.ts
function $2587789e20bc75b6$var$emit(instance, event, ...rawArgs) {
    return $2587789e20bc75b6$export$15f4c4319e4e597d(instance, instance.vnode.props || (0, $7s0Ms.EMPTY_OBJ), $2587789e20bc75b6$export$ea66d7ac9b8996b6, event, ...rawArgs);
}
/**
* @internal for vapor only
*/ function $2587789e20bc75b6$export$15f4c4319e4e597d(instance, props, getter, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $2587789e20bc75b6$var$getModelModifiers(props, event.slice(7), getter);
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $7s0Ms.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $7s0Ms.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = getter(props, handlerName = (0, $7s0Ms.toHandlerKey)(event)) || getter(props, handlerName = (0, $7s0Ms.toHandlerKey)((0, $7s0Ms.camelize)(event)));
    if (!handler && isModelListener) handler = getter(props, handlerName = (0, $7s0Ms.toHandlerKey)((0, $7s0Ms.hyphenate)(event)));
    if (handler) $2587789e20bc75b6$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = getter(props, handlerName + `Once`);
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $2587789e20bc75b6$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $2587789e20bc75b6$export$ea66d7ac9b8996b6(props, key) {
    return props[key];
}
const $2587789e20bc75b6$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $2587789e20bc75b6$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $2587789e20bc75b6$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $7s0Ms.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $2587789e20bc75b6$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $7s0Ms.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $7s0Ms.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $7s0Ms.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $7s0Ms.extend)(normalized, raw);
    if ((0, $7s0Ms.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
/**
* Check if an incoming prop key is a declared emit event listener.
* e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
* both considered matched listeners.
*
* @internal for vapor only
*/ function $2587789e20bc75b6$export$bd525f5264ebdc33(options, key) {
    if (!options || !(0, $7s0Ms.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $7s0Ms.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $7s0Ms.hasOwn)(options, (0, $7s0Ms.hyphenate)(key)) || (0, $7s0Ms.hasOwn)(options, key);
}
//#endregion
//#region packages/runtime-core/src/componentRenderUtils.ts
/**
* dev only flag to track whether $attrs was used during render.
* If $attrs was used during render then the warning for failed attrs
* fallthrough can be suppressed.
*/ let $2587789e20bc75b6$var$accessedAttrs = false;
function $2587789e20bc75b6$var$markAttrsAccessed() {
    $2587789e20bc75b6$var$accessedAttrs = true;
}
function $2587789e20bc75b6$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $2587789e20bc75b6$export$824c074beef4c41b(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $2587789e20bc75b6$export$a0e1465ad202d515(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render = Component;
            result = $2587789e20bc75b6$export$a0e1465ad202d515(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $2587789e20bc75b6$export$f83a77e4c783b3a2(attrs);
        }
    } catch (err) {
        $2587789e20bc75b6$var$blockStack.length = 0;
        $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, 1);
        result = $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $7s0Ms.isModelListener))) fallthroughAttrs = $2587789e20bc75b6$export$316c7e1847985a1d(fallthroughAttrs, propsOptions);
                root = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $2587789e20bc75b6$var$isTeleport(root.type) ? $2587789e20bc75b6$var$getInnerChild$1(root) || root : root;
        $2587789e20bc75b6$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $2587789e20bc75b6$export$824c074beef4c41b(prev);
    return result;
}
/**
* dev only
* In dev mode, template root level comments are rendered, which turns the
* template into a fragment root, but we need to locate the single element
* root for attrs and scope id processing.
*/ const $2587789e20bc75b6$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $2587789e20bc75b6$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $2587789e20bc75b6$export$a0e1465ad202d515(childRoot),
        setRoot
    ];
};
/**
* Dev only
*/ function $2587789e20bc75b6$export$b82d7003bc568535(attrs) {
    const allAttrs = Object.keys(attrs);
    const eventAttrs = [];
    const extraAttrs = [];
    for(let i = 0, l = allAttrs.length; i < l; i++){
        const key = allAttrs[i];
        if ((0, $7s0Ms.isOn)(key)) {
            if (!(0, $7s0Ms.isModelListener)(key)) eventAttrs.push(key[2].toLowerCase() + key.slice(3));
        } else extraAttrs.push(key);
    }
    if (extraAttrs.length) $2587789e20bc75b6$var$warn$1(`Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`);
    if (eventAttrs.length) $2587789e20bc75b6$var$warn$1(`Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
}
function $2587789e20bc75b6$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2587789e20bc75b6$export$3868d13f8734ae81(child)) {
            if (child.type !== $2587789e20bc75b6$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $2587789e20bc75b6$export$80ff18eb01272c8e = (key)=>key === "class" || key === "style" || (0, $7s0Ms.isOn)(key);
const $2587789e20bc75b6$export$f83a77e4c783b3a2 = (attrs)=>{
    let res;
    for(const key in attrs)if ($2587789e20bc75b6$export$80ff18eb01272c8e(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $2587789e20bc75b6$export$316c7e1847985a1d = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $7s0Ms.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $2587789e20bc75b6$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $2587789e20bc75b6$export$4d299b491347818a;
};
function $2587789e20bc75b6$export$225fd36bef19d8c6(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $2587789e20bc75b6$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($2587789e20bc75b6$var$hasPropValueChanged(nextProps, prevProps, key) && !$2587789e20bc75b6$export$bd525f5264ebdc33(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $2587789e20bc75b6$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $2587789e20bc75b6$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($2587789e20bc75b6$var$hasPropValueChanged(nextProps, prevProps, key) && !$2587789e20bc75b6$export$bd525f5264ebdc33(emitsOptions, key)) return true;
    }
    return false;
}
function $2587789e20bc75b6$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $7s0Ms.isObject)(nextProp) && (0, $7s0Ms.isObject)(prevProp)) return !(0, $7s0Ms.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $2587789e20bc75b6$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent && !parent.vapor){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
//#endregion
//#region packages/runtime-core/src/internalObject.ts
/**
* Used during vnode props/slots normalization to check if the vnode props/slots
* are the internal attrs / slots object of a component via
* `Object.getPrototypeOf`. This is more performant than defining a
* non-enumerable property. (one of the optimizations done for ssr-benchmark)
*/ const $2587789e20bc75b6$var$internalObjectProto = {};
const $2587789e20bc75b6$export$1fa0ca5a6375b7 = ()=>Object.create($2587789e20bc75b6$var$internalObjectProto);
const $2587789e20bc75b6$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $2587789e20bc75b6$var$internalObjectProto;
//#endregion
//#region packages/runtime-core/src/componentProps.ts
function $2587789e20bc75b6$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = instance.props = {};
    const attrs = $2587789e20bc75b6$export$1fa0ca5a6375b7();
    instance.propsDefaults = Object.create(null);
    $2587789e20bc75b6$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $SdEQh.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $2587789e20bc75b6$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $2587789e20bc75b6$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $SdEQh.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if ((optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($2587789e20bc75b6$export$bd525f5264ebdc33(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $7s0Ms.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $7s0Ms.camelize)(key);
                        props[camelizedKey] = $2587789e20bc75b6$export$ba06f8f07b4aa3a7(options, camelizedKey, value, instance, $2587789e20bc75b6$var$baseResolveDefault);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($2587789e20bc75b6$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || !(0, $7s0Ms.hasOwn)(rawProps, key) && ((kebabKey = (0, $7s0Ms.hyphenate)(key)) === key || !(0, $7s0Ms.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) props[key] = $2587789e20bc75b6$export$ba06f8f07b4aa3a7(options, key, void 0, instance, $2587789e20bc75b6$var$baseResolveDefault, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $7s0Ms.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $SdEQh.trigger)(instance.attrs, "set", "");
}
function $2587789e20bc75b6$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $7s0Ms.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $7s0Ms.hasOwn)(options, camelKey = (0, $7s0Ms.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$2587789e20bc75b6$export$bd525f5264ebdc33(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const castValues = rawCastValues || (0, $7s0Ms.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $2587789e20bc75b6$export$ba06f8f07b4aa3a7(options, key, castValues[key], instance, $2587789e20bc75b6$var$baseResolveDefault, !(0, $7s0Ms.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
/**
* @internal for runtime-vapor
*/ function $2587789e20bc75b6$export$ba06f8f07b4aa3a7(options, key, value, instance, resolveDefault, isAbsent = false) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $7s0Ms.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $7s0Ms.isFunction)(defaultValue)) {
                const cachedDefaults = instance.propsDefaults || (instance.propsDefaults = {});
                if ((0, $7s0Ms.hasOwn)(cachedDefaults, key)) value = cachedDefaults[key];
                else value = cachedDefaults[key] = resolveDefault(defaultValue, instance, key);
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1] && (value === "" || value === (0, $7s0Ms.hyphenate)(key))) value = true;
        }
    }
    return value;
}
/**
* runtime-dom-specific default resolving logic
*/ function $2587789e20bc75b6$var$baseResolveDefault(factory, instance, key) {
    let value;
    const prev = $2587789e20bc75b6$export$a5e695a16aa0b6d4(instance);
    const props = (0, $SdEQh.toRaw)(instance.props);
    value = factory.call(null, props);
    $2587789e20bc75b6$export$95e96a1fb881e3e7(prev);
    return value;
}
const $2587789e20bc75b6$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $2587789e20bc75b6$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $2587789e20bc75b6$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $7s0Ms.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $2587789e20bc75b6$var$normalizePropsOptions(raw, appContext, true);
            (0, $7s0Ms.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $7s0Ms.isObject)(comp)) cache.set(comp, (0, $7s0Ms.EMPTY_ARR));
        return 0, $7s0Ms.EMPTY_ARR;
    }
    $2587789e20bc75b6$export$f0eb979c68386821(raw, normalized, needCastKeys);
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $7s0Ms.isObject)(comp)) cache.set(comp, res);
    return res;
}
/**
* @internal for runtime-vapor only
*/ function $2587789e20bc75b6$export$f0eb979c68386821(raw, normalized, needCastKeys) {
    if ((0, $7s0Ms.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $7s0Ms.camelize)(raw[i]);
        if ($2587789e20bc75b6$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $7s0Ms.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $7s0Ms.camelize)(key);
        if ($2587789e20bc75b6$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $7s0Ms.isArray)(opt) || (0, $7s0Ms.isFunction)(opt) ? {
                type: opt
            } : (0, $7s0Ms.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $7s0Ms.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $7s0Ms.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $7s0Ms.isFunction)(propType) && propType.name === "Boolean";
            prop[0] = shouldCast;
            prop[1] = shouldCastTrue;
            if (shouldCast || (0, $7s0Ms.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
}
function $2587789e20bc75b6$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $7s0Ms.isReservedProp)(key)) return true;
    return false;
}
function $2587789e20bc75b6$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") return ctor.constructor && ctor.constructor.name || "";
    return "";
}
/**
* dev only
* @internal
*/ function $2587789e20bc75b6$export$45855e0dd982478b(rawProps, resolvedProps, options) {
    resolvedProps = (0, $SdEQh.toRaw)(resolvedProps);
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $7s0Ms.camelize)(key));
    for(const key in options){
        const opt = options[key];
        if (opt != null) $2587789e20bc75b6$var$validateProp(key, resolvedProps[key], opt, resolvedProps, !camelizePropsKey.includes(key));
    }
}
/**
* dev only
*/ function $2587789e20bc75b6$var$validateProp(key, value, propOptions, resolvedProps, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = propOptions;
    if (required && isAbsent) {
        $2587789e20bc75b6$var$warn$1("Missing required prop: \"" + key + "\"");
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $7s0Ms.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $2587789e20bc75b6$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $2587789e20bc75b6$var$warn$1($2587789e20bc75b6$var$getInvalidTypeMessage(key, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, resolvedProps)) $2587789e20bc75b6$var$warn$1("Invalid prop: custom validator check failed for prop \"" + key + "\".");
}
const $2587789e20bc75b6$var$isSimpleType = /*@__PURE__*/ (0, $7s0Ms.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
* dev only
*/ function $2587789e20bc75b6$var$assertType(value, type) {
    let valid;
    const expectedType = $2587789e20bc75b6$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($2587789e20bc75b6$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $7s0Ms.isObject)(value);
    else if (expectedType === "Array") valid = (0, $7s0Ms.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
* dev only
*/ function $2587789e20bc75b6$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $7s0Ms.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $7s0Ms.toRawType)(value);
    const expectedValue = $2587789e20bc75b6$var$styleValue(value, expectedType);
    const receivedValue = $2587789e20bc75b6$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $2587789e20bc75b6$var$isExplicable(expectedType) && $2587789e20bc75b6$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($2587789e20bc75b6$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
* dev only
*/ function $2587789e20bc75b6$var$styleValue(value, type) {
    if ((0, $7s0Ms.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
/**
* dev only
*/ function $2587789e20bc75b6$var$isExplicable(type) {
    return [
        "string",
        "number",
        "boolean"
    ].some((elem)=>type.toLowerCase() === elem);
}
/**
* dev only
*/ function $2587789e20bc75b6$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
//#endregion
//#region packages/runtime-core/src/componentSlots.ts
const $2587789e20bc75b6$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $2587789e20bc75b6$var$normalizeSlotValue = (value)=>(0, $7s0Ms.isArray)(value) ? value.map($2587789e20bc75b6$export$a0e1465ad202d515) : [
        $2587789e20bc75b6$export$a0e1465ad202d515(value)
    ];
const $2587789e20bc75b6$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $2587789e20bc75b6$export$694b237e827a3d23((...args)=>{
        return $2587789e20bc75b6$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $2587789e20bc75b6$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($2587789e20bc75b6$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $7s0Ms.isFunction)(value)) slots[key] = $2587789e20bc75b6$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $2587789e20bc75b6$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $2587789e20bc75b6$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $2587789e20bc75b6$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $2587789e20bc75b6$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$2587789e20bc75b6$var$isInternalKey(key)) slots[key] = children[key];
};
const $2587789e20bc75b6$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $2587789e20bc75b6$export$1fa0ca5a6375b7();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $2587789e20bc75b6$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $7s0Ms.def)(slots, "_", type, true);
        } else $2587789e20bc75b6$var$normalizeObjectSlots(children, slots, instance);
    } else if (children) $2587789e20bc75b6$var$normalizeVNodeSlots(instance, children);
};
const $2587789e20bc75b6$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $7s0Ms.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $2587789e20bc75b6$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $2587789e20bc75b6$var$normalizeObjectSlots(children, slots, instance);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $2587789e20bc75b6$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$2587789e20bc75b6$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
//#endregion
//#region packages/runtime-core/src/profiling.ts
let $2587789e20bc75b6$var$supported;
let $2587789e20bc75b6$var$perf;
let $2587789e20bc75b6$var$cachedNow = 0;
const $2587789e20bc75b6$var$p = /*@__PURE__*/ Promise.resolve();
const $2587789e20bc75b6$var$getNow = ()=>$2587789e20bc75b6$var$cachedNow || ($2587789e20bc75b6$var$p.then(()=>$2587789e20bc75b6$var$cachedNow = 0), $2587789e20bc75b6$var$cachedNow = $2587789e20bc75b6$var$isSupported() ? $2587789e20bc75b6$var$perf.now() : Date.now());
/**
* @internal
*/ function $2587789e20bc75b6$export$b62aa2130c86b59b(instance, type) {
    if (instance.appContext.config.performance && $2587789e20bc75b6$var$isSupported()) $2587789e20bc75b6$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsPerfStart(instance, type, $2587789e20bc75b6$var$getNow());
}
/**
* @internal
*/ function $2587789e20bc75b6$export$97a67d1a5c124236(instance, type) {
    if (instance.appContext.config.performance && $2587789e20bc75b6$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$2587789e20bc75b6$var$formatComponentName(instance, instance.type)}> ${type}`;
        $2587789e20bc75b6$var$perf.mark(endTag);
        $2587789e20bc75b6$var$perf.measure(measureName, startTag, endTag);
        $2587789e20bc75b6$var$perf.clearMeasures(measureName);
        $2587789e20bc75b6$var$perf.clearMarks(startTag);
        $2587789e20bc75b6$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsPerfEnd(instance, type, $2587789e20bc75b6$var$getNow());
}
function $2587789e20bc75b6$var$isSupported() {
    if ($2587789e20bc75b6$var$supported !== void 0) return $2587789e20bc75b6$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2587789e20bc75b6$var$supported = true;
        $2587789e20bc75b6$var$perf = window.performance;
    } else $2587789e20bc75b6$var$supported = false;
    return $2587789e20bc75b6$var$supported;
}
//#endregion
//#region packages/runtime-core/src/featureFlags.ts
let $2587789e20bc75b6$var$initialized = false;
/**
* This is only called in esm-bundler builds.
* It is called when a renderer is created, in `baseCreateRenderer` so that
* importing runtime-core is side-effects free.
*/ function $2587789e20bc75b6$export$f9d0db67c92b2ab2() {
    if ($2587789e20bc75b6$var$initialized) return;
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $7s0Ms.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $7s0Ms.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $7s0Ms.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    $2587789e20bc75b6$var$initialized = true;
}
//#endregion
//#region packages/runtime-core/src/renderer.ts
const $2587789e20bc75b6$export$be204faa7b4ee90a = {
    "ENTER": 0,
    "0": "ENTER",
    "LEAVE": 1,
    "1": "LEAVE",
    "REORDER": 2,
    "2": "REORDER"
};
const $2587789e20bc75b6$export$51ec8e020844a97a = $2587789e20bc75b6$var$queueEffectWithSuspense;
/**
* The createRenderer function accepts two generic arguments:
* HostNode and HostElement, corresponding to Node and Element types in the
* host environment. For example, for runtime-dom, HostNode would be the DOM
* `Node` interface and HostElement would be the DOM `Element` interface.
*
* Custom renderers can pass in the platform specific types like this:
*
* ``` js
* const { render, createApp } = createRenderer<Node, Element>({
*   patchProp,
*   ...nodeOps
* })
* ```
*/ function $2587789e20bc75b6$export$53ae2f996c64e9a(options) {
    return $2587789e20bc75b6$var$baseCreateRenderer(options);
}
function $2587789e20bc75b6$export$200524cf0d997ff0(options) {
    return $2587789e20bc75b6$var$baseCreateRenderer(options, $2587789e20bc75b6$var$createHydrationFunctions);
}
function $2587789e20bc75b6$var$baseCreateRenderer(options, createHydrationFns) {
    $2587789e20bc75b6$export$f9d0db67c92b2ab2();
    const target = (0, $7s0Ms.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $7s0Ms.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$2587789e20bc75b6$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
            if (n2.dynamicChildren === (0, $7s0Ms.EMPTY_ARR)) n2.dynamicChildren = [];
            n2.dynamicChildren.hasOnce = true;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $2587789e20bc75b6$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $2587789e20bc75b6$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $2587789e20bc75b6$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $2587789e20bc75b6$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            case $2587789e20bc75b6$export$c7c4a6890f1c1342:
                $2587789e20bc75b6$var$getVaporInterface(parentComponent, n2).slot(n1, n2, container, anchor, parentComponent, parentSuspense, slotScopeIds);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $2587789e20bc75b6$export$4bb192c7cacf928f(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $2587789e20bc75b6$export$4bb192c7cacf928f(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    /**
	* Dev / HMR only
	*/ const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $2587789e20bc75b6$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $7s0Ms.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            /**
			* Special case for setting value on DOM elements:
			* - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
			* - it needs to be forced (#1471)
			* #2353 proposes adding another renderer option to configure this, but
			* the properties affects are so finite it is worth special casing it
			* here to reduce the complexity. (Special casing it also should not
			* affect non-DOM renderers)
			*/ if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $7s0Ms.def)(el, "__vnode", vnode, true);
            (0, $7s0Ms.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
        if (transition) $2587789e20bc75b6$export$b65fa8a64a2e2d16(el, transition, ()=>hostInsert(el, container, anchor), parentSuspense);
        else hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || dirs) {
            const isHmr = false;
            $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                let prev;
                vnodeHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                dirs && $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "mounted");
            }, void 0, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        const inheritedScopeIds = $2587789e20bc75b6$export$3390f5447109b373(vnode, parentComponent);
        for(let i = 0; i < inheritedScopeIds.length; i++)hostSetScopeId(el, inheritedScopeIds[i]);
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(children[i]) : $2587789e20bc75b6$export$a0e1465ad202d515(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $7s0Ms.EMPTY_OBJ);
        const newProps = n2.props || (0, $7s0Ms.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $2587789e20bc75b6$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (n2.ibu) n2.ibu();
        if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $2587789e20bc75b6$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $2587789e20bc75b6$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $2587789e20bc75b6$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs || n2.iu) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
            vnodeHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            n2.iu && n2.iu();
            dirs && $2587789e20bc75b6$export$91e53aad4f01262(n2, n1, parentComponent, "updated");
        }, void 0, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = oldVNode.el && (oldVNode.type === $2587789e20bc75b6$export$ffb0004e005737fa || !$2587789e20bc75b6$var$isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $7s0Ms.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $7s0Ms.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $7s0Ms.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (n2.key != null || parentComponent && n2 === parentComponent.subTree) $2587789e20bc75b6$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n2.type.__vapor) {
            if (n1 == null) {
                if (n2.shapeFlag & 512) $2587789e20bc75b6$var$getVaporInterface(parentComponent, n2).activate(n2, container, anchor, parentComponent, parentSuspense);
                else {
                    const vnodeBeforeMountHook = !$2587789e20bc75b6$export$4d0901d882427199(n2) && n2.props && n2.props.onVnodeBeforeMount;
                    $2587789e20bc75b6$var$getVaporInterface(parentComponent, n2).mount(n2, container, anchor, parentComponent, parentSuspense, ()=>{
                        if (n2.dirs) {
                            $2587789e20bc75b6$export$91e53aad4f01262(n2, null, parentComponent, "created");
                            $2587789e20bc75b6$export$91e53aad4f01262(n2, null, parentComponent, "beforeMount");
                        }
                    }, ()=>{
                        if (vnodeBeforeMountHook) $2587789e20bc75b6$var$invokeVNodeHook(vnodeBeforeMountHook, parentComponent, n2);
                    });
                    if (n2.dirs) $2587789e20bc75b6$export$51ec8e020844a97a(()=>$2587789e20bc75b6$export$91e53aad4f01262(n2, null, parentComponent, "mounted"), void 0, parentSuspense);
                    const vnodeMountedHook = !$2587789e20bc75b6$export$4d0901d882427199(n2) && n2.props && n2.props.onVnodeMounted;
                    if (vnodeMountedHook) {
                        const scopedVNode = n2;
                        $2587789e20bc75b6$export$51ec8e020844a97a(()=>$2587789e20bc75b6$var$invokeVNodeHook(vnodeMountedHook, parentComponent, scopedVNode), void 0, parentSuspense);
                    }
                }
            } else {
                const shouldUpdate = $2587789e20bc75b6$export$225fd36bef19d8c6(n1, n2, optimized);
                $2587789e20bc75b6$var$getVaporInterface(parentComponent, n2).update(n1, n2, shouldUpdate, ()=>{
                    if (n2.dirs) $2587789e20bc75b6$export$91e53aad4f01262(n2, n1, parentComponent, "beforeUpdate");
                }, ()=>{
                    const vnodeBeforeUpdateHook = n2.props && n2.props.onVnodeBeforeUpdate;
                    if (vnodeBeforeUpdateHook) $2587789e20bc75b6$var$invokeVNodeHook(vnodeBeforeUpdateHook, parentComponent, n2, n1);
                    if (n2.ibu) n2.ibu();
                });
                const vnodeUpdatedHook = n2.props && n2.props.onVnodeUpdated;
                if (shouldUpdate && (vnodeUpdatedHook || n2.dirs || n2.iu)) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                    n2.dirs && $2587789e20bc75b6$export$91e53aad4f01262(n2, n1, parentComponent, "updated");
                    vnodeUpdatedHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeUpdatedHook, parentComponent, n2, n1);
                    n2.iu && n2.iu();
                }, void 0, parentSuspense);
            }
        } else if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $2587789e20bc75b6$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($2587789e20bc75b6$export$a33216a979d8327a(initialVNode)) instance.ctx.renderer = internals;
        $2587789e20bc75b6$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            if (parentSuspense) {
                const hydratedEl = instance.vnode.el;
                parentSuspense.registerDep(instance, (setupResult)=>{
                    const { vnode: vnode } = instance;
                    $2587789e20bc75b6$var$handleSetupResult(instance, setupResult, false);
                    if (hydratedEl) vnode.el = hydratedEl;
                    const placeholder = !hydratedEl && instance.subTree.el;
                    setupRenderEffect(instance, vnode, hostParentNode(hydratedEl || instance.subTree.el), hydratedEl ? null : getNextHostNode(instance.subTree), parentSuspense, namespace, optimized);
                    if (placeholder) {
                        vnode.placeholder = null;
                        hostRemove(placeholder);
                    }
                    $2587789e20bc75b6$var$updateHOCHostEl(instance, vnode.el);
                });
            }
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($2587789e20bc75b6$export$225fd36bef19d8c6(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                n2.el = n1.el;
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.effect.run();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    class SetupRenderEffect extends (0, $SdEQh.ReactiveEffect) {
        constructor(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized){
            const prevScope = (0, $SdEQh.setCurrentScope)(instance.scope);
            super();
            this.instance = instance;
            this.initialVNode = initialVNode;
            this.container = container;
            this.anchor = anchor;
            this.parentSuspense = parentSuspense;
            this.namespace = namespace;
            this.optimized = optimized;
            (0, $SdEQh.setCurrentScope)(prevScope);
            this.job = instance.job = ()=>{
                if (this.dirty) this.run();
            };
            this.job.i = instance;
            var e, e1;
        }
        notify() {
            if (!(this.flags & 256)) {
                const job = this.job;
                $2587789e20bc75b6$export$fba1a0a20887772f(job, job.i.uid);
            }
        }
        fn() {
            const { instance: instance, initialVNode: initialVNode, container: container, anchor: anchor, parentSuspense: parentSuspense, namespace: namespace, optimized: optimized } = this;
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $2587789e20bc75b6$export$4d0901d882427199(initialVNode);
                $2587789e20bc75b6$var$toggleRecurse(instance, false);
                if (bm) (0, $7s0Ms.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $2587789e20bc75b6$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $2587789e20bc75b6$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $2587789e20bc75b6$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (instance.m) $2587789e20bc75b6$export$51ec8e020844a97a(instance.m, void 0, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $2587789e20bc75b6$export$51ec8e020844a97a(()=>$2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), void 0, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && parent.vnode && $2587789e20bc75b6$export$4d0901d882427199(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $2587789e20bc75b6$export$51ec8e020844a97a(instance.a, void 0, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$export$a76a9a73068a1a5e(instance);
                this.initialVNode = this.container = this.anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $2587789e20bc75b6$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                                if (!instance.isUnmounted) instance.update();
                            }, void 0, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $2587789e20bc75b6$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $7s0Ms.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                if (next.ibu) next.ibu();
                $2587789e20bc75b6$var$toggleRecurse(instance, true);
                const nextTree = $2587789e20bc75b6$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, hostParentNode(prevTree.el), getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $2587789e20bc75b6$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $2587789e20bc75b6$export$51ec8e020844a97a(u, void 0, parentSuspense);
                if ((vnodeHook = next.props && next.props.onVnodeUpdated) || next.iu) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                    vnodeHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                    next.iu && next.iu();
                }, void 0, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsComponentUpdated(instance);
            }
        }
    }
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const effect = instance.effect = new SetupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
        instance.update = effect.run.bind(effect);
        $2587789e20bc75b6$var$toggleRecurse(instance, true);
        effect.run();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $2587789e20bc75b6$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $2587789e20bc75b6$var$updateSlots(instance, nextVNode.children, optimized);
        const prevSub = (0, $SdEQh.setActiveSub)();
        $2587789e20bc75b6$var$flushPreFlushCbs(instance);
        (0, $SdEQh.setActiveSub)(prevSub);
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $7s0Ms.EMPTY_ARR);
        c2 = c2 || (0, $7s0Ms.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(c2[i]) : $2587789e20bc75b6$export$a0e1465ad202d515(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(c2[i]) : $2587789e20bc75b6$export$a0e1465ad202d515(c2[i]);
            if ($2587789e20bc75b6$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(c2[e2]) : $2587789e20bc75b6$export$a0e1465ad202d515(c2[e2]);
            if ($2587789e20bc75b6$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(c2[i]) : $2587789e20bc75b6$export$a0e1465ad202d515(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $2587789e20bc75b6$var$cloneIfMounted(c2[i]) : $2587789e20bc75b6$export$a0e1465ad202d515(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $2587789e20bc75b6$var$isSameVNodeType(prevChild, c2[j])) {
                    newIndex = j;
                    break;
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? (0, $7s0Ms.getSequence)(newIndexToOldIndexMap) : (0, $7s0Ms.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? anchorVNode.el || $2587789e20bc75b6$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2, parentComponent);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentComponent, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if ($2587789e20bc75b6$var$isVaporComponent(type) || type === $2587789e20bc75b6$export$c7c4a6890f1c1342) {
            $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).move(vnode, container, anchor, moveType, parentSuspense);
            return;
        }
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType, parentComponent);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals, parentComponent);
            return;
        }
        if (type === $2587789e20bc75b6$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType, parentComponent);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $2587789e20bc75b6$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        if (moveType !== 2 && shapeFlag & 1 && transition) {
            if (moveType === 0) $2587789e20bc75b6$export$b65fa8a64a2e2d16(el, transition, ()=>hostInsert(el, container, anchor), parentSuspense, true);
            else $2587789e20bc75b6$export$6a096a74cfa9e795(el, transition, ()=>{
                if (vnode.ctx.isUnmounted) hostRemove(el);
                else hostInsert(el, container, anchor);
            }, true, true);
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
        if (ref != null) {
            const prevSub = (0, $SdEQh.setActiveSub)();
            $2587789e20bc75b6$export$4bb192c7cacf928f(ref, null, parentSuspense, vnode, true);
            (0, $SdEQh.setActiveSub)(prevSub);
        }
        if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            if ($2587789e20bc75b6$var$isVaporComponent(vnode.type)) $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).deactivate(vnode, parentComponent.ctx.getStorageContainer(), parentSuspense);
            else parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$2587789e20bc75b6$export$4d0901d882427199(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) {
            if ($2587789e20bc75b6$var$isVaporComponent(type)) {
                if (dirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "beforeUnmount");
                $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).unmount(vnode, doRemove, parentSuspense);
                if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || dirs) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
                    dirs && $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "unmounted");
                    vnodeHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                }, void 0, parentSuspense);
                return;
            } else unmountComponent(vnode.component, parentSuspense, doRemove);
        } else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && !dynamicChildren.hasOnce && (type !== $2587789e20bc75b6$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $2587789e20bc75b6$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (type === $2587789e20bc75b6$export$c7c4a6890f1c1342) {
                $2587789e20bc75b6$var$getVaporInterface(parentComponent, vnode).unmount(vnode, doRemove, parentSuspense);
                return;
            }
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $2587789e20bc75b6$export$51ec8e020844a97a(()=>{
            vnodeHook && $2587789e20bc75b6$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $2587789e20bc75b6$export$91e53aad4f01262(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, void 0, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $2587789e20bc75b6$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $2587789e20bc75b6$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
            return;
        }
        if (transition) $2587789e20bc75b6$export$6a096a74cfa9e795(el, transition, ()=>hostRemove(el), !!(vnode.shapeFlag & 1));
        else hostRemove(el);
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, effect: effect, subTree: subTree, um: um, m: m, a: a } = instance;
        $2587789e20bc75b6$export$47f10f11906274f2(m);
        $2587789e20bc75b6$export$47f10f11906274f2(a);
        if (bum) (0, $7s0Ms.invokeArrayFns)(bum);
        scope.stop();
        if (effect) {
            effect.stop();
            unmount(subTree, instance, parentSuspense, doRemove);
        } else if (instance.vnode.el && subTree) {
            subTree.transition = instance.vnode.transition;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $2587789e20bc75b6$export$51ec8e020844a97a(um, void 0, parentSuspense);
        $2587789e20bc75b6$export$51ec8e020844a97a(()=>instance.isUnmounted = true, void 0, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $2587789e20bc75b6$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) {
            if ($2587789e20bc75b6$var$isVaporComponent(vnode.type)) return hostNextSibling(vnode.anchor);
            return getNextHostNode(vnode.component.subTree);
        }
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$2587789e20bc75b6$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        $2587789e20bc75b6$export$3ee27bfcb8f44b9d(instance);
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        umt: unmountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    const mountApp = (app, container, isHydrate, namespace)=>{
        const vnode = app._ceVNode || $2587789e20bc75b6$export$bf5c4cf060303d58(app._component, app._props);
        vnode.appContext = app._context;
        if (namespace === true) namespace = "svg";
        else if (namespace === false) namespace = void 0;
        if (isHydrate && hydrate) hydrate(vnode, container);
        else render(vnode, container, namespace);
        return vnode.component;
    };
    const unmountApp = (app)=>{
        render(null, app._container);
    };
    return {
        render: render,
        hydrate: hydrate,
        hydrateNode: hydrateNode,
        internals: internals,
        createApp: $2587789e20bc75b6$export$20a32069df128d70(mountApp, unmountApp, $2587789e20bc75b6$var$getComponentPublicInstance, render)
    };
}
function $2587789e20bc75b6$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $2587789e20bc75b6$var$toggleRecurse({ effect: effect, job: job, vapor: vapor }, allowed) {
    if (!vapor) {
        if (allowed) {
            effect.flags |= 128;
            job.flags |= 2;
        } else {
            effect.flags &= -129;
            job.flags &= -3;
        }
    }
}
function $2587789e20bc75b6$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
/**
* #1156
* When a component is HMR-enabled, we need to make sure that all static nodes
* inside a block also inherit the DOM element from the previous tree so that
* HMR updates (which are full updates) can retrieve the element for patching.
*
* #2080
* Inside keyed `template` fragment static children, if a fragment is moved,
* the children will always be moved. Therefore, in order to ensure correct move
* position, el should be inherited from previous nodes.
*/ function $2587789e20bc75b6$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $7s0Ms.isArray)(ch1) && (0, $7s0Ms.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $2587789e20bc75b6$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $2587789e20bc75b6$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $2587789e20bc75b6$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $2587789e20bc75b6$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $2587789e20bc75b6$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $2587789e20bc75b6$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree && instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $2587789e20bc75b6$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $2587789e20bc75b6$export$47f10f11906274f2(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 4;
}
function $2587789e20bc75b6$export$b65fa8a64a2e2d16(el, transition, insert, parentSuspense, force = false) {
    if (force && transition.persisted && !el[$2587789e20bc75b6$export$6402c150d41fe6bc]) {
        insert();
        return;
    }
    if (force || $2587789e20bc75b6$var$needTransition(parentSuspense, transition)) {
        transition.beforeEnter(el);
        insert();
        $2587789e20bc75b6$export$51ec8e020844a97a(()=>transition.enter(el), void 0, parentSuspense);
    } else insert();
}
function $2587789e20bc75b6$export$6a096a74cfa9e795(el, transition, remove, isElement = true, force = false) {
    const performRemove = ()=>{
        remove();
        if (transition && (force || !transition.persisted) && transition.afterLeave) transition.afterLeave();
    };
    if (force || isElement && transition && !transition.persisted) {
        const { leave: leave, delayLeave: delayLeave } = transition;
        const performLeave = ()=>{
            const wasLeaving = el._isLeaving || !!el[$2587789e20bc75b6$export$6402c150d41fe6bc];
            if (el._isLeaving && force) el[$2587789e20bc75b6$export$6402c150d41fe6bc](true);
            if (force && transition.persisted && !wasLeaving) remove();
            else leave(el, performRemove);
        };
        if (delayLeave) delayLeave(el, performRemove, performLeave);
        else performLeave();
    } else performRemove();
}
function $2587789e20bc75b6$var$getVaporInterface(instance, vnode) {
    const ctx = instance ? instance.appContext : vnode.appContext;
    const res = ctx && ctx.vapor;
    return res;
}
function $2587789e20bc75b6$var$isVaporComponent(type) {
    return type.__vapor;
}
/**
* shared between vdom and vapor
*/ function $2587789e20bc75b6$export$3390f5447109b373(vnode, parentComponent, includeVaporRootIds = true) {
    const inheritedScopeIds = [];
    let currentParent = parentComponent;
    let currentVNode = vnode;
    while(currentParent){
        let subTree = currentParent.subTree;
        if (!subTree) break;
        if (currentVNode === subTree || $2587789e20bc75b6$var$isSuspense(subTree.type) && (subTree.ssContent === currentVNode || subTree.ssFallback === currentVNode)) {
            const parentVNode = currentParent.vnode;
            if (parentVNode.scopeId) inheritedScopeIds.push(parentVNode.scopeId);
            if (parentVNode.slotScopeIds) inheritedScopeIds.push(...parentVNode.slotScopeIds);
            currentVNode = parentVNode;
            currentParent = currentParent.parent;
        } else break;
    }
    const vaporScopeIds = includeVaporRootIds && currentVNode.vaporScopeIds;
    if (vaporScopeIds) inheritedScopeIds.push(...vaporScopeIds);
    return inheritedScopeIds;
}
function $2587789e20bc75b6$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $2587789e20bc75b6$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
//#endregion
//#region packages/runtime-core/src/components/Suspense.ts
const $2587789e20bc75b6$var$isSuspense = (type)=>type.__isSuspense;
let $2587789e20bc75b6$var$suspenseId = 0;
const $2587789e20bc75b6$export$74bf444e3cd11ea5 = {
    name: "Suspense",
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $2587789e20bc75b6$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback && !parentSuspense.isHydrating) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $2587789e20bc75b6$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $2587789e20bc75b6$var$hydrateSuspense,
    normalize: $2587789e20bc75b6$var$normalizeSuspenseChildren
};
function $2587789e20bc75b6$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $7s0Ms.isFunction)(eventListener)) eventListener();
}
function $2587789e20bc75b6$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $2587789e20bc75b6$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $2587789e20bc75b6$var$triggerEvent(vnode, "onPending");
        $2587789e20bc75b6$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, namespace, slotScopeIds);
        $2587789e20bc75b6$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $2587789e20bc75b6$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($2587789e20bc75b6$var$isSameVNodeType(pendingBranch, newBranch)) {
            suspense.deps++;
            patch(pendingBranch, newBranch, isHydrating ? container : suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            suspense.deps--;
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, namespace, slotScopeIds, optimized);
                    $2587789e20bc75b6$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $2587789e20bc75b6$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            for(let i = 0; i < suspense.effects.length; i++){
                const effect = suspense.effects[i];
                if (effect.flags & 8) $2587789e20bc75b6$export$59536a0199721cab(effect);
            }
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, namespace, slotScopeIds, optimized);
                    $2587789e20bc75b6$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $2587789e20bc75b6$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $2587789e20bc75b6$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $2587789e20bc75b6$var$setActiveBranch(suspense, newBranch);
    } else {
        $2587789e20bc75b6$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $2587789e20bc75b6$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $2587789e20bc75b6$var$hasWarned = false;
function $2587789e20bc75b6$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    /* v8 ignore stop */ const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $2587789e20bc75b6$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $7s0Ms.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $2587789e20bc75b6$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0, parentComponent);
                        $2587789e20bc75b6$export$59536a0199721cab(effects);
                        if (isInFallback && vnode.ssFallback) vnode.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent, suspense, true);
                    if (!delayEnter && isInFallback && vnode.ssFallback) $2587789e20bc75b6$export$51ec8e020844a97a(()=>vnode.ssFallback.el = null, void 0, suspense);
                }
                if (!delayEnter) move(pendingBranch, container, anchor, 0, parentComponent);
            }
            suspense.isFallbackMountPending = false;
            $2587789e20bc75b6$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $2587789e20bc75b6$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspenseId = void 0;
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $2587789e20bc75b6$var$triggerEvent(vnode, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, namespace: namespace } = suspense;
            $2587789e20bc75b6$var$triggerEvent(vnode, "onFallback");
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container, anchor, parentComponent, null, namespace, slotScopeIds, optimized);
                $2587789e20bc75b6$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent, null, true);
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type, parentComponent);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, onResolve) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode && instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $2587789e20bc75b6$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $2587789e20bc75b6$export$a5e695a16aa0b6d4(null, void 0);
                if (hydratedEl && !instance.scope.active) {
                    if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
                    return;
                }
                instance.asyncResolved = true;
                onResolve(asyncSetupResult);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $2587789e20bc75b6$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $2587789e20bc75b6$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $2587789e20bc75b6$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $2587789e20bc75b6$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $2587789e20bc75b6$var$normalizeSuspenseSlot(children.fallback) : $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$4d299b491347818a);
}
function $2587789e20bc75b6$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $7s0Ms.isFunction)(s)) {
        const trackBlock = $2587789e20bc75b6$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $2587789e20bc75b6$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $2587789e20bc75b6$var$currentBlock;
            $2587789e20bc75b6$var$closeBlock();
        }
    }
    if ((0, $7s0Ms.isArray)(s)) {
        const singleChild = $2587789e20bc75b6$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $2587789e20bc75b6$export$a0e1465ad202d515(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $2587789e20bc75b6$var$queueEffectWithSuspense(fn, id, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $7s0Ms.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $2587789e20bc75b6$export$59536a0199721cab(fn, id);
}
function $2587789e20bc75b6$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $2587789e20bc75b6$var$updateHOCHostEl(parentComponent, el);
    }
}
function $2587789e20bc75b6$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
//#endregion
//#region packages/runtime-core/src/vnode.ts
const $2587789e20bc75b6$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $2587789e20bc75b6$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $2587789e20bc75b6$export$4d299b491347818a = Symbol.for("v-cmt");
const $2587789e20bc75b6$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $2587789e20bc75b6$export$c7c4a6890f1c1342 = Symbol.for("v-vps");
const $2587789e20bc75b6$var$blockStack = [];
let $2587789e20bc75b6$var$currentBlock = null;
/**
* Open a block.
* This must be called before `createBlock`. It cannot be part of `createBlock`
* because the children of the block are evaluated before `createBlock` itself
* is called. The generated code typically looks like this:
*
* ```js
* function render() {
*   return (openBlock(),createBlock('div', null, [...]))
* }
* ```
* disableTracking is true when creating a v-for fragment block, since a v-for
* fragment always diffs its children.
*
* @private
*/ function $2587789e20bc75b6$export$e7eaa45e502fe5cc(disableTracking = false) {
    $2587789e20bc75b6$var$blockStack.push($2587789e20bc75b6$var$currentBlock = disableTracking ? null : []);
}
function $2587789e20bc75b6$var$closeBlock() {
    $2587789e20bc75b6$var$blockStack.pop();
    $2587789e20bc75b6$var$currentBlock = $2587789e20bc75b6$var$blockStack[$2587789e20bc75b6$var$blockStack.length - 1] || null;
}
let $2587789e20bc75b6$var$isBlockTreeEnabled = 1;
/**
* Block tracking sometimes needs to be disabled, for example during the
* creation of a tree that needs to be cached by v-once. The compiler generates
* code like this:
*
* ``` js
* _cache[1] || (
*   setBlockTracking(-1, true),
*   _cache[1] = createVNode(...),
*   setBlockTracking(1),
*   _cache[1]
* )
* ```
*
* @private
*/ function $2587789e20bc75b6$export$c20bee82f26f1e27(value, inVOnce = false) {
    $2587789e20bc75b6$var$isBlockTreeEnabled += value;
    if (value < 0 && $2587789e20bc75b6$var$currentBlock && inVOnce) $2587789e20bc75b6$var$currentBlock.hasOnce = true;
}
function $2587789e20bc75b6$var$setupBlock(vnode) {
    vnode.dynamicChildren = $2587789e20bc75b6$var$isBlockTreeEnabled > 0 ? $2587789e20bc75b6$var$currentBlock || (0, $7s0Ms.EMPTY_ARR) : null;
    $2587789e20bc75b6$var$closeBlock();
    if ($2587789e20bc75b6$var$isBlockTreeEnabled > 0 && $2587789e20bc75b6$var$currentBlock) $2587789e20bc75b6$var$currentBlock.push(vnode);
    return vnode;
}
/**
* @private
*/ function $2587789e20bc75b6$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $2587789e20bc75b6$var$setupBlock($2587789e20bc75b6$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
* Create a block root vnode. Takes the same exact arguments as `createVNode`.
* A block root keeps track of dynamic nodes within the block in the
* `dynamicChildren` array.
*
* @private
*/ function $2587789e20bc75b6$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $2587789e20bc75b6$var$setupBlock($2587789e20bc75b6$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $2587789e20bc75b6$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $2587789e20bc75b6$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $2587789e20bc75b6$var$vnodeArgsTransformer;
/**
* Internal API for registering an arguments transform for createVNode
* used for creating stubs in the test-utils
* It is *internal* but needs to be exposed for test-utils to pick up proper
* typings
*/ function $2587789e20bc75b6$export$83beccd3afeeb809(transformer) {
    $2587789e20bc75b6$var$vnodeArgsTransformer = transformer;
}
const $2587789e20bc75b6$var$createVNodeWithArgsTransform = (...args)=>{
    return $2587789e20bc75b6$var$_createVNode(...$2587789e20bc75b6$var$vnodeArgsTransformer ? $2587789e20bc75b6$var$vnodeArgsTransformer(args, $2587789e20bc75b6$var$currentRenderingInstance) : args);
};
const $2587789e20bc75b6$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $2587789e20bc75b6$export$8e5958b67b6795b0 = ({ ref: ref, ref_key: ref_key, ref_for: ref_for }, i = $2587789e20bc75b6$var$currentRenderingInstance)=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $7s0Ms.isString)(ref) || (0, $SdEQh.isRef)(ref) || (0, $7s0Ms.isFunction)(ref) ? {
        i: i,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $2587789e20bc75b6$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $2587789e20bc75b6$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $2587789e20bc75b6$var$normalizeKey(props),
        ref: props && $2587789e20bc75b6$export$8e5958b67b6795b0(props),
        scopeId: $2587789e20bc75b6$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $2587789e20bc75b6$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $2587789e20bc75b6$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $7s0Ms.isString)(children) ? 8 : 16;
    if ($2587789e20bc75b6$var$isBlockTreeEnabled > 0 && !isBlockNode && $2587789e20bc75b6$var$currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) $2587789e20bc75b6$var$currentBlock.push(vnode);
    return vnode;
}
/**
* dev only
* Whether children would actually render something. Empty text and empty
* arrays are ignored, mirroring the compiler's `node.children.length` check
* for `v-html` / `v-text`.
*/ function $2587789e20bc75b6$var$hasContentChildren(children) {
    if ((0, $7s0Ms.isString)(children)) return children !== "";
    if ((0, $7s0Ms.isArray)(children)) return children.length > 0;
    return false;
}
const $2587789e20bc75b6$export$bf5c4cf060303d58 = $2587789e20bc75b6$var$_createVNode;
function $2587789e20bc75b6$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $2587789e20bc75b6$export$7d1f90a35714b16e) type = $2587789e20bc75b6$export$4d299b491347818a;
    if ($2587789e20bc75b6$export$3868d13f8734ae81(type)) {
        const cloned = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $2587789e20bc75b6$var$normalizeChildren(cloned, children);
        if ($2587789e20bc75b6$var$isBlockTreeEnabled > 0 && !isBlockNode && $2587789e20bc75b6$var$currentBlock) {
            if (cloned.shapeFlag & 6) $2587789e20bc75b6$var$currentBlock[$2587789e20bc75b6$var$currentBlock.indexOf(type)] = cloned;
            else $2587789e20bc75b6$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($2587789e20bc75b6$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $2587789e20bc75b6$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $7s0Ms.isString)(klass)) props.class = (0, $7s0Ms.normalizeClass)(klass);
        if ((0, $7s0Ms.isObject)(style)) {
            if ((0, $SdEQh.isProxy)(style) && !(0, $7s0Ms.isArray)(style)) style = (0, $7s0Ms.extend)({}, style);
            props.style = (0, $7s0Ms.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $7s0Ms.isString)(type) ? 1 : $2587789e20bc75b6$var$isSuspense(type) ? 128 : $2587789e20bc75b6$var$isTeleport(type) ? 64 : (0, $7s0Ms.isObject)(type) ? 4 : (0, $7s0Ms.isFunction)(type) ? 2 : 0;
    return $2587789e20bc75b6$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $2587789e20bc75b6$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $SdEQh.isProxy)(props) || $2587789e20bc75b6$var$isInternalObject(props) ? (0, $7s0Ms.extend)({}, props) : props;
}
function $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $2587789e20bc75b6$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $2587789e20bc75b6$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? mergeRef && ref ? (0, $7s0Ms.isArray)(ref) ? ref.concat($2587789e20bc75b6$export$8e5958b67b6795b0(extraProps)) : [
            ref,
            $2587789e20bc75b6$export$8e5958b67b6795b0(extraProps)
        ] : $2587789e20bc75b6$export$8e5958b67b6795b0(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        patchFlag: extraProps && vnode.type !== $2587789e20bc75b6$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce,
        vi: vnode.vi,
        vs: $2587789e20bc75b6$var$cloneVaporSlotMeta(vnode),
        vb: vnode.vb,
        ibu: vnode.ibu,
        iu: vnode.iu,
        cacheIndex: vnode.cacheIndex
    };
    if (transition && cloneTransition) $2587789e20bc75b6$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $2587789e20bc75b6$var$cloneVaporSlotMeta(vnode) {
    const vaporSlot = vnode.vs;
    if (!vaporSlot) return vaporSlot;
    const cloned = {
        slot: vaporSlot.slot,
        fallback: vaporSlot.fallback,
        outletFallback: vaporSlot.outletFallback
    };
    if (vnode.el) {
        cloned.state = vaporSlot.state;
        cloned.ref = vaporSlot.ref;
        cloned.scope = vaporSlot.scope;
    }
    return cloned;
}
/**
* Dev only, for HMR of hoisted vnodes reused in v-for
* https://github.com/vitejs/vite/issues/2022
*/ function $2587789e20bc75b6$var$deepCloneVNode(vnode) {
    const cloned = $2587789e20bc75b6$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $7s0Ms.isArray)(vnode.children)) cloned.children = vnode.children.map($2587789e20bc75b6$var$deepCloneVNode);
    return cloned;
}
/**
* @private
*/ function $2587789e20bc75b6$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$5f1af8db9871e1d6, null, text, flag);
}
/**
* @private
*/ function $2587789e20bc75b6$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
* @private
*/ function $2587789e20bc75b6$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($2587789e20bc75b6$export$e7eaa45e502fe5cc(), $2587789e20bc75b6$export$9f2dfe8048dfb22b($2587789e20bc75b6$export$4d299b491347818a, null, text)) : $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$4d299b491347818a, null, text);
}
function $2587789e20bc75b6$export$a0e1465ad202d515(child) {
    if (child == null || typeof child === "boolean") return $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$4d299b491347818a);
    else if ((0, $7s0Ms.isArray)(child)) return $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$ffb0004e005737fa, null, child.slice());
    else if ($2587789e20bc75b6$export$3868d13f8734ae81(child)) return $2587789e20bc75b6$var$cloneIfMounted(child);
    else return $2587789e20bc75b6$export$bf5c4cf060303d58($2587789e20bc75b6$export$5f1af8db9871e1d6, null, String(child));
}
function $2587789e20bc75b6$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $2587789e20bc75b6$export$ee4f9e12c0a92a1a(child);
}
function $2587789e20bc75b6$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $7s0Ms.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $2587789e20bc75b6$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$2587789e20bc75b6$var$isInternalObject(children)) children._ctx = $2587789e20bc75b6$var$currentRenderingInstance;
            else if (slotFlag === 3 && $2587789e20bc75b6$var$currentRenderingInstance) {
                if ($2587789e20bc75b6$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $7s0Ms.isFunction)(children)) {
        if (shapeFlag & 65) {
            $2587789e20bc75b6$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $2587789e20bc75b6$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $2587789e20bc75b6$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $2587789e20bc75b6$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge)if (key === "class") {
            if (ret.class !== toMerge.class) ret.class = (0, $7s0Ms.normalizeClass)([
                ret.class,
                toMerge.class
            ]);
        } else if (key === "style") ret.style = (0, $7s0Ms.normalizeStyle)([
            ret.style,
            toMerge.style
        ]);
        else if ((0, $7s0Ms.isOn)(key)) {
            const existing = ret[key];
            const incoming = toMerge[key];
            if (incoming && existing !== incoming && !((0, $7s0Ms.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            else if (incoming == null && existing == null && !(0, $7s0Ms.isModelListener)(key)) ret[key] = incoming;
        } else if (key !== "") ret[key] = toMerge[key];
    }
    return ret;
}
function $2587789e20bc75b6$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $2587789e20bc75b6$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
//#endregion
//#region packages/runtime-core/src/componentCurrentInstance.ts
/**
* @internal
*/ let $2587789e20bc75b6$export$5d0c78f02672825 = null;
/**
* @internal
*/ const $2587789e20bc75b6$var$getCurrentGenericInstance = ()=>$2587789e20bc75b6$export$5d0c78f02672825 || $2587789e20bc75b6$var$currentRenderingInstance;
const $2587789e20bc75b6$export$f13e630aa3915748 = ()=>$2587789e20bc75b6$export$5d0c78f02672825 && !$2587789e20bc75b6$export$5d0c78f02672825.vapor ? $2587789e20bc75b6$export$5d0c78f02672825 : $2587789e20bc75b6$var$currentRenderingInstance;
let $2587789e20bc75b6$var$isInSSRComponentSetup = false;
let $2587789e20bc75b6$var$setInSSRSetupState;
/**
* @internal
*/ let $2587789e20bc75b6$export$a1b5a29a1999a394;
{
    const g = (0, $7s0Ms.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $2587789e20bc75b6$export$a1b5a29a1999a394 = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$2587789e20bc75b6$export$5d0c78f02672825 = v1);
    $2587789e20bc75b6$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$2587789e20bc75b6$var$isInSSRComponentSetup = v1);
}const $2587789e20bc75b6$export$a5e695a16aa0b6d4 = (instance, scope = instance !== null ? instance.scope : void 0)=>{
    try {
        return [
            $2587789e20bc75b6$export$5d0c78f02672825,
            (0, $SdEQh.setCurrentScope)(scope)
        ];
    } finally{
        $2587789e20bc75b6$export$a1b5a29a1999a394(instance);
    }
};
/**
* Restores a snapshot returned by {@link setCurrentInstance}. Unlike calling
* `setCurrentInstance(...prev)`, an `undefined` saved scope is restored
* verbatim instead of re-triggering the `instance.scope` default.
* @internal
*/ const $2587789e20bc75b6$export$95e96a1fb881e3e7 = (prev)=>{
    (0, $SdEQh.setCurrentScope)(prev[1]);
    $2587789e20bc75b6$export$a1b5a29a1999a394(prev[0]);
};
const $2587789e20bc75b6$var$internalOptions = [
    "ce",
    "type",
    "uid"
];
/**
* @internal
*/ const $2587789e20bc75b6$export$f94b6c23bf914d02 = (key, silent = false)=>{
    const instance = $2587789e20bc75b6$var$getCurrentGenericInstance();
    if (!instance) return {
        hasInstance: false,
        value: void 0
    };
    if (!$2587789e20bc75b6$var$internalOptions.includes(key)) {
        var k;
        return {
            hasInstance: true,
            value: void 0
        };
    }
    return {
        hasInstance: true,
        value: instance[key]
    };
};
//#endregion
//#region packages/runtime-core/src/component.ts
const $2587789e20bc75b6$var$emptyAppContext = /*@__PURE__*/ $2587789e20bc75b6$var$createAppContext();
let $2587789e20bc75b6$var$uid = 0;
/**
* @internal for vapor
*/ function $2587789e20bc75b6$export$be5627916a199b29() {
    return $2587789e20bc75b6$var$uid++;
}
function $2587789e20bc75b6$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $2587789e20bc75b6$var$emptyAppContext;
    const instance = {
        uid: $2587789e20bc75b6$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new (0, $SdEQh.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: $2587789e20bc75b6$var$normalizePropsOptions(type, appContext),
        emitsOptions: $2587789e20bc75b6$var$normalizeEmitsOptions(type, appContext),
        emit: null,
        emitted: null,
        propsDefaults: null,
        inheritAttrs: type.inheritAttrs,
        ctx: (0, $7s0Ms.EMPTY_OBJ),
        data: (0, $7s0Ms.EMPTY_OBJ),
        props: (0, $7s0Ms.EMPTY_OBJ),
        attrs: (0, $7s0Ms.EMPTY_OBJ),
        slots: (0, $7s0Ms.EMPTY_OBJ),
        refs: (0, $7s0Ms.EMPTY_OBJ),
        setupState: (0, $7s0Ms.EMPTY_OBJ),
        setupContext: null,
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $2587789e20bc75b6$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
/**
* @internal
*/ function $2587789e20bc75b6$export$4fb1f2dc002bb2d3(name, { isNativeTag: isNativeTag }) {
    if ((0, $7s0Ms.isBuiltInTag)(name) || isNativeTag(name)) $2587789e20bc75b6$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $2587789e20bc75b6$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
function $2587789e20bc75b6$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $2587789e20bc75b6$var$setInSSRSetupState(isSSR);
    const { props: props, children: children, vi: vi } = instance.vnode;
    const isStateful = $2587789e20bc75b6$var$isStatefulComponent(instance);
    if (vi) vi(instance);
    else {
        $2587789e20bc75b6$var$initProps(instance, props, isStateful, isSSR);
        $2587789e20bc75b6$var$initSlots(instance, children, optimized || isSSR);
    }
    const setupResult = isStateful ? $2587789e20bc75b6$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $2587789e20bc75b6$var$setInSSRSetupState(false);
    return setupResult;
}
function $2587789e20bc75b6$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $2587789e20bc75b6$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const prevSub = (0, $SdEQh.setActiveSub)();
        const setupContext = instance.setupContext = setup.length > 1 ? $2587789e20bc75b6$var$createSetupContext(instance) : null;
        const prev = $2587789e20bc75b6$export$a5e695a16aa0b6d4(instance);
        const setupResult = $2587789e20bc75b6$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $7s0Ms.isPromise)(setupResult);
        (0, $SdEQh.setActiveSub)(prevSub);
        $2587789e20bc75b6$export$95e96a1fb881e3e7(prev);
        if ((isAsyncSetup || instance.sp) && !$2587789e20bc75b6$export$4d0901d882427199(instance)) $2587789e20bc75b6$export$b9b0eeb564431e5e(instance);
        if (isAsyncSetup) {
            const unsetCurrentInstance = ()=>{
                $2587789e20bc75b6$export$a5e695a16aa0b6d4(null, void 0);
            };
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $2587789e20bc75b6$var$setInSSRSetupState(true);
                try {
                    $2587789e20bc75b6$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $2587789e20bc75b6$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $2587789e20bc75b6$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $2587789e20bc75b6$var$handleSetupResult(instance, setupResult, isSSR);
    } else $2587789e20bc75b6$var$finishComponentSetup(instance, isSSR);
}
function $2587789e20bc75b6$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $7s0Ms.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $7s0Ms.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $SdEQh.proxyRefs)(setupResult);
    }
    $2587789e20bc75b6$var$finishComponentSetup(instance, isSSR);
}
let $2587789e20bc75b6$var$compile;
let $2587789e20bc75b6$var$installWithProxy;
/**
* For runtime-dom to register the compiler.
* Note the exported method uses any to avoid d.ts relying on the compiler types.
*/ function $2587789e20bc75b6$export$667bb5a67822b941(_compile) {
    $2587789e20bc75b6$var$compile = _compile;
    $2587789e20bc75b6$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $2587789e20bc75b6$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $2587789e20bc75b6$export$c93a9c496c5211fa = ()=>!$2587789e20bc75b6$var$compile;
function $2587789e20bc75b6$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $2587789e20bc75b6$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $2587789e20bc75b6$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $7s0Ms.extend)((0, $7s0Ms.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $2587789e20bc75b6$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $7s0Ms.NOOP);
        if ($2587789e20bc75b6$var$installWithProxy) $2587789e20bc75b6$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const prevInstance = $2587789e20bc75b6$export$a5e695a16aa0b6d4(instance);
        const prevSub = (0, $SdEQh.setActiveSub)();
        try {
            $2587789e20bc75b6$var$applyOptions(instance);
        } finally{
            (0, $SdEQh.setActiveSub)(prevSub);
            $2587789e20bc75b6$export$95e96a1fb881e3e7(prevInstance);
        }
    }
}
const $2587789e20bc75b6$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $SdEQh.track)(target, "get", "");
        return target[key];
    }
};
/**
* Dev-only
*/ function $2587789e20bc75b6$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $SdEQh.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $2587789e20bc75b6$var$createSetupContext(instance) {
    var event, args, exposed;
    return {
        attrs: new Proxy(instance.attrs, $2587789e20bc75b6$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: (exposed)=>$2587789e20bc75b6$export$9b7f6e342a8cbd38(instance, exposed)
    };
}
/**
* @internal
*/ function $2587789e20bc75b6$export$9b7f6e342a8cbd38(instance, exposed) {
    instance.exposed = exposed || {};
}
function $2587789e20bc75b6$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $SdEQh.proxyRefs)((0, $SdEQh.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else {
                const publicPropertiesMap = $2587789e20bc75b6$var$getPublicPropertiesMap();
                if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
            }
        },
        has (target, key) {
            const publicPropertiesMap = $2587789e20bc75b6$var$getPublicPropertiesMap();
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $2587789e20bc75b6$var$classifyRE = /(?:^|[-_])\w/g;
const $2587789e20bc75b6$var$classify = (str)=>str.replace($2587789e20bc75b6$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $2587789e20bc75b6$export$26727cfcc4d7e0fc(Component, includeInferred = true) {
    return (0, $7s0Ms.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $2587789e20bc75b6$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $2587789e20bc75b6$export$26727cfcc4d7e0fc(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry)if (registry[key] === Component) return key;
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $2587789e20bc75b6$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $2587789e20bc75b6$var$isClassComponent(value) {
    return (0, $7s0Ms.isFunction)(value) && "__vccOpts" in value;
}
//#endregion
//#region packages/runtime-core/src/apiComputed.ts
const $2587789e20bc75b6$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $SdEQh.computed)(getterOrOptions, debugOptions, $2587789e20bc75b6$var$isInSSRComponentSetup);
};
//#endregion
//#region packages/runtime-core/src/h.ts
function $2587789e20bc75b6$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $2587789e20bc75b6$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $7s0Ms.isObject)(propsOrChildren) && !(0, $7s0Ms.isArray)(propsOrChildren)) {
                if ($2587789e20bc75b6$export$3868d13f8734ae81(propsOrChildren)) return $2587789e20bc75b6$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $2587789e20bc75b6$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $2587789e20bc75b6$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $2587789e20bc75b6$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $2587789e20bc75b6$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $2587789e20bc75b6$export$c20bee82f26f1e27(1);
    }
}
//#endregion
//#region packages/runtime-core/src/customFormatter.ts
function $2587789e20bc75b6$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $SdEQh.toRaw)(instance.props)));
        if (instance.setupState !== (0, $7s0Ms.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $7s0Ms.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $SdEQh.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $7s0Ms.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $7s0Ms.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $SdEQh.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $7s0Ms.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $7s0Ms.isArray)(opts) && opts.includes(key) || (0, $7s0Ms.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $SdEQh.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
//#endregion
//#region packages/runtime-core/src/helpers/withMemo.ts
function $2587789e20bc75b6$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $2587789e20bc75b6$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $2587789e20bc75b6$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++)if ((0, $7s0Ms.hasChanged)(prev[i], memo[i])) return false;
    if ($2587789e20bc75b6$var$isBlockTreeEnabled > 0 && $2587789e20bc75b6$var$currentBlock) $2587789e20bc75b6$var$currentBlock.push(cached);
    return true;
}
//#endregion
//#region packages/runtime-core/src/index.ts
const $2587789e20bc75b6$export$83d89fbfd8236492 = "3.6.0-rc.9";
const $2587789e20bc75b6$export$c106dd0671a0fc2d = (0, $7s0Ms.NOOP);
/**
* Runtime error messages. Only exposed in dev or esm builds.
* @internal
*/ const $2587789e20bc75b6$export$795e0ad4a0e2ed30 = $2587789e20bc75b6$var$ErrorTypeStrings$1;
const $2587789e20bc75b6$export$6922d3b3a607469e = $2587789e20bc75b6$var$devtools$1;
const $2587789e20bc75b6$export$b0c258b32c26c785 = $2587789e20bc75b6$var$setDevtoolsHook$1;
/**
* SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
* @internal
*/ const $2587789e20bc75b6$export$a9679033567b336d = {
    createComponentInstance: $2587789e20bc75b6$var$createComponentInstance,
    setupComponent: $2587789e20bc75b6$var$setupComponent,
    renderComponentRoot: $2587789e20bc75b6$var$renderComponentRoot,
    setCurrentRenderingInstance: $2587789e20bc75b6$export$824c074beef4c41b,
    isVNode: $2587789e20bc75b6$export$3868d13f8734ae81,
    normalizeVNode: $2587789e20bc75b6$export$a0e1465ad202d515,
    getComponentPublicInstance: $2587789e20bc75b6$var$getComponentPublicInstance,
    ensureValidVNode: $2587789e20bc75b6$export$9fc41f261330971f,
    pushWarningContext: $2587789e20bc75b6$export$eff0ee073d211f48,
    popWarningContext: $2587789e20bc75b6$export$1f21d88a9fb0fa16
};
/**
* @internal only exposed in compat builds
*/ const $2587789e20bc75b6$export$83cf26e06ea620e1 = null;
/**
* @internal only exposed in compat builds.
*/ const $2587789e20bc75b6$export$dc678eddf276286e = null;
const $2587789e20bc75b6$export$22072a82865312f6 = null;

});
parcelRegister("SdEQh", function(module, exports) {

$parcel$export(module.exports, "setActiveSub", function () { return $0a2fa36771cb1eb1$export$852d57bcb751cc7a; });
$parcel$export(module.exports, "track", function () { return $0a2fa36771cb1eb1$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $0a2fa36771cb1eb1$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $0a2fa36771cb1eb1$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isShallow", function () { return $0a2fa36771cb1eb1$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "isReadonly", function () { return $0a2fa36771cb1eb1$export$92d09b48637741e7; });
$parcel$export(module.exports, "toReactive", function () { return $0a2fa36771cb1eb1$export$45c769cf449a508c; });
$parcel$export(module.exports, "isReactive", function () { return $0a2fa36771cb1eb1$export$352205f445242f02; });
$parcel$export(module.exports, "toReadonly", function () { return $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f; });
$parcel$export(module.exports, "shallowReadArray", function () { return $0a2fa36771cb1eb1$export$5eb48af14254449e; });
$parcel$export(module.exports, "isProxy", function () { return $0a2fa36771cb1eb1$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "isRef", function () { return $0a2fa36771cb1eb1$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $0a2fa36771cb1eb1$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $0a2fa36771cb1eb1$export$90a44edba14e47be; });
$parcel$export(module.exports, "shallowReactive", function () { return $0a2fa36771cb1eb1$export$8d81cefd22d22260; });
$parcel$export(module.exports, "shallowReadonly", function () { return $0a2fa36771cb1eb1$export$7c4b5f2b50f09f6b; });
$parcel$export(module.exports, "markRaw", function () { return $0a2fa36771cb1eb1$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $0a2fa36771cb1eb1$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $0a2fa36771cb1eb1$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "triggerRef", function () { return $0a2fa36771cb1eb1$export$f402f86588575ccc; });
$parcel$export(module.exports, "unref", function () { return $0a2fa36771cb1eb1$export$a239a76781616204; });
$parcel$export(module.exports, "toValue", function () { return $0a2fa36771cb1eb1$export$30bdcc2218aa9458; });
$parcel$export(module.exports, "proxyRefs", function () { return $0a2fa36771cb1eb1$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $0a2fa36771cb1eb1$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $0a2fa36771cb1eb1$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $0a2fa36771cb1eb1$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $0a2fa36771cb1eb1$export$28352bb4dd362521; });
$parcel$export(module.exports, "effect", function () { return $0a2fa36771cb1eb1$export$dc573d8a6576cdb3; });
$parcel$export(module.exports, "stop", function () { return $0a2fa36771cb1eb1$export$fa6813432f753b0d; });
$parcel$export(module.exports, "onEffectCleanup", function () { return $0a2fa36771cb1eb1$export$92b6a62b33d94031; });
$parcel$export(module.exports, "EffectScope", function () { return $0a2fa36771cb1eb1$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $0a2fa36771cb1eb1$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $0a2fa36771cb1eb1$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "setCurrentScope", function () { return $0a2fa36771cb1eb1$export$7c50eaa430038da7; });
$parcel$export(module.exports, "onScopeDispose", function () { return $0a2fa36771cb1eb1$export$a780418acd4762da; });
$parcel$export(module.exports, "computed", function () { return $0a2fa36771cb1eb1$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "TrackOpTypes", function () { return $0a2fa36771cb1eb1$export$2ac2bd0a56e04551; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return $0a2fa36771cb1eb1$export$1e8941c92696a26; });
$parcel$export(module.exports, "getCurrentWatcher", function () { return $0a2fa36771cb1eb1$export$2532f7acfca7c82d; });
$parcel$export(module.exports, "onWatcherCleanup", function () { return $0a2fa36771cb1eb1$export$8ddeeb083684a9d0; });
$parcel$export(module.exports, "WatcherEffect", function () { return $0a2fa36771cb1eb1$export$c243d5028940e63b; });
$parcel$export(module.exports, "traverse", function () { return $0a2fa36771cb1eb1$export$df3f009e3d155b20; });
$parcel$export(module.exports, "watch", function () { return $0a2fa36771cb1eb1$export$3db5d71bdb2d5499; });
/**
  * @vue/reactivity v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $7s0Ms = parcelRequire("7s0Ms");
//#region packages/reactivity/src/debug.ts
const $0a2fa36771cb1eb1$var$triggerEventInfos = [];
function $0a2fa36771cb1eb1$var$onTrack(sub, debugInfo) {
    throw new Error(`Internal error: onTrack should be called only in development.`);
}
function $0a2fa36771cb1eb1$var$onTrigger(sub) {
    throw new Error(`Internal error: onTrigger should be called only in development.`);
}
function $0a2fa36771cb1eb1$var$setupOnTrigger(target) {
    var val;
    throw new Error(`Internal error: setupOnTrigger should be called only in development.`);
}
function $0a2fa36771cb1eb1$var$setupFlagsHandler(target) {
    target._flags = target.flags;
    Object.defineProperty(target, "flags", {
        get () {
            return target._flags;
        },
        set (value) {
            if (!(target._flags & 48) && !!(value & 48)) $0a2fa36771cb1eb1$var$onTrigger(this);
            target._flags = value;
        }
    });
}
//#endregion
//#region packages/reactivity/src/warning.ts
function $0a2fa36771cb1eb1$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
//#endregion
//#region packages/reactivity/src/system.ts
const $0a2fa36771cb1eb1$var$notifyBuffer = [];
let $0a2fa36771cb1eb1$var$batchDepth = 0;
let $0a2fa36771cb1eb1$var$activeSub = void 0;
let $0a2fa36771cb1eb1$var$runDepth = 0;
function $0a2fa36771cb1eb1$var$incRunDepth() {
    ++$0a2fa36771cb1eb1$var$runDepth;
}
function $0a2fa36771cb1eb1$var$decRunDepth() {
    --$0a2fa36771cb1eb1$var$runDepth;
}
let $0a2fa36771cb1eb1$var$globalVersion = 0;
let $0a2fa36771cb1eb1$var$notifyIndex = 0;
let $0a2fa36771cb1eb1$var$notifyBufferLength = 0;
function $0a2fa36771cb1eb1$export$852d57bcb751cc7a(sub) {
    try {
        return $0a2fa36771cb1eb1$var$activeSub;
    } finally{
        $0a2fa36771cb1eb1$var$activeSub = sub;
    }
}
function $0a2fa36771cb1eb1$var$startBatch() {
    ++$0a2fa36771cb1eb1$var$batchDepth;
}
function $0a2fa36771cb1eb1$var$endBatch() {
    if (!--$0a2fa36771cb1eb1$var$batchDepth && $0a2fa36771cb1eb1$var$notifyBufferLength) $0a2fa36771cb1eb1$var$flush();
}
function $0a2fa36771cb1eb1$var$link(dep, sub) {
    const prevDep = sub.depsTail;
    if (prevDep !== void 0 && prevDep.dep === dep) return;
    const nextDep = prevDep !== void 0 ? prevDep.nextDep : sub.deps;
    if (nextDep !== void 0 && nextDep.dep === dep) {
        nextDep.version = $0a2fa36771cb1eb1$var$globalVersion;
        sub.depsTail = nextDep;
        return;
    }
    const prevSub = dep.subsTail;
    if (prevSub !== void 0 && prevSub.version === $0a2fa36771cb1eb1$var$globalVersion && prevSub.sub === sub) return;
    const newLink = sub.depsTail = dep.subsTail = {
        version: $0a2fa36771cb1eb1$var$globalVersion,
        dep: dep,
        sub: sub,
        prevDep: prevDep,
        nextDep: nextDep,
        prevSub: prevSub,
        nextSub: void 0
    };
    if (nextDep !== void 0) nextDep.prevDep = newLink;
    if (prevDep !== void 0) prevDep.nextDep = newLink;
    else sub.deps = newLink;
    if (prevSub !== void 0) prevSub.nextSub = newLink;
    else dep.subs = newLink;
}
function $0a2fa36771cb1eb1$var$unlink(link, sub = link.sub) {
    const dep = link.dep;
    const prevDep = link.prevDep;
    const nextDep = link.nextDep;
    const nextSub = link.nextSub;
    const prevSub = link.prevSub;
    if (nextDep !== void 0) nextDep.prevDep = prevDep;
    else sub.depsTail = prevDep;
    if (prevDep !== void 0) prevDep.nextDep = nextDep;
    else sub.deps = nextDep;
    if (nextSub !== void 0) nextSub.prevSub = prevSub;
    else dep.subsTail = prevSub;
    if (prevSub !== void 0) prevSub.nextSub = nextSub;
    else if ((dep.subs = nextSub) === void 0) {
        let toRemove = dep.deps;
        if (toRemove !== void 0) {
            do toRemove = $0a2fa36771cb1eb1$var$unlink(toRemove, dep);
            while (toRemove !== void 0);
            dep.flags |= 16;
        }
    }
    return nextDep;
}
function $0a2fa36771cb1eb1$var$propagate(link) {
    let next = link.nextSub;
    let stack;
    top: do {
        const sub = link.sub;
        let flags = sub.flags;
        if (flags & 3) {
            if (!(flags & 60)) {
                sub.flags = flags | 32;
                if ($0a2fa36771cb1eb1$var$runDepth) sub.flags |= 8;
            } else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub.flags = flags & -9 | 32;
            else if (!(flags & 48) && $0a2fa36771cb1eb1$var$isValidLink(link, sub)) {
                sub.flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) $0a2fa36771cb1eb1$var$notifyBuffer[$0a2fa36771cb1eb1$var$notifyBufferLength++] = sub;
            if (flags & 1) {
                const subSubs = sub.subs;
                if (subSubs !== void 0) {
                    link = subSubs;
                    if (subSubs.nextSub !== void 0) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = link.nextSub;
                    }
                    continue;
                }
            }
        }
        if ((link = next) !== void 0) {
            next = link.nextSub;
            continue;
        }
        while(stack !== void 0){
            link = stack.value;
            stack = stack.prev;
            if (link !== void 0) {
                next = link.nextSub;
                continue top;
            }
        }
        break;
    }while (true);
}
function $0a2fa36771cb1eb1$var$startTracking(sub) {
    ++$0a2fa36771cb1eb1$var$globalVersion;
    sub.depsTail = void 0;
    sub.flags = sub.flags & -57 | 4;
    return $0a2fa36771cb1eb1$export$852d57bcb751cc7a(sub);
}
function $0a2fa36771cb1eb1$var$endTracking(sub, prevSub) {
    $0a2fa36771cb1eb1$var$activeSub = prevSub;
    const depsTail = sub.depsTail;
    let toRemove = depsTail !== void 0 ? depsTail.nextDep : sub.deps;
    while(toRemove !== void 0)toRemove = $0a2fa36771cb1eb1$var$unlink(toRemove, sub);
    sub.flags &= -5;
}
function $0a2fa36771cb1eb1$var$flush() {
    while($0a2fa36771cb1eb1$var$notifyIndex < $0a2fa36771cb1eb1$var$notifyBufferLength){
        const effect = $0a2fa36771cb1eb1$var$notifyBuffer[$0a2fa36771cb1eb1$var$notifyIndex];
        $0a2fa36771cb1eb1$var$notifyBuffer[$0a2fa36771cb1eb1$var$notifyIndex++] = void 0;
        effect.notify();
    }
    $0a2fa36771cb1eb1$var$notifyIndex = 0;
    $0a2fa36771cb1eb1$var$notifyBufferLength = 0;
}
function $0a2fa36771cb1eb1$var$checkDirty(link, sub) {
    let stack;
    let checkDepth = 0;
    top: do {
        const dep = link.dep;
        const depFlags = dep.flags;
        let dirty = false;
        if (sub.flags & 16) dirty = true;
        else if ((depFlags & 17) === 17) {
            const subs = dep.subs;
            if (dep.update()) {
                if (subs.nextSub !== void 0) $0a2fa36771cb1eb1$var$shallowPropagate(subs);
                dirty = true;
            }
        } else if ((depFlags & 33) === 33) {
            stack = {
                value: link,
                prev: stack
            };
            link = dep.deps;
            sub = dep;
            ++checkDepth;
            continue;
        }
        if (!dirty && link.nextDep !== void 0) {
            link = link.nextDep;
            continue;
        }
        while(checkDepth){
            --checkDepth;
            link = stack.value;
            stack = stack.prev;
            if (dirty) {
                const subs = sub.subs;
                if (sub.update()) {
                    if (subs.nextSub !== void 0) $0a2fa36771cb1eb1$var$shallowPropagate(subs);
                    sub = link.sub;
                    continue;
                }
            } else sub.flags &= -33;
            sub = link.sub;
            if (link.nextDep !== void 0) {
                link = link.nextDep;
                continue top;
            }
            dirty = false;
        }
        return dirty && !!sub.flags;
    }while (true);
}
function $0a2fa36771cb1eb1$var$shallowPropagate(link) {
    do {
        const sub = link.sub;
        const nextSub = link.nextSub;
        const subFlags = sub.flags;
        if ((subFlags & 48) === 32) sub.flags = subFlags | 16;
        link = nextSub;
    }while (link !== void 0);
}
function $0a2fa36771cb1eb1$var$isValidLink(checkLink, sub) {
    let link = sub.depsTail;
    while(link !== void 0){
        if (link === checkLink) return true;
        link = link.prevDep;
    }
    return false;
}
//#endregion
//#region packages/reactivity/src/dep.ts
var $0a2fa36771cb1eb1$var$Dep = class {
    constructor(map, key){
        this.map = map;
        this.key = key;
        this._subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
    }
    get subs() {
        return this._subs;
    }
    set subs(value) {
        this._subs = value;
        if (value === void 0) this.map.delete(this.key);
    }
};
const $0a2fa36771cb1eb1$var$targetMap = /* @__PURE__ */ new WeakMap();
const $0a2fa36771cb1eb1$export$3c41b1a4e06acc14 = Symbol("");
const $0a2fa36771cb1eb1$export$49093fa1cddcb78d = Symbol("");
const $0a2fa36771cb1eb1$export$4f926f0baab682cd = Symbol("");
/**
* Tracks access to a reactive property.
*
* This will check which effect is running at the moment and record it as dep
* which records all effects that depend on the reactive property.
*
* @param target - Object holding the reactive property.
* @param type - Defines the type of access to the reactive property.
* @param key - Identifier of the reactive property to track.
*/ function $0a2fa36771cb1eb1$export$6b2a7d5132615086(target, type, key) {
    if ($0a2fa36771cb1eb1$var$activeSub !== void 0) {
        let depsMap = $0a2fa36771cb1eb1$var$targetMap.get(target);
        if (!depsMap) $0a2fa36771cb1eb1$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = new $0a2fa36771cb1eb1$var$Dep(depsMap, key));
        $0a2fa36771cb1eb1$var$link(dep, $0a2fa36771cb1eb1$var$activeSub);
    }
}
/**
* Finds all deps associated with the target (or a specific property) and
* triggers the effects stored within.
*
* @param target - The reactive object.
* @param type - Defines the type of the operation that needs to trigger effects.
* @param key - Can be used to target a specific reactive property in the target object.
*/ function $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $0a2fa36771cb1eb1$var$targetMap.get(target);
    if (!depsMap) return;
    const run = (dep)=>{
        if (dep !== void 0 && dep.subs !== void 0) {
            $0a2fa36771cb1eb1$var$propagate(dep.subs);
            $0a2fa36771cb1eb1$var$shallowPropagate(dep.subs);
        }
    };
    $0a2fa36771cb1eb1$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $7s0Ms.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $7s0Ms.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key)=>{
                if (key === "length" || key === $0a2fa36771cb1eb1$export$4f926f0baab682cd || !(0, $7s0Ms.isSymbol)(key) && key >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($0a2fa36771cb1eb1$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($0a2fa36771cb1eb1$export$3c41b1a4e06acc14));
                        if ((0, $7s0Ms.isMap)(target)) run(depsMap.get($0a2fa36771cb1eb1$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($0a2fa36771cb1eb1$export$3c41b1a4e06acc14));
                        if ((0, $7s0Ms.isMap)(target)) run(depsMap.get($0a2fa36771cb1eb1$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $7s0Ms.isMap)(target)) run(depsMap.get($0a2fa36771cb1eb1$export$3c41b1a4e06acc14));
            }
        }
    }
    $0a2fa36771cb1eb1$var$endBatch();
}
function $0a2fa36771cb1eb1$var$getDepFromReactive(object, key) {
    const depMap = $0a2fa36771cb1eb1$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
//#endregion
//#region packages/reactivity/src/arrayInstrumentations.ts
/**
* Track array iteration and return:
* - if input is reactive: a cloned raw array with reactive values
* - if input is readonly: a cloned raw array with readonly values, preserving
*   reactivity
* - if input is raw or shallow: the original raw array
*/ function $0a2fa36771cb1eb1$export$1544eab4943788e4(array) {
    const raw = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $0a2fa36771cb1eb1$export$6b2a7d5132615086(raw, "iterate", $0a2fa36771cb1eb1$export$4f926f0baab682cd);
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(array)) return raw;
    if (!/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(array)) return raw.map($0a2fa36771cb1eb1$export$45c769cf449a508c);
    return /* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(array) ? raw.map((item)=>$0a2fa36771cb1eb1$export$4a78e7a2a4fb689f($0a2fa36771cb1eb1$export$45c769cf449a508c(item))) : raw.map($0a2fa36771cb1eb1$export$4a78e7a2a4fb689f);
}
/**
* Track array iteration and return raw array
*/ function $0a2fa36771cb1eb1$export$5eb48af14254449e(arr) {
    $0a2fa36771cb1eb1$export$6b2a7d5132615086(arr = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(arr), "iterate", $0a2fa36771cb1eb1$export$4f926f0baab682cd);
    return arr;
}
function $0a2fa36771cb1eb1$var$toWrapped(target, item) {
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(target)) return /* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(target) ? $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f($0a2fa36771cb1eb1$export$45c769cf449a508c(item)) : $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f(item);
    return $0a2fa36771cb1eb1$export$45c769cf449a508c(item);
}
const $0a2fa36771cb1eb1$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $0a2fa36771cb1eb1$var$iterator(this, Symbol.iterator, (item)=>$0a2fa36771cb1eb1$var$toWrapped(this, item));
    },
    concat (...args) {
        return $0a2fa36771cb1eb1$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $7s0Ms.isArray)(x) ? $0a2fa36771cb1eb1$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $0a2fa36771cb1eb1$var$iterator(this, "entries", (value)=>{
            value[1] = $0a2fa36771cb1eb1$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$0a2fa36771cb1eb1$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "find", fn, thisArg, (item)=>$0a2fa36771cb1eb1$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "findLast", fn, thisArg, (item)=>$0a2fa36771cb1eb1$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    forEach (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $0a2fa36771cb1eb1$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $0a2fa36771cb1eb1$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $0a2fa36771cb1eb1$export$1544eab4943788e4(this).join(separator);
    },
    lastIndexOf (...args) {
        return $0a2fa36771cb1eb1$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $0a2fa36771cb1eb1$var$noTracking(this, "pop");
    },
    push (...args) {
        return $0a2fa36771cb1eb1$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $0a2fa36771cb1eb1$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $0a2fa36771cb1eb1$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $0a2fa36771cb1eb1$var$noTracking(this, "shift");
    },
    some (fn, thisArg) {
        return $0a2fa36771cb1eb1$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $0a2fa36771cb1eb1$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $0a2fa36771cb1eb1$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $0a2fa36771cb1eb1$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $0a2fa36771cb1eb1$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $0a2fa36771cb1eb1$var$noTracking(this, "unshift", args);
    },
    values () {
        return $0a2fa36771cb1eb1$var$iterator(this, "values", (item)=>$0a2fa36771cb1eb1$var$toWrapped(this, item));
    }
};
function $0a2fa36771cb1eb1$var$iterator(self, method, wrapValue) {
    const arr = $0a2fa36771cb1eb1$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $0a2fa36771cb1eb1$var$arrayProto = Array.prototype;
function $0a2fa36771cb1eb1$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $0a2fa36771cb1eb1$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $0a2fa36771cb1eb1$var$arrayProto[method]) {
        const result = methodFn.apply(self, args);
        return needsWrap ? $0a2fa36771cb1eb1$export$45c769cf449a508c(result) : result;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $0a2fa36771cb1eb1$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $0a2fa36771cb1eb1$var$reduce(self, method, fn, args) {
    const arr = $0a2fa36771cb1eb1$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $0a2fa36771cb1eb1$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $0a2fa36771cb1eb1$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $0a2fa36771cb1eb1$var$toWrapped(self, result) : result;
}
function $0a2fa36771cb1eb1$var$searchProxy(self, method, args) {
    const arr = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(self);
    $0a2fa36771cb1eb1$export$6b2a7d5132615086(arr, "iterate", $0a2fa36771cb1eb1$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && /* @__PURE__ */ $0a2fa36771cb1eb1$export$5f3ca29d057519b3(args[0])) {
        args[0] = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $0a2fa36771cb1eb1$var$noTracking(self, method, args = []) {
    $0a2fa36771cb1eb1$var$startBatch();
    const prevSub = $0a2fa36771cb1eb1$export$852d57bcb751cc7a();
    const res = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $0a2fa36771cb1eb1$export$852d57bcb751cc7a(prevSub);
    $0a2fa36771cb1eb1$var$endBatch();
    return res;
}
//#endregion
//#region packages/reactivity/src/baseHandlers.ts
const $0a2fa36771cb1eb1$var$isNonTrackableKeys = /*@__PURE__*/ (0, $7s0Ms.makeMap)(`__proto__,__v_isRef,__isVue`);
const $0a2fa36771cb1eb1$var$builtInSymbols = new Set(/*@__PURE__*/ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $7s0Ms.isSymbol)));
function $0a2fa36771cb1eb1$var$hasOwnProperty(key) {
    if (!(0, $7s0Ms.isSymbol)(key)) key = String(key);
    const obj = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(this);
    $0a2fa36771cb1eb1$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $0a2fa36771cb1eb1$var$BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly = this._isReadonly, isShallow = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_isShallow") return isShallow;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly ? isShallow ? $0a2fa36771cb1eb1$var$shallowReadonlyMap : $0a2fa36771cb1eb1$var$readonlyMap : isShallow ? $0a2fa36771cb1eb1$var$shallowReactiveMap : $0a2fa36771cb1eb1$var$reactiveMap).get(target) || Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $7s0Ms.isArray)(target);
        if (!isReadonly) {
            let fn;
            if (targetIsArray && (fn = $0a2fa36771cb1eb1$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $0a2fa36771cb1eb1$var$hasOwnProperty;
        }
        const wasRef = /* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(target);
        const res = Reflect.get(target, key, wasRef ? target : receiver);
        if (wasRef && key !== "value") return res;
        if ((0, $7s0Ms.isSymbol)(key) ? $0a2fa36771cb1eb1$var$builtInSymbols.has(key) : $0a2fa36771cb1eb1$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $0a2fa36771cb1eb1$export$6b2a7d5132615086(target, "get", key);
        if (isShallow) return res;
        if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $7s0Ms.isIntegerKey)(key) ? res : res.value;
            return isReadonly && (0, $7s0Ms.isObject)(value) ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $7s0Ms.isObject)(res)) return isReadonly ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$6ec456bd5b7b3c51(res) : /* @__PURE__ */ $0a2fa36771cb1eb1$export$90a44edba14e47be(res);
        return res;
    }
};
var $0a2fa36771cb1eb1$var$MutableReactiveHandler = class extends $0a2fa36771cb1eb1$var$BaseReactiveHandler {
    constructor(isShallow = false){
        super(false, isShallow);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $7s0Ms.isArray)(target) && (0, $7s0Ms.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = /* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(oldValue);
            if (!/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(value)) {
                oldValue = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(oldValue);
                value = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && /* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $7s0Ms.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, /* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $7s0Ms.hasChanged)(value, oldValue)) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $7s0Ms.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $7s0Ms.isSymbol)(key) || !$0a2fa36771cb1eb1$var$builtInSymbols.has(key)) $0a2fa36771cb1eb1$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $0a2fa36771cb1eb1$export$6b2a7d5132615086(target, "iterate", (0, $7s0Ms.isArray)(target) ? "length" : $0a2fa36771cb1eb1$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
};
var $0a2fa36771cb1eb1$var$ReadonlyReactiveHandler = class extends $0a2fa36771cb1eb1$var$BaseReactiveHandler {
    constructor(isShallow = false){
        super(true, isShallow);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
};
const $0a2fa36771cb1eb1$var$mutableHandlers = /*@__PURE__*/ new $0a2fa36771cb1eb1$var$MutableReactiveHandler();
const $0a2fa36771cb1eb1$var$readonlyHandlers = /*@__PURE__*/ new $0a2fa36771cb1eb1$var$ReadonlyReactiveHandler();
const $0a2fa36771cb1eb1$var$shallowReactiveHandlers = /*@__PURE__*/ new $0a2fa36771cb1eb1$var$MutableReactiveHandler(true);
const $0a2fa36771cb1eb1$var$shallowReadonlyHandlers = /*@__PURE__*/ new $0a2fa36771cb1eb1$var$ReadonlyReactiveHandler(true);
//#endregion
//#region packages/reactivity/src/collectionHandlers.ts
const $0a2fa36771cb1eb1$var$toShallow = (value)=>value;
const $0a2fa36771cb1eb1$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $0a2fa36771cb1eb1$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $7s0Ms.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $0a2fa36771cb1eb1$var$toShallow : isReadonly ? $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f : $0a2fa36771cb1eb1$export$45c769cf449a508c;
        !isReadonly && $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $0a2fa36771cb1eb1$export$49093fa1cddcb78d : $0a2fa36771cb1eb1$export$3c41b1a4e06acc14);
        return (0, $7s0Ms.extend)(Object.create(innerIterator), {
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $0a2fa36771cb1eb1$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $0a2fa36771cb1eb1$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(target);
            const rawKey = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $7s0Ms.hasChanged)(key, rawKey)) $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "get", key);
                $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $0a2fa36771cb1eb1$var$getProto(rawTarget);
            const wrap = shallow ? $0a2fa36771cb1eb1$var$toShallow : readonly ? $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f : $0a2fa36771cb1eb1$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $0a2fa36771cb1eb1$export$6b2a7d5132615086(/* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(target), "iterate", $0a2fa36771cb1eb1$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(target);
            const rawKey = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $7s0Ms.hasChanged)(key, rawKey)) $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "has", key);
                $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $0a2fa36771cb1eb1$var$toShallow : readonly ? $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f : $0a2fa36771cb1eb1$export$45c769cf449a508c;
            !readonly && $0a2fa36771cb1eb1$export$6b2a7d5132615086(rawTarget, "iterate", $0a2fa36771cb1eb1$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $7s0Ms.extend)(instrumentations, readonly ? {
        add: $0a2fa36771cb1eb1$var$createReadonlyMethod("add"),
        set: $0a2fa36771cb1eb1$var$createReadonlyMethod("set"),
        delete: $0a2fa36771cb1eb1$var$createReadonlyMethod("delete"),
        clear: $0a2fa36771cb1eb1$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(this);
            const proto = $0a2fa36771cb1eb1$var$getProto(target);
            const rawValue = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(value) ? rawValue : value;
            if (!(proto.has.call(target, valueToAdd) || (0, $7s0Ms.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $7s0Ms.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue))) {
                target.add(valueToAdd);
                $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(value)) value = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(value);
            const target = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $0a2fa36771cb1eb1$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $7s0Ms.hasChanged)(value, oldValue)) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $0a2fa36771cb1eb1$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $0a2fa36771cb1eb1$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ].forEach((method)=>{
        instrumentations[method] = $0a2fa36771cb1eb1$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $0a2fa36771cb1eb1$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = $0a2fa36771cb1eb1$var$createInstrumentations(isReadonly, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $7s0Ms.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $0a2fa36771cb1eb1$var$mutableCollectionHandlers = {
    get: /*@__PURE__*/ $0a2fa36771cb1eb1$var$createInstrumentationGetter(false, false)
};
const $0a2fa36771cb1eb1$var$shallowCollectionHandlers = {
    get: /*@__PURE__*/ $0a2fa36771cb1eb1$var$createInstrumentationGetter(false, true)
};
const $0a2fa36771cb1eb1$var$readonlyCollectionHandlers = {
    get: /*@__PURE__*/ $0a2fa36771cb1eb1$var$createInstrumentationGetter(true, false)
};
const $0a2fa36771cb1eb1$var$shallowReadonlyCollectionHandlers = {
    get: /*@__PURE__*/ $0a2fa36771cb1eb1$var$createInstrumentationGetter(true, true)
};
function $0a2fa36771cb1eb1$var$checkIdentityKeys(target, has, key) {
    const rawKey = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $7s0Ms.toRawType)(target);
        $0a2fa36771cb1eb1$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
//#endregion
//#region packages/reactivity/src/reactive.ts
const $0a2fa36771cb1eb1$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $0a2fa36771cb1eb1$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $0a2fa36771cb1eb1$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $0a2fa36771cb1eb1$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $0a2fa36771cb1eb1$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(target)) return target;
    return $0a2fa36771cb1eb1$var$createReactiveObject(target, false, $0a2fa36771cb1eb1$var$mutableHandlers, $0a2fa36771cb1eb1$var$mutableCollectionHandlers, $0a2fa36771cb1eb1$var$reactiveMap);
}
/**
* Shallow version of {@link reactive}.
*
* Unlike {@link reactive}, there is no deep conversion: only root-level
* properties are reactive for a shallow reactive object. Property values are
* stored and exposed as-is - this also means properties with ref values will
* not be automatically unwrapped.
*
* @example
* ```js
* const state = shallowReactive({
*   foo: 1,
*   nested: {
*     bar: 2
*   }
* })
*
* // mutating state's own properties is reactive
* state.foo++
*
* // ...but does not convert nested objects
* isReactive(state.nested) // false
*
* // NOT reactive
* state.nested.bar++
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#shallowreactive}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$8d81cefd22d22260(target) {
    return $0a2fa36771cb1eb1$var$createReactiveObject(target, false, $0a2fa36771cb1eb1$var$shallowReactiveHandlers, $0a2fa36771cb1eb1$var$shallowCollectionHandlers, $0a2fa36771cb1eb1$var$shallowReactiveMap);
}
/**
* Takes an object (reactive or plain) or a ref and returns a readonly proxy to
* the original.
*
* A readonly proxy is deep: any nested property accessed will be readonly as
* well. It also has the same ref-unwrapping behavior as {@link reactive},
* except the unwrapped values will also be made readonly.
*
* @example
* ```js
* const original = reactive({ count: 0 })
*
* const copy = readonly(original)
*
* watchEffect(() => {
*   // works for reactivity tracking
*   console.log(copy.count)
* })
*
* // mutating original will trigger watchers relying on the copy
* original.count++
*
* // mutating the copy will fail and result in a warning
* copy.count++ // warning!
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-core.html#readonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$6ec456bd5b7b3c51(target) {
    return $0a2fa36771cb1eb1$var$createReactiveObject(target, true, $0a2fa36771cb1eb1$var$readonlyHandlers, $0a2fa36771cb1eb1$var$readonlyCollectionHandlers, $0a2fa36771cb1eb1$var$readonlyMap);
}
/**
* Shallow version of {@link readonly}.
*
* Unlike {@link readonly}, there is no deep conversion: only root-level
* properties are made readonly. Property values are stored and exposed as-is -
* this also means properties with ref values will not be automatically
* unwrapped.
*
* @example
* ```js
* const state = shallowReadonly({
*   foo: 1,
*   nested: {
*     bar: 2
*   }
* })
*
* // mutating state's own properties will fail
* state.foo++
*
* // ...but works on nested objects
* isReadonly(state.nested) // false
*
* // works
* state.nested.bar++
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#shallowreadonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$7c4b5f2b50f09f6b(target) {
    return $0a2fa36771cb1eb1$var$createReactiveObject(target, true, $0a2fa36771cb1eb1$var$shallowReadonlyHandlers, $0a2fa36771cb1eb1$var$shallowReadonlyCollectionHandlers, $0a2fa36771cb1eb1$var$shallowReadonlyMap);
}
function $0a2fa36771cb1eb1$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $7s0Ms.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $0a2fa36771cb1eb1$var$targetTypeMap((0, $7s0Ms.toRawType)(target));
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
/**
* Checks if an object is a proxy created by {@link reactive} or
* {@link shallowReactive} (or {@link ref} in some cases).
*
* @example
* ```js
* isReactive(reactive({}))            // => true
* isReactive(readonly(reactive({})))  // => true
* isReactive(ref({}).value)           // => true
* isReactive(readonly(ref({})).value) // => true
* isReactive(ref(true))               // => false
* isReactive(shallowRef({}).value)    // => false
* isReactive(shallowReactive({}))     // => true
* ```
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isreactive}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(value)) return /* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
/**
* Checks whether the passed value is a readonly object. The properties of a
* readonly object can change, but they can't be assigned directly via the
* passed object.
*
* The proxies created by {@link readonly} and {@link shallowReadonly} are
* both considered readonly, as is a computed ref without a set function.
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isreadonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
/**
* Checks if an object is a proxy created by {@link reactive},
* {@link readonly}, {@link shallowReactive} or {@link shallowReadonly}.
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isproxy}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
/**
* Returns the raw, original object of a Vue-created proxy.
*
* `toRaw()` can return the original object from proxies created by
* {@link reactive}, {@link readonly}, {@link shallowReactive} or
* {@link shallowReadonly}.
*
* This is an escape hatch that can be used to temporarily read without
* incurring proxy access / tracking overhead or write without triggering
* changes. It is **not** recommended to hold a persistent reference to the
* original object. Use with caution.
*
* @example
* ```js
* const foo = {}
* const reactiveFoo = reactive(foo)
*
* console.log(toRaw(reactiveFoo) === foo) // true
* ```
*
* @param observed - The object for which the "raw" value is requested.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#toraw}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(raw) : observed;
}
/**
* Marks an object so that it will never be converted to a proxy. Returns the
* object itself.
*
* @example
* ```js
* const foo = markRaw({})
* console.log(isReactive(reactive(foo))) // false
*
* // also works when nested inside other reactive objects
* const bar = reactive({ foo })
* console.log(isReactive(bar.foo)) // false
* ```
*
* **Warning:** `markRaw()` together with the shallow APIs such as
* {@link shallowReactive} allow you to selectively opt-out of the default
* deep reactive/readonly conversion and embed raw, non-proxied objects in your
* state graph.
*
* @param value - The object to be marked as "raw".
* @see {@link https://vuejs.org/api/reactivity-advanced.html#markraw}
*/ function $0a2fa36771cb1eb1$export$995ab8b13ad7a9d0(value) {
    if (!(0, $7s0Ms.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $7s0Ms.def)(value, "__v_skip", true);
    return value;
}
/**
* Returns a reactive proxy of the given value (if possible).
*
* If the given value is not an object, the original value itself is returned.
*
* @param value - The value for which a reactive proxy shall be created.
*/ const $0a2fa36771cb1eb1$export$45c769cf449a508c = (value)=>(0, $7s0Ms.isObject)(value) ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$90a44edba14e47be(value) : value;
/**
* Returns a readonly proxy of the given value (if possible).
*
* If the given value is not an object, the original value itself is returned.
*
* @param value - The value for which a readonly proxy shall be created.
*/ const $0a2fa36771cb1eb1$export$4a78e7a2a4fb689f = (value)=>(0, $7s0Ms.isObject)(value) ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$6ec456bd5b7b3c51(value) : value;
//#endregion
//#region packages/reactivity/src/ref.ts
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$eff4d24c3ff7876e(value) {
    return $0a2fa36771cb1eb1$var$createRef(value, $0a2fa36771cb1eb1$export$45c769cf449a508c);
}
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$9b7bc5fe3b17c8b3(value) {
    return $0a2fa36771cb1eb1$var$createRef(value);
}
function $0a2fa36771cb1eb1$var$createRef(rawValue, wrap) {
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $0a2fa36771cb1eb1$var$RefImpl(rawValue, wrap);
}
/**
* @internal
*/ var $0a2fa36771cb1eb1$var$RefImpl = class {
    constructor(value, wrap){
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 1;
        this.__v_isRef = true;
        this.__v_isShallow = false;
        this._oldValue = this._rawValue = wrap ? /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(value) : value;
        this._value = wrap ? wrap(value) : value;
        this._wrap = wrap;
        this["__v_isShallow"] = !wrap;
    }
    get dep() {
        return this;
    }
    get value() {
        $0a2fa36771cb1eb1$var$trackRef(this);
        if (this.flags & 16 && this.update()) {
            const subs = this.subs;
            if (subs !== void 0) $0a2fa36771cb1eb1$var$shallowPropagate(subs);
        }
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || /* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(newValue) || /* @__PURE__ */ $0a2fa36771cb1eb1$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(newValue);
        if ((0, $7s0Ms.hasChanged)(newValue, oldValue)) {
            this.flags |= 16;
            this._rawValue = newValue;
            this._value = !useDirectValue && this._wrap ? this._wrap(newValue) : newValue;
            const subs = this.subs;
            if (subs !== void 0) {
                $0a2fa36771cb1eb1$var$propagate(subs);
                if (!$0a2fa36771cb1eb1$var$batchDepth) $0a2fa36771cb1eb1$var$flush();
            }
        }
    }
    update() {
        this.flags &= -17;
        return (0, $7s0Ms.hasChanged)(this._oldValue, this._oldValue = this._rawValue);
    }
};
/**
* Force trigger effects that depends on a shallow ref. This is typically used
* after making deep mutations to the inner value of a shallow ref.
*
* @example
* ```js
* const shallow = shallowRef({
*   greet: 'Hello, world'
* })
*
* // Logs "Hello, world" once for the first run-through
* watchEffect(() => {
*   console.log(shallow.value.greet)
* })
*
* // This won't trigger the effect because the ref is shallow
* shallow.value.greet = 'Hello, universe'
*
* // Logs "Hello, universe"
* triggerRef(shallow)
* ```
*
* @param ref - The ref whose tied effects shall be executed.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#triggerref}
*/ function $0a2fa36771cb1eb1$export$f402f86588575ccc(ref) {
    const dep = ref.dep;
    if (dep !== void 0 && dep.subs !== void 0) {
        $0a2fa36771cb1eb1$var$propagate(dep.subs);
        $0a2fa36771cb1eb1$var$shallowPropagate(dep.subs);
        if (!$0a2fa36771cb1eb1$var$batchDepth) $0a2fa36771cb1eb1$var$flush();
    }
}
function $0a2fa36771cb1eb1$var$trackRef(dep) {
    if ($0a2fa36771cb1eb1$var$activeSub !== void 0) $0a2fa36771cb1eb1$var$link(dep, $0a2fa36771cb1eb1$var$activeSub);
}
/**
* Returns the inner value if the argument is a ref, otherwise return the
* argument itself. This is a sugar function for
* `val = isRef(val) ? val.value : val`.
*
* @example
* ```js
* function useFoo(x: number | Ref<number>) {
*   const unwrapped = unref(x)
*   // unwrapped is guaranteed to be number now
* }
* ```
*
* @param ref - Ref or plain value to be converted into the plain value.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#unref}
*/ function $0a2fa36771cb1eb1$export$a239a76781616204(ref) {
    return /* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
/**
* Normalizes values / refs / getters to values.
* This is similar to {@link unref}, except that it also normalizes getters.
* If the argument is a getter, it will be invoked and its return value will
* be returned.
*
* @example
* ```js
* toValue(1) // 1
* toValue(ref(1)) // 1
* toValue(() => 1) // 1
* ```
*
* @param source - A getter, an existing ref, or a non-function value.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#tovalue}
*/ function $0a2fa36771cb1eb1$export$30bdcc2218aa9458(source) {
    return (0, $7s0Ms.isFunction)(source) ? source() : $0a2fa36771cb1eb1$export$a239a76781616204(source);
}
const $0a2fa36771cb1eb1$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $0a2fa36771cb1eb1$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
/**
* Returns a proxy for the given object that shallowly unwraps properties that
* are refs. If the object already is reactive, it's returned as-is. If not, a
* new reactive proxy is created.
*
* @param objectWithRefs - Either an already-reactive object or a simple object
* that contains refs.
*/ function $0a2fa36771cb1eb1$export$f353fd1b97db3fa0(objectWithRefs) {
    return /* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $0a2fa36771cb1eb1$var$shallowUnwrapHandlers);
}
var $0a2fa36771cb1eb1$var$CustomRefImpl = class {
    constructor(factory){
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
        this["__v_isRef"] = true;
        this._value = void 0;
        const { get: get, set: set } = factory(()=>$0a2fa36771cb1eb1$var$trackRef(this), ()=>$0a2fa36771cb1eb1$export$f402f86588575ccc(this));
        this._get = get;
        this._set = set;
    }
    get dep() {
        return this;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
};
/**
* Creates a customized ref with explicit control over its dependency tracking
* and updates triggering.
*
* @param factory - The function that receives the `track` and `trigger` callbacks.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#customref}
*/ function $0a2fa36771cb1eb1$export$a20c2dd6199824cb(factory) {
    return new $0a2fa36771cb1eb1$var$CustomRefImpl(factory);
}
/**
* Converts a reactive object to a plain object where each property of the
* resulting object is a ref pointing to the corresponding property of the
* original object. Each individual ref is created using {@link toRef}.
*
* @param object - Reactive object to be made into an object of linked refs.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#torefs}
*/ /*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$2e9533675e5e70e0(object) {
    const ret = (0, $7s0Ms.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $0a2fa36771cb1eb1$var$propertyToRef(object, key);
    return ret;
}
var $0a2fa36771cb1eb1$var$ObjectRefImpl = class {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $7s0Ms.isSymbol)(key) ? key : String(key);
        this._raw = /* @__PURE__ */ $0a2fa36771cb1eb1$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $7s0Ms.isArray)(_object) || (0, $7s0Ms.isSymbol)(this._key) || !(0, $7s0Ms.isIntegerKey)(this._key)) do shallow = !/* @__PURE__ */ $0a2fa36771cb1eb1$export$5f3ca29d057519b3(obj) || /* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $0a2fa36771cb1eb1$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $0a2fa36771cb1eb1$var$getDepFromReactive(this._raw, this._key);
    }
};
var $0a2fa36771cb1eb1$var$GetterRefImpl = class {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
};
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $7s0Ms.isFunction)(source)) return new $0a2fa36771cb1eb1$var$GetterRefImpl(source);
    else if ((0, $7s0Ms.isObject)(source) && arguments.length > 1) return $0a2fa36771cb1eb1$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $0a2fa36771cb1eb1$export$eff4d24c3ff7876e(source);
}
function $0a2fa36771cb1eb1$var$propertyToRef(source, key, defaultValue) {
    return new $0a2fa36771cb1eb1$var$ObjectRefImpl(source, key, defaultValue);
}
//#endregion
//#region packages/reactivity/src/effect.ts
const $0a2fa36771cb1eb1$export$37ee493b2f34ee54 = {
    "ALLOW_RECURSE": 128,
    "128": "ALLOW_RECURSE",
    "PAUSED": 256,
    "256": "PAUSED",
    "STOP": 1024,
    "1024": "STOP"
};
var $0a2fa36771cb1eb1$export$28352bb4dd362521 = class {
    fn() {}
    constructor(fn){
        this.deps = void 0;
        this.depsTail = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 18;
        this.cleanups = [];
        this.cleanupsLength = 0;
        if (fn !== void 0) this.fn = fn;
        if ($0a2fa36771cb1eb1$var$activeEffectScope) $0a2fa36771cb1eb1$var$link(this, $0a2fa36771cb1eb1$var$activeEffectScope);
    }
    get active() {
        return !(this.flags & 1024);
    }
    pause() {
        this.flags |= 256;
    }
    resume() {
        if ((this.flags &= -257) & 48) this.notify();
    }
    notify() {
        if (!(this.flags & 256) && this.dirty) this.run();
    }
    run() {
        if (!this.active) return this.fn();
        $0a2fa36771cb1eb1$var$cleanup(this);
        const prevSub = $0a2fa36771cb1eb1$var$startTracking(this);
        $0a2fa36771cb1eb1$var$incRunDepth();
        try {
            return this.fn();
        } finally{
            $0a2fa36771cb1eb1$var$decRunDepth();
            $0a2fa36771cb1eb1$var$endTracking(this, prevSub);
            const flags = this.flags;
            if ((flags & 136) === 136) {
                this.flags = flags & -9;
                this.notify();
            }
        }
    }
    stop() {
        if (!this.active) return;
        this.flags = 1024;
        let dep = this.deps;
        while(dep !== void 0)dep = $0a2fa36771cb1eb1$var$unlink(dep, this);
        const sub = this.subs;
        if (sub !== void 0) $0a2fa36771cb1eb1$var$unlink(sub);
        $0a2fa36771cb1eb1$var$cleanup(this);
    }
    get dirty() {
        const flags = this.flags;
        if (flags & 16) return true;
        if (flags & 32) {
            if ($0a2fa36771cb1eb1$var$checkDirty(this.deps, this)) {
                this.flags = flags | 16;
                return true;
            } else this.flags = flags & -33;
        }
        return false;
    }
};
function $0a2fa36771cb1eb1$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $0a2fa36771cb1eb1$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $0a2fa36771cb1eb1$export$28352bb4dd362521(fn);
    if (options) {
        const { onStop: onStop, scheduler: scheduler } = options;
        if (onStop) {
            options.onStop = void 0;
            const stop = e.stop.bind(e);
            e.stop = ()=>{
                stop();
                onStop();
            };
        }
        if (scheduler) {
            options.scheduler = void 0;
            e.notify = ()=>{
                if (!(e.flags & 256)) scheduler();
            };
        }
        (0, $7s0Ms.extend)(e, options);
    }
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
/**
* Stops the effect associated with the given runner.
*
* @param runner - Association with the effect to stop tracking.
*/ function $0a2fa36771cb1eb1$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
const $0a2fa36771cb1eb1$var$resetTrackingStack = [];
/**
* Temporarily pauses tracking.
*/ function $0a2fa36771cb1eb1$export$938a971395fef855() {
    $0a2fa36771cb1eb1$var$resetTrackingStack.push($0a2fa36771cb1eb1$var$activeSub);
    $0a2fa36771cb1eb1$export$852d57bcb751cc7a();
}
/**
* Re-enables effect tracking (if it was paused).
*/ function $0a2fa36771cb1eb1$export$1f8ffc6fd33b1d16() {
    if (!($0a2fa36771cb1eb1$var$activeSub === void 0)) $0a2fa36771cb1eb1$var$resetTrackingStack.push($0a2fa36771cb1eb1$var$activeSub);
    else {
        $0a2fa36771cb1eb1$var$resetTrackingStack.push(void 0);
        for(let i = $0a2fa36771cb1eb1$var$resetTrackingStack.length - 1; i >= 0; i--)if ($0a2fa36771cb1eb1$var$resetTrackingStack[i] !== void 0) {
            $0a2fa36771cb1eb1$export$852d57bcb751cc7a($0a2fa36771cb1eb1$var$resetTrackingStack[i]);
            break;
        }
    }
}
/**
* Resets the previous global effect tracking state.
*/ function $0a2fa36771cb1eb1$export$c39176b1babaa8b8() {
    if ($0a2fa36771cb1eb1$var$resetTrackingStack.length) $0a2fa36771cb1eb1$export$852d57bcb751cc7a($0a2fa36771cb1eb1$var$resetTrackingStack.pop());
    else $0a2fa36771cb1eb1$export$852d57bcb751cc7a();
}
function $0a2fa36771cb1eb1$var$cleanup(sub) {
    const l = sub.cleanupsLength;
    if (l) {
        for(let i = 0; i < l; i++)sub.cleanups[i]();
        sub.cleanupsLength = 0;
    }
}
/**
* Registers a cleanup function for the current active effect.
* The cleanup function is called right before the next effect run, or when the
* effect is stopped.
*
* Throws a warning if there is no current active effect. The warning can be
* suppressed by passing `true` to the second argument.
*
* @param fn - the cleanup function to be registered
* @param failSilently - if `true`, will not throw warning when called without
* an active effect.
*/ function $0a2fa36771cb1eb1$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($0a2fa36771cb1eb1$var$activeSub instanceof $0a2fa36771cb1eb1$export$28352bb4dd362521) $0a2fa36771cb1eb1$var$activeSub.cleanups[$0a2fa36771cb1eb1$var$activeSub.cleanupsLength++] = ()=>$0a2fa36771cb1eb1$var$cleanupEffect(fn);
}
function $0a2fa36771cb1eb1$var$cleanupEffect(fn) {
    const prevSub = $0a2fa36771cb1eb1$export$852d57bcb751cc7a();
    try {
        fn();
    } finally{
        $0a2fa36771cb1eb1$export$852d57bcb751cc7a(prevSub);
    }
}
//#endregion
//#region packages/reactivity/src/effectScope.ts
let $0a2fa36771cb1eb1$var$activeEffectScope;
var $0a2fa36771cb1eb1$export$1168ed9dbc71ddbd = class {
    constructor(detached = false){
        this.deps = void 0;
        this.depsTail = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
        this.cleanups = [];
        this.cleanupsLength = 0;
        if (!detached && $0a2fa36771cb1eb1$var$activeEffectScope) $0a2fa36771cb1eb1$var$link(this, $0a2fa36771cb1eb1$var$activeEffectScope);
    }
    get active() {
        return !(this.flags & 1024);
    }
    pause() {
        if (!(this.flags & 256)) {
            this.flags |= 256;
            for(let link = this.deps; link !== void 0; link = link.nextDep){
                const dep = link.dep;
                if ("pause" in dep) dep.pause();
            }
        }
    }
    /**
	* Resumes the effect scope, including all child scopes and effects.
	*/ resume() {
        const flags = this.flags;
        if (flags & 256) {
            this.flags = flags & -257;
            for(let link = this.deps; link !== void 0; link = link.nextDep){
                const dep = link.dep;
                if ("resume" in dep) dep.resume();
            }
        }
    }
    run(fn) {
        const prevScope = $0a2fa36771cb1eb1$var$activeEffectScope;
        try {
            $0a2fa36771cb1eb1$var$activeEffectScope = this;
            return fn();
        } finally{
            $0a2fa36771cb1eb1$var$activeEffectScope = prevScope;
        }
    }
    stop() {
        if (!this.active) return;
        this.flags = 1024;
        this.reset();
        const sub = this.subs;
        if (sub !== void 0) $0a2fa36771cb1eb1$var$unlink(sub);
    }
    /**
	* @internal
	*/ reset() {
        let dep = this.deps;
        while(dep !== void 0){
            const node = dep.dep;
            if ("stop" in node) {
                dep = dep.nextDep;
                node.stop();
            } else dep = $0a2fa36771cb1eb1$var$unlink(dep, this);
        }
        $0a2fa36771cb1eb1$var$cleanup(this);
    }
};
/**
* Creates an effect scope object which can capture the reactive effects (i.e.
* computed and watchers) created within it so that these effects can be
* disposed together. For detailed use cases of this API, please consult its
* corresponding {@link https://github.com/vuejs/rfcs/blob/master/active-rfcs/0041-reactivity-effect-scope.md | RFC}.
*
* @param detached - Can be used to create a "detached" effect scope.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#effectscope}
*/ function $0a2fa36771cb1eb1$export$7056603ea81600be(detached) {
    return new $0a2fa36771cb1eb1$export$1168ed9dbc71ddbd(detached);
}
/**
* Returns the current active effect scope if there is one.
*
* @see {@link https://vuejs.org/api/reactivity-advanced.html#getcurrentscope}
*/ function $0a2fa36771cb1eb1$export$c7be4b0125a10cba() {
    return $0a2fa36771cb1eb1$var$activeEffectScope;
}
function $0a2fa36771cb1eb1$export$7c50eaa430038da7(scope) {
    try {
        return $0a2fa36771cb1eb1$var$activeEffectScope;
    } finally{
        $0a2fa36771cb1eb1$var$activeEffectScope = scope;
    }
}
/**
* Registers a dispose callback on the current active effect scope. The
* callback will be invoked when the associated effect scope is stopped.
*
* @param fn - The callback function to attach to the scope's cleanup.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#onscopedispose}
*/ function $0a2fa36771cb1eb1$export$a780418acd4762da(fn, failSilently = false) {
    if ($0a2fa36771cb1eb1$var$activeEffectScope !== void 0) $0a2fa36771cb1eb1$var$activeEffectScope.cleanups[$0a2fa36771cb1eb1$var$activeEffectScope.cleanupsLength++] = fn;
}
//#endregion
//#region packages/reactivity/src/computed.ts
/**
* @private exported by @vue/reactivity for Vue core use, but not exported from
* the main vue package
*/ var $0a2fa36771cb1eb1$var$ComputedRefImpl = class {
    get effect() {
        return this;
    }
    get dep() {
        return this;
    }
    /**
	* @internal
	* for backwards compat
	*/ get _dirty() {
        const flags = this.flags;
        if (flags & 16) return true;
        if (flags & 32) {
            if ($0a2fa36771cb1eb1$var$checkDirty(this.deps, this)) {
                this.flags = flags | 16;
                return true;
            } else this.flags = flags & -33;
        }
        return false;
    }
    /**
	* @internal
	* for backwards compat
	*/ set _dirty(v) {
        if (v) this.flags |= 16;
        else this.flags &= -49;
    }
    constructor(fn, setter){
        this.fn = fn;
        this.setter = setter;
        this._value = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 17;
        this.__v_isRef = true;
        this["__v_isReadonly"] = !setter;
    }
    get value() {
        const flags = this.flags;
        if (flags & 16 || flags & 32 && $0a2fa36771cb1eb1$var$checkDirty(this.deps, this)) {
            if (this.update()) {
                const subs = this.subs;
                if (subs !== void 0) $0a2fa36771cb1eb1$var$shallowPropagate(subs);
            }
        } else if (flags & 32) this.flags = flags & -33;
        if ($0a2fa36771cb1eb1$var$activeSub !== void 0) $0a2fa36771cb1eb1$var$link(this, $0a2fa36771cb1eb1$var$activeSub);
        else if ($0a2fa36771cb1eb1$var$activeEffectScope !== void 0) $0a2fa36771cb1eb1$var$link(this, $0a2fa36771cb1eb1$var$activeEffectScope);
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
    update() {
        const prevSub = $0a2fa36771cb1eb1$var$startTracking(this);
        try {
            const oldValue = this._value;
            const newValue = this.fn(oldValue);
            if ((0, $7s0Ms.hasChanged)(oldValue, newValue)) {
                this._value = newValue;
                return true;
            }
            return false;
        } finally{
            $0a2fa36771cb1eb1$var$endTracking(this, prevSub);
        }
    }
};
/*@__NO_SIDE_EFFECTS__*/ function $0a2fa36771cb1eb1$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $7s0Ms.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $0a2fa36771cb1eb1$var$ComputedRefImpl(getter, setter);
    return cRef;
}
//#endregion
//#region packages/reactivity/src/constants.ts
const $0a2fa36771cb1eb1$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $0a2fa36771cb1eb1$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $0a2fa36771cb1eb1$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
//#endregion
//#region packages/reactivity/src/watch.ts
const $0a2fa36771cb1eb1$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $0a2fa36771cb1eb1$var$INITIAL_WATCHER_VALUE = {};
let $0a2fa36771cb1eb1$var$activeWatcher = void 0;
/**
* Returns the current active effect if there is one.
*/ function $0a2fa36771cb1eb1$export$2532f7acfca7c82d() {
    return $0a2fa36771cb1eb1$var$activeWatcher;
}
/**
* Registers a cleanup callback on the current active effect. This
* registered cleanup callback will be invoked right before the
* associated effect re-runs.
*
* @param cleanupFn - The callback function to attach to the effect's cleanup.
* @param failSilently - if `true`, will not throw warning when called without
* an active effect.
* @param owner - The effect that this cleanup function should be attached to.
* By default, the current active effect.
*/ function $0a2fa36771cb1eb1$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $0a2fa36771cb1eb1$var$activeWatcher) {
    if (owner) {
        const { call: call } = owner.options;
        if (call) owner.cleanups[owner.cleanupsLength++] = ()=>call(cleanupFn, 4);
        else owner.cleanups[owner.cleanupsLength++] = cleanupFn;
    }
}
var $0a2fa36771cb1eb1$export$c243d5028940e63b = class extends $0a2fa36771cb1eb1$export$28352bb4dd362521 {
    constructor(source, cb, options = (0, $7s0Ms.EMPTY_OBJ)){
        const { deep: deep, once: once, call: call, onWarn: onWarn } = options;
        let getter;
        let forceTrigger = false;
        let isMultiSource = false;
        if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(source)) {
            getter = ()=>source.value;
            forceTrigger = /* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(source);
        } else if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(source)) {
            getter = ()=>$0a2fa36771cb1eb1$var$reactiveGetter(source, deep);
            forceTrigger = true;
        } else if ((0, $7s0Ms.isArray)(source)) {
            isMultiSource = true;
            forceTrigger = source.some((s)=>/* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(s) || /* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(s));
            getter = ()=>source.map((s)=>{
                    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(s)) return s.value;
                    else if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$352205f445242f02(s)) return $0a2fa36771cb1eb1$var$reactiveGetter(s, deep);
                    else if ((0, $7s0Ms.isFunction)(s)) return call ? call(s, 2) : s();
                });
        } else if ((0, $7s0Ms.isFunction)(source)) {
            if (cb) getter = call ? ()=>call(source, 2) : source;
            else getter = ()=>{
                if (this.cleanupsLength) {
                    const prevSub = $0a2fa36771cb1eb1$export$852d57bcb751cc7a();
                    try {
                        $0a2fa36771cb1eb1$var$cleanup(this);
                    } finally{
                        $0a2fa36771cb1eb1$export$852d57bcb751cc7a(prevSub);
                    }
                }
                const currentEffect = $0a2fa36771cb1eb1$var$activeWatcher;
                $0a2fa36771cb1eb1$var$activeWatcher = this;
                try {
                    return call ? call(source, 3, [
                        this.boundCleanup
                    ]) : source(this.boundCleanup);
                } finally{
                    $0a2fa36771cb1eb1$var$activeWatcher = currentEffect;
                }
            };
        } else getter = (0, $7s0Ms.NOOP);
        if (cb && deep) {
            const baseGetter = getter;
            const depth = deep === true ? Infinity : deep;
            getter = ()=>$0a2fa36771cb1eb1$export$df3f009e3d155b20(baseGetter(), depth);
        }
        super(getter);
        this.cb = cb;
        this.options = options;
        this.boundCleanup = (fn)=>$0a2fa36771cb1eb1$export$8ddeeb083684a9d0(fn, false, this);
        this.forceTrigger = forceTrigger;
        this.isMultiSource = isMultiSource;
        if (once && cb) {
            const _cb = cb;
            cb = (...args)=>{
                const res = _cb(...args);
                this.stop();
                return res;
            };
        }
        this.cb = cb;
        this.oldValue = isMultiSource ? new Array(source.length).fill($0a2fa36771cb1eb1$var$INITIAL_WATCHER_VALUE) : $0a2fa36771cb1eb1$var$INITIAL_WATCHER_VALUE;
    }
    run(initialRun = false) {
        const oldValue = this.oldValue;
        const newValue = this.oldValue = super.run();
        if (!this.cb) return;
        const { immediate: immediate, deep: deep, call: call } = this.options;
        if (initialRun && !immediate) return;
        if (initialRun || deep || this.forceTrigger || (this.isMultiSource ? newValue.some((v, i)=>(0, $7s0Ms.hasChanged)(v, oldValue[i])) : (0, $7s0Ms.hasChanged)(newValue, oldValue))) {
            $0a2fa36771cb1eb1$var$cleanup(this);
            const currentWatcher = $0a2fa36771cb1eb1$var$activeWatcher;
            $0a2fa36771cb1eb1$var$activeWatcher = this;
            try {
                const args = [
                    newValue,
                    oldValue === $0a2fa36771cb1eb1$var$INITIAL_WATCHER_VALUE ? void 0 : this.isMultiSource && oldValue[0] === $0a2fa36771cb1eb1$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    this.boundCleanup
                ];
                call ? call(this.cb, 3, args) : this.cb(...args);
            } finally{
                $0a2fa36771cb1eb1$var$activeWatcher = currentWatcher;
            }
        }
    }
};
function $0a2fa36771cb1eb1$var$reactiveGetter(source, deep) {
    if (deep) return source;
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$7f3fe6025abfa26e(source) || deep === false || deep === 0) return $0a2fa36771cb1eb1$export$df3f009e3d155b20(source, 1);
    return $0a2fa36771cb1eb1$export$df3f009e3d155b20(source);
}
function $0a2fa36771cb1eb1$var$warnInvalidSource(s, onWarn) {
    (onWarn || $0a2fa36771cb1eb1$var$warn)(`Invalid watch source: `, s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
}
function $0a2fa36771cb1eb1$export$3db5d71bdb2d5499(source, cb, options = (0, $7s0Ms.EMPTY_OBJ)) {
    const effect = new $0a2fa36771cb1eb1$export$c243d5028940e63b(source, cb, options);
    effect.run(true);
    const stop = effect.stop.bind(effect);
    stop.pause = effect.pause.bind(effect);
    stop.resume = effect.resume.bind(effect);
    stop.stop = stop;
    return stop;
}
function $0a2fa36771cb1eb1$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $7s0Ms.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if (/* @__PURE__ */ $0a2fa36771cb1eb1$export$4f9f5282de18fc69(value)) $0a2fa36771cb1eb1$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $7s0Ms.isArray)(value)) for(let i = 0; i < value.length; i++)$0a2fa36771cb1eb1$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $7s0Ms.isSet)(value) || (0, $7s0Ms.isMap)(value)) value.forEach((v)=>{
        $0a2fa36771cb1eb1$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $7s0Ms.isPlainObject)(value)) {
        for(const key in value)$0a2fa36771cb1eb1$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $0a2fa36771cb1eb1$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});



parcelRegister("clmPQ", function(module, exports) {

$parcel$export(module.exports, "setInsertionState", function () { return $8fc928cd6c76f02e$export$c97c22f44c469014; });
$parcel$export(module.exports, "createTextNode", function () { return $8fc928cd6c76f02e$export$b2ce9ad90858ed7a; });
$parcel$export(module.exports, "txt", function () { return $8fc928cd6c76f02e$export$ac96b34a74de2f22; });
$parcel$export(module.exports, "child", function () { return $8fc928cd6c76f02e$export$f9574b70e1d95d9d; });
$parcel$export(module.exports, "nthChild", function () { return $8fc928cd6c76f02e$export$715692cc82be070b; });
$parcel$export(module.exports, "next", function () { return $8fc928cd6c76f02e$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "remove", function () { return $8fc928cd6c76f02e$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "withOnce", function () { return $8fc928cd6c76f02e$export$81831a240bcfd22e; });
$parcel$export(module.exports, "renderEffect", function () { return $8fc928cd6c76f02e$export$6c64e011838f4702; });
$parcel$export(module.exports, "on", function () { return $8fc928cd6c76f02e$export$af631764ddc44097; });
$parcel$export(module.exports, "createInvoker", function () { return $8fc928cd6c76f02e$export$a1d07c64020e8889; });
$parcel$export(module.exports, "onBinding", function () { return $8fc928cd6c76f02e$export$1583747b0ccdaa69; });
$parcel$export(module.exports, "delegate", function () { return $8fc928cd6c76f02e$export$10b1921597150314; });
$parcel$export(module.exports, "delegateEvents", function () { return $8fc928cd6c76f02e$export$ad0f7f87f67e17d6; });
$parcel$export(module.exports, "setDynamicEvents", function () { return $8fc928cd6c76f02e$export$8fcd6a995a854c39; });
$parcel$export(module.exports, "withVaporModifiers", function () { return $8fc928cd6c76f02e$export$57d458c682274bab; });
$parcel$export(module.exports, "withVaporKeys", function () { return $8fc928cd6c76f02e$export$b41fa5aac87099ed; });
$parcel$export(module.exports, "setProp", function () { return $8fc928cd6c76f02e$export$8a39838a0f735648; });
$parcel$export(module.exports, "setDOMProp", function () { return $8fc928cd6c76f02e$export$c16cd4a7fa698f59; });
$parcel$export(module.exports, "setAttr", function () { return $8fc928cd6c76f02e$export$c609e428011345f3; });
$parcel$export(module.exports, "setClass", function () { return $8fc928cd6c76f02e$export$2796c4ce44e61efa; });
$parcel$export(module.exports, "setClassName", function () { return $8fc928cd6c76f02e$export$826e926e0c74f2b8; });
$parcel$export(module.exports, "setStyle", function () { return $8fc928cd6c76f02e$export$37a5fde709c1db82; });
$parcel$export(module.exports, "setValue", function () { return $8fc928cd6c76f02e$export$80746c6bc6142fc8; });
$parcel$export(module.exports, "setText", function () { return $8fc928cd6c76f02e$export$cbe0d99836e1498f; });
$parcel$export(module.exports, "setElementText", function () { return $8fc928cd6c76f02e$export$1193aae213924971; });
$parcel$export(module.exports, "setHtml", function () { return $8fc928cd6c76f02e$export$e9d3191caab19f4d; });
$parcel$export(module.exports, "setDynamicProps", function () { return $8fc928cd6c76f02e$export$be77d6fc3302ce7c; });
$parcel$export(module.exports, "setBlockKey", function () { return $8fc928cd6c76f02e$export$96002406b1640ec1; });
$parcel$export(module.exports, "insert", function () { return $8fc928cd6c76f02e$export$21a5ca8aa77d35ff; });
$parcel$export(module.exports, "createSlot", function () { return $8fc928cd6c76f02e$export$e88b45bda5c13eb9; });
$parcel$export(module.exports, "DynamicFragment", function () { return $8fc928cd6c76f02e$export$2740cb41b6047c28; });
$parcel$export(module.exports, "isFragment", function () { return $8fc928cd6c76f02e$export$9522e17588c12572; });
$parcel$export(module.exports, "isVaporComponent", function () { return $8fc928cd6c76f02e$export$f43892e053afd2a0; });
$parcel$export(module.exports, "VaporFragment", function () { return $8fc928cd6c76f02e$export$abfed41506cb93e8; });
$parcel$export(module.exports, "useVaporCssVars", function () { return $8fc928cd6c76f02e$export$7ac556a74ffeb129; });
$parcel$export(module.exports, "createComponent", function () { return $8fc928cd6c76f02e$export$60e54eaca7e7fb38; });
$parcel$export(module.exports, "createAssetComponent", function () { return $8fc928cd6c76f02e$export$fd68e6e975efa84b; });
$parcel$export(module.exports, "createComponentWithFallback", function () { return $8fc928cd6c76f02e$export$8b456629be3b9f98; });
$parcel$export(module.exports, "createPlainElement", function () { return $8fc928cd6c76f02e$export$1453c0694157b862; });
$parcel$export(module.exports, "createVaporApp", function () { return $8fc928cd6c76f02e$export$ab21481d5d94015c; });
$parcel$export(module.exports, "createVaporSSRApp", function () { return $8fc928cd6c76f02e$export$291d13b1df8f2f86; });
$parcel$export(module.exports, "defineVaporComponent", function () { return $8fc928cd6c76f02e$export$bcd4d980d2d74077; });
$parcel$export(module.exports, "defineVaporAsyncComponent", function () { return $8fc928cd6c76f02e$export$638df296a30bd467; });
$parcel$export(module.exports, "VaporTransition", function () { return $8fc928cd6c76f02e$export$a9727d0b86227c77; });
$parcel$export(module.exports, "VaporKeepAlive", function () { return $8fc928cd6c76f02e$export$93e48a5fa2bfad35; });
$parcel$export(module.exports, "vaporInteropPlugin", function () { return $8fc928cd6c76f02e$export$4fa2a5402abc6e89; });
$parcel$export(module.exports, "VaporTeleport", function () { return $8fc928cd6c76f02e$export$6bc080ef119efb18; });
$parcel$export(module.exports, "defineVaporCustomElement", function () { return $8fc928cd6c76f02e$export$7dc92afc90cd43f8; });
$parcel$export(module.exports, "VaporElement", function () { return $8fc928cd6c76f02e$export$3ba6ba579e6b6c77; });
$parcel$export(module.exports, "defineVaporSSRCustomElement", function () { return $8fc928cd6c76f02e$export$105fe6a037adba94; });
$parcel$export(module.exports, "template", function () { return $8fc928cd6c76f02e$export$ce69bd05624d0c48; });
$parcel$export(module.exports, "createIf", function () { return $8fc928cd6c76f02e$export$df9df05a8736ecf5; });
$parcel$export(module.exports, "createKeyedFragment", function () { return $8fc928cd6c76f02e$export$1c7a187eacf2e9a; });
$parcel$export(module.exports, "createFor", function () { return $8fc928cd6c76f02e$export$990ded969be008a7; });
$parcel$export(module.exports, "createSelector", function () { return $8fc928cd6c76f02e$export$595d22ed68ca2841; });
$parcel$export(module.exports, "createForSlots", function () { return $8fc928cd6c76f02e$export$1c04d4cb91c5864f; });
$parcel$export(module.exports, "getRestElement", function () { return $8fc928cd6c76f02e$export$f22e14c83846d2c6; });
$parcel$export(module.exports, "getDefaultValue", function () { return $8fc928cd6c76f02e$export$9f15c5f175f17548; });
$parcel$export(module.exports, "createTemplateRefSetter", function () { return $8fc928cd6c76f02e$export$f3f2dfaab714a7e8; });
$parcel$export(module.exports, "setStaticTemplateRef", function () { return $8fc928cd6c76f02e$export$902da257a3c86fce; });
$parcel$export(module.exports, "setTemplateRefBinding", function () { return $8fc928cd6c76f02e$export$131d6b7239ae7b36; });
$parcel$export(module.exports, "createDynamicComponent", function () { return $8fc928cd6c76f02e$export$dd39299cb479bb8a; });
$parcel$export(module.exports, "applyVShow", function () { return $8fc928cd6c76f02e$export$ef682a92d74a99d4; });
$parcel$export(module.exports, "applyTextModel", function () { return $8fc928cd6c76f02e$export$3ae7eb13ae2ede6d; });
$parcel$export(module.exports, "applyCheckboxModel", function () { return $8fc928cd6c76f02e$export$7ef78625cdf299a8; });
$parcel$export(module.exports, "applyRadioModel", function () { return $8fc928cd6c76f02e$export$487f8d7ffa92a3d1; });
$parcel$export(module.exports, "applySelectModel", function () { return $8fc928cd6c76f02e$export$51f70f5febddf4c; });
$parcel$export(module.exports, "applyDynamicModel", function () { return $8fc928cd6c76f02e$export$b751fd10f5ef748d; });
$parcel$export(module.exports, "withVaporDirectives", function () { return $8fc928cd6c76f02e$export$66a5d204b19d8abb; });
$parcel$export(module.exports, "VaporTransitionGroup", function () { return $8fc928cd6c76f02e$export$27eb1a88f101ff62; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("7s0Ms")).extend; });
/**
  * @vue/runtime-vapor v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $3dLyd = parcelRequire("3dLyd");
var $SdEQh = parcelRequire("SdEQh");
var $bmuEm = parcelRequire("bmuEm");
var $SdEQh = parcelRequire("SdEQh");

var $7s0Ms = parcelRequire("7s0Ms");

var $SdEQh = parcelRequire("SdEQh");
//#region packages/runtime-vapor/src/insertionState.ts
let $8fc928cd6c76f02e$var$insertionParent;
let $8fc928cd6c76f02e$var$insertionAnchor;
let $8fc928cd6c76f02e$var$insertionIndex;
/**
* This function is called before a block type that requires insertion
* (component, slot outlet, if, for) is created.
*
* - `anchor` is a Node: insert before this template `<!>` placeholder during
*   client render; during hydration the located placeholder unit is the
*   block's hydration target.
* - `anchor` is a number: append; the value is the hydration start unit index
*   (the count of preceding logical units), omitted by codegen when 0.
* - `anchor` absent: append with no preceding units.
*/ function $8fc928cd6c76f02e$export$c97c22f44c469014(parent, anchor) {
    $8fc928cd6c76f02e$var$insertionParent = parent;
    if (typeof anchor === "number") {
        $8fc928cd6c76f02e$var$insertionAnchor = void 0;
        $8fc928cd6c76f02e$var$insertionIndex = anchor;
    } else {
        $8fc928cd6c76f02e$var$insertionAnchor = anchor;
        $8fc928cd6c76f02e$var$insertionIndex = void 0;
    }
}
function $8fc928cd6c76f02e$var$resetInsertionState() {
    $8fc928cd6c76f02e$var$insertionParent = $8fc928cd6c76f02e$var$insertionAnchor = $8fc928cd6c76f02e$var$insertionIndex = void 0;
}
//#endregion
//#region packages/runtime-vapor/src/dom/node.ts
const $8fc928cd6c76f02e$var$SVG_NS = "http://www.w3.org/2000/svg";
const $8fc928cd6c76f02e$var$MATHML_NS = "http://www.w3.org/1998/Math/MathML";
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$var$createElement(tagName, ns) {
    return ns ? document.createElementNS(ns === 1 ? $8fc928cd6c76f02e$var$SVG_NS : $8fc928cd6c76f02e$var$MATHML_NS, tagName) : document.createElement(tagName);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(value = "") {
    return document.createTextNode(value);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$var$createComment(data) {
    return document.createComment(data);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$var$querySelector(selectors) {
    return document.querySelector(selectors);
}
/* @__NO_SIDE_EFFECTS__ */ function $8fc928cd6c76f02e$var$parentNode(node) {
    return node.parentNode;
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$ac96b34a74de2f22(node) {
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        let n = /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(node);
        if (!n) return node.appendChild(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
        return n;
    }
    return /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(node);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$f9574b70e1d95d9d(node, isText) {
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        const n = $8fc928cd6c76f02e$var$locateChildByLogicalIndex(node, 0);
        return isText ? $8fc928cd6c76f02e$var$resolveBlankTextTarget(n, node) : n;
    }
    return /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(node);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$715692cc82be070b(node, i, isText) {
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        const n = $8fc928cd6c76f02e$var$locateChildByLogicalIndex(node, i);
        return isText ? $8fc928cd6c76f02e$var$resolveBlankTextTarget(n, node) : n;
    }
    return node.childNodes[i];
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$48cfd1e771a65c4f(node, isText) {
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        let result = $8fc928cd6c76f02e$var$nextLogicalSibling(node);
        const parent = node.parentNode;
        if (isText) result = $8fc928cd6c76f02e$var$resolveBlankTextTarget(result, parent);
        if (parent) $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(parent, node, result, 1);
        return result;
    }
    return /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(node);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$var$_child(node) {
    return node.firstChild;
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$var$_next(node) {
    return node.nextSibling;
}
function $8fc928cd6c76f02e$var$locateChildByLogicalIndex(parent, logicalIndex) {
    let child = parent.$llc || $8fc928cd6c76f02e$var$skipUntrackedAnchors(parent.firstChild);
    let fromIndex = child && child.$idx || 0;
    if (logicalIndex < fromIndex) {
        child = $8fc928cd6c76f02e$var$skipUntrackedAnchors(parent.firstChild);
        fromIndex = 0;
    }
    while(child){
        if (fromIndex === logicalIndex) {
            child.$idx = logicalIndex;
            return parent.$llc = child;
        }
        child = $8fc928cd6c76f02e$var$nextLogicalSibling(child);
        fromIndex++;
    }
    return null;
}
function $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(parent, from, to, logicalIndexOffset = 0) {
    const insertionParent = parent;
    if (insertionParent.$llc === from) {
        if (to) to.$idx = from.$idx + logicalIndexOffset;
        insertionParent.$llc = to;
    }
}
//#endregion
//#region packages/runtime-vapor/src/renderContext.ts
let $8fc928cd6c76f02e$var$currentRenderContext = {
    slotOwner: null,
    slotBoundary: null,
    slotScopeIds: null,
    suspense: null
};
function $8fc928cd6c76f02e$var$setRenderContext(ctx) {
    const prev = $8fc928cd6c76f02e$var$currentRenderContext;
    $8fc928cd6c76f02e$var$currentRenderContext = ctx;
    return prev;
}
function $8fc928cd6c76f02e$var$withRenderContext(ctx, fn) {
    if (ctx === $8fc928cd6c76f02e$var$currentRenderContext) return fn();
    const prev = $8fc928cd6c76f02e$var$setRenderContext(ctx);
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$currentRenderContext = prev;
    }
}
function $8fc928cd6c76f02e$var$deriveRenderContext(base, slotOwner, slotBoundary, slotScopeIds, suspense) {
    return slotOwner === base.slotOwner && slotBoundary === base.slotBoundary && slotScopeIds === base.slotScopeIds && suspense === base.suspense ? base : {
        slotOwner: slotOwner,
        slotBoundary: slotBoundary,
        slotScopeIds: slotScopeIds,
        suspense: suspense
    };
}
function $8fc928cd6c76f02e$var$deriveSlotOwner(base, slotOwner) {
    return $8fc928cd6c76f02e$var$deriveRenderContext(base, slotOwner, base.slotBoundary, base.slotScopeIds, base.suspense);
}
function $8fc928cd6c76f02e$var$deriveSlotBoundary(base, slotBoundary) {
    return $8fc928cd6c76f02e$var$deriveRenderContext(base, base.slotOwner, slotBoundary, base.slotScopeIds, base.suspense);
}
function $8fc928cd6c76f02e$var$deriveSlotScopeIds(base, slotScopeIds) {
    return $8fc928cd6c76f02e$var$deriveRenderContext(base, base.slotOwner, base.slotBoundary, slotScopeIds, base.suspense);
}
function $8fc928cd6c76f02e$var$deriveSuspense(base, suspense) {
    return $8fc928cd6c76f02e$var$deriveRenderContext(base, base.slotOwner, base.slotBoundary, base.slotScopeIds, suspense);
}
//#endregion
//#region packages/runtime-vapor/src/dom/scopeIdStamp.ts
function $8fc928cd6c76f02e$var$setElementScopeIds(el, scopeIds) {
    for(let i = 0; i < scopeIds.length; i++)el.setAttribute(scopeIds[i], "");
}
function $8fc928cd6c76f02e$var$setElementScopeIdsDeep(el, scopeIds) {
    $8fc928cd6c76f02e$var$setElementScopeIds(el, scopeIds);
    let child = el.firstElementChild;
    while(child){
        $8fc928cd6c76f02e$var$setElementScopeIdsDeep(child, scopeIds);
        child = child.nextElementSibling;
    }
}
/**
* Stamped-variant cache: ids are written once per (template prototype × id
* cell) and clones inherit them via cloneNode. Never stale because scope ids
* are compile-time constants; entries are freed with their cell (WeakMap key).
*/ const $8fc928cd6c76f02e$var$stampedTemplates = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$cloneStampedTemplate(prototype, scopeIds) {
    if (prototype.nodeType !== 1) return prototype.cloneNode(true);
    let variants = $8fc928cd6c76f02e$var$stampedTemplates.get(prototype);
    if (!variants) $8fc928cd6c76f02e$var$stampedTemplates.set(prototype, variants = /* @__PURE__ */ new WeakMap());
    let stamped = variants.get(scopeIds);
    if (!stamped) {
        stamped = prototype.cloneNode(true);
        $8fc928cd6c76f02e$var$setElementScopeIdsDeep(stamped, scopeIds);
        variants.set(scopeIds, stamped);
    }
    return stamped.cloneNode(true);
}
//#endregion
//#region packages/runtime-vapor/src/dom/hydration.ts
const $8fc928cd6c76f02e$var$START_TAG_RE = /^<([^\s/>]+)/;
let $8fc928cd6c76f02e$var$isHydratingEnabled$1 = false;
function $8fc928cd6c76f02e$var$setIsHydratingEnabled(value) {
    $8fc928cd6c76f02e$var$isHydratingEnabled$1 = value;
}
let $8fc928cd6c76f02e$var$currentHydrationNode = null;
let $8fc928cd6c76f02e$var$isHydrating$1 = false;
function $8fc928cd6c76f02e$var$setIsHydrating(value) {
    if (!$8fc928cd6c76f02e$var$isHydratingEnabled$1 && !(0, $3dLyd.isHydrating) && !(0, $3dLyd.isHydratingEnabled)) return false;
    try {
        return $8fc928cd6c76f02e$var$isHydrating$1;
    } finally{
        $8fc928cd6c76f02e$var$isHydrating$1 = value;
    }
}
let $8fc928cd6c76f02e$var$deferredHydrationBoundaryDepth = 0;
function $8fc928cd6c76f02e$var$isInDeferredHydrationBoundary() {
    return $8fc928cd6c76f02e$var$deferredHydrationBoundaryDepth > 0;
}
function $8fc928cd6c76f02e$var$withDeferredHydrationBoundary(fn) {
    $8fc928cd6c76f02e$var$deferredHydrationBoundaryDepth++;
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$deferredHydrationBoundaryDepth--;
    }
}
function $8fc928cd6c76f02e$var$runWithoutHydration(fn) {
    const prev = $8fc928cd6c76f02e$var$setIsHydrating(false);
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$setIsHydrating(prev);
    }
}
let $8fc928cd6c76f02e$var$isOptimized$1 = false;
let $8fc928cd6c76f02e$var$liveCursors = 0;
let $8fc928cd6c76f02e$var$hydrationDepth = 0;
function $8fc928cd6c76f02e$var$performHydration(fn, setup, cleanup) {
    if (!$8fc928cd6c76f02e$var$isOptimized$1) {
        $8fc928cd6c76f02e$var$adoptTemplate = $8fc928cd6c76f02e$var$adoptTemplateImpl;
        $8fc928cd6c76f02e$var$locateHydrationNode = $8fc928cd6c76f02e$var$locateHydrationNodeImpl;
        $8fc928cd6c76f02e$var$parseAdoptTarget = $8fc928cd6c76f02e$var$parseAdoptTargetImpl;
        Comment.prototype.$fe = void 0;
        Node.prototype.$idx = void 0;
        Node.prototype.$llc = void 0;
        Node.prototype.$vha = 0;
        Node.prototype.$rcn = void 0;
        $8fc928cd6c76f02e$var$isOptimized$1 = true;
    }
    const prev = $8fc928cd6c76f02e$var$setIsHydrating(true);
    const prevHydrationNode = $8fc928cd6c76f02e$var$currentHydrationNode;
    $8fc928cd6c76f02e$var$currentHydrationNode = null;
    try {
        setup();
        return fn();
    } finally{
        cleanup();
        $8fc928cd6c76f02e$var$currentHydrationNode = prevHydrationNode;
        $8fc928cd6c76f02e$var$setIsHydrating(prev);
    }
}
function $8fc928cd6c76f02e$var$withHydration(container, fn) {
    const setup = ()=>$8fc928cd6c76f02e$export$c97c22f44c469014(container);
    const cleanup = ()=>$8fc928cd6c76f02e$var$resetInsertionState();
    return $8fc928cd6c76f02e$var$performHydration(fn, setup, cleanup);
}
function $8fc928cd6c76f02e$var$hydrateNode(node, fn) {
    const setup = ()=>$8fc928cd6c76f02e$var$setCurrentHydrationNode(node);
    const cleanup = ()=>{};
    return $8fc928cd6c76f02e$var$performHydration(fn, setup, cleanup);
}
let $8fc928cd6c76f02e$var$adoptTemplate;
let $8fc928cd6c76f02e$var$locateHydrationNode;
let $8fc928cd6c76f02e$var$parseAdoptTarget;
const $8fc928cd6c76f02e$var$isComment = (node, data)=>node.nodeType === 8 && node.data === data;
let $8fc928cd6c76f02e$var$markerlessHydrationContainer = null;
function $8fc928cd6c76f02e$var$setMarkerlessHydrationContainer(container) {
    try {
        return $8fc928cd6c76f02e$var$markerlessHydrationContainer;
    } finally{
        $8fc928cd6c76f02e$var$markerlessHydrationContainer = container;
        $8fc928cd6c76f02e$var$innermostFragmentClaim = null;
    }
}
let $8fc928cd6c76f02e$var$transitionChild = 0;
function $8fc928cd6c76f02e$var$setTransitionChildPending(pending) {
    try {
        return $8fc928cd6c76f02e$var$transitionChild === 1;
    } finally{
        $8fc928cd6c76f02e$var$transitionChild = pending ? 1 : 0;
    }
}
function $8fc928cd6c76f02e$var$createFragmentClaim() {
    return {
        start: null
    };
}
let $8fc928cd6c76f02e$var$innermostFragmentClaim = null;
/**
* Consume the fragment start under the cursor for `claim`, or take over the
* one the enclosing block consumed when nothing was hydrated in between.
*/ function $8fc928cd6c76f02e$var$claimFragmentStart(claim) {
    const node = $8fc928cd6c76f02e$var$currentHydrationNode;
    if (!node || $8fc928cd6c76f02e$var$transitionChild === 2) return;
    if ($8fc928cd6c76f02e$var$isComment(node, "[")) {
        claim.start = node;
        $8fc928cd6c76f02e$var$setCurrentHydrationNode(node.nextSibling);
    } else {
        const outer = $8fc928cd6c76f02e$var$innermostFragmentClaim;
        if (!outer || !outer.start || node !== $8fc928cd6c76f02e$var$skipUntrackedAnchors(outer.start.nextSibling)) return;
        claim.start = outer.start;
        outer.start = null;
    }
    if ($8fc928cd6c76f02e$var$markerlessHydrationContainer) $8fc928cd6c76f02e$var$innermostFragmentClaim = claim;
}
function $8fc928cd6c76f02e$var$setCurrentHydrationNode(node) {
    $8fc928cd6c76f02e$var$currentHydrationNode = $8fc928cd6c76f02e$var$skipUntrackedAnchors(node);
}
function $8fc928cd6c76f02e$var$advanceHydrationNode(node) {
    let next = $8fc928cd6c76f02e$var$skipUntrackedAnchors(node.nextSibling);
    if (next && $8fc928cd6c76f02e$var$currentHydrationNode === next) return;
    while(!next){
        const parent = node.parentNode;
        if (!parent) break;
        node = parent;
        next = $8fc928cd6c76f02e$var$skipUntrackedAnchors(node.nextSibling);
    }
    if ($8fc928cd6c76f02e$var$currentHydrationNode !== next) $8fc928cd6c76f02e$var$currentHydrationNode = next;
}
/**
* Open the block being entered: it is a transition child when the flag was
* armed for its level (element children carry insertion state and are not)
* unless it keeps its markers (component roots); its own content is not.
* Claims registered while it is open are only takeover targets for its
* content.
*/ function $8fc928cd6c76f02e$var$openBlockScope(keepsMarkers) {
    $8fc928cd6c76f02e$var$transitionChild = $8fc928cd6c76f02e$var$transitionChild === 1 && !$8fc928cd6c76f02e$var$insertionParent && !keepsMarkers ? 2 : 0;
}
function $8fc928cd6c76f02e$var$enterHydrationCursor(claim, keepsMarkers) {
    const cursor = $8fc928cd6c76f02e$var$captureHydrationCursor(keepsMarkers);
    $8fc928cd6c76f02e$var$locateHydrationNode(claim);
    cursor.start = $8fc928cd6c76f02e$var$currentHydrationNode;
    return cursor;
}
/**
* Capture the outer resume cursor and open the block scope without locating
* a start node, for dynamic wrappers whose inner owner locates the local
* start later, after the selected inner path is known. This avoids consuming
* insertion state too early.
*/ function $8fc928cd6c76f02e$var$captureHydrationCursor(keepsMarkers) {
    const cursor = {
        start: null,
        resume: $8fc928cd6c76f02e$var$insertionParent ? $8fc928cd6c76f02e$var$currentHydrationNode : void 0,
        transitionChild: $8fc928cd6c76f02e$var$transitionChild,
        innermostFragmentClaim: $8fc928cd6c76f02e$var$innermostFragmentClaim
    };
    $8fc928cd6c76f02e$var$openBlockScope(keepsMarkers);
    return cursor;
}
function $8fc928cd6c76f02e$var$exitHydrationCursor(cursor) {
    if (!cursor) return;
    $8fc928cd6c76f02e$var$transitionChild = cursor.transitionChild;
    $8fc928cd6c76f02e$var$innermostFragmentClaim = cursor.innermostFragmentClaim;
    if (cursor.resume !== void 0) $8fc928cd6c76f02e$var$setCurrentHydrationNode(cursor.resume);
}
/**
* Locate the first non-fragment-comment node and locate the next node
* while handling potential fragments.
*/ function $8fc928cd6c76f02e$var$adoptTemplateImpl(node, template, adoptChildren = false, ns, target = $8fc928cd6c76f02e$var$parseAdoptTargetImpl(template)) {
    if (target.type !== 8) node = target.blank ? $8fc928cd6c76f02e$var$resolveBlankTextTarget(node, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node)) : $8fc928cd6c76f02e$var$resolveHydrationTarget(node);
    if (!$8fc928cd6c76f02e$var$matchesAdoptTarget(node, target)) node = $8fc928cd6c76f02e$var$handleMismatch(node, template, adoptChildren, ns);
    $8fc928cd6c76f02e$var$advanceHydrationNode(node);
    return node;
}
function $8fc928cd6c76f02e$var$nextLogicalSibling(node) {
    return $8fc928cd6c76f02e$var$skipUntrackedAnchors($8fc928cd6c76f02e$var$isComment(node, "[") ? $8fc928cd6c76f02e$var$locateEndAnchor(node).nextSibling : $8fc928cd6c76f02e$var$isComment(node, "teleport start") ? $8fc928cd6c76f02e$var$locateEndAnchor(node, "teleport start", "teleport end").nextSibling : node.nextSibling);
}
/** Advance past anchors that occupy no SSR logical position. */ function $8fc928cd6c76f02e$var$skipUntrackedAnchors(node) {
    while(node !== null && node.$vha & 2)node = node.nextSibling;
    return node;
}
function $8fc928cd6c76f02e$var$locateHydrationNodeImpl(claim) {
    let node;
    if ($8fc928cd6c76f02e$var$insertionAnchor) node = $8fc928cd6c76f02e$var$insertionAnchor;
    else if ($8fc928cd6c76f02e$var$insertionParent) node = $8fc928cd6c76f02e$var$locateChildByLogicalIndex($8fc928cd6c76f02e$var$insertionParent, $8fc928cd6c76f02e$var$insertionIndex || 0);
    else node = $8fc928cd6c76f02e$var$currentHydrationNode;
    $8fc928cd6c76f02e$var$resetInsertionState();
    $8fc928cd6c76f02e$var$setCurrentHydrationNode(node);
    if (claim) $8fc928cd6c76f02e$var$claimFragmentStart(claim);
}
/**
* The end anchor of the SSR fragment starting at `node`, or null when `node`
* is not a fragment start. The candidate-range shape every slot host checks
* before claiming hydrated content.
*/ function $8fc928cd6c76f02e$var$locateFragmentEnd(node) {
    return node && $8fc928cd6c76f02e$var$isComment(node, "[") ? $8fc928cd6c76f02e$var$locateEndAnchor(node) : null;
}
function $8fc928cd6c76f02e$var$locateEndAnchor(node, open = "[", close = "]") {
    if (node.$fe) return node.$fe;
    const stack = [
        node
    ];
    while((node = /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(node)) && stack.length > 0)if (node.nodeType === 8) {
        if (node.data === open) {
            if (node.$fe) node = node.$fe;
            else stack.push(node);
        } else if (node.data === close) {
            const matchingOpen = stack.pop();
            matchingOpen.$fe = node;
            if (stack.length === 0) return node;
        }
    }
    return null;
}
/**
* The close marker of a claimed range once its content hydrated. The cursor
* normally rests on it, so only a mismatch pays for the walk from `start`.
*/ function $8fc928cd6c76f02e$var$locateClaimedEnd(start) {
    const node = $8fc928cd6c76f02e$var$currentHydrationNode;
    if (node && $8fc928cd6c76f02e$var$isComment(node, "]") && !$8fc928cd6c76f02e$var$isClaimedAnchor(node)) return start.$fe = node;
    return $8fc928cd6c76f02e$var$locateEndAnchor(start);
}
function $8fc928cd6c76f02e$var$handleMismatch(node, template, adoptChildren, ns) {
    $8fc928cd6c76f02e$var$warnHydrationNodeMismatch(node, template);
    if ($8fc928cd6c76f02e$var$isComment(node, "[")) $8fc928cd6c76f02e$var$removeFragmentNodes(node);
    const shouldPreserveAnchor = $8fc928cd6c76f02e$var$isClaimedAnchor(node);
    const container = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
    const next = shouldPreserveAnchor ? node : /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(node);
    if (!shouldPreserveAnchor) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(node, container);
    if (template[0] !== "<") {
        const newNode = $8fc928cd6c76f02e$var$markRecreatedNode(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(template));
        container.insertBefore(newNode, next);
        if (!shouldPreserveAnchor) $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(container, node, newNode);
        return newNode;
    }
    const t = /* @__PURE__ */ $8fc928cd6c76f02e$var$createElement("template");
    let newNode;
    if (ns) {
        const tag = ns === 1 ? "svg" : "math";
        t.innerHTML = `<${tag}>${template}</${tag}>`;
        newNode = /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(/* @__PURE__ */ $8fc928cd6c76f02e$var$_child(t.content)).cloneNode(true);
    } else {
        t.innerHTML = template;
        newNode = /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(t.content).cloneNode(true);
    }
    $8fc928cd6c76f02e$var$markRecreatedNode(newNode);
    if (newNode.nodeType === 1) {
        const descendants = newNode.querySelectorAll("*");
        for(let i = 0; i < descendants.length; i++)$8fc928cd6c76f02e$var$markRecreatedNode(descendants[i]);
        const slotScopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
        if (slotScopeIds) $8fc928cd6c76f02e$var$setElementScopeIdsDeep(newNode, slotScopeIds);
    }
    if (adoptChildren && node.nodeType === 1 && !newNode.firstChild) {
        let child = node.firstChild;
        while(child){
            const nextChild = child.nextSibling;
            newNode.appendChild(child);
            child = nextChild;
        }
    }
    container.insertBefore(newNode, next);
    if (!shouldPreserveAnchor) $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(container, node, newNode);
    return newNode;
}
function $8fc928cd6c76f02e$var$parseAdoptTargetImpl(template) {
    let type;
    let tag = null;
    let tagUpper = null;
    let blank = false;
    if (template[0] !== "<") {
        type = 3;
        blank = template.trim() === "";
    } else if (template[1] === "!") type = 8;
    else {
        type = 1;
        const match = $8fc928cd6c76f02e$var$START_TAG_RE.exec(template);
        if (match) {
            tag = match[1].toLowerCase();
            tagUpper = match[1].toUpperCase();
        }
    }
    return {
        type: type,
        tag: tag,
        tagUpper: tagUpper,
        blank: blank
    };
}
/**
* Whether a server-rendered node can be adopted for the given client
* template: the node type must match the template's expected type, and
* element tags must match exactly — a prefix check is not enough
* (e.g. a server `<i>` must not be adopted for a client `<ins>`).
* The uppercase identity compare handles HTML elements without allocating;
* the lowercase fallback covers case-preserving foreign elements (SVG/MathML).
*/ function $8fc928cd6c76f02e$var$matchesAdoptTarget(node, target) {
    if (node.nodeType !== target.type) return false;
    if (target.type !== 1) return true;
    return !target.tag || node.tagName === target.tagUpper || node.tagName.toLowerCase() === target.tag;
}
function $8fc928cd6c76f02e$var$validateHydrationTarget(node, template) {
    if (!$8fc928cd6c76f02e$var$matchesAdoptTarget(node, $8fc928cd6c76f02e$var$parseAdoptTargetImpl(template))) $8fc928cd6c76f02e$var$warnHydrationNodeMismatch(node, template);
}
function $8fc928cd6c76f02e$var$hydrateTextNode(node, expected) {
    if (node.nodeType !== 3) return false;
    const text = node;
    if (text.data === expected) return true;
    const parent = text.parentElement;
    if (parent && !(0, $3dLyd.isMismatchAllowed)(parent, 0)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$warnHydrationTextMismatch(text, expected);
        (0, $3dLyd.logMismatchError)();
    }
    text.data = expected;
    return true;
}
function $8fc928cd6c76f02e$var$warnHydrationTextMismatch(node, expected) {
    (0, $3dLyd.warn)(`Hydration text mismatch in`, node.parentNode, `\n  - rendered on server: ${JSON.stringify(node.data)}\n  - expected on client: ${JSON.stringify(expected)}`);
}
function $8fc928cd6c76f02e$var$warnHydrationNodeMismatch(node, expected) {
    if (!(0, $3dLyd.isMismatchAllowed)(node.parentElement, 1)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $3dLyd.warn)(`Hydration node mismatch:\n- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $8fc928cd6c76f02e$var$isComment(node, "[") ? `(start of fragment)` : ``, `\n- expected on client:`, expected);
        (0, $3dLyd.logMismatchError)();
    }
}
function $8fc928cd6c76f02e$var$removeFragmentNodes(node, endAnchor) {
    const parent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
    if (!parent) return;
    const end = endAnchor || $8fc928cd6c76f02e$var$locateEndAnchor(node);
    while(true){
        const next = /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(node);
        if (next && next !== end) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(next, parent);
        else break;
    }
}
function $8fc928cd6c76f02e$var$removeHydrationNode(node, close = null) {
    const parent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
    if (!parent) return;
    if ($8fc928cd6c76f02e$var$isComment(node, "[")) {
        const end = $8fc928cd6c76f02e$var$locateEndAnchor(node);
        $8fc928cd6c76f02e$var$removeFragmentNodes(node, end || void 0);
        const endParent = end && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(end);
        if (end && end !== close && endParent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(end, endParent);
    } else if ($8fc928cd6c76f02e$var$isComment(node, "teleport start")) {
        const end = $8fc928cd6c76f02e$var$locateEndAnchor(node, "teleport start", "teleport end");
        $8fc928cd6c76f02e$var$removeFragmentNodes(node, end || void 0);
        const endParent = end && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(end);
        if (end && end !== close && endParent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(end, endParent);
    }
    $8fc928cd6c76f02e$export$cd7f480d6b8286c3(node, parent);
}
/**
* Removes unclaimed server-rendered nodes and reports a children mismatch.
* Trims `node` alone by default, the rest of `container`'s child list when
* `container` is given, or the logical siblings up to `close` when leaving a
* hydration boundary (which also moves the cursor onto `close`). Range cleanup
* keeps reused hydration anchors in place.
*/ function $8fc928cd6c76f02e$var$cleanupHydrationTail(node, container, close = null) {
    if (close) {
        let cur = node;
        let hasRemovableNode = false;
        while(cur && cur !== close){
            if (!$8fc928cd6c76f02e$var$isClaimedAnchor(cur)) hasRemovableNode = true;
            cur = $8fc928cd6c76f02e$var$nextLogicalSibling(cur);
        }
        if (!cur) return;
        if (!hasRemovableNode) {
            $8fc928cd6c76f02e$var$setCurrentHydrationNode(close);
            return;
        }
    }
    const mismatchContainer = container || node.parentElement;
    if (mismatchContainer instanceof Element) $8fc928cd6c76f02e$var$warnHydrationChildrenMismatch(mismatchContainer);
    if (!container && !close) {
        $8fc928cd6c76f02e$var$removeHydrationNode(node);
        return;
    }
    let current = node;
    while(current && current !== close && (!container || current.parentNode === container)){
        const next = $8fc928cd6c76f02e$var$nextLogicalSibling(current);
        if (!$8fc928cd6c76f02e$var$isClaimedAnchor(current)) $8fc928cd6c76f02e$var$removeHydrationNode(current, close);
        current = next;
    }
    if (close) $8fc928cd6c76f02e$var$setCurrentHydrationNode(close);
}
/**
* Claim a node as some fragment's insertion anchor standing AT an SSR
* logical position. Claiming a previously untracked anchor promotes it into
* the position stream — a revived deferred branch does this when its runtime
* anchor takes over the logical unit the branch occupies. Use
* `claimUntrackedAnchor` for an anchor that must stay invisible to traversal.
*/ function $8fc928cd6c76f02e$var$claimAnchor(node) {
    node.$vha = 1;
    return node;
}
/**
* Claim a node as an anchor that holds no SSR logical position, so hydration
* traversal steps over it and inserting one mid-pass cannot shift the
* positions the server output defines. See `2`.
*/ function $8fc928cd6c76f02e$var$claimUntrackedAnchor(node) {
    node.$vha = 3;
    return node;
}
/**
* Whether some fragment owns this node as its insertion anchor, whatever its
* origin. Cleanup and mismatch recovery must leave it in place.
*/ function $8fc928cd6c76f02e$var$isClaimedAnchor(node) {
    return !!node && !!(node.$vha & 1);
}
function $8fc928cd6c76f02e$var$markRecreatedNode(node) {
    node.$rcn = 1;
    return node;
}
function $8fc928cd6c76f02e$var$isRecreatedNode(node) {
    return !!node && node.$rcn === 1;
}
/**
* SSR omits empty text nodes. Block owners consume their opening markers
* before template adoption. Preserve any remaining boundary or sibling while
* seeding the missing text at its logical position.
*/ function $8fc928cd6c76f02e$var$resolveBlankTextTarget(node, parent) {
    node = $8fc928cd6c76f02e$var$skipUntrackedAnchors(node);
    if (node && node.nodeType === 3) return node;
    const text = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
    parent.insertBefore(text, node);
    if (node) $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(parent, node, text);
    return text;
}
function $8fc928cd6c76f02e$var$resolveHydrationTarget(node) {
    while(true){
        const flags = node.$vha;
        if (flags) {
            if (!(flags & 2)) return node;
        } else if (!(node.nodeType === 8 && (node.data === "[" || node.data === "]" || node.data === "teleport start" || node.data === "teleport end"))) return node;
        const next = node.nextSibling;
        if (!next) return node;
        node = next;
    }
}
function $8fc928cd6c76f02e$var$warnHydrationChildrenMismatch(container) {
    if (container && !(0, $3dLyd.isMismatchAllowed)(container, 1)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $3dLyd.warn)(`Hydration children mismatch on`, container, `\nServer rendered element contains more child nodes than client nodes.`);
        (0, $3dLyd.logMismatchError)();
    }
}
function $8fc928cd6c76f02e$var$enterHydrationBoundary(close) {
    return ()=>$8fc928cd6c76f02e$var$trimHydrationBoundary(close);
}
/** Trim the unclaimed SSR nodes left between the cursor and `close`. */ function $8fc928cd6c76f02e$var$trimHydrationBoundary(close) {
    const node = $8fc928cd6c76f02e$var$currentHydrationNode;
    if (close && node && node !== close && !(close.compareDocumentPosition(node) & 4)) $8fc928cd6c76f02e$var$cleanupHydrationTail(node, void 0, close);
}
//#endregion
//#region packages/runtime-vapor/src/vdomInteropState.ts
let $8fc928cd6c76f02e$var$isInteropEnabled = false;
function $8fc928cd6c76f02e$var$setInteropEnabled() {
    $8fc928cd6c76f02e$var$isInteropEnabled = true;
}
const $8fc928cd6c76f02e$var$interopKey = Symbol(`interop`);
/**
* Carries the live VDOM slots ref on the raw-slots object handed to a vapor
* component mounted from VDOM. Replaces the old overloaded `_` key, which
* elsewhere means SlotFlags (vdom slots) or VaporSlotStability (slot
* functions).
*/ const $8fc928cd6c76f02e$var$interopSlotsKey = Symbol(`interopSlots`);
//#endregion
//#region packages/runtime-vapor/src/componentEmits.ts
/**
* The logic from core isn't too reusable so it's better to duplicate here
*/ function $8fc928cd6c76f02e$var$normalizeEmitsOptions(comp) {
    const cached = comp.__emitsOptions;
    if (cached) return cached;
    const raw = comp.emits;
    if (!raw) return null;
    let normalized;
    if ((0, $7s0Ms.isArray)(raw)) {
        normalized = {};
        for (const key of raw)normalized[key] = null;
    } else normalized = raw;
    return comp.__emitsOptions = normalized;
}
function $8fc928cd6c76f02e$var$emit(instance, event, ...rawArgs) {
    const vnode = $8fc928cd6c76f02e$var$isInteropEnabled && instance.interopVNode;
    (0, $3dLyd.baseEmit)(instance, vnode ? vnode.props || (0, $7s0Ms.EMPTY_OBJ) : instance.rawProps || (0, $7s0Ms.EMPTY_OBJ), vnode ? (0, $3dLyd.defaultPropGetter) : $8fc928cd6c76f02e$var$getAttrFromRawProps, event, ...rawArgs);
}
//#endregion
//#region packages/runtime-vapor/src/once.ts
/**
* Whether the code running now belongs to a v-once region: slot content or
* fallback rendered by a `<slot v-once>`, or a compiled v-once directive.
* While set, renderEffect runs its function once instead of creating an
* effect. Every component boundary resets it (Vapor setup, vdom mount), and
* deferred work captures it at creation. Call sites test `inOnce` first so
* the common path pays neither the closure nor the call.
*/ let $8fc928cd6c76f02e$var$inOnce = false;
function $8fc928cd6c76f02e$export$81831a240bcfd22e(fn, value = true) {
    if ($8fc928cd6c76f02e$var$inOnce === value) return fn();
    const prev = $8fc928cd6c76f02e$var$inOnce;
    try {
        $8fc928cd6c76f02e$var$inOnce = value;
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$inOnce = prev;
    }
}
//#endregion
//#region packages/runtime-vapor/src/suspense.ts
let $8fc928cd6c76f02e$var$isSuspenseEnabled = false;
let $8fc928cd6c76f02e$var$currentUnmountSuspense;
function $8fc928cd6c76f02e$var$enableSuspense() {
    $8fc928cd6c76f02e$var$isSuspenseEnabled = true;
}
function $8fc928cd6c76f02e$var$setCurrentUnmountSuspense(suspense) {
    try {
        return $8fc928cd6c76f02e$var$currentUnmountSuspense;
    } finally{
        $8fc928cd6c76f02e$var$currentUnmountSuspense = suspense;
    }
}
/**
* Establishes `suspense` as the active unmount pass's boundary around `fn`.
* The single entry point for the ambient: unmountComponent and the interop
* vnode unmount re-enter through this when their explicit argument differs
* from the active pass.
*/ function $8fc928cd6c76f02e$var$runWithUnmountSuspense(suspense, fn) {
    const prev = $8fc928cd6c76f02e$var$setCurrentUnmountSuspense(suspense);
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$setCurrentUnmountSuspense(prev);
    }
}
/**
* The effective boundary for a teardown reached without a parameter channel —
* scope-disposal callbacks and block removal: the active unmount pass's
* boundary when one is set, the caller's fallback otherwise.
*/ function $8fc928cd6c76f02e$var$resolveUnmountSuspense(fallback) {
    return $8fc928cd6c76f02e$var$currentUnmountSuspense === void 0 ? fallback : $8fc928cd6c76f02e$var$currentUnmountSuspense;
}
//#endregion
//#region packages/runtime-vapor/src/renderEffect.ts
var $8fc928cd6c76f02e$var$RenderEffect = class extends (0, $SdEQh.ReactiveEffect) {
    constructor(render, noLifecycle = false){
        super(noLifecycle ? render : void 0);
        this.render = render;
        const instance = (0, $3dLyd.currentInstance);
        this.order = instance ? instance.effectCount++ : 0;
        var e, e1;
        this.i = instance;
        this.job = void 0;
        this.flags |= 128;
    }
    createJob() {
        const job = ()=>{
            if (!(this.flags & 256) && this.dirty) {
                const deferred = $8fc928cd6c76f02e$var$isSuspenseEnabled && this.i && this.i.deferredKeepAliveUpdates;
                if (deferred) {
                    if ($8fc928cd6c76f02e$var$isDeferredKeepAliveStateLive(deferred)) {
                        deferred.effects.push(job);
                        return;
                    }
                    $8fc928cd6c76f02e$var$settleDeferredKeepAliveUpdates(deferred, job);
                    return;
                }
                this.run();
            }
        };
        if (this.i) job.i = this.i;
        job.flags |= 2;
        return this.job = job;
    }
    fn() {
        const instance = this.i;
        const scope = this.subs ? this.subs.sub : void 0;
        const hasUpdateHooks = instance && (instance.bu || instance.u);
        const prev = (0, $3dLyd.setCurrentInstance)(instance, scope);
        try {
            if (hasUpdateHooks && instance.isMounted && !instance.isUpdating) {
                instance.isUpdating = true;
                try {
                    instance.bu && (0, $7s0Ms.invokeArrayFns)(instance.bu);
                    this.render();
                } catch (err) {
                    instance.isUpdating = false;
                    throw err;
                }
                let updateJob = this.updateJob;
                if (!updateJob) updateJob = this.updateJob = ()=>{
                    instance.isUpdating = false;
                    instance.u && (0, $7s0Ms.invokeArrayFns)(instance.u);
                };
                (0, $3dLyd.queuePostRenderEffect)(updateJob, void 0, instance.suspense);
            } else this.render();
        } finally{
            (0, $3dLyd.restoreCurrentInstance)(prev);
        }
    }
    notify() {
        if (!(this.flags & 256)) (0, $3dLyd.queueJob)(this.job || this.createJob(), this.i ? this.i.uid : void 0, false, this.order);
    }
};
function $8fc928cd6c76f02e$export$6c64e011838f4702(fn, noLifecycle = false) {
    if ($8fc928cd6c76f02e$var$inOnce) return fn();
    new $8fc928cd6c76f02e$var$RenderEffect(fn, noLifecycle).run();
}
//#endregion
//#region packages/runtime-vapor/src/componentProps.ts
function $8fc928cd6c76f02e$var$isolatePropSources(rawProps) {
    let hasFunctionSource = false;
    for(const key in rawProps)if (key !== "$" && (0, $7s0Ms.isFunction)(rawProps[key])) hasFunctionSource = true;
    const dynamicSources = rawProps.$;
    if (dynamicSources && !hasFunctionSource) for(let i = 0; i < dynamicSources.length; i++){
        const source = dynamicSources[i];
        if ((0, $7s0Ms.isFunction)(source)) {
            hasFunctionSource = true;
            break;
        } else {
            for(const key in source)if ((0, $7s0Ms.isFunction)(source[key])) {
                hasFunctionSource = true;
                break;
            }
            if (hasFunctionSource) break;
        }
    }
    if (!hasFunctionSource) return rawProps;
    const isolated = Object.create(null);
    let committed;
    for(const key in rawProps){
        if (key === "$") continue;
        const source = rawProps[key];
        if ((0, $7s0Ms.isFunction)(source)) {
            const target = committed || (committed = (0, $SdEQh.shallowReactive)({}));
            isolated[key] = ()=>target[key];
        } else isolated[key] = source;
    }
    let committedDynamicSources;
    let previousDynamicSources;
    if (dynamicSources) {
        const isolatedDynamicSources = [];
        committedDynamicSources = [];
        previousDynamicSources = [];
        for(let i = 0; i < dynamicSources.length; i++){
            const source = dynamicSources[i];
            if ((0, $7s0Ms.isFunction)(source)) {
                const target = committedDynamicSources[i] = (0, $SdEQh.shallowReactive)({});
                previousDynamicSources[i] = {};
                isolatedDynamicSources[i] = ()=>target;
            } else {
                const isolatedSource = Object.create(null);
                let target;
                for(const key in source){
                    const value = source[key];
                    if ((0, $7s0Ms.isFunction)(value)) {
                        if (!target) target = committedDynamicSources[i] = (0, $SdEQh.shallowReactive)({});
                        const committedSource = target;
                        isolatedSource[key] = ()=>committedSource[key];
                    } else isolatedSource[key] = value;
                }
                isolatedDynamicSources[i] = target ? isolatedSource : source;
            }
        }
        const symbols = Object.getOwnPropertySymbols(dynamicSources);
        for(let i = 0; i < symbols.length; i++)isolatedDynamicSources[symbols[i]] = dynamicSources[symbols[i]];
        isolated.$ = isolatedDynamicSources;
    }
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        if (committed) {
            for(const key in rawProps)if (key !== "$" && (0, $7s0Ms.isFunction)(rawProps[key])) committed[key] = $8fc928cd6c76f02e$var$resolveSource(rawProps[key]);
        }
        if (dynamicSources) for(let i = 0; i < dynamicSources.length; i++){
            const source = dynamicSources[i];
            const target = committedDynamicSources[i];
            if (!target) continue;
            if ((0, $7s0Ms.isFunction)(source)) {
                const next = $8fc928cd6c76f02e$var$resolveFunctionSource(source) || (0, $7s0Ms.EMPTY_OBJ);
                const previous = previousDynamicSources[i];
                for(const key in previous)if (!(0, $7s0Ms.hasOwn)(next, key)) {
                    delete target[key];
                    delete previous[key];
                }
                for(const key in next)target[key] = previous[key] = next[key];
            } else for(const key in source)if ((0, $7s0Ms.isFunction)(source[key])) target[key] = $8fc928cd6c76f02e$var$resolveSource(source[key]);
        }
    }, true);
    return isolated;
}
function $8fc928cd6c76f02e$var$resolveSource(source) {
    return (0, $7s0Ms.isFunction)(source) ? $8fc928cd6c76f02e$var$resolveFunctionSource(source) : source;
}
function $8fc928cd6c76f02e$var$resolveFunctionSource(source) {
    if (source._cache) return source._cache.value;
    const parent = (0, $3dLyd.currentInstance) && (0, $3dLyd.currentInstance).parent;
    if (parent) {
        const prev = (0, $3dLyd.setCurrentInstance)(parent, (0, $SdEQh.getCurrentScope)());
        try {
            source._cache = (0, $SdEQh.computed)((oldValue)=>{
                const prevInner = (0, $3dLyd.setCurrentInstance)(parent);
                try {
                    return $8fc928cd6c76f02e$var$stabilizeDynamicSourceValue(oldValue, source());
                } finally{
                    (0, $3dLyd.restoreCurrentInstance)(prevInner);
                }
            });
            (0, $SdEQh.onScopeDispose)(()=>source._cache = void 0);
        } finally{
            (0, $3dLyd.restoreCurrentInstance)(prev);
        }
        return source._cache.value;
    }
    return source();
}
function $8fc928cd6c76f02e$var$snapshotRawProps(rawProps) {
    const snapshot = Object.create(null);
    for(const key in rawProps)if (key !== "$") snapshot[key] = $8fc928cd6c76f02e$var$freezeValue(key, $8fc928cd6c76f02e$var$readSource(rawProps[key]));
    const dynamicSources = rawProps.$;
    if (dynamicSources) {
        const snapshotSources = [];
        for(let i = 0; i < dynamicSources.length; i++){
            const source = dynamicSources[i];
            const isDynamic = (0, $7s0Ms.isFunction)(source);
            const resolved = $8fc928cd6c76f02e$var$readSource(source) || (0, $7s0Ms.EMPTY_OBJ);
            const value = Object.create(null);
            for(const key in resolved)value[key] = $8fc928cd6c76f02e$var$freezeValue(key, isDynamic ? resolved[key] : $8fc928cd6c76f02e$var$readSource(resolved[key]));
            snapshotSources[i] = value;
        }
        const symbols = Object.getOwnPropertySymbols(dynamicSources);
        for(let i = 0; i < symbols.length; i++)snapshotSources[symbols[i]] = dynamicSources[symbols[i]];
        snapshot.$ = snapshotSources;
    }
    return snapshot;
}
function $8fc928cd6c76f02e$var$readSource(source) {
    return (0, $7s0Ms.isFunction)(source) ? source() : source;
}
function $8fc928cd6c76f02e$var$freezeValue(key, value) {
    if (key === "class" && value && !(0, $7s0Ms.isString)(value)) return (0, $7s0Ms.normalizeClass)(value);
    if (key === "style" && (0, $7s0Ms.isArray)(value)) return (0, $7s0Ms.normalizeStyle)(value);
    return (0, $7s0Ms.isFunction)(value) ? ()=>value : value;
}
function $8fc928cd6c76f02e$var$stabilizeDynamicSourceValue(oldValue, value) {
    if (!(0, $7s0Ms.isPlainObject)(oldValue) || !(0, $7s0Ms.isPlainObject)(value)) return value;
    const oldKeys = Object.keys(oldValue);
    const newKeys = Object.keys(value);
    if (oldKeys.length !== newKeys.length) return value;
    for(let i = 0; i < newKeys.length; i++){
        const key = newKeys[i];
        if (!(0, $7s0Ms.hasOwn)(oldValue, key) || !Object.is(oldValue[key], value[key])) return value;
    }
    return oldValue;
}
function $8fc928cd6c76f02e$var$getPropsProxyHandlers(comp) {
    if (comp.__propsHandlers) return comp.__propsHandlers;
    const propsOptions = $8fc928cd6c76f02e$var$normalizePropsOptions(comp)[0];
    const emitsOptions = $8fc928cd6c76f02e$var$normalizeEmitsOptions(comp);
    const isProp = propsOptions ? (key)=>(0, $7s0Ms.isString)(key) && (0, $7s0Ms.hasOwn)(propsOptions, (0, $7s0Ms.camelize)(key)) : (0, $7s0Ms.NO);
    const isAttr = propsOptions || emitsOptions ? (key)=>(0, $7s0Ms.isString)(key) && key !== "$" && !(0, $7s0Ms.isReservedProp)(key) && !isProp(key) && !(0, $3dLyd.isEmitListener)(emitsOptions, key) : (key)=>(0, $7s0Ms.isString)(key) && !(0, $7s0Ms.isReservedProp)(key);
    const normalizeRawProp = (key, value)=>{
        if (!value) return value;
        if (key === "class" && !(0, $7s0Ms.isString)(value)) return (0, $7s0Ms.normalizeClass)(value);
        if (key === "style" && (0, $7s0Ms.isObject)(value)) return (0, $7s0Ms.normalizeStyle)(value);
        return value;
    };
    const getProp = (instance, key)=>{
        if (key === "__v_isReactive" || key === "__v_isShallow") return true;
        if (!isProp(key)) return;
        const rawProps = instance.rawProps;
        const dynamicSources = rawProps.$;
        if (dynamicSources && (0, $7s0Ms.isOn)(key)) {
            const handlers = {};
            let matchedKey;
            for(let i = -1; i < dynamicSources.length; i++){
                const source = i < 0 ? rawProps : dynamicSources[i];
                const isDynamic = (0, $7s0Ms.isFunction)(source);
                const resolved = isDynamic ? $8fc928cd6c76f02e$var$resolveFunctionSource(source) : source;
                for(const rawKey in resolved)if ((0, $7s0Ms.camelize)(rawKey) === key) {
                    if (!(0, $7s0Ms.hasOwn)(handlers, rawKey)) matchedKey = rawKey;
                    const value = isDynamic ? resolved[rawKey] : $8fc928cd6c76f02e$var$resolveSource(resolved[rawKey]);
                    handlers[rawKey] = $8fc928cd6c76f02e$var$mergeEventHandlers(handlers[rawKey], value);
                }
            }
            return (0, $3dLyd.resolvePropValue)(propsOptions, key, matchedKey === void 0 ? void 0 : handlers[matchedKey], instance, $8fc928cd6c76f02e$var$resolveDefault, matchedKey === void 0);
        }
        const merged = dynamicSources && (key === "class" || key === "style") ? [] : void 0;
        if (dynamicSources) {
            let i = dynamicSources.length;
            let source, isDynamic, rawKey;
            while(i--){
                source = dynamicSources[i];
                isDynamic = (0, $7s0Ms.isFunction)(source);
                source = isDynamic ? $8fc928cd6c76f02e$var$resolveFunctionSource(source) : source;
                for(rawKey in source)if ((0, $7s0Ms.camelize)(rawKey) === key) {
                    const value = isDynamic ? source[rawKey] : $8fc928cd6c76f02e$var$resolveSource(source[rawKey]);
                    if (merged) merged.push(value);
                    else return (0, $3dLyd.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value), instance, $8fc928cd6c76f02e$var$resolveDefault);
                }
            }
        }
        for(const rawKey in rawProps)if ((0, $7s0Ms.camelize)(rawKey) === key) {
            const value = $8fc928cd6c76f02e$var$resolveSource(rawProps[rawKey]);
            if (merged) merged.push(value);
            else return (0, $3dLyd.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value), instance, $8fc928cd6c76f02e$var$resolveDefault);
        }
        const hasMerged = !!(merged && merged.length);
        let value;
        if (hasMerged) {
            if (merged.length === 1) value = merged[0];
            else if (key === "class") {
                for(let i = merged.length - 1; i >= 0; i--)if (value !== merged[i]) value = (0, $7s0Ms.normalizeClass)([
                    value,
                    merged[i]
                ]);
            } else value = merged.reverse();
        }
        return (0, $3dLyd.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value), instance, $8fc928cd6c76f02e$var$resolveDefault, !hasMerged);
    };
    const propsHandlers = propsOptions ? {
        get: getProp,
        has: (_, key)=>isProp(key),
        ownKeys: ()=>Object.keys(propsOptions),
        getOwnPropertyDescriptor (target, key) {
            if (isProp(key)) return {
                configurable: true,
                enumerable: true,
                get: ()=>getProp(target, key)
            };
        }
    } : null;
    const getAttr = (target, key)=>{
        if ((0, $7s0Ms.isString)(key) && !(0, $7s0Ms.isReservedProp)(key) && !isProp(key) && !(0, $3dLyd.isEmitListener)(emitsOptions, key)) return $8fc928cd6c76f02e$var$getAttrFromRawProps(target, key);
    };
    const hasAttr = (target, key)=>{
        if (isAttr(key)) return $8fc928cd6c76f02e$var$hasAttrFromRawProps(target, key);
        else return false;
    };
    const getAttrKeys = (target)=>$8fc928cd6c76f02e$var$getKeysFromRawProps(target.rawProps).filter(isAttr);
    const attrsHandlers = {
        get: (target, key)=>getAttr(target.rawProps, key),
        has: (target, key)=>hasAttr(target.rawProps, key),
        ownKeys: getAttrKeys,
        getOwnPropertyDescriptor (target, key) {
            if ((0, $7s0Ms.isString)(key) && hasAttr(target.rawProps, key)) return {
                configurable: true,
                enumerable: true,
                get: ()=>getAttr(target.rawProps, key)
            };
        }
    };
    return comp.__propsHandlers = [
        propsHandlers,
        attrsHandlers
    ];
}
function $8fc928cd6c76f02e$var$getAttrFromRawProps(rawProps, key) {
    if (key === "$") return;
    const dynamicSources = rawProps.$;
    const isEvent = dynamicSources && (0, $7s0Ms.isString)(key) && (0, $7s0Ms.isOn)(key);
    const merged = key === "class" || key === "style" || isEvent ? [] : void 0;
    if (dynamicSources) {
        let i = dynamicSources.length;
        let source, isDynamic;
        while(i--){
            source = dynamicSources[i];
            isDynamic = (0, $7s0Ms.isFunction)(source);
            source = isDynamic ? $8fc928cd6c76f02e$var$resolveFunctionSource(source) : source;
            if (source && (0, $7s0Ms.hasOwn)(source, key)) {
                const value = isDynamic ? source[key] : $8fc928cd6c76f02e$var$resolveSource(source[key]);
                if (merged) merged.push(value);
                else return value;
            }
        }
    }
    if ((0, $7s0Ms.hasOwn)(rawProps, key)) {
        const value = $8fc928cd6c76f02e$var$resolveSource(rawProps[key]);
        if (merged) merged.push(value);
        else return value;
    }
    if (merged && merged.length) {
        merged.reverse();
        return isEvent ? merged.reduce($8fc928cd6c76f02e$var$mergeEventHandlers) : merged;
    }
}
function $8fc928cd6c76f02e$var$mergeEventHandlers(existing, incoming) {
    if (!existing) return incoming;
    return incoming && existing !== incoming && !((0, $7s0Ms.isArray)(existing) && existing.includes(incoming)) ? [].concat(existing, incoming) : existing;
}
function $8fc928cd6c76f02e$var$hasAttrFromRawProps(rawProps, key) {
    if (key === "$") return false;
    const dynamicSources = rawProps.$;
    if (dynamicSources) {
        let i = dynamicSources.length;
        while(i--){
            const source = $8fc928cd6c76f02e$var$resolveSource(dynamicSources[i]);
            if (source && (0, $7s0Ms.hasOwn)(source, key)) return true;
        }
    }
    return (0, $7s0Ms.hasOwn)(rawProps, key);
}
function $8fc928cd6c76f02e$var$getKeysFromRawProps(rawProps) {
    const keys = [];
    for(const key in rawProps)if (key !== "$") keys.push(key);
    const dynamicSources = rawProps.$;
    if (dynamicSources) {
        let i = dynamicSources.length;
        let source;
        while(i--){
            source = (0, $7s0Ms.isFunction)(dynamicSources[i]) ? $8fc928cd6c76f02e$var$resolveFunctionSource(dynamicSources[i]) : dynamicSources[i];
            for(const key in source)keys.push(key);
        }
    }
    return Array.from(new Set(keys));
}
function $8fc928cd6c76f02e$var$normalizePropsOptions(comp) {
    const cached = comp.__propsOptions;
    if (cached) return cached;
    const raw = comp.props;
    if (!raw) return 0, $7s0Ms.EMPTY_ARR;
    const normalized = {};
    const needCastKeys = [];
    (0, $3dLyd.baseNormalizePropsOptions)(raw, normalized, needCastKeys);
    return comp.__propsOptions = [
        normalized,
        needCastKeys
    ];
}
function $8fc928cd6c76f02e$var$resolveDefault(factory, instance) {
    const prev = (0, $3dLyd.setCurrentInstance)(instance);
    const res = factory.call(null, instance.props);
    (0, $3dLyd.restoreCurrentInstance)(prev);
    return res;
}
function $8fc928cd6c76f02e$var$hasFallthroughAttrs(comp, rawProps) {
    if (rawProps) {
        if (rawProps.$) return true;
        const propsOptions = comp.props ? $8fc928cd6c76f02e$var$normalizePropsOptions(comp)[0] : null;
        for(const key in rawProps)if (!propsOptions || !(0, $7s0Ms.hasOwn)(propsOptions, (0, $7s0Ms.camelize)(key))) return true;
    }
    return false;
}
/**
* dev only
*/ function $8fc928cd6c76f02e$var$setupPropsValidation(instance, warningContext = instance) {
    const rawProps = instance.rawProps;
    if (!rawProps) return;
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        (0, $3dLyd.pushWarningContext)(warningContext);
        (0, $3dLyd.validateProps)($8fc928cd6c76f02e$var$resolveDynamicProps(rawProps), instance.props, $8fc928cd6c76f02e$var$normalizePropsOptions(instance.type)[0]);
        (0, $3dLyd.popWarningContext)();
    }, true);
}
function $8fc928cd6c76f02e$var$resolveDynamicProps(props) {
    const mergedRawProps = {};
    for(const key in props)if (key !== "$") mergedRawProps[key] = $8fc928cd6c76f02e$var$resolveSource(props[key]);
    if (props.$) for (const source of props.$){
        const isDynamic = (0, $7s0Ms.isFunction)(source);
        const resolved = isDynamic ? $8fc928cd6c76f02e$var$resolveFunctionSource(source) : source;
        for(const key in resolved){
            const value = isDynamic ? resolved[key] : $8fc928cd6c76f02e$var$resolveSource(source[key]);
            if (key === "class" || key === "style") {
                const existing = mergedRawProps[key];
                mergedRawProps[key] = (0, $7s0Ms.isArray)(existing) ? [
                    ...existing,
                    value
                ] : [
                    existing,
                    value
                ];
            } else if ((0, $7s0Ms.isOn)(key)) mergedRawProps[key] = $8fc928cd6c76f02e$var$mergeEventHandlers(mergedRawProps[key], value);
            else mergedRawProps[key] = value;
        }
    }
    return mergedRawProps;
}
function $8fc928cd6c76f02e$var$propsSetDevTrap(_, key) {
    (0, $3dLyd.warn)(`Attempt to mutate prop ${JSON.stringify(key)} failed. Props are readonly.`);
    return true;
}
function $8fc928cd6c76f02e$var$propsDeleteDevTrap(_, key) {
    (0, $3dLyd.warn)(`Attempt to delete prop ${JSON.stringify(key)} failed. Props are readonly.`);
    return true;
}
const $8fc928cd6c76f02e$var$rawPropsProxyHandlers = {
    get: $8fc928cd6c76f02e$var$getAttrFromRawProps,
    has: $8fc928cd6c76f02e$var$hasAttrFromRawProps,
    ownKeys: $8fc928cd6c76f02e$var$getKeysFromRawProps,
    getOwnPropertyDescriptor (target, key) {
        if ($8fc928cd6c76f02e$var$hasAttrFromRawProps(target, key)) return {
            configurable: true,
            enumerable: true,
            get: ()=>$8fc928cd6c76f02e$var$getAttrFromRawProps(target, key)
        };
    }
};
//#endregion
//#region packages/runtime-vapor/src/dom/event.ts
function $8fc928cd6c76f02e$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
    return ()=>el.removeEventListener(event, handler, options);
}
function $8fc928cd6c76f02e$export$af631764ddc44097(el, event, handler, options) {
    if ((0, $7s0Ms.isArray)(handler)) handler.forEach((fn)=>$8fc928cd6c76f02e$export$af631764ddc44097(el, event, fn, options));
    else {
        if (!handler) return;
        el.addEventListener(event, $8fc928cd6c76f02e$export$a1d07c64020e8889(handler), options);
    }
}
function $8fc928cd6c76f02e$export$1583747b0ccdaa69(el, event, handler, options) {
    if ((0, $7s0Ms.isArray)(handler)) {
        handler.forEach((fn)=>$8fc928cd6c76f02e$export$1583747b0ccdaa69(el, event, fn, options));
        return;
    }
    if (!handler) return;
    if (options && options.once) {
        const firedKey = `$evtonce_${options.capture ? 1 : 0}_${event}`;
        if (el[firedKey]) return;
        const invoker = handler;
        handler = (...args)=>{
            el[firedKey] = true;
            return invoker(...args);
        };
    }
    const cleanup = $8fc928cd6c76f02e$var$addEventListener(el, event, $8fc928cd6c76f02e$export$a1d07c64020e8889(handler), options);
    (0, $SdEQh.onEffectCleanup)(cleanup);
}
function $8fc928cd6c76f02e$export$10b1921597150314(el, event, handler) {
    const key = `$evt${event}`;
    const existing = el[key];
    const invoker = $8fc928cd6c76f02e$export$a1d07c64020e8889(handler);
    if (existing) {
        if ((0, $7s0Ms.isArray)(existing)) existing.push(invoker);
        else el[key] = [
            existing,
            invoker
        ];
    } else el[key] = invoker;
}
/**
* Event delegation borrowed from solid
*/ const $8fc928cd6c76f02e$var$delegatedEvents = /*@__PURE__*/ Object.create(null);
const $8fc928cd6c76f02e$export$ad0f7f87f67e17d6 = (...names)=>{
    for (const name of names)if (!$8fc928cd6c76f02e$var$delegatedEvents[name]) {
        $8fc928cd6c76f02e$var$delegatedEvents[name] = true;
        document.addEventListener(name, $8fc928cd6c76f02e$var$delegatedEventHandler);
    }
};
const $8fc928cd6c76f02e$var$delegatedEventHandler = (e)=>{
    let node = e.composedPath && e.composedPath()[0] || e.target;
    if (e.target !== node) Object.defineProperty(e, "target", {
        configurable: true,
        value: node
    });
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    while(node !== null){
        const handlers = node[`$evt${e.type}`];
        if (handlers) {
            if ((0, $7s0Ms.isArray)(handlers)) {
                for (const handler of handlers)if (!node.disabled) {
                    handler(e);
                    if (e.cancelBubble) return;
                }
            } else if (!node.disabled) {
                handlers(e);
                if (e.cancelBubble) return;
            }
        }
        node = node.host && node.host !== node && node.host instanceof Node ? node.host : node.parentNode;
    }
};
function $8fc928cd6c76f02e$export$8fcd6a995a854c39(el, events) {
    for(const name in events){
        const [event, options] = (0, $bmuEm.parseEventName)(`on:${name}`);
        $8fc928cd6c76f02e$export$1583747b0ccdaa69(el, event, events[name], options);
    }
}
function $8fc928cd6c76f02e$export$57d458c682274bab(fn, modifiers) {
    return $8fc928cd6c76f02e$export$a1d07c64020e8889(typeof fn === "function" ? (0, $bmuEm.withModifiers)(fn, modifiers) : fn);
}
function $8fc928cd6c76f02e$export$b41fa5aac87099ed(fn, modifiers) {
    return $8fc928cd6c76f02e$export$a1d07c64020e8889(typeof fn === "function" ? (0, $bmuEm.withKeys)(fn, modifiers) : fn);
}
function $8fc928cd6c76f02e$export$a1d07c64020e8889(handler) {
    const i = (0, $3dLyd.currentInstance);
    return (...args)=>(0, $3dLyd.callWithAsyncErrorHandling)(handler, i, 5, args);
}
//#endregion
//#region packages/runtime-vapor/src/transition.ts
let $8fc928cd6c76f02e$var$applyTransitionHooks;
let $8fc928cd6c76f02e$var$applyTransitionLeaveHooks;
let $8fc928cd6c76f02e$var$deferBranchUpdateDuringLeave;
let $8fc928cd6c76f02e$var$removeBranchWithLeave;
let $8fc928cd6c76f02e$var$isTransitionEnabled = false;
function $8fc928cd6c76f02e$var$registerTransitionHooks(applyHooks, applyLeaveHooks, deferBranchUpdate, removeBranch) {
    $8fc928cd6c76f02e$var$isTransitionEnabled = true;
    $8fc928cd6c76f02e$var$applyTransitionHooks = applyHooks;
    $8fc928cd6c76f02e$var$applyTransitionLeaveHooks = applyLeaveHooks;
    $8fc928cd6c76f02e$var$deferBranchUpdateDuringLeave = deferBranchUpdate;
    $8fc928cd6c76f02e$var$removeBranchWithLeave = removeBranch;
}
const $8fc928cd6c76f02e$var$displayName = "VaporTransition";
function $8fc928cd6c76f02e$var$isVaporTransition(component) {
    return component.displayName === $8fc928cd6c76f02e$var$displayName;
}
//#endregion
//#region packages/runtime-vapor/src/dom/prop.ts
const $8fc928cd6c76f02e$var$shouldSkipFallthroughKey = (el, key)=>{
    const instance = (0, $3dLyd.currentInstance);
    return !$8fc928cd6c76f02e$var$isApplyingFallthroughProps && el.$root && instance.hasFallthrough && instance.type.inheritAttrs !== false && key in instance.attrs && !$8fc928cd6c76f02e$var$isDeclaredModelListener(instance, key) && (!$8fc928cd6c76f02e$var$shouldUseFunctionalFallthrough(instance.type) || (0, $3dLyd.isFunctionalFallthroughKey)(key));
};
function $8fc928cd6c76f02e$export$8a39838a0f735648(el, key, value) {
    if (key in el) $8fc928cd6c76f02e$export$c16cd4a7fa698f59(el, key, value);
    else $8fc928cd6c76f02e$export$c609e428011345f3(el, key, value);
}
function $8fc928cd6c76f02e$export$c609e428011345f3(el, key, value, isSVG = false) {
    if ($8fc928cd6c76f02e$var$shouldSkipFallthroughKey(el, key)) return;
    if (key === "true-value") el._trueValue = value;
    else if (key === "false-value") el._falseValue = value;
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$attributeHasMismatch(el, key, value);
        el[`$${key}`] = value;
        return;
    }
    if (value !== el[`$${key}`]) {
        el[`$${key}`] = value;
        if (isSVG && key.startsWith("xlink:")) {
            if (value != null) el.setAttributeNS((0, $bmuEm.xlinkNS), key, value);
            else el.removeAttributeNS((0, $bmuEm.xlinkNS), key.slice(6, key.length));
        } else {
            const isBoolean = (0, $7s0Ms.isSpecialBooleanAttr)(key);
            if (value == null || isBoolean && !(0, $7s0Ms.includeBooleanAttr)(value)) el.removeAttribute(key);
            else el.setAttribute(key, isBoolean ? "" : (0, $7s0Ms.isSymbol)(value) ? String(value) : value);
        }
    }
}
function $8fc928cd6c76f02e$export$c16cd4a7fa698f59(el, key, value, forceHydrate = false, attrName) {
    if ($8fc928cd6c76f02e$var$shouldSkipFallthroughKey(el, key)) return;
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$attributeHasMismatch(el, key, value);
        if (!forceHydrate && !$8fc928cd6c76f02e$var$shouldForceHydrate(el, key)) return;
    }
    const cacheKey = `$p$${key}`;
    if (value === el[cacheKey] && cacheKey in el) return;
    el[cacheKey] = value;
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $7s0Ms.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $8fc928cd6c76f02e$export$2796c4ce44e61efa(el, value, isSVG = false, isNormalized = false) {
    if (el.$clsFlags !== void 0) el.$clsFlags = void 0;
    if (el.$root) $8fc928cd6c76f02e$var$setClassIncremental(el, value, isNormalized);
    else {
        if (!isNormalized) value = (0, $7s0Ms.normalizeClass)(value);
        if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$classHasMismatch(el, value, false);
            el.$cls = value;
            return;
        }
        if (value !== el.$cls) {
            el.$cls = value;
            if ($8fc928cd6c76f02e$var$isTransitionEnabled) (0, $bmuEm.patchClass)(el, value, isSVG);
            else if (isSVG) el.setAttribute("class", value);
            else el.className = value;
        }
    }
}
function $8fc928cd6c76f02e$export$826e926e0c74f2b8(el, flags, cls, prefix = "", suffix = "") {
    if (flags === el.$clsFlags) return;
    let value = prefix;
    if ((0, $7s0Ms.isString)(cls)) {
        if (flags & 1) value += cls;
    } else for(let i = 0, bit = 1; i < cls.length; i++, bit <<= 1)if (flags & bit) value += cls[i];
    if (!prefix && value.charCodeAt(0) === 32) value = value.slice(1);
    if (suffix) value = value ? `${value} ${suffix}` : suffix;
    if (el.$root || $8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$export$2796c4ce44e61efa(el, value, false, true);
    else {
        el.$cls = value;
        if ($8fc928cd6c76f02e$var$isTransitionEnabled) (0, $bmuEm.patchClass)(el, value, false);
        else el.className = value;
    }
    el.$clsFlags = flags;
}
function $8fc928cd6c76f02e$var$setClassIncremental(el, value, isNormalized = false) {
    const cacheKey = `$clsi${$8fc928cd6c76f02e$var$isApplyingFallthroughProps ? "$" : ""}`;
    const normalizedValue = isNormalized ? value : (0, $7s0Ms.normalizeClass)(value);
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$classHasMismatch(el, normalizedValue, true);
        el[cacheKey] = normalizedValue;
        return;
    }
    const prev = el[cacheKey];
    if ((value = el[cacheKey] = normalizedValue) !== prev) {
        const nextList = value.split(/\s+/);
        if (value) el.classList.add(...nextList);
        if (prev) {
            for (const cls of prev.split(/\s+/))if (!nextList.includes(cls)) el.classList.remove(cls);
        }
    }
}
function $8fc928cd6c76f02e$var$shouldDeferCheckStyleMismatch(el) {
    return $8fc928cd6c76f02e$var$hasCssVarsInOwnerChain((0, $3dLyd.currentInstance)) || $8fc928cd6c76f02e$var$hasCssVars(el.style);
}
function $8fc928cd6c76f02e$var$hasCssVarsInOwnerChain(instance) {
    while(instance){
        if (instance.getCssVars) return true;
        instance = instance.parent;
    }
    return false;
}
function $8fc928cd6c76f02e$var$hasCssVars(style) {
    for(let i = 0; i < style.length; i++)if (style.item(i).startsWith("--")) return true;
    return false;
}
function $8fc928cd6c76f02e$var$checkHydrationStyleMismatch(el, value, normalizedValue, isIncremental) {
    if ($8fc928cd6c76f02e$var$shouldDeferCheckStyleMismatch(el)) {
        const instance = (0, $3dLyd.currentInstance);
        (0, $3dLyd.queuePostFlushCb)(()=>{
            $8fc928cd6c76f02e$var$styleHasMismatch(el, value, normalizedValue, isIncremental, instance);
        });
    } else $8fc928cd6c76f02e$var$styleHasMismatch(el, value, normalizedValue, isIncremental);
}
function $8fc928cd6c76f02e$export$37a5fde709c1db82(el, value) {
    if (el.$root) $8fc928cd6c76f02e$var$setStyleIncremental(el, value);
    else {
        const normalizedValue = (0, $7s0Ms.normalizeStyle)(value);
        if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
            if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $8fc928cd6c76f02e$var$checkHydrationStyleMismatch(el, value, normalizedValue, false);
            el.$sty = normalizedValue;
            $8fc928cd6c76f02e$var$hydrateVShowDisplay(el, normalizedValue);
            return;
        }
        (0, $bmuEm.patchStyle)(el, el.$sty, el.$sty = normalizedValue);
    }
}
function $8fc928cd6c76f02e$var$setStyleIncremental(el, value) {
    const cacheKey = `$styi${$8fc928cd6c76f02e$var$isApplyingFallthroughProps ? "$" : ""}`;
    const normalizedValue = (0, $7s0Ms.isString)(value) ? (0, $7s0Ms.parseStringStyle)(value) : (0, $7s0Ms.normalizeStyle)(value);
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $8fc928cd6c76f02e$var$checkHydrationStyleMismatch(el, value, normalizedValue, true);
        el[cacheKey] = normalizedValue;
        $8fc928cd6c76f02e$var$hydrateVShowDisplay(el, normalizedValue);
        return;
    }
    (0, $bmuEm.patchStyle)(el, el[cacheKey], el[cacheKey] = normalizedValue);
}
function $8fc928cd6c76f02e$var$hydrateVShowDisplay(el, style) {
    if ((0, $bmuEm.vShowOriginalDisplay) in el) {
        let display = (0, $7s0Ms.isString)(style) ? (0, $7s0Ms.parseStringStyle)(style).display : style && style.display;
        if ((0, $7s0Ms.isArray)(display)) display = display[display.length - 1];
        el[0, $bmuEm.vShowOriginalDisplay] = display == null ? "" : String(display);
    }
}
function $8fc928cd6c76f02e$export$80746c6bc6142fc8(el, value, forceHydrate = false) {
    if ($8fc928cd6c76f02e$var$shouldSkipFallthroughKey(el, "value")) return;
    el._value = value;
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$attributeHasMismatch(el, "value", (0, $7s0Ms.isString)(value) ? $8fc928cd6c76f02e$var$getClientText(el, value) : value);
        if (!forceHydrate && !$8fc928cd6c76f02e$var$shouldForceHydrate(el, "value")) return;
    }
    const oldValue = el.tagName === "OPTION" ? el.getAttribute("value") : el.value;
    const newValue = value == null ? "" : value;
    if (oldValue !== newValue) el.value = newValue;
    if (value == null) el.removeAttribute("value");
    else el.setAttribute("value", (0, $7s0Ms.isSymbol)(newValue) ? String(newValue) : newValue);
}
/**
* Only called on text nodes!
* Compiler should also ensure value passed here is already converted by
* `toDisplayString`
*/ function $8fc928cd6c76f02e$export$cbe0d99836e1498f(el, value) {
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el) && !$8fc928cd6c76f02e$var$isRecreatedNode(el.parentNode)) {
        const clientText = $8fc928cd6c76f02e$var$getClientText(el.parentNode, value);
        if (el.nodeValue == clientText) {
            el.$txt = clientText;
            return;
        }
        const parent = el.parentElement;
        if (parent && !(0, $3dLyd.isMismatchAllowed)(parent, 0)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$warnHydrationTextMismatch(el, value);
            (0, $3dLyd.logMismatchError)();
        }
    }
    if (el.$txt !== value) el.nodeValue = el.$txt = value;
}
/**
* Used by setDynamicProps and `textContent` bindings, so need to guard with
* `toDisplayString`
*/ function $8fc928cd6c76f02e$export$1193aae213924971(el, value) {
    value = (0, $7s0Ms.toDisplayString)(value);
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        let clientText = $8fc928cd6c76f02e$var$getClientText(el, value);
        if (el.textContent === clientText) {
            el.$txt = clientText;
            return;
        }
        if (!(0, $3dLyd.isMismatchAllowed)(el, 0)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $3dLyd.warn)(`Hydration text content mismatch on`, el, `\n  - rendered on server: ${el.textContent}\n  - expected on client: ${clientText}`);
            (0, $3dLyd.logMismatchError)();
        }
    }
    if (el.$txt !== value) el.textContent = el.$txt = value;
}
function $8fc928cd6c76f02e$export$e9d3191caab19f4d(el, value) {
    value = value == null ? "" : (0, $bmuEm.unsafeToTrustedHTML)(value);
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !$8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        el.$html = value;
        return;
    }
    if (el.$html !== value) el.innerHTML = el.$html = value;
}
function $8fc928cd6c76f02e$export$be77d6fc3302ce7c(el, args, isSVG) {
    $8fc928cd6c76f02e$var$patchDynamicProps(el, args.length > 1 ? (0, $3dLyd.mergeProps)(...args) : args[0] || (0, $7s0Ms.EMPTY_OBJ), isSVG);
}
function $8fc928cd6c76f02e$var$patchDynamicProps(el, props, isSVG) {
    const cacheKey = `$dprops${$8fc928cd6c76f02e$var$isApplyingFallthroughProps ? "$" : ""}`;
    const prevProps = el[cacheKey];
    const nextProps = Object.create(null);
    if (prevProps) {
        for(const key in prevProps)if (!(key in props)) $8fc928cd6c76f02e$var$setDynamicProp(el, key, null, isSVG);
    }
    for (const key of Object.keys(props)){
        if ((0, $7s0Ms.isReservedProp)(key)) continue;
        const value = props[key];
        nextProps[key] = value;
        if (prevProps && key in prevProps && !(0, $7s0Ms.isOn)(key) && (value == null || typeof value !== "object") && Object.is(prevProps[key], value)) continue;
        $8fc928cd6c76f02e$var$setDynamicProp(el, key, value, isSVG);
    }
    el[cacheKey] = nextProps;
}
/**
* @internal
*/ function $8fc928cd6c76f02e$var$setDynamicProp(el, key, value, isSVG = false) {
    let forceHydrate = false;
    if (key === "class") $8fc928cd6c76f02e$export$2796c4ce44e61efa(el, value, isSVG);
    else if (key === "style") $8fc928cd6c76f02e$export$37a5fde709c1db82(el, value);
    else if ((0, $7s0Ms.isOn)(key)) {
        if ($8fc928cd6c76f02e$var$shouldSkipFallthroughKey(el, key)) return;
        const [event, options] = (0, $bmuEm.parseEventName)(key);
        $8fc928cd6c76f02e$export$1583747b0ccdaa69(el, event, value, options);
    } else if ((forceHydrate = key[0] === ".") ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : (0, $bmuEm.shouldSetAsProp)(el, key, value, isSVG)) {
        if (key === "innerHTML") $8fc928cd6c76f02e$export$e9d3191caab19f4d(el, value);
        else if (key === "textContent") $8fc928cd6c76f02e$export$1193aae213924971(el, value);
        else if (key === "value" && (0, $7s0Ms.canSetValueDirectly)(el.tagName)) $8fc928cd6c76f02e$export$80746c6bc6142fc8(el, value, forceHydrate);
        else $8fc928cd6c76f02e$export$c16cd4a7fa698f59(el, key, value, forceHydrate);
    } else if (el._isVueCE && ((0, $bmuEm.shouldSetAsPropForVueCE)(el, key) || el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $7s0Ms.isString)(value)))) $8fc928cd6c76f02e$export$c16cd4a7fa698f59(el, (0, $7s0Ms.camelize)(key), value, forceHydrate, key);
    else $8fc928cd6c76f02e$export$c609e428011345f3(el, key, value, isSVG);
    return value;
}
let $8fc928cd6c76f02e$var$isOptimized = false;
/**
* Optimize property lookup for cache properties on Element and Text nodes
*/ function $8fc928cd6c76f02e$var$optimizePropertyLookup() {
    if ($8fc928cd6c76f02e$var$isOptimized) return;
    $8fc928cd6c76f02e$var$isOptimized = true;
    const proto = Element.prototype;
    proto.$transition = void 0;
    proto.$key = void 0;
    proto.$evtclick = void 0;
    proto.$root = false;
    proto.$clsFlags = void 0;
    proto.$html = proto.$cls = proto.$sty = "";
    Text.prototype.$txt = void 0;
}
function $8fc928cd6c76f02e$var$classHasMismatch(el, expected, isIncremental) {
    const actual = el.getAttribute("class");
    const actualClassSet = (0, $3dLyd.toClassSet)(actual || "");
    const expectedClassSet = (0, $3dLyd.toClassSet)(expected);
    let hasMismatch = false;
    if (isIncremental) {
        if (expected) hasMismatch = Array.from(expectedClassSet).some((cls)=>!actualClassSet.has(cls));
    } else hasMismatch = !(0, $3dLyd.isSetEqual)(actualClassSet, expectedClassSet);
    if (hasMismatch) {
        if ((0, $3dLyd.warnPropMismatch)(el, "class", 2, actual, expected)) {
            (0, $3dLyd.logMismatchError)();
            return true;
        }
    }
    return false;
}
function $8fc928cd6c76f02e$var$styleHasMismatch(el, value, normalizedValue, isIncremental, instance = (0, $3dLyd.currentInstance)) {
    const actual = el.getAttribute("style");
    const actualStyleMap = (0, $3dLyd.toStyleMap)(actual || "");
    const expected = (0, $7s0Ms.isString)(value) ? value : (0, $7s0Ms.stringifyStyle)(normalizedValue);
    const expectedStyleMap = (0, $3dLyd.toStyleMap)(expected);
    if (el[0, $bmuEm.vShowHidden]) expectedStyleMap.set("display", "none");
    if (instance) $8fc928cd6c76f02e$var$resolveCssVars(instance, el, expectedStyleMap);
    let hasMismatch = false;
    if (isIncremental) {
        if (expected) hasMismatch = Array.from(expectedStyleMap.entries()).some(([key, val])=>actualStyleMap.get(key) !== val);
    } else hasMismatch = !(0, $3dLyd.isMapEqual)(actualStyleMap, expectedStyleMap);
    if (hasMismatch) {
        if ((0, $3dLyd.warnPropMismatch)(el, "style", 3, actual, expected)) {
            (0, $3dLyd.logMismatchError)();
            return true;
        }
    }
    return false;
}
/**
* dev only
*/ function $8fc928cd6c76f02e$var$resolveCssVars(instance, block, expectedMap) {
    if (!instance.isMounted) return;
    const rootBlocks = $8fc928cd6c76f02e$var$normalizeBlock(instance);
    if (instance.getCssVars && $8fc928cd6c76f02e$var$normalizeBlock(block).every((b)=>rootBlocks.includes(b))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $7s0Ms.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $7s0Ms.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if ($8fc928cd6c76f02e$var$normalizeBlock(block).every((b)=>rootBlocks.includes(b)) && instance.parent) $8fc928cd6c76f02e$var$resolveCssVars(instance.parent, instance.block, expectedMap);
}
function $8fc928cd6c76f02e$var$attributeHasMismatch(el, key, value) {
    if ((0, $3dLyd.isValidHtmlOrSvgAttribute)(el, key)) {
        const { actual: actual, expected: expected } = (0, $3dLyd.getAttributeMismatch)(el, key, value);
        if (actual !== expected) {
            if ((0, $3dLyd.warnPropMismatch)(el, key, 4, actual, expected)) {
                (0, $3dLyd.logMismatchError)();
                return true;
            }
        }
    }
    return false;
}
function $8fc928cd6c76f02e$var$getClientText(el, value) {
    if (value[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) value = value.slice(1);
    return value;
}
function $8fc928cd6c76f02e$var$shouldForceHydrate(el, key) {
    const { tagName: tagName } = el;
    return (tagName === "INPUT" || tagName === "OPTION") && (key.endsWith("value") || key === "indeterminate") || tagName.includes("-");
}
//#endregion
//#region packages/runtime-vapor/src/asyncComponentState.ts
let $8fc928cd6c76f02e$var$isAsyncComponentEnabled = false;
function $8fc928cd6c76f02e$var$enableAsyncComponent() {
    $8fc928cd6c76f02e$var$isAsyncComponentEnabled = true;
}
//#endregion
//#region packages/runtime-vapor/src/slotBoundary.ts
function $8fc928cd6c76f02e$var$withSlotBoundary(boundary, fn) {
    return $8fc928cd6c76f02e$var$withRenderContext($8fc928cd6c76f02e$var$deriveSlotBoundary($8fc928cd6c76f02e$var$currentRenderContext, boundary), fn);
}
function $8fc928cd6c76f02e$var$trackSlotBoundaryDirtying(fragment, onInvalid) {
    const boundary = $8fc928cd6c76f02e$var$currentRenderContext.slotBoundary;
    if (!boundary) return;
    if (onInvalid) $8fc928cd6c76f02e$var$registerContentInvalid(boundary, onInvalid, fragment);
    let prevValid;
    (fragment.bu || (fragment.bu = [])).push(()=>{
        prevValid = $8fc928cd6c76f02e$var$isValidSlot(fragment);
    });
    (fragment.u || (fragment.u = [])).push(()=>{
        if ($8fc928cd6c76f02e$var$isValidSlot(fragment) !== prevValid) boundary.markDirty();
    });
}
function $8fc928cd6c76f02e$var$registerContentInvalid(boundary, onInvalid, fragment) {
    const callbacks = boundary.onContentInvalid || (boundary.onContentInvalid = []);
    callbacks.push(onInvalid);
    const unregister = ()=>{
        const index = callbacks.indexOf(onInvalid);
        if (index > -1) callbacks.splice(index, 1);
    };
    (fragment.bum || (fragment.bum = [])).push(unregister);
}
function $8fc928cd6c76f02e$var$hasSlotFallback(boundary) {
    while(boundary){
        if (boundary.getFallback()) return true;
        boundary = boundary.parent;
    }
    return false;
}
//#endregion
//#region packages/runtime-vapor/src/helpers/setKey.ts
function $8fc928cd6c76f02e$export$96002406b1640ec1(block, key) {
    const frag = block;
    frag.$key = key;
    if ($8fc928cd6c76f02e$var$isInteropEnabled && frag.setKey) frag.setKey(key);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/typeof.js
function $8fc928cd6c76f02e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fc928cd6c76f02e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fc928cd6c76f02e$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/toPrimitive.js
function $8fc928cd6c76f02e$var$toPrimitive(t, r) {
    if ("object" != $8fc928cd6c76f02e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8fc928cd6c76f02e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/toPropertyKey.js
function $8fc928cd6c76f02e$var$toPropertyKey(t) {
    var i = $8fc928cd6c76f02e$var$toPrimitive(t, "string");
    return "symbol" == $8fc928cd6c76f02e$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/defineProperty.js
function $8fc928cd6c76f02e$var$_defineProperty(e, r, t) {
    return (r = $8fc928cd6c76f02e$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/objectSpread2.js
function $8fc928cd6c76f02e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fc928cd6c76f02e$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fc928cd6c76f02e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8fc928cd6c76f02e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fc928cd6c76f02e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
//#endregion
//#region packages/runtime-vapor/src/slotFragment.ts
function $8fc928cd6c76f02e$var$renderSlotFallback(boundary, scope) {
    let result;
    const scopeIds = boundary && boundary.getScopeIds ? boundary.getScopeIds() : null;
    while(boundary){
        const current = boundary;
        const localFallback = current.getFallback();
        if (localFallback) {
            let selected = false;
            const onContentInvalid = [];
            const renderFallback = scopeIds ? ()=>$8fc928cd6c76f02e$var$renderWithSlotScopeIds(scopeIds, localFallback) : localFallback;
            const content = current.run(()=>$8fc928cd6c76f02e$var$withSlotBoundary($8fc928cd6c76f02e$var$_objectSpread2($8fc928cd6c76f02e$var$_objectSpread2({}, current), {}, {
                    getFallback: ()=>void 0,
                    onContentInvalid: onContentInvalid,
                    markDirty: (force)=>current.markDirty(!!force || !selected && $8fc928cd6c76f02e$var$hasSlotFallback(current.parent))
                }), renderFallback), scope);
            if ($8fc928cd6c76f02e$var$isValidSlot(content)) {
                selected = true;
                return {
                    block: content,
                    onContentInvalid: onContentInvalid
                };
            }
            result = {
                block: content,
                onContentInvalid: onContentInvalid
            };
        }
        boundary = current.parent;
    }
    return result;
}
function $8fc928cd6c76f02e$var$beforeExpose(state, block) {
    const bm = state.bm;
    if (bm) for(let i = 0; i < bm.length; i++)bm[i](block);
}
/**
* The winning exposed branch for a slot host: the committed fallback while one
* is active, the resolved content otherwise. Every host's `syncNodes` points
* its exposed nodes here.
*/ function $8fc928cd6c76f02e$var$resolveExposedSlotNodes(state) {
    return state.activeFallback || state.getContent();
}
function $8fc928cd6c76f02e$var$markSlotResolutionDirty(state, force = false) {
    if (state.isDisposed()) return;
    if (state.isReconciling || state.isBusy()) {
        state.pendingRecheck = true;
        state.pendingRecheckForce = state.pendingRecheckForce || force;
        return;
    }
    $8fc928cd6c76f02e$var$recheckSlotResolution(state, force);
}
function $8fc928cd6c76f02e$var$invalidateExposedSlotContent(state) {
    const callbacks = state.activeFallback ? state.activeFallbackInvalidCallbacks : state.boundary.onContentInvalid;
    if (callbacks) for(let i = 0; i < callbacks.length; i++)callbacks[i]();
}
function $8fc928cd6c76f02e$var$clearSlotFallback(state, parentNode = state.getParentNode()) {
    if (state.fallbackScope) {
        state.fallbackScope.stop();
        state.fallbackScope = void 0;
    }
    const fallback = state.activeFallback;
    if (fallback) {
        $8fc928cd6c76f02e$export$cd7f480d6b8286c3(fallback, state.fallbackInserted ? parentNode || void 0 : void 0);
        state.activeFallback = null;
        state.fallbackInserted = false;
    }
    state.activeFallbackInvalidCallbacks = void 0;
}
function $8fc928cd6c76f02e$var$leaveSlotFallback(state, hooks, afterLeave) {
    const fallback = state.activeFallback;
    if (!fallback || !$8fc928cd6c76f02e$var$applyTransitionLeaveHooks(fallback, hooks, afterLeave)) return false;
    $8fc928cd6c76f02e$var$clearSlotFallback(state);
    return true;
}
function $8fc928cd6c76f02e$var$renderFallbackInScope(state) {
    const scope = new (0, $SdEQh.EffectScope)(true);
    let renderedFallback;
    try {
        renderedFallback = $8fc928cd6c76f02e$var$renderSlotFallback(state.boundary, scope);
    } catch (err) {
        scope.stop();
        throw err;
    }
    if (!renderedFallback) {
        scope.stop();
        return;
    }
    return {
        block: renderedFallback.block,
        onContentInvalid: renderedFallback.onContentInvalid,
        scope: scope
    };
}
function $8fc928cd6c76f02e$var$insertActiveSlotFallback(state, moveType) {
    const fallback = state.activeFallback;
    if ($8fc928cd6c76f02e$var$isHydrating$1 || !fallback || !$8fc928cd6c76f02e$var$isValidSlot(fallback)) return;
    const parentNode = state.getParentNode();
    if (!parentNode) return;
    if (moveType === void 0) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(fallback, parentNode, state.getAnchor());
    else $8fc928cd6c76f02e$var$move(fallback, parentNode, state.getAnchor(), moveType);
    state.fallbackInserted = true;
}
function $8fc928cd6c76f02e$var$commitSlotFallback(state, block, scope, onContentInvalid, detachContent) {
    state.activeFallback = block;
    state.activeFallbackInvalidCallbacks = onContentInvalid;
    state.fallbackScope = scope;
    state.fallbackInserted = $8fc928cd6c76f02e$var$isHydrating$1;
    if ($8fc928cd6c76f02e$var$isTransitionEnabled) {
        if (state.$transition) {
            if (!(0, $7s0Ms.isArray)(block)) $8fc928cd6c76f02e$export$96002406b1640ec1(block, "_fb");
            state.$transition = $8fc928cd6c76f02e$var$applyTransitionHooks(block, state.$transition, $8fc928cd6c76f02e$var$ownerFragment(state));
        }
    }
    if (detachContent && !$8fc928cd6c76f02e$var$isHydrating$1) {
        const parentNode = state.getParentNode();
        const contentInvalidCallbacks = state.boundary.onContentInvalid;
        if (contentInvalidCallbacks) for(let i = 0; i < contentInvalidCallbacks.length; i++)contentInvalidCallbacks[i]();
        if (parentNode) $8fc928cd6c76f02e$var$removeAttachedNodes$1(state.getContent(), parentNode, false);
    }
    $8fc928cd6c76f02e$var$beforeExpose(state, block);
    $8fc928cd6c76f02e$var$insertActiveSlotFallback(state);
}
function $8fc928cd6c76f02e$var$ownerFragment(state) {
    const frag = state;
    return frag.__vf ? frag : void 0;
}
function $8fc928cd6c76f02e$var$renderAndCommitSlotFallback(state, hadFallback) {
    const result = $8fc928cd6c76f02e$var$renderFallbackInScope(state);
    $8fc928cd6c76f02e$var$clearSlotFallback(state);
    if (result) $8fc928cd6c76f02e$var$commitSlotFallback(state, result.block, result.scope, result.onContentInvalid, !hadFallback);
}
function $8fc928cd6c76f02e$var$disposeSlotResolution(state, parentNode) {
    $8fc928cd6c76f02e$var$clearSlotFallback(state, parentNode || null);
    state.pendingRecheck = false;
    state.pendingRecheckForce = false;
    state.lastNodesValid = void 0;
}
function $8fc928cd6c76f02e$var$recheckSlotResolution(state, force = false) {
    if (state.isReconciling) {
        state.pendingRecheck = true;
        state.pendingRecheckForce = state.pendingRecheckForce || force;
        return;
    }
    let nextForce = force || state.pendingRecheckForce;
    do {
        state.pendingRecheck = false;
        state.pendingRecheckForce = false;
        state.isReconciling = true;
        try {
            $8fc928cd6c76f02e$var$recheckSlotResolutionNow(state, nextForce);
        } finally{
            state.isReconciling = false;
        }
        if (!state.pendingRecheck) return;
        nextForce = state.pendingRecheckForce;
    }while (true);
}
function $8fc928cd6c76f02e$var$recheckSlotResolutionNow(state, force) {
    var _state$lastNodesValid;
    const fallback = state.activeFallback;
    const fallbackValid = fallback ? $8fc928cd6c76f02e$var$isValidSlot(fallback) : false;
    const contentValid = state.isContentValid();
    const exposedValid = fallback ? fallbackValid : contentValid;
    const prevNodesValid = (_state$lastNodesValid = state.lastNodesValid) !== null && _state$lastNodesValid !== void 0 ? _state$lastNodesValid : exposedValid;
    if (!force && contentValid && !fallback && prevNodesValid) {
        state.syncNodes();
        state.lastNodesValid = true;
        return;
    }
    if (contentValid) {
        const content = state.getContent();
        const hadFallback = !!fallback;
        $8fc928cd6c76f02e$var$clearSlotFallback(state);
        if (hadFallback) {
            $8fc928cd6c76f02e$var$beforeExpose(state, content);
            if (!$8fc928cd6c76f02e$var$isHydrating$1) {
                const parentNode = state.getParentNode();
                if (parentNode) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(content, parentNode, state.getAnchor());
            }
        }
    } else if (fallback) {
        if (prevNodesValid) {
            if (!fallbackValid && $8fc928cd6c76f02e$var$hasSlotFallback(state.boundary.parent)) $8fc928cd6c76f02e$var$renderAndCommitSlotFallback(state, true);
            else if (force && fallbackValid) $8fc928cd6c76f02e$var$renderAndCommitSlotFallback(state, true);
        } else if (fallbackValid) $8fc928cd6c76f02e$var$insertActiveSlotFallback(state);
        else if (force) $8fc928cd6c76f02e$var$renderAndCommitSlotFallback(state, true);
    } else $8fc928cd6c76f02e$var$renderAndCommitSlotFallback(state, false);
    const nextFallback = state.activeFallback;
    const nextNodesValid = contentValid && !nextFallback ? true : nextFallback ? nextFallback === fallback ? fallbackValid : $8fc928cd6c76f02e$var$isValidSlot(nextFallback) : state.isContentValid();
    state.syncNodes();
    state.lastNodesValid = nextNodesValid;
    if (prevNodesValid !== nextNodesValid) state.notifyExposedValidityChange();
}
//#endregion
//#region packages/runtime-vapor/src/dom/hydrateFragment.ts
var $8fc928cd6c76f02e$var$SlotHydrationSession = class {
    constructor(claim, parent, pending){
        this.claim = claim;
        this.parent = parent;
        this.pending = pending;
        this.deferred = null;
    }
    /**
	* The boundary's SSR close marker while it owns its range, else the
	* inherited one. Derived on read: the content's first block may take the
	* range over mid-content (see `FragmentClaim`).
	*/ get endAnchor() {
        return this.ownEndAnchor || (this.parent ? this.parent.endAnchor : null);
    }
    /** The close marker of the range this boundary itself owns, if any. */ get ownEndAnchor() {
        return $8fc928cd6c76f02e$var$locateFragmentEnd(this.claim.start);
    }
    /** Trim the range's unclaimed tail; a range the content took over has none. */ exitBoundary() {
        const close = this.ownEndAnchor;
        if (close) $8fc928cd6c76f02e$var$trimHydrationBoundary(close);
    }
    /** Record a claim in the ledger; false = no pending window, act now. */ defer(anchor) {
        if (!this.pending) return false;
        (this.deferred || (this.deferred = [])).push(anchor);
        return true;
    }
    /**
	* Settle ledger entries. `from > 0` (only ever passed for an invalid
	* inner segment) rolls back just that segment's tail of the ledger.
	*/ settle(contentValid, from = 0) {
        const deferred = this.deferred;
        if (!deferred) return;
        const batch = from ? deferred.splice(from) : deferred;
        if (!from) this.deferred = null;
        for(let i = 0; i < batch.length; i++)if (contentValid) batch[i].onContent();
        else batch[i].onFallback();
    }
    /**
	* Open a pending window. The returned `finish` is idempotent and applies
	* the settlement rules above; on invalid content it also rewinds the
	* cursor to `start` so fallback hydrates the range content walked over.
	*/ beginSegment(start) {
        const prevPending = this.pending;
        const watermark = this.deferred ? this.deferred.length : 0;
        this.pending = true;
        let active = true;
        return (contentValid)=>{
            if (!active) return;
            active = false;
            this.settle(contentValid, !contentValid && prevPending ? watermark : 0);
            this.pending = prevPending;
            if (!contentValid) $8fc928cd6c76f02e$var$setCurrentHydrationNode(start);
        };
    }
    /**
	* Unconditional variant for a child boundary that settled: the parent's
	* ledger settles as content even if the parent itself was not pending —
	* it may hold entries adopted from an earlier undecided child.
	*/ settleAsContent() {
        this.settle(true);
        this.pending = false;
    }
    /** Boundary ended still undecided: its ledger becomes the parent's. */ adoptInto(parent) {
        if (this.deferred) {
            (parent.deferred || (parent.deferred = [])).push(...this.deferred);
            this.deferred = null;
        }
    }
};
let $8fc928cd6c76f02e$var$currentSlotHydrationSession = null;
function $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor() {
    return $8fc928cd6c76f02e$var$currentSlotHydrationSession ? $8fc928cd6c76f02e$var$currentSlotHydrationSession.endAnchor : null;
}
/** Locate this boundary's SSR range and consume its opening marker. */ function $8fc928cd6c76f02e$var$enterSlotBoundaryRange(pending) {
    const claim = $8fc928cd6c76f02e$var$createFragmentClaim();
    $8fc928cd6c76f02e$var$locateHydrationNode(claim);
    return new $8fc928cd6c76f02e$var$SlotHydrationSession(claim, $8fc928cd6c76f02e$var$currentSlotHydrationSession, pending);
}
function $8fc928cd6c76f02e$var$withHydratingSlotBoundary(fn) {
    const session = $8fc928cd6c76f02e$var$enterSlotBoundaryRange(false);
    const prevSession = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    $8fc928cd6c76f02e$var$currentSlotHydrationSession = session;
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$currentSlotHydrationSession = prevSession;
        session.exitBoundary();
    }
}
/**
* A boundary that starts undecided (forwarded interop slots): if `fn`
* completes without settling, the range stays unclaimed — the ledger is
* adopted by the parent boundary and the cursor rewinds. If it settles,
* the parent's own pending window settles as content along with it.
*/ function $8fc928cd6c76f02e$var$withPendingHydratingSlotBoundary(fn) {
    const parentSession = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    const contentStart = $8fc928cd6c76f02e$var$currentHydrationNode;
    const session = $8fc928cd6c76f02e$var$enterSlotBoundaryRange(true);
    $8fc928cd6c76f02e$var$currentSlotHydrationSession = session;
    let completed = false;
    try {
        const result = fn();
        completed = true;
        return result;
    } finally{
        $8fc928cd6c76f02e$var$currentSlotHydrationSession = parentSession;
        if (!completed) session.exitBoundary();
        else if (session.pending) {
            session.adoptInto(parentSession);
            $8fc928cd6c76f02e$var$setCurrentHydrationNode(contentStart);
        } else {
            session.exitBoundary();
            parentSession.settleAsContent();
        }
    }
}
function $8fc928cd6c76f02e$var$queuePendingSlotContentAnchor(anchor) {
    const session = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    return !!session && session.defer(anchor);
}
/**
* Builds the attach step of a deferred shared-fallback decision. Once the
* winning side is known, resolve the reference node, then either claim the
* candidate SSR range's end anchor (when this host won one) or insert the
* runtime anchor, and move the host's nodes into place. The claim itself
* stays host-specific: which anchor fields it publishes and whether the
* hydration cursor must advance differ per host.
*/ function $8fc928cd6c76f02e$var$createDeferredSlotAttach(contentStart, slotEnd, runtimeAnchor, candidate, claimCandidate, getNodes, onAttached) {
    return ()=>{
        const insertionAnchor = $8fc928cd6c76f02e$var$resolveDeferredInsertionAnchor(candidate, contentStart, slotEnd);
        const parent = insertionAnchor && insertionAnchor.parentNode;
        if (!parent) return;
        let anchor;
        if (candidate) anchor = claimCandidate(candidate);
        else {
            $8fc928cd6c76f02e$var$insertUntrackedAnchor(parent, insertionAnchor, runtimeAnchor);
            anchor = runtimeAnchor;
        }
        if (onAttached) onAttached(parent);
        $8fc928cd6c76f02e$var$move(getNodes(), parent, anchor);
    };
}
/**
* Claims the SSR fragment close marker directly preceding a receiver slot's
* end anchor. Slot content hydrating inside the receiver does not own that
* marker, but boundary cleanup can run before deferred anchors are inserted,
* so it must be marked as claimed up front.
*/ function $8fc928cd6c76f02e$var$claimPrecedingFragmentClose(slotEnd) {
    const previous = slotEnd && slotEnd.previousSibling;
    if (previous && $8fc928cd6c76f02e$var$isComment(previous, "]")) $8fc928cd6c76f02e$var$claimAnchor(previous);
}
/**
* The reference node a deferred slot anchor attaches before: the candidate
* range's end when one exists, otherwise the (still-attached) content start,
* otherwise the receiver slot's end anchor.
*/ function $8fc928cd6c76f02e$var$resolveDeferredInsertionAnchor(candidate, contentStart, slotEnd) {
    return candidate || (contentStart && contentStart.parentNode ? contentStart : slotEnd);
}
function $8fc928cd6c76f02e$var$startPendingSlotContent(start) {
    const session = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    if (!session) return ()=>{};
    return session.beginSegment(start);
}
/**
* Wraps startPendingSlotContent's one-shot protocol: the decision must be
* resolved exactly once, and an abandoned render (throw) must resolve it as
* content so the enclosing slot hydration session can continue. Inactive
* guards (`shouldDefer` false) are inert.
*/ const $8fc928cd6c76f02e$var$INERT_PENDING_SLOT_CONTENT = {
    finish: (0, $7s0Ms.NOOP),
    settle: (0, $7s0Ms.NOOP)
};
function $8fc928cd6c76f02e$var$startPendingSlotContentGuard(shouldDefer, start) {
    if (!shouldDefer) return $8fc928cd6c76f02e$var$INERT_PENDING_SLOT_CONTENT;
    let finish = $8fc928cd6c76f02e$var$startPendingSlotContent(start);
    const resolve = (contentValid)=>{
        if (finish) {
            finish(contentValid);
            finish = null;
        }
    };
    return {
        finish: resolve,
        settle: ()=>resolve(true)
    };
}
function $8fc928cd6c76f02e$var$resolvePendingSlotContent() {
    const session = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    if (session && session.pending) session.settleAsContent();
}
function $8fc928cd6c76f02e$var$isPendingSlotContent() {
    const session = $8fc928cd6c76f02e$var$currentSlotHydrationSession;
    return !!(session && session.pending);
}
/**
* Insert an anchor at a position resolved during the hydration pass. Untracked
* anchors hold no SSR logical position, so traversal steps over them and the
* insert can happen right away. `nextNode` may already have been trimmed by
* boundary cleanup, in which case the anchor is appended instead.
*/ function $8fc928cd6c76f02e$var$insertUntrackedAnchor(parentNode$1, nextNode, anchor) {
    parentNode$1.insertBefore(anchor, nextNode && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(nextNode) === parentNode$1 ? nextNode : null);
}
/**
* Whether `node` can serve as `frag`'s anchor. Beyond the SSR candidates
* (`<!---->` and a fragment close), dev builds also accept a runtime anchor
* this fragment kind already created: those carry the fragment's debug label
* as their comment data, where prod uses unlabeled text nodes.
*/ function $8fc928cd6c76f02e$var$isReusableAnchorCandidate(node, frag) {
    return !!node && ($8fc928cd6c76f02e$var$isComment(node, "") || $8fc928cd6c76f02e$var$isComment(node, "]") || false);
}
function $8fc928cd6c76f02e$var$reuseOrCreateAfterAnchor(node, resetNodes) {
    const parent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
    return $8fc928cd6c76f02e$var$isClaimedAnchor(node) && parent ? {
        kind: "create",
        parent: parent,
        next: node.nextSibling,
        resetNodes: resetNodes
    } : {
        kind: "reuse",
        node: node,
        resetNodes: resetNodes
    };
}
function $8fc928cd6c76f02e$var$prepareDeferredHydrationAnchor(frag, hasRender) {
    const isRevivingDeferredBranch = $8fc928cd6c76f02e$var$isInDeferredHydrationBoundary() && hasRender && !(frag.__vf & 4) && !$8fc928cd6c76f02e$var$isValidBlock(frag.nodes);
    const reusingDeferredAnchor = isRevivingDeferredBranch && !!frag.anchor && !!frag.anchor.parentNode;
    if (isRevivingDeferredBranch) {
        let slotEndAnchor = null;
        const anchor = frag.anchor || ($8fc928cd6c76f02e$var$currentHydrationNode === (slotEndAnchor = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor()) ? slotEndAnchor : null);
        if (anchor) $8fc928cd6c76f02e$var$setCurrentHydrationNode($8fc928cd6c76f02e$var$claimAnchor(anchor));
    }
    return reusingDeferredAnchor;
}
/** Rule 1: the enclosing slot has not decided content vs fallback yet. */ function $8fc928cd6c76f02e$var$planPendingSlotDecision(frag, isEmpty) {
    if ($8fc928cd6c76f02e$var$isPendingSlotContent() && (isEmpty || !$8fc928cd6c76f02e$var$isValidBlock(frag.nodes))) {
        const slotEnd = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor();
        const node = $8fc928cd6c76f02e$var$currentHydrationNode || slotEnd;
        if (node) {
            const parent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
            if (parent) return {
                kind: "pending",
                parent: parent,
                slotEnd: slotEnd
            };
        }
    }
}
/** Rule 2: adopt the anchor createPlainElement injected for native children. */ function $8fc928cd6c76f02e$var$planReuseInjectedAnchor(frag) {
    if (frag.__vf & 512 && $8fc928cd6c76f02e$var$isClaimedAnchor($8fc928cd6c76f02e$var$currentHydrationNode) && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode($8fc928cd6c76f02e$var$currentHydrationNode)) return {
        kind: "reuse",
        node: $8fc928cd6c76f02e$var$currentHydrationNode
    };
}
/** Rule 3: the fragment owns an SSR range; its close marker is the anchor. */ function $8fc928cd6c76f02e$var$planReuseOwnClose(frag) {
    const close = frag.__vf & 4 ? $8fc928cd6c76f02e$var$currentSlotHydrationSession && $8fc928cd6c76f02e$var$currentSlotHydrationSession.ownEndAnchor : frag.hydrationClaim && frag.hydrationClaim.start ? $8fc928cd6c76f02e$var$locateClaimedEnd(frag.hydrationClaim.start) : null;
    if (close) return $8fc928cd6c76f02e$var$reuseOrCreateAfterAnchor(close);
}
/** Rule 4: the client rendered nothing and owns no range. */ function $8fc928cd6c76f02e$var$planEmptyBranch(frag) {
    const flags = frag.__vf;
    if ($8fc928cd6c76f02e$var$isReusableAnchorCandidate($8fc928cd6c76f02e$var$currentHydrationNode, frag)) return $8fc928cd6c76f02e$var$reuseOrCreateAfterAnchor($8fc928cd6c76f02e$var$currentHydrationNode);
    if (!(flags & 512) && $8fc928cd6c76f02e$var$currentHydrationNode && $8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode, "teleport anchor")) {
        const parentNode$2 = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode($8fc928cd6c76f02e$var$currentHydrationNode);
        if (parentNode$2) return {
            kind: "create",
            parent: parentNode$2,
            next: $8fc928cd6c76f02e$var$currentHydrationNode,
            mark: $8fc928cd6c76f02e$var$currentHydrationNode
        };
    }
    if (!(flags & 4) && $8fc928cd6c76f02e$var$currentHydrationNode && !$8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode, "]")) {
        const parentNode$3 = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode($8fc928cd6c76f02e$var$currentHydrationNode);
        if (flags & 512 && parentNode$3) return {
            kind: "create-cleanup",
            parent: parentNode$3,
            next: null,
            cleanupStart: $8fc928cd6c76f02e$var$currentHydrationNode,
            cleanupUntil: null,
            cleanupContainer: parentNode$3
        };
        if (parentNode$3) {
            const anchor = $8fc928cd6c76f02e$var$nextLogicalSibling($8fc928cd6c76f02e$var$currentHydrationNode);
            if ($8fc928cd6c76f02e$var$isReusableAnchorCandidate(anchor, frag) && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(anchor)) return $8fc928cd6c76f02e$var$reuseOrCreateAfterAnchor(anchor, true);
            return $8fc928cd6c76f02e$var$planTrimFromCursor(parentNode$3, anchor);
        }
    }
}
/** Trim the unclaimed SSR range at the cursor, then create a fresh anchor. */ function $8fc928cd6c76f02e$var$planTrimFromCursor(parent, next) {
    return {
        kind: "create-cleanup",
        parent: parent,
        next: next,
        cleanupStart: $8fc928cd6c76f02e$var$currentHydrationNode,
        cleanupUntil: next
    };
}
/** Rule 5: the block is a bare runtime comment from earlier in this pass. */ function $8fc928cd6c76f02e$var$planRestartFromRuntimeComment(frag) {
    if ($8fc928cd6c76f02e$var$isValidBlock(frag.nodes) || !(frag.nodes instanceof Comment)) return;
    if ($8fc928cd6c76f02e$var$isReusableAnchorCandidate(frag.nodes, frag) && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(frag.nodes)) return $8fc928cd6c76f02e$var$reuseOrCreateAfterAnchor(frag.nodes, true);
    if (!/* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(frag.nodes) && $8fc928cd6c76f02e$var$currentHydrationNode) {
        const parentNode$4 = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode($8fc928cd6c76f02e$var$currentHydrationNode);
        if (parentNode$4) return $8fc928cd6c76f02e$var$planTrimFromCursor(parentNode$4, $8fc928cd6c76f02e$var$nextLogicalSibling($8fc928cd6c76f02e$var$currentHydrationNode));
    }
}
/** Rule 6: derive the anchor position from the hydrated block itself. */ function $8fc928cd6c76f02e$var$planFromBlockBoundary(frag) {
    const node = $8fc928cd6c76f02e$var$findBlockBoundary(frag.nodes);
    return {
        kind: "create",
        parent: node.parentNode,
        next: node.nextNode
    };
}
function $8fc928cd6c76f02e$var$resolveDynamicAnchor(frag, isEmpty) {
    return $8fc928cd6c76f02e$var$planPendingSlotDecision(frag, isEmpty) || $8fc928cd6c76f02e$var$planReuseInjectedAnchor(frag) || $8fc928cd6c76f02e$var$planReuseOwnClose(frag) || (isEmpty ? $8fc928cd6c76f02e$var$planEmptyBranch(frag) : void 0) || $8fc928cd6c76f02e$var$planRestartFromRuntimeComment(frag) || $8fc928cd6c76f02e$var$planFromBlockBoundary(frag);
}
function $8fc928cd6c76f02e$var$executeAnchorPlan(frag, plan) {
    let advanceAfterRestore = null;
    let exitHydrationBoundary;
    const createRuntimeAnchor = ()=>{
        var _frag$anchorLabel;
        return frag.anchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
    };
    try {
        switch(plan.kind){
            case "reuse":
                if (plan.resetNodes) frag.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                frag.anchor = $8fc928cd6c76f02e$var$claimAnchor(plan.node);
                if ($8fc928cd6c76f02e$var$currentHydrationNode === frag.anchor) $8fc928cd6c76f02e$var$advanceHydrationNode(frag.anchor);
                else {
                    exitHydrationBoundary = $8fc928cd6c76f02e$var$enterHydrationBoundary(frag.anchor);
                    advanceAfterRestore = frag.anchor;
                }
                break;
            case "pending":
                {
                    const slotEnd = plan.slotEnd;
                    $8fc928cd6c76f02e$var$queuePendingSlotContentAnchor({
                        onContent: ()=>{
                            const node = $8fc928cd6c76f02e$var$currentHydrationNode;
                            const nodeParent = node && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
                            if (node && nodeParent === plan.parent && $8fc928cd6c76f02e$var$isReusableAnchorCandidate(node, frag)) {
                                if ($8fc928cd6c76f02e$var$isClaimedAnchor(node)) {
                                    const nextNode = node.nextSibling;
                                    $8fc928cd6c76f02e$var$advanceHydrationNode(node);
                                    nodeParent.insertBefore(createRuntimeAnchor(), nextNode);
                                } else {
                                    frag.anchor = $8fc928cd6c76f02e$var$claimAnchor(node);
                                    $8fc928cd6c76f02e$var$advanceHydrationNode(node);
                                }
                                return;
                            }
                            $8fc928cd6c76f02e$var$insertUntrackedAnchor(plan.parent, node && nodeParent === plan.parent ? node : slotEnd, createRuntimeAnchor());
                        },
                        onFallback: ()=>{
                            createRuntimeAnchor();
                        }
                    });
                    break;
                }
            case "create":
                if (plan.resetNodes) frag.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                if (plan.mark) $8fc928cd6c76f02e$var$claimAnchor(plan.mark);
                $8fc928cd6c76f02e$var$insertUntrackedAnchor(plan.parent, plan.next, createRuntimeAnchor());
                break;
            case "create-cleanup":
                {
                    frag.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                    const cleanupParent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(plan.cleanupStart);
                    if (cleanupParent) $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(cleanupParent, plan.cleanupStart, plan.cleanupUntil, 1);
                    if (plan.cleanupUntil) exitHydrationBoundary = $8fc928cd6c76f02e$var$enterHydrationBoundary(plan.cleanupUntil);
                    else {
                        $8fc928cd6c76f02e$var$cleanupHydrationTail(plan.cleanupStart, plan.cleanupContainer);
                        $8fc928cd6c76f02e$var$setCurrentHydrationNode(null);
                    }
                    $8fc928cd6c76f02e$var$insertUntrackedAnchor(plan.parent, plan.next, createRuntimeAnchor());
                    break;
                }
        }
    } finally{
        exitHydrationBoundary && exitHydrationBoundary();
        if (advanceAfterRestore && $8fc928cd6c76f02e$var$currentHydrationNode === advanceAfterRestore) $8fc928cd6c76f02e$var$advanceHydrationNode(advanceAfterRestore);
    }
}
function $8fc928cd6c76f02e$var$hydrateDynamicFragmentAnchor(frag, isEmpty = false) {
    $8fc928cd6c76f02e$var$executeAnchorPlan(frag, $8fc928cd6c76f02e$var$resolveDynamicAnchor(frag, isEmpty));
}
function $8fc928cd6c76f02e$var$updateHydratingSlotContent(frag, render, key) {
    const contentStart = $8fc928cd6c76f02e$var$currentHydrationNode;
    const pending = $8fc928cd6c76f02e$var$startPendingSlotContentGuard(frag.sharedFallback || $8fc928cd6c76f02e$var$hasSlotFallback(frag.boundary), contentStart);
    try {
        frag.updateContent(render, key);
        const contentValid = $8fc928cd6c76f02e$var$isValidSlot(frag.getContent());
        pending.finish(contentValid);
        return {
            contentStart: contentStart,
            contentValid: contentValid
        };
    } finally{
        pending.settle();
    }
}
/** The hydrating half of `SlotFragment.updateSlot`: content, then anchor. */ function $8fc928cd6c76f02e$var$hydrateSlotFragmentContent(frag, render, hasLocalFallback, key, shouldForce) {
    if (frag.sharedFallback || frag.inheritFallback && !hasLocalFallback) {
        const claim = $8fc928cd6c76f02e$var$createFragmentClaim();
        $8fc928cd6c76f02e$var$locateHydrationNode(claim);
        const { contentStart: contentStart, contentValid: contentValid } = $8fc928cd6c76f02e$var$updateHydratingSlotContent(frag, render, key);
        const end = $8fc928cd6c76f02e$var$locateFragmentEnd(claim.start);
        let exposedValid = contentValid;
        if (frag.sharedFallback) {
            $8fc928cd6c76f02e$var$recheckSlotResolution(frag, shouldForce || frag.pendingRecheckForce);
            exposedValid = $8fc928cd6c76f02e$var$isValidSlot(frag.nodes);
        } else {
            frag.syncNodes();
            frag.lastNodesValid = contentValid;
        }
        if (exposedValid) {
            if (end) {
                frag.anchor = $8fc928cd6c76f02e$var$claimAnchor(end);
                $8fc928cd6c76f02e$var$advanceHydrationNode(end);
            } else $8fc928cd6c76f02e$var$hydrateDynamicFragmentAnchor(frag, !$8fc928cd6c76f02e$var$isValidBlock(frag.nodes));
        } else if (frag.sharedFallback) {
            var _frag$anchorLabel2;
            const slotEnd = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor();
            const candidate = end && end !== slotEnd ? end : null;
            if (candidate) $8fc928cd6c76f02e$var$advanceHydrationNode(candidate);
            const anchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
            frag.anchor = anchor;
            $8fc928cd6c76f02e$var$claimPrecedingFragmentClose(slotEnd);
            const attachContent = $8fc928cd6c76f02e$var$createDeferredSlotAttach(contentStart, slotEnd, anchor, candidate, (candidate)=>frag.anchor = $8fc928cd6c76f02e$var$claimAnchor(candidate), ()=>frag.nodes);
            if (!$8fc928cd6c76f02e$var$queuePendingSlotContentAnchor({
                onContent: attachContent,
                onFallback: ()=>{}
            })) {
                if (candidate) $8fc928cd6c76f02e$var$claimAnchor(candidate);
                (0, $3dLyd.queuePostFlushCb)(attachContent);
            }
        } else {
            var _frag$anchorLabel3;
            const anchor = frag.anchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
            const slotEnd = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor();
            const parent = slotEnd && slotEnd.parentNode;
            if (parent) {
                $8fc928cd6c76f02e$var$claimPrecedingFragmentClose(slotEnd);
                (0, $3dLyd.queuePostFlushCb)(()=>{
                    if (slotEnd.parentNode === parent) parent.insertBefore(anchor, slotEnd);
                });
            }
        }
    } else $8fc928cd6c76f02e$var$withHydratingSlotBoundary(()=>{
        $8fc928cd6c76f02e$var$updateHydratingSlotContent(frag, render, key);
        $8fc928cd6c76f02e$var$recheckSlotResolution(frag, shouldForce || frag.pendingRecheckForce);
        $8fc928cd6c76f02e$var$hydrateDynamicFragmentAnchor(frag, !$8fc928cd6c76f02e$var$isValidBlock(frag.nodes));
    });
}
//#endregion
//#region packages/runtime-vapor/src/componentSlots.ts
const $8fc928cd6c76f02e$var$rawSlotsOwnerMap = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$rawSlotWrappersCache = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots) {
    if (!rawSlots) return rawSlots;
    const normalized = (0, $7s0Ms.isFunction)(rawSlots) ? {
        default: rawSlots
    } : rawSlots;
    if (!$8fc928cd6c76f02e$var$rawSlotsOwnerMap.has(normalized)) $8fc928cd6c76f02e$var$rawSlotsOwnerMap.set(normalized, $8fc928cd6c76f02e$var$getScopeOwner());
    return normalized;
}
/**
* Freeze the slot set of a v-once component: dynamic sources resolve once,
* in `resolveSlot` precedence, into plain entries. The slot functions stay
* live; the child re-runs them on its own updates.
*/ function $8fc928cd6c76f02e$var$snapshotRawSlots(rawSlots) {
    const dynamicSources = rawSlots.$;
    if (!dynamicSources) return rawSlots;
    const snapshot = {};
    for(const key in rawSlots)if (key !== "$") snapshot[key] = rawSlots[key];
    for (const source of dynamicSources)if ((0, $7s0Ms.isFunction)(source)) {
        const slot = $8fc928cd6c76f02e$var$withSlotOwner(rawSlots, ()=>source());
        if ((0, $7s0Ms.isArray)(slot)) for (const s of slot)snapshot[String(s.name)] = s.fn;
        else if (slot) snapshot[String(slot.name)] = slot.fn;
    } else for(const key in source)snapshot[key] = source[key];
    for (const symbol of Object.getOwnPropertySymbols(rawSlots))snapshot[symbol] = rawSlots[symbol];
    $8fc928cd6c76f02e$var$rawSlotsOwnerMap.set(snapshot, $8fc928cd6c76f02e$var$rawSlotsOwnerMap.get(rawSlots) || null);
    return snapshot;
}
function $8fc928cd6c76f02e$var$withSlotOwner(slots, fn) {
    const owner = $8fc928cd6c76f02e$var$rawSlotsOwnerMap.get(slots);
    if (owner === void 0) return fn();
    return $8fc928cd6c76f02e$var$withRenderContext($8fc928cd6c76f02e$var$deriveSlotOwner($8fc928cd6c76f02e$var$currentRenderContext, owner), fn);
}
function $8fc928cd6c76f02e$var$getOwnedSlot(slots, key, slot) {
    if (!$8fc928cd6c76f02e$var$rawSlotsOwnerMap.has(slots)) return slot;
    let wrappers = $8fc928cd6c76f02e$var$rawSlotWrappersCache.get(slots);
    if (!wrappers) $8fc928cd6c76f02e$var$rawSlotWrappersCache.set(slots, wrappers = /* @__PURE__ */ new Map());
    const cached = wrappers.get(key);
    if (cached && cached.slot === slot) return cached.wrapped;
    const wrapped = (...args)=>$8fc928cd6c76f02e$var$withSlotOwner(slots, ()=>slot(...args));
    wrapped._ = slot._;
    wrappers.set(key, {
        slot: slot,
        wrapped: wrapped
    });
    return wrapped;
}
const $8fc928cd6c76f02e$var$dynamicSlotsProxyHandlers = {
    get: $8fc928cd6c76f02e$var$getSlot,
    has: (target, key)=>!!$8fc928cd6c76f02e$var$getSlot(target, key),
    getOwnPropertyDescriptor (target, key) {
        const slot = $8fc928cd6c76f02e$var$getSlot(target, key);
        if (slot) return {
            configurable: true,
            enumerable: true,
            value: slot
        };
    },
    ownKeys (target) {
        const keys = new Set(Object.keys(target).filter((k)=>k !== "$"));
        const dynamicSources = target.$;
        if (dynamicSources) for (const source of dynamicSources)if ((0, $7s0Ms.isFunction)(source)) {
            const slot = $8fc928cd6c76f02e$var$withSlotOwner(target, ()=>$8fc928cd6c76f02e$var$resolveFunctionSource(source));
            if (slot) {
                if ((0, $7s0Ms.isArray)(slot)) for (const s of slot)keys.add(String(s.name));
                else keys.add(String(slot.name));
            }
        } else for (const key of Object.keys(source))keys.add(key);
        return [
            ...keys
        ];
    },
    set: (0, $7s0Ms.NO),
    deleteProperty: (0, $7s0Ms.NO)
};
function $8fc928cd6c76f02e$var$getSlot(target, key) {
    const slot = $8fc928cd6c76f02e$var$resolveSlot(target, key);
    if (slot) return $8fc928cd6c76f02e$var$getOwnedSlot(target, key, (0, $7s0Ms.isFunction)(slot) ? slot : slot.fn);
}
function $8fc928cd6c76f02e$var$resolveSlot(target, key) {
    if (key === "$") return;
    const dynamicSources = target.$;
    if (dynamicSources) {
        let i = dynamicSources.length;
        let source;
        while(i--){
            source = dynamicSources[i];
            if ((0, $7s0Ms.isFunction)(source)) {
                const slot = $8fc928cd6c76f02e$var$withSlotOwner(target, ()=>$8fc928cd6c76f02e$var$resolveFunctionSource(source));
                if (slot) {
                    if ((0, $7s0Ms.isArray)(slot)) {
                        for(let j = slot.length - 1; j >= 0; j--)if (String(slot[j].name) === key) return slot[j];
                    } else if (String(slot.name) === key) return slot;
                }
            } else if ((0, $7s0Ms.hasOwn)(source, key)) return source[key];
        }
    }
    if ((0, $7s0Ms.hasOwn)(target, key)) return target[key];
}
/**
* Get the effective slot instance for accessing rawSlots and scopeId.
* Prefers the slot owner (if inside a slot), falls back to currentInstance.
*/ function $8fc928cd6c76f02e$var$getScopeOwner() {
    return $8fc928cd6c76f02e$var$currentRenderContext.slotOwner || (0, $3dLyd.currentInstance);
}
function $8fc928cd6c76f02e$export$e88b45bda5c13eb9(name = "default", rawProps, fallback, flags = 0) {
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$resetInsertionState();
    let hydrationCursor = null;
    const instance = $8fc928cd6c76f02e$var$getScopeOwner();
    const rawSlots = instance.rawSlots;
    const scopeId = !(flags & 1) && instance.type.__scopeId;
    const outerSlotScopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
    const slotScopeIds = scopeId ? outerSlotScopeIds ? [
        ...outerSlotScopeIds,
        `${scopeId}-s`
    ] : [
        `${scopeId}-s`
    ] : outerSlotScopeIds;
    const once = !!(flags & 2);
    const slotProps = rawProps ? new Proxy(once ? $8fc928cd6c76f02e$var$snapshotRawProps(rawProps) : rawProps, $8fc928cd6c76f02e$var$rawPropsProxyHandlers) : (0, $7s0Ms.EMPTY_OBJ);
    let fragment;
    let isCustomElementSlot = false;
    const interopSlotsSource = $8fc928cd6c76f02e$var$isInteropEnabled && rawSlots[$8fc928cd6c76f02e$var$interopSlotsKey];
    if (interopSlotsSource) {
        if ($8fc928cd6c76f02e$var$isHydrating$1) hydrationCursor = $8fc928cd6c76f02e$var$enterHydrationCursor();
        fragment = $8fc928cd6c76f02e$var$withRenderContext($8fc928cd6c76f02e$var$deriveSlotScopeIds($8fc928cd6c76f02e$var$currentRenderContext, slotScopeIds), ()=>instance.appContext.vdom.slot(interopSlotsSource, name, slotProps, instance, {
                fallback: fallback,
                flags: flags,
                adoptAnchor: _insertionAnchor
            }));
    } else {
        if (once && fallback) {
            const originalFallback = fallback;
            fallback = (...args)=>$8fc928cd6c76f02e$export$81831a240bcfd22e(()=>originalFallback(...args));
        }
        if ($8fc928cd6c76f02e$var$isHydrating$1) hydrationCursor = $8fc928cd6c76f02e$var$captureHydrationCursor();
        const ce = instance.ce || $8fc928cd6c76f02e$var$isAsyncComponentEnabled && instance.parent && (0, $3dLyd.isAsyncWrapper)(instance.parent) && instance.parent.ce;
        isCustomElementSlot = !!(ce && ce._hasShadowRoot());
        const slotFragment = !isCustomElementSlot && $8fc928cd6c76f02e$var$shouldUseSlotFragment(rawSlots, name, fallback, flags) ? new $8fc928cd6c76f02e$var$SlotFragment(flags, _insertionAnchor) : void 0;
        let dynamicFragment;
        if (slotFragment) {
            slotFragment.ctx = $8fc928cd6c76f02e$var$deriveSlotScopeIds(slotFragment.ctx, slotScopeIds);
            fragment = slotFragment;
        } else {
            dynamicFragment = new $8fc928cd6c76f02e$export$2740cb41b6047c28(132, void 0, false, false, void 0, _insertionAnchor);
            const ctx = dynamicFragment.ctx;
            dynamicFragment.ctx = $8fc928cd6c76f02e$var$deriveRenderContext(ctx, ctx.slotOwner, null, slotScopeIds, ctx.suspense);
            fragment = dynamicFragment;
        }
        const isDynamicName = (0, $7s0Ms.isFunction)(name);
        const renderSlot = ()=>{
            if (isCustomElementSlot) {
                const el = /* @__PURE__ */ $8fc928cd6c76f02e$var$createElement("slot");
                if (slotScopeIds) $8fc928cd6c76f02e$var$setElementScopeIds(el, slotScopeIds);
                const setSlotProps = ()=>{
                    const slotName = (0, $7s0Ms.isFunction)(name) ? name() : name;
                    $8fc928cd6c76f02e$export$be77d6fc3302ce7c(el, [
                        slotProps,
                        slotName !== "default" ? {
                            name: slotName
                        } : {}
                    ]);
                };
                if (once) setSlotProps();
                else $8fc928cd6c76f02e$export$6c64e011838f4702(setSlotProps);
                if (fallback) {
                    const fallbackFn = fallback;
                    $8fc928cd6c76f02e$var$withRenderContext(dynamicFragment.ctx, ()=>{
                        const block = fallbackFn();
                        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block, el);
                        $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(block);
                    });
                }
                fragment.nodes = el;
                return;
            }
            const slotName = (0, $7s0Ms.isFunction)(name) ? name() : name;
            const resolvedSlot = $8fc928cd6c76f02e$var$resolveSlot(rawSlots, slotName);
            const slot = resolvedSlot ? $8fc928cd6c76f02e$var$getOwnedSlot(rawSlots, slotName, (0, $7s0Ms.isFunction)(resolvedSlot) ? resolvedSlot : resolvedSlot.fn) : void 0;
            const render = slot ? getBoundSlot(slot) : void 0;
            const key = resolvedSlot && !(0, $7s0Ms.isFunction)(resolvedSlot) && (0, $7s0Ms.hasOwn)(resolvedSlot, "key") ? resolvedSlot.key : render || fallback;
            if (slotFragment) slotFragment.updateSlot(render, fallback, key);
            else if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$withHydratingSlotBoundary(()=>dynamicFragment.update(render || fallback, key));
            else dynamicFragment.update(render || fallback, key);
        };
        let cachedSlot;
        let cachedBoundSlot;
        const getBoundSlot = (slot)=>{
            if (slot !== cachedSlot) {
                cachedSlot = slot;
                cachedBoundSlot = ()=>$8fc928cd6c76f02e$var$renderWithSlotScopeIds(slotScopeIds, ()=>once ? $8fc928cd6c76f02e$export$81831a240bcfd22e(()=>slot(slotProps)) : slot(slotProps));
            }
            return cachedBoundSlot;
        };
        if (!once && !isCustomElementSlot && (isDynamicName || rawSlots.$)) $8fc928cd6c76f02e$export$6c64e011838f4702(renderSlot);
        else renderSlot();
    }
    if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$isInteropFragment(fragment)) fragment.hydrate();
    $8fc928cd6c76f02e$var$finishBlockCreation(fragment, fragment.anchor, hydrationCursor, _insertionParent, _insertionAnchor, isCustomElementSlot);
    return fragment;
}
function $8fc928cd6c76f02e$var$shouldUseSlotFragment(rawSlots, name, fallback, flags) {
    if ($8fc928cd6c76f02e$var$currentRenderContext.slotBoundary && (0, $7s0Ms.isForwardedSlot)(flags)) return true;
    if (!fallback) return false;
    if (rawSlots === (0, $7s0Ms.EMPTY_OBJ)) return false;
    if ((0, $7s0Ms.isFunction)(name) || rawSlots.$) return true;
    const slot = $8fc928cd6c76f02e$var$resolveSlot(rawSlots, name);
    if (!slot) return false;
    return ((0, $7s0Ms.isFunction)(slot) ? slot : slot.fn)._ === 1;
}
//#endregion
//#region packages/runtime-vapor/src/scopeId.ts
/**
* Catch-up for slot content DOM created outside the ambient window (eager
* template clones, hand-built elements). Shallow on purpose: element subtrees
* can contain mounted component internals, so descendants are left to the
* creation-time ambient. Interop fragments derive their ids through the vdom
* patch context and are skipped.
*/ function $8fc928cd6c76f02e$var$stampSlotContent(block, scopeIds) {
    if (block instanceof Element) {
        for(let i = 0; i < scopeIds.length; i++)if (!block.hasAttribute(scopeIds[i])) block.setAttribute(scopeIds[i], "");
    } else if ((0, $7s0Ms.isArray)(block)) for (const b of block)$8fc928cd6c76f02e$var$stampSlotContent(b, scopeIds);
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$isInteropFragment(block))) $8fc928cd6c76f02e$var$stampSlotContent(block.nodes, scopeIds);
}
function $8fc928cd6c76f02e$var$renderWithSlotScopeIds(scopeIds, render) {
    const block = $8fc928cd6c76f02e$var$withRenderContext($8fc928cd6c76f02e$var$deriveSlotScopeIds($8fc928cd6c76f02e$var$currentRenderContext, scopeIds), render);
    if (scopeIds && !$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$stampSlotContent(block, scopeIds);
    return block;
}
function $8fc928cd6c76f02e$var$getCurrentScopeId() {
    const scopeOwner = $8fc928cd6c76f02e$var$getScopeOwner();
    return scopeOwner ? scopeOwner.type.__scopeId : void 0;
}
function $8fc928cd6c76f02e$var$registerScopeIdOwner(instance, frag) {
    const owners = frag.scopeIdOwners || (frag.scopeIdOwners = []);
    if (!owners.includes(instance)) owners.push(instance);
}
function $8fc928cd6c76f02e$var$resolveScopeIdRoot(instance, onComponent) {
    return $8fc928cd6c76f02e$var$getRootElement(instance.block, {
        onDynamicFragment: (frag)=>$8fc928cd6c76f02e$var$registerScopeIdOwner(instance, frag),
        onComponent: onComponent,
        excludeSlotOutlets: true
    });
}
function $8fc928cd6c76f02e$var$applyScopeIdOwners(owners) {
    for(let i = 0; i < owners.length; i++)$8fc928cd6c76f02e$var$applyRootScopeIds(owners[i]);
}
let $8fc928cd6c76f02e$var$publishInteropScopeIds = null;
function $8fc928cd6c76f02e$var$setPublishInteropScopeIds(fn) {
    $8fc928cd6c76f02e$var$publishInteropScopeIds = fn;
}
function $8fc928cd6c76f02e$var$pushOwnRootScopeIds(instance, ids) {
    const { scopeId: scopeId, slotScopeIds: slotScopeIds } = instance;
    if (scopeId) (ids || (ids = [])).push(scopeId);
    if (slotScopeIds) (ids || (ids = [])).push(...slotScopeIds);
    return ids;
}
function $8fc928cd6c76f02e$var$hasOwnRootScopeIds(instance) {
    return !!(instance.parent && (instance.scopeId || instance.slotScopeIds));
}
/**
* The instance's root-only ids, climbing the effective-root chain so the
* innermost owner's collection carries every ancestor's contribution.
* Assigned parent blocks ground the climb: a null parent block means an
* in-setup mount, where the mounting component is never the root.
*/ function $8fc928cd6c76f02e$var$collectRootScopeIds(instance) {
    let ids = $8fc928cd6c76f02e$var$pushOwnRootScopeIds(instance, null);
    let current = instance;
    while(current.parent && $8fc928cd6c76f02e$export$f43892e053afd2a0(current.parent) && $8fc928cd6c76f02e$var$isRootChainChild(current.parent, current)){
        current = current.parent;
        ids = $8fc928cd6c76f02e$var$pushOwnRootScopeIds(current, ids);
    }
    return ids;
}
function $8fc928cd6c76f02e$var$isRootChainChild(parent, child) {
    return parent.block === child || !!parent.block && $8fc928cd6c76f02e$var$getRootChainComponent(parent.block) === child;
}
/**
* Resolves the effective root, registers owners along the chain, and applies
* the instance's root-only ids: element roots are stamped, vnode-backed roots
* are published for core to apply at its own mount. When the chain crosses a
* nested component with its own root ids, the outer owner delegates — the
* innermost owner's collect climbs every ancestor, so one pre-insert
* application preserves both custom element connectedCallback timing and
* VDOM's innermost-first attribute order.
*/ function $8fc928cd6c76f02e$var$applyRootScopeIds(instance) {
    let delegated = false;
    const root = $8fc928cd6c76f02e$var$resolveScopeIdRoot(instance, (nested)=>{
        if ($8fc928cd6c76f02e$var$hasOwnRootScopeIds(nested)) delegated = true;
    });
    if (delegated) return;
    const scopeIds = $8fc928cd6c76f02e$var$collectRootScopeIds(instance);
    if (!scopeIds) return;
    if (root) $8fc928cd6c76f02e$var$setElementScopeIds(root, scopeIds);
    if ($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$publishInteropScopeIds) $8fc928cd6c76f02e$var$publishInteropScopeIds(instance.block, scopeIds);
}
function $8fc928cd6c76f02e$var$applyComponentScopeIds(instance) {
    if (!$8fc928cd6c76f02e$var$hasOwnRootScopeIds(instance)) return;
    $8fc928cd6c76f02e$var$applyRootScopeIds(instance);
}
/**
* Hydration counterpart of applyComponentScopeIds: hydrated roots already
* carry SSR scope attrs, so the walk only registers dynamic root tracking,
* publishes interop carriers, and stamps mismatch-recreated roots
* (client-built DOM without SSR attrs).
*/ function $8fc928cd6c76f02e$var$hydrateComponentScopeIds(instance) {
    if (!$8fc928cd6c76f02e$var$hasOwnRootScopeIds(instance)) return;
    const root = $8fc928cd6c76f02e$var$resolveScopeIdRoot(instance);
    const stampRoot = root && $8fc928cd6c76f02e$var$isRecreatedNode(root) ? root : void 0;
    const publish = $8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$publishInteropScopeIds;
    if (!stampRoot && !publish) return;
    const scopeIds = $8fc928cd6c76f02e$var$collectRootScopeIds(instance);
    if (!scopeIds) return;
    if (stampRoot) $8fc928cd6c76f02e$var$setElementScopeIds(stampRoot, scopeIds);
    if (publish) publish(instance.block, scopeIds);
}
//#endregion
//#region packages/runtime-vapor/src/keepAlive.ts
let $8fc928cd6c76f02e$var$isKeepAliveEnabled = false;
let $8fc928cd6c76f02e$var$currentCacheKey;
function $8fc928cd6c76f02e$var$enableKeepAlive() {
    $8fc928cd6c76f02e$var$isKeepAliveEnabled = true;
}
function $8fc928cd6c76f02e$var$withKeepAliveEnabled(value) {
    $8fc928cd6c76f02e$var$enableKeepAlive();
    return value;
}
function $8fc928cd6c76f02e$var$getKeepAliveContext(instance) {
    let owner = instance;
    while($8fc928cd6c76f02e$var$isAsyncComponentEnabled && owner && owner.vapor && (0, $3dLyd.isAsyncWrapper)(owner))owner = owner.parent;
    return owner && owner.vapor && (0, $3dLyd.isKeepAlive)(owner) ? owner.ctx : null;
}
function $8fc928cd6c76f02e$var$withCurrentCacheKey(key, fn) {
    if (key === void 0) return fn();
    const prev = $8fc928cd6c76f02e$var$currentCacheKey;
    $8fc928cd6c76f02e$var$currentCacheKey = key;
    try {
        return fn();
    } finally{
        $8fc928cd6c76f02e$var$currentCacheKey = prev;
    }
}
//#endregion
//#region packages/runtime-vapor/src/fragment.ts
var $8fc928cd6c76f02e$export$abfed41506cb93e8 = class {
    constructor(nodes, flags = 1){
        this.nodes = nodes;
        this.__vf = flags;
    }
};
var $8fc928cd6c76f02e$var$RenderContextFragment = class extends $8fc928cd6c76f02e$export$abfed41506cb93e8 {
    constructor(nodes, flags = 1){
        super(nodes, flags);
        this.renderInstance = (0, $3dLyd.currentInstance);
        this.ctx = $8fc928cd6c76f02e$var$currentRenderContext;
        if ($8fc928cd6c76f02e$var$isKeepAliveEnabled) this.keepAliveCtx = $8fc928cd6c76f02e$var$getKeepAliveContext((0, $3dLyd.currentInstance));
    }
    get slotBoundary() {
        return this.ctx.slotBoundary;
    }
    get slotScopeIds() {
        return this.ctx.slotScopeIds;
    }
    runWithRenderCtx(fn, scope) {
        return $8fc928cd6c76f02e$var$runWithRenderCtx(this, fn, scope);
    }
};
function $8fc928cd6c76f02e$var$runWithRenderCtx(fragment, fn, scope) {
    if (scope === void 0 && (0, $3dLyd.currentInstance) === fragment.renderInstance) return $8fc928cd6c76f02e$var$withRenderContext(fragment.ctx, fn);
    const prevInstance = (0, $3dLyd.setCurrentInstance)(fragment.renderInstance, scope);
    try {
        return $8fc928cd6c76f02e$var$withRenderContext(fragment.ctx, fn);
    } finally{
        (0, $3dLyd.restoreCurrentInstance)(prevInstance);
    }
}
/**
* The one construction point for a slot host's boundary context, shared by
* SlotFragment and both vdom-interop slot hosts. `run` and `getScopeIds`
* always come from the host fragment's render seam; `parent`, `getFallback`
* and `markDirty` stay host-specific (ownership caps, fallback sources and
* dirty batching differ per host).
*/ function $8fc928cd6c76f02e$var$createSlotBoundary(fragment, parent, getFallback, markDirty, onContentInvalid) {
    return {
        parent: parent,
        getFallback: getFallback,
        run: (fn, scope)=>$8fc928cd6c76f02e$var$runWithRenderCtx(fragment, fn, scope),
        getScopeIds: ()=>fragment.slotScopeIds,
        markDirty: markDirty,
        onContentInvalid: onContentInvalid
    };
}
var $8fc928cd6c76f02e$var$ForFragment = class extends $8fc928cd6c76f02e$export$abfed41506cb93e8 {
    constructor(nodes, trackSlotBoundary, onInvalid){
        super(nodes, 8);
        if (trackSlotBoundary) $8fc928cd6c76f02e$var$trackSlotBoundaryDirtying(this, onInvalid);
    }
    onReset(fn) {
        (this.resetListeners || (this.resetListeners = [])).push(fn);
    }
};
var $8fc928cd6c76f02e$var$ForBlock = class extends $8fc928cd6c76f02e$export$abfed41506cb93e8 {
    constructor(nodes, scope, item, key, index, renderKey){
        super(nodes, 16);
        this.scope = scope;
        this.itemRef = item;
        this.keyRef = key;
        this.indexRef = index;
        this.key = renderKey;
    }
};
var $8fc928cd6c76f02e$export$2740cb41b6047c28 = class extends $8fc928cd6c76f02e$var$RenderContextFragment {
    constructor(flags = 0, anchorLabel, keyed = false, trackSlotBoundary = false, onInvalid, adoptAnchor){
        super($8fc928cd6c76f02e$var$EMPTY_BLOCK, 2 | flags);
        this.everUpdated = false;
        if (keyed) this.keyed = true;
        if (!$8fc928cd6c76f02e$var$isHydrating$1) this.anchor = $8fc928cd6c76f02e$var$resolveFragmentAnchor(adoptAnchor, anchorLabel);
        if (trackSlotBoundary) $8fc928cd6c76f02e$var$trackSlotBoundaryDirtying(this, onInvalid);
    }
    get autoHydrate() {
        return true;
    }
    update(render, key = render, noScope = false, branchKey) {
        const everUpdated = this.everUpdated;
        this.everUpdated = true;
        if (key === this.current) {
            if ($8fc928cd6c76f02e$var$isHydrating$1 && this.autoHydrate) $8fc928cd6c76f02e$var$hydrateDynamicFragmentAnchor(this, true);
            return;
        }
        const transition = $8fc928cd6c76f02e$var$isTransitionEnabled ? this.$transition : void 0;
        const prevKey = this.current;
        const wasMounted = prevKey !== void 0;
        this.current = key;
        const prevSub = (0, $SdEQh.setActiveSub)();
        let reusingDeferredAnchor = false;
        try {
            const parent = !$8fc928cd6c76f02e$var$isHydrating$1 ? this.getBranchParent() : null;
            const isUpdate = wasMounted || everUpdated && !!parent;
            if (isUpdate) {
                const bu = this.bu;
                if (bu) for(let i = 0; i < bu.length; i++)bu[i]();
            }
            if (transition && $8fc928cd6c76f02e$var$deferBranchUpdateDuringLeave(this, render, key, noScope, branchKey)) return;
            let removePrevious;
            if (wasMounted) {
                const scope = this.scope;
                const previous = this.nodes;
                const removeBranch = ()=>$8fc928cd6c76f02e$export$cd7f480d6b8286c3(previous, parent || void 0);
                let deferRemoval = false;
                if (scope) {
                    if (this.keepAliveCtx) deferRemoval = this.keepAliveCtx.prepareBranchRemoval(this, scope, prevKey);
                    else scope.stop();
                }
                if (transition && $8fc928cd6c76f02e$var$removeBranchWithLeave(this, transition, parent, render, key, noScope, branchKey)) return;
                if (deferRemoval) removePrevious = removeBranch;
                else removeBranch();
            }
            reusingDeferredAnchor = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$prepareDeferredHydrationAnchor(this, !!render) : false;
            this.renderBranch(render, transition, parent, key, noScope, isUpdate, removePrevious, branchKey);
        } finally{
            (0, $SdEQh.setActiveSub)(prevSub);
        }
        if ($8fc928cd6c76f02e$var$isHydrating$1 && this.autoHydrate && !reusingDeferredAnchor) $8fc928cd6c76f02e$var$hydrateDynamicFragmentAnchor(this, render == null);
    }
    getBranchParent() {
        return this.anchor.parentNode;
    }
    renderBranch(render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey) {
        this.branchKey = this.keyed ? key : branchKey;
        if (render) {
            const keepAliveCtx = $8fc928cd6c76f02e$var$isKeepAliveEnabled ? this.keepAliveCtx : null;
            const useScope = !noScope || !!this.fallthrough;
            if (keepAliveCtx) keepAliveCtx.runBranchRender(this, ()=>this.renderNodes(render, useScope, parent, transition), useScope, removePrevious);
            else {
                this.scope = useScope ? new (0, $SdEQh.EffectScope)() : void 0;
                this.renderNodes(render, useScope, parent, transition);
            }
            if (this.scopeIdOwners) $8fc928cd6c76f02e$var$applyScopeIdOwners(this.scopeIdOwners);
            if (parent) {
                $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.nodes, parent, this.anchor);
                if (removePrevious && keepAliveCtx) keepAliveCtx.cacheBlock(this);
            }
        } else {
            this.scope = void 0;
            this.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
            if (removePrevious) removePrevious();
        }
        const u = this.u;
        if (notifyUpdated && u) for(let i = 0; i < u.length; i++)u[i](this.nodes);
    }
    renderNodes(render, useScope, parent, transition) {
        try {
            this.nodes = this.runWithRenderCtx(()=>{
                const nodes = (useScope ? this.scope.run(render) : render()) || $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                if (parent && this.fallthrough) this.fallthrough(nodes);
                const bm = this.bm;
                if (bm) for(let i = 0; i < bm.length; i++)bm[i](nodes);
                return nodes;
            });
        } finally{
            if ($8fc928cd6c76f02e$var$isTransitionEnabled && transition) this.$transition = $8fc928cd6c76f02e$var$applyTransitionHooks(this.nodes, transition, this);
        }
    }
};
var $8fc928cd6c76f02e$var$SlotFragment = class extends $8fc928cd6c76f02e$export$2740cb41b6047c28 {
    constructor(flags = 0, adoptAnchor){
        super(1156, void 0, false, false, void 0, adoptAnchor);
        this.disposed = false;
        this.activeFallback = null;
        this.fallbackInserted = false;
        this.pendingRecheck = false;
        this.pendingRecheckForce = false;
        this.isReconciling = false;
        this.content = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
        this.isUpdating = false;
        (0, $SdEQh.onScopeDispose)(()=>{
            this.disposed = true;
            if (this.fallbackScope) this.fallbackScope.stop();
        }, true);
        this.sharedFallback = !!(flags & 8);
        this.inheritFallback = (0, $7s0Ms.slotInheritsFallback)(flags);
        this.notifyParentBoundary = (0, $7s0Ms.slotNotifiesBoundary)(flags);
        if (this.sharedFallback) {
            if (this.slotBoundary) $8fc928cd6c76f02e$var$registerContentInvalid(this.slotBoundary, ()=>{
                $8fc928cd6c76f02e$var$invalidateExposedSlotContent(this);
                const anchor = this.anchor;
                const parent = anchor.parentNode;
                if (parent) {
                    $8fc928cd6c76f02e$var$removeAttachedNodes$1(this.content, parent);
                    if (this.activeFallback) $8fc928cd6c76f02e$var$removeAttachedNodes$1(this.activeFallback, parent);
                    $8fc928cd6c76f02e$var$removeNode(anchor, parent);
                }
            }, this);
        }
    }
    get autoHydrate() {
        return false;
    }
    renderBranch(render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey) {
        super.renderBranch(render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey);
        if (!this.isUpdating) {
            this.content = this.nodes;
            $8fc928cd6c76f02e$var$recheckSlotResolution(this, false);
        }
    }
    get boundary() {
        return this.ownBoundary || (this.ownBoundary = $8fc928cd6c76f02e$var$createSlotBoundary(this, this.inheritFallback ? this.slotBoundary : null, ()=>this.localFallback, (force)=>$8fc928cd6c76f02e$var$markSlotResolutionDirty(this, force)));
    }
    insert(parent, anchor, parentSuspense) {
        this.disposed = false;
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.nodes, parent, anchor, parentSuspense);
        if (this.activeFallback === this.nodes) this.fallbackInserted = true;
    }
    move(parent, anchor, moveType, parentComponent, parentSuspense) {
        $8fc928cd6c76f02e$var$move(this.nodes, parent, anchor, moveType, parentComponent, parentSuspense);
        if (this.activeFallback === this.nodes) this.fallbackInserted = true;
    }
    remove(parent) {
        this.disposed = true;
        if (this.fallbackScope) this.fallbackScope.stop();
        const nodes = this.nodes;
        $8fc928cd6c76f02e$export$cd7f480d6b8286c3(nodes, parent);
        if (this.activeFallback === nodes) {
            this.activeFallback = null;
            this.fallbackInserted = false;
        }
        this.clearContentInvalid();
        $8fc928cd6c76f02e$var$disposeSlotResolution(this, parent);
    }
    clearContentInvalid() {
        const callbacks = this.ownBoundary && this.ownBoundary.onContentInvalid;
        if (callbacks) callbacks.length = 0;
    }
    getBranchParent() {
        return this.activeFallback ? null : super.getBranchParent();
    }
    updateContent(render, key) {
        if (key !== this.current) this.clearContentInvalid();
        this.nodes = this.content;
        this.update(render, key);
        this.content = this.nodes;
    }
    updateSlot(render, fallback, key = render || fallback) {
        const prevLocalFallback = this.localFallback;
        this.localFallback = fallback;
        const boundary = this.boundary;
        const contentCtx = this.contentCtx || (this.contentCtx = $8fc928cd6c76f02e$var$deriveSlotBoundary(this.ctx, boundary));
        const slotRender = render ? ()=>$8fc928cd6c76f02e$var$withRenderContext(contentCtx, render) : ()=>$8fc928cd6c76f02e$var$EMPTY_BLOCK;
        this.isUpdating = true;
        this.pendingRecheck = false;
        try {
            const shouldForce = prevLocalFallback !== fallback;
            if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$hydrateSlotFragmentContent(this, slotRender, !!fallback, key, shouldForce);
            else {
                this.updateContent(slotRender, key);
                $8fc928cd6c76f02e$var$recheckSlotResolution(this, shouldForce || this.pendingRecheckForce);
            }
        } finally{
            this.pendingRecheck = false;
            this.pendingRecheckForce = false;
            this.isUpdating = false;
        }
    }
    getContent() {
        return this.content;
    }
    getParentNode() {
        return this.anchor ? this.anchor.parentNode : null;
    }
    getAnchor() {
        return this.anchor || null;
    }
    isBusy() {
        return this.isUpdating;
    }
    isDisposed() {
        return this.disposed;
    }
    isContentValid() {
        return $8fc928cd6c76f02e$var$isValidSlot(this.content);
    }
    syncNodes() {
        this.nodes = $8fc928cd6c76f02e$var$resolveExposedSlotNodes(this);
    }
    notifyExposedValidityChange() {
        if (this.notifyParentBoundary && this.slotBoundary) this.slotBoundary.markDirty();
    }
};
/**
* Adopt the template `<!>` placeholder passed through the insertion state as
* the fragment anchor instead of creating (and later inserting) a runtime
* anchor. Restricted to comments: adopting any other node would remove user
* DOM on removeFragment. Callers detect adoption by identity: the returned
* node is the adopted anchor iff it equals the passed one.
*/ function $8fc928cd6c76f02e$var$resolveFragmentAnchor(adopt, anchorLabel) {
    if (adopt && adopt.nodeType === 8) return $8fc928cd6c76f02e$var$claimUntrackedAnchor(adopt);
    return $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
}
/**
* Whether a fragment adopted the captured insertion anchor — the template
* `<!>` placeholder — as its own, which means it rendered in place and the
* creator must skip its trailing insert. Unrelated to hydration's
* `isClaimedAnchor` / `skipUntrackedAnchors`, which are about anchor nodes
* marked during a hydration pass.
*
* The insertion anchor must be checked non-null: append inserts capture no
* anchor, and fragments without a client anchor (vdom interop slots, any
* fragment during hydration) would otherwise compare undefined === undefined
* and falsely skip their only insertion.
*/ function $8fc928cd6c76f02e$var$isAdoptedPlaceholder(fragmentAnchor, insertionAnchor) {
    return !!insertionAnchor && fragmentAnchor === insertionAnchor;
}
/**
* Shared tail for every block-creating API (`createIf`, `createFor`,
* `createKeyedFragment`, `createDynamicComponent`, slot outlets): the block is
* built, now hand it over to the scope that asked for it.
*
* Client render: insert it at the captured insertion point, unless it adopted
* that point's `<!>` placeholder as its own anchor and therefore already
* rendered in place. Hydration: there is nothing to insert — the block adopted
* server nodes where they already stood — so hand back the cursor instead.
*
* Site-specific hydration work (claiming a leftover `<!---->`, advancing past
* an anchor, running an interop fragment's `hydrate()`) belongs *before* this
* call, guarded by `isHydrating`; keeping it out of here avoids allocating a
* callback on the client-render path, which never needs one.
*/ function $8fc928cd6c76f02e$var$finishBlockCreation(block, anchor, cursor, insertionParent, insertionAnchor, force) {
    if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$exitHydrationCursor(cursor);
    else if (insertionParent && (force || !$8fc928cd6c76f02e$var$isAdoptedPlaceholder(anchor, insertionAnchor))) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block, insertionParent, insertionAnchor);
    if (insertionParent) $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(block);
}
function $8fc928cd6c76f02e$export$9522e17588c12572(val) {
    return !!(val && val.__vf);
}
function $8fc928cd6c76f02e$var$isInteropFragment(val) {
    return !!(val && val.__vf & 64);
}
function $8fc928cd6c76f02e$var$isSlotOutletFragment(val) {
    return !!(val && val.__vf & 128);
}
function $8fc928cd6c76f02e$var$isDynamicFragment(val) {
    return !!(val && val.__vf & 2);
}
/**
* The key a fragment hands to its branch root as default: a declared key
* (static key on a dynamic component) or the current branch key (keyed
* fragment, dynamic component `:key`, v-if branch index).
*/ function $8fc928cd6c76f02e$var$getFragmentKey(frag) {
    var _frag$$key;
    return (_frag$$key = frag.$key) !== null && _frag$$key !== void 0 ? _frag$$key : frag.branchKey;
}
function $8fc928cd6c76f02e$var$isForFragment(val) {
    return !!(val && val.__vf & 8);
}
function $8fc928cd6c76f02e$var$isForBlock(val) {
    return !!(val && val.__vf & 16);
}
function $8fc928cd6c76f02e$var$isVaporSlotOutlet(val) {
    return !!(val && val.__vf & 4);
}
function $8fc928cd6c76f02e$var$isSlotResolver(val) {
    return !!(val && val.__vf & 1024);
}
//#endregion
//#region packages/runtime-vapor/src/teleport.ts
let $8fc928cd6c76f02e$var$isTeleportEnabled = false;
function $8fc928cd6c76f02e$var$enableTeleport(value) {
    $8fc928cd6c76f02e$var$isTeleportEnabled = true;
    return value;
}
function $8fc928cd6c76f02e$var$isVaporTeleport(value) {
    return !!(value && value.__isTeleport && value.__vapor);
}
function $8fc928cd6c76f02e$var$isTeleportFragment(value) {
    return !!(value && value.__vf & 32);
}
//#endregion
//#region packages/runtime-vapor/src/block.ts
const $8fc928cd6c76f02e$var$EMPTY_BLOCK = (0, $7s0Ms.EMPTY_ARR);
function $8fc928cd6c76f02e$var$isBlock(val) {
    return val instanceof Node || (0, $7s0Ms.isArray)(val) || $8fc928cd6c76f02e$export$f43892e053afd2a0(val) || $8fc928cd6c76f02e$export$9522e17588c12572(val);
}
function $8fc928cd6c76f02e$var$isValidBlock(block, componentAsValid = false) {
    if (!block) return false;
    else if (block instanceof Node) return !(block instanceof Comment) && !$8fc928cd6c76f02e$var$isClaimedAnchor(block);
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return componentAsValid || $8fc928cd6c76f02e$var$isValidBlock(block.block, componentAsValid);
    else if ((0, $7s0Ms.isArray)(block)) return block.length > 0 && block.some((block)=>$8fc928cd6c76f02e$var$isValidBlock(block, componentAsValid));
    else {
        if ($8fc928cd6c76f02e$var$isInteropEnabled && block.isBlockValid) return block.isBlockValid(componentAsValid);
        return $8fc928cd6c76f02e$var$isValidBlock(block.nodes, componentAsValid);
    }
}
function $8fc928cd6c76f02e$var$isValidSlot(block) {
    return $8fc928cd6c76f02e$var$isValidBlock(block, true);
}
function $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block, parent, anchor = null, parentSuspense) {
    if (block instanceof Node) {
        $8fc928cd6c76f02e$var$insertNode(block, parent, anchor, parentSuspense);
        return;
    }
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        if (block.isMounted && !block.isDeactivated) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block.block, parent, anchor, parentSuspense);
        else $8fc928cd6c76f02e$var$mountComponent(block, parent, anchor);
    } else if ((0, $7s0Ms.isArray)(block)) for (const b of block)$8fc928cd6c76f02e$export$21a5ca8aa77d35ff(b, parent, anchor, parentSuspense);
    else $8fc928cd6c76f02e$var$insertFragment(block, parent, anchor, parentSuspense);
}
function $8fc928cd6c76f02e$var$insertNode(block, parent, anchor = null, parentSuspense) {
    if (!$8fc928cd6c76f02e$var$isHydrating$1) {
        const transition = $8fc928cd6c76f02e$var$isTransitionEnabled && block instanceof Element ? block.$transition : void 0;
        if (transition) {
            const insert = ()=>parent.insertBefore(block, anchor);
            if ($8fc928cd6c76f02e$var$isVShowMountEnter(block, transition)) {
                transition.beforeEnter(block);
                insert();
                (0, $3dLyd.queuePostRenderEffect)(()=>transition.enter(block), void 0, parentSuspense);
            } else (0, $3dLyd.performTransitionEnter)(block, transition, insert, parentSuspense);
        } else if (block !== anchor) parent.insertBefore(block, anchor);
    }
}
function $8fc928cd6c76f02e$var$isVShowMountEnter(el, transition) {
    return transition.persisted && !!el.$vshow && !el[0, $bmuEm.vShowHidden];
}
function $8fc928cd6c76f02e$var$insertFragment(block, parent, anchor = null, parentSuspense) {
    const blockAnchor = block.anchor;
    if (blockAnchor) {
        $8fc928cd6c76f02e$var$insertNode(blockAnchor, parent, anchor, parentSuspense);
        anchor = blockAnchor;
    }
    if (block.insert) block.insert(parent, anchor, parentSuspense, block.$transition);
    else $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block.nodes, parent, anchor, parentSuspense);
}
function $8fc928cd6c76f02e$var$move(block, parent, anchor = null, moveType = 1, parentComponent, parentSuspense) {
    if (block instanceof Node) {
        if ($8fc928cd6c76f02e$var$isTransitionEnabled && block instanceof Element && block.$transition && moveType !== 2) {
            if (moveType === 0) (0, $3dLyd.performTransitionEnter)(block, block.$transition, ()=>parent.insertBefore(block, anchor), parentSuspense, true);
            else (0, $3dLyd.performTransitionLeave)(block, block.$transition, ()=>{
                if (moveType === 1 && parentComponent && parentComponent.isUnmounted) block.remove();
                else parent.insertBefore(block, anchor);
            }, true, true);
        } else parent.insertBefore(block, anchor);
    } else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        if (block.isMounted) $8fc928cd6c76f02e$var$move(block.block, parent, anchor, moveType, parentComponent, parentSuspense);
        else $8fc928cd6c76f02e$var$mountComponent(block, parent, anchor);
    } else if ((0, $7s0Ms.isArray)(block)) for (const b of block)$8fc928cd6c76f02e$var$move(b, parent, anchor, moveType, parentComponent, parentSuspense);
    else {
        if (block.anchor) {
            $8fc928cd6c76f02e$var$move(block.anchor, parent, anchor, moveType, parentComponent, parentSuspense);
            anchor = block.anchor;
        }
        if (block.move) block.move(parent, anchor, moveType, parentComponent, parentSuspense, block.$transition);
        else $8fc928cd6c76f02e$var$move(block.nodes, parent, anchor, moveType, parentComponent, parentSuspense);
    }
}
function $8fc928cd6c76f02e$export$cd7f480d6b8286c3(block, parent) {
    if (block instanceof Node) $8fc928cd6c76f02e$var$removeNode(block, parent);
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) $8fc928cd6c76f02e$var$unmountComponent(block, parent, $8fc928cd6c76f02e$var$isSuspenseEnabled && $8fc928cd6c76f02e$var$isInteropEnabled ? $8fc928cd6c76f02e$var$resolveUnmountSuspense(block.suspense) : block.suspense);
    else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$export$cd7f480d6b8286c3(block[i], parent);
    else $8fc928cd6c76f02e$var$removeFragment(block, parent);
}
function $8fc928cd6c76f02e$var$removeAttachedNodes$1(block, parent, removeAnchors = true) {
    if (block instanceof Node) {
        if (block.parentNode === parent) $8fc928cd6c76f02e$var$removeNode(block, parent);
    } else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        if (block.block) $8fc928cd6c76f02e$var$removeAttachedNodes$1(block.block, parent, removeAnchors);
    } else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$removeAttachedNodes$1(block[i], parent, removeAnchors);
    else {
        $8fc928cd6c76f02e$var$removeAttachedNodes$1(block.nodes, parent, removeAnchors);
        const anchor = block.anchor;
        if (removeAnchors && anchor && anchor.parentNode === parent) $8fc928cd6c76f02e$var$removeNode(anchor, parent);
    }
}
function $8fc928cd6c76f02e$var$removeNode(block, parent) {
    if ($8fc928cd6c76f02e$var$isTransitionEnabled && block.$transition && block instanceof Element) (0, $3dLyd.performTransitionLeave)(block, block.$transition, ()=>parent && block.parentNode === parent && parent.removeChild(block));
    else parent && parent.removeChild(block);
}
function $8fc928cd6c76f02e$var$removeFragment(block, parent) {
    const bum = block.bum;
    if (bum) for(let i = 0; i < bum.length; i++)bum[i]();
    if (block.remove) block.remove(parent, block.$transition);
    else $8fc928cd6c76f02e$export$cd7f480d6b8286c3(block.nodes, parent);
    if (block.anchor) $8fc928cd6c76f02e$var$removeNode(block.anchor, parent);
    if (block.scope) block.scope.stop();
}
/**
* Block removal doesn't descend into elements, so it never reaches a block
* mounted into one. Unmount the vdom components in its tree synchronously when
* its owner scope is disposed, as vdom does for an element's children.
*/ function $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(block) {
    if ($8fc928cd6c76f02e$var$isInteropEnabled && !(block instanceof Node)) (0, $SdEQh.onScopeDispose)(()=>$8fc928cd6c76f02e$var$unmountVDOM(block), true);
}
/**
* Unmounts the vdom components in a block tree whose DOM goes away without
* block removal.
*/ function $8fc928cd6c76f02e$var$unmountVDOM(block) {
    if (!block || block instanceof Node) return;
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) $8fc928cd6c76f02e$var$unmountVDOM(block.block);
    else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$unmountVDOM(block[i]);
    else if ($8fc928cd6c76f02e$var$isInteropFragment(block)) block.remove();
    else $8fc928cd6c76f02e$var$unmountVDOM(block.nodes);
}
/**
* dev / test only
*/ function $8fc928cd6c76f02e$var$normalizeBlock(block) {
    var child;
    throw new Error("normalizeBlock should not be used in production code paths");
}
/**
* First node of a block as it appears in its own container, or `undefined`
* when the block has no node there: an empty array of blocks, or a block
* whose content lives elsewhere (a teleport target) and has no marker left.
*/ function $8fc928cd6c76f02e$var$getBlockFirstNode(block) {
    if (block instanceof Node) return block;
    else if ((0, $7s0Ms.isArray)(block)) {
        for(let i = 0; i < block.length; i++){
            const anchor = $8fc928cd6c76f02e$var$getBlockFirstNode(block[i]);
            if (anchor) return anchor;
        }
        return;
    } else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return $8fc928cd6c76f02e$var$getBlockFirstNode($8fc928cd6c76f02e$var$getComponentPhysicalBlock(block));
    else {
        if ($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(block)) {
            const marker = block.placeholder || block.anchor;
            if (marker) return marker;
        }
        const nodes = block.nodes;
        if ($8fc928cd6c76f02e$var$isValidBlock(nodes)) return $8fc928cd6c76f02e$var$getBlockFirstNode(nodes);
        const node = $8fc928cd6c76f02e$var$getBlockFirstNode(nodes);
        const anchor = block.anchor;
        return node && (!anchor || node.parentNode === anchor.parentNode) ? node : anchor;
    }
}
function $8fc928cd6c76f02e$var$findBlockBoundary(block) {
    const boundaryBlock = $8fc928cd6c76f02e$export$f43892e053afd2a0(block) ? $8fc928cd6c76f02e$var$getComponentPhysicalBlock(block) : block;
    const lastChild = $8fc928cd6c76f02e$var$findLastChild(boundaryBlock);
    let { parentNode: parentNode, nextSibling: nextNode } = lastChild;
    if (nextNode && $8fc928cd6c76f02e$var$isComment(nextNode, "]") && $8fc928cd6c76f02e$var$isFragmentBlock(boundaryBlock) && !$8fc928cd6c76f02e$var$isComment(lastChild, "]") && !(lastChild.nodeType === 3 && !lastChild.data)) nextNode = nextNode.nextSibling;
    return {
        parentNode: parentNode,
        nextNode: nextNode
    };
}
function $8fc928cd6c76f02e$var$findLastChild(node) {
    if (node && node instanceof Node) return node;
    else if ((0, $7s0Ms.isArray)(node)) return $8fc928cd6c76f02e$var$findLastChild(node[node.length - 1]);
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(node)) return $8fc928cd6c76f02e$var$findLastChild($8fc928cd6c76f02e$var$getComponentPhysicalBlock(node));
    else {
        if (node.anchor) return node.anchor;
        return $8fc928cd6c76f02e$var$findLastChild(node.nodes);
    }
}
function $8fc928cd6c76f02e$var$getComponentPhysicalBlock(instance) {
    return $8fc928cd6c76f02e$var$isSuspenseEnabled && instance.pendingBlock || instance.block;
}
function $8fc928cd6c76f02e$var$isFragmentBlock(block) {
    if ((0, $7s0Ms.isArray)(block)) return true;
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return $8fc928cd6c76f02e$var$isFragmentBlock($8fc928cd6c76f02e$var$getComponentPhysicalBlock(block));
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block)) return $8fc928cd6c76f02e$var$isFragmentBlock(block.nodes);
    return false;
}
//#endregion
//#region packages/runtime-vapor/src/helpers/useCssVars.ts
/**
* Css vars are root-inherited state: the owner writes its root chain before
* insertion, containers on that chain write the content they produce later
* (`bm` hooks; `u` for vdom-owned interop content), and teleports are written
* directly as outlets since their content leaves the chain.
*/ function $8fc928cd6c76f02e$export$7ac556a74ffeb129(getter) {
    const instance = (0, $3dLyd.currentInstance);
    let vars = (0, $7s0Ms.EMPTY_OBJ);
    const apply = instance.applyCssVars = (nodes)=>{
        if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$setVarsOnBlock(nodes, vars);
        $8fc928cd6c76f02e$var$registerCssVarApply(nodes, apply);
    };
    const watchVars = ()=>(0, $3dLyd.watch)(()=>{
            vars = (0, $7s0Ms.extend)({}, getter());
            if (instance.ce) (0, $bmuEm.setVarsOnNode)(instance.ce, vars);
            else $8fc928cd6c76f02e$var$setVarsOnBlock(instance.block, vars);
            const outlets = instance.cssVarOutlets;
            if (outlets) for(let i = 0; i < outlets.length; i++)$8fc928cd6c76f02e$var$setVarsOnBlock(outlets[i].nodes, vars);
        }, (0, $7s0Ms.NOOP), {
            flush: "post"
        });
    (0, $3dLyd.onBeforeMount)(()=>{
        if (!instance.ce) $8fc928cd6c76f02e$var$registerCssVarApply(instance.block, apply);
    });
    if ($8fc928cd6c76f02e$var$isHydrating$1) (0, $3dLyd.onMounted)(watchVars);
    else (0, $3dLyd.onBeforeMount)(watchVars);
}
function $8fc928cd6c76f02e$var$setVarsOnBlock(block, vars) {
    if (block instanceof Node) (0, $bmuEm.setVarsOnNode)(block, vars);
    else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$setVarsOnBlock(block[i], vars);
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) $8fc928cd6c76f02e$var$setVarsOnBlock(block.block, vars);
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(block))) $8fc928cd6c76f02e$var$setVarsOnBlock(block.nodes, vars);
}
function $8fc928cd6c76f02e$var$registerCssVarApply(block, apply) {
    if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$registerCssVarApply(block[i], apply);
    else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        if (block.block) $8fc928cd6c76f02e$var$registerCssVarApply(block.block, apply);
        else (block.bm || (block.bm = [])).push(()=>apply(block.block));
    } else if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(block))) {
        const hooks = $8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$isInteropFragment(block) ? block.u || (block.u = []) : $8fc928cd6c76f02e$var$isDynamicFragment(block) || $8fc928cd6c76f02e$var$isForFragment(block) ? block.bm || (block.bm = []) : void 0;
        if (hooks && !hooks.includes(apply)) hooks.push(apply);
        $8fc928cd6c76f02e$var$registerCssVarApply(block.nodes, apply);
    }
}
function $8fc928cd6c76f02e$var$registerCssVarOutlet(owner, frag) {
    (owner.cssVarOutlets || (owner.cssVarOutlets = [])).push(frag);
    (0, $SdEQh.onScopeDispose)(()=>(0, $7s0Ms.remove)(owner.cssVarOutlets, frag), true);
}
function $8fc928cd6c76f02e$var$applyComponentCssVars(instance) {
    let current = instance;
    while(current && current.vapor){
        const owner = current;
        if (owner.applyCssVars && !owner.ce) owner.applyCssVars(owner.block);
        current = current.parent;
    }
}
//#endregion
//#region packages/runtime-vapor/src/hmr.ts
function $8fc928cd6c76f02e$var$hmrRerender(instance) {
    if (!instance.type.render) {
        const parent = instance.parent;
        if (parent && parent.vapor) return parent.hmrRerender();
        if (!parent && !instance.ce) return instance.hmrReload(instance.type);
    }
    const { parentNode: parentNode, nextNode: anchor } = $8fc928cd6c76f02e$var$findBlockBoundary(instance.block);
    const parent = parentNode;
    if (instance.renderScope) instance.renderScope.stop();
    $8fc928cd6c76f02e$export$cd7f480d6b8286c3(instance.block, parent);
    const prev = (0, $3dLyd.setCurrentInstance)(instance);
    (0, $3dLyd.pushWarningContext)(instance);
    try {
        $8fc928cd6c76f02e$var$withRenderContext($8fc928cd6c76f02e$var$deriveSlotScopeIds($8fc928cd6c76f02e$var$currentRenderContext, null), ()=>{
            $8fc928cd6c76f02e$var$runDevRender(instance);
            $8fc928cd6c76f02e$var$applyComponentFallthrough(instance);
        });
    } finally{
        (0, $3dLyd.popWarningContext)();
        (0, $3dLyd.restoreCurrentInstance)(prev);
    }
    $8fc928cd6c76f02e$var$applyComponentScopeIds(instance);
    $8fc928cd6c76f02e$var$applyComponentCssVars(instance);
    $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(instance.block, parent, anchor);
}
function $8fc928cd6c76f02e$var$hmrReload(instance, newComp) {
    const parentInstance = instance.parent;
    if (parentInstance) {
        parentInstance.hmrRerender();
        return;
    }
    const { parentNode: parentNode, nextNode: anchor } = $8fc928cd6c76f02e$var$findBlockBoundary(instance.block);
    const parent = parentNode;
    $8fc928cd6c76f02e$var$unmountComponent(instance, parent);
    const prev = (0, $3dLyd.setCurrentInstance)(parentInstance);
    let newInstance;
    try {
        newInstance = $8fc928cd6c76f02e$export$60e54eaca7e7fb38(newComp, instance.rawProps, instance.rawSlots, instance.isSingleRoot, void 0, instance.appContext);
    } finally{
        (0, $3dLyd.restoreCurrentInstance)(prev);
    }
    $8fc928cd6c76f02e$var$mountComponent(newInstance, parent, anchor);
    const app = instance.appContext.app;
    if (app && app._instance === instance) app._instance = newInstance;
}
//#endregion
//#region packages/runtime-vapor/src/component.ts
function $8fc928cd6c76f02e$var$useVdomInterop(component, appContext) {
    return !!appContext.vdom && !component.__vapor;
}
function $8fc928cd6c76f02e$var$resolveFallthroughOwner(isSingleRoot) {
    const instance = (0, $3dLyd.currentInstance);
    if ((isSingleRoot || $8fc928cd6c76f02e$var$isTransitionEnabled && instance && $8fc928cd6c76f02e$var$isVaporTransition(instance.type)) && $8fc928cd6c76f02e$export$f43892e053afd2a0(instance) && instance.type.inheritAttrs !== false && instance.hasFallthrough) return instance;
}
function $8fc928cd6c76f02e$export$60e54eaca7e7fb38(component, rawProps, rawSlots, isSingleRoot, once, appContext = (0, $3dLyd.currentInstance) && (0, $3dLyd.currentInstance).appContext || $8fc928cd6c76f02e$var$emptyContext, managedMount = false, ce) {
    const wasInOnce = $8fc928cd6c76f02e$var$inOnce;
    if (wasInOnce && !managedMount) once = true;
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    let hydration = null;
    let pendingAsyncHydration = false;
    if ($8fc928cd6c76f02e$var$isHydrating$1) hydration = $8fc928cd6c76f02e$var$enterComponentHydration(component);
    else $8fc928cd6c76f02e$var$resetInsertionState();
    const prevCtx = $8fc928cd6c76f02e$var$currentRenderContext;
    try {
        if ($8fc928cd6c76f02e$var$isSuspenseEnabled && !prevCtx.suspense && (0, $3dLyd.currentInstance) && (0, $3dLyd.currentInstance).suspense) $8fc928cd6c76f02e$var$setRenderContext($8fc928cd6c76f02e$var$deriveSuspense(prevCtx, (0, $3dLyd.currentInstance).suspense));
        const owner = $8fc928cd6c76f02e$var$resolveFallthroughOwner(isSingleRoot);
        if (owner) {
            const source = ()=>$8fc928cd6c76f02e$var$resolveFallthroughAttrs(owner);
            if (rawProps && rawProps !== (0, $7s0Ms.EMPTY_OBJ)) {
                const sources = rawProps.$;
                rawProps = (0, $7s0Ms.extend)({}, rawProps, {
                    $: sources ? sources.concat(source) : [
                        source
                    ]
                });
            } else rawProps = {
                $: [
                    source
                ]
            };
        }
        let keepAliveCtx = null;
        if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && (0, $3dLyd.currentInstance) && (0, $3dLyd.currentInstance).vapor && (0, $3dLyd.isKeepAlive)((0, $3dLyd.currentInstance))) {
            const ctx = (0, $3dLyd.currentInstance).ctx;
            keepAliveCtx = ctx;
            const cached = ctx.getCachedComponent(component);
            if (cached) {
                const scope = (0, $SdEQh.getCurrentScope)();
                if ($8fc928cd6c76f02e$export$f43892e053afd2a0(cached) && cached.unmountScope !== scope) {
                    cached.unmountScope = scope;
                    $8fc928cd6c76f02e$var$registerUnmount(cached);
                }
                return cached;
            }
        }
        let asyncBoundary = false;
        if ($8fc928cd6c76f02e$var$isAsyncComponentEnabled && !$8fc928cd6c76f02e$var$isHydrating$1) {
            const resolved = component.__asyncResolved;
            if (resolved && !($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$useVdomInterop(resolved, appContext))) {
                component = resolved;
                asyncBoundary = true;
            }
        }
        if ($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isVaporTeleport(component)) {
            const frag = component.process(rawProps, $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots), _insertionAnchor);
            if (_insertionParent) {
                (0, $SdEQh.onScopeDispose)(()=>frag.disposeTarget(), true);
                $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(frag);
            } else (0, $SdEQh.onScopeDispose)(()=>frag.scheduleTargetDispose(), true);
            if (!$8fc928cd6c76f02e$var$isHydrating$1) {
                if (_insertionParent) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag, _insertionParent, _insertionAnchor, $8fc928cd6c76f02e$var$currentRenderContext.suspense);
            } else frag.hydrate();
            return frag;
        }
        let inputScope;
        if (keepAliveCtx && !once && (rawProps || rawSlots && rawSlots.$)) {
            const scope = new (0, $SdEQh.EffectScope)(true);
            let isolated = false;
            scope.run(()=>{
                if (rawProps) {
                    const next = keepAliveCtx.isolatePropSources(rawProps);
                    isolated = next !== rawProps;
                    rawProps = next;
                }
                if (rawSlots && rawSlots.$) {
                    const next = keepAliveCtx.isolateSlotSources(rawSlots);
                    isolated = isolated || next !== rawSlots;
                    rawSlots = next;
                }
            });
            if (isolated) inputScope = scope;
        }
        if ($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$useVdomInterop(component, appContext)) {
            const frag = appContext.vdom.mount(component, (0, $3dLyd.currentInstance), rawProps, $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots), once);
            if (inputScope) frag.inputScope = inputScope;
            if (_insertionParent) $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(frag);
            if (!$8fc928cd6c76f02e$var$isHydrating$1) {
                if (_insertionParent) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag, _insertionParent, _insertionAnchor, $8fc928cd6c76f02e$var$currentRenderContext.suspense);
            } else frag.hydrate();
            return frag;
        }
        const instance = new $8fc928cd6c76f02e$var$VaporComponentInstance(component, rawProps, rawSlots, appContext, once, ce);
        if (inputScope) instance.inputScope = inputScope;
        if (asyncBoundary) (0, $3dLyd.markAsyncBoundary)(instance);
        if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && !($8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(instance))) {
            keepAliveCtx || (keepAliveCtx = $8fc928cd6c76f02e$var$getKeepAliveContext((0, $3dLyd.currentInstance)));
            if (keepAliveCtx) keepAliveCtx.processShapeFlag(instance);
        }
        const outerCtx = $8fc928cd6c76f02e$var$currentRenderContext;
        $8fc928cd6c76f02e$var$setRenderContext($8fc928cd6c76f02e$var$deriveRenderContext(outerCtx, null, outerCtx.slotBoundary, null, outerCtx.suspense));
        let hasWarningContext = false;
        let hasInitMeasure = false;
        if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(instance) && component.__asyncHydrate) {
            const setup = ()=>$8fc928cd6c76f02e$var$setupComponent(instance, component);
            component.__asyncHydrate($8fc928cd6c76f02e$var$currentHydrationNode, instance, wasInOnce ? ()=>$8fc928cd6c76f02e$export$81831a240bcfd22e(setup, false) : setup);
        } else {
            if (wasInOnce) $8fc928cd6c76f02e$export$81831a240bcfd22e(()=>$8fc928cd6c76f02e$var$setupComponent(instance, component), false);
            else $8fc928cd6c76f02e$var$setupComponent(instance, component);
            if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$isSuspenseEnabled && instance.suspense && instance.asyncDep) {
                const pendingBlock = [];
                const { claim: claim, cursor: cursor } = hydration;
                let node = claim && claim.start || cursor.start;
                const hydrationNext = $8fc928cd6c76f02e$var$nextLogicalSibling(node);
                do {
                    pendingBlock.push(node);
                    node = node.nextSibling;
                }while (node !== hydrationNext);
                instance.pendingBlock = pendingBlock.length === 1 ? pendingBlock[0] : pendingBlock;
                $8fc928cd6c76f02e$var$advanceHydrationNode(pendingBlock[pendingBlock.length - 1]);
                pendingAsyncHydration = true;
            }
        }
        if (keepAliveCtx) instance.unmountScope = (0, $SdEQh.getCurrentScope)();
        $8fc928cd6c76f02e$var$registerUnmount(instance);
        if (_insertionParent) $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(instance);
        if (!managedMount && (_insertionParent || $8fc928cd6c76f02e$var$isHydrating$1)) $8fc928cd6c76f02e$var$mountComponent(instance, _insertionParent, _insertionAnchor);
        return instance;
    } finally{
        $8fc928cd6c76f02e$var$setRenderContext(prevCtx);
        if (hydration) $8fc928cd6c76f02e$var$exitComponentHydration(hydration, !pendingAsyncHydration);
    }
}
/**
* Open a component's SSR range: locate its start and claim its markers.
* Shared by creation and by the deferred render of an async setup, which
* re-enters the range once setup has settled.
*/ function $8fc928cd6c76f02e$var$enterComponentHydration(component) {
    $8fc928cd6c76f02e$var$resolvePendingSlotContent();
    const claim = component.__multiRoot ? $8fc928cd6c76f02e$var$createFragmentClaim() : void 0;
    const cursor = $8fc928cd6c76f02e$var$enterHydrationCursor(claim, true);
    const close = claim && claim.start ? $8fc928cd6c76f02e$var$locateEndAnchor(claim.start) : null;
    if (close) $8fc928cd6c76f02e$var$claimAnchor(close);
    return {
        claim: claim,
        cursor: cursor,
        close: close
    };
}
/**
* Hand the cursor back; with `finalizeBoundary` the unclaimed tail of the
* range is trimmed first and the cursor moves past the close marker.
*/ function $8fc928cd6c76f02e$var$exitComponentHydration({ close: close, cursor: cursor }, finalizeBoundary) {
    if (finalizeBoundary) {
        $8fc928cd6c76f02e$var$trimHydrationBoundary(close);
        if (close && $8fc928cd6c76f02e$var$currentHydrationNode === close) $8fc928cd6c76f02e$var$advanceHydrationNode(close);
    }
    $8fc928cd6c76f02e$var$exitHydrationCursor(cursor);
}
function $8fc928cd6c76f02e$var$setupComponent(instance, component) {
    const prevInstance = (0, $3dLyd.setCurrentInstance)(instance);
    const prevSub = (0, $SdEQh.setActiveSub)();
    const setupFn = (0, $7s0Ms.isFunction)(component) ? component : component.setup;
    const setupResult = setupFn ? (0, $3dLyd.callWithErrorHandling)(setupFn, instance, 0, [
        instance.props,
        instance
    ]) || (0, $7s0Ms.EMPTY_OBJ) : (0, $7s0Ms.EMPTY_OBJ);
    const isAsyncSetup = (0, $7s0Ms.isPromise)(setupResult);
    if ((isAsyncSetup || instance.sp) && !($8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(instance))) (0, $3dLyd.markAsyncBoundary)(instance);
    if (isAsyncSetup) {
        instance.asyncDep = setupResult;
        var _getComponentName;
    } else $8fc928cd6c76f02e$var$handleSetupResult(setupResult, component, instance);
    (0, $SdEQh.setActiveSub)(prevSub);
    (0, $3dLyd.restoreCurrentInstance)(prevInstance);
}
let $8fc928cd6c76f02e$var$isApplyingFallthroughProps = false;
function $8fc928cd6c76f02e$var$shouldUseFunctionalFallthrough(component) {
    return (0, $7s0Ms.isFunction)(component) && !component.props && !($8fc928cd6c76f02e$var$isTransitionEnabled && $8fc928cd6c76f02e$var$isVaporTransition(component));
}
/**
* The single source of truth for the attrs a component may fall through to
* its effective root — used both for the root element render effect and for
* forwarding into a root component's props. Functional components without
* declared props only pass class / style / event listeners; v-model
* listeners with a corresponding declared prop never fall through (the
* component handles the v-model itself — #1543, #1643, #1989). Never
* returns undefined so consumers can always diff away stale keys.
*/ function $8fc928cd6c76f02e$var$resolveFallthroughAttrs(instance) {
    const attrs = $8fc928cd6c76f02e$var$shouldUseFunctionalFallthrough(instance.type) ? (0, $3dLyd.getFunctionalFallthrough)(instance.attrs) || (0, $7s0Ms.EMPTY_OBJ) : instance.attrs;
    const propsOptions = $8fc928cd6c76f02e$var$normalizePropsOptions(instance.type)[0];
    if (propsOptions) {
        for(const key in attrs)if ((0, $7s0Ms.isModelListener)(key)) return (0, $3dLyd.filterModelListeners)(attrs, propsOptions);
    }
    return attrs;
}
function $8fc928cd6c76f02e$var$isDeclaredModelListener(instance, key) {
    if (!(0, $7s0Ms.isModelListener)(key)) return false;
    const propsOptions = $8fc928cd6c76f02e$var$normalizePropsOptions(instance.type)[0];
    return !!propsOptions && key.slice(9) in propsOptions;
}
function $8fc928cd6c76f02e$var$applyFallthroughProps(el, attrs) {
    $8fc928cd6c76f02e$var$isApplyingFallthroughProps = true;
    try {
        $8fc928cd6c76f02e$var$patchDynamicProps(el, attrs);
    } finally{
        $8fc928cd6c76f02e$var$isApplyingFallthroughProps = false;
    }
}
/**
* dev only
*/ function $8fc928cd6c76f02e$var$createDevSetupStateProxy(setupState) {
    return new Proxy(setupState, {
        get (target, key, receiver) {
            if ((0, $7s0Ms.isString)(key) && !key.startsWith("__v") && !(0, $7s0Ms.hasOwn)((0, $SdEQh.toRaw)(setupState), key)) (0, $3dLyd.warn)(`Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`);
            return Reflect.get(target, key, receiver);
        }
    });
}
function $8fc928cd6c76f02e$var$callRender(render, instance, setupState) {
    return (0, $3dLyd.callWithErrorHandling)(render, instance, 1, [
        setupState,
        instance.props,
        instance.emit,
        instance.attrs,
        instance.slots
    ]);
}
/**
* dev only
* Runs devRender with everything it creates owned by a fresh per-render
* scope, so HMR rerender can tear down one generation by stopping the
* scope - including components nested inside elements, which the block
* graph cannot reach.
*/ function $8fc928cd6c76f02e$var$runDevRender(instance) {
    instance.accessedAttrs = instance.props === instance.attrs;
    (instance.renderScope = new (0, $SdEQh.EffectScope)()).run(()=>$8fc928cd6c76f02e$var$devRender(instance));
}
/**
* dev only
*/ function $8fc928cd6c76f02e$var$devRender(instance) {
    const prev = (0, $3dLyd.setCurrentRenderingInstance)(instance);
    try {
        instance.block = (instance.type.render ? $8fc928cd6c76f02e$var$callRender(instance.type.render, instance, instance.setupState) : (0, $3dLyd.callWithErrorHandling)((0, $7s0Ms.isFunction)(instance.type) ? instance.type : instance.type.setup, instance, 0, [
            instance.props,
            {
                slots: instance.slots,
                attrs: instance.attrs,
                emit: instance.emit,
                expose: instance.expose
            }
        ])) || [];
    } finally{
        (0, $3dLyd.setCurrentRenderingInstance)(prev);
    }
}
const $8fc928cd6c76f02e$var$emptyContext = {
    app: null,
    config: {},
    provides: /*@__PURE__*/ Object.create(null)
};
var $8fc928cd6c76f02e$var$VaporComponentInstance = class {
    constructor(comp, rawProps, rawSlots, appContext, once, ce){
        this.effectCount = 0;
        this.vapor = true;
        this.uid = (0, $3dLyd.nextUid)();
        this.type = comp;
        this.parent = (0, $3dLyd.currentInstance);
        if (0, $3dLyd.currentInstance) {
            this.root = (0, $3dLyd.currentInstance).root;
            this.appContext = (0, $3dLyd.currentInstance).appContext;
            this.provides = (0, $3dLyd.currentInstance).provides;
            this.ids = (0, $3dLyd.currentInstance).ids;
        } else {
            this.root = this;
            this.appContext = appContext || $8fc928cd6c76f02e$var$emptyContext;
            this.provides = Object.create(this.appContext.provides);
            this.ids = [
                "",
                0,
                0
            ];
        }
        this.block = null;
        this.scope = new (0, $SdEQh.EffectScope)(true);
        this.emit = $8fc928cd6c76f02e$var$emit.bind(null, this);
        this.expose = (0, $3dLyd.expose).bind(null, this);
        this.refs = (0, $7s0Ms.EMPTY_OBJ);
        this.emitted = this.exposed = this.exposeProxy = this.propsDefaults = null;
        this.suspense = null;
        this.suspenseId = 0;
        if ($8fc928cd6c76f02e$var$isSuspenseEnabled) {
            const suspense = this.suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense;
            this.suspenseId = suspense ? suspense.pendingId : 0;
        }
        this.asyncDep = null;
        this.asyncResolved = false;
        this.isMounted = this.isUnmounted = this.isUpdating = this.isDeactivated = false;
        this.rawProps = once && rawProps ? $8fc928cd6c76f02e$var$snapshotRawProps(rawProps) : rawProps || (0, $7s0Ms.EMPTY_OBJ);
        this.hasFallthrough = !!ce || $8fc928cd6c76f02e$var$hasFallthroughAttrs(comp, this.rawProps);
        if (rawProps || comp.props) {
            const [propsHandlers, attrsHandlers] = $8fc928cd6c76f02e$var$getPropsProxyHandlers(comp);
            this.attrs = new Proxy(this, attrsHandlers);
            this.props = comp.props ? new Proxy(this, propsHandlers) : (0, $7s0Ms.isFunction)(comp) ? this.attrs : (0, $7s0Ms.EMPTY_OBJ);
        } else this.props = this.attrs = (0, $7s0Ms.EMPTY_OBJ);
        let normalizedRawSlots = $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots);
        if (once && normalizedRawSlots) normalizedRawSlots = $8fc928cd6c76f02e$var$snapshotRawSlots(normalizedRawSlots);
        this.rawSlots = normalizedRawSlots || (0, $7s0Ms.EMPTY_OBJ);
        this.slots = normalizedRawSlots ? new Proxy(normalizedRawSlots, $8fc928cd6c76f02e$var$dynamicSlotsProxyHandlers) : (0, $7s0Ms.EMPTY_OBJ);
        this.scopeId = $8fc928cd6c76f02e$var$getCurrentScopeId();
        this.slotScopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
        if (ce) ce(this);
        var target, key, receiver;
    }
    /**
	* Expose `getKeysFromRawProps` on the instance so it can be used in code
	* paths where it's needed, e.g. `useModel`
	*/ rawKeys() {
        const vnode = $8fc928cd6c76f02e$var$isInteropEnabled && this.interopVNode;
        return vnode ? Object.keys(vnode.props || (0, $7s0Ms.EMPTY_OBJ)) : $8fc928cd6c76f02e$var$getKeysFromRawProps(this.rawProps);
    }
};
function $8fc928cd6c76f02e$export$f43892e053afd2a0(value) {
    return value instanceof $8fc928cd6c76f02e$var$VaporComponentInstance;
}
/**
* Resolve an asset component by name before passing it to the fallback helper;
* a string passed directly to `createComponentWithFallback` is plain element
* fallback, not a component name.
*/ function $8fc928cd6c76f02e$export$fd68e6e975efa84b(name, rawProps, rawSlots, isSingleRoot, once, maybeSelfReference, ns, appContext) {
    return $8fc928cd6c76f02e$export$8b456629be3b9f98((0, $3dLyd.resolveComponent)(name, maybeSelfReference), rawProps, rawSlots, isSingleRoot, once, ns, appContext);
}
/**
* Used when a component cannot be resolved at compile time
* and needs rely on runtime resolution - where it might fallback to a plain
* element if the resolution fails.
*/ function $8fc928cd6c76f02e$export$8b456629be3b9f98(comp, rawProps, rawSlots, isSingleRoot, once, ns, appContext) {
    if (comp === (0, $3dLyd.NULL_DYNAMIC_COMPONENT)) {
        if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$currentHydrationNode) {
            if ($8fc928cd6c76f02e$var$isReusableNullComponentAnchor($8fc928cd6c76f02e$var$currentHydrationNode)) {
                const node = $8fc928cd6c76f02e$var$currentHydrationNode;
                if ($8fc928cd6c76f02e$var$isComment(node, "")) $8fc928cd6c76f02e$var$advanceHydrationNode(node);
                return node;
            }
            const nextAnchor = $8fc928cd6c76f02e$var$nextLogicalSibling($8fc928cd6c76f02e$var$currentHydrationNode);
            if (nextAnchor && $8fc928cd6c76f02e$var$isReusableNullComponentAnchor(nextAnchor)) return nextAnchor;
        }
        return /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a("");
    }
    if (!(0, $7s0Ms.isString)(comp)) return $8fc928cd6c76f02e$export$60e54eaca7e7fb38(comp, rawProps, rawSlots, isSingleRoot, once, appContext);
    return $8fc928cd6c76f02e$export$1453c0694157b862(comp, rawProps, rawSlots, isSingleRoot, once, ns);
}
function $8fc928cd6c76f02e$var$isReusableNullComponentAnchor(node) {
    return $8fc928cd6c76f02e$var$isComment(node, "") || false;
}
function $8fc928cd6c76f02e$export$1453c0694157b862(comp, rawProps, rawSlots, isSingleRoot, once, ns) {
    rawSlots = $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots);
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    let hydrationCursor = null;
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        $8fc928cd6c76f02e$var$resolvePendingSlotContent();
        hydrationCursor = $8fc928cd6c76f02e$var$enterHydrationCursor();
    } else $8fc928cd6c76f02e$var$resetInsertionState();
    const defaultSlot = rawSlots && $8fc928cd6c76f02e$var$getSlot(rawSlots, "default");
    const hasDynamicSlots = !!rawSlots && !!rawSlots.$;
    const adoptHydrationChildren = !!defaultSlot;
    const hydrationTemplate = hasDynamicSlots && !defaultSlot ? `<${comp}><!></${comp}>` : `<${comp}/>`;
    const el = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$adoptTemplate($8fc928cd6c76f02e$var$currentHydrationNode, hydrationTemplate, adoptHydrationChildren, ns) : /* @__PURE__ */ $8fc928cd6c76f02e$var$createElement(comp, ns);
    el.$root = isSingleRoot;
    if (!$8fc928cd6c76f02e$var$isHydrating$1 || $8fc928cd6c76f02e$var$isRecreatedNode(el)) {
        const scopeId = $8fc928cd6c76f02e$var$getCurrentScopeId();
        if (scopeId) el.setAttribute(scopeId, "");
        const slotScopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
        if (slotScopeIds) $8fc928cd6c76f02e$var$setElementScopeIds(el, slotScopeIds);
    }
    if (rawProps) {
        const isSVG = ns === 1;
        const setFn = ()=>$8fc928cd6c76f02e$var$patchDynamicProps(el, $8fc928cd6c76f02e$var$resolveDynamicProps(rawProps), isSVG);
        if (once) setFn();
        else $8fc928cd6c76f02e$export$6c64e011838f4702(setFn);
    }
    if (rawSlots) {
        let nextNode = null;
        if ($8fc928cd6c76f02e$var$isHydrating$1) {
            nextNode = $8fc928cd6c76f02e$var$nextLogicalSibling(el);
            let child = el.firstChild;
            if (rawSlots.$ && !child) child = el.appendChild($8fc928cd6c76f02e$var$claimAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a()));
            $8fc928cd6c76f02e$var$setCurrentHydrationNode(child);
        }
        if (rawSlots.$) {
            const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(512, void 0);
            if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
            $8fc928cd6c76f02e$export$6c64e011838f4702(()=>frag.update($8fc928cd6c76f02e$var$getSlot(rawSlots, "default")));
            if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag, el);
            $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(frag);
        } else {
            const slot = $8fc928cd6c76f02e$var$getSlot(rawSlots, "default");
            if (slot) {
                const block = slot();
                if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block, el);
                $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(block);
            }
        }
        if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$setCurrentHydrationNode(nextNode);
    }
    $8fc928cd6c76f02e$var$finishBlockCreation(el, void 0, hydrationCursor, _insertionParent, _insertionAnchor);
    return el;
}
function $8fc928cd6c76f02e$var$mountComponent(instance, parent, anchor) {
    if ($8fc928cd6c76f02e$var$isSuspenseEnabled && instance.suspense && instance.asyncDep && !instance.asyncResolved) {
        if (instance.asyncDepRegistered) {
            if (instance.pendingBlock) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(instance.pendingBlock, parent, anchor);
            else if (instance.block) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(instance.block, parent, anchor);
            if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && instance.shapeFlag & 512) instance.isDeactivated = false;
            return;
        }
        const suspense = instance.suspense;
        const deferred = $8fc928cd6c76f02e$var$isKeepAliveEnabled && $8fc928cd6c76f02e$var$deferKeepAliveRenderEffects(instance);
        const hydrating = $8fc928cd6c76f02e$var$isHydrating$1;
        if (!hydrating) {
            instance.block = /* @__PURE__ */ $8fc928cd6c76f02e$var$createComment("");
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(instance.block, parent, anchor);
        }
        instance.asyncDepRegistered = true;
        const component = instance.type;
        let asyncSetupFinished = false;
        const finishAsyncSetup = (setupResult)=>{
            if (asyncSetupFinished) return;
            asyncSetupFinished = true;
            instance.asyncResolved = true;
            const handleResult = ()=>{
                const prevInstance = (0, $3dLyd.setCurrentInstance)(instance);
                const prevSub = (0, $SdEQh.setActiveSub)();
                try {
                    $8fc928cd6c76f02e$var$handleSetupResult(setupResult, component, instance);
                } finally{
                    (0, $SdEQh.setActiveSub)(prevSub);
                    (0, $3dLyd.restoreCurrentInstance)(prevInstance);
                }
            };
            try {
                const pendingBlock = hydrating ? instance.pendingBlock : instance.block;
                const { parentNode: parentNode, nextNode: nextNode } = $8fc928cd6c76f02e$var$findBlockBoundary(pendingBlock);
                const renderAndMount = ()=>{
                    handleResult();
                    $8fc928cd6c76f02e$var$mountComponent(instance, parentNode, nextNode);
                };
                if (hydrating) $8fc928cd6c76f02e$var$hydrateNode($8fc928cd6c76f02e$var$getBlockFirstNode(pendingBlock), ()=>{
                    const hydration = $8fc928cd6c76f02e$var$enterComponentHydration(component);
                    try {
                        $8fc928cd6c76f02e$var$withDeferredHydrationBoundary(renderAndMount);
                    } finally{
                        $8fc928cd6c76f02e$var$exitComponentHydration(hydration, true);
                    }
                });
                else {
                    renderAndMount();
                    $8fc928cd6c76f02e$export$cd7f480d6b8286c3(pendingBlock, parentNode);
                }
            } finally{
                if (hydrating) instance.pendingBlock = void 0;
            }
        };
        suspense.registerDep(instance, (setupResult)=>{
            if (deferred) {
                if (deferred.pendingRoot === instance) deferred.pendingRoot = void 0;
                if (!deferred.flushQueued) {
                    deferred.flushQueued = true;
                    (0, $3dLyd.queuePostRenderEffect)(deferred.flushJob, void 0, deferred.suspense);
                }
            }
            finishAsyncSetup(setupResult);
        });
        if (deferred) {
            const state = deferred;
            instance.asyncDep.catch((0, $7s0Ms.NOOP)).then((setupResult)=>{
                if (asyncSetupFinished) return;
                if (!instance.isUnmounted && !suspense.isUnmounted && !suspense.pendingBranch) finishAsyncSetup(setupResult);
                if (!state.flushQueued && state.pendingRoot === instance) $8fc928cd6c76f02e$var$settleDeferredKeepAliveUpdates(state);
            });
        }
        return;
    }
    if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && instance.shapeFlag & 512 && instance.isMounted) {
        instance.parent.ctx.activate(instance, parent, anchor);
        return;
    }
    const { root: root, type: type } = instance;
    if (root && root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
    if (instance.bm) (0, $7s0Ms.invokeArrayFns)(instance.bm);
    if (!$8fc928cd6c76f02e$var$isHydrating$1) {
        $8fc928cd6c76f02e$var$applyComponentScopeIds(instance);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(instance.block, parent, anchor, instance.suspense);
    } else $8fc928cd6c76f02e$var$hydrateComponentScopeIds(instance);
    if (instance.m) (0, $3dLyd.queuePostRenderEffect)(instance.m, void 0, instance.suspense);
    if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && instance.shapeFlag & 256 && instance.a) (0, $3dLyd.queuePostRenderEffect)(instance.a, void 0, instance.suspense);
    instance.isMounted = true;
}
function $8fc928cd6c76f02e$var$registerUnmount(instance) {
    const scope = instance.unmountScope;
    (0, $SdEQh.onScopeDispose)(()=>{
        if (scope && instance.unmountScope === scope) instance.unmountScope = void 0;
        $8fc928cd6c76f02e$var$unmountComponent(instance, void 0, $8fc928cd6c76f02e$var$isInteropEnabled ? $8fc928cd6c76f02e$var$resolveUnmountSuspense(instance.suspense) : instance.suspense);
    }, true);
}
function $8fc928cd6c76f02e$var$unmountComponent(instance, parentNode, parentSuspense = instance.suspense) {
    if ($8fc928cd6c76f02e$var$isSuspenseEnabled && $8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$currentUnmountSuspense !== parentSuspense) {
        $8fc928cd6c76f02e$var$runWithUnmountSuspense(parentSuspense, ()=>$8fc928cd6c76f02e$var$unmountComponent(instance, parentNode, parentSuspense));
        return;
    }
    if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && instance.shapeFlag & 256 && instance.parent && instance.parent.vapor && instance.parent.ctx) {
        if (parentNode) instance.parent.ctx.deactivate(instance, parentSuspense);
        return;
    }
    const pendingAsyncSetup = !!instance.asyncDep && !instance.asyncResolved;
    if (!instance.isUnmounted) {
        const hasLifecycle = instance.isMounted || pendingAsyncSetup;
        if (hasLifecycle) {
            (0, $3dLyd.invalidateMount)(instance.m);
            (0, $3dLyd.invalidateMount)(instance.a);
            if (instance.bum) (0, $7s0Ms.invokeArrayFns)(instance.bum);
        }
        if ($8fc928cd6c76f02e$var$isKeepAliveEnabled) {
            const inputScope = instance.inputScope;
            if (inputScope) inputScope.stop();
        }
        instance.scope.stop();
        if (hasLifecycle && instance.um) (0, $3dLyd.queuePostRenderEffect)(instance.um, void 0, parentSuspense);
        instance.isUnmounted = true;
    }
    if ($8fc928cd6c76f02e$var$isSuspenseEnabled && pendingAsyncSetup) {
        if (instance.pendingBlock) {
            if (parentNode) {
                const pendingBlock = instance.pendingBlock;
                const { parentNode: blockParent } = $8fc928cd6c76f02e$var$findBlockBoundary(pendingBlock);
                if (blockParent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(pendingBlock, blockParent);
                instance.pendingBlock = void 0;
            }
        } else if (instance.block instanceof Comment) {
            const blockParent = instance.block.parentNode;
            if (blockParent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(instance.block, blockParent);
        }
    } else if (parentNode) {
        if (instance.block) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(instance.block, parentNode);
    }
}
function $8fc928cd6c76f02e$var$getExposed(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $SdEQh.markRaw)(instance.exposed), {
        get: (target, key)=>(0, $SdEQh.unref)(target[key]),
        set: (target, key, value, receiver)=>{
            const oldValue = target[key];
            if ((0, $SdEQh.isRef)(oldValue) && !(0, $SdEQh.isRef)(value)) {
                oldValue.value = value;
                return true;
            }
            return Reflect.set(target, key, value, receiver);
        }
    }));
}
function $8fc928cd6c76f02e$var$getRootElement(block, visitor) {
    if (block instanceof Element) return block;
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        if (visitor) {
            if (visitor.onComponent && visitor.onComponent(block)) return;
            if (visitor.stopAtComponent) return;
        }
        return $8fc928cd6c76f02e$var$getRootElement(block.block, visitor);
    }
    if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(block))) {
        if (visitor) {
            if (visitor.excludeSlotOutlets && $8fc928cd6c76f02e$var$isSlotOutletFragment(block)) return;
            if ($8fc928cd6c76f02e$var$isDynamicFragment(block) && visitor.onDynamicFragment && visitor.onDynamicFragment(block)) return;
            if ($8fc928cd6c76f02e$var$isInteropEnabled && visitor.onInteropFragment && $8fc928cd6c76f02e$var$isInteropFragment(block) && visitor.onInteropFragment(block)) return;
        }
        return $8fc928cd6c76f02e$var$getRootElement(block.nodes, visitor);
    }
    if ((0, $7s0Ms.isArray)(block)) {
        const single = $8fc928cd6c76f02e$var$singleRootOf(block);
        return single === void 0 ? void 0 : $8fc928cd6c76f02e$var$getRootElement(single, visitor);
    }
}
function $8fc928cd6c76f02e$var$singleRootOf(nodes) {
    let single;
    let hasComment = false;
    for (const b of nodes){
        if (b instanceof Comment) {
            hasComment = true;
            continue;
        }
        if (single !== void 0) return;
        single = b;
    }
    return hasComment ? single : void 0;
}
/**
* Descends the same effective-root rules as getRootElement but stops at the
* first component instead of resolving an element. Used to verify `child`
* sits on `parent`'s root chain when the chain passes through fragments
* (where `parent.block === child` cannot see the link).
*/ function $8fc928cd6c76f02e$var$getRootChainComponent(block) {
    while(true){
        if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return block;
        if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(block))) {
            if ($8fc928cd6c76f02e$var$isSlotOutletFragment(block)) return;
            block = block.nodes;
            continue;
        }
        if ((0, $7s0Ms.isArray)(block)) {
            const single = $8fc928cd6c76f02e$var$singleRootOf(block);
            if (single === void 0) return;
            block = single;
            continue;
        }
        return;
    }
}
function $8fc928cd6c76f02e$var$handleSetupResult(setupResult, component, instance) {
    if ($8fc928cd6c76f02e$var$isBlock(setupResult)) instance.block = setupResult;
    else if ((0, $7s0Ms.isFunction)(setupResult) && instance.asyncDep) instance.block = (0, $3dLyd.callWithErrorHandling)(setupResult, instance, 1) || [];
    else if ((0, $7s0Ms.isFunction)(component)) instance.block = [];
    else if (!component.render) instance.block = [];
    else {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.block = $8fc928cd6c76f02e$var$callRender(component.render, instance, setupResult) || [];
    }
    $8fc928cd6c76f02e$var$applyComponentFallthrough(instance);
}
function $8fc928cd6c76f02e$var$applyComponentFallthrough(instance) {
    if (instance.hasFallthrough && instance.type.inheritAttrs !== false) $8fc928cd6c76f02e$var$applyFallthroughAttrs(instance.block, instance, void 0);
}
function $8fc928cd6c76f02e$var$applyFallthroughAttrs(block, instance, scope) {
    const state = new $8fc928cd6c76f02e$var$FallthroughResolveState(scope);
    const root = $8fc928cd6c76f02e$var$resolveFallthroughRoot(block, state);
    const { fragments: fragments, innermost: innermost, hasSlotOutlet: hasSlotOutlet } = state;
    if (fragments) for (const frag of fragments)$8fc928cd6c76f02e$var$registerDynamicFragmentFallthroughAttrs(frag, instance);
    if (root && !hasSlotOutlet) {
        let ownerScope = scope;
        if (innermost) ownerScope = innermost.scope || (innermost.scope = state.parentScope ? state.parentScope.run(()=>new (0, $SdEQh.EffectScope)()) : new (0, $SdEQh.EffectScope)());
        const applyEffect = ()=>$8fc928cd6c76f02e$export$6c64e011838f4702(()=>$8fc928cd6c76f02e$var$applyFallthroughProps(root, $8fc928cd6c76f02e$var$resolveFallthroughAttrs(instance)));
        ownerScope ? ownerScope.run(applyEffect) : applyEffect();
    }
}
var $8fc928cd6c76f02e$var$FallthroughResolveState = class {
    constructor(parentScope){
        this.stopAtComponent = true;
        this.parentScope = parentScope;
    }
    onDynamicFragment(frag) {
        if (frag.__vf & 4) {
            this.hasSlotOutlet = true;
            return true;
        }
        (this.fragments || (this.fragments = [])).push(frag);
        if (this.innermost && this.innermost.scope) this.parentScope = this.innermost.scope;
        this.innermost = frag;
    }
};
function $8fc928cd6c76f02e$var$resolveFallthroughRoot(block, state) {
    const root = $8fc928cd6c76f02e$var$getRootElement(block, state);
    const { innermost: innermost } = state;
    var child;
    return root;
}
function $8fc928cd6c76f02e$var$containsTeleportFragment(block) {
    if ($8fc928cd6c76f02e$var$isTeleportFragment(block)) return true;
    if ((0, $7s0Ms.isArray)(block)) return block.some((child)=>!(child instanceof Comment) && $8fc928cd6c76f02e$var$containsTeleportFragment(child));
    return $8fc928cd6c76f02e$export$9522e17588c12572(block) && $8fc928cd6c76f02e$var$containsTeleportFragment(block.nodes);
}
function $8fc928cd6c76f02e$var$registerDynamicFragmentFallthroughAttrs(frag, instance) {
    if (frag.fallthrough) return;
    frag.fallthrough = (nodes)=>$8fc928cd6c76f02e$var$applyFallthroughAttrs(nodes, instance, frag.scope);
}
/**
* A deferred state stays live while its async root is pending or its flush is
* queued for the same Suspense generation. The flush is requeued if that
* generation is discarded, so `flushQueued` cannot strand buffered updates.
*/ function $8fc928cd6c76f02e$var$isDeferredKeepAliveStateLive(state) {
    const suspense = state.suspense;
    if (suspense.isUnmounted || state.pendingId !== suspense.pendingId) return false;
    if (state.flushQueued) return true;
    const root = state.pendingRoot;
    return !!root && !root.isUnmounted;
}
function $8fc928cd6c76f02e$var$settleDeferredKeepAliveUpdates(state, currentJob) {
    const { effects: effects, owners: owners } = state;
    state.effects = [];
    state.owners = [];
    state.pendingRoot = void 0;
    for(let i = 0; i < owners.length; i++)if (owners[i].deferredKeepAliveUpdates === state) owners[i].deferredKeepAliveUpdates = void 0;
    if (currentJob && !effects.includes(currentJob)) effects.push(currentJob);
    if (effects.length > 1) effects.sort((a, b)=>a.order - b.order);
    for(let i = 0; i < effects.length; i++){
        const job = effects[i];
        (0, $3dLyd.callWithErrorHandling)(job, job.i, job.i ? 15 : 14);
    }
}
function $8fc928cd6c76f02e$var$deferKeepAliveRenderEffects(instance) {
    const suspense = instance.suspense;
    const owners = [];
    let keepAlive;
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        const owner = instance.parent;
        if (owner && owner.vapor && (0, $3dLyd.isKeepAlive)(owner) && owner.suspense === suspense) {
            keepAlive = owner;
            owners.push(keepAlive);
        }
    } else {
        let child = instance;
        let owner = instance.parent;
        while(owner && owner.vapor && owner.suspense === suspense){
            const vaporOwner = owner;
            let root = vaporOwner.block;
            while($8fc928cd6c76f02e$var$isDynamicFragment(root) && !(root.__vf & 4))root = root.nodes;
            if (root !== child) return;
            owners.push(vaporOwner);
            if ((0, $3dLyd.isKeepAlive)(owner)) keepAlive = vaporOwner;
            child = vaporOwner;
            owner = vaporOwner.parent;
        }
    }
    if (!keepAlive) return;
    let deferred = keepAlive.deferredKeepAliveUpdates;
    if (!deferred || deferred.suspense !== suspense || deferred.pendingId !== instance.suspenseId) {
        const flushJob = ()=>{
            state.flushQueued = false;
            if (keepAlive.deferredKeepAliveUpdates !== state || state.pendingRoot) return;
            $8fc928cd6c76f02e$var$settleDeferredKeepAliveUpdates(state);
        };
        flushJob.flags = 8;
        const state = {
            effects: [],
            owners: [],
            suspense: suspense,
            pendingId: instance.suspenseId,
            pendingRoot: instance,
            flushQueued: false,
            flushJob: flushJob
        };
        deferred = state;
    } else deferred.pendingRoot = instance;
    for(let i = 0; i < owners.length; i++){
        const owner = owners[i];
        if (owner.deferredKeepAliveUpdates !== deferred) {
            owner.deferredKeepAliveUpdates = deferred;
            deferred.owners.push(owner);
        }
    }
    return deferred;
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateApp.ts
let $8fc928cd6c76f02e$var$_createApp;
const $8fc928cd6c76f02e$var$rootInstances = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$mountApp = (app, container)=>{
    $8fc928cd6c76f02e$var$optimizePropertyLookup();
    if (container.nodeType === 1) container.textContent = "";
    const instance = app._ceComponent || $8fc928cd6c76f02e$export$60e54eaca7e7fb38(app._component, app._props, null, false, false, app._context);
    $8fc928cd6c76f02e$var$mountComponent(instance, container);
    (0, $3dLyd.flushOnAppMount)();
    $8fc928cd6c76f02e$var$rootInstances.set(app, instance);
    return instance;
};
let $8fc928cd6c76f02e$var$_hydrateApp;
const $8fc928cd6c76f02e$var$hydrateApp = (app, container)=>{
    if (!container.hasChildNodes()) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $3dLyd.warn)("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
        return $8fc928cd6c76f02e$var$mountApp(app, container);
    }
    $8fc928cd6c76f02e$var$optimizePropertyLookup();
    let instance;
    $8fc928cd6c76f02e$var$withHydration(container, ()=>{
        instance = app._ceComponent || $8fc928cd6c76f02e$export$60e54eaca7e7fb38(app._component, app._props, null, false, false, app._context, true);
        $8fc928cd6c76f02e$var$mountComponent(instance, container);
        (0, $3dLyd.flushOnAppMount)();
    });
    $8fc928cd6c76f02e$var$rootInstances.set(app, instance);
    return instance;
};
const $8fc928cd6c76f02e$var$unmountApp = (app)=>{
    const instance = $8fc928cd6c76f02e$var$rootInstances.get(app);
    $8fc928cd6c76f02e$var$unmountComponent(instance, app._container);
    (0, $3dLyd.flushOnAppMount)(instance);
    $8fc928cd6c76f02e$var$rootInstances.delete(app);
};
function $8fc928cd6c76f02e$var$prepareApp() {
    (0, $3dLyd.initFeatureFlags)();
    const target = (0, $7s0Ms.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) (0, $3dLyd.setDevtoolsHook)(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
}
function $8fc928cd6c76f02e$var$postPrepareApp(app) {
    app.vapor = true;
    const mount = app.mount;
    app.mount = (container, ...args)=>{
        container = (0, $bmuEm.normalizeContainer)(container);
        if (!container) return;
        const proxy = mount(container, ...args);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
}
const $8fc928cd6c76f02e$export$ab21481d5d94015c = (comp, props)=>{
    $8fc928cd6c76f02e$var$prepareApp();
    if (!$8fc928cd6c76f02e$var$_createApp) $8fc928cd6c76f02e$var$_createApp = (0, $3dLyd.createAppAPI)($8fc928cd6c76f02e$var$mountApp, $8fc928cd6c76f02e$var$unmountApp, $8fc928cd6c76f02e$var$getExposed);
    const app = $8fc928cd6c76f02e$var$_createApp(comp, props);
    $8fc928cd6c76f02e$var$postPrepareApp(app);
    return app;
};
const $8fc928cd6c76f02e$export$291d13b1df8f2f86 = (comp, props)=>{
    $8fc928cd6c76f02e$var$setIsHydratingEnabled(true);
    $8fc928cd6c76f02e$var$prepareApp();
    if (!$8fc928cd6c76f02e$var$_hydrateApp) $8fc928cd6c76f02e$var$_hydrateApp = (0, $3dLyd.createAppAPI)($8fc928cd6c76f02e$var$hydrateApp, $8fc928cd6c76f02e$var$unmountApp, $8fc928cd6c76f02e$var$getExposed);
    const app = $8fc928cd6c76f02e$var$_hydrateApp(comp, props);
    $8fc928cd6c76f02e$var$postPrepareApp(app);
    return app;
};
//#endregion
//#region packages/runtime-vapor/src/apiDefineComponent.ts
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$bcd4d980d2d74077(comp, extraOptions) {
    if ((0, $7s0Ms.isFunction)(comp)) return /*@__PURE__*/ (()=>(0, $7s0Ms.extend)({
            name: comp.name
        }, extraOptions, {
            setup: comp,
            __vapor: true
        }))();
    comp.__vapor = true;
    return comp;
}
//#endregion
//#region packages/runtime-vapor/src/apiDefineAsyncComponent.ts
function $8fc928cd6c76f02e$export$638df296a30bd467(source) {
    $8fc928cd6c76f02e$var$enableAsyncComponent();
    const { load: load, getResolvedComp: getResolvedComp, setPendingRequest: setPendingRequest, source: { loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay, hydrate: hydrateStrategy, timeout: timeout, suspensible: suspensible = true } } = (0, $3dLyd.createAsyncComponentContext)(source);
    return /* @__PURE__ */ $8fc928cd6c76f02e$export$bcd4d980d2d74077({
        name: "VaporAsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
            const endAnchor = $8fc928cd6c76f02e$var$isComment(el, "[") ? $8fc928cd6c76f02e$var$locateEndAnchor(el) : null;
            let nodes;
            if (endAnchor) {
                const end = /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(endAnchor);
                const range = nodes = [
                    el
                ];
                let cur = el;
                while(true){
                    let n = /* @__PURE__ */ $8fc928cd6c76f02e$var$_next(cur);
                    if (n && n !== end) range.push(cur = n);
                    else break;
                }
            } else nodes = el;
            const prev = (0, $3dLyd.setCurrentInstance)(instance);
            try {
                const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0);
                frag.nodes = nodes;
                instance.block = frag;
            } finally{
                (0, $3dLyd.restoreCurrentInstance)(prev);
            }
            instance.isMounted = true;
            $8fc928cd6c76f02e$var$setCurrentHydrationNode($8fc928cd6c76f02e$var$nextLogicalSibling(el));
            (0, $3dLyd.performAsyncHydrate)(el, instance, ()=>$8fc928cd6c76f02e$var$hydrateNode(el, ()=>$8fc928cd6c76f02e$var$withDeferredHydrationBoundary(hydrate)), getResolvedComp, load, hydrateStrategy, false);
        },
        get __asyncResolved () {
            return getResolvedComp();
        },
        setup () {
            const instance = (0, $3dLyd.currentInstance);
            (0, $3dLyd.markAsyncBoundary)(instance);
            const placeholder = instance.block;
            let frag;
            if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$isDynamicFragment(placeholder)) {
                frag = placeholder;
                frag.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                $8fc928cd6c76f02e$var$locateHydrationNode();
            } else {
                frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0);
                if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
            }
            let resolvedComp = getResolvedComp();
            if (resolvedComp) {
                frag.update(()=>$8fc928cd6c76f02e$var$createInnerComp(resolvedComp, instance));
                if (frag === placeholder) {
                    const u = frag.u;
                    if (u) u.forEach((hook)=>hook(frag.nodes));
                }
                return frag;
            }
            const onError = (err)=>{
                setPendingRequest(null);
                (0, $3dLyd.handleError)(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense) {
                const renderBranch = (render)=>{
                    if (!instance.isUnmounted) instance.scope.run(()=>frag.update(render));
                };
                return load().then(()=>{
                    resolvedComp = getResolvedComp();
                    if (resolvedComp) renderBranch(()=>$8fc928cd6c76f02e$var$createInnerComp(resolvedComp, instance));
                    return frag;
                }).catch((err)=>{
                    onError(err);
                    if (errorComponent) renderBranch(()=>$8fc928cd6c76f02e$var$createErrorComp(errorComponent, instance, ()=>err));
                    return frag;
                });
            }
            const { loaded: loaded, error: error, delayed: delayed } = (0, $3dLyd.useAsyncComponentState)(delay, timeout, onError, instance);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    setPendingRequest(null);
                    return;
                }
                onError(err);
                error.value = err;
            });
            $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
                resolvedComp = getResolvedComp();
                let render;
                let key;
                if (loaded.value && resolvedComp) {
                    render = ()=>$8fc928cd6c76f02e$var$createInnerComp(resolvedComp, instance);
                    key = 1;
                } else if (error.value && errorComponent) {
                    render = ()=>$8fc928cd6c76f02e$var$createErrorComp(errorComponent, instance, ()=>error.value);
                    key = 2;
                } else if (loadingComponent && !delayed.value) {
                    render = ()=>$8fc928cd6c76f02e$var$createInnerComp(loadingComponent, instance);
                    key = 3;
                }
                frag.update(render, key);
                if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && frag.keepAliveCtx) frag.keepAliveCtx.cacheBlock();
            });
            return frag;
        }
    });
}
/**
* The block an async wrapper has settled on, or undefined while it is
* unresolved or (under deferred hydration) resolved but not set up yet.
* Consumers reading through the wrapper treat undefined as unresolved.
*/ function $8fc928cd6c76f02e$var$getAsyncWrapperInner(instance) {
    const frag = instance.block;
    if ($8fc928cd6c76f02e$var$isDynamicFragment(frag) && frag.current !== void 0 && instance.type.__asyncResolved) return frag.nodes;
}
function $8fc928cd6c76f02e$var$createErrorComp(comp, parent, getError) {
    return $8fc928cd6c76f02e$var$createInnerComp(comp, parent, {
        error: getError
    }, {});
}
function $8fc928cd6c76f02e$var$createInnerComp(comp, parent, rawProps = parent.rawProps, rawSlots = parent.rawSlots) {
    const prevInstance = (0, $3dLyd.setCurrentInstance)(parent);
    try {
        return $8fc928cd6c76f02e$export$60e54eaca7e7fb38(comp, rawProps, rawSlots, void 0, void 0, parent.appContext);
    } finally{
        (0, $3dLyd.restoreCurrentInstance)(prevInstance);
    }
}
//#endregion
//#region packages/runtime-vapor/src/components/Transition.ts
let $8fc928cd6c76f02e$var$registered = false;
const $8fc928cd6c76f02e$var$ensureTransitionHooksRegistered = ()=>{
    if (!$8fc928cd6c76f02e$var$registered) {
        $8fc928cd6c76f02e$var$registered = true;
        $8fc928cd6c76f02e$var$registerTransitionHooks($8fc928cd6c76f02e$var$applyTransitionHooksImpl, $8fc928cd6c76f02e$var$applyTransitionLeaveHooksImpl, $8fc928cd6c76f02e$var$deferBranchUpdateDuringLeaveImpl, $8fc928cd6c76f02e$var$removeBranchWithLeaveImpl);
    }
};
const $8fc928cd6c76f02e$var$hydrateTransitionImpl = (suspense)=>{
    if (!$8fc928cd6c76f02e$var$currentHydrationNode || !(0, $3dLyd.isTemplateNode)($8fc928cd6c76f02e$var$currentHydrationNode)) return;
    const templateNode = $8fc928cd6c76f02e$var$currentHydrationNode;
    const { content: content, parentNode: parentNode } = templateNode;
    const { firstChild: firstChild } = content;
    if (firstChild) {
        let transitionEl;
        for(let node = firstChild; node; node = node.nextSibling)if (node instanceof Element) {
            transitionEl = node;
            break;
        }
        parentNode.insertBefore(content, templateNode);
        parentNode.removeChild(templateNode);
        $8fc928cd6c76f02e$var$updateLastLocatedLogicalChild(parentNode, templateNode, firstChild);
        $8fc928cd6c76f02e$var$setCurrentHydrationNode(firstChild);
        if (transitionEl instanceof HTMLElement || transitionEl instanceof SVGElement) {
            const originalDisplay = transitionEl.style.display;
            transitionEl.style.display = "none";
            return (hooks)=>{
                hooks.beforeEnter(transitionEl);
                transitionEl.style.display = originalDisplay;
                (0, $3dLyd.queuePostRenderEffect)(()=>hooks.enter(transitionEl), void 0, suspense);
            };
        }
    }
};
const $8fc928cd6c76f02e$var$decorate$1 = (t)=>{
    t.displayName = $8fc928cd6c76f02e$var$displayName;
    t.props = (0, $bmuEm.TransitionPropsValidators);
    t.__vapor = true;
    return t;
};
const $8fc928cd6c76f02e$export$a9727d0b86227c77 = /*@__PURE__*/ $8fc928cd6c76f02e$var$decorate$1((props, { slots: slots, expose: expose })=>{
    expose();
    $8fc928cd6c76f02e$var$ensureTransitionHooksRegistered();
    const instance = (0, $3dLyd.currentInstance);
    const performAppear = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$hydrateTransitionImpl(instance.suspense) : void 0;
    const state = (0, $3dLyd.useTransitionState)();
    const { mode: mode } = props;
    const resolvedProps = (0, $SdEQh.computed)(()=>(0, $bmuEm.resolveTransitionProps)(props));
    const propsProxy = new Proxy({}, {
        get (_, key) {
            return resolvedProps.value[key];
        }
    });
    const shouldPerformAppear = !!props.appear && !!performAppear;
    if (instance.rawSlots.$) {
        const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0);
        if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
        state.root = frag;
        let isMounted = false;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            if (!frag.$transition) frag.$transition = $8fc928cd6c76f02e$var$resolveTransitionHooks(frag, propsProxy, state, instance);
            else frag.$transition.mode = resolvedProps.value.mode;
            const prevNodes = frag.nodes;
            frag.update(slots.default);
            if (isMounted && frag.nodes === prevNodes && !state.isLeaving) frag.$transition = $8fc928cd6c76f02e$var$applyTransitionHooksImpl(frag.nodes, frag.$transition);
            if (!isMounted && shouldPerformAppear) performAppear(frag.$transition);
            isMounted = true;
        });
        return frag;
    }
    const children = slots.default && slots.default() || [];
    state.root = children;
    let appliedHooks = {
        __vapor: true,
        state: state,
        props: propsProxy,
        instance: instance
    };
    let isMounted = false;
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        appliedHooks = $8fc928cd6c76f02e$var$applyTransitionHooksImpl(children, appliedHooks);
        if (!isMounted) {
            isMounted = true;
            if (shouldPerformAppear) performAppear(appliedHooks);
        }
    });
    return children;
});
const $8fc928cd6c76f02e$var$transitionTypeMap = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$getTransitionType(block) {
    const type = $8fc928cd6c76f02e$var$transitionTypeMap.get(block);
    if (type !== void 0) return type;
    if (block instanceof Element) return block.localName;
    if ($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$export$9522e17588c12572(block) && block.getTransitionType) {
        const type = block.getTransitionType();
        if (type !== void 0) return type;
    }
    return block;
}
function $8fc928cd6c76f02e$var$setTransitionType(block, type) {
    $8fc928cd6c76f02e$var$transitionTypeMap.set(block, type);
}
function $8fc928cd6c76f02e$var$getLeavingNodesForType(state, block) {
    const { leavingNodes: leavingNodes } = state;
    const type = $8fc928cd6c76f02e$var$getTransitionType(block);
    let nodes = leavingNodes.get(type);
    if (!nodes) {
        nodes = Object.create(null);
        leavingNodes.set(type, nodes);
    }
    return nodes;
}
function $8fc928cd6c76f02e$var$getLeaveElement(block) {
    const el = $8fc928cd6c76f02e$var$getTransitionElement(block);
    if (el) return el;
    if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && !(0, $7s0Ms.isArray)(block.nodes) && (block.nodes instanceof Element || $8fc928cd6c76f02e$export$9522e17588c12572(block.nodes))) return $8fc928cd6c76f02e$var$getLeaveElement(block.nodes);
}
const $8fc928cd6c76f02e$var$transitionKeys = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$getTransitionKey(block) {
    return $8fc928cd6c76f02e$var$transitionKeys.get(block);
}
function $8fc928cd6c76f02e$var$setTransitionKey(block, key) {
    $8fc928cd6c76f02e$var$transitionKeys.set(block, key);
}
const $8fc928cd6c76f02e$var$getTransitionHooksContext = (block, state)=>{
    const key = String($8fc928cd6c76f02e$var$getTransitionKey(block));
    const leavingNodes = $8fc928cd6c76f02e$var$getLeavingNodesForType(state, block);
    return {
        isLeaving: ()=>leavingNodes[key] === block,
        setLeavingNodeCache: ()=>{
            leavingNodes[key] = block;
        },
        unsetLeavingNodeCache: ()=>{
            if (leavingNodes[key] === block) delete leavingNodes[key];
        },
        earlyRemove: ()=>{
            const leavingNode = leavingNodes[key];
            if (leavingNode && $8fc928cd6c76f02e$var$getTransitionKey(leavingNode) === $8fc928cd6c76f02e$var$getTransitionKey(block)) {
                const el = $8fc928cd6c76f02e$var$getLeaveElement(leavingNode);
                if (el && el[0, $3dLyd.leaveCbKey]) el[0, $3dLyd.leaveCbKey]();
            }
        }
    };
};
function $8fc928cd6c76f02e$var$resolveTransitionHooks(block, props, state, instance) {
    const context = $8fc928cd6c76f02e$var$getTransitionHooksContext(block, state);
    const hooks = (0, $3dLyd.baseResolveTransitionHooks)(context, props, state, instance);
    hooks.__vapor = true;
    hooks.persisted = hooks.persisted || !!state.persisted;
    hooks.state = state;
    hooks.props = props;
    hooks.instance = instance;
    return hooks;
}
function $8fc928cd6c76f02e$var$applyTransitionHooksImpl(block, hooks, owner) {
    if ((0, $7s0Ms.isArray)(block)) {
        block = block.filter((b)=>!(b instanceof Comment));
        if (block.length === 1) block = block[0];
        else if (block.length === 0) return hooks;
    }
    if (hooks.applyGroup && ($8fc928cd6c76f02e$var$isForFragment(block) || $8fc928cd6c76f02e$var$isVaporSlotOutlet(block) || $8fc928cd6c76f02e$export$f43892e053afd2a0(block) && $8fc928cd6c76f02e$var$isVaporSlotOutlet(block.block))) {
        hooks.applyGroup(block, hooks.props, hooks.state, hooks.instance);
        return hooks;
    }
    const fragments = [];
    const child = $8fc928cd6c76f02e$var$resolveTransitionBlock(block, (fragment)=>fragments.push(fragment), owner);
    if (!child) {
        fragments.forEach((f)=>f.$transition = hooks);
        return hooks;
    }
    const { props: props, instance: instance, state: state, delayedLeave: delayedLeave } = hooks;
    state.persisted = $8fc928cd6c76f02e$var$isPersistedRoot(state.root);
    const resolvedHooks = $8fc928cd6c76f02e$var$resolveTransitionHooks(child, props, state, instance);
    resolvedHooks.delayedLeave = delayedLeave;
    child.$transition = resolvedHooks;
    fragments.forEach((f)=>f.$transition = resolvedHooks);
    return resolvedHooks;
}
function $8fc928cd6c76f02e$var$isPersistedRoot(block) {
    while(block){
        if (block.$vshow) return true;
        if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
            if ($8fc928cd6c76f02e$var$isVaporTransition(block.type)) return false;
            block = $8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(block) ? $8fc928cd6c76f02e$var$getAsyncWrapperInner(block) : block.block;
        } else if ((0, $7s0Ms.isArray)(block)) block = block.find((b)=>!(b instanceof Comment));
        else if ($8fc928cd6c76f02e$export$9522e17588c12572(block) && ($8fc928cd6c76f02e$var$isVaporSlotOutlet(block) || !($8fc928cd6c76f02e$var$isDynamicFragment(block) || $8fc928cd6c76f02e$var$isForFragment(block)))) block = block.nodes;
        else return false;
    }
    return false;
}
function $8fc928cd6c76f02e$var$applyTransitionLeaveHooksImpl(block, enterHooks, afterLeaveCb) {
    const leavingBlock = $8fc928cd6c76f02e$var$findTransitionBlock(block);
    if (!leavingBlock) return false;
    const { props: props, state: state, instance: instance } = enterHooks;
    const leavingHooks = $8fc928cd6c76f02e$var$resolveTransitionHooks(leavingBlock, props, state, instance);
    leavingBlock.$transition = leavingHooks;
    const { mode: mode } = props;
    if (mode === "out-in") {
        state.isLeaving = true;
        leavingHooks.afterLeave = ()=>{
            state.isLeaving = false;
            afterLeaveCb();
            leavingBlock.$transition = void 0;
            delete leavingHooks.afterLeave;
        };
    } else if (mode === "in-out") leavingHooks.delayLeave = (block, earlyRemove, delayedLeave)=>{
        const leavingNodes = $8fc928cd6c76f02e$var$getLeavingNodesForType(state, leavingBlock);
        const leavingKey = String($8fc928cd6c76f02e$var$getTransitionKey(leavingBlock));
        leavingNodes[leavingKey] = leavingBlock;
        const delayedLeaveCb = ()=>{
            delayedLeave();
            leavingBlock.$transition = void 0;
            if (enterHooks.delayedLeave === delayedLeaveCb) delete enterHooks.delayedLeave;
        };
        block[0, $3dLyd.leaveCbKey] = ()=>{
            earlyRemove();
            block[0, $3dLyd.leaveCbKey] = void 0;
            leavingBlock.$transition = void 0;
            if (leavingNodes[leavingKey] === leavingBlock) delete leavingNodes[leavingKey];
            if (enterHooks.delayedLeave === delayedLeaveCb) delete enterHooks.delayedLeave;
        };
        enterHooks.delayedLeave = delayedLeaveCb;
    };
    return true;
}
function $8fc928cd6c76f02e$var$deferBranchUpdateDuringLeaveImpl(frag, render, key, noScope, branchKey) {
    if (!frag.$transition.state.isLeaving) return false;
    const pending = frag.pending;
    if (pending) {
        pending.render = render;
        pending.key = key;
        pending.noScope = noScope;
        pending.branchKey = branchKey;
    } else frag.pending = {
        render: render,
        key: key,
        noScope: noScope,
        branchKey: branchKey
    };
    return true;
}
function $8fc928cd6c76f02e$var$removeBranchWithLeaveImpl(frag, transition, parent, render, key, noScope, branchKey) {
    const mode = transition.mode;
    if (mode && !transition.persisted && (mode !== "in-out" || render) && (mode !== "out-in" || $8fc928cd6c76f02e$var$isValidBlock(frag.nodes))) {
        const instance = (0, $3dLyd.currentInstance);
        $8fc928cd6c76f02e$var$applyTransitionLeaveHooksImpl(frag.nodes, transition, ()=>{
            if (transition.state.isUnmounting) return;
            const prevInstance = (0, $3dLyd.setCurrentInstance)(instance);
            try {
                const pending = frag.pending;
                if (pending) {
                    frag.pending = void 0;
                    frag.renderBranch(pending.render, transition, parent, pending.key, pending.noScope, true, void 0, pending.branchKey);
                } else frag.renderBranch(render, transition, parent, key, noScope, true, void 0, branchKey);
            } finally{
                (0, $3dLyd.restoreCurrentInstance)(prevInstance);
            }
        });
        if (mode === "out-in") {
            parent && $8fc928cd6c76f02e$export$cd7f480d6b8286c3(frag.nodes, parent);
            return true;
        }
    }
    return false;
}
const $8fc928cd6c76f02e$var$ROOT_KEY_CONTEXT = {
    key: void 0
};
const $8fc928cd6c76f02e$var$keyContexts = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$KEY_CONTEXT_OWNER = 34;
function $8fc928cd6c76f02e$var$transitionTypeOf(block) {
    return $8fc928cd6c76f02e$var$isAsyncComponentEnabled && block.type.__asyncResolved || block.type;
}
function $8fc928cd6c76f02e$var$withDefaultKey(ctx, key) {
    return ctx.type || key == null ? ctx : {
        key: key
    };
}
function $8fc928cd6c76f02e$var$isUnresolvedAsyncWrapper(block) {
    return $8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(block) && $8fc928cd6c76f02e$var$getAsyncWrapperInner(block) === void 0;
}
function $8fc928cd6c76f02e$var$enterComponentKeyContext(ctx, block, unresolved = $8fc928cd6c76f02e$var$isUnresolvedAsyncWrapper(block)) {
    var _block$$key;
    if (ctx.type) return ctx;
    return unresolved ? $8fc928cd6c76f02e$var$withDefaultKey(ctx, block.$key) : {
        key: (_block$$key = block.$key) !== null && _block$$key !== void 0 ? _block$$key : ctx.key,
        type: $8fc928cd6c76f02e$var$transitionTypeOf(block)
    };
}
function $8fc928cd6c76f02e$var$enterFragmentKeyContext(frag, ctx, key = $8fc928cd6c76f02e$var$getFragmentKey(frag)) {
    if (frag.__vf & $8fc928cd6c76f02e$var$KEY_CONTEXT_OWNER) $8fc928cd6c76f02e$var$keyContexts.set(frag, ctx);
    return $8fc928cd6c76f02e$var$withDefaultKey(ctx, key);
}
function $8fc928cd6c76f02e$var$resolveChildIdentity(child, ctx) {
    var _child$$key;
    $8fc928cd6c76f02e$var$transitionKeys.set(child, ctx.type ? ctx.key : (_child$$key = child.$key) !== null && _child$$key !== void 0 ? _child$$key : ctx.key);
    if (ctx.type) $8fc928cd6c76f02e$var$setTransitionType(child, ctx.type);
}
/**
* Resolve the transition child of `block` together with its identity.
* `owner` is the fragment whose content `block` is.
*/ function $8fc928cd6c76f02e$var$resolveTransitionBlock(block, onFragment, owner) {
    const ctx = owner ? $8fc928cd6c76f02e$var$withDefaultKey($8fc928cd6c76f02e$var$keyContexts.get(owner) || $8fc928cd6c76f02e$var$ROOT_KEY_CONTEXT, $8fc928cd6c76f02e$var$getFragmentKey(owner)) : $8fc928cd6c76f02e$var$ROOT_KEY_CONTEXT;
    const children = [];
    $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block, onFragment, children, ctx);
    return children[0];
}
/** Locate the transition child of `block` without touching its identity. */ function $8fc928cd6c76f02e$var$findTransitionBlock(block) {
    const children = [];
    $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block, void 0, children, void 0);
    return children[0];
}
function $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block, onFragment, children, ctx) {
    if (block instanceof Node) {
        if (block instanceof Element) {
            children.push(block);
            if (ctx) $8fc928cd6c76f02e$var$resolveChildIdentity(block, ctx);
        }
    } else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) $8fc928cd6c76f02e$var$collectComponentTransitionBlocks(block, onFragment, children, ctx);
    else if ((0, $7s0Ms.isArray)(block)) $8fc928cd6c76f02e$var$collectArrayTransitionBlocks(block, onFragment, children, ctx);
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block)) $8fc928cd6c76f02e$var$collectFragmentTransitionBlocks(block, onFragment, children, ctx);
}
function $8fc928cd6c76f02e$var$collectComponentTransitionBlocks(block, onFragment, children, ctx) {
    if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && (0, $3dLyd.isKeepAlive)(block)) {
        $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block.block, onFragment, children, ctx);
        return;
    }
    const async = $8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(block);
    const inner = async ? $8fc928cd6c76f02e$var$getAsyncWrapperInner(block) : void 0;
    if (ctx) ctx = $8fc928cd6c76f02e$var$enterComponentKeyContext(ctx, block, async && inner === void 0);
    if (async) {
        if (inner === void 0) {
            if ($8fc928cd6c76f02e$export$9522e17588c12572(block.block)) {
                if (onFragment) onFragment(block.block);
                if (ctx) $8fc928cd6c76f02e$var$keyContexts.set(block.block, ctx);
            }
            return;
        }
        $8fc928cd6c76f02e$var$collectTransitionBlocks$1(inner, onFragment, children, ctx);
        return;
    }
    if ($8fc928cd6c76f02e$var$isVaporTransition(block.type)) return;
    $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block.block, onFragment, children, ctx);
}
function $8fc928cd6c76f02e$var$collectArrayTransitionBlocks(block, onFragment, children, ctx) {
    let hasFound = false;
    for (const c of block){
        if (c instanceof Comment) continue;
        const nested = [];
        $8fc928cd6c76f02e$var$collectTransitionBlocks$1(c, onFragment, nested, ctx);
        if (nested.length) children.push(nested[0]);
        hasFound = true;
        break;
    }
}
function $8fc928cd6c76f02e$var$collectFragmentTransitionBlocks(block, onFragment, children, ctx) {
    if ($8fc928cd6c76f02e$var$isInteropEnabled && block.hasVDOMContent && block.hasVDOMContent()) {
        children.push(block);
        if (ctx) {
            $8fc928cd6c76f02e$var$resolveChildIdentity(block, ctx);
            if (!ctx.type) {
                const type = block.getTransitionType();
                if (type !== void 0) $8fc928cd6c76f02e$var$setTransitionType(block, type);
            }
        }
        return;
    }
    if (onFragment) onFragment(block);
    $8fc928cd6c76f02e$var$collectTransitionBlocks$1(block.nodes, onFragment, children, ctx && $8fc928cd6c76f02e$var$enterFragmentKeyContext(block, ctx));
}
function $8fc928cd6c76f02e$var$setTransitionHooks$1(block, hooks) {
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        block = $8fc928cd6c76f02e$var$findTransitionBlock(block.block);
        if (!block) return;
    }
    block.$transition = hooks;
}
function $8fc928cd6c76f02e$var$isValidTransitionBlock(block) {
    return block instanceof Element || !!($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$export$9522e17588c12572(block) && block.hasVDOMContent && block.hasVDOMContent());
}
function $8fc928cd6c76f02e$var$getTransitionElement(block) {
    if (block instanceof Element) return block;
    if ($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$export$9522e17588c12572(block) && block.getTransitionElement) return block.getTransitionElement();
}
//#endregion
//#region packages/runtime-vapor/src/refCleanup.ts
/**
* Stores ref cleanup functions keyed by the element/component they are set on.
* Shared between apiTemplateRef.ts (writes) and KeepAlive deactivate (reads).
*/ const $8fc928cd6c76f02e$var$refCleanups = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$invalidatePendingRef(el) {
    const c = $8fc928cd6c76f02e$var$refCleanups.get(el);
    if (c && c.job) {
        c.job.flags = c.job.flags | 4;
        c.job = void 0;
    }
}
/**
* Synchronously clear the ref for an element being deactivated by KeepAlive.
* In VDOM core, refs are cleared during unmount before the deactivation check.
* Since Vapor's KeepAlive retains scopes (skipping onScopeDispose), we need
* this explicit sync cleanup path.
*/ function $8fc928cd6c76f02e$var$unsetRef(el) {
    $8fc928cd6c76f02e$var$invalidatePendingRef(el);
    const c = $8fc928cd6c76f02e$var$refCleanups.get(el);
    if (c) c.fn();
}
const $8fc928cd6c76f02e$export$93e48a5fa2bfad35 = /*@__PURE__*/ $8fc928cd6c76f02e$var$withKeepAliveEnabled(/* @__PURE__ */ $8fc928cd6c76f02e$export$bcd4d980d2d74077({
    name: "VaporKeepAlive",
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots, expose: expose }) {
        let exposed;
        expose(exposed);
        if (!slots.default) return;
        const keepAliveInstance = (0, $3dLyd.currentInstance);
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        const storageContainer = /* @__PURE__ */ $8fc928cd6c76f02e$var$createElement("div");
        const keptAliveScopes = /* @__PURE__ */ new Map();
        const resolveCacheKeyFromBlock = (block, interop, branchKey)=>{
            var _ref3, _$key;
            if (interop && $8fc928cd6c76f02e$var$isInteropEnabled) {
                var _ref, _ref2, _frag$$key;
                const frag = block;
                return (_ref = (_ref2 = (_frag$$key = frag.$key) !== null && _frag$$key !== void 0 ? _frag$$key : frag.vnode.key) !== null && _ref2 !== void 0 ? _ref2 : branchKey) !== null && _ref !== void 0 ? _ref : frag.vnode.type;
            }
            return (_ref3 = (_$key = block.$key) !== null && _$key !== void 0 ? _$key : branchKey) !== null && _ref3 !== void 0 ? _ref3 : block.type;
        };
        let current;
        let rootFragment;
        if (__VUE_PROD_DEVTOOLS__) {
            keepAliveInstance.__v_cache = cache;
            keepAliveInstance.__v_keptAliveScopes = keptAliveScopes;
        }
        const addCacheKey = (key)=>{
            const { max: max } = props;
            keys.add(key);
            if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
        };
        const innerCacheBlock = (key, block, isCurrent)=>{
            if (cache.has(key)) {
                if (isCurrent) {
                    keys.delete(key);
                    keys.add(key);
                }
            } else addCacheKey(key);
            cache.set(key, block);
            if (isCurrent) current = block;
        };
        const cacheBlock = (block = keepAliveInstance.block)=>{
            if ($8fc928cd6c76f02e$var$isDynamicFragment(block)) {
                const transition = block.$transition;
                if (transition && transition.mode === "out-in" && transition.state.isLeaving) return;
            }
            const [innerBlock, interop, branchKey] = $8fc928cd6c76f02e$var$getInnerBlock(block);
            if (!innerBlock) return;
            const cacheKey = resolveCacheKeyFromBlock(innerBlock, interop, branchKey);
            if (!$8fc928cd6c76f02e$var$shouldCache(innerBlock, props, interop)) {
                if (cache.has(cacheKey)) pruneCacheEntry(cacheKey);
                return;
            }
            $8fc928cd6c76f02e$var$setShapeFlag(innerBlock, interop, cache.has(cacheKey));
            const { currentBlock: currentBlock, currentKey: currentKey } = getCurrentBlockState();
            innerCacheBlock(cacheKey, innerBlock, currentBlock === innerBlock || currentKey === cacheKey);
        };
        const processShapeFlag = (block, requireKeptAlive = false)=>{
            const [innerBlock, interop, branchKey] = $8fc928cd6c76f02e$var$getInnerBlock(block);
            if (!innerBlock || requireKeptAlive && !$8fc928cd6c76f02e$var$isKeptAlive(innerBlock, interop) || !$8fc928cd6c76f02e$var$shouldCache(innerBlock, props, interop)) return false;
            const cacheKey = resolveCacheKeyFromBlock(innerBlock, interop, branchKey);
            $8fc928cd6c76f02e$var$setShapeFlag(innerBlock, interop, cache.has(cacheKey));
            return cacheKey;
        };
        const pruneCache = (filter)=>{
            cache.forEach((cached, key)=>{
                const instance = $8fc928cd6c76f02e$var$getInstanceFromCache(cached);
                if (!instance) return;
                const name = (0, $3dLyd.getComponentName)((0, $3dLyd.isAsyncWrapper)(instance) ? instance.type.__asyncResolved || {} : instance.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        };
        const deleteScope = (key)=>{
            const scope = keptAliveScopes.get(key);
            if (scope) {
                keptAliveScopes.delete(key);
                for (const [k, s] of keptAliveScopes)if (s === scope) {
                    keptAliveScopes.delete(k);
                    break;
                }
            }
            return scope;
        };
        const cacheScope = (cacheKey, scopeLookupKey, scope)=>{
            const prevScope = keptAliveScopes.get(cacheKey);
            if (prevScope && prevScope !== scope) {
                const staleScope = deleteScope(cacheKey);
                if (staleScope) staleScope.stop();
            }
            keptAliveScopes.set(cacheKey, scope);
            if (scopeLookupKey !== cacheKey) keptAliveScopes.set(scopeLookupKey, scope);
        };
        const pruneCacheEntry = (key)=>{
            const cached = cache.get(key);
            if (cached && (!current || cached !== current)) {
                $8fc928cd6c76f02e$var$unsetShapeFlag(cached);
                const parentNode = $8fc928cd6c76f02e$var$findBlockBoundary(cached).parentNode;
                if (parentNode) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(cached, parentNode);
            } else if (current) $8fc928cd6c76f02e$var$unsetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
            const scope = deleteScope(key);
            if (scope) scope.stop();
        };
        (0, $3dLyd.watch)(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>(0, $3dLyd.matches)(include, name));
            exclude && pruneCache((name)=>!(0, $3dLyd.matches)(exclude, name));
            cacheBlock();
        }, {
            flush: "post",
            deep: true
        });
        (0, $3dLyd.onMounted)(cacheBlock);
        (0, $3dLyd.onUpdated)(cacheBlock);
        const getCurrentBlockState = ()=>{
            const block = keepAliveInstance.block;
            const [currentBlock, interop, branchKey] = $8fc928cd6c76f02e$var$getInnerBlock(block);
            return {
                currentBlock: currentBlock,
                interop: interop,
                currentKey: currentBlock && resolveCacheKeyFromBlock(currentBlock, interop, branchKey)
            };
        };
        (0, $3dLyd.onBeforeUnmount)(()=>{
            const { currentBlock: currentBlock, interop: interop, currentKey: currentKey } = getCurrentBlockState();
            const deactivateCached = (cached)=>{
                $8fc928cd6c76f02e$var$unsetShapeFlag(cached);
                const instance = $8fc928cd6c76f02e$var$getInstanceFromCache(cached);
                if (instance) {
                    const da = instance.da;
                    da && (0, $3dLyd.queuePostRenderEffect)(da, void 0, keepAliveInstance.suspense);
                }
            };
            let matched = false;
            cache.forEach((cached, key)=>{
                if (currentKey === key) {
                    matched = true;
                    deactivateCached(cached);
                    return;
                }
                $8fc928cd6c76f02e$var$unsetShapeFlag(cached);
                const parentNode = $8fc928cd6c76f02e$var$findBlockBoundary(cached).parentNode;
                $8fc928cd6c76f02e$export$cd7f480d6b8286c3(cached, parentNode || void 0);
            });
            if (!matched && currentBlock && $8fc928cd6c76f02e$var$isKeptAlive(currentBlock, interop)) deactivateCached(currentBlock);
            keptAliveScopes.forEach((scope)=>scope.stop());
            keptAliveScopes.clear();
        });
        const keepAliveCtx = {
            isolatePropSources: $8fc928cd6c76f02e$var$isolatePropSources,
            isolateSlotSources: $8fc928cd6c76f02e$var$isolateSlotSources,
            getStorageContainer: ()=>storageContainer,
            getCachedComponent: (comp, key)=>{
                if ($8fc928cd6c76f02e$var$isInteropEnabled && (0, $3dLyd.isVNode)(comp)) {
                    var _ref4, _comp$key;
                    return cache.get((_ref4 = (_comp$key = comp.key) !== null && _comp$key !== void 0 ? _comp$key : $8fc928cd6c76f02e$var$currentCacheKey) !== null && _ref4 !== void 0 ? _ref4 : comp.type);
                }
                const branchKey = key !== null && key !== void 0 ? key : $8fc928cd6c76f02e$var$currentCacheKey;
                return branchKey != null ? cache.get(branchKey) : cache.get(comp) || cache.get(comp.__asyncResolved);
            },
            activate: (instance, parentNode, anchor, parentSuspense)=>{
                current = instance;
                $8fc928cd6c76f02e$var$activate$1(instance, parentNode, anchor, parentSuspense);
            },
            deactivate: (instance, parentSuspense)=>{
                current = void 0;
                $8fc928cd6c76f02e$var$deactivate$1(instance, storageContainer, parentSuspense);
            },
            prepareBranchRemoval (frag, scope, prevKey) {
                if (frag !== rootFragment) {
                    scope.stop();
                    return false;
                }
                const fragKey = $8fc928cd6c76f02e$var$getFragmentKey(frag);
                const cacheKey = $8fc928cd6c76f02e$var$withCurrentCacheKey(fragKey, ()=>processShapeFlag(frag.nodes, true));
                if (cacheKey === false) {
                    scope.stop();
                    return false;
                }
                scope.pause();
                cacheScope(cacheKey, fragKey !== null && fragKey !== void 0 ? fragKey : prevKey, scope);
                return true;
            },
            runBranchRender (frag, fn, useScope, removePrevious) {
                const fragKey = $8fc928cd6c76f02e$var$getFragmentKey(frag);
                const cachedScope = useScope ? deleteScope(fragKey !== null && fragKey !== void 0 ? fragKey : frag.current) : void 0;
                frag.scope = useScope ? cachedScope || new (0, $SdEQh.EffectScope)() : void 0;
                if (cachedScope) cachedScope.resume();
                let incomingCacheKey = false;
                const run = ()=>{
                    try {
                        fn();
                    } finally{
                        incomingCacheKey = processShapeFlag(frag.nodes);
                    }
                };
                try {
                    $8fc928cd6c76f02e$var$withCurrentCacheKey(fragKey, run);
                    if (removePrevious && incomingCacheKey !== false && !cache.has(incomingCacheKey)) addCacheKey(incomingCacheKey);
                } finally{
                    if (removePrevious) removePrevious();
                }
            },
            processShapeFlag: processShapeFlag,
            cacheBlock: cacheBlock
        };
        if ($8fc928cd6c76f02e$var$isInteropEnabled) keepAliveCtx.clearCurrent = (block)=>{
            if (current === block) current = void 0;
        };
        keepAliveInstance.ctx = keepAliveCtx;
        let children = slots.default();
        rootFragment = $8fc928cd6c76f02e$var$registerDynamicFragmentHooks(children, keepAliveCtx);
        if ((0, $7s0Ms.isArray)(children)) {
            children = children.filter((child)=>!(child instanceof Comment));
            if (children.length === 1) rootFragment = $8fc928cd6c76f02e$var$registerDynamicFragmentHooks(children[0], keepAliveCtx);
            if (children.length > 1) return children;
        }
        return children;
    }
}));
function $8fc928cd6c76f02e$var$registerDynamicFragmentHooks(block, keepAliveCtx) {
    if (!$8fc928cd6c76f02e$var$isDynamicFragment(block)) return;
    (block.u || (block.u = [])).unshift(()=>{
        if (block.$transition && block.$transition.mode === "out-in") keepAliveCtx.cacheBlock(block);
    });
    return block;
}
const $8fc928cd6c76f02e$var$shouldCache = (block, props, interop = false)=>{
    const isAsync = (0, $3dLyd.isAsyncWrapper)(interop ? block.vnode : block);
    const type = interop && $8fc928cd6c76f02e$var$isInteropEnabled ? block.vnode.type : block.type;
    if (isAsync && !type.__asyncResolved) return !props.include;
    const { include: include, exclude: exclude } = props;
    const name = (0, $3dLyd.getComponentName)(isAsync ? type.__asyncResolved : type);
    return !(include && (!name || !(0, $3dLyd.matches)(include, name)) || exclude && name && (0, $3dLyd.matches)(exclude, name));
};
function $8fc928cd6c76f02e$var$setShapeFlag(block, interop, cached) {
    if (interop && $8fc928cd6c76f02e$var$isInteropEnabled) {
        if (cached) block.vnode.shapeFlag |= 512;
        block.vnode.shapeFlag |= 256;
    } else {
        if (cached) block.shapeFlag |= 512;
        block.shapeFlag |= 256;
    }
}
const $8fc928cd6c76f02e$var$unsetShapeFlag = (cached)=>{
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(cached)) {
        (0, $3dLyd.resetShapeFlag)(cached);
        if ($8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(cached)) {
            const [inner] = $8fc928cd6c76f02e$var$getInnerBlock(cached.block);
            if (inner && $8fc928cd6c76f02e$export$f43892e053afd2a0(inner)) (0, $3dLyd.resetShapeFlag)(inner);
        }
    } else if ($8fc928cd6c76f02e$var$isInteropEnabled) {
        const vnode = cached.vnode;
        (0, $3dLyd.resetShapeFlag)(vnode);
        if ($8fc928cd6c76f02e$export$f43892e053afd2a0(vnode.component)) $8fc928cd6c76f02e$var$unsetShapeFlag(vnode.component);
    }
};
function $8fc928cd6c76f02e$var$isKeptAlive(cached, interop) {
    if (interop && $8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$isInteropFragment(cached)) return !!(cached.vnode.shapeFlag & 256);
    return !!(cached.shapeFlag & 256);
}
function $8fc928cd6c76f02e$var$getInnerBlock(block, branchKey = $8fc928cd6c76f02e$var$currentCacheKey) {
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return [
        block,
        false,
        branchKey
    ];
    else if ($8fc928cd6c76f02e$var$isInteropEnabled && $8fc928cd6c76f02e$var$isInteropFragment(block)) return [
        block,
        true,
        branchKey
    ];
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block)) {
        var _getFragmentKey;
        return $8fc928cd6c76f02e$var$getInnerBlock(block.nodes, (_getFragmentKey = $8fc928cd6c76f02e$var$getFragmentKey(block)) !== null && _getFragmentKey !== void 0 ? _getFragmentKey : branchKey);
    }
    return [
        void 0,
        false,
        branchKey
    ];
}
function $8fc928cd6c76f02e$var$getInstanceFromCache(cached) {
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(cached)) return cached;
    if ($8fc928cd6c76f02e$var$isInteropEnabled) return cached.vnode.component;
}
function $8fc928cd6c76f02e$var$activate$1(instance, parentNode, anchor, parentSuspense = instance.suspense) {
    const inputScope = instance.inputScope;
    if (inputScope) inputScope.resume();
    $8fc928cd6c76f02e$var$move(instance, parentNode, anchor, 0, instance, parentSuspense);
    (0, $3dLyd.queuePostRenderEffect)(()=>{
        instance.isDeactivated = false;
        if (instance.a) (0, $7s0Ms.invokeArrayFns)(instance.a);
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) (0, $3dLyd.devtoolsComponentAdded)(instance);
}
function $8fc928cd6c76f02e$var$deactivate$1(instance, container, parentSuspense = instance.suspense) {
    const inputScope = instance.inputScope;
    if (inputScope) inputScope.pause();
    $8fc928cd6c76f02e$var$unsetRef(instance);
    (0, $3dLyd.invalidateMount)(instance.m);
    (0, $3dLyd.invalidateMount)(instance.a);
    $8fc928cd6c76f02e$var$move(instance, container, null, 1, instance, parentSuspense);
    (0, $3dLyd.queuePostRenderEffect)(()=>{
        if (instance.da) (0, $7s0Ms.invokeArrayFns)(instance.da);
        instance.isDeactivated = true;
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) (0, $3dLyd.devtoolsComponentAdded)(instance);
}
function $8fc928cd6c76f02e$var$isolateSlotSources(rawSlots) {
    const dynamicSources = rawSlots.$;
    const isolatedSources = dynamicSources.slice();
    const committedSources = (0, $SdEQh.shallowReactive)([]);
    let hasFunctionSource = false;
    for(let i = 0; i < dynamicSources.length; i++){
        const source = dynamicSources[i];
        if ((0, $7s0Ms.isFunction)(source)) {
            hasFunctionSource = true;
            isolatedSources[i] = ()=>committedSources[i];
        }
    }
    if (!hasFunctionSource) return rawSlots;
    const isolated = $8fc928cd6c76f02e$var$_objectSpread2($8fc928cd6c76f02e$var$_objectSpread2({}, rawSlots), {}, {
        $: isolatedSources
    });
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        for(let i = 0; i < dynamicSources.length; i++){
            const source = dynamicSources[i];
            if ((0, $7s0Ms.isFunction)(source)) committedSources[i] = $8fc928cd6c76f02e$var$resolveFunctionSource(source);
        }
    }, true);
    return isolated;
}
//#endregion
//#region packages/runtime-vapor/src/vdomInterop.ts
const $8fc928cd6c76f02e$var$EMPTY_VNODES = (0, $7s0Ms.EMPTY_ARR);
function $8fc928cd6c76f02e$var$getRawTransitionChild(vnode) {
    if (!vnode) return;
    const children = (0, $3dLyd.getTransitionRawChildren)([
        vnode
    ]);
    return children.length === 1 ? children[0] : void 0;
}
function $8fc928cd6c76f02e$var$isVaporTransitionHooks(hooks) {
    return !!hooks && hooks.__vapor === true;
}
function $8fc928cd6c76f02e$var$getVaporInstance(vnode) {
    return vnode.component;
}
function $8fc928cd6c76f02e$var$prepareInteropSlotTransition(frag, vnode, forwarded, previous, resumeAfterLeave, delayedLeaveSource) {
    const transition = frag.$transition;
    const instance = frag.renderInstance;
    if (transition && !$8fc928cd6c76f02e$var$isVaporTransitionHooks(transition)) {
        (0, $3dLyd.setTransitionHooks)(vnode, transition);
        return;
    }
    if (transition && transition.applyGroup) return;
    if (!transition && !(forwarded && instance && $8fc928cd6c76f02e$var$isVaporTransition(instance.type))) return;
    const branch = (0, $3dLyd.resolveTransitionChild)([
        vnode
    ], true);
    if (!transition) return branch;
    return (0, $3dLyd.prepareTransitionSwitch)(previous, branch, transition.props, transition.state, transition.instance, resumeAfterLeave, delayedLeaveSource || transition) || (0, $3dLyd.createCommentVNode)();
}
function $8fc928cd6c76f02e$var$getInteropTransitionType(vnode) {
    const child = $8fc928cd6c76f02e$var$getRawTransitionChild(vnode);
    return child && child.type;
}
function $8fc928cd6c76f02e$var$vnodeKeyOf(vnode) {
    var _vnode$key;
    return (_vnode$key = vnode.key) !== null && _vnode$key !== void 0 ? _vnode$key : void 0;
}
function $8fc928cd6c76f02e$var$getVNodeKey(vnode) {
    const child = $8fc928cd6c76f02e$var$getRawTransitionChild(vnode);
    return child && $8fc928cd6c76f02e$var$vnodeKeyOf(child);
}
function $8fc928cd6c76f02e$var$getInteropTransitionElement(vnode) {
    if (!vnode) return;
    const component = vnode.component;
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(component)) {
        const block = component.block && $8fc928cd6c76f02e$var$findTransitionBlock(component.block);
        return block && $8fc928cd6c76f02e$var$getTransitionElement(block);
    }
    if (component) return $8fc928cd6c76f02e$var$getInteropTransitionElement(component.subTree);
    if (vnode.el instanceof Element) return vnode.el;
    if (vnode.type === (0, $3dLyd.Fragment)) {
        const child = $8fc928cd6c76f02e$var$getRawTransitionChild(vnode);
        if (child) return $8fc928cd6c76f02e$var$getInteropTransitionElement(child);
    } else if (vnode.shapeFlag & 64 && (0, $7s0Ms.isArray)(vnode.children)) {
        const child = (0, $3dLyd.resolveTransitionChild)(vnode.children);
        if (child) return $8fc928cd6c76f02e$var$getInteropTransitionElement(child);
    }
}
function $8fc928cd6c76f02e$var$filterReservedProps(props) {
    const filtered = {};
    for(const key in props)if (!(0, $7s0Ms.isReservedProp)(key)) filtered[key] = props[key];
    return filtered;
}
const $8fc928cd6c76f02e$var$vaporInteropImpl = {
    applyCssVars (vnode, vars) {
        $8fc928cd6c76f02e$var$setVarsOnBlock($8fc928cd6c76f02e$var$getVaporInstance(vnode).block, vars);
    },
    mount (vnode, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount) {
        const selfAnchor = vnode.anchor = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
        vnode.el = selfAnchor;
        container.insertBefore(selfAnchor, anchor);
        const prev = (0, $3dLyd.currentInstance);
        (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
        const propsRef = (0, $SdEQh.shallowRef)($8fc928cd6c76f02e$var$filterReservedProps(vnode.props));
        const slotsRef = (0, $SdEQh.shallowRef)($8fc928cd6c76f02e$var$normalizeInteropSlots(vnode.children));
        const rawSlots = $8fc928cd6c76f02e$var$createInteropRawSlots(slotsRef);
        const prevCtx = $8fc928cd6c76f02e$var$currentRenderContext;
        if ($8fc928cd6c76f02e$var$isSuspenseEnabled && parentSuspense) $8fc928cd6c76f02e$var$setRenderContext($8fc928cd6c76f02e$var$deriveSuspense(prevCtx, parentSuspense));
        const dynamicPropSource = [
            ()=>propsRef.value
        ];
        dynamicPropSource[$8fc928cd6c76f02e$var$interopKey] = true;
        const instance = vnode.component = $8fc928cd6c76f02e$export$60e54eaca7e7fb38(vnode.type, {
            $: dynamicPropSource
        }, rawSlots, void 0, void 0, parentComponent ? parentComponent.appContext : vnode.appContext, true);
        instance.rawPropsRef = propsRef;
        instance.rawSlotsRef = slotsRef;
        const vnodeHookState = $8fc928cd6c76f02e$var$ensureVNodeHookState(instance, vnode);
        $8fc928cd6c76f02e$var$setInteropComponentScopeIds(instance, vnode);
        if (parentComponent && (0, $3dLyd.isKeepAlive)(parentComponent)) {
            $8fc928cd6c76f02e$var$enableKeepAlive();
            instance.shapeFlag = vnode.shapeFlag;
        }
        if (vnode.transition) {
            $8fc928cd6c76f02e$var$ensureTransitionHooksRegistered();
            (instance.bm || (instance.bm = [])).push(()=>{
                const transition = vnodeHookState.vnode.transition;
                if (transition) $8fc928cd6c76f02e$var$setTransitionHooks$1(instance, transition);
            });
        }
        $8fc928cd6c76f02e$var$setRenderContext(prevCtx);
        const rootEl = $8fc928cd6c76f02e$var$resolveInteropRootEl(instance);
        if (rootEl) vnode.el = rootEl;
        onVnodeBeforeMount && onVnodeBeforeMount();
        if (vnode.dirs) {
            if (rootEl) onBeforeMount && onBeforeMount();
            else vnode.dirs = null;
        }
        $8fc928cd6c76f02e$var$mountComponent(instance, container, selfAnchor);
        (0, $3dLyd.simpleSetCurrentInstance)(prev);
        return instance;
    },
    update (n1, n2, shouldUpdate, onBeforeUpdate, onVnodeBeforeUpdate) {
        n2.component = n1.component;
        n2.el = n1.el;
        n2.anchor = n1.anchor;
        const instance = $8fc928cd6c76f02e$var$getVaporInstance(n2);
        const vnodeHookState = $8fc928cd6c76f02e$var$ensureVNodeHookState(instance, n2);
        if (shouldUpdate) {
            const rootEl = $8fc928cd6c76f02e$var$getRootElement(instance);
            if (rootEl) n2.el = rootEl;
            onVnodeBeforeUpdate && onVnodeBeforeUpdate();
            if (n2.dirs) {
                if (rootEl) onBeforeUpdate && onBeforeUpdate();
                else n2.dirs = null;
            }
            vnodeHookState.pendingVNodeUpdate = n2;
            if (n2.transition && instance.block) {
                $8fc928cd6c76f02e$var$ensureTransitionHooksRegistered();
                $8fc928cd6c76f02e$var$setTransitionHooks$1(instance, n2.transition);
            }
            instance.rawPropsRef.value = $8fc928cd6c76f02e$var$filterReservedProps(n2.props);
            instance.rawSlotsRef.value = $8fc928cd6c76f02e$var$normalizeInteropSlots(n2.children);
            (0, $3dLyd.queuePostFlushCb)(()=>{
                $8fc928cd6c76f02e$var$syncVNodeEl(n2, instance);
                if (vnodeHookState.pendingVNodeUpdate === n2 && !instance.isUpdating) vnodeHookState.pendingVNodeUpdate = null;
            });
        }
    },
    unmount (vnode, doRemove, parentSuspense) {
        if ($8fc928cd6c76f02e$var$isSuspenseEnabled && $8fc928cd6c76f02e$var$currentUnmountSuspense !== parentSuspense) {
            $8fc928cd6c76f02e$var$runWithUnmountSuspense(parentSuspense, ()=>$8fc928cd6c76f02e$var$vaporInteropImpl.unmount(vnode, doRemove, parentSuspense));
            return;
        }
        const container = doRemove ? vnode.anchor.parentNode : void 0;
        const instance = $8fc928cd6c76f02e$var$getVaporInstance(vnode);
        let slotStartAnchor = null;
        if (instance) {
            const anchor = vnode.anchor;
            if (instance.block) {
                $8fc928cd6c76f02e$var$unmountComponent(instance, container, parentSuspense);
                if (!doRemove) {
                    const blockContainer = $8fc928cd6c76f02e$var$needsHostParentForRemove(instance.block) ? anchor && anchor.parentNode : void 0;
                    $8fc928cd6c76f02e$export$cd7f480d6b8286c3(instance.block, blockContainer);
                }
            } else {
                $8fc928cd6c76f02e$var$unmountComponent(instance, container, parentSuspense);
                if (!doRemove) instance.pendingBlock = void 0;
            }
        } else if (vnode.vb) {
            const anchor = vnode.anchor;
            if (vnode.el && vnode.el !== anchor && $8fc928cd6c76f02e$var$isComment(vnode.el, "[")) slotStartAnchor = vnode.el;
            const blockContainer = container || ($8fc928cd6c76f02e$var$needsHostParentForRemove(vnode.vb) ? anchor && anchor.parentNode : void 0);
            $8fc928cd6c76f02e$var$stopVaporSlotScope(vnode);
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(vnode.vb, blockContainer);
        }
        if (doRemove) {
            if (slotStartAnchor) {
                const parent = slotStartAnchor.parentNode;
                if (parent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(slotStartAnchor, parent);
            }
            const anchor = vnode.anchor;
            const parent = anchor.parentNode;
            if (parent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(anchor, parent);
        }
    },
    /**
	* vapor slot in vdom
	*/ slot (n1, n2, container, anchor, parentComponent, parentSuspense, slotScopeIds) {
        if (!n1) {
            const slotBlock = $8fc928cd6c76f02e$var$renderVaporSlot(n2, parentComponent, parentSuspense, slotScopeIds);
            const selfAnchor = ($8fc928cd6c76f02e$export$9522e17588c12572(slotBlock) ? slotBlock.anchor : void 0) || /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(n2.el = n2.anchor = selfAnchor, container, anchor);
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(n2.vb = slotBlock, container, selfAnchor, parentSuspense);
        } else if (!n1.vs || !n2.vs || !n1.vs.slot || !n2.vs.slot || n2.vs.slot !== n1.vs.slot) {
            const selfAnchor = n1.anchor;
            const parent = selfAnchor.parentNode;
            const nextSibling = selfAnchor.nextSibling;
            const rangeStartAnchor = n1.el && n1.el !== selfAnchor && $8fc928cd6c76f02e$var$isComment(n1.el, "[") ? n1.el : void 0;
            const oldBlockOwnsAnchor = $8fc928cd6c76f02e$export$9522e17588c12572(n1.vb) && n1.vb.anchor === selfAnchor;
            $8fc928cd6c76f02e$var$stopVaporSlotScope(n1);
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(n1.vb, parent);
            const slotBlock = $8fc928cd6c76f02e$var$renderVaporSlot(n2, parentComponent, parentSuspense, slotScopeIds);
            let newAnchor = $8fc928cd6c76f02e$export$9522e17588c12572(slotBlock) ? slotBlock.anchor : void 0;
            let insertAnchor = nextSibling;
            if (newAnchor) {
                if (!oldBlockOwnsAnchor) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(selfAnchor, parent);
            } else if (oldBlockOwnsAnchor) newAnchor = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
            else {
                newAnchor = selfAnchor;
                insertAnchor = selfAnchor;
            }
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(n2.anchor = newAnchor, parent, insertAnchor);
            n2.el = rangeStartAnchor || newAnchor;
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(n2.vb = slotBlock, parent, newAnchor, parentSuspense);
        } else {
            const vs1 = n1.vs;
            const vs2 = n2.vs;
            n2.el = n1.el;
            n2.anchor = n1.anchor;
            n2.vb = n1.vb;
            (vs2.ref = vs1.ref).value = n2.props;
            vs2.scope = vs1.scope;
            $8fc928cd6c76f02e$var$syncInteropVaporSlotState(n1, n2);
        }
    },
    move (vnode, container, anchor, moveType, parentSuspense) {
        const block = vnode.vb || vnode.component;
        const pendingRangeOwnsFragmentStart = $8fc928cd6c76f02e$export$f43892e053afd2a0(block) && !!block.pendingBlock;
        if (vnode.el && vnode.el !== vnode.anchor && $8fc928cd6c76f02e$var$isComment(vnode.el, "[") && !pendingRangeOwnsFragmentStart) $8fc928cd6c76f02e$var$move(vnode.el, container, anchor, moveType, void 0, parentSuspense);
        $8fc928cd6c76f02e$var$move(block, container, anchor, moveType, void 0, parentSuspense);
        $8fc928cd6c76f02e$var$move(vnode.anchor, container, anchor, moveType, void 0, parentSuspense);
    },
    hydrate (vnode, node, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1 && !(0, $3dLyd.isHydrating) && !(0, $3dLyd.isHydratingEnabled)) return node;
        let instance;
        $8fc928cd6c76f02e$var$hydrateNode(node, ()=>{
            instance = this.mount(vnode, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount);
        });
        if (instance && instance.asyncDep && !instance.asyncResolved) vnode.el = node;
        return anchor;
    },
    hydrateSlot (vnode, node, parentComponent, parentSuspense, slotScopeIds) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1 && !(0, $3dLyd.isHydrating) && !(0, $3dLyd.isHydratingEnabled)) return node;
        const container = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(node);
        let createdAnchor = false;
        let resumeNode = null;
        $8fc928cd6c76f02e$var$hydrateNode(node, ()=>{
            vnode.vb = $8fc928cd6c76f02e$var$renderVaporSlot(vnode, parentComponent, parentSuspense, slotScopeIds);
            const fragmentAnchor = $8fc928cd6c76f02e$export$9522e17588c12572(vnode.vb) && vnode.vb.anchor;
            let anchor = fragmentAnchor || $8fc928cd6c76f02e$var$currentHydrationNode;
            const wrapped = $8fc928cd6c76f02e$var$isComment(node, "[") && $8fc928cd6c76f02e$var$isComment(anchor, "]");
            if (!fragmentAnchor && !wrapped) {
                createdAnchor = true;
                resumeNode = anchor && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(anchor) === container ? anchor : null;
                anchor = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
                container.insertBefore(anchor, resumeNode);
            }
            if ($8fc928cd6c76f02e$var$isComment(node, "[") && $8fc928cd6c76f02e$var$isComment(anchor, "]")) {
                vnode.el = node;
                vnode.anchor = anchor;
            } else vnode.anchor = vnode.el = anchor;
        });
        if (createdAnchor) return resumeNode;
        return $8fc928cd6c76f02e$var$isComment(node, "[") ? vnode.anchor.nextSibling : vnode.anchor;
    },
    setTransitionHooks (component, hooks) {
        $8fc928cd6c76f02e$var$ensureTransitionHooksRegistered();
        $8fc928cd6c76f02e$var$setTransitionHooks$1(component, hooks);
    },
    activate (vnode, container, anchor, parentComponent, parentSuspense) {
        const cached = parentComponent.ctx.getCachedComponent(vnode);
        vnode.el = cached.el;
        vnode.component = cached.component;
        vnode.anchor = cached.anchor;
        const instance = $8fc928cd6c76f02e$var$getVaporInstance(vnode);
        const vnodeHookState = $8fc928cd6c76f02e$var$ensureVNodeHookState(instance, vnode);
        const rootEl = $8fc928cd6c76f02e$var$getRootElement(instance);
        if (rootEl) vnode.el = rootEl;
        if (vnode.dirs && !rootEl) vnode.dirs = null;
        if ((0, $3dLyd.shouldUpdateComponent)(cached, vnode)) {
            vnodeHookState.pendingVNodeUpdate = vnode;
            instance.rawPropsRef.value = $8fc928cd6c76f02e$var$filterReservedProps(vnode.props);
            instance.rawSlotsRef.value = $8fc928cd6c76f02e$var$normalizeInteropSlots(vnode.children);
            const vnodeBeforeUpdateHook = vnode.props && vnode.props.onVnodeBeforeUpdate;
            if (vnodeBeforeUpdateHook) (0, $3dLyd.callWithAsyncErrorHandling)(vnodeBeforeUpdateHook, parentComponent, 7, [
                vnode,
                cached
            ]);
            if (vnode.ibu) vnode.ibu();
            if (vnode.dirs) (0, $3dLyd.invokeDirectiveHook)(vnode, cached, parentComponent, "beforeUpdate");
            (0, $3dLyd.queuePostFlushCb)(()=>{
                $8fc928cd6c76f02e$var$syncVNodeEl(vnode, instance);
                if (vnodeHookState.pendingVNodeUpdate === vnode && !instance.isUpdating) vnodeHookState.pendingVNodeUpdate = null;
            });
            (0, $3dLyd.queuePostRenderEffect)(()=>{
                if (vnode.dirs) (0, $3dLyd.invokeDirectiveHook)(vnode, cached, parentComponent, "updated");
                const vnodeUpdatedHook = vnode.props && vnode.props.onVnodeUpdated;
                if (vnodeUpdatedHook) (0, $3dLyd.callWithAsyncErrorHandling)(vnodeUpdatedHook, parentComponent, 7, [
                    vnode,
                    cached
                ]);
                if (vnode.iu) vnode.iu();
            }, void 0, parentSuspense);
        }
        $8fc928cd6c76f02e$var$activate$1(instance, container, anchor, parentSuspense);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(vnode.anchor, container, anchor);
        const vnodeMountedHook = vnode.props && vnode.props.onVnodeMounted;
        if (vnodeMountedHook) (0, $3dLyd.queuePostRenderEffect)(()=>{
            (0, $3dLyd.callWithAsyncErrorHandling)(vnodeMountedHook, parentComponent, 7, [
                vnode
            ]);
        }, void 0, parentSuspense);
    },
    deactivate (vnode, container, parentSuspense) {
        const instance = $8fc928cd6c76f02e$var$getVaporInstance(vnode);
        $8fc928cd6c76f02e$var$deactivate$1(instance, container, parentSuspense);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(vnode.anchor, container);
        (0, $3dLyd.queuePostRenderEffect)(()=>{
            const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
            if (vnodeHook) (0, $3dLyd.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                vnode
            ]);
        }, void 0, parentSuspense);
    }
};
const $8fc928cd6c76f02e$var$vaporSlotPropsProxyHandler = {
    get (target, key) {
        return target.value[key];
    },
    has (target, key) {
        return key in target.value;
    },
    ownKeys (target) {
        return Reflect.ownKeys(target.value);
    },
    getOwnPropertyDescriptor (target, key) {
        if (key in target.value) return {
            enumerable: true,
            configurable: true
        };
    }
};
const $8fc928cd6c76f02e$var$vaporSlotWrappersCache = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$vaporSlotsProxyHandler = {
    get (target, key) {
        const slot = (0, $7s0Ms.isString)(key) && !$8fc928cd6c76f02e$var$isInternalSlotKey(key) ? $8fc928cd6c76f02e$var$getSlot(target, key) : target[key];
        if ((0, $7s0Ms.isFunction)(slot)) {
            slot[0, $3dLyd.rawVaporSlotKey] = slot;
            let wrappers = $8fc928cd6c76f02e$var$vaporSlotWrappersCache.get(target);
            if (!wrappers) $8fc928cd6c76f02e$var$vaporSlotWrappersCache.set(target, wrappers = /* @__PURE__ */ new Map());
            const cached = wrappers.get(key);
            if (cached && cached.slot === slot) return cached.wrapped;
            const wrapped = (props)=>[
                    (0, $3dLyd.renderSlot)({
                        [key]: slot
                    }, key, props)
                ];
            wrapped[0, $3dLyd.rawVaporSlotKey] = slot;
            wrapped._n = true;
            wrappers.set(key, {
                slot: slot,
                wrapped: wrapped
            });
            return wrapped;
        }
        return slot;
    },
    ownKeys (target) {
        return Array.from($8fc928cd6c76f02e$var$dynamicSlotsProxyHandlers.ownKeys(target)).filter((key)=>(0, $7s0Ms.isString)(key) && !$8fc928cd6c76f02e$var$isInternalSlotKey(key));
    },
    getOwnPropertyDescriptor (target, key) {
        if (!(0, $7s0Ms.isString)(key) || $8fc928cd6c76f02e$var$isInternalSlotKey(key)) return;
        return $8fc928cd6c76f02e$var$dynamicSlotsProxyHandlers.getOwnPropertyDescriptor(target, key);
    }
};
let $8fc928cd6c76f02e$var$vdomHydrateNode;
function $8fc928cd6c76f02e$var$resolveVNodeRange(vnode) {
    const { type: type, shapeFlag: shapeFlag, el: el, anchor: anchor } = vnode;
    if (shapeFlag & 64 && el && anchor && anchor !== el) return [
        el,
        anchor
    ];
    if ((type === (0, $3dLyd.Static) || type === (0, $3dLyd.Fragment)) && anchor) return el && anchor !== el ? [
        el,
        anchor
    ] : [
        anchor,
        anchor
    ];
    if (shapeFlag & 6) {
        const subTree = vnode.component && vnode.component.subTree;
        if (subTree) return $8fc928cd6c76f02e$var$resolveVNodeRange(subTree);
    }
}
function $8fc928cd6c76f02e$var$resolveVNodeNodes(vnode) {
    if (vnode.component && $8fc928cd6c76f02e$export$f43892e053afd2a0(vnode.component)) {
        const block = vnode.component.block;
        if (block) {
            const anchor = vnode.anchor;
            if (anchor) return [
                block,
                anchor
            ];
            return block;
        }
    }
    if (vnode.type === (0, $3dLyd.VaporSlot) && vnode.vb) {
        const { el: el, anchor: anchor, vb: vb } = vnode;
        if (!anchor) return vb;
        return el && el !== anchor && $8fc928cd6c76f02e$var$isComment(el, "[") ? [
            el,
            vb,
            anchor
        ] : [
            vb,
            anchor
        ];
    }
    const vnodeRange = $8fc928cd6c76f02e$var$resolveVNodeRange(vnode);
    if (vnodeRange) {
        const nodeRange = [];
        let n = vnodeRange[0];
        while(n){
            nodeRange.push(n);
            if (n === vnodeRange[1]) break;
            n = n.nextSibling;
        }
        return nodeRange;
    }
    if (vnode.shapeFlag & 6) {
        const subTree = vnode.component && vnode.component.subTree;
        if (subTree) return $8fc928cd6c76f02e$var$resolveVNodeNodes(subTree);
    }
    return vnode.el;
}
function $8fc928cd6c76f02e$var$removeAttachedNodes(block, parent) {
    if (block instanceof Node) {
        if (block.parentNode === parent) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(block, parent);
    } else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$removeAttachedNodes(block[i], parent);
}
function $8fc928cd6c76f02e$var$trackFragmentVNodeUpdates(frag, vnode, syncNodes) {
    vnode.ibu = ()=>{
        if (frag.bu) frag.bu.forEach((hook)=>hook());
    };
    vnode.iu = ()=>{
        syncNodes();
        if (frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
    };
}
/**
* Shared content cell for interop fragments. Hosts write the subset they
* own — do not read a field the host does not maintain (`valid` stays false
* where validity is derived live from the nodes; `nodes` stays EMPTY_BLOCK
* where the fragment's own `nodes` is the snapshot).
*
* `resolved` implements the optimistic-validity rule every interop fragment
* shares: nodes stay unresolved until the first sync (on insert / after
* patch), and validity reports true until then to keep a host boundary from
* mounting its fallback before the content exists. This keeps the common
* (valid) case free — an empty result is corrected later when the resolve
* path notifies the boundary to recheck; starting invalid would instead
* mount-then-teardown the fallback on every interop mount. Hydration starts
* resolved (SSR nodes exist).
*/ var $8fc928cd6c76f02e$var$InteropContentState = class {
    constructor(){
        this.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
        this.valid = false;
        this.resolved = $8fc928cd6c76f02e$var$isHydrating$1;
    }
};
function $8fc928cd6c76f02e$var$createVNodeFragment(vnode) {
    const frag = $8fc928cd6c76f02e$var$createInteropFragment($8fc928cd6c76f02e$var$EMPTY_BLOCK, vnode);
    frag.$key = $8fc928cd6c76f02e$var$vnodeKeyOf(vnode);
    const content = new $8fc928cd6c76f02e$var$InteropContentState();
    const syncNodes = ()=>{
        frag.nodes = $8fc928cd6c76f02e$var$resolveVNodeNodes(frag.vnode);
        content.resolved = true;
    };
    frag.isBlockValid = (componentAsValid)=>content.resolved ? $8fc928cd6c76f02e$var$isValidBlock(frag.nodes, componentAsValid) : true;
    $8fc928cd6c76f02e$var$trackFragmentVNodeUpdates(frag, vnode, syncNodes);
    return {
        frag: frag,
        syncNodes: syncNodes
    };
}
/**
* Mount a vnode as a dynamic component branch (`<component :is="vnode">`
* in a vapor template). The KeepAlive lookup, fallthrough and hydration of
* the vnode live here so the dynamic component only sees a block.
*/ function $8fc928cd6c76f02e$var$mountDynamicVNode(internals, vnode, parentComponent, isSingleRoot) {
    if (parentComponent && (0, $3dLyd.isKeepAlive)(parentComponent)) {
        const cached = parentComponent.ctx.getCachedComponent(vnode.type, vnode.key);
        if (cached) return cached;
    }
    const owner = $8fc928cd6c76f02e$var$resolveFallthroughOwner(isSingleRoot);
    const frag = $8fc928cd6c76f02e$var$mountVNode(internals, vnode, parentComponent, owner && (()=>$8fc928cd6c76f02e$var$resolveFallthroughAttrs(owner)));
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        $8fc928cd6c76f02e$var$locateHydrationNode($8fc928cd6c76f02e$var$shouldConsumeFragmentStart(vnode) ? $8fc928cd6c76f02e$var$createFragmentClaim() : void 0);
        frag.hydrate();
    }
    return frag;
}
function $8fc928cd6c76f02e$var$shouldConsumeFragmentStart(vnode) {
    if (vnode.type === (0, $3dLyd.Fragment)) return false;
    if (vnode.shapeFlag & 6) {
        const type = vnode.type;
        return !!type.__vapor && !type.__multiRoot;
    }
    return true;
}
/**
* Mount VNode in vapor
*/ function $8fc928cd6c76f02e$var$mountVNode(internals, vnode, parentComponent, getFallthroughAttrs) {
    let suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    const baseVNode = vnode;
    if (getFallthroughAttrs) vnode = (0, $3dLyd.cloneVNode)(baseVNode, getFallthroughAttrs());
    const { frag: frag, syncNodes: syncNodes } = $8fc928cd6c76f02e$var$createVNodeFragment(vnode);
    let isMounted = false;
    let mountedParentNode;
    let mountedAnchor = null;
    let namespace;
    let isUnmounted = false;
    const unmount = (parentNode, transition)=>{
        if (isUnmounted) {
            if (parentNode) {
                $8fc928cd6c76f02e$var$removeAttachedNodes($8fc928cd6c76f02e$var$resolveVNodeNodes(vnode), parentNode);
                if (vnode.anchor && vnode.anchor.parentNode === parentNode) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(vnode.anchor, parentNode);
            }
            return;
        }
        if (transition) (0, $3dLyd.setTransitionHooks)(vnode, transition);
        const parentSuspense = $8fc928cd6c76f02e$var$resolveUnmountSuspense(suspense);
        if (vnode.shapeFlag & 256) {
            const keepAliveCtx = parentComponent.ctx;
            keepAliveCtx.clearCurrent(frag);
            const storageContainer = keepAliveCtx.getStorageContainer();
            if (vnode.type.__vapor) {
                $8fc928cd6c76f02e$var$deactivate$1(vnode.component, storageContainer, parentSuspense);
                $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(vnode.anchor, storageContainer);
            } else (0, $3dLyd.deactivate)(vnode, storageContainer, internals, parentComponent, parentSuspense);
        } else {
            isUnmounted = true;
            internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        }
        if (vnode.anchor && parentNode && vnode.anchor.parentNode === parentNode) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(vnode.anchor, parentNode);
    };
    frag.hydrate = ()=>{
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        $8fc928cd6c76f02e$var$hydrateVNode(vnode, parentComponent, frag.slotScopeIds);
        isMounted = true;
        syncNodes();
    };
    const place = (parentNode, anchor, parentSuspense, transition, moveType = 2)=>{
        if ($8fc928cd6c76f02e$var$isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        const operationSuspense = suspense;
        if (vnode.shapeFlag & 512) {
            if (vnode.type.__vapor) {
                $8fc928cd6c76f02e$var$activate$1(vnode.component, parentNode, anchor, operationSuspense);
                $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(vnode.anchor, parentNode, anchor);
            } else (0, $3dLyd.activate)(vnode, parentNode, anchor, internals, parentComponent, operationSuspense, void 0, false);
            return;
        } else {
            const prev = (0, $3dLyd.currentInstance);
            (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
            if (!isMounted) {
                if (transition) (0, $3dLyd.setTransitionHooks)(vnode, transition);
                namespace = (0, $3dLyd.getContainerType)(parentNode);
                internals.p(null, vnode, parentNode, anchor, parentComponent, operationSuspense, namespace, frag.slotScopeIds);
                isMounted = true;
            } else {
                if (transition && moveType !== 2) (0, $3dLyd.setTransitionHooks)(vnode, transition);
                internals.m(vnode, parentNode, anchor, moveType, parentComponent, operationSuspense);
            }
            (0, $3dLyd.simpleSetCurrentInstance)(prev);
            mountedParentNode = parentNode;
            mountedAnchor = anchor;
        }
        syncNodes();
        if (isMounted && frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
    };
    frag.insert = (parentNode, anchor, parentSuspense, transition)=>place(parentNode, anchor, parentSuspense, transition);
    frag.move = (parentNode, anchor, moveType, _parentComponent, parentSuspense, transition)=>place(parentNode, anchor, parentSuspense, transition, moveType);
    if (getFallthroughAttrs) {
        let applied = false;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const next = (0, $3dLyd.cloneVNode)(baseVNode, getFallthroughAttrs());
            if (!applied) {
                applied = true;
                return;
            }
            if (!isMounted || !mountedParentNode) return;
            const previous = vnode;
            vnode = next;
            $8fc928cd6c76f02e$var$trackFragmentVNodeUpdates(frag, vnode, syncNodes);
            frag.vnode = vnode;
            frag.$key = $8fc928cd6c76f02e$var$vnodeKeyOf(vnode);
            const prevInstance = (0, $3dLyd.currentInstance);
            (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
            internals.p(previous, vnode, mountedParentNode, mountedAnchor, parentComponent, suspense, namespace, frag.slotScopeIds);
            (0, $3dLyd.simpleSetCurrentInstance)(prevInstance);
            syncNodes();
        });
    }
    frag.remove = unmount;
    return frag;
}
/**
* Mount vdom component in vapor
*/ function $8fc928cd6c76f02e$var$createVDOMComponent(internals, component, parentComponent, rawProps, rawSlots, once) {
    let suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    const useBridge = $8fc928cd6c76f02e$var$shouldUseRendererBridge(component);
    const comp = useBridge ? $8fc928cd6c76f02e$var$ensureRendererBridge(component) : component;
    const vnode = (0, $3dLyd.createVNode)(comp, rawProps && (0, $7s0Ms.extend)({}, new Proxy(rawProps, $8fc928cd6c76f02e$var$rawPropsProxyHandlers)));
    const { frag: frag, syncNodes: syncNodes } = $8fc928cd6c76f02e$var$createVNodeFragment(vnode);
    const keepAliveCtx = $8fc928cd6c76f02e$var$isKeepAliveEnabled ? $8fc928cd6c76f02e$var$getKeepAliveContext(parentComponent) : null;
    if (keepAliveCtx) {
        keepAliveCtx.processShapeFlag(frag);
        if (component.__asyncLoader) {
            let disposed = false;
            (0, $SdEQh.onScopeDispose)(()=>disposed = true);
            component.__asyncLoader().then(()=>{
                if (!disposed) keepAliveCtx.cacheBlock(frag);
            }).catch((0, $7s0Ms.NOOP));
        }
    }
    if (!once && component.__asyncLoader && rawSlots && rawSlots.$) $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        $8fc928cd6c76f02e$var$dynamicSlotsProxyHandlers.ownKeys(rawSlots);
        const instance = vnode.component;
        if (instance && instance.isMounted) instance.update();
    }, true);
    vnode.vi = (instance)=>{
        const wrapper = new $8fc928cd6c76f02e$var$VaporComponentInstance(useBridge ? comp : {
            props: instance.propsOptions[0],
            __propsOptions: instance.propsOptions
        }, rawProps, rawSlots, parentComponent ? parentComponent.appContext : void 0, once);
        const attrs = (0, $3dLyd.createInternalObject)();
        const isFilteredAttr = (key)=>typeof key === "string" && ((0, $7s0Ms.isReservedProp)(key) || (0, $3dLyd.isEmitListener)(instance.emitsOptions, key));
        instance.attrs = new Proxy(attrs, {
            get (_, key) {
                if (isFilteredAttr(key)) return;
                return wrapper.attrs[key];
            },
            has (_, key) {
                return !isFilteredAttr(key) && key in wrapper.attrs;
            },
            ownKeys () {
                return Reflect.ownKeys(wrapper.attrs).filter((key)=>!isFilteredAttr(key));
            },
            getOwnPropertyDescriptor (_, key) {
                if (!isFilteredAttr(key) && key in wrapper.attrs) return {
                    enumerable: true,
                    configurable: true
                };
            }
        });
        instance.props = vnode.shapeFlag & 2 && !comp.props ? instance.attrs : (0, $SdEQh.shallowReactive)(wrapper.props);
        instance.slots = wrapper.rawSlots === (0, $7s0Ms.EMPTY_OBJ) ? (0, $7s0Ms.EMPTY_OBJ) : new Proxy(wrapper.rawSlots, $8fc928cd6c76f02e$var$vaporSlotsProxyHandler);
        if (component.__asyncLoader && instance.slots !== (0, $7s0Ms.EMPTY_OBJ)) {
            vnode.children = instance.slots;
            vnode.shapeFlag |= 32;
        }
    };
    let rawRef = null;
    let isMounted = false;
    let isUnmounted = false;
    let isDomRemoved = false;
    const removeDom = (parentNode)=>{
        if (!parentNode || isDomRemoved) return;
        $8fc928cd6c76f02e$var$removeAttachedNodes($8fc928cd6c76f02e$var$resolveVNodeNodes(vnode), parentNode);
        isDomRemoved = true;
    };
    const unmount = (parentNode, transition)=>{
        if (isUnmounted) {
            if (!transition) removeDom(parentNode);
            return;
        }
        if (rawRef) (0, $3dLyd.setRef)(rawRef, null, null, vnode, true);
        if (transition) (0, $3dLyd.setTransitionHooks)(vnode, transition);
        const parentSuspense = $8fc928cd6c76f02e$var$resolveUnmountSuspense(suspense);
        if (vnode.shapeFlag & 256) {
            if (frag.inputScope) frag.inputScope.pause();
            keepAliveCtx.clearCurrent(frag);
            (0, $3dLyd.deactivate)(vnode, keepAliveCtx.getStorageContainer(), internals, parentComponent, parentSuspense);
            return;
        }
        isUnmounted = true;
        isMounted = false;
        if ($8fc928cd6c76f02e$var$isKeepAliveEnabled && frag.inputScope) frag.inputScope.stop();
        internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        if (!transition) removeDom(parentNode);
    };
    frag.hydrate = ()=>{
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        $8fc928cd6c76f02e$var$hydrateVNode(vnode, parentComponent, frag.slotScopeIds);
        isMounted = true;
        syncNodes();
    };
    vnode.scopeId = $8fc928cd6c76f02e$var$getCurrentScopeId() || null;
    vnode.slotScopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
    const place = (parentNode, anchor, parentSuspense, transition, moveType = 2)=>{
        if ($8fc928cd6c76f02e$var$isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        const operationSuspense = suspense;
        if (vnode.shapeFlag & 512) {
            if (frag.inputScope) frag.inputScope.resume();
            (0, $3dLyd.activate)(vnode, parentNode, anchor, internals, parentComponent, operationSuspense, void 0, false);
        } else {
            const prev = (0, $3dLyd.currentInstance);
            (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
            if (!isMounted) {
                if (transition) (0, $3dLyd.setTransitionHooks)(vnode, transition);
                internals.mt(vnode, parentNode, anchor, parentComponent, operationSuspense, (0, $3dLyd.getContainerType)(parentNode), false);
                if (rawRef) (0, $3dLyd.setRef)(rawRef, null, operationSuspense, vnode);
                isMounted = true;
            } else {
                if (transition && moveType !== 2) (0, $3dLyd.setTransitionHooks)(vnode, transition);
                internals.m(vnode, parentNode, anchor, moveType, parentComponent, operationSuspense);
            }
            (0, $3dLyd.simpleSetCurrentInstance)(prev);
        }
        syncNodes();
        if (isMounted && frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
    };
    frag.insert = (parentNode, anchor, parentSuspense, transition)=>place(parentNode, anchor, parentSuspense, transition);
    frag.move = (parentNode, anchor, moveType, _parentComponent, parentSuspense, transition)=>place(parentNode, anchor, parentSuspense, transition, moveType);
    frag.remove = unmount;
    frag.setRef = (instance, ref, refFor, refKey)=>{
        const oldRawRef = rawRef;
        rawRef = (0, $3dLyd.normalizeRef)({
            ref: ref,
            ref_for: refFor,
            ref_key: refKey
        }, instance);
        if (isMounted) {
            if (rawRef) (0, $3dLyd.setRef)(rawRef, oldRawRef, suspense, vnode);
            else if (oldRawRef) (0, $3dLyd.setRef)(oldRawRef, null, null, vnode, true);
        }
    };
    return frag;
}
const $8fc928cd6c76f02e$var$rendererBridgeCache = /* @__PURE__ */ new WeakMap();
/**
* Teleport/Suspense are renderer primitives (`__isTeleport` / `__isSuspense`),
* not regular components with their own render pipeline.
*
* We wrap them with a tiny functional bridge so they can pass through the
* interop component mount path while preserving built-in vnode semantics.
*/ function $8fc928cd6c76f02e$var$shouldUseRendererBridge(component) {
    return !!(component.__isTeleport || component.__isSuspense);
}
function $8fc928cd6c76f02e$var$ensureRendererBridge(component) {
    let bridge = $8fc928cd6c76f02e$var$rendererBridgeCache.get(component);
    if (!bridge) $8fc928cd6c76f02e$var$rendererBridgeCache.set(component, bridge = (props, { slots: slots })=>(0, $3dLyd.createVNode)(component, props, slots));
    return bridge;
}
function $8fc928cd6c76f02e$var$hasValidVNodeContent(vnode) {
    return !!(0, $3dLyd.ensureValidVNode)(vnode.type === (0, $3dLyd.Fragment) && (0, $7s0Ms.isArray)(vnode.children) ? vnode.children : [
        vnode
    ]);
}
function $8fc928cd6c76f02e$var$isSlotOutletOnlyVNode(vnode) {
    if (vnode.type === (0, $3dLyd.VaporSlot)) return true;
    return vnode.type === (0, $3dLyd.Fragment) && (0, $7s0Ms.isArray)(vnode.children) && vnode.children.every((child)=>(0, $3dLyd.isVNode)(child) && $8fc928cd6c76f02e$var$isSlotOutletOnlyVNode(child));
}
function $8fc928cd6c76f02e$var$hydrateForwardedEmptySlotFragment(vnode, parentComponent, contentValid) {
    if (vnode.type !== (0, $3dLyd.Fragment) || !(0, $7s0Ms.isArray)(vnode.children)) return false;
    const children = vnode.children;
    const inheritedEmptySlotEndAnchor = $8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode, "]") && $8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode.previousSibling, "[") ? $8fc928cd6c76f02e$var$currentHydrationNode : null;
    const slotEndAnchor = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor() || inheritedEmptySlotEndAnchor;
    const slotStartAnchor = slotEndAnchor && slotEndAnchor.previousSibling;
    if (!contentValid && $8fc928cd6c76f02e$var$currentHydrationNode === slotEndAnchor && slotStartAnchor && $8fc928cd6c76f02e$var$isComment(slotStartAnchor, "[")) {
        vnode.el = slotStartAnchor;
        vnode.anchor = slotEndAnchor;
        $8fc928cd6c76f02e$var$advanceHydrationNode(slotEndAnchor);
        return true;
    }
    const isEmptyFragmentStart = $8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode, "[");
    const hasSlotOutletChildren = children.length > 0;
    const slotOutletOnlyChildren = children.every((child)=>(0, $3dLyd.isVNode)(child) && $8fc928cd6c76f02e$var$isSlotOutletOnlyVNode(child));
    if (!isEmptyFragmentStart || !contentValid || !hasSlotOutletChildren || !slotOutletOnlyChildren) return false;
    const fragmentStartAnchor = $8fc928cd6c76f02e$var$currentHydrationNode;
    const fragmentEndAnchor = $8fc928cd6c76f02e$var$locateEndAnchor(fragmentStartAnchor);
    if (!fragmentEndAnchor || fragmentStartAnchor.nextSibling !== fragmentEndAnchor) return false;
    vnode.el = fragmentStartAnchor;
    $8fc928cd6c76f02e$var$withHydratingSlotBoundary(()=>{
        children.forEach((child)=>{
            $8fc928cd6c76f02e$var$hydrateVNode(child, parentComponent);
        });
    });
    vnode.anchor = fragmentEndAnchor;
    if ($8fc928cd6c76f02e$var$currentHydrationNode === fragmentEndAnchor) $8fc928cd6c76f02e$var$advanceHydrationNode(fragmentEndAnchor);
    return true;
}
function $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(vnode, refresh, beforeUpdate) {
    const track = (node)=>{
        if (beforeUpdate) node.ibu = beforeUpdate;
        node.iu = refresh;
        if (node.type === (0, $3dLyd.Fragment) && (0, $7s0Ms.isArray)(node.children)) node.children.forEach((child)=>{
            if ((0, $3dLyd.isVNode)(child)) track(child);
        });
    };
    track(vnode);
}
/**
* Construction point for the interop hosts' resolution state — the shared
* bookkeeping fields plus the host-specific hooks. (SlotFragment, the third
* host, implements SlotResolutionState directly as a class.)
*/ function $8fc928cd6c76f02e$var$createSlotResolutionState(boundary, hooks) {
    return (0, $7s0Ms.extend)({
        boundary: boundary,
        activeFallback: null,
        fallbackInserted: false,
        pendingRecheck: false,
        pendingRecheckForce: false,
        isReconciling: false
    }, hooks);
}
/**
* Exposes `$transition` through the outlet fragment so BaseTransition state
* stays on the fragment; hooks inherited from VDOM BaseTransition are
* filtered out on read because they belong to its own state machine.
* Enumerable + configurable to match an object-literal accessor pair.
*/ function $8fc928cd6c76f02e$var$installInteropTransitionAccessor(state, frag) {
    Object.defineProperty(state, "$transition", {
        enumerable: true,
        configurable: true,
        get () {
            const transition = frag.$transition;
            return transition && $8fc928cd6c76f02e$var$isVaporTransitionHooks(transition) ? transition : void 0;
        },
        set (transition) {
            frag.$transition = transition;
        }
    });
}
function $8fc928cd6c76f02e$var$renderVDOMSlot(internals, slotsRef, name, props, parentComponent, options = (0, $7s0Ms.EMPTY_OBJ)) {
    const { fallback: fallback, flags: flags = 0, adoptAnchor: adoptAnchor } = options;
    const once = !!(flags & 2);
    const sharedFallback = !!(flags & 8);
    const forwarded = (0, $7s0Ms.isForwardedSlot)(flags);
    const inheritFallback = (0, $7s0Ms.slotInheritsFallback)(flags);
    const notifiesBoundary = (0, $7s0Ms.slotNotifiesBoundary)(flags);
    let suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense || parentComponent.suspense;
    const frag = $8fc928cd6c76f02e$var$createInteropFragment($8fc928cd6c76f02e$var$EMPTY_BLOCK, null, 128);
    const slotBoundary = frag.slotBoundary;
    const content = new $8fc928cd6c76f02e$var$InteropContentState();
    const scope = (0, $SdEQh.effectScope)();
    let localFallback;
    let rendered = null;
    let isMounted = false;
    let currentParentNode = null;
    let slotNamespace;
    let currentAnchor = null;
    let sharedContentStorage;
    let disposed = false;
    let pendingInOutVNode;
    let pendingOutIn;
    let isContentUpdateRecheck = false;
    let slotResolutionState;
    frag.isBlockValid = (componentAsValid)=>{
        if (!content.resolved) return true;
        return slotResolutionState.activeFallback ? $8fc928cd6c76f02e$var$isValidBlock(slotResolutionState.activeFallback, componentAsValid) : content.valid;
    };
    const boundary = $8fc928cd6c76f02e$var$createSlotBoundary(frag, inheritFallback ? slotBoundary : null, ()=>localFallback, (force)=>$8fc928cd6c76f02e$var$markSlotResolutionDirty(slotResolutionState, force), [
        cleanupInvalidContent
    ]);
    const contentBoundary = forwarded || fallback ? boundary : null;
    slotResolutionState = $8fc928cd6c76f02e$var$createSlotResolutionState(boundary, {
        getContent: ()=>content.nodes,
        getParentNode: ()=>currentParentNode,
        getAnchor: ()=>currentAnchor,
        isBusy: ()=>false,
        isDisposed: ()=>disposed,
        isContentValid: ()=>content.valid,
        syncNodes: ()=>{
            frag.nodes = $8fc928cd6c76f02e$var$resolveExposedSlotNodes(slotResolutionState);
        },
        notifyExposedValidityChange: ()=>{
            if (notifiesBoundary && !isContentUpdateRecheck && slotBoundary) slotBoundary.markDirty();
        }
    });
    $8fc928cd6c76f02e$var$installInteropTransitionAccessor(slotResolutionState, frag);
    if (sharedFallback && slotBoundary) $8fc928cd6c76f02e$var$registerContentInvalid(slotBoundary, parkSharedContent, frag);
    if (notifiesBoundary) $8fc928cd6c76f02e$var$trackSlotBoundaryDirtying(frag, sharedFallback ? void 0 : cleanupInvalidContent);
    localFallback = fallback ? once ? ()=>$8fc928cd6c76f02e$export$81831a240bcfd22e(()=>fallback(internals, parentComponent)) : ()=>fallback(internals, parentComponent) : void 0;
    const place = (parentNode, anchor, parentSuspense, moveType)=>{
        if ($8fc928cd6c76f02e$var$isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        if (localFallback && !inheritFallback && !frag.anchor) {
            frag.anchor = $8fc928cd6c76f02e$var$resolveFragmentAnchor(adoptAnchor, void 0);
            if (frag.anchor !== adoptAnchor) parentNode.insertBefore(frag.anchor, anchor);
            anchor = frag.anchor;
        }
        const sharedContentParked = !!sharedContentStorage;
        currentParentNode = parentNode;
        currentAnchor = anchor;
        if (!isMounted) {
            slotNamespace = (0, $3dLyd.getContainerType)(parentNode);
            scope.run(render);
            isMounted = true;
        } else {
            if (sharedContentParked) {
                $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag.nodes, parentNode, anchor, suspense);
                sharedContentStorage = void 0;
                if (slotResolutionState.activeFallback) slotResolutionState.fallbackInserted = true;
            } else if ((0, $3dLyd.isVNode)(rendered)) internals.m(rendered, parentNode, anchor, moveType === void 0 ? 2 : moveType, parentComponent, suspense);
            else if (rendered) {
                if (moveType === void 0) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(rendered, parentNode, anchor, suspense);
                else $8fc928cd6c76f02e$var$move(rendered, parentNode, anchor, moveType, void 0, suspense);
            }
            if (!sharedContentParked) $8fc928cd6c76f02e$var$insertActiveSlotFallback(slotResolutionState, moveType);
        }
        notifyUpdated();
    };
    frag.insert = (parentNode, anchor, parentSuspense)=>place(parentNode, anchor, parentSuspense);
    frag.move = (parentNode, anchor, moveType, _parentComponent, parentSuspense)=>place(parentNode, anchor, parentSuspense, moveType);
    frag.remove = (parentNode)=>{
        const storage = sharedContentStorage;
        if (parentNode && !storage) currentParentNode = parentNode;
        scope.stop();
        disposed = true;
        const leavingElement = pendingOutIn && pendingOutIn.leavingElement;
        pendingOutIn = void 0;
        const leave = leavingElement && leavingElement[0, $3dLyd.leaveCbKey];
        if (leave) leave(true);
        if (rendered) removeRenderedContent(rendered, storage || parentNode);
        $8fc928cd6c76f02e$var$disposeSlotResolution(slotResolutionState, storage || parentNode);
        if (storage) {
            const anchor = frag.anchor;
            if (anchor && anchor.parentNode === storage) frag.anchor = void 0;
            sharedContentStorage = void 0;
        }
    };
    frag.hydrate = ()=>{
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        const hydrationParent = $8fc928cd6c76f02e$var$currentHydrationNode && $8fc928cd6c76f02e$var$currentHydrationNode.parentNode;
        scope.run(render);
        if (!currentParentNode) {
            currentAnchor = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor() || $8fc928cd6c76f02e$var$currentHydrationNode;
            currentParentNode = currentAnchor.parentNode;
        }
        slotNamespace = (0, $3dLyd.getContainerType)(hydrationParent || currentParentNode);
        if (content.valid && localFallback && !inheritFallback && !frag.anchor) {
            const outletAnchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
            $8fc928cd6c76f02e$var$insertUntrackedAnchor(currentParentNode, currentAnchor, outletAnchor);
            frag.anchor = currentAnchor = outletAnchor;
        }
        isMounted = true;
    };
    return frag;
    function cleanupInvalidContent() {
        const pending = pendingInOutVNode;
        if (pending) {
            pendingInOutVNode = void 0;
            const transition = slotResolutionState.$transition;
            const fallback = slotResolutionState.activeFallback;
            if (transition) (0, $3dLyd.prepareTransitionLeave)(pending, fallback && $8fc928cd6c76f02e$var$isValidSlot(fallback) ? transition : void 0, transition.props, transition.state, transition.instance, (0, $7s0Ms.NOOP));
            internals.um(pending, parentComponent, $8fc928cd6c76f02e$var$resolveUnmountSuspense(suspense), true);
            return;
        }
        if (currentParentNode) $8fc928cd6c76f02e$var$removeAttachedNodes(content.nodes, currentParentNode);
    }
    function parkSharedContent() {
        if (!currentParentNode || sharedContentStorage) return;
        $8fc928cd6c76f02e$var$invalidateExposedSlotContent(slotResolutionState);
        const storage = document.createDocumentFragment();
        let anchor = frag.anchor;
        if (!anchor || anchor.parentNode !== currentParentNode) anchor = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
        storage.appendChild(anchor);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag.nodes, storage, anchor, suspense);
        sharedContentStorage = storage;
        currentParentNode = storage;
        currentAnchor = anchor;
    }
    function notifyUpdated() {
        $8fc928cd6c76f02e$var$syncInteropRoot(parentComponent);
        if (isMounted && frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
    }
    function notifyBeforeUpdate() {
        if (isMounted && frag.bu) frag.bu.forEach((hook)=>hook());
    }
    function recheckAfterContentUpdate(forceResolutionRecheck = false) {
        isContentUpdateRecheck = true;
        try {
            $8fc928cd6c76f02e$var$recheckSlotResolution(slotResolutionState, forceResolutionRecheck);
        } finally{
            isContentUpdateRecheck = false;
        }
    }
    function finishContentUpdate(forceResolutionRecheck = false) {
        recheckAfterContentUpdate(forceResolutionRecheck);
        notifyUpdated();
    }
    function patchSlotVNode(previous, next, slotScopeIds, valid) {
        setVNode(next);
        const refreshSlotVNode = ()=>{
            const prevValid = content.valid;
            const prevOutput = frag.nodes;
            setRendered(next);
            recheckAfterContentUpdate();
            if (content.valid !== prevValid || !$8fc928cd6c76f02e$var$isSameResolvedOutput(prevOutput, frag.nodes)) notifyUpdated();
        };
        $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(next, refreshSlotVNode, notifyBeforeUpdate);
        internals.p(previous, next, currentParentNode, currentAnchor, parentComponent, suspense, slotNamespace, $8fc928cd6c76f02e$var$concatInteropScopeIds(frag.slotScopeIds, slotScopeIds));
        setRendered(next, valid);
        finishContentUpdate();
    }
    function removeRenderedContent(renderedContent, parentNode) {
        const contentDetached = !!slotResolutionState.activeFallback;
        if ((0, $3dLyd.isVNode)(renderedContent)) internals.um(renderedContent, parentComponent, $8fc928cd6c76f02e$var$resolveUnmountSuspense(suspense), !contentDetached && !!parentNode);
        else $8fc928cd6c76f02e$export$cd7f480d6b8286c3(renderedContent, contentDetached ? void 0 : parentNode);
    }
    function resumeOutIn() {
        (0, $3dLyd.queuePostFlushCb)(()=>{
            const pending = pendingOutIn;
            pendingOutIn = void 0;
            if (!pending || disposed || !currentParentNode) return;
            const pendingContent = pending.content;
            if ((0, $3dLyd.isVNode)(pendingContent)) {
                const nextVNode = $8fc928cd6c76f02e$var$prepareInteropSlotTransition(frag, pendingContent, forwarded, void 0, (0, $7s0Ms.NOOP)) || pendingContent;
                patchSlotVNode(pending.placeholder, nextVNode, pendingContent.slotScopeIds, pending.contentValid);
            } else {
                setVNode(null);
                if (pending.placeholder) removeRenderedContent(pending.placeholder, currentParentNode);
                if (pendingContent) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(pendingContent, currentParentNode, currentAnchor, suspense);
                setRendered(pendingContent || null, pending.contentValid);
                finishContentUpdate();
            }
        });
    }
    function render() {
        const prev = (0, $3dLyd.currentInstance);
        (0, $3dLyd.simpleSetCurrentInstance)(frag.renderInstance);
        try {
            once ? renderContent() : $8fc928cd6c76f02e$export$6c64e011838f4702(renderContent);
        } finally{
            (0, $3dLyd.simpleSetCurrentInstance)(prev);
        }
    }
    function renderContent() {
        notifyBeforeUpdate();
        $8fc928cd6c76f02e$var$withRenderContext(frag.ctx, ()=>$8fc928cd6c76f02e$var$withSlotBoundary(contentBoundary, ()=>{
                const { content: slotContent, valid: slotContentValid } = resolveSlotContent();
                if ($8fc928cd6c76f02e$var$isHydrating$1) {
                    hydrateContent(slotContent, slotContentValid);
                    return;
                }
                if (pendingOutIn) {
                    pendingOutIn.content = slotContent;
                    pendingOutIn.contentValid = slotContentValid;
                    return;
                }
                if ((0, $3dLyd.isVNode)(slotContent)) {
                    applyVNodeContent(slotContent, slotContentValid);
                    return;
                }
                if (slotContent) {
                    applyBlockContent(slotContent, slotContentValid);
                    return;
                }
                applyEmptyContent();
            }));
    }
    function resolveSlotContent() {
        let slotContent;
        let slotContentValid = false;
        if (slotsRef.value) {
            const renderContent = ()=>(0, $3dLyd.renderSlot)(slotsRef.value, (0, $7s0Ms.isFunction)(name) ? name() : name, props);
            slotContent = once ? $8fc928cd6c76f02e$export$81831a240bcfd22e(renderContent) : renderContent();
            if ((0, $3dLyd.isVNode)(slotContent)) {
                if (slotContent.type === (0, $3dLyd.Fragment)) {
                    const children = slotContent.children;
                    (0, $3dLyd.ensureVaporSlotFallback)(children, localFallback);
                    slotContentValid = $8fc928cd6c76f02e$var$hasValidVNodeContent(slotContent);
                } else slotContentValid = true;
            } else if (slotContent) slotContentValid = $8fc928cd6c76f02e$var$isValidSlot(slotContent);
        }
        return {
            content: slotContent,
            valid: slotContentValid
        };
    }
    function applyVNodeContent(slotContent, slotContentValid) {
        const prevRendered = rendered;
        const transition = slotResolutionState.$transition;
        const mode = transition && transition.props.mode;
        let delayedLeaveSource;
        if (slotResolutionState.activeFallback && !slotContentValid) {
            applyEmptyContent();
            return;
        }
        if (slotResolutionState.activeFallback && slotContentValid && transition) {
            if (mode === "out-in") {
                const fallback = slotResolutionState.activeFallback;
                const leavingBlock = fallback && $8fc928cd6c76f02e$var$findTransitionBlock(fallback);
                pendingOutIn = {
                    content: slotContent,
                    placeholder: null,
                    contentValid: true,
                    leavingElement: leavingBlock && $8fc928cd6c76f02e$var$getTransitionElement(leavingBlock)
                };
                if ($8fc928cd6c76f02e$var$leaveSlotFallback(slotResolutionState, transition, resumeOutIn)) return;
                pendingOutIn = void 0;
            } else if (mode === "in-out") {
                const enterHooks = (0, $7s0Ms.extend)({}, transition);
                delete enterHooks.delayedLeave;
                $8fc928cd6c76f02e$var$leaveSlotFallback(slotResolutionState, enterHooks, (0, $7s0Ms.NOOP));
                delayedLeaveSource = enterHooks;
            }
        }
        const prevIsVNode = (0, $3dLyd.isVNode)(prevRendered);
        const prevVNode = prevIsVNode && (!slotResolutionState.activeFallback || content.valid) ? prevRendered : null;
        if (prevVNode && !slotContentValid && transition && $8fc928cd6c76f02e$var$hasSlotFallback(boundary)) {
            if (mode === "out-in") {
                const placeholder = $8fc928cd6c76f02e$var$prepareInteropSlotTransition(frag, slotContent, forwarded, void 0, (0, $7s0Ms.NOOP)) || (0, $3dLyd.createCommentVNode)();
                if ((0, $3dLyd.prepareTransitionLeave)(prevVNode, void 0, transition.props, transition.state, transition.instance, resumeOutIn)) {
                    suspendForOutIn(prevVNode, placeholder, slotContent, false);
                    return;
                }
            } else if (mode === "in-out") {
                pendingInOutVNode = prevVNode;
                setVNode(null);
                setRendered(null);
                finishContentUpdate();
                return;
            }
        }
        const transitionChild = $8fc928cd6c76f02e$var$prepareInteropSlotTransition(frag, slotContent, forwarded, prevVNode || void 0, resumeOutIn, delayedLeaveSource);
        const nextVNode = transitionChild || slotContent;
        if (prevVNode && transitionChild && transition && transition.state.isLeaving) {
            suspendForOutIn(prevVNode, nextVNode, slotContent, slotContentValid);
            return;
        }
        if (prevRendered && !prevIsVNode) removeRenderedContent(prevRendered, currentParentNode);
        patchSlotVNode(prevVNode, nextVNode, slotContent.slotScopeIds, slotContentValid);
    }
    function applyBlockContent(slotContent, slotContentValid) {
        setVNode(null);
        const prevRendered = rendered;
        if (prevRendered) removeRenderedContent(prevRendered, currentParentNode);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(slotContent, currentParentNode, currentAnchor, suspense);
        setRendered(slotContent, slotContentValid);
        finishContentUpdate();
    }
    function applyEmptyContent() {
        if (rendered) removeRenderedContent(rendered, currentParentNode);
        setVNode(null);
        setRendered(null);
        finishContentUpdate();
    }
    function setVNode(vnode) {
        frag.vnode = vnode;
        frag.$key = vnode ? $8fc928cd6c76f02e$var$getVNodeKey(vnode) : void 0;
    }
    /** Commit rendered output, deriving the content nodes and validity. */ function setRendered(renderedContent, knownValid) {
        rendered = renderedContent;
        if ((0, $3dLyd.isVNode)(renderedContent)) {
            content.nodes = $8fc928cd6c76f02e$var$resolveVNodeNodes(renderedContent);
            content.valid = knownValid === void 0 ? $8fc928cd6c76f02e$var$hasValidVNodeContent(renderedContent) : knownValid;
        } else if (renderedContent) {
            content.nodes = renderedContent;
            content.valid = knownValid === void 0 ? $8fc928cd6c76f02e$var$isValidSlot(renderedContent) : knownValid;
        } else {
            content.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
            content.valid = false;
        }
        content.resolved = true;
    }
    function suspendForOutIn(prevVNode, placeholder, slotContent, contentValid) {
        pendingOutIn = {
            content: slotContent,
            placeholder: placeholder,
            contentValid: contentValid,
            leavingElement: $8fc928cd6c76f02e$var$getInteropTransitionElement(prevVNode)
        };
        setVNode(placeholder);
        rendered = placeholder;
        internals.p(prevVNode, placeholder, currentParentNode, currentAnchor, parentComponent, suspense, slotNamespace, null);
    }
    /**
	* One-shot hydration claimer: adopts the SSR-rendered slot range —
	* content, a local-fallback candidate range, or a deferred shared-fallback
	* decision — instead of mounting. Runs only on the first render pass under
	* an active hydration cursor; later passes take the CSR paths above.
	*/ function hydrateContent(slotContent, slotContentValid) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        if (slotContentValid && $8fc928cd6c76f02e$var$isPendingSlotContent()) $8fc928cd6c76f02e$var$resolvePendingSlotContent();
        const contentStart = $8fc928cd6c76f02e$var$currentHydrationNode;
        const contentEnd = $8fc928cd6c76f02e$var$locateFragmentEnd(contentStart);
        const slotEnd = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor();
        const candidateEnd = contentEnd && contentEnd !== slotEnd ? contentEnd : null;
        const deferSharedContent = sharedFallback && !slotContentValid && $8fc928cd6c76f02e$var$isPendingSlotContent();
        const localFallbackOwnsRange = !!(!inheritFallback && !slotContentValid && !deferSharedContent && localFallback && candidateEnd);
        const hydratedContent = !deferSharedContent && slotContent && (slotContentValid || !$8fc928cd6c76f02e$var$hasSlotFallback(boundary)) ? slotContent : void 0;
        if ((0, $3dLyd.isVNode)(hydratedContent)) {
            const hydrationVNode = $8fc928cd6c76f02e$var$prepareInteropSlotTransition(frag, hydratedContent, forwarded, void 0, (0, $7s0Ms.NOOP)) || hydratedContent;
            setVNode(hydrationVNode);
            const refreshSlotVNode = ()=>{
                frag.nodes = $8fc928cd6c76f02e$var$resolveVNodeNodes(hydrationVNode);
                notifyUpdated();
            };
            $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(hydrationVNode, refreshSlotVNode, notifyBeforeUpdate);
            const hydrationParent = /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode($8fc928cd6c76f02e$var$currentHydrationNode);
            if (!$8fc928cd6c76f02e$var$hydrateForwardedEmptySlotFragment(hydrationVNode, parentComponent, slotContentValid)) $8fc928cd6c76f02e$var$hydrateVNode(hydrationVNode, parentComponent, $8fc928cd6c76f02e$var$concatInteropScopeIds(frag.slotScopeIds, hydrationVNode === hydratedContent ? null : hydratedContent.slotScopeIds));
            currentParentNode = hydrationParent;
            currentAnchor = internals.n(hydrationVNode);
            setRendered(hydrationVNode, slotContentValid);
        } else if (hydratedContent) {
            setVNode(null);
            setRendered(hydratedContent, slotContentValid);
        } else {
            setVNode(null);
            setRendered(null);
        }
        if (deferSharedContent && localFallback && candidateEnd) $8fc928cd6c76f02e$var$withPendingHydratingSlotBoundary(()=>finishContentUpdate(true));
        else if (localFallbackOwnsRange) {
            $8fc928cd6c76f02e$var$withHydratingSlotBoundary(()=>finishContentUpdate(true));
            frag.anchor = currentAnchor = $8fc928cd6c76f02e$var$claimAnchor(candidateEnd);
            currentParentNode = candidateEnd.parentNode;
            $8fc928cd6c76f02e$var$advanceHydrationNode(candidateEnd);
        } else finishContentUpdate(true);
        const exposedValid = $8fc928cd6c76f02e$var$isValidSlot(frag.nodes);
        if (deferSharedContent && exposedValid && candidateEnd) {
            frag.anchor = currentAnchor = $8fc928cd6c76f02e$var$claimAnchor(candidateEnd);
            currentParentNode = candidateEnd.parentNode;
        }
        if (sharedFallback && exposedValid && candidateEnd && $8fc928cd6c76f02e$var$currentHydrationNode === candidateEnd) $8fc928cd6c76f02e$var$advanceHydrationNode(candidateEnd);
        else if (deferSharedContent && !exposedValid) {
            if (candidateEnd && $8fc928cd6c76f02e$var$currentHydrationNode === candidateEnd) $8fc928cd6c76f02e$var$advanceHydrationNode(candidateEnd);
            const anchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
            const detachedParent = document.createDocumentFragment();
            detachedParent.appendChild(anchor);
            currentParentNode = detachedParent;
            currentAnchor = anchor;
            $8fc928cd6c76f02e$var$claimPrecedingFragmentClose(slotEnd);
            const attachAnchor = $8fc928cd6c76f02e$var$createDeferredSlotAttach(contentStart, slotEnd, anchor, candidateEnd, (candidate)=>{
                frag.anchor = currentAnchor = $8fc928cd6c76f02e$var$claimAnchor(candidate);
                if ($8fc928cd6c76f02e$var$currentHydrationNode === contentStart) $8fc928cd6c76f02e$var$advanceHydrationNode(candidate);
                return currentAnchor;
            }, ()=>frag.nodes, (parent)=>{
                currentParentNode = parent;
            });
            if (!$8fc928cd6c76f02e$var$queuePendingSlotContentAnchor({
                onContent: ()=>{
                    attachAnchor();
                    if (!candidateEnd) (0, $3dLyd.queuePostFlushCb)(()=>{
                        if (!disposed) frag.anchor = anchor;
                    });
                },
                onFallback: ()=>{
                    frag.anchor = anchor;
                }
            })) (0, $3dLyd.queuePostFlushCb)(()=>{
                attachAnchor();
                if (!disposed && !candidateEnd) frag.anchor = anchor;
            });
        }
    }
}
function $8fc928cd6c76f02e$var$needsHostParentForRemove(block) {
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) return (0, $3dLyd.isKeepAlive)(block) || $8fc928cd6c76f02e$var$needsHostParentForRemove(block.block);
    if ((0, $7s0Ms.isArray)(block)) return block.some($8fc928cd6c76f02e$var$needsHostParentForRemove);
    if ($8fc928cd6c76f02e$export$9522e17588c12572(block)) return $8fc928cd6c76f02e$var$needsHostParentForRemove(block.nodes);
    return false;
}
const $8fc928cd6c76f02e$export$4fa2a5402abc6e89 = (app)=>{
    $8fc928cd6c76f02e$var$enableSuspense();
    $8fc928cd6c76f02e$var$setInteropEnabled();
    $8fc928cd6c76f02e$var$setPublishInteropScopeIds($8fc928cd6c76f02e$var$publishVaporScopeIds);
    app._context.vapor = $8fc928cd6c76f02e$var$vaporInteropImpl;
    const internals = (0, $bmuEm.ensureRenderer)().internals;
    app._context.vdom = {
        mount: $8fc928cd6c76f02e$var$createVDOMComponent.bind(null, internals),
        slot: $8fc928cd6c76f02e$var$renderVDOMSlot.bind(null, internals),
        mountVNode: $8fc928cd6c76f02e$var$mountDynamicVNode.bind(null, internals)
    };
    const mount = app.mount;
    app.mount = (...args)=>{
        $8fc928cd6c76f02e$var$optimizePropertyLookup();
        return mount(...args);
    };
};
function $8fc928cd6c76f02e$var$hydrateVNode(vnode, parentComponent, slotScopeIds = null) {
    const node = $8fc928cd6c76f02e$var$currentHydrationNode;
    if (!$8fc928cd6c76f02e$var$vdomHydrateNode) $8fc928cd6c76f02e$var$vdomHydrateNode = (0, $bmuEm.ensureHydrationRenderer)().hydrateNode;
    const nextNode = $8fc928cd6c76f02e$var$vdomHydrateNode(node, vnode, parentComponent, null, slotScopeIds, false);
    if (nextNode) $8fc928cd6c76f02e$var$setCurrentHydrationNode(nextNode);
    else $8fc928cd6c76f02e$var$advanceHydrationNode(node);
}
function $8fc928cd6c76f02e$var$createFallback(fallback, parentComponent, isVNodeFallback) {
    const internals = (0, $bmuEm.ensureRenderer)().internals;
    return ()=>{
        if (isVNodeFallback()) {
            const frag = $8fc928cd6c76f02e$var$createVNodeChildrenFragment(internals, ()=>{
                const children = fallback();
                return children == null ? $8fc928cd6c76f02e$var$EMPTY_VNODES : $8fc928cd6c76f02e$var$normalizeInteropSlotValue(children);
            }, parentComponent);
            if ($8fc928cd6c76f02e$var$isHydrating$1 && frag.hydrate) frag.hydrate();
            return frag;
        }
        return fallback();
    };
}
const $8fc928cd6c76f02e$var$renderEmptyVNodes = ()=>$8fc928cd6c76f02e$var$EMPTY_VNODES;
function $8fc928cd6c76f02e$var$resolveInteropVaporSlotState(vnode) {
    const slot = vnode.vs;
    let state = slot.state;
    if (!state) {
        state = {
            localFallback: (0, $SdEQh.shallowRef)(slot.fallback),
            outletFallback: (0, $SdEQh.shallowRef)(slot.outletFallback)
        };
        slot.state = state;
    }
    return state;
}
function $8fc928cd6c76f02e$var$syncInteropVaporSlotState(n1, n2) {
    const prevState = n1.vs.state;
    if (!prevState) return;
    n2.vs.state = prevState;
    prevState.localFallback.value = n2.vs.fallback;
    prevState.outletFallback.value = n2.vs.outletFallback;
}
function $8fc928cd6c76f02e$var$trackInteropFallbackChanges(scope, state, onChange) {
    if (!scope) return;
    let trackedLocalFallback;
    let trackedOutletFallback;
    let initialized = false;
    scope.run(()=>{
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const nextLocalFallback = state.localFallback.value;
            const nextOutletFallback = state.outletFallback.value;
            if (!initialized) {
                trackedLocalFallback = nextLocalFallback;
                trackedOutletFallback = nextOutletFallback;
                initialized = true;
                return;
            }
            if (trackedLocalFallback === nextLocalFallback && trackedOutletFallback === nextOutletFallback) return;
            trackedLocalFallback = nextLocalFallback;
            trackedOutletFallback = nextOutletFallback;
            onChange();
        }, true);
    });
}
function $8fc928cd6c76f02e$var$renderVaporSlot(vnode, parentComponent, parentSuspense, contextSlotScopeIds) {
    const prev = (0, $3dLyd.currentInstance);
    const prevCtx = $8fc928cd6c76f02e$var$currentRenderContext;
    (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
    if ($8fc928cd6c76f02e$var$isSuspenseEnabled && parentSuspense) $8fc928cd6c76f02e$var$setRenderContext($8fc928cd6c76f02e$var$deriveSuspense(prevCtx, parentSuspense));
    try {
        if (!vnode.vs || !vnode.vs.slot) return $8fc928cd6c76f02e$var$EMPTY_BLOCK;
        const slotState = $8fc928cd6c76f02e$var$resolveInteropVaporSlotState(vnode);
        const frag = $8fc928cd6c76f02e$var$createInteropFragment($8fc928cd6c76f02e$var$EMPTY_BLOCK, null, 128);
        frag.ctx = $8fc928cd6c76f02e$var$deriveSlotScopeIds(frag.ctx, $8fc928cd6c76f02e$var$getInteropVaporSlotScopeIds(vnode, parentComponent, contextSlotScopeIds));
        const content = new $8fc928cd6c76f02e$var$InteropContentState();
        frag.isBlockValid = (componentAsValid)=>content.resolved ? $8fc928cd6c76f02e$var$isValidBlock(frag.nodes, componentAsValid) : true;
        const slotBoundary = frag.slotBoundary;
        let isResolvingContent = false;
        let localFallback;
        let outletFallback;
        let currentParentNode = null;
        let currentAnchor = null;
        let disposed = false;
        let slotResolutionState;
        let ownedSlotFragment;
        let ownedSlotFragmentDirtyQueued = false;
        let ownedSlotFragmentDirtyForce = false;
        const onContentInvalid = [
            ()=>{
                if (currentParentNode) $8fc928cd6c76f02e$var$removeAttachedNodes(content.nodes, currentParentNode);
            }
        ];
        const markInteropSlotResolutionDirty = (force)=>{
            const target = ownedSlotFragment;
            if (!target) {
                $8fc928cd6c76f02e$var$markSlotResolutionDirty(slotResolutionState, force);
                return;
            }
            ownedSlotFragmentDirtyForce = ownedSlotFragmentDirtyForce || !!force;
            if (ownedSlotFragmentDirtyQueued) return;
            ownedSlotFragmentDirtyQueued = true;
            (0, $3dLyd.queuePostFlushCb)(()=>{
                ownedSlotFragmentDirtyQueued = false;
                const force = ownedSlotFragmentDirtyForce;
                ownedSlotFragmentDirtyForce = false;
                $8fc928cd6c76f02e$var$markSlotResolutionDirty(target, force);
            });
        };
        const localFallbackBoundary = $8fc928cd6c76f02e$var$createSlotBoundary(frag, $8fc928cd6c76f02e$var$createSlotBoundary(frag, slotBoundary, ()=>slotState.outletFallback.value ? outletFallback : void 0, markInteropSlotResolutionDirty), ()=>slotState.localFallback.value ? localFallback : void 0, markInteropSlotResolutionDirty, onContentInvalid);
        slotResolutionState = $8fc928cd6c76f02e$var$createSlotResolutionState(localFallbackBoundary, {
            getContent: ()=>content.nodes,
            getParentNode: ()=>currentParentNode,
            getAnchor: ()=>currentAnchor,
            isBusy: ()=>isResolvingContent,
            isDisposed: ()=>disposed,
            isContentValid: ()=>$8fc928cd6c76f02e$var$isValidSlot(content.nodes),
            syncNodes: ()=>{
                frag.nodes = $8fc928cd6c76f02e$var$resolveExposedSlotNodes(slotResolutionState);
                content.resolved = true;
            },
            notifyExposedValidityChange: ()=>{
                if (slotBoundary) slotBoundary.markDirty();
            }
        });
        const takePendingRecheck = ()=>{
            const force = slotResolutionState.pendingRecheckForce;
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            return force;
        };
        const dispose = (parentNode)=>{
            if (disposed) return;
            if (parentNode) currentParentNode = parentNode;
            disposed = true;
            $8fc928cd6c76f02e$var$disposeSlotResolution(slotResolutionState, parentNode);
            currentParentNode = null;
            currentAnchor = null;
        };
        try {
            localFallback = $8fc928cd6c76f02e$var$createFallback(()=>(slotState.localFallback.value || $8fc928cd6c76f02e$var$renderEmptyVNodes)(), parentComponent, ()=>!!slotState.localFallback.value && !!slotState.localFallback.value[0, $3dLyd.vdomSlotFallbackKey]);
            outletFallback = $8fc928cd6c76f02e$var$createFallback(()=>(slotState.outletFallback.value || $8fc928cd6c76f02e$var$renderEmptyVNodes)(), parentComponent, ()=>!!slotState.outletFallback.value && !!slotState.outletFallback.value[0, $3dLyd.vdomSlotFallbackKey]);
            const hasInteropFallback = !!slotState.localFallback.value || !!slotState.outletFallback.value;
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            let pending = $8fc928cd6c76f02e$var$INERT_PENDING_SLOT_CONTENT;
            const finalizeResolvedContent = (resolvedContent)=>{
                if (hasInteropFallback && $8fc928cd6c76f02e$var$isSlotResolver(resolvedContent)) {
                    pending.finish(true);
                    return resolvedContent;
                }
                content.nodes = resolvedContent || $8fc928cd6c76f02e$var$EMPTY_BLOCK;
                pending.finish($8fc928cd6c76f02e$var$isValidSlot(content.nodes));
                $8fc928cd6c76f02e$var$recheckSlotResolution(slotResolutionState, takePendingRecheck());
                return resolvedContent;
            };
            let resolvedContent;
            isResolvingContent = true;
            try {
                if ($8fc928cd6c76f02e$var$isHydrating$1) resolvedContent = $8fc928cd6c76f02e$var$withHydratingSlotBoundary(()=>{
                    pending = $8fc928cd6c76f02e$var$startPendingSlotContentGuard($8fc928cd6c76f02e$var$hasSlotFallback(localFallbackBoundary), $8fc928cd6c76f02e$var$currentHydrationNode);
                    try {
                        return finalizeResolvedContent($8fc928cd6c76f02e$var$withRenderContext(frag.ctx, ()=>{
                            const renderSlot = ()=>$8fc928cd6c76f02e$var$withSlotBoundary(localFallbackBoundary, ()=>$8fc928cd6c76f02e$var$invokeVaporSlot(vnode));
                            return renderSlot();
                        }));
                    } finally{
                        pending.settle();
                    }
                });
                else resolvedContent = finalizeResolvedContent($8fc928cd6c76f02e$var$withRenderContext(frag.ctx, ()=>$8fc928cd6c76f02e$var$withSlotBoundary(localFallbackBoundary, ()=>$8fc928cd6c76f02e$var$invokeVaporSlot(vnode))));
            } finally{
                isResolvingContent = false;
            }
            if (hasInteropFallback && $8fc928cd6c76f02e$var$isSlotResolver(resolvedContent)) {
                ownedSlotFragment = resolvedContent;
                $8fc928cd6c76f02e$var$trackInteropFallbackChanges(vnode.vs.scope, slotState, ()=>markInteropSlotResolutionDirty());
                dispose();
                return resolvedContent;
            }
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            frag.insert = (parentNode, anchor, parentSuspense)=>{
                currentParentNode = parentNode;
                currentAnchor = anchor;
                if (slotResolutionState.activeFallback) $8fc928cd6c76f02e$var$insertActiveSlotFallback(slotResolutionState);
                else $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(frag.nodes, parentNode, anchor, parentSuspense);
            };
            frag.move = (parentNode, anchor, moveType, parentComponent, parentSuspense)=>{
                currentParentNode = parentNode;
                currentAnchor = anchor;
                if (slotResolutionState.activeFallback) $8fc928cd6c76f02e$var$insertActiveSlotFallback(slotResolutionState, moveType);
                else $8fc928cd6c76f02e$var$move(frag.nodes, parentNode, anchor, moveType, parentComponent, parentSuspense);
            };
            frag.remove = (parentNode)=>{
                if (!slotResolutionState.activeFallback) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(frag.nodes, parentNode);
                dispose(parentNode);
            };
            $8fc928cd6c76f02e$var$trackInteropFallbackChanges(vnode.vs.scope, slotState, ()=>{
                $8fc928cd6c76f02e$var$recheckSlotResolution(slotResolutionState, true);
            });
            if ($8fc928cd6c76f02e$var$isHydrating$1 && $8fc928cd6c76f02e$var$currentHydrationNode) {
                currentAnchor = $8fc928cd6c76f02e$var$currentHydrationNode;
                currentParentNode = currentAnchor.parentNode;
            }
            return frag;
        } catch (e) {
            dispose(currentParentNode || void 0);
            $8fc928cd6c76f02e$var$stopVaporSlotScope(vnode);
            throw e;
        }
    } finally{
        $8fc928cd6c76f02e$var$setRenderContext(prevCtx);
        (0, $3dLyd.simpleSetCurrentInstance)(prev);
    }
}
function $8fc928cd6c76f02e$var$stopVaporSlotScope(vnode) {
    if (vnode.vs && vnode.vs.scope) {
        vnode.vs.scope.stop();
        vnode.vs.scope = void 0;
    }
}
/**
* Slot functions can create renderEffects while evaluating their block.
* Those effects live in this dedicated scope so slot re-mount/unmount can
* dispose them immediately instead of waiting for the parent component.
*/ function $8fc928cd6c76f02e$var$invokeVaporSlot(vnode) {
    const propsRef = vnode.vs.ref = (0, $SdEQh.shallowRef)(vnode.props);
    const scope = (0, $SdEQh.effectScope)();
    vnode.vs.scope = scope;
    try {
        const run = ()=>vnode.vs.slot(new Proxy(propsRef, $8fc928cd6c76f02e$var$vaporSlotPropsProxyHandler));
        return $8fc928cd6c76f02e$var$inOnce ? $8fc928cd6c76f02e$export$81831a240bcfd22e(()=>scope.run(run), false) : scope.run(run);
    } catch (e) {
        vnode.vs.scope = void 0;
        scope.stop();
        throw e;
    }
}
function $8fc928cd6c76f02e$var$resolveInteropRootEl(instance) {
    return $8fc928cd6c76f02e$var$getRootElement(instance, {
        onDynamicFragment: (frag)=>$8fc928cd6c76f02e$var$registerInteropRootSync(instance, frag)
    });
}
function $8fc928cd6c76f02e$var$syncVNodeEl(vnode, instance) {
    const rootEl = $8fc928cd6c76f02e$var$resolveInteropRootEl(instance);
    if (rootEl) vnode.el = rootEl;
    else {
        vnode.el = vnode.anchor;
        vnode.dirs = null;
    }
}
function $8fc928cd6c76f02e$var$syncInteropRoot(instance) {
    const state = $8fc928cd6c76f02e$var$vnodeHookStateMap.get(instance);
    if (!state) return;
    $8fc928cd6c76f02e$var$syncVNodeEl(state.vnode, instance);
}
const $8fc928cd6c76f02e$var$vnodeHookStateMap = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$ensureVNodeHookState(instance, vnode) {
    instance.interopVNode = vnode;
    let state = $8fc928cd6c76f02e$var$vnodeHookStateMap.get(instance);
    if (!state) {
        state = {
            vnode: vnode,
            pendingVNodeUpdate: null
        };
        $8fc928cd6c76f02e$var$vnodeHookStateMap.set(instance, state);
        (instance.bu || (instance.bu = [])).push(()=>{
            if (state.pendingVNodeUpdate) return;
            const vnodeHook = state.vnode.props && state.vnode.props.onVnodeBeforeUpdate;
            if (vnodeHook) (0, $3dLyd.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                state.vnode,
                state.vnode
            ]);
            if (state.vnode.ibu) state.vnode.ibu();
        });
        (instance.u || (instance.u = [])).unshift(()=>$8fc928cd6c76f02e$var$syncInteropRoot(instance));
        instance.u.push(()=>{
            if (state.pendingVNodeUpdate) {
                state.pendingVNodeUpdate = null;
                return;
            }
            const vnodeHook = state.vnode.props && state.vnode.props.onVnodeUpdated;
            if (vnodeHook) (0, $3dLyd.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                state.vnode,
                state.vnode
            ]);
            if (state.vnode.iu) state.vnode.iu();
        });
    } else state.vnode = vnode;
    return state;
}
function $8fc928cd6c76f02e$var$createVNodeChildrenFragment(internals, render, parentComponent) {
    let suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    const frag = $8fc928cd6c76f02e$var$createInteropFragment();
    const content = new $8fc928cd6c76f02e$var$InteropContentState();
    frag.isBlockValid = ()=>content.resolved ? content.valid : true;
    let currentVNode = null;
    let currentChildren = $8fc928cd6c76f02e$var$EMPTY_VNODES;
    let currentParentNode = null;
    let childrenNamespace;
    let currentAnchor = null;
    let isMounted = false;
    let isRenderEffectStarted = false;
    const scope = (0, $SdEQh.effectScope)();
    const cleanupInvalidContent = ()=>{
        if (currentParentNode) $8fc928cd6c76f02e$var$removeAttachedNodes(frag.nodes, currentParentNode);
    };
    if (frag.slotBoundary) $8fc928cd6c76f02e$var$registerContentInvalid(frag.slotBoundary, cleanupInvalidContent, frag);
    const syncResolvedNodes = (children = currentChildren)=>{
        const prevValid = content.resolved ? content.valid : true;
        content.valid = !!(0, $3dLyd.ensureValidVNode)(children);
        if (children.length === 0) frag.nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK;
        else if (children.length === 1) frag.nodes = $8fc928cd6c76f02e$var$resolveVNodeNodes(children[0]);
        else frag.nodes = children.map($8fc928cd6c76f02e$var$resolveVNodeNodes);
        content.resolved = true;
        return prevValid !== content.valid;
    };
    const syncResolvedNodesAndCleanup = (children = currentChildren)=>{
        const validityChanged = syncResolvedNodes(children);
        if (!content.valid && frag.slotBoundary) {
            cleanupInvalidContent();
            currentVNode = null;
            currentChildren = $8fc928cd6c76f02e$var$EMPTY_VNODES;
        }
        return validityChanged;
    };
    const notifyUpdated = (validityChanged = false)=>{
        if (validityChanged && frag.slotBoundary) frag.slotBoundary.markDirty();
        if (isMounted && frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
    };
    const notifyBeforeUpdate = ()=>{
        if (isMounted && frag.bu) frag.bu.forEach((hook)=>hook());
    };
    const renderContent = ()=>{
        const prev = (0, $3dLyd.currentInstance);
        (0, $3dLyd.simpleSetCurrentInstance)(parentComponent);
        try {
            $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
                $8fc928cd6c76f02e$var$withRenderContext(frag.ctx, ()=>{
                    const nextChildren = render();
                    notifyBeforeUpdate();
                    if ($8fc928cd6c76f02e$var$isHydrating$1) {
                        nextChildren.forEach((vnode)=>$8fc928cd6c76f02e$var$hydrateVNode(vnode, parentComponent, frag.slotScopeIds));
                        currentChildren = nextChildren;
                        currentVNode = (0, $3dLyd.createVNode)((0, $3dLyd.Fragment), null, nextChildren);
                        currentParentNode = $8fc928cd6c76f02e$var$currentHydrationNode.parentNode;
                        childrenNamespace = (0, $3dLyd.getContainerType)(currentParentNode);
                        currentAnchor = $8fc928cd6c76f02e$var$currentHydrationNode;
                        if (frag.slotBoundary && currentAnchor && $8fc928cd6c76f02e$var$isClaimedAnchor(currentAnchor) && currentAnchor !== $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor() && currentAnchor.nextSibling) currentAnchor = currentAnchor.nextSibling;
                    } else if (!isMounted) {
                        currentChildren = nextChildren;
                        currentVNode = (0, $3dLyd.createVNode)((0, $3dLyd.Fragment), null, nextChildren);
                        const wasResolved = content.resolved;
                        const validityChanged = syncResolvedNodes(nextChildren);
                        if (wasResolved) notifyUpdated(validityChanged);
                        return;
                    } else if (!currentVNode) {
                        currentChildren = nextChildren;
                        currentVNode = (0, $3dLyd.createVNode)((0, $3dLyd.Fragment), null, nextChildren);
                        $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(currentVNode, ()=>{
                            notifyUpdated(syncResolvedNodesAndCleanup(nextChildren));
                        }, notifyBeforeUpdate);
                        if (nextChildren.length) internals.mc(nextChildren, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
                    } else {
                        const nextVNode = (0, $3dLyd.createVNode)((0, $3dLyd.Fragment), null, nextChildren);
                        $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(nextVNode, ()=>{
                            notifyUpdated(syncResolvedNodesAndCleanup(nextChildren));
                        }, notifyBeforeUpdate);
                        internals.pc(currentVNode, nextVNode, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
                        currentChildren = nextChildren;
                        currentVNode = nextVNode;
                    }
                    const validityChanged = syncResolvedNodesAndCleanup();
                    if ($8fc928cd6c76f02e$var$isHydrating$1) {
                        if (isMounted && frag.u) frag.u.forEach((hook)=>hook(frag.nodes));
                    } else notifyUpdated(validityChanged);
                });
            });
        } finally{
            (0, $3dLyd.simpleSetCurrentInstance)(prev);
        }
    };
    const startRenderEffect = ()=>{
        if (isRenderEffectStarted) return;
        isRenderEffectStarted = true;
        scope.run(renderContent);
    };
    if (!$8fc928cd6c76f02e$var$isHydrating$1) startRenderEffect();
    const place = (parentNode, anchor, parentSuspense, moveType = 2)=>{
        if ($8fc928cd6c76f02e$var$isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        currentParentNode = parentNode;
        currentAnchor = anchor;
        if (!isMounted) {
            childrenNamespace = (0, $3dLyd.getContainerType)(parentNode);
            startRenderEffect();
            if (currentVNode) $8fc928cd6c76f02e$var$trackSlotVNodeUpdatesWithRefresh(currentVNode, ()=>{
                notifyUpdated(syncResolvedNodesAndCleanup(currentChildren));
            }, notifyBeforeUpdate);
            if (currentChildren.length) internals.mc(currentChildren, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
            syncResolvedNodes();
            isMounted = true;
        } else currentChildren.forEach((vnode)=>{
            internals.m(vnode, parentNode, anchor, moveType, parentComponent, suspense);
        });
    };
    frag.insert = (parentNode, anchor, parentSuspense)=>place(parentNode, anchor, parentSuspense);
    frag.move = (parentNode, anchor, moveType, _parentComponent, parentSuspense)=>place(parentNode, anchor, parentSuspense, moveType);
    frag.remove = (parentNode)=>{
        scope.stop();
        const parentSuspense = $8fc928cd6c76f02e$var$resolveUnmountSuspense(suspense);
        currentChildren.forEach((vnode)=>{
            internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        });
    };
    frag.hydrate = ()=>{
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        startRenderEffect();
        isMounted = true;
    };
    return frag;
}
function $8fc928cd6c76f02e$var$isSameResolvedOutput(prev, next) {
    return prev === next || (0, $7s0Ms.isArray)(prev) && (0, $7s0Ms.isArray)(next) && prev.length === next.length && prev.every((node, index)=>node === next[index]);
}
function $8fc928cd6c76f02e$var$normalizeInteropSlots(rawSlots) {
    if (rawSlots == null) return 0, $7s0Ms.EMPTY_OBJ;
    if (!(0, $7s0Ms.isObject)(rawSlots) || (0, $7s0Ms.isArray)(rawSlots) || (0, $3dLyd.isVNode)(rawSlots)) return $8fc928cd6c76f02e$var$normalizeInteropDefaultSlot(rawSlots);
    const normalized = (0, $3dLyd.createInternalObject)();
    for(const key in rawSlots){
        if ($8fc928cd6c76f02e$var$isInternalSlotKey(key)) continue;
        const slot = rawSlots[key];
        if ((0, $7s0Ms.isFunction)(slot)) normalized[key] = slot[0, $3dLyd.rawVaporSlotKey] || slot._n ? slot : $8fc928cd6c76f02e$var$normalizeInteropSlot(slot, rawSlots._ctx);
        else if (slot != null) normalized[key] = ()=>$8fc928cd6c76f02e$var$normalizeInteropSlotValue(slot);
    }
    [
        "_",
        "_ctx",
        "$stable"
    ].forEach((key)=>{
        const descriptor = Object.getOwnPropertyDescriptor(rawSlots, key);
        if (descriptor) Object.defineProperty(normalized, key, descriptor);
    });
    return normalized;
}
const $8fc928cd6c76f02e$var$interopSlotCache = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$normalizeInteropSlot(rawSlot, ctx) {
    let cache = $8fc928cd6c76f02e$var$interopSlotCache.get(rawSlot);
    if (!cache) $8fc928cd6c76f02e$var$interopSlotCache.set(rawSlot, cache = {});
    if (ctx) {
        let ctxCache = cache.ctx;
        if (!ctxCache) cache.ctx = ctxCache = /* @__PURE__ */ new WeakMap();
        const cached = ctxCache.get(ctx);
        if (cached) return cached;
        const normalized = $8fc928cd6c76f02e$var$createNormalizedInteropSlot(rawSlot, ctx);
        ctxCache.set(ctx, normalized);
        return normalized;
    }
    if (cache.noCtx) return cache.noCtx;
    return cache.noCtx = $8fc928cd6c76f02e$var$createNormalizedInteropSlot(rawSlot, ctx);
}
function $8fc928cd6c76f02e$var$createNormalizedInteropSlot(rawSlot, ctx) {
    const normalized = (0, $3dLyd.withCtx)((...args)=>$8fc928cd6c76f02e$var$normalizeInteropSlotValue(rawSlot(...args)), ctx);
    normalized._c = false;
    return normalized;
}
function $8fc928cd6c76f02e$var$normalizeInteropDefaultSlot(value) {
    const normalized = (0, $3dLyd.createInternalObject)();
    const normalizedValue = $8fc928cd6c76f02e$var$normalizeInteropSlotValue(value);
    normalized.default = ()=>normalizedValue;
    return normalized;
}
function $8fc928cd6c76f02e$var$normalizeInteropSlotValue(value) {
    return (0, $7s0Ms.isArray)(value) ? value.map((child)=>(0, $3dLyd.normalizeVNode)(child)) : [
        (0, $3dLyd.normalizeVNode)(value)
    ];
}
const $8fc928cd6c76f02e$var$isInternalSlotKey = (key)=>key === "_" || key === "_ctx" || key === "$stable" || key === "$";
const $8fc928cd6c76f02e$var$interopSlotsSourceHandlers = {
    get (target, key) {
        const slots = target.value;
        return slots && slots[key];
    },
    has (target, key) {
        const slots = target.value;
        return !!slots && key in slots;
    },
    ownKeys (target) {
        const slots = target.value;
        return slots ? Object.keys(slots).filter((key)=>!$8fc928cd6c76f02e$var$isInternalSlotKey(key)) : (0, $7s0Ms.EMPTY_ARR);
    },
    getOwnPropertyDescriptor (target, key) {
        const slots = target.value;
        const descriptor = slots && Object.getOwnPropertyDescriptor(slots, key);
        if (descriptor && descriptor.enumerable && !$8fc928cd6c76f02e$var$isInternalSlotKey(key)) return {
            enumerable: true,
            configurable: true,
            value: descriptor.value
        };
    }
};
function $8fc928cd6c76f02e$var$createInteropRawSlots(slotsRef) {
    return {
        $: [
            new Proxy(slotsRef, $8fc928cd6c76f02e$var$interopSlotsSourceHandlers)
        ],
        [$8fc928cd6c76f02e$var$interopSlotsKey]: slotsRef
    };
}
const $8fc928cd6c76f02e$var$interopRootSyncFragmentMap = /* @__PURE__ */ new WeakMap();
function $8fc928cd6c76f02e$var$registerInteropRootSync(instance, frag) {
    if ($8fc928cd6c76f02e$var$interopRootSyncFragmentMap.get(frag) === instance) return;
    $8fc928cd6c76f02e$var$interopRootSyncFragmentMap.set(frag, instance);
    (frag.u || (frag.u = [])).push(()=>$8fc928cd6c76f02e$var$syncInteropRoot(instance));
}
/**
* Stores the vnode-derived root-only ids on the instance. Metadata only:
* mountComponent and dynamic branch renders apply them pre-insert to roots
* that mount afterwards; kept roots keep their mount-time ids (VDOM parity).
*/ function $8fc928cd6c76f02e$var$setInteropComponentScopeIds(instance, vnode) {
    instance.scopeId = vnode.scopeId;
    const inherited = (0, $3dLyd.getInheritedScopeIds)(vnode, instance.parent);
    instance.slotScopeIds = $8fc928cd6c76f02e$var$concatInteropScopeIds(vnode.slotScopeIds, inherited.length ? inherited : null);
}
function $8fc928cd6c76f02e$var$concatInteropScopeIds(base, own) {
    return base ? own && own.length && own !== base ? base.concat(own) : base : own || null;
}
/**
* Publishes root-only ids onto the interop vnode backing a vapor component's
* effective root, for core to apply at its own pre-insertion mount. A nested
* component crossed during the descent re-collects canonically — its climb
* carries every ancestor's contribution — superseding the caller's subset.
*/ function $8fc928cd6c76f02e$var$publishVaporScopeIds(block, scopeIds) {
    let currentScopeIds = scopeIds;
    $8fc928cd6c76f02e$var$getRootElement(block, {
        onComponent: (instance)=>{
            currentScopeIds = $8fc928cd6c76f02e$var$collectRootScopeIds(instance) || [];
        },
        onInteropFragment: (frag)=>{
            if (frag.vnode) {
                $8fc928cd6c76f02e$var$setVNodeVaporScopeIds(frag.vnode, currentScopeIds);
                return true;
            }
        },
        excludeSlotOutlets: true
    });
}
function $8fc928cd6c76f02e$var$setVNodeVaporScopeIds(vnode, scopeIds) {
    vnode.vaporScopeIds = scopeIds;
    if (vnode.ssContent) $8fc928cd6c76f02e$var$setVNodeVaporScopeIds(vnode.ssContent, scopeIds);
    if (vnode.ssFallback) $8fc928cd6c76f02e$var$setVNodeVaporScopeIds(vnode.ssFallback, scopeIds);
}
function $8fc928cd6c76f02e$var$getInteropVaporSlotScopeIds(vnode, parentComponent, contextSlotScopeIds) {
    const inherited = (0, $3dLyd.getInheritedScopeIds)(vnode, parentComponent, false);
    return $8fc928cd6c76f02e$var$concatInteropScopeIds($8fc928cd6c76f02e$var$concatInteropScopeIds(contextSlotScopeIds, vnode.slotScopeIds), inherited.length ? inherited : null);
}
function $8fc928cd6c76f02e$var$interopHasVDOMContent() {
    return !!this.vnode;
}
function $8fc928cd6c76f02e$var$interopSetKey(key) {
    if (this.vnode) this.vnode.key = key;
}
function $8fc928cd6c76f02e$var$interopGetTransitionType() {
    return this.vnode ? $8fc928cd6c76f02e$var$getInteropTransitionType(this.vnode) : void 0;
}
function $8fc928cd6c76f02e$var$interopGetTransitionElement() {
    return this.vnode ? $8fc928cd6c76f02e$var$getInteropTransitionElement(this.vnode) : void 0;
}
function $8fc928cd6c76f02e$var$createInteropFragment(nodes = $8fc928cd6c76f02e$var$EMPTY_BLOCK, vnode = null, extraFlags = 0) {
    const frag = new $8fc928cd6c76f02e$var$RenderContextFragment(nodes, 64 | extraFlags);
    frag.vnode = vnode;
    frag.hasVDOMContent = $8fc928cd6c76f02e$var$interopHasVDOMContent;
    frag.setKey = $8fc928cd6c76f02e$var$interopSetKey;
    frag.getTransitionType = $8fc928cd6c76f02e$var$interopGetTransitionType;
    frag.getTransitionElement = $8fc928cd6c76f02e$var$interopGetTransitionElement;
    return frag;
}
//#endregion
//#region packages/runtime-vapor/src/components/Teleport.ts
const $8fc928cd6c76f02e$var$VaporTeleportImpl = {
    name: "VaporTeleport",
    __isTeleport: true,
    __vapor: true,
    process (props, slots, adoptAnchor) {
        return new $8fc928cd6c76f02e$var$TeleportFragment(props, slots, adoptAnchor);
    }
};
var $8fc928cd6c76f02e$var$TeleportFragment = class extends $8fc928cd6c76f02e$var$RenderContextFragment {
    constructor(props, slots, adoptAnchor){
        super([], 32);
        this.childrenInitialized = false;
        this.childrenScope = (0, $SdEQh.getCurrentScope)();
        this.mountState = {
            location: 0
        };
        this.dispose = ()=>{
            const scope = this.scope;
            if (scope) {
                this.scope = void 0;
                scope.stop();
            }
            const mountState = this.mountState;
            if (this.nodes && mountState.location === 1) {
                $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.nodes, mountState.container);
                this.nodes = [];
            }
            this.disposeTarget();
            this.mountState = {
                location: 0
            };
        };
        this.hydrate = ()=>{
            if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
            const target = this.target = (0, $3dLyd.resolveTeleportTarget)(this.resolvedProps, $8fc928cd6c76f02e$var$querySelector);
            const disabled = (0, $3dLyd.isTeleportDisabled)(this.resolvedProps);
            this.placeholder = $8fc928cd6c76f02e$var$currentHydrationNode;
            if (target) {
                const targetNode = target._lpa || target.firstChild;
                if (disabled) this.hydrateDisabledTeleport(target, targetNode);
                else {
                    this.anchor = $8fc928cd6c76f02e$var$claimAnchor($8fc928cd6c76f02e$var$locateTeleportEndAnchor($8fc928cd6c76f02e$var$currentHydrationNode.nextSibling));
                    this.hydrateTargetAnchors(target, targetNode);
                    this.mountState = {
                        location: 2,
                        container: target,
                        anchor: this.targetAnchor || null
                    };
                    if (targetNode) $8fc928cd6c76f02e$var$setCurrentHydrationNode(targetNode.nextSibling);
                    if (!this.targetAnchor) this.mountChildren(target);
                    else this.initChildren();
                }
            } else if (disabled) this.hydrateDisabledTeleport(null, null);
            else this.anchor = $8fc928cd6c76f02e$var$claimAnchor($8fc928cd6c76f02e$var$locateTeleportEndAnchor($8fc928cd6c76f02e$var$currentHydrationNode.nextSibling));
            $8fc928cd6c76f02e$var$advanceHydrationNode(this.anchor);
        };
        this.rawSlots = slots;
        this.anchor = $8fc928cd6c76f02e$var$isHydrating$1 ? void 0 : $8fc928cd6c76f02e$var$resolveFragmentAnchor(adoptAnchor, "teleport end");
        const propsProxy = new Proxy(props, $8fc928cd6c76f02e$var$rawPropsProxyHandlers);
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const prevTo = this.resolvedProps && this.resolvedProps.to;
            const wasDisabled = this.isDisabled;
            this.resolvedProps = (0, $7s0Ms.extend)({}, propsProxy);
            this.isDisabled = (0, $3dLyd.isTeleportDisabled)(this.resolvedProps);
            if (wasDisabled !== this.isDisabled || !this.isDisabled && prevTo !== this.resolvedProps.to) this.handlePropsUpdate();
        });
    }
    get parent() {
        return this.anchor ? /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.anchor) : null;
    }
    get scopeOwner() {
        return this.ctx.slotOwner || this.renderInstance;
    }
    initChildren() {
        const instance = this.renderInstance;
        const prevInstance = (0, $3dLyd.setCurrentInstance)(instance, this.childrenScope);
        const prevUpdating = instance ? instance.isUpdating : false;
        if (instance) instance.isUpdating = true;
        try {
            this.childrenInitialized = true;
            $8fc928cd6c76f02e$export$6c64e011838f4702(()=>$8fc928cd6c76f02e$var$withRenderContext(this.ctx, ()=>{
                    const prevScope = this.scope;
                    if (prevScope) prevScope.stop();
                    const scope = this.scope = new (0, $SdEQh.EffectScope)();
                    this.handleChildrenUpdate(scope.run(()=>this.rawSlots && this.rawSlots.default ? this.rawSlots.default() : []) || []);
                }));
            const owner = this.scopeOwner;
            if (owner && owner.applyCssVars) $8fc928cd6c76f02e$var$registerCssVarOutlet(owner, this);
            this.bindChildren(this.nodes);
        } finally{
            if (instance) instance.isUpdating = prevUpdating;
            (0, $3dLyd.restoreCurrentInstance)(prevInstance);
        }
    }
    ensureChildrenInitialized() {
        if (!this.childrenInitialized) this.initChildren();
    }
    bindChildren(block) {
        const owner = this.scopeOwner;
        if (owner && owner.applyCssVars) owner.applyCssVars(block);
    }
    handleChildrenUpdate(children) {
        const mountState = this.mountState;
        if ($8fc928cd6c76f02e$var$isHydrating$1 || !this.parent || mountState.location === 0) {
            this.nodes = children;
            return;
        }
        $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.nodes, mountState.container);
        this.nodes = children;
        this.bindChildren(children);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(children, mountState.container, mountState.anchor);
    }
    mount(parent, anchor, location) {
        if ($8fc928cd6c76f02e$var$isTransitionEnabled && this.$transition && this.mountState.location === 0) $8fc928cd6c76f02e$var$applyTransitionHooks(this.nodes, this.$transition, this);
        if (this.mountState.location !== 0) $8fc928cd6c76f02e$var$move(this.nodes, parent, anchor, 2);
        else $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.nodes, parent, anchor);
        this.mountState = {
            location: location,
            container: parent,
            anchor: anchor
        };
    }
    prepareTargetAnchors(target) {
        if (!this.targetAnchor || /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetAnchor) !== target) {
            if (this.targetStart) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.targetStart, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetStart));
            if (this.targetAnchor) $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.targetAnchor, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetAnchor));
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.targetStart = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(""), target);
            $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.targetAnchor = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(""), target);
        }
    }
    prepareTarget() {
        const target = this.target = (0, $3dLyd.resolveTeleportTarget)(this.resolvedProps, $8fc928cd6c76f02e$var$querySelector);
        if (target) this.prepareTargetAnchors(target);
        return target;
    }
    queueTargetUpdate() {
        if (!this.mountToTargetJob || this.mountToTargetJob.flags & 4) this.mountToTargetJob = ()=>{
            this.mountToTargetJob = void 0;
            if (!this.anchor) return;
            if (this.isDisabled) {
                if (!this.targetAnchor) this.prepareTarget();
            } else this.mountToTarget();
        };
        (0, $3dLyd.queuePostRenderEffect)(this.mountToTargetJob, void 0, this.parentSuspense !== void 0 ? this.parentSuspense : $8fc928cd6c76f02e$var$isSuspenseEnabled && this.ctx.suspense || null);
    }
    mountToTarget() {
        const target = this.prepareTarget();
        if (target) {
            this.ensureChildrenInitialized();
            this.mount(target, this.targetAnchor, 2);
            this.cancelMountToTarget();
        }
    }
    handlePropsUpdate() {
        if (!this.parent || $8fc928cd6c76f02e$var$isHydrating$1) return;
        if (this.isDisabled) {
            this.ensureChildrenInitialized();
            this.mount(this.parent, this.anchor, 1);
            if (!this.targetAnchor) {
                if ((0, $3dLyd.isTeleportDeferred)(this.resolvedProps) || !this.parent.isConnected) this.queueTargetUpdate();
                else this.prepareTarget();
            }
        } else if ((0, $3dLyd.isTeleportDeferred)(this.resolvedProps) || !this.parent.isConnected) this.queueTargetUpdate();
        else this.mountToTarget();
    }
    insert(container, anchor, parentSuspense) {
        if ($8fc928cd6c76f02e$var$isHydrating$1) return;
        if (parentSuspense !== void 0) this.parentSuspense = parentSuspense;
        const wasMountedInTarget = this.mountState.location === 2;
        if (!this.placeholder) this.placeholder = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a();
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.placeholder, container, anchor);
        $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(this.anchor, container, anchor);
        if (!wasMountedInTarget) this.handlePropsUpdate();
    }
    move(container, anchor, _moveType, _parentComponent, parentSuspense) {
        this.insert(container, anchor, parentSuspense);
    }
    cancelMountToTarget() {
        if (this.mountToTargetJob) {
            this.mountToTargetJob.flags |= 4;
            this.mountToTargetJob = void 0;
        }
    }
    disposeTarget() {
        this.cancelMountToTarget();
        const mountState = this.mountState;
        if (this.nodes && mountState.location === 2) {
            const targetParent = this.targetStart && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetStart) || this.targetAnchor && /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetAnchor) || void 0;
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.nodes, targetParent);
            this.nodes = [];
            this.mountState = {
                location: 0
            };
        }
        if (this.targetStart) {
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.targetStart, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetStart));
            this.targetStart = void 0;
        }
        if (this.targetAnchor) {
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.targetAnchor, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.targetAnchor));
            this.targetAnchor = void 0;
        }
        this.target = void 0;
    }
    scheduleTargetDispose() {
        this.cancelMountToTarget();
        (0, $3dLyd.queuePostFlushCb)(()=>this.disposeTarget());
    }
    remove() {
        this.dispose();
        if (this.anchor) {
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.anchor, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.anchor));
            this.anchor = void 0;
        }
        if (this.placeholder) {
            $8fc928cd6c76f02e$export$cd7f480d6b8286c3(this.placeholder, /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.placeholder));
            this.placeholder = void 0;
        }
    }
    hydrateTargetAnchors(target, targetNode) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") this.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    this.targetAnchor = $8fc928cd6c76f02e$var$claimAnchor(targetAnchor);
                    target._lpa = this.targetAnchor.nextSibling;
                    break;
                }
            }
            targetAnchor = targetAnchor.nextSibling;
        }
    }
    hydrateDisabledTeleport(target, targetNode) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        let nextNode = this.placeholder.nextSibling;
        $8fc928cd6c76f02e$var$setCurrentHydrationNode(nextNode);
        this.anchor = $8fc928cd6c76f02e$var$claimAnchor($8fc928cd6c76f02e$var$locateTeleportEndAnchor(nextNode));
        this.mountState = {
            location: 1,
            container: /* @__PURE__ */ $8fc928cd6c76f02e$var$parentNode(this.anchor),
            anchor: this.anchor
        };
        if (target) this.hydrateTargetAnchors(target, targetNode);
        else {
            this.targetStart = targetNode;
            this.targetAnchor = targetNode && targetNode.nextSibling;
        }
        this.initChildren();
    }
    mountChildren(target) {
        if (!$8fc928cd6c76f02e$var$isHydrating$1) return;
        target.appendChild(this.targetStart = /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(""));
        target.appendChild(this.targetAnchor = $8fc928cd6c76f02e$var$claimAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a("")));
        this.mountState = {
            location: 2,
            container: target,
            anchor: this.targetAnchor
        };
        if (!(0, $3dLyd.isMismatchAllowed)(target, 1)) {
            if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) (0, $3dLyd.warn)(`Hydration children mismatch on`, target, `\nServer rendered element contains fewer child nodes than client nodes.`);
            (0, $3dLyd.logMismatchError)();
        }
        $8fc928cd6c76f02e$var$runWithoutHydration(this.initChildren.bind(this));
    }
};
const $8fc928cd6c76f02e$export$6bc080ef119efb18 = /*@__PURE__*/ $8fc928cd6c76f02e$var$enableTeleport($8fc928cd6c76f02e$var$VaporTeleportImpl);
function $8fc928cd6c76f02e$var$locateTeleportEndAnchor(node = $8fc928cd6c76f02e$var$currentHydrationNode) {
    let depth = 0;
    while(node){
        if ($8fc928cd6c76f02e$var$isComment(node, "teleport start")) depth++;
        else if ($8fc928cd6c76f02e$var$isComment(node, "teleport end")) {
            if (depth === 0) return node;
            else depth--;
        }
        node = node.nextSibling;
    }
    return null;
}
//#endregion
//#region packages/runtime-vapor/src/apiDefineCustomElement.ts
const $8fc928cd6c76f02e$var$vaporCustomElementHydrates = /* @__PURE__ */ new WeakMap();
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$7dc92afc90cd43f8(options, extraOptions, _createApp, _hydrate) {
    let Comp = /* @__PURE__ */ $8fc928cd6c76f02e$export$bcd4d980d2d74077(options, extraOptions);
    if ((0, $7s0Ms.isPlainObject)(Comp)) Comp = (0, $7s0Ms.extend)({}, Comp, extraOptions);
    class VaporCustomElement extends $8fc928cd6c76f02e$export$3ba6ba579e6b6c77 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VaporCustomElement.def = Comp;
    if (_hydrate) $8fc928cd6c76f02e$var$vaporCustomElementHydrates.set(VaporCustomElement, _hydrate);
    return VaporCustomElement;
}
const $8fc928cd6c76f02e$export$105fe6a037adba94 = (options, extraOptions)=>{
    return /* @__PURE__ */ $8fc928cd6c76f02e$export$7dc92afc90cd43f8(options, extraOptions, $8fc928cd6c76f02e$export$291d13b1df8f2f86, $8fc928cd6c76f02e$var$withHydration);
};
var $8fc928cd6c76f02e$export$3ba6ba579e6b6c77 = class extends (0, $bmuEm.VueElementBase) {
    constructor(def, props = {}, createAppFn = $8fc928cd6c76f02e$export$ab21481d5d94015c){
        super(def, (0, $SdEQh.shallowReactive)(props), createAppFn);
    }
    _needsHydration() {
        const hydrate = $8fc928cd6c76f02e$var$vaporCustomElementHydrates.get(this.constructor);
        if (this.shadowRoot && hydrate) return true;
        return false;
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VaporElement";
        this._app = this._createApp(this._def);
        this._inheritParentContext();
        if (this._def.configureApp) this._def.configureApp(this._app);
        const hydrate = $8fc928cd6c76f02e$var$vaporCustomElementHydrates.get(this.constructor);
        if (this.shadowRoot && hydrate) hydrate(this._root, this._createComponent.bind(this));
        else this._createComponent();
        this._app.mount(this._root);
    }
    _update() {}
    _unmount() {
        if (this._app) this._app.unmount();
        if (this._instance && this._instance.ce) this._instance.ce = void 0;
        this._app = this._instance = null;
    }
    _createComponent() {
        const ce = (instance)=>{
            this._app._ceComponent = this._instance = instance;
            this._processInstance();
        };
        $8fc928cd6c76f02e$export$60e54eaca7e7fb38(this._def, this._props, this.shadowRoot ? void 0 : this._createSlots(), void 0, void 0, this._app._context, false, ce);
    }
    /**
	* Only called when shadowRoot is false. The light DOM children parsed on
	* connect become static slots, so `<slot/>` outlets render them in place
	* through the normal slot pipeline instead of a native outlet that has to
	* be replaced after mount.
	*/ _createSlots() {
        const parsed = this._slots;
        if (!parsed) return;
        const scopeId = this._def.__scopeId;
        let slots;
        for(const name in parsed){
            const nodes = parsed[name];
            if (scopeId) {
                const id = scopeId + "-s";
                for (const n of nodes)if (n.nodeType === 1) {
                    n.setAttribute(id, "");
                    const walker = document.createTreeWalker(n, 1);
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
            }
            (slots || (slots = {}))[name] = ()=>nodes;
        }
        return slots;
    }
};
//#endregion
//#region packages/runtime-vapor/src/dom/template.ts
let $8fc928cd6c76f02e$var$t;
function $8fc928cd6c76f02e$var$cloneTemplate(n) {
    const scopeIds = $8fc928cd6c76f02e$var$currentRenderContext.slotScopeIds;
    return scopeIds ? $8fc928cd6c76f02e$var$cloneStampedTemplate(n, scopeIds) : n.cloneNode(true);
}
/*@__NO_SIDE_EFFECTS__*/ function $8fc928cd6c76f02e$export$ce69bd05624d0c48(html, flags = 0, ns) {
    const root = !!(flags & 1);
    const isStatic = !!(flags & 2);
    let node;
    let adoptTarget;
    return ()=>{
        if ($8fc928cd6c76f02e$var$isHydrating$1) {
            if (!(html[0] === "<" && html[1] === "!")) $8fc928cd6c76f02e$var$resolvePendingSlotContent();
            let adopted = null;
            if (isStatic && !$8fc928cd6c76f02e$var$isComment($8fc928cd6c76f02e$var$currentHydrationNode, "")) {
                adopted = $8fc928cd6c76f02e$var$resolveHydrationTarget($8fc928cd6c76f02e$var$currentHydrationNode);
                if (html !== "") {
                    if (html[0] !== "<") {
                        if (!$8fc928cd6c76f02e$var$hydrateTextNode(adopted, html) && __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $8fc928cd6c76f02e$var$validateHydrationTarget(adopted, html);
                    } else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $8fc928cd6c76f02e$var$validateHydrationTarget(adopted, html);
                }
                if (!node) node = adopted.cloneNode(true);
                $8fc928cd6c76f02e$var$advanceHydrationNode(adopted);
            } else adopted = $8fc928cd6c76f02e$var$adoptTemplate($8fc928cd6c76f02e$var$currentHydrationNode, html, false, ns, adoptTarget || (adoptTarget = $8fc928cd6c76f02e$var$parseAdoptTarget(html)));
            if (root) adopted.$root = true;
            return adopted;
        }
        if (node) {
            const ret = $8fc928cd6c76f02e$var$cloneTemplate(node);
            if (root) ret.$root = true;
            return ret;
        }
        if (html[0] !== "<") return /* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a(html);
        $8fc928cd6c76f02e$var$t = $8fc928cd6c76f02e$var$t || document.createElement("template");
        if (ns) {
            const tag = ns === 1 ? "svg" : "math";
            $8fc928cd6c76f02e$var$t.innerHTML = `<${tag}>${html}</${tag}>`;
            node = /* @__PURE__ */ $8fc928cd6c76f02e$var$_child(/* @__PURE__ */ $8fc928cd6c76f02e$var$_child($8fc928cd6c76f02e$var$t.content));
        } else {
            $8fc928cd6c76f02e$var$t.innerHTML = html;
            node = /* @__PURE__ */ $8fc928cd6c76f02e$var$_child($8fc928cd6c76f02e$var$t.content);
        }
        const ret = $8fc928cd6c76f02e$var$cloneTemplate(node);
        if (root) ret.$root = true;
        return ret;
    };
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateIf.ts
function $8fc928cd6c76f02e$export$df9df05a8736ecf5(condition, b1, b2, flags = 1) {
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$resetInsertionState();
    let hydrationCursor = null;
    let branchShape;
    let anchor;
    let frag;
    if (flags & 16) {
        const ok = condition();
        let claim;
        if ($8fc928cd6c76f02e$var$isHydrating$1) {
            branchShape = $8fc928cd6c76f02e$var$decodeIfShape(flags, ok);
            claim = branchShape === 2 ? $8fc928cd6c76f02e$var$createFragmentClaim() : void 0;
            hydrationCursor = $8fc928cd6c76f02e$var$enterHydrationCursor(claim);
        }
        frag = ok ? b1() : b2 ? b2() : [
            $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a())
        ];
        if ($8fc928cd6c76f02e$var$isHydrating$1 && claim && claim.start) $8fc928cd6c76f02e$var$advanceHydrationNode($8fc928cd6c76f02e$var$locateEndAnchor(claim.start));
    } else {
        const index = flags >> 8;
        const keyed = index > 0;
        const keyBase = keyed ? (index - 1) * 2 : 0;
        const trackSlotBoundary = !!(flags & 128);
        const dynamicFragment = new $8fc928cd6c76f02e$export$2740cb41b6047c28(256, void 0, keyed, trackSlotBoundary, trackSlotBoundary ? ()=>{
            const anchor = dynamicFragment.anchor;
            const parent = anchor.parentNode;
            if (parent) $8fc928cd6c76f02e$var$removeNode(anchor, parent);
        } : void 0, _insertionAnchor);
        anchor = dynamicFragment.anchor;
        frag = dynamicFragment;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const ok = condition();
            if ($8fc928cd6c76f02e$var$isHydrating$1) {
                branchShape = $8fc928cd6c76f02e$var$decodeIfShape(flags, ok);
                dynamicFragment.hydrationClaim = branchShape === 2 ? $8fc928cd6c76f02e$var$createFragmentClaim() : void 0;
                hydrationCursor = $8fc928cd6c76f02e$var$enterHydrationCursor(dynamicFragment.hydrationClaim);
            }
            dynamicFragment.update(ok ? b1 : b2, keyed ? keyBase + (ok ? 0 : 1) : void 0, $8fc928cd6c76f02e$var$isNoScopeBranch(flags, ok));
        });
    }
    if ($8fc928cd6c76f02e$var$isHydrating$1 && branchShape === 0 && hydrationCursor) {
        const start = hydrationCursor.start;
        if (start && $8fc928cd6c76f02e$var$currentHydrationNode === start && $8fc928cd6c76f02e$var$isComment(start, "")) $8fc928cd6c76f02e$var$advanceHydrationNode(start);
    }
    $8fc928cd6c76f02e$var$finishBlockCreation(frag, anchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
}
function $8fc928cd6c76f02e$var$decodeIfShape(shape, ok) {
    return shape >> (ok ? 0 : 2) & 3;
}
function $8fc928cd6c76f02e$var$isNoScopeBranch(flags, ok) {
    return !!(flags & (ok ? 32 : 64));
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateFragment.ts
/**
* Create a dynamic fragment keyed by a reactive value for Vapor transitions.
* The fragment is re-rendered when the key changes to trigger enter/leave
* animations.
*
* Example:
* <VaporTransition>
*   <h1 :key="count">{{ count }}</h1>
* </VaporTransition>
*/ function $8fc928cd6c76f02e$export$1c7a187eacf2e9a(key, render, trackSlotBoundary = false) {
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$resetInsertionState();
    const hydrationCursor = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$captureHydrationCursor() : null;
    const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0, true, trackSlotBoundary, trackSlotBoundary ? ()=>{
        const parent = frag.anchor.parentNode;
        if (parent) $8fc928cd6c76f02e$var$removeNode(frag.anchor, parent);
    } : void 0, _insertionAnchor);
    if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>frag.update(render, key()));
    $8fc928cd6c76f02e$var$finishBlockCreation(frag, frag.anchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateFor.ts
const $8fc928cd6c76f02e$export$990ded969be008a7 = (src, renderItem, getKey, flags = 0)=>{
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    const _insertionIndex = $8fc928cd6c76f02e$var$insertionIndex;
    let hydrationCursor = null;
    let hydrationClaim;
    if ($8fc928cd6c76f02e$var$isHydrating$1) {
        hydrationClaim = $8fc928cd6c76f02e$var$createFragmentClaim();
        hydrationCursor = $8fc928cd6c76f02e$var$enterHydrationCursor(hydrationClaim);
    } else $8fc928cd6c76f02e$var$resetInsertionState();
    let isMounted = false;
    let oldBlocks = [];
    let newBlocks;
    let newKeys;
    let parent;
    let parentAnchor;
    let pendingHydrationAnchor = false;
    if (!$8fc928cd6c76f02e$var$isHydrating$1) {
        parentAnchor = $8fc928cd6c76f02e$var$resolveFragmentAnchor(_insertionAnchor, "for");
        if (parentAnchor === _insertionAnchor) parent = parentAnchor.parentNode;
    }
    const trackSlotBoundary = !!(flags & 32);
    const frag = new $8fc928cd6c76f02e$var$ForFragment(oldBlocks, trackSlotBoundary, trackSlotBoundary ? ()=>{
        const parent = parentAnchor.parentNode;
        if (parent) $8fc928cd6c76f02e$var$removeNode(parentAnchor, parent);
    } : void 0);
    const instance = (0, $3dLyd.currentInstance);
    const isComponent = !!(flags & 2);
    const canUseFastRemove = !!(flags & 1) && !isComponent;
    const isSingleNode = !!(flags & 8);
    const isFragment = !!(flags & 16);
    const wrappedRows = !!(flags & 64);
    const ctx = $8fc928cd6c76f02e$var$currentRenderContext;
    (0, $SdEQh.onScopeDispose)(()=>{
        $8fc928cd6c76f02e$var$stopBlockScopes(oldBlocks);
        if (newBlocks && newBlocks !== oldBlocks) $8fc928cd6c76f02e$var$stopBlockScopes(newBlocks);
        oldBlocks = [];
        newBlocks = [];
    }, true);
    const renderList = ()=>{
        const source = $8fc928cd6c76f02e$var$normalizeSource(src());
        const sourceKeys = source.keys;
        const newLength = source.values.length;
        const oldLength = oldBlocks.length;
        newBlocks = new Array(newLength);
        newKeys = void 0;
        if (getKey) {
            newKeys = new Array(newLength);
            for(let i = 0; i < newLength; i++){
                const value = $8fc928cd6c76f02e$var$getItemValue(source, i);
                newKeys[i] = sourceKeys ? getKey(value, sourceKeys[i], i) : getKey(value, i, void 0);
            }
        }
        const prevSub = (0, $SdEQh.setActiveSub)();
        const wasMounted = isMounted;
        if (wasMounted && frag.bu) for(let i = 0; i < frag.bu.length; i++)frag.bu[i]();
        if (!wasMounted) {
            isMounted = true;
            if ($8fc928cd6c76f02e$var$isHydrating$1) hydrateList(source, newLength);
            else mountAll(source, newLength);
        } else {
            parent = parentAnchor.parentNode;
            if (!oldLength) mountAll(source, newLength);
            else if (!newLength) {
                if (frag.resetListeners) for (const fn of frag.resetListeners)fn();
                const doRemove = !canUseFastRemove;
                for(let i = 0; i < oldLength; i++)unmount(oldBlocks[i], doRemove);
                if (canUseFastRemove) {
                    parent.textContent = "";
                    parent.appendChild(parentAnchor);
                }
            } else if (!getKey) {
                const commonLength = Math.min(newLength, oldLength);
                for(let i = 0; i < commonLength; i++)updateAt(newBlocks[i] = oldBlocks[i], source, i);
                for(let i = oldLength; i < newLength; i++)mount(source, i, parentAnchor);
                for(let i = newLength; i < oldLength; i++)unmount(oldBlocks[i]);
            } else {
                const commonLength = Math.min(oldLength, newLength);
                let endOffset = 0;
                while(endOffset < commonLength){
                    const index = newLength - endOffset - 1;
                    const key = newKeys[index];
                    const existingBlock = oldBlocks[oldLength - endOffset - 1];
                    if (existingBlock.key !== key) break;
                    updateAt(existingBlock, source, index);
                    newBlocks[index] = existingBlock;
                    endOffset++;
                }
                const e1 = commonLength - endOffset;
                const e2 = oldLength - endOffset;
                const e3 = newLength - endOffset;
                const queuedIndices = [];
                const oldKeyIndexMap = /* @__PURE__ */ new Map();
                for(let i = 0; i < e1; i++){
                    const currentKey = newKeys[i];
                    const oldBlock = oldBlocks[i];
                    if (oldBlock.key === currentKey) updateAt(newBlocks[i] = oldBlock, source, i);
                    else {
                        queuedIndices.push(i);
                        oldKeyIndexMap.set(oldBlock.key, i);
                    }
                }
                for(let i = e1; i < e2; i++)oldKeyIndexMap.set(oldBlocks[i].key, i);
                for(let i = e1; i < e3; i++)queuedIndices.push(i);
                let queuedLength = queuedIndices.length;
                let sources = (0, $7s0Ms.EMPTY_ARR);
                let mountCounter = 0;
                if (oldKeyIndexMap.size === 0) mountCounter = queuedLength;
                else {
                    sources = new Array(queuedLength);
                    for(let q = queuedLength - 1; q >= 0; q--){
                        const index = queuedIndices[q];
                        const key = newKeys[index];
                        const oldIndex = oldKeyIndexMap.get(key);
                        if (oldIndex !== void 0) {
                            oldKeyIndexMap.delete(key);
                            const reusedBlock = newBlocks[index] = oldBlocks[oldIndex];
                            updateAt(reusedBlock, source, index);
                            sources[q] = oldIndex + 1;
                        } else {
                            sources[q] = 0;
                            mountCounter++;
                        }
                    }
                }
                const useFastRemove = mountCounter === newLength;
                if (useFastRemove && frag.resetListeners) for (const fn of frag.resetListeners)fn();
                if (oldKeyIndexMap.size) for (const leftoverIndex of oldKeyIndexMap.values())unmount(oldBlocks[leftoverIndex], !(useFastRemove && canUseFastRemove));
                if (useFastRemove && canUseFastRemove) {
                    parent.textContent = "";
                    parent.appendChild(parentAnchor);
                }
                let sequence;
                const hasReuse = mountCounter !== queuedLength;
                if (hasReuse) {
                    sequence = $8fc928cd6c76f02e$var$planMoves(queuedIndices, sources, e2, e3);
                    queuedLength = queuedIndices.length;
                }
                const allKept = hasReuse && sequence === void 0;
                let sequenceEnd = sequence ? sequence.length - 1 : -1;
                let scanFrom = newLength;
                let cachedAnchor;
                for(let q = queuedLength - 1; q >= 0; q--){
                    const index = queuedIndices[q];
                    let isKept = allKept && sources[q] !== 0;
                    if (sequenceEnd >= 0 && sequence[sequenceEnd] === q) {
                        sequenceEnd--;
                        isKept = sources[q] !== 0;
                    }
                    if (isKept) continue;
                    let anchorNode;
                    for(let i = index + 1; i < scanFrom; i++){
                        const node = $8fc928cd6c76f02e$var$getBlockFirstNode(newBlocks[i].nodes);
                        if (node && node.parentNode === parent) {
                            anchorNode = node;
                            break;
                        }
                    }
                    if (anchorNode === void 0) {
                        if (cachedAnchor === void 0) cachedAnchor = parentAnchor;
                        anchorNode = cachedAnchor;
                    }
                    scanFrom = index + 1;
                    cachedAnchor = anchorNode;
                    const block = newBlocks[index];
                    if (block !== void 0) $8fc928cd6c76f02e$var$move(block.nodes, parent, anchorNode, 2);
                    else mount(source, index, anchorNode);
                }
            }
        }
        oldBlocks = newBlocks;
        frag.nodes = parentAnchor ? [
            newBlocks,
            parentAnchor
        ] : [
            newBlocks
        ];
        if (wasMounted && frag.u) for (const fn of frag.u)fn(frag.nodes);
        (0, $SdEQh.setActiveSub)(prevSub);
    };
    const needKey = renderItem.length > 1;
    const needIndex = renderItem.length > 2;
    const insertForBlock = isSingleNode ? (block, anchor)=>$8fc928cd6c76f02e$var$insertNode(block.nodes, parent, anchor) : isFragment ? (block, anchor)=>$8fc928cd6c76f02e$var$insertFragment(block.nodes, parent, anchor) : (block, anchor)=>$8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block.nodes, parent, anchor);
    const removeForBlock = isSingleNode ? (block)=>$8fc928cd6c76f02e$var$removeNode(block.nodes, parent) : isFragment ? (block)=>$8fc928cd6c76f02e$var$removeFragment(block.nodes, parent) : (block)=>$8fc928cd6c76f02e$export$cd7f480d6b8286c3(block.nodes, parent);
    const mount = (source, idx, anchor)=>{
        const keys = source.keys;
        const itemRef = (0, $SdEQh.shallowRef)($8fc928cd6c76f02e$var$getItemValue(source, idx));
        const keyRef = needKey ? (0, $SdEQh.shallowRef)(keys ? keys[idx] : idx) : void 0;
        const indexRef = needIndex ? (0, $SdEQh.shallowRef)(keys ? idx : void 0) : void 0;
        let nodes;
        const scope = new (0, $SdEQh.EffectScope)(true);
        const prevScope = (0, $SdEQh.setCurrentScope)(scope);
        let ok = false;
        try {
            nodes = renderItem(itemRef, keyRef, indexRef);
            ok = true;
        } finally{
            (0, $SdEQh.setCurrentScope)(prevScope);
            if (!ok) scope.stop();
        }
        const block = newBlocks[idx] = new $8fc928cd6c76f02e$var$ForBlock(nodes, scope, itemRef, keyRef, indexRef, newKeys ? newKeys[idx] : void 0);
        if ($8fc928cd6c76f02e$var$isTransitionEnabled && frag.$transition) {
            const hooks = frag.$transition;
            if (hooks.applyGroup) hooks.applyGroup(block, hooks.props, hooks.state, hooks.instance);
            else $8fc928cd6c76f02e$var$applyTransitionHooks(block.nodes, hooks);
        }
        const bm = frag.bm;
        if (bm) for(let i = 0; i < bm.length; i++)bm[i](block.nodes);
        if (parent) insertForBlock(block, anchor);
        return block;
    };
    const mountAll = (source, newLength)=>{
        for(let i = 0; i < newLength; i++)mount(source, i, parentAnchor);
    };
    const updateAt = (block, source, idx)=>{
        const keys = source.keys;
        update(block, $8fc928cd6c76f02e$var$getItemValue(source, idx), keys ? keys[idx] : idx, keys ? idx : void 0);
    };
    function hydrateList(source, newLength) {
        const hydrationStart = $8fc928cd6c76f02e$var$currentHydrationNode;
        const claim = hydrationClaim;
        let exitHydrationBoundary;
        const slotEndAnchor = $8fc928cd6c76f02e$var$getCurrentSlotEndAnchor();
        const slotFallbackRange = $8fc928cd6c76f02e$var$isPendingSlotContent() && slotEndAnchor;
        const reuseBoundaryClose = (close)=>{
            parentAnchor = $8fc928cd6c76f02e$var$claimAnchor(close);
            exitHydrationBoundary = $8fc928cd6c76f02e$var$enterHydrationBoundary(parentAnchor);
        };
        try {
            for(let i = 0; i < newLength; i++){
                const node = $8fc928cd6c76f02e$var$currentHydrationNode;
                let nextNode = null;
                if ($8fc928cd6c76f02e$var$isComment(node, "]")) nextNode = $8fc928cd6c76f02e$var$claimAnchor(node);
                else if (wrappedRows && $8fc928cd6c76f02e$var$isComment(node, "[")) {
                    nextNode = $8fc928cd6c76f02e$var$nextLogicalSibling(node);
                    $8fc928cd6c76f02e$var$setCurrentHydrationNode(node.nextSibling);
                }
                mount(source, i, parentAnchor);
                if (nextNode) $8fc928cd6c76f02e$var$setCurrentHydrationNode(nextNode);
            }
            if (claim.start) {
                reuseBoundaryClose($8fc928cd6c76f02e$var$locateClaimedEnd(claim.start));
                if (_insertionParent) {
                    const idx = _insertionAnchor ? _insertionAnchor.$idx : _insertionIndex || 0;
                    if (idx !== void 0) {
                        parentAnchor.$idx = idx;
                        _insertionParent.$llc = parentAnchor;
                    }
                }
            } else if (slotFallbackRange && !$8fc928cd6c76f02e$var$isValidSlot(newBlocks)) {
                const anchor = $8fc928cd6c76f02e$var$currentHydrationNode !== hydrationStart ? $8fc928cd6c76f02e$var$currentHydrationNode : hydrationStart !== slotEndAnchor ? hydrationStart.nextSibling : slotEndAnchor;
                parentAnchor = $8fc928cd6c76f02e$var$claimUntrackedAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
                const hydrationAnchor = parentAnchor;
                pendingHydrationAnchor = true;
                if ($8fc928cd6c76f02e$var$currentHydrationNode === hydrationStart || $8fc928cd6c76f02e$var$currentHydrationNode === slotEndAnchor) $8fc928cd6c76f02e$var$setCurrentHydrationNode(hydrationStart);
                const attachAnchor = ()=>{
                    const parentNode = anchor.parentNode;
                    if (parentNode) parentNode.insertBefore(hydrationAnchor, anchor);
                };
                if (!$8fc928cd6c76f02e$var$queuePendingSlotContentAnchor({
                    onContent: ()=>(0, $3dLyd.queuePostFlushCb)(attachAnchor),
                    onFallback: ()=>{}
                })) (0, $3dLyd.queuePostFlushCb)(attachAnchor);
            } else if ($8fc928cd6c76f02e$var$markerlessHydrationContainer) {
                const afterRows = $8fc928cd6c76f02e$var$currentHydrationNode;
                if (!newLength && afterRows && $8fc928cd6c76f02e$var$isComment(afterRows, "")) parentAnchor = $8fc928cd6c76f02e$var$claimAnchor(afterRows);
                else {
                    parentAnchor = $8fc928cd6c76f02e$var$claimAnchor(/* @__PURE__ */ $8fc928cd6c76f02e$export$b2ce9ad90858ed7a());
                    $8fc928cd6c76f02e$var$markerlessHydrationContainer.insertBefore(parentAnchor, afterRows && afterRows.parentNode === $8fc928cd6c76f02e$var$markerlessHydrationContainer ? afterRows : null);
                    pendingHydrationAnchor = true;
                }
            } else {
                const close = $8fc928cd6c76f02e$var$currentHydrationNode;
                reuseBoundaryClose(close);
            }
        } finally{
            exitHydrationBoundary && exitHydrationBoundary();
        }
    }
    const update = ({ itemRef: itemRef, keyRef: keyRef, indexRef: indexRef }, newItem, newKey, newIndex)=>{
        if (newItem !== itemRef.value) itemRef.value = newItem;
        if (keyRef && newKey !== void 0 && newKey !== keyRef.value) keyRef.value = newKey;
        if (indexRef && newIndex !== indexRef.value) indexRef.value = newIndex;
    };
    const unmount = (block, doRemove = true)=>{
        if (!isComponent) block.scope.stop();
        if (doRemove) removeForBlock(block);
        else if ($8fc928cd6c76f02e$var$isInteropEnabled) $8fc928cd6c76f02e$var$unmountVDOM(block);
        if (isComponent) block.scope.stop();
    };
    if (flags & 4) renderList();
    else $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        if (!isMounted) return renderList();
        $8fc928cd6c76f02e$var$withRenderContext(ctx, renderList);
    });
    if ($8fc928cd6c76f02e$var$isHydrating$1 && !pendingHydrationAnchor && $8fc928cd6c76f02e$var$currentHydrationNode === parentAnchor) $8fc928cd6c76f02e$var$advanceHydrationNode(parentAnchor);
    $8fc928cd6c76f02e$var$finishBlockCreation(frag, parentAnchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
};
/**
* Builds a key-indexed selector that activates only the opers registered with
* the key matching the current source value. Compared to letting each item
* subscribe directly, this keeps re-renders on source change O(2) instead of
* O(N) (only previous and new active item re-run).
*
* Selector cleanup follows the current scope. Per-item teardown is auto-wired
* via `onScopeDispose` so callers (typically v-for item scopes) don't need
* explicit deregistration. For bulk-reset hot paths, attach the selector to
* the v-for via `frag.onReset(selector.reset)` to skip the per-item Map ops.
*/ function $8fc928cd6c76f02e$export$595d22ed68ca2841(source) {
    const operMap = /* @__PURE__ */ new Map();
    let activeKey = source();
    let activeOpers;
    let pendingKey = activeKey;
    let pending = false;
    let generation = 0;
    (0, $SdEQh.watch)(source, (newValue)=>{
        pendingKey = newValue;
        if (pending) return;
        pending = true;
        if (activeOpers !== void 0) for (const oper of activeOpers)oper();
        (0, $3dLyd.queuePostFlushCb)(()=>{
            pending = false;
            activeKey = pendingKey;
            activeOpers = operMap.get(activeKey);
            if (activeOpers !== void 0) for (const oper of activeOpers)oper();
        });
    });
    const register = (key, oper)=>{
        oper();
        let opers = operMap.get(key);
        if (opers !== void 0) opers.push(oper);
        else {
            opers = [
                oper
            ];
            operMap.set(key, opers);
            if (key === activeKey) activeOpers = opers;
        }
        const myGen = generation;
        (0, $SdEQh.onScopeDispose)(()=>{
            if (myGen !== generation) return;
            const list = operMap.get(key);
            if (list === void 0) return;
            if (list.length === 1) {
                operMap.delete(key);
                if (key === activeKey) activeOpers = void 0;
            } else {
                const idx = list.indexOf(oper);
                if (idx !== -1) list.splice(idx, 1);
            }
        }, true);
    };
    register.reset = ()=>{
        operMap.clear();
        activeOpers = void 0;
        generation++;
    };
    return register;
}
/**
* Decides which reused blocks may stay where they are: the longest increasing
* subsequence of their old indices is already in relative order, so only the
* blocks outside it need a DOM move. Returns that subsequence as indices into
* `sources`, or `undefined` when no reused block has to move at all.
*
* Two planners, picked by how dense the change is across the range it touches:
*
* - dense (the queued indices cover at least half of the range they span):
*   pull the in-place matches in that range into the plan too and run an
*   unbounded LIS, which is move-count minimal like vdom's. The range is at
*   most `2 * queuedIndices.length` wide here, so this stays O(queued).
* - sparse (a couple of rows moved across an otherwise untouched list, e.g. a
*   far swap): keep the in-place matches pinned, which costs nothing but
*   bounds each segment's LIS by its stationary neighbours. Not minimal in
*   general, but it never walks the untouched majority.
*
* Both arrays are expanded in place on the dense path.
*/ function $8fc928cd6c76f02e$var$planMoves(queuedIndices, sources, e2, e3) {
    let queuedLength = queuedIndices.length;
    const denseLength = e3 - queuedIndices[0];
    const isDense = queuedLength * 2 >= denseLength;
    let moved = false;
    let maxSource = 0;
    if (isDense) {
        let read = queuedLength - 1;
        queuedIndices.length = sources.length = denseLength;
        for(let write = denseLength - 1, index = e3 - 1; write >= 0; write--, index--){
            if (read >= 0 && queuedIndices[read] === index) sources[write] = sources[read--];
            else sources[write] = index + 1;
            queuedIndices[write] = index;
        }
        queuedLength = denseLength;
        for(let q = 0; q < queuedLength; q++){
            const value = sources[q];
            if (value !== 0) {
                if (value < maxSource) moved = true;
                else maxSource = value;
            }
        }
    } else {
        let seg = 0;
        while(seg < queuedLength){
            let segEnd = seg;
            while(segEnd + 1 < queuedLength && queuedIndices[segEnd + 1] === queuedIndices[segEnd] + 1)segEnd++;
            const lowerBound = queuedIndices[seg] - 1;
            const nextIndex = queuedIndices[segEnd] + 1;
            const upperBound = nextIndex < e3 ? nextIndex : e2;
            for(let q = seg; q <= segEnd; q++){
                const value = sources[q];
                const oldIndex = value - 1;
                if (oldIndex <= lowerBound || oldIndex >= upperBound) sources[q] = 0;
                else if (value < maxSource) moved = true;
                else maxSource = value;
            }
            seg = segEnd + 1;
        }
    }
    return moved ? (0, $7s0Ms.getSequence)(sources) : void 0;
}
function $8fc928cd6c76f02e$var$stopBlockScopes(blocks) {
    for(let i = 0; i < blocks.length; i++){
        const block = blocks[i];
        if (block) {
            const scope = block.scope;
            if (scope) scope.stop();
        }
    }
}
function $8fc928cd6c76f02e$var$isSameMapKey(a, b) {
    return Object.is(a, b) || a === 0 && b === 0;
}
function $8fc928cd6c76f02e$export$1c04d4cb91c5864f(rawSource, renderSlot, getName, getKey) {
    let oldRecords = [];
    const needKey = renderSlot.length > 1;
    const needIndex = renderSlot.length > 2;
    const update = (record, [item, key, index])=>{
        if (!Object.is(record.itemRef.value, item)) record.itemRef.value = item;
        if (record.keyRef && !Object.is(record.keyRef.value, key)) record.keyRef.value = key;
        if (record.indexRef && !Object.is(record.indexRef.value, index)) record.indexRef.value = index;
    };
    return ()=>{
        const source = $8fc928cd6c76f02e$var$normalizeSource(rawSource());
        const sourceLength = source.values.length;
        const names = new Array(sourceLength);
        const identities = getKey ? new Array(sourceLength) : names;
        const items = new Array(sourceLength);
        let sameResolution = sourceLength === oldRecords.length;
        for(let i = 0; i < sourceLength; i++){
            const item = items[i] = $8fc928cd6c76f02e$var$getItem(source, i);
            const name = names[i] = String(getName(...item));
            const identity = identities[i] = getKey ? getKey(...item) : name;
            if (sameResolution && (!$8fc928cd6c76f02e$var$isSameMapKey(oldRecords[i].rawIdentity, identity) || oldRecords[i].name !== name)) sameResolution = false;
        }
        if (sameResolution) {
            const prevSub = (0, $SdEQh.setActiveSub)();
            for(let i = sourceLength - 1; i >= 0; i--)update(oldRecords[i], items[i]);
            (0, $SdEQh.setActiveSub)(prevSub);
            return oldRecords;
        }
        const oldByIdentity = /* @__PURE__ */ new Map();
        for(let i = 0; i < oldRecords.length; i++)oldByIdentity.set(oldRecords[i].rawIdentity, oldRecords[i]);
        const records = new Array(sourceLength);
        const prevSub = (0, $SdEQh.setActiveSub)();
        for(let i = sourceLength - 1; i >= 0; i--){
            const slotItem = items[i];
            const rawIdentity = identities[i];
            let record = oldByIdentity.get(rawIdentity);
            if (record) {
                oldByIdentity.delete(rawIdentity);
                update(record, slotItem);
                record.name = names[i];
            } else {
                const [item, key, index] = slotItem;
                const itemRef = (0, $SdEQh.shallowRef)(item);
                const keyRef = needKey ? (0, $SdEQh.shallowRef)(key) : void 0;
                const indexRef = needIndex ? (0, $SdEQh.shallowRef)(index) : void 0;
                record = {
                    rawIdentity: rawIdentity,
                    itemRef: itemRef,
                    keyRef: keyRef,
                    indexRef: indexRef,
                    name: names[i],
                    fn: renderSlot(itemRef, keyRef, indexRef),
                    key: itemRef
                };
            }
            records[i] = record;
        }
        (0, $SdEQh.setActiveSub)(prevSub);
        oldRecords = records;
        return records;
    };
}
function $8fc928cd6c76f02e$var$normalizeSource(source) {
    let values = source;
    let needsWrap = false;
    let isReadonlySource = false;
    let keys;
    if ((0, $7s0Ms.isArray)(source)) {
        if ((0, $SdEQh.isReactive)(source)) {
            needsWrap = !(0, $SdEQh.isShallow)(source);
            values = (0, $SdEQh.shallowReadArray)(source);
            isReadonlySource = (0, $SdEQh.isReadonly)(source);
        }
    } else if ((0, $7s0Ms.isString)(source)) values = source.split("");
    else if (typeof source === "number") {
        values = new Array(source);
        for(let i = 0; i < source; i++)values[i] = i + 1;
    } else if ((0, $7s0Ms.isObject)(source)) {
        if (source[Symbol.iterator]) values = Array.from(source);
        else {
            keys = Object.keys(source);
            values = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++)values[i] = source[keys[i]];
        }
    } else values = [];
    return {
        values: values,
        needsWrap: needsWrap,
        isReadonlySource: isReadonlySource,
        keys: keys
    };
}
function $8fc928cd6c76f02e$var$getItemValue({ values: values, needsWrap: needsWrap, isReadonlySource: isReadonlySource }, idx) {
    return needsWrap ? isReadonlySource ? (0, $SdEQh.toReadonly)((0, $SdEQh.toReactive)(values[idx])) : (0, $SdEQh.toReactive)(values[idx]) : values[idx];
}
function $8fc928cd6c76f02e$var$getItem(source, idx) {
    const value = $8fc928cd6c76f02e$var$getItemValue(source, idx);
    if (source.keys) return [
        value,
        source.keys[idx],
        idx
    ];
    else return [
        value,
        idx,
        void 0
    ];
}
function $8fc928cd6c76f02e$export$f22e14c83846d2c6(val, keys) {
    const res = {};
    for (const key of Object.keys(val))if (!keys.includes(key)) res[key] = val[key];
    return res;
}
function $8fc928cd6c76f02e$export$9f15c5f175f17548(val, getDefaultVal) {
    return val === void 0 ? getDefaultVal() : val;
}
//#endregion
//#region packages/runtime-vapor/src/apiTemplateRef.ts
function $8fc928cd6c76f02e$var$getTemplateRefUpdateFragment(el) {
    if ($8fc928cd6c76f02e$var$isDynamicFragment(el)) return el;
    if ($8fc928cd6c76f02e$var$isAsyncComponentEnabled && $8fc928cd6c76f02e$export$f43892e053afd2a0(el) && (0, $3dLyd.isAsyncWrapper)(el)) return el.block;
}
/**
* Async/dynamic component targets swap their inner block on update, so the ref
* has to be re-applied after the fragment settles. Registration is idempotent
* per (el, owner) pair: `getTemplateRefUpdateFragment` reads the async
* wrapper's mutable `block`, so the resolved fragment is compared by identity
* rather than with a "registered once" flag.
*/ function $8fc928cd6c76f02e$var$registerFragmentRefUpdate(el, registeredFrag, reapply) {
    const frag = $8fc928cd6c76f02e$var$getTemplateRefUpdateFragment(el);
    if (frag && registeredFrag !== frag) {
        (frag.u || (frag.u = [])).push(()=>{
            if ($8fc928cd6c76f02e$export$f43892e053afd2a0(el) && el.isDeactivated) return;
            reapply();
        });
        return frag;
    }
    return registeredFrag;
}
function $8fc928cd6c76f02e$var$ensureCleanup(el) {
    let cleanupRef = $8fc928cd6c76f02e$var$refCleanups.get(el);
    if (!cleanupRef) {
        $8fc928cd6c76f02e$var$refCleanups.set(el, cleanupRef = {
            fn: (0, $7s0Ms.NOOP)
        });
        (0, $SdEQh.onScopeDispose)(()=>{
            $8fc928cd6c76f02e$var$invalidatePendingRef(el);
            cleanupRef.fn();
            $8fc928cd6c76f02e$var$refCleanups.delete(el);
        });
    }
    return cleanupRef;
}
function $8fc928cd6c76f02e$export$f3f2dfaab714a7e8() {
    const instance = $8fc928cd6c76f02e$var$getScopeOwner();
    const stateMap = /* @__PURE__ */ new WeakMap();
    return (el, ref, refFor, refKey)=>{
        let state = stateMap.get(el);
        if (!state) stateMap.set(el, state = {
            ref: ref,
            suspense: $8fc928cd6c76f02e$var$currentRenderContext.suspense
        });
        $8fc928cd6c76f02e$var$setTemplateRefWithState(instance, el, state, ref, refFor, refKey);
    };
}
function $8fc928cd6c76f02e$var$setTemplateRefWithState(instance, el, state, ref, refFor, refKey) {
    state.ref = ref;
    state.refFor = refFor;
    state.refKey = refKey;
    state.registeredFrag = $8fc928cd6c76f02e$var$registerFragmentRefUpdate(el, state.registeredFrag, ()=>{
        $8fc928cd6c76f02e$var$setRef$1(instance, state.suspense, el, state.ref, state.oldRef, state.refFor, state.refKey, state.oldRefKey);
        state.oldRef = state.ref;
        state.oldRefKey = state.ref != null ? state.refKey : void 0;
    });
    $8fc928cd6c76f02e$var$setRef$1(instance, state.suspense, el, ref, state.oldRef, refFor, refKey, state.oldRefKey);
    state.oldRef = ref;
    state.oldRefKey = ref != null ? refKey : void 0;
}
/**
* Static refs never change value, so they need no old-ref tracking and no
* per-element state - only the fragment re-apply hook shared with the
* stateful path.
*/ function $8fc928cd6c76f02e$export$902da257a3c86fce(el, ref, refFor, refKey) {
    const instance = $8fc928cd6c76f02e$var$getScopeOwner();
    const suspense = $8fc928cd6c76f02e$var$currentRenderContext.suspense;
    $8fc928cd6c76f02e$var$setRef$1(instance, suspense, el, ref, void 0, refFor, refKey);
    $8fc928cd6c76f02e$var$registerFragmentRefUpdate(el, void 0, ()=>{
        $8fc928cd6c76f02e$var$setRef$1(instance, suspense, el, ref, ref, refFor, refKey);
    });
}
function $8fc928cd6c76f02e$export$131d6b7239ae7b36(el, getter, refFor, refKey) {
    const instance = $8fc928cd6c76f02e$var$getScopeOwner();
    let state;
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        const ref = getter();
        if (!state) state = {
            ref: ref,
            suspense: $8fc928cd6c76f02e$var$currentRenderContext.suspense
        };
        $8fc928cd6c76f02e$var$setTemplateRefWithState(instance, el, state, ref, refFor, refKey);
    });
}
/**
* Function for handling a template ref
*/ function $8fc928cd6c76f02e$var$setRef$1(instance, suspense, el, ref, oldRef, refFor = false, refKey, oldRefKey) {
    if (!instance || instance.isUnmounted) return;
    const setupState = null;
    const refValue = $8fc928cd6c76f02e$var$getRefValue(el);
    if ($8fc928cd6c76f02e$var$isInteropEnabled) {
        const target = $8fc928cd6c76f02e$export$9522e17588c12572(el) && el.setRef ? el : refValue && $8fc928cd6c76f02e$export$9522e17588c12572(refValue) && refValue.setRef ? refValue : null;
        if (target) {
            target.setRef(instance, ref, refFor, refKey);
            return;
        }
    }
    const refs = instance.refs === (0, $7s0Ms.EMPTY_OBJ) ? instance.refs = {} : instance.refs;
    const canSetSetupRef = (0, $7s0Ms.NO);
    const canSetRef = (ref, key)=>{
        if (key && (0, $3dLyd.isTemplateRefKey)(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $8fc928cd6c76f02e$var$invalidatePendingRef(el);
        if ((0, $7s0Ms.isString)(oldRef)) refs[oldRef] = null;
        else if ((0, $SdEQh.isRef)(oldRef)) {
            if (canSetRef(oldRef, oldRefKey)) oldRef.value = null;
            if (oldRefKey) refs[oldRefKey] = null;
        } else if ((0, $7s0Ms.isFunction)(oldRef) && $8fc928cd6c76f02e$var$isDynamicFragment(el)) (0, $3dLyd.callWithErrorHandling)(oldRef, instance, 12, [
            null,
            refs
        ]);
    } else if (oldRef != null && $8fc928cd6c76f02e$var$isDynamicFragment(el)) {
        if ((0, $7s0Ms.isFunction)(oldRef)) (0, $3dLyd.callWithErrorHandling)(oldRef, instance, 12, [
            null,
            refs
        ]);
        else if (refFor) $8fc928cd6c76f02e$var$unsetRef(el);
    }
    if (ref == null) return;
    if ((0, $7s0Ms.isFunction)(ref)) {
        const invokeRefSetter = (value)=>{
            (0, $3dLyd.callWithErrorHandling)(ref, instance, 12, [
                value,
                refs
            ]);
        };
        invokeRefSetter(refValue);
        $8fc928cd6c76f02e$var$ensureCleanup(el).fn = ()=>invokeRefSetter(null);
    } else {
        const _isString = (0, $7s0Ms.isString)(ref);
        const _isRef = (0, $SdEQh.isRef)(ref);
        let existing;
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (refFor) {
                    if (refValue == null) return;
                    existing = _isString ? (0, refs[ref]) : canSetRef(ref) || !refKey ? ref.value : refs[refKey];
                    if (!(0, $7s0Ms.isArray)(existing)) {
                        existing = [
                            refValue
                        ];
                        if (_isString) refs[ref] = existing;
                        else {
                            if (canSetRef(ref, refKey)) ref.value = existing;
                            if (refKey) refs[refKey] = existing;
                        }
                    } else if (!existing.includes(refValue)) existing.push(refValue);
                } else if (_isString) refs[ref] = refValue;
                else if (_isRef) {
                    if (canSetRef(ref, refKey)) ref.value = refValue;
                    if (refKey) refs[refKey] = refValue;
                }
            };
            const cleanup = $8fc928cd6c76f02e$var$ensureCleanup(el);
            cleanup.fn = ()=>{
                if (refFor) {
                    if ((0, $7s0Ms.isArray)(existing)) (0, $7s0Ms.remove)(existing, refValue);
                } else if (_isString) refs[ref] = null;
                else if (_isRef) {
                    if (canSetRef(ref, refKey)) ref.value = null;
                    if (refKey) refs[refKey] = null;
                }
            };
            $8fc928cd6c76f02e$var$invalidatePendingRef(el);
            if (refValue != null) {
                const job = ()=>{
                    doSet();
                    if (cleanup.job === job) cleanup.job = void 0;
                };
                cleanup.job = job;
                (0, $3dLyd.queuePostRenderEffect)(job, -1, suspense);
            } else doSet();
        }
    }
}
const $8fc928cd6c76f02e$var$getRefValue = (el)=>{
    if ($8fc928cd6c76f02e$export$f43892e053afd2a0(el)) {
        if ($8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(el)) {
            const inner = $8fc928cd6c76f02e$var$getAsyncWrapperInner(el);
            if (inner === void 0) return null;
            return $8fc928cd6c76f02e$var$getRefValue(inner);
        }
        return $8fc928cd6c76f02e$var$getExposed(el) || el;
    } else if ($8fc928cd6c76f02e$var$isTeleportEnabled && $8fc928cd6c76f02e$var$isTeleportFragment(el)) return null;
    else if ($8fc928cd6c76f02e$var$isDynamicFragment(el)) {
        if ((0, $7s0Ms.isArray)(el.nodes)) return null;
        return $8fc928cd6c76f02e$var$getRefValue(el.nodes);
    }
    return el;
};
//#endregion
//#region packages/runtime-vapor/src/apiCreateDynamicComponent.ts
function $8fc928cd6c76f02e$export$dd39299cb479bb8a(getter, rawProps, rawSlots, flags = 0, key) {
    const isSingleRoot = !!(flags & 1);
    const once = !!(flags & 2);
    const slotRoot = !!(flags & 4);
    const ns = flags & 8 ? 1 : flags & 16 ? 2 : void 0;
    const _insertionParent = $8fc928cd6c76f02e$var$insertionParent;
    const _insertionAnchor = $8fc928cd6c76f02e$var$insertionAnchor;
    if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$resetInsertionState();
    const normalizedRawSlots = $8fc928cd6c76f02e$var$normalizeRawSlots(rawSlots);
    const scopeOwner = $8fc928cd6c76f02e$var$getScopeOwner();
    const render = (value, resolved, appContext)=>{
        if ($8fc928cd6c76f02e$var$isBlock(value)) return value;
        if ($8fc928cd6c76f02e$var$isInteropEnabled && appContext.vdom && (0, $3dLyd.isVNode)(value)) return appContext.vdom.mountVNode(value, (0, $3dLyd.currentInstance), isSingleRoot);
        return $8fc928cd6c76f02e$export$8b456629be3b9f98(resolved, rawProps, normalizedRawSlots, isSingleRoot, once, ns, appContext);
    };
    if (once) {
        const hydrationCursor = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$enterHydrationCursor() : null;
        const value = getter();
        const appContext = $8fc928cd6c76f02e$var$getAppContext();
        const block = render(value, $8fc928cd6c76f02e$var$resolveValue(value, appContext, scopeOwner), appContext);
        $8fc928cd6c76f02e$var$finishBlockCreation(block, void 0, hydrationCursor, _insertionParent, _insertionAnchor);
        return block;
    }
    const hydrationCursor = $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$captureHydrationCursor() : null;
    const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0, false, slotRoot, slotRoot ? ()=>{
        const nodes = frag.nodes;
        if (nodes instanceof Node) {
            const parent = nodes.parentNode;
            if (parent) $8fc928cd6c76f02e$var$removeNode(nodes, parent);
        }
        const anchorParent = frag.anchor.parentNode;
        if (anchorParent) $8fc928cd6c76f02e$var$removeNode(frag.anchor, anchorParent);
    } : void 0, _insertionAnchor);
    if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
    let lastKey;
    let lastResolved;
    let branchToken;
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        const value = getter();
        const userKey = key ? key() : void 0;
        const appContext = $8fc928cd6c76f02e$var$getAppContext();
        const resolved = $8fc928cd6c76f02e$var$resolveValue(value, appContext, scopeOwner);
        if (resolved === (0, $3dLyd.NULL_DYNAMIC_COMPONENT)) {
            frag.update(void 0, resolved);
            return;
        }
        let branchKey = resolved;
        if (key) {
            if (userKey !== lastKey || resolved !== lastResolved) {
                lastKey = userKey;
                lastResolved = resolved;
                branchToken = {};
            }
            branchKey = branchToken;
        }
        if (branchKey === frag.current && !$8fc928cd6c76f02e$var$isHydrating$1) return;
        frag.update(()=>render(value, resolved, appContext), branchKey, false, userKey);
    });
    $8fc928cd6c76f02e$var$finishBlockCreation(frag, frag.anchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
}
function $8fc928cd6c76f02e$var$getAppContext() {
    return (0, $3dLyd.currentInstance) && (0, $3dLyd.currentInstance).appContext || $8fc928cd6c76f02e$var$emptyContext;
}
function $8fc928cd6c76f02e$var$resolveValue(value, appContext, scopeOwner) {
    if ($8fc928cd6c76f02e$var$isBlock(value) || $8fc928cd6c76f02e$var$isInteropEnabled && appContext.vdom && (0, $3dLyd.isVNode)(value)) return value;
    const resolved = $8fc928cd6c76f02e$var$withScopeOwner(scopeOwner, ()=>(0, $3dLyd.resolveDynamicComponent)(value));
    const type = typeof resolved;
    if (!resolved || type !== "string" && type !== "object" && type !== "function" && type !== "symbol") return 0, $3dLyd.NULL_DYNAMIC_COMPONENT;
    return resolved;
}
function $8fc928cd6c76f02e$var$withScopeOwner(owner, fn) {
    const prev = (0, $3dLyd.setCurrentRenderingInstance)(owner);
    try {
        return fn();
    } finally{
        (0, $3dLyd.setCurrentRenderingInstance)(prev);
    }
}
//#endregion
//#region packages/runtime-vapor/src/directives/vShow.ts
/**
* v-show is root-inherited state: it lands on the effective root element of
* `target`, and any producer on the root chain (dynamic fragment branch,
* interop subtree, pending async setup) can replace that root later. `apply`
* resolves the root through the shared chain walker and registers itself on
* every producer it passes, so a replacement root re-enters `apply` and
* registers the producers inside it in turn.
*/ function $8fc928cd6c76f02e$export$ef682a92d74a99d4(target, source) {
    let value;
    let transition;
    let unresolved = false;
    let slotRoot = false;
    const visitor = {
        onComponent (instance) {
            if ($8fc928cd6c76f02e$var$isSuspenseEnabled && instance.asyncDep && !instance.asyncResolved) {
                if (!instance.$vshow) (instance.bm || (instance.bm = [])).push(()=>apply(instance.block));
                unresolved = true;
                $8fc928cd6c76f02e$var$mark(instance);
                return true;
            }
            $8fc928cd6c76f02e$var$mark(instance);
        },
        onDynamicFragment (frag) {
            if ($8fc928cd6c76f02e$var$isSlotOutletFragment(frag)) return slotRoot = true;
            $8fc928cd6c76f02e$var$mark(frag);
            $8fc928cd6c76f02e$var$register(frag.bm || (frag.bm = []), apply);
        }
    };
    if ($8fc928cd6c76f02e$var$isInteropEnabled) visitor.onInteropFragment = (frag)=>{
        if ($8fc928cd6c76f02e$var$isSlotOutletFragment(frag)) return slotRoot = true;
        $8fc928cd6c76f02e$var$mark(frag);
        if ($8fc928cd6c76f02e$var$isTransitionEnabled && frag.$transition) transition = frag.$transition;
        $8fc928cd6c76f02e$var$register(frag.u || (frag.u = []), apply);
        if (!$8fc928cd6c76f02e$var$isValidBlock(frag.nodes)) unresolved = true;
    };
    const apply = (nodes)=>{
        transition = void 0;
        unresolved = slotRoot = false;
        const root = $8fc928cd6c76f02e$var$getRootElement(nodes, visitor);
        if (root) $8fc928cd6c76f02e$var$setDisplay(root, value, transition);
    };
    $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
        value = source();
        apply(target);
    });
}
function $8fc928cd6c76f02e$var$mark(block) {
    block.$vshow = true;
}
function $8fc928cd6c76f02e$var$register(hooks, hook) {
    if (!hooks.includes(hook)) hooks.push(hook);
}
function $8fc928cd6c76f02e$var$setDisplay(el, value, transition) {
    const hidden = !value;
    if (!((0, $bmuEm.vShowOriginalDisplay) in el)) {
        $8fc928cd6c76f02e$var$mark(el);
        el[0, $bmuEm.vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        el[0, $bmuEm.vShowHidden] = hidden;
        $8fc928cd6c76f02e$var$writeDisplay(el, value);
        return;
    }
    if (el[0, $bmuEm.vShowHidden] === hidden) return;
    el[0, $bmuEm.vShowHidden] = hidden;
    const $transition = $8fc928cd6c76f02e$var$isTransitionEnabled ? el.$transition || transition : void 0;
    if ($transition) {
        const prevSub = (0, $SdEQh.setActiveSub)();
        try {
            if (value) {
                $transition.beforeEnter(el);
                el.style.display = el[0, $bmuEm.vShowOriginalDisplay];
                $transition.enter(el);
            } else if (el.isConnected) $transition.leave(el, ()=>{
                el.style.display = "none";
            });
            else el.style.display = "none";
        } finally{
            (0, $SdEQh.setActiveSub)(prevSub);
        }
    } else $8fc928cd6c76f02e$var$writeDisplay(el, value);
}
function $8fc928cd6c76f02e$var$writeDisplay(el, value) {
    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $8fc928cd6c76f02e$var$isHydrating$1) {
        const hidden = el.style.display === "none";
        if (!value === hidden) return;
        const expected = value ? el[0, $bmuEm.vShowOriginalDisplay] : "none";
        if ((0, $3dLyd.warnPropMismatch)(el, "style", 3, `display: ${el.style.display}`, expected ? `display: ${expected}` : false)) (0, $3dLyd.logMismatchError)();
    }
    el.style.display = value ? el[0, $bmuEm.vShowOriginalDisplay] : "none";
}
//#endregion
//#region packages/runtime-vapor/src/directives/vModel.ts
function $8fc928cd6c76f02e$var$ensureMounted(cb) {
    if ((0, $3dLyd.currentInstance).isMounted) cb();
    else (0, $3dLyd.onMounted)($8fc928cd6c76f02e$var$inOnce ? ()=>$8fc928cd6c76f02e$export$81831a240bcfd22e(cb) : cb);
}
const $8fc928cd6c76f02e$export$3ae7eb13ae2ede6d = (el, get, set, { trim: trim, number: number, lazy: lazy } = {})=>{
    (0, $bmuEm.vModelTextInit)(el, trim, number, lazy, set);
    $8fc928cd6c76f02e$var$ensureMounted(()=>{
        let value;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            (0, $bmuEm.vModelTextUpdate)(el, value, value = get(), trim, number, lazy);
        });
    });
};
const $8fc928cd6c76f02e$export$7ef78625cdf299a8 = (el, get, set)=>{
    (0, $bmuEm.vModelCheckboxInit)(el, set);
    $8fc928cd6c76f02e$var$ensureMounted(()=>{
        let value;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            (0, $bmuEm.vModelCheckboxUpdate)(el, value, (0, $SdEQh.traverse)(value = get()));
        });
    });
};
const $8fc928cd6c76f02e$export$487f8d7ffa92a3d1 = (el, get, set)=>{
    el.addEventListener("change", ()=>set((0, $bmuEm.vModelGetValue)(el)));
    $8fc928cd6c76f02e$var$ensureMounted(()=>{
        let value;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            if (value !== (value = get())) el.checked = (0, $7s0Ms.looseEqual)(value, (0, $bmuEm.vModelGetValue)(el));
        });
    });
};
const $8fc928cd6c76f02e$export$51f70f5febddf4c = (el, get, set, modifiers)=>{
    (0, $bmuEm.vModelSelectInit)(el, get(), modifiers && modifiers.number, set);
    $8fc928cd6c76f02e$var$ensureMounted(()=>{
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>(0, $bmuEm.vModelSetSelected)(el, (0, $SdEQh.traverse)(get())));
    });
};
const $8fc928cd6c76f02e$export$b751fd10f5ef748d = (el, get, set, modifiers)=>{
    let apply = $8fc928cd6c76f02e$export$3ae7eb13ae2ede6d;
    if (el.tagName === "SELECT") apply = $8fc928cd6c76f02e$export$51f70f5febddf4c;
    else if (el.tagName === "TEXTAREA") apply = $8fc928cd6c76f02e$export$3ae7eb13ae2ede6d;
    else if (el.type === "checkbox") apply = $8fc928cd6c76f02e$export$7ef78625cdf299a8;
    else if (el.type === "radio") apply = $8fc928cd6c76f02e$export$487f8d7ffa92a3d1;
    apply(el, get, set, modifiers);
};
//#endregion
//#region packages/runtime-vapor/src/directives/custom.ts
function $8fc928cd6c76f02e$export$66a5d204b19d8abb(node, dirs) {
    if (node instanceof Element) {
        $8fc928cd6c76f02e$var$applyDirectivesToElement(node, dirs, (0, $3dLyd.currentInstance));
        return;
    }
    const instance = (0, $3dLyd.currentInstance);
    const once = $8fc928cd6c76f02e$var$inOnce;
    let currentElement = null;
    let directiveScope;
    let disposed = false;
    let pending = false;
    let pendingSetups;
    const visitor = {
        onDynamicFragment: track,
        onComponent (block) {
            if ($8fc928cd6c76f02e$var$isSuspenseEnabled && block.asyncDep && !block.asyncResolved) {
                pending = true;
                if (!(pendingSetups || (pendingSetups = /* @__PURE__ */ new WeakSet())).has(block)) {
                    pendingSetups.add(block);
                    (0, $3dLyd.onBeforeMount)(applyDirectives, block);
                }
                return true;
            }
            if ($8fc928cd6c76f02e$var$isAsyncComponentEnabled && (0, $3dLyd.isAsyncWrapper)(block)) {
                const inner = block.block;
                if ($8fc928cd6c76f02e$export$9522e17588c12572(inner) && inner.nodes === $8fc928cd6c76f02e$var$EMPTY_BLOCK) pending = true;
            }
        },
        excludeSlotOutlets: true
    };
    if ($8fc928cd6c76f02e$var$isInteropEnabled) visitor.onInteropFragment = (frag)=>{
        if (frag.nodes === $8fc928cd6c76f02e$var$EMPTY_BLOCK) pending = true;
        track(frag);
    };
    function stopDirectiveScope() {
        if (directiveScope) {
            directiveScope.stop();
            directiveScope = void 0;
        }
    }
    function track(frag) {
        const u = frag.u || (frag.u = []);
        if (u.includes(applyDirectives)) return;
        u.push(applyDirectives);
        if ($8fc928cd6c76f02e$var$isDynamicFragment(frag)) (frag.bu || (frag.bu = [])).push(()=>{
            if (currentElement && $8fc928cd6c76f02e$var$getRootElement(frag.nodes) === currentElement) {
                currentElement = null;
                stopDirectiveScope();
            }
        });
    }
    function applyDirectives() {
        if (disposed) return;
        pending = false;
        const element = $8fc928cd6c76f02e$var$getRootElement(node, visitor);
        if (!element && pending) {
            if (currentElement !== null) {
                currentElement = null;
                stopDirectiveScope();
            }
            return;
        }
        if (element === currentElement) return;
        currentElement = element;
        stopDirectiveScope();
        if (!element) return;
        directiveScope = new (0, $SdEQh.EffectScope)(true);
        const prev = (0, $3dLyd.setCurrentInstance)(instance, directiveScope);
        try {
            if (once) $8fc928cd6c76f02e$export$81831a240bcfd22e(()=>$8fc928cd6c76f02e$var$applyDirectivesToElement(element, dirs, instance));
            else $8fc928cd6c76f02e$var$applyDirectivesToElement(element, dirs, instance);
        } finally{
            (0, $3dLyd.restoreCurrentInstance)(prev);
        }
    }
    (0, $SdEQh.onScopeDispose)(()=>{
        disposed = true;
        stopDirectiveScope();
    }, true);
    applyDirectives();
}
function $8fc928cd6c76f02e$var$applyDirectivesToElement(element, dirs, instance) {
    const hookCounts = null;
    for (const [dir, value, argument, modifiers] of dirs)if (dir) {
        if (!(0, $7s0Ms.isFunction)(dir)) continue;
        const ret = (0, $3dLyd.callWithErrorHandling)(dir, instance, 8, [
            element,
            value,
            argument,
            modifiers
        ]);
        if (ret) (0, $SdEQh.onScopeDispose)(()=>(0, $3dLyd.callWithErrorHandling)(ret, instance, 8));
    }
}
const $8fc928cd6c76f02e$var$lifecycleHookNames = {};
function $8fc928cd6c76f02e$var$countLifecycleHooks(instance) {
    const counts = [];
    for(const key in $8fc928cd6c76f02e$var$lifecycleHookNames){
        const hooks = instance[key];
        counts.push(hooks ? hooks.length : 0);
    }
    return counts;
}
function $8fc928cd6c76f02e$var$warnLifecycleHooks(instance, before) {
    let i = 0;
    for(const key in $8fc928cd6c76f02e$var$lifecycleHookNames){
        const hooks = instance[key];
        if (hooks && hooks.length > before[i]) (0, $3dLyd.warn)(`${$8fc928cd6c76f02e$var$lifecycleHookNames[key]}() was called inside a custom directive. Lifecycle hooks are not supported in Vapor directives: they attach to the component, not the element. Use watchPostEffect() for work that needs the element in the DOM, and return a cleanup function for teardown.`);
        i++;
    }
}
//#endregion
//#region packages/runtime-vapor/src/components/TransitionGroup.ts
const $8fc928cd6c76f02e$var$positionMap = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $8fc928cd6c76f02e$var$trackedTransitionGroupOwners = /* @__PURE__ */ new WeakSet();
const $8fc928cd6c76f02e$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $8fc928cd6c76f02e$export$27eb1a88f101ff62 = /*@__PURE__*/ $8fc928cd6c76f02e$var$decorate(/* @__PURE__ */ $8fc928cd6c76f02e$export$bcd4d980d2d74077({
    name: "VaporTransitionGroup",
    props: /*@__PURE__*/ (0, $7s0Ms.extend)({}, (0, $bmuEm.TransitionPropsValidators), {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots, expose: expose }) {
        expose();
        if (!$8fc928cd6c76f02e$var$isTransitionEnabled) $8fc928cd6c76f02e$var$registerTransitionHooks($8fc928cd6c76f02e$var$applyTransitionHooksImpl, ()=>false, ()=>false, ()=>false);
        const instance = (0, $3dLyd.currentInstance);
        const state = (0, $3dLyd.useTransitionState)();
        let cssTransitionProps;
        const propsProxy = new Proxy({}, {
            get (_, key) {
                return cssTransitionProps[key];
            }
        });
        let prevChildren = [];
        let isUpdatePending = false;
        let isUpdatedPending = false;
        let slottedBlock = [];
        const beforeUpdate = ()=>{
            if (isUpdatePending) return;
            isUpdatePending = true;
            prevChildren = [];
            const children = $8fc928cd6c76f02e$var$resolveTransitionBlocks(slottedBlock, void 0, void 0, true);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                const el = $8fc928cd6c76f02e$var$isValidTransitionBlock(child) && child.$transition ? $8fc928cd6c76f02e$var$getTransitionElement(child) : void 0;
                if (el && !el[0, $bmuEm.vShowHidden]) {
                    prevChildren.push(child);
                    $8fc928cd6c76f02e$var$positionMap.set(child, el.getBoundingClientRect());
                }
            }
        };
        const flushUpdated = ()=>{
            isUpdatedPending = false;
            if (!isUpdatePending) return;
            isUpdatePending = false;
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            const firstChild = $8fc928cd6c76f02e$var$getFirstConnectedChild(prevChildren);
            if (!!!(firstChild && (0, $bmuEm.hasCSSTransform)(firstChild, firstChild.parentNode, moveClass))) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach((child)=>{
                const el = $8fc928cd6c76f02e$var$getTransitionElement(child);
                if (el) (0, $bmuEm.callPendingCbs)(el);
            });
            prevChildren.forEach($8fc928cd6c76f02e$var$recordPosition);
            const movedChildren = prevChildren.filter($8fc928cd6c76f02e$var$applyTranslation);
            (0, $bmuEm.forceReflow)(firstChild);
            movedChildren.forEach((c)=>(0, $bmuEm.handleMovedChildren)($8fc928cd6c76f02e$var$getTransitionElement(c), moveClass));
            prevChildren = [];
        };
        const updated = ()=>{
            if (!isUpdatePending || isUpdatedPending) return;
            isUpdatedPending = true;
            (0, $3dLyd.queuePostRenderEffect)(flushUpdated, void 0, instance.suspense);
        };
        (0, $3dLyd.onBeforeUpdate)(beforeUpdate);
        (0, $3dLyd.onUpdated)(updated);
        const updateHooks = {
            beforeUpdate: beforeUpdate,
            updated: updated
        };
        if ($8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$var$locateHydrationNode();
        const tag = props.tag;
        let isMounted = false;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            cssTransitionProps = (0, $bmuEm.resolveTransitionProps)(props);
            if (isMounted) $8fc928cd6c76f02e$var$applyGroupTransitionHooks(slottedBlock, propsProxy, state, instance, updateHooks);
        }, true);
        const createContainer = ()=>tag ? $8fc928cd6c76f02e$var$isHydrating$1 ? $8fc928cd6c76f02e$var$adoptTemplate($8fc928cd6c76f02e$var$currentHydrationNode, `<${tag}/>`) : /* @__PURE__ */ $8fc928cd6c76f02e$var$createElement(tag) : void 0;
        const renderChildren = (slot, container, run = (render)=>render())=>{
            let nextNode = null;
            let prevMarkerlessContainer = null;
            let prevTransitionChildPending = false;
            if ($8fc928cd6c76f02e$var$isHydrating$1 && container) {
                prevMarkerlessContainer = $8fc928cd6c76f02e$var$setMarkerlessHydrationContainer(container);
                prevTransitionChildPending = $8fc928cd6c76f02e$var$setTransitionChildPending(true);
                nextNode = $8fc928cd6c76f02e$var$nextLogicalSibling(container);
                $8fc928cd6c76f02e$var$setCurrentHydrationNode(container.firstChild || container);
            }
            let transitionBlocks = [];
            try {
                run(()=>{
                    const block = slot && slot() || [];
                    transitionBlocks = $8fc928cd6c76f02e$var$applyGroupTransitionHooks(block, propsProxy, state, instance, updateHooks);
                    slottedBlock = block;
                    if (container) {
                        if (!$8fc928cd6c76f02e$var$isHydrating$1) $8fc928cd6c76f02e$export$21a5ca8aa77d35ff(block, container);
                        $8fc928cd6c76f02e$var$registerNestedVDOMCleanup(block);
                        return container;
                    }
                    return block;
                });
                if ($8fc928cd6c76f02e$var$isHydrating$1 && container && $8fc928cd6c76f02e$var$currentHydrationNode && $8fc928cd6c76f02e$var$currentHydrationNode.parentNode === container && !transitionBlocks.some((child)=>child === $8fc928cd6c76f02e$var$currentHydrationNode)) $8fc928cd6c76f02e$var$cleanupHydrationTail($8fc928cd6c76f02e$var$currentHydrationNode, container);
            } finally{
                if ($8fc928cd6c76f02e$var$isHydrating$1 && container) {
                    $8fc928cd6c76f02e$var$setMarkerlessHydrationContainer(prevMarkerlessContainer);
                    $8fc928cd6c76f02e$var$setTransitionChildPending(prevTransitionChildPending);
                    $8fc928cd6c76f02e$var$setCurrentHydrationNode(nextNode);
                }
            }
            isMounted = true;
        };
        if (!instance.rawSlots.$) {
            const container = createContainer();
            renderChildren(slots.default, container);
            return container || slottedBlock;
        }
        const frag = new $8fc928cd6c76f02e$export$2740cb41b6047c28(0, void 0);
        let currentSlot;
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const slot = slots.default;
            if (isMounted && slot === currentSlot) return;
            renderChildren(slot, createContainer(), (render)=>frag.update(render));
            currentSlot = slot;
        });
        return frag;
    }
}));
function $8fc928cd6c76f02e$var$resolveTransitionBlocks(block, onFragment, onUpdateOwner, collectOnly = false) {
    const children = [];
    if (collectOnly) {
        $8fc928cd6c76f02e$var$collectTransitionBlocks(block, children, onFragment, onUpdateOwner);
        return children;
    }
    const keys = /* @__PURE__ */ new Map();
    $8fc928cd6c76f02e$var$collectTransitionBlocks(block, children, onFragment, onUpdateOwner, keys, $8fc928cd6c76f02e$var$ROOT_KEY_CONTEXT);
    for(let i = 0; i < children.length; i++)$8fc928cd6c76f02e$var$setTransitionKey(children[i], keys.get(children[i]));
    return children;
}
function $8fc928cd6c76f02e$var$collectTransitionBlocks(block, children, onFragment, onUpdateOwner, keys, ctx) {
    if (block instanceof Node) {
        if (block instanceof Element) {
            children.push(block);
            if (keys) keys.set(block, block.$key);
        }
    } else if ($8fc928cd6c76f02e$export$f43892e053afd2a0(block)) {
        const isRootSlot = block.block && $8fc928cd6c76f02e$var$isVaporSlotOutlet(block.block);
        if (onUpdateOwner && !isRootSlot) onUpdateOwner(block);
        const start = children.length;
        $8fc928cd6c76f02e$var$collectTransitionBlocks(block.block, children, onFragment, isRootSlot ? onUpdateOwner : void 0, keys, ctx && (isRootSlot ? $8fc928cd6c76f02e$var$withDefaultKey(ctx, block.$key) : $8fc928cd6c76f02e$var$enterComponentKeyContext(ctx, block)));
        if (keys) {
            if (!isRootSlot) {
                const t = $8fc928cd6c76f02e$var$transitionTypeOf(block);
                for(let i = start; i < children.length; i++)$8fc928cd6c76f02e$var$setTransitionType(children[i], t);
            }
            $8fc928cd6c76f02e$var$resolveOwnerKey(children, start, block.$key, keys, !isRootSlot);
        }
    } else if ((0, $7s0Ms.isArray)(block)) for(let i = 0; i < block.length; i++)$8fc928cd6c76f02e$var$collectTransitionBlocks(block[i], children, onFragment, onUpdateOwner, keys, ctx);
    else if ($8fc928cd6c76f02e$export$9522e17588c12572(block)) {
        const isItem = $8fc928cd6c76f02e$var$isForBlock(block);
        if (!isItem) {
            if (onFragment) onFragment(block);
            if (onUpdateOwner) onUpdateOwner(block);
        }
        if ($8fc928cd6c76f02e$var$isInteropEnabled && block.hasVDOMContent && block.hasVDOMContent()) {
            children.push(block);
            if (keys) keys.set(block, block.$key);
        } else {
            const key = isItem ? block.key : $8fc928cd6c76f02e$var$getFragmentKey(block);
            const start = children.length;
            $8fc928cd6c76f02e$var$collectTransitionBlocks(block.nodes, children, onFragment, onUpdateOwner, keys, ctx && $8fc928cd6c76f02e$var$enterFragmentKeyContext(block, ctx, key));
            if (!keys) return;
            if (!isItem) $8fc928cd6c76f02e$var$resolveOwnerKey(children, start, key, keys, false);
            else if (key != null) {
                if (children.length - start === 1) keys.set(children[start], key);
                else for(let i = start; i < children.length; i++)keys.set(children[i], `${key}:${i - start}`);
            }
        }
    }
}
function $8fc928cd6c76f02e$var$resolveOwnerKey(children, start, key, keys, final) {
    if (children.length - start === 1) {
        const child = children[start];
        if (final || keys.get(child) == null) keys.set(child, key);
        return;
    }
    if (key == null) return;
    for(let i = start; i < children.length; i++){
        const child = children[i];
        const inner = keys.get(child);
        keys.set(child, String(key) + String(inner != null ? inner : i - start));
    }
}
function $8fc928cd6c76f02e$var$applyGroupTransitionHooks(block, props, state, instance, updateHooks) {
    const fragments = [];
    const children = $8fc928cd6c76f02e$var$resolveTransitionBlocks(block, (frag)=>fragments.push(frag), (owner)=>$8fc928cd6c76f02e$var$trackTransitionGroupUpdate(owner, instance, updateHooks));
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($8fc928cd6c76f02e$var$isValidTransitionBlock(child)) {
            if ($8fc928cd6c76f02e$var$getTransitionKey(child) != null) child.$transition = $8fc928cd6c76f02e$var$resolveTransitionHooks(child, props, state, instance);
        }
    }
    fragments.forEach((frag)=>{
        const hooks = $8fc928cd6c76f02e$var$resolveTransitionHooks(frag, props, state, instance);
        hooks.applyGroup = (block, props, state, instance)=>$8fc928cd6c76f02e$var$applyGroupTransitionHooks(block, props, state, instance, updateHooks);
        frag.$transition = hooks;
    });
    return children;
}
function $8fc928cd6c76f02e$var$trackTransitionGroupUpdate(owner, instance, updateHooks) {
    if ($8fc928cd6c76f02e$var$trackedTransitionGroupOwners.has(owner)) return;
    if ($8fc928cd6c76f02e$export$9522e17588c12572(owner)) {
        $8fc928cd6c76f02e$var$trackedTransitionGroupOwners.add(owner);
        (owner.bu || (owner.bu = [])).push(updateHooks.beforeUpdate);
        (owner.u || (owner.u = [])).push(updateHooks.updated);
        return;
    }
    if (!$8fc928cd6c76f02e$var$hasDynamicPropsSource(owner.rawProps)) return;
    $8fc928cd6c76f02e$var$trackedTransitionGroupOwners.add(owner);
    const prevGroup = (0, $3dLyd.setCurrentInstance)(instance, owner.scope);
    try {
        $8fc928cd6c76f02e$export$6c64e011838f4702(()=>{
            const prev = (0, $3dLyd.setCurrentInstance)(owner, owner.scope);
            try {
                $8fc928cd6c76f02e$var$resolveDynamicProps(owner.rawProps);
            } finally{
                (0, $3dLyd.restoreCurrentInstance)(prev);
            }
        });
    } finally{
        (0, $3dLyd.restoreCurrentInstance)(prevGroup);
    }
}
function $8fc928cd6c76f02e$var$hasDynamicPropsSource(props) {
    if (props.$) return true;
    for(const key in props)if (key !== "$" && (0, $7s0Ms.isFunction)(props[key])) return true;
    return false;
}
function $8fc928cd6c76f02e$var$recordPosition(c) {
    const el = $8fc928cd6c76f02e$var$getTransitionElement(c);
    if (el) $8fc928cd6c76f02e$var$newPositionMap.set(c, el.getBoundingClientRect());
}
function $8fc928cd6c76f02e$var$applyTranslation(c) {
    const el = $8fc928cd6c76f02e$var$getTransitionElement(c);
    if (el && (0, $bmuEm.baseApplyTranslation)($8fc928cd6c76f02e$var$positionMap.get(c), $8fc928cd6c76f02e$var$newPositionMap.get(c), el)) return c;
}
function $8fc928cd6c76f02e$var$getFirstConnectedChild(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const el = $8fc928cd6c76f02e$var$getTransitionElement(child);
        if (el && el.isConnected) return el;
    }
}

});


parcelRegister("cF2Ke", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("jvVeB", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $e34d4f297b86b975$export$b3890eb0ae9dca99; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
const $e34d4f297b86b975$var$_hoisted_1 = {
    id: "nav",
    class: "flex flex-wrap justify-center gap-x-2 gap-y-1"
};
const $e34d4f297b86b975$var$_hoisted_2 = {
    class: "rich-text mx-auto w-full max-w-6xl px-4 pb-12"
};
function $e34d4f297b86b975$export$b3890eb0ae9dca99(_ctx, _cache) {
    const _component_router_link = (0, $3dLyd.resolveComponent)("router-link");
    const _component_router_view = (0, $3dLyd.resolveComponent)("router-view");
    return (0, $3dLyd.openBlock)(), (0, $3dLyd.createElementBlock)((0, $3dLyd.Fragment), null, [
        (0, $3dLyd.createElementVNode)("div", $e34d4f297b86b975$var$_hoisted_1, [
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[0] || (_cache[0] = [
                            (0, $3dLyd.createTextVNode)("Home", -1)
                        ])
                    ]),
                _: 1
            }),
            _cache[6] || (_cache[6] = (0, $3dLyd.createTextVNode)(" | ", -1)),
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/decorator/class"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[1] || (_cache[1] = [
                            (0, $3dLyd.createTextVNode)("Decorator (class)", -1)
                        ])
                    ]),
                _: 1
            }),
            _cache[7] || (_cache[7] = (0, $3dLyd.createTextVNode)(" | ", -1)),
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/decorator/function"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[2] || (_cache[2] = [
                            (0, $3dLyd.createTextVNode)("Decorator (function)", -1)
                        ])
                    ]),
                _: 1
            }),
            _cache[8] || (_cache[8] = (0, $3dLyd.createTextVNode)(" | ", -1)),
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/component"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[3] || (_cache[3] = [
                            (0, $3dLyd.createTextVNode)("Component", -1)
                        ])
                    ]),
                _: 1
            }),
            _cache[9] || (_cache[9] = (0, $3dLyd.createTextVNode)(" | ", -1)),
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/chart"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[4] || (_cache[4] = [
                            (0, $3dLyd.createTextVNode)("Chart", -1)
                        ])
                    ]),
                _: 1
            }),
            _cache[10] || (_cache[10] = (0, $3dLyd.createTextVNode)(" | ", -1)),
            (0, $3dLyd.createVNode)(_component_router_link, {
                to: "/about"
            }, {
                default: (0, $3dLyd.withCtx)(()=>[
                        ..._cache[5] || (_cache[5] = [
                            (0, $3dLyd.createTextVNode)("About", -1)
                        ])
                    ]),
                _: 1
            })
        ]),
        (0, $3dLyd.createElementVNode)("main", $e34d4f297b86b975$var$_hoisted_2, [
            (0, $3dLyd.createVNode)(_component_router_view)
        ])
    ], 64);
}

});

parcelRegister("9c2LK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b1761f2ef32b6d0$export$2e2bcd8739ae039; });
let $6b1761f2ef32b6d0$var$NOOP = ()=>{};
var $6b1761f2ef32b6d0$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("76BgN", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $52c600f94124b7a5$export$a143d493d941bafc; }, function (v) { return $52c600f94124b7a5$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $52c600f94124b7a5$export$f99ded8fe4b79145; }, function (v) { return $52c600f94124b7a5$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $52c600f94124b7a5$export$a143d493d941bafc;
var $52c600f94124b7a5$export$e4cf37d7f6fb9e0a;
var $52c600f94124b7a5$export$f99ded8fe4b79145;
var $52c600f94124b7a5$export$599f31c3813fae4d;
'use strict';

var $ciAhb = parcelRequire("ciAhb");

var $jkrR6 = parcelRequire("jkrR6");
const $52c600f94124b7a5$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$52c600f94124b7a5$export$a143d493d941bafc = $52c600f94124b7a5$var$Buffer;
$52c600f94124b7a5$export$e4cf37d7f6fb9e0a = $52c600f94124b7a5$var$SlowBuffer;
$52c600f94124b7a5$export$f99ded8fe4b79145 = 50;
const $52c600f94124b7a5$var$K_MAX_LENGTH = 0x7fffffff;
$52c600f94124b7a5$export$599f31c3813fae4d = $52c600f94124b7a5$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $52c600f94124b7a5$var$Buffer.TYPED_ARRAY_SUPPORT = $52c600f94124b7a5$var$typedArraySupport();
if (!$52c600f94124b7a5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $52c600f94124b7a5$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($52c600f94124b7a5$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$52c600f94124b7a5$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($52c600f94124b7a5$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$52c600f94124b7a5$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $52c600f94124b7a5$var$createBuffer(length) {
    if (length > $52c600f94124b7a5$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $52c600f94124b7a5$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $52c600f94124b7a5$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $52c600f94124b7a5$var$allocUnsafe(arg);
    }
    return $52c600f94124b7a5$var$from(arg, encodingOrOffset, length);
}
$52c600f94124b7a5$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $52c600f94124b7a5$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $52c600f94124b7a5$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $52c600f94124b7a5$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($52c600f94124b7a5$var$isInstance(value, ArrayBuffer) || value && $52c600f94124b7a5$var$isInstance(value.buffer, ArrayBuffer)) return $52c600f94124b7a5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($52c600f94124b7a5$var$isInstance(value, SharedArrayBuffer) || value && $52c600f94124b7a5$var$isInstance(value.buffer, SharedArrayBuffer))) return $52c600f94124b7a5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $52c600f94124b7a5$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $52c600f94124b7a5$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $52c600f94124b7a5$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $52c600f94124b7a5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $52c600f94124b7a5$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($52c600f94124b7a5$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($52c600f94124b7a5$var$Buffer, Uint8Array);
function $52c600f94124b7a5$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $52c600f94124b7a5$var$alloc(size, fill, encoding) {
    $52c600f94124b7a5$var$assertSize(size);
    if (size <= 0) return $52c600f94124b7a5$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $52c600f94124b7a5$var$createBuffer(size).fill(fill, encoding) : $52c600f94124b7a5$var$createBuffer(size).fill(fill);
    return $52c600f94124b7a5$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $52c600f94124b7a5$var$Buffer.alloc = function(size, fill, encoding) {
    return $52c600f94124b7a5$var$alloc(size, fill, encoding);
};
function $52c600f94124b7a5$var$allocUnsafe(size) {
    $52c600f94124b7a5$var$assertSize(size);
    return $52c600f94124b7a5$var$createBuffer(size < 0 ? 0 : $52c600f94124b7a5$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $52c600f94124b7a5$var$Buffer.allocUnsafe = function(size) {
    return $52c600f94124b7a5$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $52c600f94124b7a5$var$Buffer.allocUnsafeSlow = function(size) {
    return $52c600f94124b7a5$var$allocUnsafe(size);
};
function $52c600f94124b7a5$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$52c600f94124b7a5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $52c600f94124b7a5$var$byteLength(string, encoding) | 0;
    let buf = $52c600f94124b7a5$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $52c600f94124b7a5$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $52c600f94124b7a5$var$checked(array.length) | 0;
    const buf = $52c600f94124b7a5$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $52c600f94124b7a5$var$fromArrayView(arrayView) {
    if ($52c600f94124b7a5$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $52c600f94124b7a5$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $52c600f94124b7a5$var$fromArrayLike(arrayView);
}
function $52c600f94124b7a5$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $52c600f94124b7a5$var$Buffer.prototype);
    return buf;
}
function $52c600f94124b7a5$var$fromObject(obj) {
    if ($52c600f94124b7a5$var$Buffer.isBuffer(obj)) {
        const len = $52c600f94124b7a5$var$checked(obj.length) | 0;
        const buf = $52c600f94124b7a5$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $52c600f94124b7a5$var$numberIsNaN(obj.length)) return $52c600f94124b7a5$var$createBuffer(0);
        return $52c600f94124b7a5$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $52c600f94124b7a5$var$fromArrayLike(obj.data);
}
function $52c600f94124b7a5$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $52c600f94124b7a5$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $52c600f94124b7a5$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $52c600f94124b7a5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $52c600f94124b7a5$var$Buffer.alloc(+length);
}
$52c600f94124b7a5$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $52c600f94124b7a5$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$52c600f94124b7a5$var$Buffer.compare = function compare(a, b) {
    if ($52c600f94124b7a5$var$isInstance(a, Uint8Array)) a = $52c600f94124b7a5$var$Buffer.from(a, a.offset, a.byteLength);
    if ($52c600f94124b7a5$var$isInstance(b, Uint8Array)) b = $52c600f94124b7a5$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(a) || !$52c600f94124b7a5$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$52c600f94124b7a5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$52c600f94124b7a5$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $52c600f94124b7a5$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $52c600f94124b7a5$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($52c600f94124b7a5$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) buf = $52c600f94124b7a5$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $52c600f94124b7a5$var$byteLength(string, encoding) {
    if ($52c600f94124b7a5$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $52c600f94124b7a5$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $52c600f94124b7a5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $52c600f94124b7a5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$52c600f94124b7a5$var$Buffer.byteLength = $52c600f94124b7a5$var$byteLength;
function $52c600f94124b7a5$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $52c600f94124b7a5$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8Slice(this, start, end);
        case 'ascii':
            return $52c600f94124b7a5$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $52c600f94124b7a5$var$latin1Slice(this, start, end);
        case 'base64':
            return $52c600f94124b7a5$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $52c600f94124b7a5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$52c600f94124b7a5$var$Buffer.prototype._isBuffer = true;
function $52c600f94124b7a5$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$52c600f94124b7a5$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$52c600f94124b7a5$var$swap(this, i, i + 1);
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $52c600f94124b7a5$var$swap(this, i, i + 3);
        $52c600f94124b7a5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $52c600f94124b7a5$var$swap(this, i, i + 7);
        $52c600f94124b7a5$var$swap(this, i + 1, i + 6);
        $52c600f94124b7a5$var$swap(this, i + 2, i + 5);
        $52c600f94124b7a5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $52c600f94124b7a5$var$utf8Slice(this, 0, length);
    return $52c600f94124b7a5$var$slowToString.apply(this, arguments);
};
$52c600f94124b7a5$var$Buffer.prototype.toLocaleString = $52c600f94124b7a5$var$Buffer.prototype.toString;
$52c600f94124b7a5$var$Buffer.prototype.equals = function equals(b) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $52c600f94124b7a5$var$Buffer.compare(this, b) === 0;
};
$52c600f94124b7a5$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $52c600f94124b7a5$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($52c600f94124b7a5$var$customInspectSymbol) $52c600f94124b7a5$var$Buffer.prototype[$52c600f94124b7a5$var$customInspectSymbol] = $52c600f94124b7a5$var$Buffer.prototype.inspect;
$52c600f94124b7a5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($52c600f94124b7a5$var$isInstance(target, Uint8Array)) target = $52c600f94124b7a5$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $52c600f94124b7a5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($52c600f94124b7a5$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $52c600f94124b7a5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($52c600f94124b7a5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $52c600f94124b7a5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $52c600f94124b7a5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $52c600f94124b7a5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$52c600f94124b7a5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$52c600f94124b7a5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $52c600f94124b7a5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$52c600f94124b7a5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $52c600f94124b7a5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $52c600f94124b7a5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($52c600f94124b7a5$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $52c600f94124b7a5$var$utf8Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $52c600f94124b7a5$var$asciiWrite(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$asciiToBytes(string), buf, offset, length);
}
function $52c600f94124b7a5$var$base64Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$base64ToBytes(string), buf, offset, length);
}
function $52c600f94124b7a5$var$ucs2Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$52c600f94124b7a5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $52c600f94124b7a5$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $52c600f94124b7a5$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $52c600f94124b7a5$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $52c600f94124b7a5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$52c600f94124b7a5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $52c600f94124b7a5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ciAhb.fromByteArray(buf);
    else return $ciAhb.fromByteArray(buf.slice(start, end));
}
function $52c600f94124b7a5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $52c600f94124b7a5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $52c600f94124b7a5$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $52c600f94124b7a5$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $52c600f94124b7a5$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $52c600f94124b7a5$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $52c600f94124b7a5$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $52c600f94124b7a5$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$52c600f94124b7a5$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $52c600f94124b7a5$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $52c600f94124b7a5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$52c600f94124b7a5$var$Buffer.prototype.readUintLE = $52c600f94124b7a5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readUintBE = $52c600f94124b7a5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint8 = $52c600f94124b7a5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$52c600f94124b7a5$var$Buffer.prototype.readUint16LE = $52c600f94124b7a5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint16BE = $52c600f94124b7a5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$52c600f94124b7a5$var$Buffer.prototype.readUint32LE = $52c600f94124b7a5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint32BE = $52c600f94124b7a5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$52c600f94124b7a5$var$Buffer.prototype.readBigUInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$52c600f94124b7a5$var$Buffer.prototype.readBigUInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$52c600f94124b7a5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$52c600f94124b7a5$var$Buffer.prototype.readBigInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$52c600f94124b7a5$var$Buffer.prototype.readBigInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$52c600f94124b7a5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return $jkrR6.read(this, offset, true, 23, 4);
};
$52c600f94124b7a5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return $jkrR6.read(this, offset, false, 23, 4);
};
$52c600f94124b7a5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 8, this.length);
    return $jkrR6.read(this, offset, true, 52, 8);
};
$52c600f94124b7a5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 8, this.length);
    return $jkrR6.read(this, offset, false, 52, 8);
};
function $52c600f94124b7a5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$52c600f94124b7a5$var$Buffer.prototype.writeUintLE = $52c600f94124b7a5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUintBE = $52c600f94124b7a5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint8 = $52c600f94124b7a5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint16LE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint16BE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint32LE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint32BE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $52c600f94124b7a5$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $52c600f94124b7a5$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$52c600f94124b7a5$var$Buffer.prototype.writeBigUInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeBigUInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeBigInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeBigInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $52c600f94124b7a5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $jkrR6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$52c600f94124b7a5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeFloat(this, value, offset, true, noAssert);
};
$52c600f94124b7a5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeFloat(this, value, offset, false, noAssert);
};
function $52c600f94124b7a5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $jkrR6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$52c600f94124b7a5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeDouble(this, value, offset, true, noAssert);
};
$52c600f94124b7a5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$52c600f94124b7a5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$52c600f94124b7a5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$52c600f94124b7a5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $52c600f94124b7a5$var$Buffer.isBuffer(val) ? val : $52c600f94124b7a5$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $52c600f94124b7a5$var$errors = {};
function $52c600f94124b7a5$var$E(sym, getMessage, Base) {
    $52c600f94124b7a5$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$52c600f94124b7a5$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$52c600f94124b7a5$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$52c600f94124b7a5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $52c600f94124b7a5$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $52c600f94124b7a5$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $52c600f94124b7a5$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $52c600f94124b7a5$var$checkBounds(buf, offset, byteLength) {
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $52c600f94124b7a5$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $52c600f94124b7a5$var$checkBounds(buf, offset, byteLength);
}
function $52c600f94124b7a5$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $52c600f94124b7a5$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $52c600f94124b7a5$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $52c600f94124b7a5$var$validateNumber(value, type);
        throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $52c600f94124b7a5$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $52c600f94124b7a5$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $52c600f94124b7a5$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($52c600f94124b7a5$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $52c600f94124b7a5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $52c600f94124b7a5$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $52c600f94124b7a5$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $52c600f94124b7a5$var$base64ToBytes(str) {
    return $ciAhb.toByteArray($52c600f94124b7a5$var$base64clean(str));
}
function $52c600f94124b7a5$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $52c600f94124b7a5$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $52c600f94124b7a5$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $52c600f94124b7a5$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $52c600f94124b7a5$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $52c600f94124b7a5$var$BufferBigIntNotDefined : fn;
}
function $52c600f94124b7a5$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("ciAhb", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $8f434e29c230537f$export$d622b2ad8d90c771; }, function (v) { return $8f434e29c230537f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $8f434e29c230537f$export$6100ba28696e12de; }, function (v) { return $8f434e29c230537f$export$6100ba28696e12de = v; });
var $8f434e29c230537f$export$a48f0734ac7c2329;
var $8f434e29c230537f$export$d622b2ad8d90c771;
var $8f434e29c230537f$export$6100ba28696e12de;
'use strict';
$8f434e29c230537f$export$a48f0734ac7c2329 = $8f434e29c230537f$var$byteLength;
$8f434e29c230537f$export$d622b2ad8d90c771 = $8f434e29c230537f$var$toByteArray;
$8f434e29c230537f$export$6100ba28696e12de = $8f434e29c230537f$var$fromByteArray;
var $8f434e29c230537f$var$lookup = [];
var $8f434e29c230537f$var$revLookup = [];
var $8f434e29c230537f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8f434e29c230537f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8f434e29c230537f$var$i = 0, $8f434e29c230537f$var$len = $8f434e29c230537f$var$code.length; $8f434e29c230537f$var$i < $8f434e29c230537f$var$len; ++$8f434e29c230537f$var$i){
    $8f434e29c230537f$var$lookup[$8f434e29c230537f$var$i] = $8f434e29c230537f$var$code[$8f434e29c230537f$var$i];
    $8f434e29c230537f$var$revLookup[$8f434e29c230537f$var$code.charCodeAt($8f434e29c230537f$var$i)] = $8f434e29c230537f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8f434e29c230537f$var$revLookup['-'.charCodeAt(0)] = 62;
$8f434e29c230537f$var$revLookup['_'.charCodeAt(0)] = 63;
function $8f434e29c230537f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8f434e29c230537f$var$byteLength(b64) {
    var lens = $8f434e29c230537f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8f434e29c230537f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8f434e29c230537f$var$toByteArray(b64) {
    var tmp;
    var lens = $8f434e29c230537f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8f434e29c230537f$var$Arr($8f434e29c230537f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 18 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 2 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 10 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8f434e29c230537f$var$tripletToBase64(num) {
    return $8f434e29c230537f$var$lookup[num >> 18 & 0x3F] + $8f434e29c230537f$var$lookup[num >> 12 & 0x3F] + $8f434e29c230537f$var$lookup[num >> 6 & 0x3F] + $8f434e29c230537f$var$lookup[num & 0x3F];
}
function $8f434e29c230537f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8f434e29c230537f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8f434e29c230537f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8f434e29c230537f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8f434e29c230537f$var$lookup[tmp >> 2] + $8f434e29c230537f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8f434e29c230537f$var$lookup[tmp >> 10] + $8f434e29c230537f$var$lookup[tmp >> 4 & 0x3F] + $8f434e29c230537f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("jkrR6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $e1257e1b0b7982b6$export$aafa59e2e03f2942; }, function (v) { return $e1257e1b0b7982b6$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $e1257e1b0b7982b6$export$68d8715fc104d294; }, function (v) { return $e1257e1b0b7982b6$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e1257e1b0b7982b6$export$aafa59e2e03f2942;
var $e1257e1b0b7982b6$export$68d8715fc104d294;
$e1257e1b0b7982b6$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e1257e1b0b7982b6$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("dKmBq", function(module, exports) {
$parcel$export(module.exports, "observer", function () { return (parcelRequire("hTNas")).observer; });
$parcel$export(module.exports, "reaction", function () { return (parcelRequire("hTNas")).reaction; });
parcelRequire("90cxg");
parcelRequire("hTNas");

});
parcelRegister("90cxg", function(module, exports) {

$parcel$export(module.exports, "ProxyMap", function () { return $68ddd672d6052ab0$export$5bcdd9ec8525d86e; });

var $5hfm1 = parcelRequire("5hfm1");
var $68ddd672d6052ab0$var$_a;
const $68ddd672d6052ab0$var$uniqueKey = (0, $5hfm1.uniqueID)();
class $68ddd672d6052ab0$export$5bcdd9ec8525d86e {
    constructor(){
        Object.defineProperty(this, $68ddd672d6052ab0$var$_a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ProxyMap'
        });
    }
    set(key, value) {
        key[$68ddd672d6052ab0$var$uniqueKey] = value;
        return this;
    }
    get(key) {
        return key[$68ddd672d6052ab0$var$uniqueKey];
    }
    has(key) {
        return $68ddd672d6052ab0$var$uniqueKey in key;
    }
    delete(key) {
        return delete key[$68ddd672d6052ab0$var$uniqueKey];
    }
}
$68ddd672d6052ab0$var$_a = Symbol.toStringTag;

});

parcelRegister("hTNas", function(module, exports) {

$parcel$export(module.exports, "reaction", function () { return $d07db66c3f12de68$export$7203b476385689ae; });
$parcel$export(module.exports, "observer", function () { return $d07db66c3f12de68$export$b6ae1bc530f4c149; });

var $ga05Q = parcelRequire("ga05Q");
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
parcelRequire("4Bs72");
var $8i16b = parcelRequire("8i16b");

var $cF2Ke = parcelRequire("cF2Ke");

var $1mAlS = parcelRequire("1mAlS");

var $90cxg = parcelRequire("90cxg");
const $d07db66c3f12de68$var$reactionMap = new (0, $90cxg.ProxyMap)();
const $d07db66c3f12de68$export$7203b476385689ae = (expression)=>(effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $d07db66c3f12de68$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $d07db66c3f12de68$var$reactionMap.set(this, reactions);
        });
const $d07db66c3f12de68$var$wrapClass = (Component)=>class ObserverComponent extends Component {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
        }
        mounted() {
            var _a, _b;
            this.disposers = (_a = $d07db66c3f12de68$var$reactionMap.get(this)) === null || _a === void 0 ? void 0 : _a.map(({ expression: expression, effect: effect })=>(0, $cF2Ke.reaction)((reaction)=>expression(this, reaction), effect.bind(this)));
            (_b = super.mounted) === null || _b === void 0 || _b.call(this);
        }
        render() {
            return (0, $ga05Q.jsx)((0, $1mAlS.Observer), {
                children: ()=>{
                    var _a;
                    return (_a = super.render) === null || _a === void 0 ? void 0 : _a.call(this);
                }
            });
        }
        unmounted() {
            var _a;
            for (const disposer of this.disposers || [])disposer();
            this.disposers = [];
            (_a = super.unmounted) === null || _a === void 0 || _a.call(this);
        }
    };
function $d07db66c3f12de68$export$b6ae1bc530f4c149(component) {
    if (typeof component === 'function') {
        const { prototype: prototype } = component;
        if (prototype instanceof (0, $8i16b.Base) || typeof (prototype === null || prototype === void 0 ? void 0 : prototype.render) === 'function') return $d07db66c3f12de68$var$wrapClass(component);
    }
    const FunctionComponent = component;
    return (0, $3dLyd.defineComponent)({
        setup: (props, context)=>()=>(0, $ga05Q.jsx)((0, $1mAlS.Observer), {
                    children: ()=>FunctionComponent(Object.assign(Object.assign({}, props), context.attrs), context)
                })
    });
}

});
parcelRegister("ga05Q", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $a33522cf031f7bc0$export$34b9dba7ce09269b; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
function $a33522cf031f7bc0$export$34b9dba7ce09269b(type, props, key) {
    const { children: children } = props;
    delete props.children;
    if (arguments.length > 2) props.key = key;
    return (0, $3dLyd.h)(type, props, children);
}

});

parcelRegister("4Bs72", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return (parcelRequire("8se3f")).ComponentBase; });
$parcel$export(module.exports, "Watch", function () { return (parcelRequire("3XCRw")).decorator; });
$parcel$export(module.exports, "Prop", function () { return (parcelRequire("dOOCA")).decorator; });
$parcel$export(module.exports, "TSX", function () { return (parcelRequire("9SF3p")).TSX; });
$parcel$export(module.exports, "Vue", function () { return (parcelRequire("8i16b")).Base; });
$parcel$export(module.exports, "toNative", function () { return (parcelRequire("8se3f")).toNative; });

var $8se3f = parcelRequire("8se3f");

var $bWe0F = parcelRequire("bWe0F");

var $lrmBZ = parcelRequire("lrmBZ");

var $3XCRw = parcelRequire("3XCRw");

var $dOOCA = parcelRequire("dOOCA");

var $iHHBW = parcelRequire("iHHBW");

var $j5Y3x = parcelRequire("j5Y3x");

var $fsqjs = parcelRequire("fsqjs");

var $hRBzK = parcelRequire("hRBzK");

var $k03fS = parcelRequire("k03fS");

var $h3ZfC = parcelRequire("h3ZfC");

var $6vnB4 = parcelRequire("6vnB4");

var $ebqAl = parcelRequire("ebqAl");

var $9SF3p = parcelRequire("9SF3p");

var $8i16b = parcelRequire("8i16b");
parcelRequire("aq4Ra");

});
parcelRegister("8se3f", function(module, exports) {

$parcel$export(module.exports, "ComponentBase", function () { return $627bd68e25d2f96c$export$425c3e0a21b857e8; });
$parcel$export(module.exports, "toNative", function () { return $627bd68e25d2f96c$export$b5ba361dca0a2be9; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");

var $loI0s = parcelRequire("loI0s");

var $iTlXO = parcelRequire("iTlXO");

var $bWe0F = parcelRequire("bWe0F");

var $kqC8x = parcelRequire("kqC8x");

var $jolYj = parcelRequire("jolYj");

var $h3ZfC = parcelRequire("h3ZfC");

var $lrmBZ = parcelRequire("lrmBZ");

var $3XCRw = parcelRequire("3XCRw");

var $dOOCA = parcelRequire("dOOCA");

var $j5Y3x = parcelRequire("j5Y3x");

var $iHHBW = parcelRequire("iHHBW");

var $fsqjs = parcelRequire("fsqjs");

var $hRBzK = parcelRequire("hRBzK");

var $kmLhc = parcelRequire("kmLhc");
function $627bd68e25d2f96c$var$componentOptionFactory(cons, extend) {
    const optionBuilder = {};
    (0, $bWe0F.build)(cons, optionBuilder);
    (0, $hRBzK.build)(cons, optionBuilder);
    (0, $kqC8x.build)(cons, optionBuilder); //after VModel
    (0, $3XCRw.build)(cons, optionBuilder);
    (0, $dOOCA.build)(cons, optionBuilder);
    (0, $j5Y3x.build)(cons, optionBuilder);
    (0, $fsqjs.build)(cons, optionBuilder);
    (0, $lrmBZ.build)(cons, optionBuilder); //after Computed
    (0, $kmLhc.build)(cons, optionBuilder);
    (0, $h3ZfC.build)(cons, optionBuilder); //the last one
    const raw = Object.assign(Object.assign({
        name: cons.name,
        setup: optionBuilder.setup,
        data () {
            var _a;
            delete optionBuilder.data;
            (0, $jolYj.build)(cons, optionBuilder);
            return (_a = optionBuilder.data) !== null && _a !== void 0 ? _a : {};
        },
        methods: optionBuilder.methods,
        computed: optionBuilder.computed,
        watch: optionBuilder.watch,
        props: optionBuilder.props,
        inject: optionBuilder.inject,
        provide () {
            var _a;
            (0, $iHHBW.build)(cons, optionBuilder, this);
            return (_a = optionBuilder.provide) !== null && _a !== void 0 ? _a : {};
        }
    }, optionBuilder.hooks), {
        extends: extend
    });
    return raw;
}
function $627bd68e25d2f96c$var$buildComponent(cons, arg, extend) {
    var _a, _b;
    const option = $627bd68e25d2f96c$var$componentOptionFactory(cons, extend);
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    Object.keys(arg).reduce((option, name)=>{
        if ([
            'options',
            'modifier',
            'methods',
            'emits',
            'setup',
            'provide'
        ].includes(name)) return option;
        option[name] = arg[name];
        return option;
    }, option);
    //apply event emits
    let emits = Array.from(slot.obtainMap('emits').keys());
    if (Array.isArray(arg.emits)) emits = Array.from(new Set([
        ...emits,
        ...arg.emits
    ]));
    option.emits = emits;
    //merge methods
    if ('object' === typeof arg.methods && !Array.isArray(arg.methods) && arg.methods !== null) {
        (_a = option.methods) !== null && _a !== void 0 ? _a : option.methods = {};
        Object.assign(option.methods, arg.methods);
    }
    //merge setup function
    if (!option.setup) option.setup = arg.setup;
    else {
        const oldSetup = option.setup;
        const newSetup = (_b = arg.setup) !== null && _b !== void 0 ? _b : function() {
            return {};
        };
        const setup = function(props, ctx) {
            const newRet = newSetup(props, ctx);
            const oldRet = oldSetup(props, ctx);
            if (oldRet instanceof Promise || newRet instanceof Promise) return Promise.all([
                newRet,
                oldRet
            ]).then((arr)=>{
                return Object.assign({}, arr[0], arr[1]);
            });
            else return Object.assign({}, newRet, oldRet);
        };
        option.setup = setup;
    }
    //merge provide function
    const oldProvider = (0, $iTlXO.getProviderFunction)(option.provide);
    const newProvider = (0, $iTlXO.getProviderFunction)(arg.provide);
    option.provide = function() {
        return Object.assign({}, oldProvider.call(this), newProvider.call(this));
    };
    //custom decorator
    const map = slot.getMap('customDecorator');
    if (map && map.size > 0) map.forEach((v)=>{
        v.forEach((ite)=>ite.creator.apply({}, [
                option,
                ite.key
            ]));
    });
    //shallow merge options
    if (arg.options) Object.assign(option, arg.options);
    //apply modifier
    if (arg.modifier) arg.modifier(option);
    return (0, $3dLyd.defineComponent)(option);
}
function $627bd68e25d2f96c$var$build(cons, option) {
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    slot.inComponent = true;
    const superSlot = (0, $iTlXO.getSuperSlot)(cons.prototype);
    if (superSlot) {
        if (!superSlot.inComponent) throw 'Class should be decorated by Component or ComponentBase: ' + slot.master;
        if (superSlot.cachedVueComponent === null) throw 'Component decorator 1';
    }
    const component = $627bd68e25d2f96c$var$buildComponent(cons, option, superSlot === null ? undefined : superSlot.cachedVueComponent);
    component.__vfdConstructor = cons;
    slot.cachedVueComponent = component;
    cons.__vccOpts = component;
}
const $627bd68e25d2f96c$export$425c3e0a21b857e8 = (0, $iTlXO.optionNullableClassDecorator)((cons, option)=>{
    $627bd68e25d2f96c$var$build(cons, option !== null && option !== void 0 ? option : {});
});
function $627bd68e25d2f96c$export$b5ba361dca0a2be9(cons) {
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    if (!slot.inComponent) throw 'to native 1';
    const cached = slot.cachedVueComponent;
    if (!cached) throw 'to native 2';
    return cached;
}

});
parcelRegister("loI0s", function(module, exports) {

$parcel$export(module.exports, "getSlot", function () { return $f93df99da2858f9f$export$f81520ef48fbe118; });
$parcel$export(module.exports, "obtainSlot", function () { return $f93df99da2858f9f$export$55fad84da1c41cea; });
parcelRequire("dvQrG");
var $bJk2s = parcelRequire("bJk2s");
const $f93df99da2858f9f$var$SlotSymbol = Symbol('vue-facing-decorator-slot');
class $f93df99da2858f9f$export$8c6ed5c666ac1360 {
    constructor(master){
        Object.defineProperty(this, "master", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "names", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "inComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "cachedVueComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.master = master;
    }
    obtainMap(name) {
        let map = this.getMap(name);
        if (!map) {
            map = new Map();
            this.names.set(name, map);
        }
        return map;
    }
    getMap(name) {
        const map = this.names.get(name);
        return map;
    }
}
const $f93df99da2858f9f$var$metadata = new (0, $bJk2s.Metadata)($f93df99da2858f9f$var$SlotSymbol);
function $f93df99da2858f9f$export$43c296757b81c771(obj, defaultSlot) {
    if ($f93df99da2858f9f$export$f81520ef48fbe118(obj)) throw '';
    if (defaultSlot) defaultSlot.master = obj;
    const slot = defaultSlot !== null && defaultSlot !== void 0 ? defaultSlot : new $f93df99da2858f9f$export$8c6ed5c666ac1360(obj);
    $f93df99da2858f9f$var$metadata.create(obj, slot);
    return slot;
}
function $f93df99da2858f9f$export$f81520ef48fbe118(obj) {
    return $f93df99da2858f9f$var$metadata.getOwn(obj);
}
function $f93df99da2858f9f$export$55fad84da1c41cea(obj, defaultSlot) {
    const slot = $f93df99da2858f9f$export$f81520ef48fbe118(obj);
    if (slot) return slot;
    return $f93df99da2858f9f$export$43c296757b81c771(obj, defaultSlot);
}

});
parcelRegister("dvQrG", function(module, exports) {

$parcel$export(module.exports, "Metadata", function () { return (parcelRequire("bJk2s")).Metadata; });

var $bJk2s = parcelRequire("bJk2s");

});
parcelRegister("bJk2s", function(module, exports) {

$parcel$export(module.exports, "Metadata", function () { return $88a370ef08773ac9$export$e7adebdc1ebd2fed; });

var $1IamB = parcelRequire("1IamB");
var $88a370ef08773ac9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $88a370ef08773ac9$var$_Metadata_instances, $88a370ef08773ac9$var$_Metadata_travel;
class $88a370ef08773ac9$export$e7adebdc1ebd2fed {
    /**
     * Metadata.
     * @param symbol Optional. Signature for this metadata. It will be set as the key in the target.
     */ constructor(symbol = Symbol('faple-metadata')){
        $88a370ef08773ac9$var$_Metadata_instances.add(this);
        this.symbol = symbol;
    }
    /**
     * Create metadata in the target.
     * @param target Target.
     * @param data   Init metadata.
     */ create(target, data) {
        if (Object.getOwnPropertyDescriptor(target, this.symbol)) (0, $1IamB.error)('Target had metadata');
        Object.defineProperty(target, this.symbol, {
            enumerable: false,
            configurable: false,
            writable: false,
            value: data
        });
    }
    /**
     * Get own metadata.
     * @param target Target.
     * @returns Metadata data or undefined.
     */ getOwn(target) {
        const des = Object.getOwnPropertyDescriptor(target, this.symbol);
        if (!des) return undefined;
        return des.value;
    }
    /**
    * Get metadata in prototype chain.
    * @param target Target.
    * @returns Metadata data or undefined.
    */ get(target) {
        let data = undefined;
        $88a370ef08773ac9$var$__classPrivateFieldGet(this, $88a370ef08773ac9$var$_Metadata_instances, "m", $88a370ef08773ac9$var$_Metadata_travel).call(this, target, (target, _data)=>{
            data = _data;
            return false;
        });
        return data;
    }
    /**
     * Get metadata array in prototype chain.
     * @param target Target.
     * @returns Metadata array to acient.
     */ getAll(target) {
        let data = [];
        $88a370ef08773ac9$var$__classPrivateFieldGet(this, $88a370ef08773ac9$var$_Metadata_instances, "m", $88a370ef08773ac9$var$_Metadata_travel).call(this, target, (target, _data)=>{
            data.push(_data);
            return true;
        });
        return data;
    }
    /**
     * Set value in the own mdatadata.
     * Implement by `obtainOwn`.
     * @param target Target.
     * @param key Key.
     * @param value value.
     */ setValueOwn(target, key, value) {
        const _data = this.getOwn(target);
        if (!_data) (0, $1IamB.error)('Target has not metadata');
        _data[key] = value;
    }
    /**
    * Set value in the recent mdatadata in prototype chain.
    * Implement by `obtain`.
    * @param target Target.
    * @param key Key.
    * @param value value.
    */ setValue(target, key, value) {
        const _data = this.get(target);
        if (!_data) (0, $1IamB.error)('Target has not metadata');
        _data[key] = value;
    }
    /**
     * Get value in the own metadata.
     * @param target Target.
     * @param key Key.
     * @returns
     */ getValueOwn(target, key) {
        const data = this.getOwn(target);
        if (data === undefined) (0, $1IamB.error)('Target has not metadata');
        return data[key];
    }
    /**
    * Get value in the recent mdatadata WHICH HAS THE KEY in prototype chain.
    * @param target Target.
    * @param key Key.
    */ getValue(target, key) {
        let foundMetadata = false;
        let value = undefined;
        $88a370ef08773ac9$var$__classPrivateFieldGet(this, $88a370ef08773ac9$var$_Metadata_instances, "m", $88a370ef08773ac9$var$_Metadata_travel).call(this, target, (target, _data)=>{
            foundMetadata = true;
            if (!(key in _data) || _data[key] === undefined) return true;
            value = _data[key];
            return false;
        });
        if (!foundMetadata) (0, $1IamB.error)('Target has not metadata');
        return value;
    }
}
$88a370ef08773ac9$var$_Metadata_instances = new WeakSet(), $88a370ef08773ac9$var$_Metadata_travel = function _Metadata_travel(target, traveler) {
    let t = target;
    do {
        const data = this.getOwn(t);
        if (data !== undefined) {
            if (!traveler(target, data)) break;
        }
        t = Object.getPrototypeOf(t);
    }while (t !== null);
};

});
parcelRegister("1IamB", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $13f1f07f67bc6a3e$export$a3bc9b8ed74fc; });
function $13f1f07f67bc6a3e$export$a3bc9b8ed74fc(str) {
    throw `facing-metadata: ${str}`;
}

});




parcelRegister("iTlXO", function(module, exports) {

$parcel$export(module.exports, "toComponentReverse", function () { return $dc0e669b622bd904$export$24e76474a56d46af; });
$parcel$export(module.exports, "getSuperSlot", function () { return $dc0e669b622bd904$export$f5ff6a15189e0f60; });
$parcel$export(module.exports, "filterNames", function () { return $dc0e669b622bd904$export$899efafbba5f734f; });
$parcel$export(module.exports, "getValidOwnPropertyNames", function () { return $dc0e669b622bd904$export$f901187bd6d808f9; });
$parcel$export(module.exports, "getProviderFunction", function () { return $dc0e669b622bd904$export$4f6969ad550ef58b; });
$parcel$export(module.exports, "optionNullableMemberDecorator", function () { return $dc0e669b622bd904$export$d77d8c1a0bc3ba75; });
$parcel$export(module.exports, "optionNullableClassDecorator", function () { return $dc0e669b622bd904$export$3be4012fea40d4cb; });

var $cNyFo = parcelRequire("cNyFo");

var $8i16b = parcelRequire("8i16b");

var $loI0s = parcelRequire("loI0s");
function $dc0e669b622bd904$export$dd5385caa81b6660(proto) {
    const p = Object.getPrototypeOf(proto);
    if (!(p instanceof (0, $8i16b.Base))) return null;
    return p;
}
function $dc0e669b622bd904$export$24e76474a56d46af(proto) {
    const arr = [];
    let curr = proto;
    do {
        arr.unshift(curr);
        curr = $dc0e669b622bd904$export$dd5385caa81b6660(curr);
    }while (curr !== null && !(0, $loI0s.getSlot)(curr));
    return arr;
}
function $dc0e669b622bd904$export$f5ff6a15189e0f60(proto) {
    let curr = $dc0e669b622bd904$export$dd5385caa81b6660(proto);
    while(curr !== null){
        const slot = (0, $loI0s.getSlot)(curr);
        if (slot) return slot;
        curr = $dc0e669b622bd904$export$dd5385caa81b6660(curr);
    }
    return null;
}
function $dc0e669b622bd904$export$899efafbba5f734f(names, slot, mapNames) {
    return names.filter((name)=>{
        let currSlot = slot;
        while(currSlot != null){
            for (const mapName of currSlot.names.keys()){
                if (mapName === 'customDecorator') {
                    const map = currSlot.obtainMap('customDecorator');
                    if (map.has(name)) {
                        if (map.get(name).every((ite)=>!ite.preserve)) return false;
                    }
                }
                if (mapNames && mapNames.includes(mapName)) continue;
                const map = currSlot.names.get(mapName);
                if (map.has(name)) return false;
            }
            currSlot = $dc0e669b622bd904$export$f5ff6a15189e0f60(currSlot.master);
        }
        return true;
    });
}
function $dc0e669b622bd904$export$f901187bd6d808f9(obj, filter) {
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    return Object.keys(descriptors).filter((name)=>filter(descriptors[name], name));
}
function $dc0e669b622bd904$export$4f6969ad550ef58b(provide) {
    if (typeof provide === 'function') return provide;
    return function() {
        return provide || {};
    };
}
function $dc0e669b622bd904$export$d77d8c1a0bc3ba75(handler) {
    function decorator(optionOrProtoOrValue, nameOrCtx) {
        if (nameOrCtx) {
            const protoOrValue = optionOrProtoOrValue;
            (0, $cNyFo.compatibleMemberDecorator)(function(proto, name) {
                handler(proto, name);
            })(protoOrValue, nameOrCtx);
        } else {
            const option = optionOrProtoOrValue;
            return (0, $cNyFo.compatibleMemberDecorator)(function(proto, name) {
                handler(proto, name, option);
            });
        }
    }
    return decorator;
}
function $dc0e669b622bd904$export$3be4012fea40d4cb(handler) {
    function decorator(optionOrCons, ctx) {
        if (typeof optionOrCons === 'function') {
            const cons = optionOrCons;
            (0, $cNyFo.compatibleClassDecorator)(function(cons) {
                handler(cons);
            })(cons, ctx);
        } else {
            const option = optionOrCons;
            return (0, $cNyFo.compatibleClassDecorator)(function(cons) {
                handler(cons, option);
            });
        }
    }
    return decorator;
}

});
parcelRegister("cNyFo", function(module, exports) {

$parcel$export(module.exports, "compatibleClassDecorator", function () { return $9514f3b5e9cd0037$export$312d0557e589bc8a; });
$parcel$export(module.exports, "compatibleMemberDecorator", function () { return $9514f3b5e9cd0037$export$49d57d4a4f7496b6; });

var $loI0s = parcelRequire("loI0s");
const $9514f3b5e9cd0037$export$569d6cae07c10a88 = {};
function $9514f3b5e9cd0037$export$312d0557e589bc8a(deco) {
    return function(cons, ctx) {
        var _a;
        if (ctx) {
            if (ctx.kind !== 'class') throw 'deco stage 3 class';
            const proto = (_a = $9514f3b5e9cd0037$export$569d6cae07c10a88.fakePrototype) !== null && _a !== void 0 ? _a : $9514f3b5e9cd0037$export$569d6cae07c10a88.fakePrototype = {};
            const slot = (0, $loI0s.obtainSlot)(proto);
            delete $9514f3b5e9cd0037$export$569d6cae07c10a88.fakePrototype;
            (0, $loI0s.obtainSlot)(cons.prototype, slot);
            const ret = deco(cons);
            return ret;
        } else return deco(cons);
    };
}
function $9514f3b5e9cd0037$export$49d57d4a4f7496b6(deco) {
    return function(protoOrValue, nameOrCtx) {
        var _a;
        if (typeof nameOrCtx === 'object') {
            const ctx = nameOrCtx;
            const value = protoOrValue;
            const proto = (_a = $9514f3b5e9cd0037$export$569d6cae07c10a88.fakePrototype) !== null && _a !== void 0 ? _a : $9514f3b5e9cd0037$export$569d6cae07c10a88.fakePrototype = {};
            proto[ctx.name] = value;
            return deco(proto, ctx.name);
        } else {
            const name = nameOrCtx;
            const proto = protoOrValue;
            return deco(proto, name);
        }
    };
}

});

parcelRegister("8i16b", function(module, exports) {

$parcel$export(module.exports, "Base", function () { return $6090db59915a25ec$export$ef88aa0d34c34520; });
const $6090db59915a25ec$export$ef88aa0d34c34520 = class {
};

});


parcelRegister("bWe0F", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $8b0ffa830cc4c717$export$3f8fe6489e95757d; });

var $cNyFo = parcelRequire("cNyFo");

var $loI0s = parcelRequire("loI0s");
function $8b0ffa830cc4c717$export$46bdae34a7208737(setupFunction) {
    return (0, $cNyFo.compatibleMemberDecorator)(function(proto, name) {
        const slot = (0, $loI0s.obtainSlot)(proto);
        const map = slot.obtainMap('setup');
        map.set(name, {
            setupFunction: setupFunction
        });
    });
}
const $8b0ffa830cc4c717$var$isPromise = (v)=>v instanceof Promise;
function $8b0ffa830cc4c717$export$3f8fe6489e95757d(cons, optionBuilder) {
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const map = slot.getMap('setup');
    if (!map || map.size === 0) return;
    const setup = function(props, ctx) {
        const setupData = {};
        let promises = null;
        for (const name of map.keys()){
            const setupState = map.get(name).setupFunction(props, ctx);
            if ($8b0ffa830cc4c717$var$isPromise(setupState)) {
                promises !== null && promises !== void 0 ? promises : promises = [];
                promises.push(setupState.then((v)=>{
                    setupData[name] = v;
                }));
            } else setupData[name] = setupState;
        }
        if (Array.isArray(promises)) return Promise.all(promises).then(()=>{
            return setupData;
        });
        else return setupData;
    };
    optionBuilder.setup = setup;
}

});

parcelRegister("kqC8x", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $edf3d1862637cb11$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
function $edf3d1862637cb11$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.computed) !== null && _a !== void 0 ? _a : optionBuilder.computed = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const map = slot.obtainMap('computed');
    const vanillaMap = slot.obtainMap('vanilla');
    const protoArr = (0, $iTlXO.toComponentReverse)(cons.prototype);
    protoArr.forEach((proto)=>{
        (0, $iTlXO.getValidOwnPropertyNames)(proto, (des, name)=>{
            return (typeof des.get === 'function' || typeof des.set === 'function') && !vanillaMap.has(name);
        }).forEach((name)=>{
            map.set(name, true);
            const des = Object.getOwnPropertyDescriptor(proto, name);
            optionBuilder.computed[name] = {
                get: typeof des.get === 'function' ? des.get : undefined,
                set: typeof des.set === 'function' ? des.set : undefined
            };
        });
    });
}

});

parcelRegister("jolYj", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $e1e14d5667219347$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
function $e1e14d5667219347$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.data) !== null && _a !== void 0 ? _a : optionBuilder.data = {};
    const sample = new cons();
    let names = (0, $iTlXO.getValidOwnPropertyNames)(sample, (des, name)=>{
        var _a, _b;
        return !!des.enumerable && !((_a = optionBuilder.methods) === null || _a === void 0 ? void 0 : _a[name]) && !((_b = optionBuilder.props) === null || _b === void 0 ? void 0 : _b[name]);
    });
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    //include these names:
    //provide, user may access field directly
    //customDecorator
    names = (0, $iTlXO.filterNames)(names, slot, [
        'provide',
        'customDecorator'
    ]);
    Object.assign(optionBuilder.data, names.reduce((pv, cv)=>{
        pv[cv] = sample[cv];
        return pv;
    }, {}));
}

});

parcelRegister("h3ZfC", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $c6c23aa01657d361$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $c6c23aa01657d361$export$fd75dcd53aced7c6 = [
    "beforeCreate",
    "created",
    "beforeMount",
    "mounted",
    "beforeUpdate",
    "updated",
    "activated",
    "deactivated",
    "beforeDestroy",
    "beforeUnmount",
    "destroyed",
    "unmounted",
    "renderTracked",
    "renderTriggered",
    "errorCaptured",
    "serverPrefetch",
    "render"
];
const $c6c23aa01657d361$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('hooks');
    map.set(name, null);
});
function $c6c23aa01657d361$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a, _b, _c;
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const protoArr = (0, $iTlXO.toComponentReverse)(cons.prototype);
    const map = slot.obtainMap('hooks');
    (_a = optionBuilder.hooks) !== null && _a !== void 0 ? _a : optionBuilder.hooks = {};
    (_b = optionBuilder.methods) !== null && _b !== void 0 ? _b : optionBuilder.methods = {};
    const HookFunctions = {};
    const MethodFunctions = {};
    protoArr.forEach((proto)=>{
        let names = (0, $iTlXO.getValidOwnPropertyNames)(proto, (des, name)=>{
            return typeof des.value === 'function' && name !== 'constructor';
        });
        //include these names:
        //watch, user may call watch method directly
        //hooks, user may call hook method directly
        //emits, user may have a method name which is same as one of event names
        //provide, user may access field directly
        //customDecorator
        names = (0, $iTlXO.filterNames)(names, slot, [
            'watch',
            'hooks',
            'emits',
            'provide',
            'customDecorator'
        ]);
        names.forEach((name)=>{
            if ($c6c23aa01657d361$export$fd75dcd53aced7c6.includes(name) || map.has(name)) HookFunctions[name] = proto[name];
            else MethodFunctions[name] = proto[name];
        });
    });
    Object.assign(optionBuilder.methods, MethodFunctions);
    const beforeCreateCallbacks = [
        ...(_c = optionBuilder.beforeCreateCallbacks) !== null && _c !== void 0 ? _c : []
    ];
    if (beforeCreateCallbacks && beforeCreateCallbacks.length > 0) {
        const oldBeforeCreateCallback = HookFunctions['beforeCreate'];
        HookFunctions['beforeCreate'] = function() {
            beforeCreateCallbacks.forEach((callback)=>callback.apply(this, arguments));
            if (oldBeforeCreateCallback) oldBeforeCreateCallback.apply(this, arguments);
        };
    }
    Object.assign(optionBuilder.hooks, HookFunctions);
}

});

parcelRegister("lrmBZ", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $f9bda8cc22c1cd23$export$3f8fe6489e95757d; });

var $aUP80 = parcelRequire("aUP80");

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $f9bda8cc22c1cd23$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, key) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('ref');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $f9bda8cc22c1cd23$export$3f8fe6489e95757d(cons, optionBuilder) {
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.getMap('ref');
    if (!names || names.size === 0) return;
    (0, $aUP80.applyAccessors)(optionBuilder, (ctx)=>{
        const data = new Map;
        names.forEach((value, name)=>{
            const refKey = value === null ? name : value;
            data.set(name, {
                get: function() {
                    return ctx.$refs[refKey];
                },
                set: undefined
            });
        });
        return data;
    });
}

});
parcelRegister("aUP80", function(module, exports) {

$parcel$export(module.exports, "applyAccessors", function () { return $7f26cb55f8598ba4$export$f5db7f88babe0e97; });
function $7f26cb55f8598ba4$export$f5db7f88babe0e97(optionBuilder, dataFunc) {
    var _a;
    (_a = optionBuilder.beforeCreateCallbacks) !== null && _a !== void 0 ? _a : optionBuilder.beforeCreateCallbacks = [];
    optionBuilder.beforeCreateCallbacks.push(function() {
        const ctx = this;
        const data = dataFunc(ctx);
        data.forEach((v, n)=>{
            Object.defineProperty(ctx, n, v);
        });
    });
}

});


parcelRegister("3XCRw", function(module, exports) {

$parcel$export(module.exports, "decorator", function () { return $2e25070588dead41$export$46bdae34a7208737; });
$parcel$export(module.exports, "build", function () { return $2e25070588dead41$export$3f8fe6489e95757d; });

var $loI0s = parcelRequire("loI0s");

var $cNyFo = parcelRequire("cNyFo");
function $2e25070588dead41$export$46bdae34a7208737(key, option) {
    return (0, $cNyFo.compatibleMemberDecorator)(function(proto, name) {
        const slot = (0, $loI0s.obtainSlot)(proto);
        const map = slot.obtainMap('watch');
        const opt = Object.assign({}, option !== null && option !== void 0 ? option : {}, {
            key: key,
            handler: proto[name]
        });
        if (map.has(name)) {
            const t = map.get(name);
            if (Array.isArray(t)) t.push(opt);
            else map.set(name, [
                t,
                opt
            ]);
        } else map.set(name, opt);
    });
}
function $2e25070588dead41$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.watch) !== null && _a !== void 0 ? _a : optionBuilder.watch = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.getMap('watch');
    if (!names || names.size === 0) return;
    names.forEach((value, _name)=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        values.forEach((v)=>{
            if (!optionBuilder.watch[v.key]) optionBuilder.watch[v.key] = v;
            else {
                const t = optionBuilder.watch[v.key];
                if (Array.isArray(t)) t.push(v);
                else optionBuilder.watch[v.key] = [
                    t,
                    v
                ];
            }
        });
    });
}

});

parcelRegister("dOOCA", function(module, exports) {

$parcel$export(module.exports, "decorator", function () { return $0298a1e83485bbb2$export$46bdae34a7208737; });
$parcel$export(module.exports, "build", function () { return $0298a1e83485bbb2$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $0298a1e83485bbb2$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, option) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('props');
    const opt = Object.assign({}, option !== null && option !== void 0 ? option : {});
    map.set(name, opt);
});
function $0298a1e83485bbb2$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.props) !== null && _a !== void 0 ? _a : optionBuilder.props = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.getMap('props');
    if (!names || names.size === 0) return;
    names.forEach((value, name)=>{
        optionBuilder.props[name] = value;
    });
}

});

parcelRegister("j5Y3x", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $de6d11d41d74ac57$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $de6d11d41d74ac57$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, option) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('inject');
    const opt = Object.assign({}, option !== null && option !== void 0 ? option : {});
    map.set(name, opt);
});
function $de6d11d41d74ac57$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.inject) !== null && _a !== void 0 ? _a : optionBuilder.inject = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.getMap('inject');
    if (!names || names.size === 0) return;
    names.forEach((value, name)=>{
        optionBuilder.inject[name] = value;
    });
}

});

parcelRegister("iHHBW", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $d9de125d860f3e1e$export$3f8fe6489e95757d; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $d9de125d860f3e1e$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, key) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('provide');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $d9de125d860f3e1e$export$3f8fe6489e95757d(cons, optionBuilder, vueInstance) {
    var _a;
    (_a = optionBuilder.provide) !== null && _a !== void 0 ? _a : optionBuilder.provide = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.obtainMap('provide');
    if (!names) return null;
    names.forEach((value, name)=>{
        const key = value === null ? name : value;
        optionBuilder.provide[key] = (0, $3dLyd.computed)(()=>vueInstance[name]);
    });
}

});

parcelRegister("fsqjs", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $b40de1b91f2217ab$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
var $b40de1b91f2217ab$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b40de1b91f2217ab$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, key) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('emit');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $b40de1b91f2217ab$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.methods) !== null && _a !== void 0 ? _a : optionBuilder.methods = {};
    const proto = cons.prototype;
    const slot = (0, $loI0s.obtainSlot)(proto);
    const names = slot.getMap('emit');
    if (!names || names.size === 0) return;
    const emits = slot.obtainMap('emits');
    names.forEach((value, key)=>{
        const eventName = value === null ? key : value;
        emits.set(eventName, true);
        optionBuilder.methods[key] = function() {
            return $b40de1b91f2217ab$var$__awaiter(this, arguments, void 0, function*() {
                const ret = proto[key].apply(this, arguments);
                if (ret instanceof Promise) {
                    const proRet = yield ret;
                    this.$emit(eventName, proRet);
                } else if (ret === undefined) this.$emit(eventName);
                else this.$emit(eventName, ret);
            });
        };
    });
}

});

parcelRegister("hRBzK", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $d01488a0ecd15fea$export$3f8fe6489e95757d; });

var $iTlXO = parcelRequire("iTlXO");

var $dOOCA = parcelRequire("dOOCA");

var $loI0s = parcelRequire("loI0s");
const $d01488a0ecd15fea$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name, option) {
    var _a;
    option !== null && option !== void 0 ? option : option = {};
    const slot = (0, $loI0s.obtainSlot)(proto);
    let vmodelName = 'modelValue';
    const propsConfig = Object.assign({}, option);
    if (propsConfig) {
        vmodelName = (_a = propsConfig.name) !== null && _a !== void 0 ? _a : vmodelName;
        delete propsConfig.name;
    }
    (0, $dOOCA.decorator)(propsConfig)(proto, vmodelName);
    const map = slot.obtainMap('v-model');
    map.set(name, option);
});
function $d01488a0ecd15fea$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.computed) !== null && _a !== void 0 ? _a : optionBuilder.computed = {};
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const names = slot.getMap('v-model');
    if (!names || names.size === 0) return;
    const emits = slot.obtainMap('emits');
    names.forEach((value, name)=>{
        var _a;
        const vmodelName = (_a = value && value.name) !== null && _a !== void 0 ? _a : 'modelValue';
        const eventName = `update:${vmodelName}`;
        optionBuilder.computed[name] = {
            get: function() {
                return this[vmodelName];
            },
            set: function(val) {
                this.$emit(eventName, val);
            }
        };
        emits.set(eventName, true);
    });
}

});

parcelRegister("kmLhc", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $ed3a88d54cce6c30$export$3f8fe6489e95757d; });

var $aUP80 = parcelRequire("aUP80");

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
function $ed3a88d54cce6c30$export$3f8fe6489e95757d(cons, optionBuilder) {
    const slot = (0, $loI0s.obtainSlot)(cons.prototype);
    const vanillaMap = slot.getMap('vanilla');
    if (!vanillaMap || vanillaMap.size === 0) return;
    const protoArr = (0, $iTlXO.toComponentReverse)(cons.prototype);
    const map = new Map;
    (0, $aUP80.applyAccessors)(optionBuilder, (ctx)=>{
        protoArr.forEach((proto)=>{
            const deses = Object.getOwnPropertyDescriptors(proto);
            for(const name in deses){
                const des = deses[name];
                if (des && vanillaMap.has(name)) {
                    if (typeof des.get === 'function' || typeof des.set === 'function') map.set(name, {
                        set: typeof des.set === 'function' ? des.set.bind(ctx) : undefined,
                        get: typeof des.get === 'function' ? des.get.bind(ctx) : undefined
                    });
                }
            }
        });
        return map;
    });
}

});


parcelRegister("k03fS", function(module, exports) {

var $iTlXO = parcelRequire("iTlXO");

var $loI0s = parcelRequire("loI0s");
const $e8f65522bacfae53$export$46bdae34a7208737 = (0, $iTlXO.optionNullableMemberDecorator)(function(proto, name) {
    const slot = (0, $loI0s.obtainSlot)(proto);
    const map = slot.obtainMap('vanilla');
    map.set(name, true);
});

});

parcelRegister("6vnB4", function(module, exports) {

var $loI0s = parcelRequire("loI0s");

var $cNyFo = parcelRequire("cNyFo");
function $4bc7f12f87fa526a$export$13d893143ac665a6(creator, opt) {
    return (0, $cNyFo.compatibleMemberDecorator)(function(proto, key) {
        const slot = (0, $loI0s.obtainSlot)(proto);
        const map = slot.obtainMap('customDecorator');
        if (!map.has(key)) map.set(key, []);
        const arr = map.get(key);
        arr.push({
            key: key,
            creator: creator,
            preserve: !!(opt === null || opt === void 0 ? void 0 : opt.preserve)
        });
    });
}

});

parcelRegister("ebqAl", function(module, exports) {

var $8se3f = parcelRequire("8se3f");

var $loI0s = parcelRequire("loI0s");

var $8i16b = parcelRequire("8i16b");
function $a536b7040b642369$export$7d6c3ba1e86fd7aa(...conses) {
    class MixinsClass extends (0, $8i16b.Base) {
    }
    (0, $8se3f.ComponentBase)({
        mixins: conses.map((cons)=>(0, $loI0s.obtainSlot)(cons.prototype).cachedVueComponent)
    })(MixinsClass);
    return MixinsClass;
}

});

parcelRegister("9SF3p", function(module, exports) {

$parcel$export(module.exports, "TSX", function () { return $731900ae0bc2f9ba$export$94b8be0c52501862; });
function $731900ae0bc2f9ba$export$94b8be0c52501862() {
    return function(cons) {
        return cons;
    };
}

});

parcelRegister("aq4Ra", function(module, exports) {

});


parcelRegister("1mAlS", function(module, exports) {

$parcel$export(module.exports, "Observer", function () { return $8ca2220517fdb9d6$export$c1cbdee04e18ea8b; });
// src/index.ts

var $jprT2 = parcelRequire("jprT2");
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
var $SdEQh = parcelRequire("SdEQh");

var $cF2Ke = parcelRequire("cF2Ke");
var $8ca2220517fdb9d6$export$c1cbdee04e18ea8b = (0, $3dLyd.defineComponent)({
    data: ()=>({
            key: 0,
            dispose: ()=>{}
        }),
    mounted () {
        this.dispose = (0, $cF2Ke.reaction)(()=>this.$slots.default?.(), ()=>{
            this.forceUpdate();
        }, {
            requiresObservable: true
        });
    },
    unmounted () {
        this.dispose();
    },
    methods: {
        forceUpdate () {
            this.key++;
        }
    },
    render () {
        return (0, $3dLyd.h)(this.$slots.default, {
            mobxVueKey: this.key
        });
    }
});
function $8ca2220517fdb9d6$export$aa207039f277c5f(initializer, annotations) {
    const localObservable = (0, $SdEQh.shallowRef)((0, $cF2Ke.observable)(initializer(), annotations, {
        autoBind: true,
        deep: true
    }));
    const dispose = (0, $cF2Ke.reaction)(()=>(0, $cF2Ke.toJS)(localObservable.value), ()=>{
        (0, $SdEQh.triggerRef)(localObservable);
    }, {
        fireImmediately: false,
        delay: 0
    });
    (0, $jprT2.tryOnScopeDispose)(()=>{
        dispose();
    });
    return (0, $SdEQh.readonly)(localObservable);
}
// src/index.ts
var $8ca2220517fdb9d6$export$901cf72dabf2112a = {
    install: (app)=>{
        app.component("Observer", $8ca2220517fdb9d6$export$c1cbdee04e18ea8b);
    }
};
var $8ca2220517fdb9d6$export$2e2bcd8739ae039 = $8ca2220517fdb9d6$export$901cf72dabf2112a;

});
parcelRegister("jprT2", function(module, exports) {

$parcel$export(module.exports, "tryOnScopeDispose", function () { return $b764e52e3c6095c1$export$c3d49ae4e58d3d9d; });
parcelRequire("bOOIZ");
var $3dLyd = parcelRequire("3dLyd");
var $SdEQh = parcelRequire("SdEQh");
var $bOOIZ = parcelRequire("bOOIZ");
function $b764e52e3c6095c1$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $SdEQh.shallowRef)();
    (0, $3dLyd.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    });
    return (0, $SdEQh.readonly)(result);
}
function $b764e52e3c6095c1$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $SdEQh.ref)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $3dLyd.watch)(source, update, {
        flush: "sync"
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $SdEQh.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $SdEQh.getCurrentScope)()) {
        (0, $SdEQh.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $b764e52e3c6095c1$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function $b764e52e3c6095c1$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $SdEQh.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
const $b764e52e3c6095c1$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const $b764e52e3c6095c1$export$a797c3886d31ed0 = (key, value)=>{
    var _a;
    const instance = (_a = (0, $3dLyd.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$b764e52e3c6095c1$var$localProvidedStateMap.has(instance)) $b764e52e3c6095c1$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    const localProvidedState = $b764e52e3c6095c1$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    (0, $3dLyd.provide)(key, value);
};
const $b764e52e3c6095c1$export$89897216f9bf9933 = (...args)=>{
    var _a;
    const key = args[0];
    const instance = (_a = (0, $3dLyd.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("injectLocal must be called in setup");
    if ($b764e52e3c6095c1$var$localProvidedStateMap.has(instance) && key in $b764e52e3c6095c1$var$localProvidedStateMap.get(instance)) return $b764e52e3c6095c1$var$localProvidedStateMap.get(instance)[key];
    return (0, $3dLyd.inject)(...args);
};
function $b764e52e3c6095c1$export$91b9c7550061230e(composable, options) {
    const key = (options == null ? void 0 : options.injectionKey) || Symbol("InjectionState");
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $b764e52e3c6095c1$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$b764e52e3c6095c1$export$89897216f9bf9933(key);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $b764e52e3c6095c1$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!state) {
            scope = (0, $SdEQh.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $b764e52e3c6095c1$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    if (!(0, $bOOIZ.isVue3) && !(0, $3dLyd.version).startsWith("2.7.")) return;
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $SdEQh.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $b764e52e3c6095c1$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $SdEQh.unref)(obj);
    return (0, $SdEQh.unref)(obj)[key];
}
function $b764e52e3c6095c1$export$4e62c701997796c1(v) {
    return (0, $SdEQh.unref)(v) != null;
}
function $b764e52e3c6095c1$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $b764e52e3c6095c1$export$30bdcc2218aa9458(r) {
    return typeof r === "function" ? r() : (0, $SdEQh.unref)(r);
}
const $b764e52e3c6095c1$export$13fbab860e8afb41 = $b764e52e3c6095c1$export$30bdcc2218aa9458;
function $b764e52e3c6095c1$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $SdEQh.unref) : $b764e52e3c6095c1$export$30bdcc2218aa9458;
    return function(...args) {
        return (0, $3dLyd.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $b764e52e3c6095c1$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $b764e52e3c6095c1$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $b764e52e3c6095c1$export$45c769cf449a508c(objectRef) {
    if (!(0, $SdEQh.isRef)(objectRef)) return (0, $SdEQh.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $SdEQh.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $SdEQh.isRef)(objectRef.value[p]) && !(0, $SdEQh.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $SdEQh.reactive)(proxy);
}
function $b764e52e3c6095c1$export$35298289c11958e1(fn) {
    return $b764e52e3c6095c1$export$45c769cf449a508c((0, $3dLyd.computed)(fn));
}
function $b764e52e3c6095c1$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $b764e52e3c6095c1$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $SdEQh.toRefs)(obj)).filter(([k, v])=>!predicate($b764e52e3c6095c1$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(Object.entries((0, $SdEQh.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
const $b764e52e3c6095c1$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $b764e52e3c6095c1$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $b764e52e3c6095c1$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $b764e52e3c6095c1$export$aedb69ff3e31596c = (val)=>val != null;
const $b764e52e3c6095c1$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $b764e52e3c6095c1$var$toString = Object.prototype.toString;
const $b764e52e3c6095c1$export$a6cdc56e425d0d0a = (val)=>$b764e52e3c6095c1$var$toString.call(val) === "[object Object]";
const $b764e52e3c6095c1$export$461939dd4422153 = ()=>Date.now();
const $b764e52e3c6095c1$export$fc00ee57782020aa = ()=>+Date.now();
const $b764e52e3c6095c1$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $b764e52e3c6095c1$export$8793edee2d425525 = ()=>{};
const $b764e52e3c6095c1$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $b764e52e3c6095c1$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
const $b764e52e3c6095c1$export$fedb369cb70207f1 = /* @__PURE__ */ $b764e52e3c6095c1$var$getIsIOS();
function $b764e52e3c6095c1$var$getIsIOS() {
    var _a, _b;
    return $b764e52e3c6095c1$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $b764e52e3c6095c1$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $b764e52e3c6095c1$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $b764e52e3c6095c1$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $b764e52e3c6095c1$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $b764e52e3c6095c1$export$8793edee2d425525;
    };
    const filter = (invoke)=>{
        const duration = $b764e52e3c6095c1$export$30bdcc2218aa9458(ms);
        const maxDuration = $b764e52e3c6095c1$export$30bdcc2218aa9458(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(invoke());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $b764e52e3c6095c1$export$cd62e9dbf204fd92(ms, trailing = true, leading = true, rejectOnCancel = false) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $b764e52e3c6095c1$export$8793edee2d425525;
    let lastValue;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $b764e52e3c6095c1$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = $b764e52e3c6095c1$export$30bdcc2218aa9458(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $b764e52e3c6095c1$export$8d46ce8e0ead9c2b(extendFilter = $b764e52e3c6095c1$export$8cc0e33a27868391) {
    const isActive = (0, $SdEQh.ref)(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $SdEQh.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
const $b764e52e3c6095c1$export$2161f27fc78b6ab2 = {
    mounted: (0, $bOOIZ.isVue3) ? "mounted" : "inserted",
    updated: (0, $bOOIZ.isVue3) ? "updated" : "componentUpdated",
    unmounted: (0, $bOOIZ.isVue3) ? "unmounted" : "unbind"
};
function $b764e52e3c6095c1$var$cacheStringFunction(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const $b764e52e3c6095c1$var$hyphenateRE = /\B([A-Z])/g;
const $b764e52e3c6095c1$export$6e6a0a3676c4b8bb = $b764e52e3c6095c1$var$cacheStringFunction((str)=>str.replace($b764e52e3c6095c1$var$hyphenateRE, "-$1").toLowerCase());
const $b764e52e3c6095c1$var$camelizeRE = /-(\w)/g;
const $b764e52e3c6095c1$export$161d051f5dd25de7 = $b764e52e3c6095c1$var$cacheStringFunction((str)=>{
    return str.replace($b764e52e3c6095c1$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
function $b764e52e3c6095c1$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $b764e52e3c6095c1$export$f0954fd7d5368655(arg) {
    return arg;
}
function $b764e52e3c6095c1$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $b764e52e3c6095c1$export$468cda29b159ee5d(fn) {
    return fn();
}
function $b764e52e3c6095c1$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $b764e52e3c6095c1$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $b764e52e3c6095c1$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $b764e52e3c6095c1$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $b764e52e3c6095c1$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $b764e52e3c6095c1$export$5c967efe8efb656c(target) {
    return target || (0, $3dLyd.getCurrentInstance)();
}
function $b764e52e3c6095c1$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $SdEQh.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $SdEQh.readonly)((0, $SdEQh.customRef)(()=>({
            get: r,
            set: $b764e52e3c6095c1$export$8793edee2d425525
        }))) : (0, $SdEQh.ref)(r);
}
const $b764e52e3c6095c1$export$fb2b8a41d9966b32 = $b764e52e3c6095c1$export$1f60508e4f47b4b7;
function $b764e52e3c6095c1$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $b764e52e3c6095c1$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $SdEQh.toRefs)(obj)).filter(([k, v])=>predicate($b764e52e3c6095c1$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $b764e52e3c6095c1$export$1f60508e4f47b4b7(obj, k)
            ])));
}
function $b764e52e3c6095c1$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $SdEQh.customRef)((track, trigger)=>{
        let value = $b764e52e3c6095c1$export$30bdcc2218aa9458(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = $b764e52e3c6095c1$export$30bdcc2218aa9458(defaultValue);
                trigger();
            }, $b764e52e3c6095c1$export$30bdcc2218aa9458(afterMs));
        $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $b764e52e3c6095c1$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $b764e52e3c6095c1$export$a1f1cf91007f23bf($b764e52e3c6095c1$export$fca2c450ae03b38e(ms, options), fn);
}
function $b764e52e3c6095c1$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $SdEQh.ref)(value.value);
    const updater = $b764e52e3c6095c1$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $3dLyd.watch)(value, ()=>updater());
    return debounced;
}
function $b764e52e3c6095c1$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $3dLyd.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $b764e52e3c6095c1$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $b764e52e3c6095c1$export$a1f1cf91007f23bf($b764e52e3c6095c1$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $b764e52e3c6095c1$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $SdEQh.ref)(value.value);
    const updater = $b764e52e3c6095c1$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $3dLyd.watch)(value, ()=>updater());
    return throttled;
}
function $b764e52e3c6095c1$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $SdEQh.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $b764e52e3c6095c1$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $b764e52e3c6095c1$export$6b6db3af7a80e2d2 = $b764e52e3c6095c1$export$4b7f2010e13474b2;
function $b764e52e3c6095c1$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        if (0, $bOOIZ.isVue2) (0, $bOOIZ.set)(...args);
        else {
            const [target, key, value] = args;
            target[key] = value;
        }
    }
}
function $b764e52e3c6095c1$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $b764e52e3c6095c1$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $3dLyd.watch)(source, $b764e52e3c6095c1$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $b764e52e3c6095c1$export$37fdf671f882195e(source, cb, options = {}) {
    const { eventFilter: filter, ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $b764e52e3c6095c1$export$8d46ce8e0ead9c2b(filter);
    const stop = $b764e52e3c6095c1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: eventFilter
    });
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $b764e52e3c6095c1$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($b764e52e3c6095c1$export$37fdf671f882195e(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($b764e52e3c6095c1$export$37fdf671f882195e(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
function $b764e52e3c6095c1$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    if (!Array.isArray(targets)) targets = [
        targets
    ];
    return (0, $3dLyd.watch)(source, (newValue)=>targets.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $b764e52e3c6095c1$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $SdEQh.isRef)(objectRef)) return (0, $SdEQh.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $SdEQh.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _a;
                const replaceRef = (_a = $b764e52e3c6095c1$export$30bdcc2218aa9458(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
function $b764e52e3c6095c1$export$25180f6b7105226e(fn, sync = true, target) {
    const instance = $b764e52e3c6095c1$export$5c967efe8efb656c(target);
    if (instance) (0, $3dLyd.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $3dLyd.nextTick)(fn);
}
function $b764e52e3c6095c1$export$7b037ce8d7969c15(fn, target) {
    const instance = $b764e52e3c6095c1$export$5c967efe8efb656c(target);
    if (instance) (0, $3dLyd.onBeforeUnmount)(fn, target);
}
function $b764e52e3c6095c1$export$cf1be5b643f0827(fn, sync = true, target) {
    const instance = $b764e52e3c6095c1$export$5c967efe8efb656c();
    if (instance) (0, $3dLyd.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $3dLyd.nextTick)(fn);
}
function $b764e52e3c6095c1$export$9fa6e59ca833c930(fn, target) {
    const instance = $b764e52e3c6095c1$export$5c967efe8efb656c(target);
    if (instance) (0, $3dLyd.onUnmounted)(fn, target);
}
function $b764e52e3c6095c1$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $3dLyd.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    stop == null || stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($b764e52e3c6095c1$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $SdEQh.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $3dLyd.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    stop == null || stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($b764e52e3c6095c1$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(r)).finally(()=>{
            stop == null || stop();
            return $b764e52e3c6095c1$export$30bdcc2218aa9458(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes($b764e52e3c6095c1$export$30bdcc2218aa9458(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray($b764e52e3c6095c1$export$30bdcc2218aa9458(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $b764e52e3c6095c1$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $b764e52e3c6095c1$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $b764e52e3c6095c1$export$a40009bd2c363351(r) {
    return $b764e52e3c6095c1$var$createUntil(r);
}
function $b764e52e3c6095c1$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $b764e52e3c6095c1$export$34602ebc410e389c(...args) {
    var _a;
    const list = args[0];
    const values = args[1];
    let compareFn = (_a = args[2]) != null ? _a : $b764e52e3c6095c1$var$defaultComparator;
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).filter((x)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(values).findIndex((y)=>compareFn(x, y)) === -1));
}
function $b764e52e3c6095c1$export$1e5a400faddb345f(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).every((element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array)));
}
function $b764e52e3c6095c1$export$d62e4083f0a2d244(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).map((i)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(i)).filter(fn));
}
function $b764e52e3c6095c1$export$ace4ef07c63f605e(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458($b764e52e3c6095c1$export$30bdcc2218aa9458(list).find((element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array))));
}
function $b764e52e3c6095c1$export$3ec066cdb63e2970(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).findIndex((element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array)));
}
function $b764e52e3c6095c1$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $b764e52e3c6095c1$export$b59cd47693a134f7(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(!Array.prototype.findLast ? $b764e52e3c6095c1$var$findLast($b764e52e3c6095c1$export$30bdcc2218aa9458(list), (element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array)) : $b764e52e3c6095c1$export$30bdcc2218aa9458(list).findLast((element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array))));
}
function $b764e52e3c6095c1$var$isArrayIncludesOptions(obj) {
    return $b764e52e3c6095c1$export$a6cdc56e425d0d0a(obj) && $b764e52e3c6095c1$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $b764e52e3c6095c1$export$34f006a38543d952(...args) {
    var _a;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($b764e52e3c6095c1$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value2)=>element[key] === $b764e52e3c6095c1$export$30bdcc2218aa9458(value2);
    }
    comparator = comparator != null ? comparator : (element, value2)=>element === $b764e52e3c6095c1$export$30bdcc2218aa9458(value2);
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).slice(formIndex).some((element, index, array)=>comparator($b764e52e3c6095c1$export$30bdcc2218aa9458(element), $b764e52e3c6095c1$export$30bdcc2218aa9458(value), index, $b764e52e3c6095c1$export$30bdcc2218aa9458(array))));
}
function $b764e52e3c6095c1$export$4a02928bbff39848(list, separator) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).map((i)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(i)).join($b764e52e3c6095c1$export$30bdcc2218aa9458(separator)));
}
function $b764e52e3c6095c1$export$8cc4758f083c4ffe(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).map((i)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(i)).map(fn));
}
function $b764e52e3c6095c1$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer($b764e52e3c6095c1$export$30bdcc2218aa9458(sum), $b764e52e3c6095c1$export$30bdcc2218aa9458(value), index);
    return (0, $3dLyd.computed)(()=>{
        const resolved = $b764e52e3c6095c1$export$30bdcc2218aa9458(list);
        return args.length ? resolved.reduce(reduceCallback, $b764e52e3c6095c1$export$30bdcc2218aa9458(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $b764e52e3c6095c1$export$53834b0e1a20e7a3(list, fn) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$30bdcc2218aa9458(list).some((element, index, array)=>fn($b764e52e3c6095c1$export$30bdcc2218aa9458(element), index, array)));
}
function $b764e52e3c6095c1$var$uniq(array) {
    return Array.from(new Set(array));
}
function $b764e52e3c6095c1$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
function $b764e52e3c6095c1$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $3dLyd.computed)(()=>{
        const resolvedList = $b764e52e3c6095c1$export$30bdcc2218aa9458(list).map((element)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(element));
        return compareFn ? $b764e52e3c6095c1$var$uniqueElementsBy(resolvedList, compareFn) : $b764e52e3c6095c1$var$uniq(resolvedList);
    });
}
function $b764e52e3c6095c1$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $SdEQh.unref)(initialValue);
    const count = (0, $SdEQh.ref)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.min(max, count.value + delta);
    const dec = (delta = 1)=>count.value = Math.max(min, count.value - delta);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $b764e52e3c6095c1$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
const $b764e52e3c6095c1$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function $b764e52e3c6095c1$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $b764e52e3c6095c1$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $b764e52e3c6095c1$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $b764e52e3c6095c1$var$defaultMeridiem;
    const matches = {
        Yo: ()=>$b764e52e3c6095c1$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$b764e52e3c6095c1$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString(options.locales, {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString(options.locales, {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$b764e52e3c6095c1$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$b764e52e3c6095c1$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$b764e52e3c6095c1$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$b764e52e3c6095c1$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$b764e52e3c6095c1$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true)
    };
    return formatStr.replace($b764e52e3c6095c1$var$REGEX_FORMAT, (match, $1)=>{
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $b764e52e3c6095c1$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($b764e52e3c6095c1$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $b764e52e3c6095c1$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $3dLyd.computed)(()=>$b764e52e3c6095c1$export$3ae94a2503e890a1($b764e52e3c6095c1$export$fcc71269590ba0a8($b764e52e3c6095c1$export$30bdcc2218aa9458(date)), $b764e52e3c6095c1$export$30bdcc2218aa9458(formatStr), options));
}
function $b764e52e3c6095c1$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $SdEQh.ref)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = $b764e52e3c6095c1$export$30bdcc2218aa9458(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && $b764e52e3c6095c1$export$7383f122bf48ec30) resume();
    if ((0, $SdEQh.isRef)(interval) || typeof interval === "function") {
        const stopWatch = (0, $3dLyd.watch)(interval, ()=>{
            if (isActive.value && $b764e52e3c6095c1$export$7383f122bf48ec30) resume();
        });
        $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $b764e52e3c6095c1$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $SdEQh.ref)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $b764e52e3c6095c1$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: counter,
        reset: reset,
        ...controls
    };
    else return counter;
}
function $b764e52e3c6095c1$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $SdEQh.ref)((_a = options.initialValue) != null ? _a : null);
    (0, $3dLyd.watch)(source, ()=>ms.value = $b764e52e3c6095c1$export$fc00ee57782020aa(), options);
    return ms;
}
function $b764e52e3c6095c1$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true } = options;
    const isPending = (0, $SdEQh.ref)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, $b764e52e3c6095c1$export$30bdcc2218aa9458(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($b764e52e3c6095c1$export$7383f122bf48ec30) start();
    }
    $b764e52e3c6095c1$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $SdEQh.readonly)(isPending),
        start: start,
        stop: stop
    };
}
function $b764e52e3c6095c1$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $b764e52e3c6095c1$export$14705c14c13d528a(callback != null ? callback : $b764e52e3c6095c1$export$8793edee2d425525, interval, options);
    const ready = (0, $3dLyd.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
function $b764e52e3c6095c1$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $3dLyd.computed)(()=>{
        let resolved = $b764e52e3c6095c1$export$30bdcc2218aa9458(value);
        if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $b764e52e3c6095c1$export$8906942fea47e698(value) {
    return (0, $3dLyd.computed)(()=>`${$b764e52e3c6095c1$export$30bdcc2218aa9458(value)}`);
}
function $b764e52e3c6095c1$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $SdEQh.isRef)(initialValue);
    const _value = (0, $SdEQh.ref)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = $b764e52e3c6095c1$export$30bdcc2218aa9458(truthyValue);
            _value.value = _value.value === truthy ? $b764e52e3c6095c1$export$30bdcc2218aa9458(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $b764e52e3c6095c1$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...source instanceof Function ? source() : Array.isArray(source) ? source : $b764e52e3c6095c1$export$30bdcc2218aa9458(source)
    ];
    return (0, $3dLyd.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
function $b764e52e3c6095c1$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $SdEQh.ref)(0);
    const stop = $b764e52e3c6095c1$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= $b764e52e3c6095c1$export$30bdcc2218aa9458(count)) (0, $3dLyd.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $b764e52e3c6095c1$export$578b5d9cbe132cee(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $b764e52e3c6095c1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $b764e52e3c6095c1$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
function $b764e52e3c6095c1$export$79f242cf85fb93a(source, cb, options) {
    return (0, $3dLyd.watch)(source, cb, {
        ...options,
        deep: true
    });
}
function $b764e52e3c6095c1$export$63ac06655f58d92a(source, cb, options = {}) {
    const { eventFilter: eventFilter = $b764e52e3c6095c1$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $b764e52e3c6095c1$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $SdEQh.ref)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $3dLyd.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $SdEQh.ref)(0);
        const syncCounter = (0, $SdEQh.ref)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $3dLyd.watch)(source, ()=>{
            syncCounter.value++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $3dLyd.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $b764e52e3c6095c1$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $3dLyd.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
function $b764e52e3c6095c1$export$95d4a8ca30b80ae0(source, cb, options) {
    const stop = (0, $3dLyd.watch)(source, (...args)=>{
        (0, $3dLyd.nextTick)(()=>stop());
        return cb(...args);
    }, options);
    return stop;
}
function $b764e52e3c6095c1$export$2768dce732d5eb3(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $b764e52e3c6095c1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $b764e52e3c6095c1$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
function $b764e52e3c6095c1$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $b764e52e3c6095c1$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($b764e52e3c6095c1$var$getWatchSources(source), $b764e52e3c6095c1$var$getOldValue(source));
        });
        return res2;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $b764e52e3c6095c1$var$getWatchSources(sources) {
    if ((0, $SdEQh.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>$b764e52e3c6095c1$export$30bdcc2218aa9458(item));
    return $b764e52e3c6095c1$export$30bdcc2218aa9458(sources);
}
function $b764e52e3c6095c1$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $b764e52e3c6095c1$export$909eba9696cc3445(source, cb, options) {
    return (0, $3dLyd.watch)(source, (v, ov, onInvalidate)=>{
        if (v) cb(v, ov, onInvalidate);
    }, options);
}

});
parcelRegister("bOOIZ", function(module, exports) {

$parcel$export(module.exports, "isVue2", function () { return $330a8a4d792339f4$export$1da84e343e81ceb9; });
$parcel$export(module.exports, "isVue3", function () { return $330a8a4d792339f4$export$34b222e3d4733e48; });
$parcel$export(module.exports, "set", function () { return $330a8a4d792339f4$export$adaa4cf7ef1b65be; });

var $fyBkV = parcelRequire("fyBkV");
var $330a8a4d792339f4$export$1da84e343e81ceb9 = false;
var $330a8a4d792339f4$export$34b222e3d4733e48 = true;
var $330a8a4d792339f4$export$a8cb34872e7d8b79 = undefined;
function $330a8a4d792339f4$export$4b3e715f166fdd78() {}
function $330a8a4d792339f4$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $330a8a4d792339f4$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}
$parcel$exportWildcard(module.exports, $fyBkV);

});





parcelRegister("cjZH9", function(module, exports) {

$parcel$export(module.exports, "buttonVariants", function () { return $cd21c284b0688972$export$dca1ee5a936bb312; });
$parcel$export(module.exports, "Button", function () { return (parcelRequire("12X8W")).default; });

var $cAeXR = parcelRequire("cAeXR");

var $12X8W = parcelRequire("12X8W");
const $cd21c284b0688972$export$dca1ee5a936bb312 = (0, $cAeXR.cva)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            "default": "h-10 px-4 py-2",
            "sm": "h-9 rounded-md px-3",
            "lg": "h-11 rounded-md px-8",
            "icon": "h-10 w-10",
            "icon-sm": "size-9",
            "icon-lg": "size-11"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});

});
parcelRegister("cAeXR", function(module, exports) {

$parcel$export(module.exports, "cva", function () { return $353b901d58838839$export$87dc52566e90b739; });
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $ajIhI = parcelRequire("ajIhI");
const $353b901d58838839$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $353b901d58838839$export$a274e22fb40f762e = (0, $ajIhI.clsx);
const $353b901d58838839$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $353b901d58838839$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $353b901d58838839$var$falsyToString(variantProp) || $353b901d58838839$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $353b901d58838839$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

});
parcelRegister("ajIhI", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $3622a645c822ba87$export$4f5d2d50c9deca37; });
function $3622a645c822ba87$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $3622a645c822ba87$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $3622a645c822ba87$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $3622a645c822ba87$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3622a645c822ba87$export$2e2bcd8739ae039 = $3622a645c822ba87$export$4f5d2d50c9deca37;

});


parcelRegister("12X8W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c33daf2b6a98ad6$export$2e2bcd8739ae039; });
let $0c33daf2b6a98ad6$var$script;



let $0c33daf2b6a98ad6$var$initialize = ()=>{
    $0c33daf2b6a98ad6$var$script = (parcelRequire("ihv3b"));
    if ($0c33daf2b6a98ad6$var$script.__esModule) $0c33daf2b6a98ad6$var$script = $0c33daf2b6a98ad6$var$script.default;
    $0c33daf2b6a98ad6$var$script.render = (parcelRequire("QR13Y")).render;
    (parcelRequire("1CRNk")).default($0c33daf2b6a98ad6$var$script);
    $0c33daf2b6a98ad6$var$script.__scopeId = 'data-v-782b48';
    $0c33daf2b6a98ad6$var$script.__file = "Button.vue";
};
$0c33daf2b6a98ad6$var$initialize();
var $0c33daf2b6a98ad6$export$2e2bcd8739ae039 = $0c33daf2b6a98ad6$var$script;

});
parcelRegister("ihv3b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6bf85432af4852fd$export$2e2bcd8739ae039; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");

var $8jUgy = parcelRequire("8jUgy");

var $g9cuX = parcelRequire("g9cuX");

var $cjZH9 = parcelRequire("cjZH9");
var $6bf85432af4852fd$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $3dLyd.defineComponent)({
    __name: 'Button',
    props: {
        variant: {},
        size: {},
        class: {
            type: [
                Boolean,
                null,
                String,
                Object,
                Array
            ]
        },
        asChild: {
            type: Boolean
        },
        as: {
            default: "button"
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props,
            get Primitive () {
                return 0, $8jUgy.Primitive;
            },
            get cn () {
                return 0, $g9cuX.cn;
            },
            get buttonVariants () {
                return 0, $cjZH9.buttonVariants;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("8jUgy", function(module, exports) {

$parcel$export(module.exports, "Primitive", function () { return $60ebbe55f6430146$export$250ffa63cdc0d034; });

var $gSUyW = parcelRequire("gSUyW");
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/Primitive/Primitive.ts
const $60ebbe55f6430146$var$SELF_CLOSING_TAGS = [
    "area",
    "img",
    "input"
];
const $60ebbe55f6430146$export$250ffa63cdc0d034 = /*#__PURE__*/ (0, $3dLyd.defineComponent)({
    name: "Primitive",
    inheritAttrs: false,
    props: {
        asChild: {
            type: Boolean,
            default: false
        },
        as: {
            type: [
                String,
                Object
            ],
            default: "div"
        }
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const asTag = props.asChild ? "template" : props.as;
        if (typeof asTag === "string" && $60ebbe55f6430146$var$SELF_CLOSING_TAGS.includes(asTag)) return ()=>(0, $3dLyd.h)(asTag, attrs);
        if (asTag !== "template") return ()=>(0, $3dLyd.h)(props.as, attrs, {
                default: slots.default
            });
        return ()=>(0, $3dLyd.h)((0, $gSUyW.Slot), attrs, {
                default: slots.default
            });
    }
});

});
parcelRegister("gSUyW", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $c4ad90a65ca4c431$export$8c6ed5c666ac1360; });

var $6R8f2 = parcelRequire("6R8f2");
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/Primitive/Slot.ts
const $c4ad90a65ca4c431$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $3dLyd.defineComponent)({
    name: "PrimitiveSlot",
    inheritAttrs: false,
    setup (_, { attrs: attrs, slots: slots }) {
        return ()=>{
            if (!slots.default) return null;
            const children = (0, $6R8f2.renderSlotFragments)(slots.default());
            const firstNonCommentChildrenIndex = children.findIndex((child)=>child.type !== (0, $3dLyd.Comment));
            if (firstNonCommentChildrenIndex === -1) return children;
            const firstNonCommentChildren = children[firstNonCommentChildrenIndex];
            delete firstNonCommentChildren.props?.ref;
            const mergedProps = firstNonCommentChildren.props ? (0, $3dLyd.mergeProps)(attrs, firstNonCommentChildren.props) : attrs;
            const cloned = (0, $3dLyd.cloneVNode)({
                ...firstNonCommentChildren,
                props: {}
            }, mergedProps);
            if (children.length === 1) return cloned;
            children[firstNonCommentChildrenIndex] = cloned;
            return children;
        };
    }
});

});
parcelRegister("6R8f2", function(module, exports) {

$parcel$export(module.exports, "renderSlotFragments", function () { return $4fde15ed12be8965$export$e3200b1318e9d1; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/shared/renderSlotFragments.ts
function $4fde15ed12be8965$export$e3200b1318e9d1(children) {
    if (!children) return [];
    return children.flatMap((child)=>{
        if (child.type === (0, $3dLyd.Fragment)) return $4fde15ed12be8965$export$e3200b1318e9d1(child.children);
        return [
            child
        ];
    });
}

});



parcelRegister("g9cuX", function(module, exports) {

$parcel$export(module.exports, "cn", function () { return $c08547c4ddec854c$export$1343a74baacb0543; });

var $ajIhI = parcelRequire("ajIhI");

var $8PRYw = parcelRequire("8PRYw");
const $c08547c4ddec854c$export$1343a74baacb0543 = (...inputs)=>(0, $8PRYw.twMerge)((0, $ajIhI.clsx)(inputs));

});
parcelRegister("8PRYw", function(module, exports) {

$parcel$export(module.exports, "twMerge", function () { return $ac50df6aa25f3147$export$b4660bb6000dfbc9; });
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $ac50df6aa25f3147$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $ac50df6aa25f3147$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $ac50df6aa25f3147$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $ac50df6aa25f3147$var$CLASS_PART_SEPARATOR = '-';
const $ac50df6aa25f3147$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $ac50df6aa25f3147$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $ac50df6aa25f3147$var$createClassGroupUtils = (config)=>{
    const classMap = $ac50df6aa25f3147$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $ac50df6aa25f3147$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($ac50df6aa25f3147$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $ac50df6aa25f3147$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $ac50df6aa25f3147$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $ac50df6aa25f3147$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $ac50df6aa25f3147$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $ac50df6aa25f3147$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $ac50df6aa25f3147$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($ac50df6aa25f3147$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($ac50df6aa25f3147$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $ac50df6aa25f3147$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $ac50df6aa25f3147$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $ac50df6aa25f3147$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $ac50df6aa25f3147$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $ac50df6aa25f3147$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $ac50df6aa25f3147$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $ac50df6aa25f3147$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $ac50df6aa25f3147$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $ac50df6aa25f3147$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $ac50df6aa25f3147$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $ac50df6aa25f3147$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $ac50df6aa25f3147$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $ac50df6aa25f3147$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $ac50df6aa25f3147$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $ac50df6aa25f3147$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $ac50df6aa25f3147$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($ac50df6aa25f3147$var$isThemeGetter(classDefinition)) {
        $ac50df6aa25f3147$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($ac50df6aa25f3147$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $ac50df6aa25f3147$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $ac50df6aa25f3147$var$processClassesRecursively(value, $ac50df6aa25f3147$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $ac50df6aa25f3147$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($ac50df6aa25f3147$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $ac50df6aa25f3147$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $ac50df6aa25f3147$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $ac50df6aa25f3147$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $ac50df6aa25f3147$var$IMPORTANT_MODIFIER = '!';
const $ac50df6aa25f3147$var$MODIFIER_SEPARATOR = ':';
const $ac50df6aa25f3147$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $ac50df6aa25f3147$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $ac50df6aa25f3147$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $ac50df6aa25f3147$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($ac50df6aa25f3147$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($ac50df6aa25f3147$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $ac50df6aa25f3147$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $ac50df6aa25f3147$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $ac50df6aa25f3147$var$createResultObject($ac50df6aa25f3147$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $ac50df6aa25f3147$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $ac50df6aa25f3147$var$createConfigUtils = (config)=>({
        cache: $ac50df6aa25f3147$var$createLruCache(config.cacheSize),
        parseClassName: $ac50df6aa25f3147$var$createParseClassName(config),
        sortModifiers: $ac50df6aa25f3147$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $ac50df6aa25f3147$var$createPostfixLookupClassGroupIds(config),
        ...$ac50df6aa25f3147$var$createClassGroupUtils(config)
    });
const $ac50df6aa25f3147$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $ac50df6aa25f3147$var$SPLIT_CLASSES_REGEX = /\s+/;
const $ac50df6aa25f3147$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($ac50df6aa25f3147$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $ac50df6aa25f3147$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $ac50df6aa25f3147$export$a8bbfb445e1f163f = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $ac50df6aa25f3147$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $ac50df6aa25f3147$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $ac50df6aa25f3147$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $ac50df6aa25f3147$export$ea2d4fba4d1bd27f = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $ac50df6aa25f3147$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $ac50df6aa25f3147$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($ac50df6aa25f3147$export$a8bbfb445e1f163f(...args));
};
const $ac50df6aa25f3147$var$fallbackThemeArr = [];
const $ac50df6aa25f3147$export$e176af7b8eefe933 = (key)=>{
    const themeGetter = (theme)=>theme[key] || $ac50df6aa25f3147$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    themeGetter.themeKey = key;
    return themeGetter;
};
const $ac50df6aa25f3147$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $ac50df6aa25f3147$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $ac50df6aa25f3147$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $ac50df6aa25f3147$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $ac50df6aa25f3147$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $ac50df6aa25f3147$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $ac50df6aa25f3147$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $ac50df6aa25f3147$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $ac50df6aa25f3147$var$isFraction = (value)=>$ac50df6aa25f3147$var$fractionRegex.test(value);
const $ac50df6aa25f3147$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $ac50df6aa25f3147$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $ac50df6aa25f3147$var$isPercent = (value)=>value.endsWith('%') && $ac50df6aa25f3147$var$isNumber(value.slice(0, -1));
const $ac50df6aa25f3147$var$isTshirtSize = (value)=>$ac50df6aa25f3147$var$tshirtUnitRegex.test(value);
const $ac50df6aa25f3147$var$isAny = ()=>true;
const $ac50df6aa25f3147$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $ac50df6aa25f3147$var$lengthUnitRegex.test(value) && !$ac50df6aa25f3147$var$colorFunctionRegex.test(value);
const $ac50df6aa25f3147$var$isNever = ()=>false;
const $ac50df6aa25f3147$var$isShadow = (value)=>$ac50df6aa25f3147$var$shadowRegex.test(value);
const $ac50df6aa25f3147$var$isImage = (value)=>$ac50df6aa25f3147$var$imageRegex.test(value);
const $ac50df6aa25f3147$var$isAnyNonArbitrary = (value)=>!$ac50df6aa25f3147$var$isArbitraryValue(value) && !$ac50df6aa25f3147$var$isArbitraryVariable(value);
const $ac50df6aa25f3147$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $ac50df6aa25f3147$var$isArbitrarySize = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelSize, $ac50df6aa25f3147$var$isNever);
const $ac50df6aa25f3147$var$isArbitraryValue = (value)=>$ac50df6aa25f3147$var$arbitraryValueRegex.test(value);
const $ac50df6aa25f3147$var$isArbitraryLength = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelLength, $ac50df6aa25f3147$var$isLengthOnly);
const $ac50df6aa25f3147$var$isArbitraryNumber = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelNumber, $ac50df6aa25f3147$var$isNumber);
const $ac50df6aa25f3147$var$isArbitraryWeight = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelWeight, $ac50df6aa25f3147$var$isAny);
const $ac50df6aa25f3147$var$isArbitraryFamilyName = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelFamilyName, $ac50df6aa25f3147$var$isNever);
const $ac50df6aa25f3147$var$isArbitraryPosition = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelPosition, $ac50df6aa25f3147$var$isNever);
const $ac50df6aa25f3147$var$isArbitraryImage = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelImage, $ac50df6aa25f3147$var$isImage);
const $ac50df6aa25f3147$var$isArbitraryShadow = (value)=>$ac50df6aa25f3147$var$getIsArbitraryValue(value, $ac50df6aa25f3147$var$isLabelShadow, $ac50df6aa25f3147$var$isShadow);
const $ac50df6aa25f3147$var$isArbitraryVariable = (value)=>$ac50df6aa25f3147$var$arbitraryVariableRegex.test(value);
const $ac50df6aa25f3147$var$isArbitraryVariableLength = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelLength);
const $ac50df6aa25f3147$var$isArbitraryVariableFamilyName = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelFamilyName);
const $ac50df6aa25f3147$var$isArbitraryVariablePosition = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelPosition);
const $ac50df6aa25f3147$var$isArbitraryVariableSize = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelSize);
const $ac50df6aa25f3147$var$isArbitraryVariableImage = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelImage);
const $ac50df6aa25f3147$var$isArbitraryVariableShadow = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelShadow, true);
const $ac50df6aa25f3147$var$isArbitraryVariableWeight = (value)=>$ac50df6aa25f3147$var$getIsArbitraryVariable(value, $ac50df6aa25f3147$var$isLabelWeight, true);
// Helpers
const $ac50df6aa25f3147$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $ac50df6aa25f3147$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $ac50df6aa25f3147$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $ac50df6aa25f3147$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $ac50df6aa25f3147$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $ac50df6aa25f3147$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $ac50df6aa25f3147$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $ac50df6aa25f3147$var$isLabelLength = (label)=>label === 'length';
const $ac50df6aa25f3147$var$isLabelNumber = (label)=>label === 'number';
const $ac50df6aa25f3147$var$isLabelFamilyName = (label)=>label === 'family-name';
const $ac50df6aa25f3147$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $ac50df6aa25f3147$var$isLabelShadow = (label)=>label === 'shadow';
const $ac50df6aa25f3147$export$6f98703d2f5d4276 = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $ac50df6aa25f3147$var$isAny,
    isAnyNonArbitrary: $ac50df6aa25f3147$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $ac50df6aa25f3147$var$isArbitraryFamilyName,
    isArbitraryImage: $ac50df6aa25f3147$var$isArbitraryImage,
    isArbitraryLength: $ac50df6aa25f3147$var$isArbitraryLength,
    isArbitraryNumber: $ac50df6aa25f3147$var$isArbitraryNumber,
    isArbitraryPosition: $ac50df6aa25f3147$var$isArbitraryPosition,
    isArbitraryShadow: $ac50df6aa25f3147$var$isArbitraryShadow,
    isArbitrarySize: $ac50df6aa25f3147$var$isArbitrarySize,
    isArbitraryValue: $ac50df6aa25f3147$var$isArbitraryValue,
    isArbitraryVariable: $ac50df6aa25f3147$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $ac50df6aa25f3147$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $ac50df6aa25f3147$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $ac50df6aa25f3147$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $ac50df6aa25f3147$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $ac50df6aa25f3147$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $ac50df6aa25f3147$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $ac50df6aa25f3147$var$isArbitraryVariableWeight,
    isArbitraryWeight: $ac50df6aa25f3147$var$isArbitraryWeight,
    isFraction: $ac50df6aa25f3147$var$isFraction,
    isInteger: $ac50df6aa25f3147$var$isInteger,
    isNamedContainerQuery: $ac50df6aa25f3147$var$isNamedContainerQuery,
    isNumber: $ac50df6aa25f3147$var$isNumber,
    isPercent: $ac50df6aa25f3147$var$isPercent,
    isTshirtSize: $ac50df6aa25f3147$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $ac50df6aa25f3147$export$ed30944e0fe6ae5c = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $ac50df6aa25f3147$export$e176af7b8eefe933('color');
    const themeFont = $ac50df6aa25f3147$export$e176af7b8eefe933('font');
    const themeText = $ac50df6aa25f3147$export$e176af7b8eefe933('text');
    const themeFontWeight = $ac50df6aa25f3147$export$e176af7b8eefe933('font-weight');
    const themeTracking = $ac50df6aa25f3147$export$e176af7b8eefe933('tracking');
    const themeLeading = $ac50df6aa25f3147$export$e176af7b8eefe933('leading');
    const themeBreakpoint = $ac50df6aa25f3147$export$e176af7b8eefe933('breakpoint');
    const themeContainer = $ac50df6aa25f3147$export$e176af7b8eefe933('container');
    const themeSpacing = $ac50df6aa25f3147$export$e176af7b8eefe933('spacing');
    const themeRadius = $ac50df6aa25f3147$export$e176af7b8eefe933('radius');
    const themeShadow = $ac50df6aa25f3147$export$e176af7b8eefe933('shadow');
    const themeInsetShadow = $ac50df6aa25f3147$export$e176af7b8eefe933('inset-shadow');
    const themeTextShadow = $ac50df6aa25f3147$export$e176af7b8eefe933('text-shadow');
    const themeDropShadow = $ac50df6aa25f3147$export$e176af7b8eefe933('drop-shadow');
    const themeBlur = $ac50df6aa25f3147$export$e176af7b8eefe933('blur');
    const themePerspective = $ac50df6aa25f3147$export$e176af7b8eefe933('perspective');
    const themeAspect = $ac50df6aa25f3147$export$e176af7b8eefe933('aspect');
    const themeEase = $ac50df6aa25f3147$export$e176af7b8eefe933('ease');
    const themeAnimate = $ac50df6aa25f3147$export$e176af7b8eefe933('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $ac50df6aa25f3147$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $ac50df6aa25f3147$var$isInteger,
            'none',
            'subgrid',
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $ac50df6aa25f3147$var$isInteger,
                    $ac50df6aa25f3147$var$isArbitraryVariable,
                    $ac50df6aa25f3147$var$isArbitraryValue
                ]
            },
            $ac50df6aa25f3147$var$isInteger,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $ac50df6aa25f3147$var$isInteger,
            'auto',
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $ac50df6aa25f3147$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            themeContainer,
            $ac50df6aa25f3147$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $ac50df6aa25f3147$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $ac50df6aa25f3147$var$isArbitraryVariablePosition,
            $ac50df6aa25f3147$var$isArbitraryPosition,
            {
                position: [
                    $ac50df6aa25f3147$var$isArbitraryVariable,
                    $ac50df6aa25f3147$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $ac50df6aa25f3147$var$isArbitraryVariableSize,
            $ac50df6aa25f3147$var$isArbitrarySize,
            {
                size: [
                    $ac50df6aa25f3147$var$isArbitraryVariable,
                    $ac50df6aa25f3147$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $ac50df6aa25f3147$var$isPercent,
            $ac50df6aa25f3147$var$isArbitraryVariableLength,
            $ac50df6aa25f3147$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $ac50df6aa25f3147$var$isNumber,
            $ac50df6aa25f3147$var$isArbitraryVariableLength,
            $ac50df6aa25f3147$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $ac50df6aa25f3147$var$isNumber,
            $ac50df6aa25f3147$var$isPercent,
            $ac50df6aa25f3147$var$isArbitraryVariablePosition,
            $ac50df6aa25f3147$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $ac50df6aa25f3147$var$isNumber,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $ac50df6aa25f3147$var$isNumber,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $ac50df6aa25f3147$var$isNumber,
            $ac50df6aa25f3147$var$isArbitraryVariable,
            $ac50df6aa25f3147$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $ac50df6aa25f3147$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            breakpoint: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            color: [
                $ac50df6aa25f3147$var$isAny
            ],
            container: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            'drop-shadow': [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $ac50df6aa25f3147$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            shadow: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            spacing: [
                'px',
                $ac50df6aa25f3147$var$isNumber
            ],
            text: [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            'text-shadow': [
                $ac50df6aa25f3147$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $ac50df6aa25f3147$var$isFraction,
                        $ac50df6aa25f3147$var$isArbitraryValue,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $ac50df6aa25f3147$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $ac50df6aa25f3147$var$isNumber,
                        'auto',
                        $ac50df6aa25f3147$var$isArbitraryValue,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $ac50df6aa25f3147$var$isInteger,
                        'auto',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $ac50df6aa25f3147$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $ac50df6aa25f3147$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $ac50df6aa25f3147$var$isArbitraryVariableLength,
                        $ac50df6aa25f3147$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $ac50df6aa25f3147$var$isArbitraryVariableWeight,
                        $ac50df6aa25f3147$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $ac50df6aa25f3147$var$isPercent,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $ac50df6aa25f3147$var$isArbitraryVariableFamilyName,
                        $ac50df6aa25f3147$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $ac50df6aa25f3147$var$isNumber,
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $ac50df6aa25f3147$var$isNumber,
                        'from-font',
                        'auto',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $ac50df6aa25f3147$var$isNumber,
                        'auto',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $ac50df6aa25f3147$var$isInteger,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $ac50df6aa25f3147$var$isInteger,
                                $ac50df6aa25f3147$var$isArbitraryVariable,
                                $ac50df6aa25f3147$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $ac50df6aa25f3147$var$isArbitraryVariable,
                                $ac50df6aa25f3147$var$isArbitraryValue
                            ],
                            conic: [
                                '',
                                $ac50df6aa25f3147$var$isInteger,
                                $ac50df6aa25f3147$var$isArbitraryVariable,
                                $ac50df6aa25f3147$var$isArbitraryValue
                            ]
                        },
                        $ac50df6aa25f3147$var$isArbitraryVariableImage,
                        $ac50df6aa25f3147$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariableLength,
                        $ac50df6aa25f3147$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        // Deprecated since Tailwind CSS v4.0.0
                        'inner',
                        'none',
                        themeShadow,
                        $ac50df6aa25f3147$var$isArbitraryVariableShadow,
                        $ac50df6aa25f3147$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $ac50df6aa25f3147$var$isArbitraryVariableShadow,
                        $ac50df6aa25f3147$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $ac50df6aa25f3147$var$isArbitraryVariableShadow,
                        $ac50df6aa25f3147$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $ac50df6aa25f3147$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $ac50df6aa25f3147$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $ac50df6aa25f3147$var$isArbitraryVariableShadow,
                        $ac50df6aa25f3147$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $ac50df6aa25f3147$var$isNumber,
                        'initial',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $ac50df6aa25f3147$var$isInteger,
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $ac50df6aa25f3147$var$isArbitraryVariable,
                        $ac50df6aa25f3147$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $ac50df6aa25f3147$var$isNumber,
                        $ac50df6aa25f3147$var$isArbitraryVariableLength,
                        $ac50df6aa25f3147$var$isArbitraryLength,
                        $ac50df6aa25f3147$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'start',
                'end',
                'right',
                'left'
            ],
            'inset-y': [
                'inset-bs',
                'inset-be',
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'ps',
                'pe',
                'pr',
                'pl'
            ],
            py: [
                'pbs',
                'pbe',
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'ms',
                'me',
                'mr',
                'ml'
            ],
            my: [
                'mbs',
                'mbe',
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-s',
                'border-w-e',
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-s',
                'border-color-e',
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-ms',
                'scroll-me',
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-ps',
                'scroll-pe',
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $ac50df6aa25f3147$export$5d86b86a654a7039 = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $ac50df6aa25f3147$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $ac50df6aa25f3147$var$overrideProperty(baseConfig, 'prefix', prefix);
    $ac50df6aa25f3147$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $ac50df6aa25f3147$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $ac50df6aa25f3147$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $ac50df6aa25f3147$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $ac50df6aa25f3147$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $ac50df6aa25f3147$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $ac50df6aa25f3147$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $ac50df6aa25f3147$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $ac50df6aa25f3147$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $ac50df6aa25f3147$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $ac50df6aa25f3147$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $ac50df6aa25f3147$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $ac50df6aa25f3147$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $ac50df6aa25f3147$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $ac50df6aa25f3147$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$ac50df6aa25f3147$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $ac50df6aa25f3147$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$ac50df6aa25f3147$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $ac50df6aa25f3147$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $ac50df6aa25f3147$export$c8d8406b6cd2243e = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $ac50df6aa25f3147$export$ea2d4fba4d1bd27f($ac50df6aa25f3147$export$ed30944e0fe6ae5c, configExtension, ...createConfig) : $ac50df6aa25f3147$export$ea2d4fba4d1bd27f(()=>$ac50df6aa25f3147$export$5d86b86a654a7039($ac50df6aa25f3147$export$ed30944e0fe6ae5c(), configExtension), ...createConfig);
const $ac50df6aa25f3147$export$b4660bb6000dfbc9 = /*#__PURE__*/ $ac50df6aa25f3147$export$ea2d4fba4d1bd27f($ac50df6aa25f3147$export$ed30944e0fe6ae5c);

});



parcelRegister("QR13Y", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $09edfb587ff0ff8a$export$b3890eb0ae9dca99; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
var $7s0Ms = parcelRequire("7s0Ms");
function $09edfb587ff0ff8a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $3dLyd.openBlock)(), (0, $3dLyd.createBlock)($setup["Primitive"], {
        as: $props.as,
        "as-child": $props.asChild,
        class: (0, $7s0Ms.normalizeClass)($setup.cn($setup.buttonVariants({
            variant: $props.variant,
            size: $props.size
        }), $setup.props.class))
    }, {
        default: (0, $3dLyd.withCtx)(()=>[
                (0, $3dLyd.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3
    }, 8, [
        "as",
        "as-child",
        "class"
    ]);
}

});

parcelRegister("1CRNk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f3119189090cd8$export$2e2bcd8739ae039; });
let $12f3119189090cd8$var$NOOP = ()=>{};
var $12f3119189090cd8$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("qHBj0", function(module, exports) {

$parcel$export(module.exports, "createVNodeCache", function () { return (parcelRequire("9MuMq")).createVNodeCache; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("9MuMq")).normalizeClass; });
$parcel$export(module.exports, "normalizeSlot", function () { return (parcelRequire("9MuMq")).normalizeSlot; });
$parcel$export(module.exports, "normalizeSlots", function () { return (parcelRequire("9MuMq")).normalizeSlots; });
$parcel$export(module.exports, "normalizeVNode", function () { return (parcelRequire("9MuMq")).normalizeVNode; });

var $8o1T3 = parcelRequire("8o1T3");

var $4MxYe = parcelRequire("4MxYe");

var $9a2X6 = parcelRequire("9a2X6");

var $haAPV = parcelRequire("haAPV");

var $9MuMq = parcelRequire("9MuMq");
parcelRequire("fyBkV");
var $SdEQh = parcelRequire("SdEQh");

});
parcelRegister("8o1T3", function(module, exports) {

$parcel$export(module.exports, "createComponent", function () { return $61b20751d2532215$export$60e54eaca7e7fb38; });
$parcel$export(module.exports, "createProxyComponent", function () { return $61b20751d2532215$export$a87d08e0c8a056c5; });
$parcel$export(module.exports, "normalizeNode", function () { return $61b20751d2532215$export$775064d9a0021ab5; });
parcelRequire("fyBkV");
var $clmPQ = parcelRequire("clmPQ");
var $3dLyd = parcelRequire("3dLyd");
var $SdEQh = parcelRequire("SdEQh");
//#region src/vapor.ts
/* @__NO_SIDE_EFFECTS__ */ function $61b20751d2532215$export$8d6d1633f67ec140(comp, extraOptions) {
    if (typeof comp === "function") return Object.assign({
        name: comp.name
    }, extraOptions, {
        setup (props, ctx) {
            const result = comp(props, ctx);
            return ()=>result;
        },
        __vapor: true
    });
    const setup = comp.setup;
    if (setup) comp.setup = (props, ctx)=>{
        const result = setup(props, ctx);
        return ()=>result;
    };
    comp.__vapor = true;
    return comp;
}
const $61b20751d2532215$export$60e54eaca7e7fb38 = (type, ...args)=>{
    if (type === (0, $3dLyd.Fragment)) {
        const slots = args[1];
        return slots ? typeof slots === "function" ? slots() : typeof slots.default === "function" ? slots.default() : [] : [];
    }
    return $clmPQ.createComponentWithFallback($61b20751d2532215$export$a87d08e0c8a056c5($3dLyd.resolveDynamicComponent(type)), ...args);
};
const $61b20751d2532215$var$proxyCache = /* @__PURE__ */ new WeakMap();
function $61b20751d2532215$export$a87d08e0c8a056c5(type, normalizeNode) {
    if (typeof type === "function") {
        const existing = $61b20751d2532215$var$proxyCache.get(type);
        if (existing) return existing;
        const i = $3dLyd.currentInstance || (0, $3dLyd.getCurrentInstance)();
        const proxy = new Proxy(type, {
            apply (target, ctx, args) {
                if (typeof target.__setup === "function") target.__setup.apply(ctx, args);
                const node = Reflect.apply(target, ctx, args);
                return normalizeNode ? normalizeNode(node) : node;
            },
            get (target, p, receiver) {
                if (i && i.appContext.vapor && p === "__vapor") return true;
                return Reflect.get(target, p, receiver);
            }
        });
        $61b20751d2532215$var$proxyCache.set(type, proxy);
        return proxy;
    }
    return type;
}
function $61b20751d2532215$export$775064d9a0021ab5(node) {
    if (node == null || typeof node === "boolean") return document.createComment("");
    else if (Array.isArray(node) && node.length) return node.map($61b20751d2532215$export$775064d9a0021ab5);
    else if ($61b20751d2532215$export$de5a9e42c1dff8da(node)) return node;
    else if (typeof node === "function") return $61b20751d2532215$var$resolveValues([
        node
    ], void 0, true)[0];
    else return document.createTextNode(String(node));
}
function $61b20751d2532215$export$de5a9e42c1dff8da(val) {
    return val instanceof Node || Array.isArray(val) || $clmPQ.isVaporComponent(val) || $clmPQ.isFragment(val);
}
function $61b20751d2532215$var$createFragment(nodes, anchor = document.createTextNode("")) {
    const frag = new $clmPQ.VaporFragment(nodes);
    frag.anchor = anchor;
    return frag;
}
function $61b20751d2532215$var$normalizeBlock(node, anchor, processFunction = false) {
    if (node instanceof Node || $clmPQ.isFragment(node)) return node;
    else if ($clmPQ.isVaporComponent(node)) return $61b20751d2532215$var$createFragment(node, anchor);
    else if (Array.isArray(node)) return $61b20751d2532215$var$createFragment(node.map((i)=>$61b20751d2532215$var$normalizeBlock(i, void 0, processFunction)), anchor);
    else if (processFunction && typeof node === "function") return $61b20751d2532215$var$resolveValues([
        node
    ], anchor, true)[0];
    else {
        const result = node == null || typeof node === "boolean" ? "" : String(node);
        if (anchor) {
            anchor.textContent = result;
            return anchor;
        } else return document.createTextNode(result);
    }
}
function $61b20751d2532215$var$resolveValue(current, value, anchor, processFunction = false) {
    anchor = anchor || (current instanceof Node && current.nodeType === 3 ? current : void 0);
    const node = $61b20751d2532215$var$normalizeBlock(value, anchor, processFunction);
    if (current) {
        if ($clmPQ.isFragment(current)) {
            if (current.anchor && current.anchor.parentNode) {
                $clmPQ.remove(current.nodes, current.anchor.parentNode);
                $clmPQ.insert(node, current.anchor.parentNode, current.anchor);
                if (!anchor) current.anchor.parentNode.removeChild(current.anchor);
                if (current.scope) current.scope.stop();
            }
        } else if (current instanceof Node) {
            if (current.nodeType === 3 && (!(node instanceof Node) || node.nodeType !== 3)) current.textContent = "";
            if ($clmPQ.isFragment(node) && current.parentNode) {
                $clmPQ.insert(node, current.parentNode, current);
                if (!anchor || current.nodeType !== 3) current.parentNode.removeChild(current);
            } else if (node instanceof Node) {
                if (current.nodeType === 3 && node.nodeType === 3) {
                    current.textContent = node.textContent;
                    return current;
                } else if (current.parentNode) current.parentNode.replaceChild(node, current);
            }
        }
    }
    return node;
}
function $61b20751d2532215$var$resolveValues(values = [], _anchor, processFunction = false) {
    const nodes = [];
    const scopes = [];
    for (const [index, value] of values.entries()){
        const anchor = index === values.length - 1 ? _anchor : void 0;
        if (typeof value === "function") $clmPQ.renderEffect(()=>{
            if (scopes[index]) scopes[index].stop();
            scopes[index] = new (0, $SdEQh.EffectScope)();
            nodes[index] = scopes[index].run(()=>$61b20751d2532215$var$resolveValue(nodes[index], value(), anchor, processFunction));
        });
        else nodes[index] = $61b20751d2532215$var$resolveValue(nodes[index], value, anchor, processFunction);
    }
    return nodes;
}
function $61b20751d2532215$export$4d3b7bb67cb076c7(anchor, ...values) {
    const resolvedValues = $61b20751d2532215$var$resolveValues(values, anchor);
    if (anchor.parentNode) $clmPQ.insert(resolvedValues, anchor.parentNode, anchor);
}
function $61b20751d2532215$export$953dd193a01bd6ec(...values) {
    return $61b20751d2532215$var$resolveValues(values);
}
function $61b20751d2532215$export$6601744ea3d02f7e(slots) {
    if (typeof slots === "function") return {
        name: "default",
        fn: slots
    };
    else if (Object.prototype.toString.call(slots) === "[object Object]" && !$61b20751d2532215$export$de5a9e42c1dff8da(slots)) return Object.entries(slots).map(([name, fn])=>({
            name: name,
            fn: fn
        }));
    else return {
        name: "default",
        fn: ()=>$61b20751d2532215$export$953dd193a01bd6ec(slots)
    };
}
/* @__NO_SIDE_EFFECTS__ */ function $61b20751d2532215$export$bcd4d980d2d74077(comp, extraOptions) {
    if (typeof comp === "function") return Object.assign({
        name: comp.name
    }, extraOptions, {
        setup: comp,
        __vapor: true
    });
    comp.__vapor = true;
    return comp;
}
const $61b20751d2532215$export$707ab93ec7399045 = /* @__PURE__ */ $61b20751d2532215$export$bcd4d980d2d74077((props, { slots: slots })=>{
    return $clmPQ.createFor(()=>props.in, (item, key, index)=>{
        return slots.default ? slots.default(props.getKey === void 0 ? item.value : item, key, index) : [];
    }, props.getKey === void 0 ? (item)=>item : props.getKey);
}, {
    props: [
        "in",
        "getKey"
    ]
});

});

parcelRegister("4MxYe", function(module, exports) {

var $8o1T3 = parcelRequire("8o1T3");
parcelRequire("fyBkV");
var $clmPQ = parcelRequire("clmPQ");
//#region src/h.ts
/* @__NO_SIDE_EFFECTS__ */ function $37b5fef87b924574$export$dda1d9f60106f0e9(type, props, children) {
    const { props: resolvedProps, key: key, ref: ref } = $37b5fef87b924574$var$resolveProps(props);
    const render = ()=>{
        const comp = (0, $8o1T3.createComponent)(type, resolvedProps, children ? typeof children === "object" && !Array.isArray(children) ? new Proxy(children, {
            get: (target, key, receiver)=>(0, $8o1T3.createProxyComponent)(Reflect.get(target, key, receiver), (0, $8o1T3.normalizeNode))
        }) : {
            default: typeof children === "function" ? (0, $8o1T3.createProxyComponent)(children, (0, $8o1T3.normalizeNode)) : ()=>(0, $8o1T3.normalizeNode)(children)
        } : void 0);
        if (ref) {
            const setRef = $clmPQ.createTemplateRefSetter();
            $clmPQ.renderEffect(()=>setRef(comp, ref));
        }
        return comp;
    };
    return key ? $clmPQ.createKeyedFragment(key, render) : render();
}
const $37b5fef87b924574$var$EVENT_REGEX = /^on[A-Z]/;
function $37b5fef87b924574$var$resolveProps(props) {
    const resolvedProps = {
        props: {}
    };
    if (props) {
        for(const p in props){
            const isFuncton = typeof props[p] === "function";
            if (p === "key") resolvedProps.key = isFuncton ? props[p] : ()=>props[p];
            else if (p === "ref") resolvedProps.ref = props[p];
            else if ($37b5fef87b924574$var$EVENT_REGEX.test(p)) resolvedProps.props[p] = ()=>props[p];
            else resolvedProps.props[p] = props[p];
        }
        return resolvedProps;
    }
    return resolvedProps;
}

});

parcelRegister("9a2X6", function(module, exports) {
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/props.ts
/* @__NO_SIDE_EFFECTS__ */ function $6ab756801e9db354$export$f13e630aa3915748() {
    return $3dLyd.currentInstance || $3dLyd.getCurrentInstance();
}
/**
* Returns the props of the current component instance.
*
* @example
* ```tsx
* import { useProps } from 'vue-jsx-vapor'
*
* defineComponent(({ foo = '' })=>{
*   const props = useProps() // { foo: '' }
* })
* ```
*/ /* @__NO_SIDE_EFFECTS__ */ function $6ab756801e9db354$export$1f264be2c424fccf() {
    return /* @__PURE__ */ $6ab756801e9db354$export$f13e630aa3915748().props;
}
/**
* Returns the merged props and attrs of the current component.\
* Equivalent to `useProps()` + `useAttrs()`.
*
* @example
* ```tsx
* import { useFullProps } from 'vue-jsx-vapor'
*
* defineComponent((props) => {
*   const fullProps = useFullProps() // = useAttrs() + useProps()
* })
*/ /* @__NO_SIDE_EFFECTS__ */ function $6ab756801e9db354$export$d4109d1aaca7f43d() {
    const attrs = (0, $3dLyd.useAttrs)();
    if (!/* @__PURE__ */ $6ab756801e9db354$export$f13e630aa3915748().type.props) return attrs;
    const props = /* @__PURE__ */ $6ab756801e9db354$export$1f264be2c424fccf();
    const fullProps = (0, $3dLyd.computed)(()=>({
            ...props,
            ...attrs
        }));
    return new Proxy({}, {
        get (_, p, receiver) {
            return Reflect.get(fullProps.value, p, receiver);
        },
        set (_, p, v, r) {
            return Reflect.set(fullProps.value, p, v, r);
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(fullProps.value, p);
        },
        has (_, p) {
            return Reflect.has(fullProps.value, p);
        },
        ownKeys () {
            return Object.keys(fullProps.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
}

});

parcelRegister("haAPV", function(module, exports) {
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/ssr.ts
function $c7fff1d04e924b71$export$6b13f7ca41e206d6(comp, filename) {
    if (typeof comp === "function") comp.__setup = ()=>{
        const ssrContext = (0, $3dLyd.useSSRContext)();
        (ssrContext.modules || (ssrContext.modules = /* @__PURE__ */ new Set())).add(filename);
    };
    else {
        const setup = comp.setup;
        comp.setup = (props, ctx)=>{
            const ssrContext = (0, $3dLyd.useSSRContext)();
            (ssrContext.modules || (ssrContext.modules = /* @__PURE__ */ new Set())).add(filename);
            if (setup) return setup(props, ctx);
        };
    }
}

});

parcelRegister("9MuMq", function(module, exports) {

$parcel$export(module.exports, "createVNodeCache", function () { return $71f079051dfd4958$export$6f0ea66d4385992f; });
$parcel$export(module.exports, "normalizeVNode", function () { return $71f079051dfd4958$export$a0e1465ad202d515; });
$parcel$export(module.exports, "normalizeSlot", function () { return $71f079051dfd4958$export$637957520399b513; });
$parcel$export(module.exports, "normalizeSlots", function () { return $71f079051dfd4958$export$134da0439a000016; });
$parcel$export(module.exports, "normalizeClass", function () { return $71f079051dfd4958$export$4f7022d2d68e2c5a; });
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
var $7s0Ms = parcelRequire("7s0Ms");
//#region src/vdom.ts
const $71f079051dfd4958$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $71f079051dfd4958$export$6f0ea66d4385992f(key) {
    const i = (0, $3dLyd.getCurrentInstance)();
    if (i) {
        if (!$71f079051dfd4958$var$cacheMap.has(i)) $71f079051dfd4958$var$cacheMap.set(i, {});
        const caches = $71f079051dfd4958$var$cacheMap.get(i);
        return caches[key] || (caches[key] = []);
    } else return [];
}
function $71f079051dfd4958$export$a0e1465ad202d515(value, flag = 1) {
    let create = (0, $3dLyd.createVNode);
    let isBlock = false;
    if (typeof value === "function") {
        isBlock = true;
        (0, $3dLyd.openBlock)();
        create = (0, $3dLyd.createBlock);
        value = value();
    }
    return (0, $3dLyd.isVNode)(value) ? isBlock ? (0, $3dLyd.createBlock)($71f079051dfd4958$var$cloneIfMounted(value)) : $71f079051dfd4958$var$cloneIfMounted(value) : Array.isArray(value) ? isBlock ? (0, $3dLyd.createElementBlock)((0, $3dLyd.Fragment), null, value.map((n)=>$71f079051dfd4958$export$a0e1465ad202d515(()=>n)), -2) : (0, $3dLyd.createElementVNode)((0, $3dLyd.Fragment), null, value.slice()) : value == null || typeof value === "boolean" ? create((0, $3dLyd.Comment)) : create((0, $3dLyd.Text), null, String(value), flag);
}
function $71f079051dfd4958$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : (0, $3dLyd.cloneVNode)(child);
}
const $71f079051dfd4958$var$normalizeSlotValue = (value)=>Array.isArray(value) ? value.map((n)=>$71f079051dfd4958$export$a0e1465ad202d515(n)) : [
        $71f079051dfd4958$export$a0e1465ad202d515(value)
    ];
const $71f079051dfd4958$export$637957520399b513 = (rawSlot)=>{
    if (rawSlot._n) return rawSlot;
    return (0, $3dLyd.withCtx)((...args)=>{
        return $71f079051dfd4958$var$normalizeSlotValue(rawSlot(...args));
    });
};
const $71f079051dfd4958$export$134da0439a000016 = (slots)=>{
    return typeof slots === "function" || Object.prototype.toString.call(slots) === "[object Object]" && !(0, $3dLyd.isVNode)(slots) ? slots : {
        default: (0, $3dLyd.withCtx)(()=>[
                $71f079051dfd4958$export$a0e1465ad202d515(()=>slots)
            ])
    };
};
const $71f079051dfd4958$export$4f7022d2d68e2c5a = (value)=>(0, $7s0Ms.normalizeClass)(value) || null;
const $71f079051dfd4958$export$afa64b67e5a01c3b = (0, $3dLyd.defineComponent);
const $71f079051dfd4958$export$bdf530073099ce9f = $71f079051dfd4958$export$afa64b67e5a01c3b((props, { slots: slots })=>{
    const defaultSlot = slots.default;
    return ()=>((0, $3dLyd.openBlock)(true), (0, $3dLyd.createElementBlock)((0, $3dLyd.Fragment), null, (0, $3dLyd.renderList)(props.in, (item, key, index)=>{
            const result = defaultSlot(item, key, index);
            return Array.isArray(result) ? result.length === 1 ? result[0] : $71f079051dfd4958$export$a0e1465ad202d515(result) : result;
        }), 128));
}, {
    props: [
        "in"
    ]
});

});


parcelRegister("9zQkT", function(module, exports) {
module.exports = $parcel$import("8Gx8l").then(()=>parcelRequire('eRk0A'));

});

parcelRegister("6hmVd", function(module, exports) {
module.exports = $parcel$import("inQQV").then(()=>parcelRequire('1MdC2'));

});

parcelRegister("7uyTa", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("2Unia"))($parcel$resolve("adQf3")),
    $parcel$import("6wO5W"),
    $parcel$import("kbKVN"),
    $parcel$import("dDtki")
]).then(()=>parcelRequire('lOlHH'));

});
parcelRegister("2Unia", function(module, exports) {
"use strict";

var $cYyc8 = parcelRequire("cYyc8");
module.exports = $cYyc8(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("cYyc8", function(module, exports) {
"use strict";
var $97259cf907575823$var$cachedBundles = {};
var $97259cf907575823$var$cachedPreloads = {};
var $97259cf907575823$var$cachedPrefetches = {};
function $97259cf907575823$var$getCache(type) {
    switch(type){
        case 'preload':
            return $97259cf907575823$var$cachedPreloads;
        case 'prefetch':
            return $97259cf907575823$var$cachedPrefetches;
        default:
            return $97259cf907575823$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $97259cf907575823$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("wJQL0", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("6wO5W"),
    $parcel$import("7nbeX")
]).then(()=>parcelRequire('3LWSN'));

});

parcelRegister("eRqW7", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("6wO5W"),
    $parcel$import("kbKVN"),
    $parcel$import("4PySu")
]).then(()=>parcelRequire('LKAXf'));

});

var $1e443bf7654c1129$exports = {};
$parcel$extendImportMap({
    "fcSXM": "logo.a72d69c2.png",
    "8Gx8l": "ClassDecorator.b9db61bf.js",
    "inQQV": "FunctionDecorator.e56a6e5d.js",
    "dDtki": "Component.34d14cb5.js",
    "kbKVN": "Component.46bc0c69.js",
    "6uZq5": "memory.5d94a806.js",
    "9uSQe": "sandbox.52aebab8.js",
    "cYG3x": "downloader.bc385c34.js",
    "6wO5W": "Component.63987ac8.js",
    "adQf3": "Component.af00bdf4.css",
    "7nbeX": "Chart.fc55f03a.js",
    "4PySu": "About.7ae5dffa.js"
});

var $de9addb89ca41b61$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $de9addb89ca41b61$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $de9addb89ca41b61$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $de9addb89ca41b61$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $de9addb89ca41b61$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $de9addb89ca41b61$var$InstrumentedPromise$1.prototype;
    return promise;
};
$de9addb89ca41b61$var$InstrumentedPromise$1.__proto__ = $de9addb89ca41b61$var$OriginalPromise;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.__proto__ = $de9addb89ca41b61$var$OriginalPromise.prototype;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $de9addb89ca41b61$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $de9addb89ca41b61$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $de9addb89ca41b61$export$cea1c58a6db52bca() {
    Promise = $de9addb89ca41b61$var$InstrumentedPromise$1;
}
function $de9addb89ca41b61$export$dfb5619354ba860() {
    if ($de9addb89ca41b61$export$baf72085f5fb4df()) $de9addb89ca41b61$export$cea1c58a6db52bca();
}
var $de9addb89ca41b61$export$2e2bcd8739ae039 = $de9addb89ca41b61$var$InstrumentedPromise$1;



var $5hfm1 = parcelRequire("5hfm1");
parcelRequire("fyBkV");
var $bmuEm = parcelRequire("bmuEm");

var $cF2Ke = parcelRequire("cF2Ke");
let $e373b8c25d764efb$var$script;



let $e373b8c25d764efb$var$initialize = ()=>{
    $e373b8c25d764efb$var$script = {};
    $e373b8c25d764efb$var$script.render = (parcelRequire("jvVeB")).render;
    $e373b8c25d764efb$var$script.__cssModules = {};
    (parcelRequire("9c2LK")).default($e373b8c25d764efb$var$script);
    $e373b8c25d764efb$var$script.__scopeId = 'data-v-20a8a5';
    $e373b8c25d764efb$var$script.__file = "App.vue";
};
$e373b8c25d764efb$var$initialize();
var $e373b8c25d764efb$export$2e2bcd8739ae039 = $e373b8c25d764efb$var$script;


/*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ /*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ /*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ //#region src/formatters/plain.ts
/**
* Renders a diagnostic into a multi-line, unicode-decorated string suitable
* for terminal output. The first line is `[<name>] <message>`; optional
* details (`fix`, `sources`, `docs`) follow with `├▶`/`╰▶` connectors.
*/ function $7e1dbf5e13b51bcb$export$332cab4fc85226b5(diagnostic) {
    const header = `[${diagnostic.name}] ${diagnostic.message}`;
    const details = [];
    if (diagnostic.fix) details.push(`fix: ${diagnostic.fix}`);
    if (diagnostic.sources?.length) details.push(`sources: ${diagnostic.sources.join(", ")}`);
    if (diagnostic.docs) details.push(`see: ${diagnostic.docs}`);
    if (details.length === 0) return header;
    return [
        header,
        ...details.map((detail, i)=>{
            return `${i < details.length - 1 ? "\u251C\u25B6" : "\u2570\u25B6"} ${detail}`;
        })
    ].join("\n");
}
//#endregion
//#region src/utils.ts
/**
* Transforms a value or a function that returns a value to a value.
*
* @param valFn either a value or a function that returns a value
* @param args  arguments to pass to the function if `valFn` is a function
*
* @internal
*/ function $7e1dbf5e13b51bcb$var$toValueWithArgs(valFn, ...args) {
    return typeof valFn === "function" ? valFn(...args) : valFn;
}
//#endregion
//#region src/diagnostic.ts
/**
* Creates a console reporter that renders each diagnostic with `formatter` and
* prints the result via `console[method]`. Both default sensibly (`'warn'` and
* {@link formatDiagnostic}); `method` can also be overridden per call through
* the reporter options.
*/ /* @__NO_SIDE_EFFECTS__ */ function $7e1dbf5e13b51bcb$export$28961117abab257d({ method: defaultMethod = "warn", formatter: formatter = $7e1dbf5e13b51bcb$export$332cab4fc85226b5 } = {}) {
    return (diagnostic, { method: method = defaultMethod } = {})=>{
        console[method](formatter(diagnostic));
    };
}
const $7e1dbf5e13b51bcb$var$captureStackTrace = Error.captureStackTrace;
var $7e1dbf5e13b51bcb$export$d3ee506da1643804 = class Diagnostic extends Error {
    name;
    /**
	* The diagnostic code, e.g. `MATH_E001`.
	* Also appears as the `name` property.
	*/ code;
    /**
	* URL to extended documentation for this diagnostic code.
	* Auto-generated from {@link DefineDiagnosticsOptions.docsBase}.
	*/ docs;
    /**
	* Optional actionable instructions on how to resolve the problem.
	*/ fix;
    /**
	* Locations in user code that contributed to this diagnostic, in
	* `file:line:column` format. Relevant when the stack trace doesn't reflect
	* the user's source (e.g. compilers, bundlers), otherwise redundant with the
	* stack and should be omitted.
	*/ sources;
    /**
	* Alias for {@link Error.message}: the reason this diagnostic was raised.
	*/ get why() {
        return this.message;
    }
    /**
	* @param init        structured initializer; `why` is required
	* @param captureFrom V8 stack-cutoff frame. Defaults to {@link Diagnostic}
	* so the top of the trace is the `new Diagnostic(...)` call site.
	* `defineDiagnostics` passes its action method to strip its own frames too.
	* Ignored on engines without `Error.captureStackTrace`.
	*/ constructor(init, captureFrom = Diagnostic){
        super(init.why, {
            cause: init.cause
        });
        this.code = this.name = init.code;
        this.fix = init.fix;
        this.docs = init.docs;
        this.sources = init.sources;
        $7e1dbf5e13b51bcb$var$captureStackTrace?.(this, captureFrom);
    }
    /**
	* Converts the diagnostic into a serializable structured object.
	*/ toJSON() {
        return {
            name: this.name,
            why: this.why,
            fix: this.fix,
            docs: this.docs,
            sources: this.sources,
            cause: this.cause,
            stack: this.stack
        };
    }
};
/**
* Resolves the docs URL for a code from a `docsBase` (string template or
* resolver function). Shared by {@link defineDiagnostics} and
* {@link defineProdDiagnostics}. Per-code `docs` overrides are handled by the
* caller; this only covers the `docsBase`-derived case.
*
* @internal
*/ function $7e1dbf5e13b51bcb$var$deriveDocs(docsBase, code) {
    return typeof docsBase === "string" ? `${docsBase}/${code.toLowerCase()}` : docsBase?.(code);
}
/**
* Creates a typed diagnostics object from a set of code definitions. Each
* code becomes a callable {@link DiagnosticHandle}: invoke to report, or
* `throw` the result to raise. No `new` required, no proxy.
*/ /* @__NO_SIDE_EFFECTS__ */ function $7e1dbf5e13b51bcb$export$1656dc1696afae07(options) {
    const reporters = options.reporters ?? [];
    const result = {};
    const { docsBase: docsBase } = options;
    for (const code of Object.keys(options.codes)){
        const def = options.codes[code];
        const docs = def.docs === false ? void 0 : def.docs || $7e1dbf5e13b51bcb$var$deriveDocs(docsBase, code);
        const handle = (params = {}, reporterOptions = {})=>{
            const diagnostic = new $7e1dbf5e13b51bcb$export$d3ee506da1643804({
                code: code,
                why: $7e1dbf5e13b51bcb$var$toValueWithArgs(def.why, params),
                fix: $7e1dbf5e13b51bcb$var$toValueWithArgs(def.fix, params),
                docs: docs,
                cause: params.cause,
                sources: params.sources
            }, handle);
            for (const reporter of reporters)reporter(diagnostic, reporterOptions);
            return diagnostic;
        };
        result[code] = handle;
    }
    return result;
}
//#endregion
//#region src/prod-diagnostics.ts
/**
* Production counterpart to {@link defineDiagnostics}. Returns a `Proxy` that
* builds a minimal {@link Diagnostic} for any accessed code: the code becomes
* the instance `name`, `docs` is derived from `docsBase`, and `why` points to
* the docs URL when one exists (empty otherwise, so the thrown header is just
* the code). It carries no catalog text, so it stays tiny in a bundle.
*
* The strip plugin (`@nostics/unplugin`) can rewrite a `defineDiagnostics()`
* call into a `process.env.NODE_ENV === 'production'` ternary that selects this
* factory in production, dropping every `why`/`fix` string from the bundle.
*
* @example
* ```ts
* const diagnostics = defineProdDiagnostics({ docsBase: 'https://docs.example.com' })
* throw diagnostics.NUXT_B2011() // NUXT_B2011: https://docs.example.com/nuxt_b2011
* ```
*/ /* @__NO_SIDE_EFFECTS__ */ function $7e1dbf5e13b51bcb$export$5deacc2d4b351bec(options = {}) {
    const { docsBase: docsBase, reporters: reporters = [] } = options;
    return new Proxy({}, {
        get (_target, code) {
            if (typeof code !== "string") return void 0;
            const handle = (params = {}, reporterOptions = {})=>{
                const docs = $7e1dbf5e13b51bcb$var$deriveDocs(docsBase, code);
                const diagnostic = new $7e1dbf5e13b51bcb$export$d3ee506da1643804({
                    code: code,
                    why: docs ?? "",
                    docs: docs,
                    cause: params.cause,
                    sources: params.sources
                }, handle);
                for (const reporter of reporters)reporter(diagnostic, reporterOptions);
                return diagnostic;
            };
            return handle;
        }
    });
}


parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $61ae4f1203339483$export$953cecd6e717a553 = (v)=>v;
/**
* Checks if a path is absolute, meaning it starts with a `/`.
*
* @param path - path to check
*
* @internal
*/ const $61ae4f1203339483$export$dda1d9f60106f0e9 = (path)=>path.startsWith("/");
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $61ae4f1203339483$export$90a7f3efeed30595(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $61ae4f1203339483$export$71511d61b312f219(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $61ae4f1203339483$export$90a7f3efeed30595(obj.default);
}
const $61ae4f1203339483$export$ffb5f4729a158638 = Object.assign;
function $61ae4f1203339483$export$2d1720544b23b823(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $61ae4f1203339483$export$39b482c5e57630a8(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $61ae4f1203339483$export$8b22cf2602fb60ce = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $61ae4f1203339483$export$39b482c5e57630a8 = Array.isArray;
function $61ae4f1203339483$export$4a5767248b18ef41(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/errors.ts
const $61ae4f1203339483$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $61ae4f1203339483$export$882b5998b3b9117c = /* @__PURE__ */ function(NavigationFailureType) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
    return NavigationFailureType;
}({});
const $61ae4f1203339483$var$ErrorTypeMessages = {
    [1] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$61ae4f1203339483$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16] ({ from: from, to: _to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $61ae4f1203339483$export$3b14a55fb2447963(type, params) {
    return $61ae4f1203339483$export$ffb5f4729a158638(/* @__PURE__ */ new Error(), {
        type: type,
        [$61ae4f1203339483$var$NavigationFailureSymbol]: true
    }, params);
}
function $61ae4f1203339483$export$4368d992c4eafac0(error, type) {
    return error instanceof Error && $61ae4f1203339483$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $61ae4f1203339483$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
/**
* Stringifies a raw location for display in dev warnings.
*
* @internal
*/ function $61ae4f1203339483$var$stringifyRoute(to) {
    if (!to || typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $61ae4f1203339483$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/diagnostics.ts
/**
* Runtime diagnostics catalog for Vue Router.
*
* Every entry has a stable `VUE_ROUTER_R####` code, a `why` that states the problem
* (the diagnosis only, never the remedy) and a `fix` that states the remedy
* (only, never the diagnosis). They are complementary: the reporter prints
* both, so neither repeats the other. The diagnosis substrings asserted by the
* warning tests stay in `why`. All call sites stay behind the existing `__DEV__` (or
* `process.env.NODE_ENV !== 'production'`) guards and remain bare expression
* statements so they tree-shake out of production builds.
*
* Codes are permanent: never rename or reuse one.
* - `VUE_ROUTER_R0###` core runtime warnings
* - `VUE_ROUTER_R1###` experimental data-loaders
*/ const $61ae4f1203339483$export$db3b6bfb95261072 = /*#__PURE__*/ (0, $7e1dbf5e13b51bcb$export$1656dc1696afae07)({
    reporters: [
        /*#__PURE__*/ (0, $7e1dbf5e13b51bcb$export$28961117abab257d)()
    ],
    codes: {
        VUE_ROUTER_R0001: {
            why: (p)=>`Parent route "${p.name}" not found when adding child route`,
            fix: "Add the parent route before its children, or check the parent name for typos.",
            docs: "https://router.vuejs.org/guide/advanced/dynamic-routing.html#Adding-nested-routes"
        },
        VUE_ROUTER_R0002: {
            why: (p)=>`Cannot remove non-existent route "${p.name}"`,
            fix: "Check the route name; it may already have been removed or was never added.",
            docs: "https://router.vuejs.org/guide/advanced/dynamic-routing.html#Removing-routes"
        },
        VUE_ROUTER_R0003: {
            why: (p)=>`Location "${$61ae4f1203339483$var$stringifyRoute(p.location)}" resolved to "${p.href}". A resolved location cannot start with multiple slashes.`,
            fix: "Remove the leading slashes from the location or fix the route configuration."
        },
        VUE_ROUTER_R0004: {
            why: (p)=>`No match found for location with path "${$61ae4f1203339483$var$stringifyRoute(p.path)}"`,
            fix: "Add a route matching this path or check for typos in the location.",
            docs: "https://router.vuejs.org/guide/essentials/dynamic-matching.html#Catch-all-404-Not-found-Route"
        },
        VUE_ROUTER_R0005: {
            why: (p)=>`router.resolve() was passed an invalid location. This will fail in production.\nLocation: ${$61ae4f1203339483$var$stringifyRoute(p.rawLocation)}`,
            fix: "Pass a valid route location: a string path or an object with `path` or `name`."
        },
        VUE_ROUTER_R0006: {
            why: (p)=>`Path "${p.path}" was passed with params but they will be ignored because a "path" was passed.`,
            fix: "Use a named route `{ name, params }` instead of `{ path, params }`.",
            docs: "https://router.vuejs.org/guide/essentials/navigation.html#Navigate-to-a-different-location"
        },
        VUE_ROUTER_R0007: {
            why: (p)=>`A \`hash\` should always start with the character "#" but received "${p.hash}".`,
            fix: (p)=>`Prepend "#" to the hash in your route location: use "#${p.hash}".`
        },
        VUE_ROUTER_R0008: {
            why: (p)=>`Invalid redirect found:\n${p.target}\n when navigating to "${p.to}".\nThis will break in production.`,
            fix: "A redirect must resolve to a location with a `name` or `path`; return one of those (or a string path) from `redirect`.",
            docs: "https://router.vuejs.org/guide/essentials/redirect-and-alias.html#Redirect"
        },
        VUE_ROUTER_R0009: {
            why: (p)=>`Detected a possibly infinite redirection in a navigation guard when going from "${p.from}" to "${p.to}". Aborting to avoid a Stack Overflow. This might break in production if not fixed.`,
            fix: "A guard is returning a new location on every call; make that return conditional so it only redirects when actually needed.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Global-Before-Guards"
        },
        VUE_ROUTER_R0010: {
            why: "Uncaught error during route navigation",
            fix: "Register an error handler with `router.onError()` to handle navigation errors."
        },
        VUE_ROUTER_R0011: {
            why: "Unexpected error when starting the router:",
            fix: "Inspect the actual cause; a navigation guard or async component likely threw during the initial navigation."
        },
        VUE_ROUTER_R0020: {
            why: (p)=>`No active route record was found when calling \`${p.fn}()\`. Maybe you called it inside of App.vue?`,
            fix: "Call it from a component rendered inside <router-view> (a page component or one of its children), not from App.vue.",
            docs: "https://router.vuejs.org/guide/advanced/composition-api.html#Navigation-Guards"
        },
        VUE_ROUTER_R0021: {
            why: "No active route record was found when reactivating component with navigation guard. This is likely a bug in vue-router.",
            fix: "Report with a minimal reproduction at https://github.com/vuejs/router/issues/new/choose."
        },
        VUE_ROUTER_R0022: {
            why: (p)=>`${p.fn}() was called outside of component setup but it must be called at the top of a setup function`,
            fix: "Call it synchronously at the top of `setup()`, before any `await`.",
            docs: "https://router.vuejs.org/guide/advanced/composition-api.html#Navigation-Guards"
        },
        VUE_ROUTER_R0023: {
            why: (p)=>`The "next" callback was never called inside of ${p.name ? `"${p.name}"` : ""}:\n${p.guard}`,
            fix: "Make sure `next()` runs on every branch, including early returns and async paths, or drop the `next` parameter and return the value instead.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0024: {
            why: (p)=>`The "next" callback was called more than once in one navigation guard when going from "${p.from}" to "${p.to}". This will fail in production.`,
            fix: "Call `next()` exactly once per guard: remove the extra call, or migrate to returning the value you passed to `next()`.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0025: {
            why: "The `next()` callback in navigation guards is deprecated.",
            fix: "Return the value instead: `next()` becomes `return`, `next(false)` becomes `return false`, `next(\"/path\")` becomes `return \"/path\"`.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0026: {
            why: (p)=>`Record with path "${p.path}" is either missing a "component(s)" or "children" property.`,
            fix: "Add a `component`, `components`, or `children` to the route record.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html"
        },
        VUE_ROUTER_R0027: {
            why: (p)=>`Component "${p.name}" in record with path "${p.path}" is not a valid component. Received "${p.received}".`,
            fix: "Pass a component or a function returning a Promise that resolves to one."
        },
        VUE_ROUTER_R0028: {
            why: (p)=>`Component "${p.name}" in record with path "${p.path}" is a Promise instead of a function that returns a Promise. This will break in production if not fixed.`,
            fix: `Defer the import in an arrow function so it loads lazily: write "() => import('./MyPage.vue')", not "import('./MyPage.vue')".`,
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html"
        },
        VUE_ROUTER_R0029: {
            why: (p)=>`Component "${p.name}" in record with path "${p.path}" is defined using "defineAsyncComponent()".`,
            fix: `Drop the wrapper and pass "() => import('./MyPage.vue')" directly; the router handles lazy components itself.`,
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html#Relationship-to-async-components"
        },
        VUE_ROUTER_R0030: {
            why: (p)=>`Component "${p.name}" in record with path "${p.path}" is a function that does not return a Promise. This will break in production if not fixed.`,
            fix: "Return a dynamic import (`() => import(\"./MyPage.vue\")`) from the function, or add a `displayName` if it is a functional component.",
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html"
        },
        VUE_ROUTER_R0040: {
            why: (p)=>`Because "${p.el}" starts with "#", scrollBehavior resolves it as an element id via document.getElementById("${p.el.slice(1)}"), not as a CSS selector. No element has that id, but "${p.el}" does match an element with document.querySelector().`,
            fix: (p)=>`Resolve the element yourself and return the node: el: document.querySelector('${p.el}').`,
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0041: {
            why: (p)=>`The selector "${p.el}" is invalid. See https://mathiasbynens.be/notes/css-escapes or CSS.escape (https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape) for the escaping rules.`,
            fix: "Build an id selector as `#${CSS.escape(id)}` so special characters in the id are escaped.",
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0042: {
            why: (p)=>`Couldn't find element using selector "${p.el}" returned by scrollBehavior.`,
            fix: "Return a selector that matches an existing element, or guard against missing elements.",
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0050: {
            why: (p)=>{
                let to;
                try {
                    to = p.to === void 0 ? "undefined" : JSON.stringify(p.to);
                } catch  {
                    to = String(p.to);
                }
                return `Invalid value for prop "to" in useLink()\n- to: ${to}`;
            },
            fix: "Pass a valid route location (a string path or an object) to the \"to\" prop."
        },
        VUE_ROUTER_R0060: {
            why: (p)=>`<router-view> can no longer be used directly inside <${p.comp}>.`,
            fix: (p)=>`Wrap the slot's resolved component with <${p.comp}> instead of nesting <router-view> in it:\n\n<router-view v-slot="{ Component }">\n  <${p.comp}>\n    <component :is="Component" />\n  </${p.comp}>\n</router-view>`,
            docs: "https://router.vuejs.org/guide/advanced/router-view-slot.html#KeepAlive-Transition"
        },
        VUE_ROUTER_R0070: {
            why: (p)=>`Cannot resolve a relative location without an absolute path. Trying to resolve "${p.to}" from "${p.from}".`,
            fix: (p)=>`Resolve from an absolute \`from\` path that starts with "/", e.g. "/${p.from}".`
        },
        VUE_ROUTER_R0080: {
            why: (p)=>`Error decoding "${p.text}". Using original value`,
            fix: "Ensure the value is correctly percent-encoded."
        },
        VUE_ROUTER_R0090: {
            why: (p)=>`Found duplicated params with name "${p.name}" for path "${p.path}". Only the last one will be available on "$route.params".`,
            fix: "Give each param a unique name within the path.",
            docs: "https://router.vuejs.org/guide/essentials/route-matching-syntax.html"
        },
        VUE_ROUTER_R0100: {
            why: (p)=>`Discarded invalid param(s) "${p.params}" when navigating.` + p.inherited + ` See https://github.com/vuejs/router/commit/e887570 for more details.`,
            fix: "Only pass params that exist on the target route."
        },
        VUE_ROUTER_R0101: {
            why: (p)=>`The Matcher cannot resolve relative paths but received "${p.path}". Unless you directly called \`matcher.resolve("${p.path}")\`, this is probably a bug in vue-router. Please open an issue at https://github.com/vuejs/router/issues/new/choose.`,
            fix: "Pass an absolute path (starting with \"/\") to the matcher."
        },
        VUE_ROUTER_R0102: {
            why: (p)=>`Alias "${p.alias}" and the original record: "${p.original}" must have the exact same param named "${p.name}"`,
            fix: "Use the same param names in the alias as in the original route.",
            docs: "https://router.vuejs.org/guide/essentials/redirect-and-alias.html#Alias"
        },
        VUE_ROUTER_R0103: {
            why: (p)=>`The route named "${p.name}" has a child without a name, an empty path, and no children. Using that name won't render the empty path child, so this is probably a mistake.`,
            fix: "Move the `name` onto the empty-path child; or, if intentional, give the child its own name to silence this.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html#Nested-Named-Routes"
        },
        VUE_ROUTER_R0104: {
            why: (p)=>`Absolute path "${p.path}" must have the exact same param named "${p.name}" as its parent "${p.parent}".`,
            fix: "Include the parent route params in the absolute child path.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html"
        },
        VUE_ROUTER_R0105: {
            why: (p)=>`Finding ancestor route "${p.ancestor}" failed for "${p.record}"`,
            fix: "Report a reproduction at https://github.com/vuejs/router/issues/new/choose."
        },
        VUE_ROUTER_R0110: {
            why: `A hash base must end with a "#"`,
            fix: (p)=>`Append "#" to the "base" argument passed to "createWebHashHistory()": "${p.base}" should be "${p.suggestion}".`
        },
        VUE_ROUTER_R0120: {
            why: "Error with push/replace State",
            fix: "The browser rejected the history API call; check for cross-origin or rate-limit issues."
        },
        VUE_ROUTER_R0121: {
            why: "history.state seems to have been manually replaced without preserving the necessary values.\nYou can find more information at https://router.vuejs.org/guide/migration/#Usage-of-history-state",
            fix: "Merge the router's state into your own when calling it manually: `history.replaceState({ ...history.state, ...yourState }, '', url)`.",
            docs: "https://router.vuejs.org/guide/migration.html#Usage-of-history-state"
        },
        VUE_ROUTER_R1001: {
            why: (p)=>`Data loader "${String(p.key)}" has a different parent than the current context. This shouldn't be happening.`,
            fix: "Report a bug with a minimal reproduction at https://github.com/vuejs/router/."
        },
        VUE_ROUTER_R1002: {
            why: "Returning a NavigationResult is deprecated.",
            fix: "Replace `return new NavigationResult(to)` with `reroute(to)`, which throws internally to reroute.",
            docs: "https://router.vuejs.org/data-loaders/navigation-aware.html#Controlling-the-navigation-with-reroute-"
        },
        VUE_ROUTER_R1003: {
            why: (p)=>`Loader "${p.key}"'s "commit()" was called but there is no staged data.`,
            fix: "Ensure the loader resolved before calling `commit()`.",
            docs: "https://router.vuejs.org/data-loaders/defining-loaders.html#Delaying-data-updates-with-commit"
        },
        VUE_ROUTER_R1004: {
            why: (p)=>"A loader returned a NavigationResult but is not registered on the route." + p.key,
            fix: "Export the loader from the page component so it gets registered, e.g. `export const useUserData = defineLoader(...)`.",
            docs: "https://router.vuejs.org/data-loaders/organization.html"
        },
        VUE_ROUTER_R1005: {
            why: (p)=>`Data loader "${p.key}" has itself as parent. This shouldn't be happening.`,
            fix: "Report a bug with a minimal reproduction at https://github.com/vuejs/router/."
        },
        VUE_ROUTER_R1006: {
            why: (p)=>`A query was defined with the same key as the loader "[${p.key}]".\nSee https://pinia-colada.esm.dev/#TODO`,
            fix: "If the key is meant to match, use the data loader directly; otherwise rename the `useQuery()` key so it no longer collides.",
            docs: "https://router.vuejs.org/data-loaders/colada.html"
        },
        VUE_ROUTER_R1007: {
            why: "Data Loader was setup twice.",
            fix: "Register `DataLoaderPlugin` a single time via `app.use()`.",
            docs: "https://router.vuejs.org/data-loaders.html#Installation"
        },
        VUE_ROUTER_R1008: {
            why: "Data Loader is experimental and subject to breaking changes in the future.",
            docs: "https://router.vuejs.org/data-loaders.html"
        },
        VUE_ROUTER_R1009: {
            why: "Returning a NavigationResult from a loader is deprecated.",
            fix: "Call `reroute(to)` inside the loader instead of returning `new NavigationResult(to)`; it throws internally to reroute.",
            docs: "https://router.vuejs.org/data-loaders/navigation-aware.html#Controlling-the-navigation-with-reroute-"
        }
    }
});
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $61ae4f1203339483$export$43caf9889c228507 = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $61ae4f1203339483$export$2408f22a0fab9ae5 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $61ae4f1203339483$export$407448d2b89b1813 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $61ae4f1203339483$export$23f2a1d2818174ef = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $61ae4f1203339483$export$ae1af26003f05816 = Symbol("");
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $61ae4f1203339483$export$7ccc53e8f1e7dfc5() {
    return (0, $3dLyd.inject)($61ae4f1203339483$export$407448d2b89b1813);
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $61ae4f1203339483$export$625550452a3fa3ec(_name) {
    return (0, $3dLyd.inject)($61ae4f1203339483$export$23f2a1d2818174ef);
}


parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
//#region \0rolldown/runtime.js

var $76BgN = parcelRequire("76BgN");
var $7427aa90e0ad70d7$require$Buffer = $76BgN.Buffer;
var $7427aa90e0ad70d7$var$__create = Object.create;
var $7427aa90e0ad70d7$var$__defProp = Object.defineProperty;
var $7427aa90e0ad70d7$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $7427aa90e0ad70d7$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $7427aa90e0ad70d7$var$__getProtoOf = Object.getPrototypeOf;
var $7427aa90e0ad70d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7427aa90e0ad70d7$var$__commonJSMin = (cb, mod)=>()=>(mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports);
var $7427aa90e0ad70d7$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $7427aa90e0ad70d7$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$7427aa90e0ad70d7$var$__hasOwnProp.call(to, key) && key !== except) $7427aa90e0ad70d7$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $7427aa90e0ad70d7$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $7427aa90e0ad70d7$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $7427aa90e0ad70d7$var$__create($7427aa90e0ad70d7$var$__getProtoOf(mod)) : {}, $7427aa90e0ad70d7$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $7427aa90e0ad70d7$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/constants.ts
const $7427aa90e0ad70d7$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
const $7427aa90e0ad70d7$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
const $7427aa90e0ad70d7$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
const $7427aa90e0ad70d7$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
//#endregion
//#region src/env.ts
const $7427aa90e0ad70d7$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
const $7427aa90e0ad70d7$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $7427aa90e0ad70d7$export$2a47bd138bf4827c = typeof $7427aa90e0ad70d7$export$44271b4f0c6a3563.chrome !== "undefined" && !!$7427aa90e0ad70d7$export$44271b4f0c6a3563.chrome.devtools;
const $7427aa90e0ad70d7$export$9f140ed41af5108c = $7427aa90e0ad70d7$export$4e09c449d6c407f7 && $7427aa90e0ad70d7$export$44271b4f0c6a3563.self !== $7427aa90e0ad70d7$export$44271b4f0c6a3563.top;
const $7427aa90e0ad70d7$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && navigator.userAgent?.toLowerCase().includes("electron");
const $7427aa90e0ad70d7$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
const $7427aa90e0ad70d7$export$cd24a69e3c9a51c8 = !$7427aa90e0ad70d7$export$9f140ed41af5108c && !$7427aa90e0ad70d7$export$2a47bd138bf4827c && !$7427aa90e0ad70d7$export$6272d088ce0bd5ee;
//#endregion
//#region src/general.ts
var $7427aa90e0ad70d7$var$import_rfdc = /* @__PURE__ */ $7427aa90e0ad70d7$var$__toESM(/* @__PURE__ */ $7427aa90e0ad70d7$var$__commonJSMin((exports, module)=>{
    module.exports = rfdc;
    function copyBuffer(cur) {
        if (cur instanceof $7427aa90e0ad70d7$require$Buffer) return $7427aa90e0ad70d7$require$Buffer.from(cur);
        return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
    }
    function rfdc(opts) {
        opts = opts || {};
        if (opts.circles) return rfdcCircles(opts);
        const constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, (o)=>new Date(o));
        constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
        constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
        if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
        let handler = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            const keys = Object.keys(a);
            const a2 = new Array(keys.length);
            for(let i = 0; i < keys.length; i++){
                const k = keys[i];
                const cur = a[k];
                if (typeof cur !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else a2[k] = fn(cur);
            }
            return a2;
        }
        function clone(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
            const o2 = {};
            for(const k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = clone(cur);
            }
            return o2;
        }
        function cloneProto(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
            const o2 = {};
            for(const k in o){
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = cloneProto(cur);
            }
            return o2;
        }
    }
    function rfdcCircles(opts) {
        const refs = [];
        const refsNew = [];
        const constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, (o)=>new Date(o));
        constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
        constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
        if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
        let handler = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            const keys = Object.keys(a);
            const a2 = new Array(keys.length);
            for(let i = 0; i < keys.length; i++){
                const k = keys[i];
                const cur = a[k];
                if (typeof cur !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else {
                    const index = refs.indexOf(cur);
                    if (index !== -1) a2[k] = refsNew[index];
                    else a2[k] = fn(cur);
                }
            }
            return a2;
        }
        function clone(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
            const o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(const k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    const i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = clone(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
        function cloneProto(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
            const o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(const k in o){
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    const i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = cloneProto(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
    }
})(), 1);
function $7427aa90e0ad70d7$export$5702a91a6f42969f() {}
const $7427aa90e0ad70d7$export$e90fb89750dba83f = (str)=>`${+str}` === str;
const $7427aa90e0ad70d7$export$6159e43e50a41987 = ()=>navigator?.platform ? navigator?.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
const $7427aa90e0ad70d7$var$classifyRE = /(?:^|[-_/])(\w)/g;
const $7427aa90e0ad70d7$var$camelizeRE = /-(\w)/g;
const $7427aa90e0ad70d7$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $7427aa90e0ad70d7$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $7427aa90e0ad70d7$export$b04d9b8d414ba5e8(str) {
    return str && `${str}`.replace($7427aa90e0ad70d7$var$classifyRE, $7427aa90e0ad70d7$var$toUpper);
}
function $7427aa90e0ad70d7$export$161d051f5dd25de7(str) {
    return str && str.replace($7427aa90e0ad70d7$var$camelizeRE, $7427aa90e0ad70d7$var$toUpper);
}
function $7427aa90e0ad70d7$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($7427aa90e0ad70d7$var$kebabizeRE, (_, lowerCaseCharacter, upperCaseLetter)=>{
        return `${lowerCaseCharacter}-${upperCaseLetter}`;
    }).toLowerCase();
}
function $7427aa90e0ad70d7$export$9bf319d8f74f51d1(filename, ext) {
    let normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith(`index${ext}`)) normalizedFilename = normalizedFilename.replace(`/index${ext}`, ext);
    const lastSlashIndex = normalizedFilename.lastIndexOf("/");
    const baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        const extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $7427aa90e0ad70d7$export$584200199479c807(state) {
    return state && state.slice().sort((a, b)=>{
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
const $7427aa90e0ad70d7$var$HTTP_URL_RE = /^https?:\/\//;
/**
* Check a string is start with `/` or a valid http url
*/ function $7427aa90e0ad70d7$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $7427aa90e0ad70d7$var$HTTP_URL_RE.test(str);
}
/**
* @copyright [rfdc](https://github.com/davidmarkclements/rfdc)
* @description A really fast deep clone alternative
*/ const $7427aa90e0ad70d7$export$b7d58db314e0ac27 = (0, $7427aa90e0ad70d7$var$import_rfdc.default)({
    circles: true
});
function $7427aa90e0ad70d7$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $7427aa90e0ad70d7$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function $7427aa90e0ad70d7$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $7427aa90e0ad70d7$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $7427aa90e0ad70d7$export$5c90113a285f2241(value) {
    return value instanceof Map;
}


//#region src/index.ts
const $db82f83da91bd66b$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
/**
Debounce functions
@param fn - Promise-returning/async function to debounce.
@param wait - Milliseconds to wait before calling `fn`. Default value is 25ms
@returns A function that delays calling `fn` until after `wait` milliseconds have elapsed since the last time it was called.
@example
```
import { debounce } from 'perfect-debounce';
const expensiveCall = async input => input;
const debouncedFn = debounce(expensiveCall, 200);
for (const number of [1, 2, 3]) {
console.log(await debouncedFn(number));
}
//=> 1
//=> 2
//=> 3
```
*/ function $db82f83da91bd66b$export$61fc7d43ac8f84b0(fn, wait = 25, options = {}) {
    options = {
        ...$db82f83da91bd66b$var$DEBOUNCE_DEFAULTS,
        ...options
    };
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    let leadingValue;
    let timeout;
    let resolveList = [];
    let currentPromise;
    let trailingArgs;
    const applyFn = (_this, args)=>{
        currentPromise = $db82f83da91bd66b$var$_applyPromised(fn, _this, args);
        currentPromise.finally(()=>{
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                const promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    const debounced = function(...args) {
        if (options.trailing) trailingArgs = args;
        if (currentPromise) return currentPromise;
        return new Promise((resolve)=>{
            const shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const promise = options.leading ? leadingValue : applyFn(this, args);
                trailingArgs = null;
                for (const _resolve of resolveList)_resolve(promise);
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
    const _clearTimeout = (timer)=>{
        if (timer) {
            clearTimeout(timer);
            timeout = null;
        }
    };
    debounced.isPending = ()=>!!timeout;
    debounced.cancel = ()=>{
        _clearTimeout(timeout);
        resolveList = [];
        trailingArgs = null;
    };
    debounced.flush = ()=>{
        _clearTimeout(timeout);
        if (!trailingArgs || currentPromise) return;
        const args = trailingArgs;
        trailingArgs = null;
        return applyFn(this, args);
    };
    return debounced;
}
async function $db82f83da91bd66b$var$_applyPromised(fn, _this, args) {
    return await fn.apply(_this, args);
}


function $36697f719f6f561e$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $36697f719f6f561e$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $36697f719f6f561e$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $36697f719f6f561e$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$36697f719f6f561e$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $36697f719f6f561e$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $36697f719f6f561e$var$defaultTask = {
    run: (function_)=>function_()
};
const $36697f719f6f561e$var$_createTask = ()=>$36697f719f6f561e$var$defaultTask;
const $36697f719f6f561e$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $36697f719f6f561e$var$_createTask;
function $36697f719f6f561e$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $36697f719f6f561e$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $36697f719f6f561e$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $36697f719f6f561e$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $36697f719f6f561e$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $36697f719f6f561e$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $36697f719f6f561e$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $36697f719f6f561e$export$f26845e0fc859724 {
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $36697f719f6f561e$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $36697f719f6f561e$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($36697f719f6f561e$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($36697f719f6f561e$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $36697f719f6f561e$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $36697f719f6f561e$var$callEachWith(this._after, event);
        });
        if (this._after && event) $36697f719f6f561e$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
}
function $36697f719f6f561e$export$39c6a2b4dbabca5d() {
    return new $36697f719f6f561e$export$f26845e0fc859724();
}
const $36697f719f6f561e$var$isBrowser = typeof window !== "undefined";
function $36697f719f6f561e$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $36697f719f6f561e$var$isBrowser,
        group: $36697f719f6f561e$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}


const $71801a0999247337$var$TYPE_REQUEST = "q";
const $71801a0999247337$var$TYPE_RESPONSE = "s";
const $71801a0999247337$export$7bd623b29ec8e1eb = 6e4;
function $71801a0999247337$var$defaultSerialize(i) {
    return i;
}
const $71801a0999247337$var$defaultDeserialize = $71801a0999247337$var$defaultSerialize;
const { clearTimeout: $71801a0999247337$var$clearTimeout, setTimeout: $71801a0999247337$var$setTimeout } = globalThis;
const $71801a0999247337$var$random = Math.random.bind(Math);
function $71801a0999247337$export$8de909a09ac6851a($functions, options) {
    const { post: post, on: on, off: off = ()=>{}, eventNames: eventNames = [], serialize: serialize = $71801a0999247337$var$defaultSerialize, deserialize: deserialize = $71801a0999247337$var$defaultDeserialize, resolver: resolver, bind: bind = "rpc", timeout: timeout = $71801a0999247337$export$7bd623b29ec8e1eb } = options;
    let $closed = false;
    const _rpcPromiseMap = /* @__PURE__ */ new Map();
    let _promiseInit;
    let rpc;
    async function _call(method, args, event, optional) {
        if ($closed) throw new Error(`[birpc] rpc is closed, cannot call "${method}"`);
        const req = {
            m: method,
            a: args,
            t: $71801a0999247337$var$TYPE_REQUEST
        };
        if (optional) req.o = true;
        const send = async (_req)=>post(serialize(_req));
        if (event) {
            await send(req);
            return;
        }
        if (_promiseInit) try {
            await _promiseInit;
        } finally{
            _promiseInit = void 0;
        }
        let { promise: promise, resolve: resolve, reject: reject } = $71801a0999247337$var$createPromiseWithResolvers();
        const id = $71801a0999247337$var$nanoid();
        req.i = id;
        let timeoutId;
        async function handler(newReq = req) {
            if (timeout >= 0) {
                timeoutId = $71801a0999247337$var$setTimeout(()=>{
                    try {
                        const handleResult = options.onTimeoutError?.call(rpc, method, args);
                        if (handleResult !== true) throw new Error(`[birpc] timeout on calling "${method}"`);
                    } catch (e) {
                        reject(e);
                    }
                    _rpcPromiseMap.delete(id);
                }, timeout);
                if (typeof timeoutId === "object") timeoutId = timeoutId.unref?.();
            }
            _rpcPromiseMap.set(id, {
                resolve: resolve,
                reject: reject,
                timeoutId: timeoutId,
                method: method
            });
            await send(newReq);
            return promise;
        }
        try {
            if (options.onRequest) await options.onRequest.call(rpc, req, handler, resolve);
            else await handler();
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        } finally{
            $71801a0999247337$var$clearTimeout(timeoutId);
            _rpcPromiseMap.delete(id);
        }
        return promise;
    }
    const $call = (method, ...args)=>_call(method, args, false);
    const $callOptional = (method, ...args)=>_call(method, args, false, true);
    const $callEvent = (method, ...args)=>_call(method, args, true);
    const $callRaw = (options2)=>_call(options2.method, options2.args, options2.event, options2.optional);
    const builtinMethods = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent,
        $callRaw: $callRaw,
        $rejectPendingCalls: $rejectPendingCalls,
        get $closed () {
            return $closed;
        },
        get $meta () {
            return options.meta;
        },
        $close: $close,
        $functions: $functions
    };
    rpc = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(builtinMethods, method)) return builtinMethods[method];
            if (method === "then" && !eventNames.includes("then") && !("then" in $functions)) return void 0;
            const sendEvent = (...args)=>_call(method, args, true);
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            const sendCall = (...args)=>_call(method, args, false);
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function $close(customError) {
        $closed = true;
        _rpcPromiseMap.forEach(({ reject: reject, method: method })=>{
            const error = new Error(`[birpc] rpc is closed, cannot call "${method}"`);
            if (customError) {
                customError.cause ??= error;
                return reject(customError);
            }
            reject(error);
        });
        _rpcPromiseMap.clear();
        off(onMessage);
    }
    function $rejectPendingCalls(handler) {
        const entries = Array.from(_rpcPromiseMap.values());
        const handlerResults = entries.map(({ method: method, reject: reject })=>{
            if (!handler) return reject(new Error(`[birpc]: rejected pending call "${method}".`));
            return handler({
                method: method,
                reject: reject
            });
        });
        _rpcPromiseMap.clear();
        return handlerResults;
    }
    async function onMessage(data, ...extra) {
        let msg;
        try {
            msg = deserialize(data);
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        }
        if (msg.t === $71801a0999247337$var$TYPE_REQUEST) {
            const { m: method, a: args, o: optional } = msg;
            let result, error;
            let fn = await (resolver ? resolver.call(rpc, method, $functions[method]) : $functions[method]);
            if (optional) fn ||= ()=>void 0;
            if (!fn) error = new Error(`[birpc] function "${method}" not found`);
            else try {
                result = await fn.apply(bind === "rpc" ? rpc : $functions, args);
            } catch (e) {
                error = e;
            }
            if (msg.i) {
                if (error && options.onError) options.onError.call(rpc, error, method, args);
                if (error && options.onFunctionError) {
                    if (options.onFunctionError.call(rpc, error, method, args) === true) return;
                }
                if (!error) try {
                    await post(serialize({
                        t: $71801a0999247337$var$TYPE_RESPONSE,
                        i: msg.i,
                        r: result
                    }), ...extra);
                    return;
                } catch (e) {
                    error = e;
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
                try {
                    await post(serialize({
                        t: $71801a0999247337$var$TYPE_RESPONSE,
                        i: msg.i,
                        e: error
                    }), ...extra);
                } catch (e) {
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
            }
        } else {
            const { i: ack, r: result, e: error } = msg;
            const promise = _rpcPromiseMap.get(ack);
            if (promise) {
                $71801a0999247337$var$clearTimeout(promise.timeoutId);
                if (error) promise.reject(error);
                else promise.resolve(result);
            }
            _rpcPromiseMap.delete(ack);
        }
    }
    _promiseInit = on(onMessage);
    return rpc;
}
const $71801a0999247337$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $71801a0999247337$export$c26b4cbcfe84a428(items, fn) {
    return items.map((i)=>{
        let r = $71801a0999247337$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $71801a0999247337$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $71801a0999247337$export$ec516731f3c62ae5(functions, channels, options = {}) {
    const getChannels = ()=>typeof channels === "function" ? channels() : channels;
    const getClients = (channels2 = getChannels())=>$71801a0999247337$export$c26b4cbcfe84a428(channels2, (s)=>$71801a0999247337$export$8de909a09ac6851a(functions, {
                ...options,
                ...s
            }));
    function _boardcast(method, args, event, optional) {
        const clients = getClients();
        return Promise.all(clients.map((c)=>c.$callRaw({
                method: method,
                args: args,
                event: event,
                optional: optional
            })));
    }
    function $call(method, ...args) {
        return _boardcast(method, args, false);
    }
    function $callOptional(method, ...args) {
        return _boardcast(method, args, false, true);
    }
    function $callEvent(method, ...args) {
        return _boardcast(method, args, true);
    }
    const broadcastBuiltin = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent
    };
    const broadcastProxy = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(broadcastBuiltin, method)) return broadcastBuiltin[method];
            const client = getClients();
            const callbacks = client.map((c)=>c[method]);
            const sendCall = (...args)=>{
                return Promise.all(callbacks.map((i)=>i(...args)));
            };
            sendCall.asEvent = async (...args)=>{
                await Promise.all(callbacks.map((i)=>i.asEvent(...args)));
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        const channels2 = getChannels();
        fn?.(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
function $71801a0999247337$var$createPromiseWithResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $71801a0999247337$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $71801a0999247337$var$nanoid(size = 21) {
    let id = "";
    let i = size;
    while(i--)id += $71801a0999247337$var$urlAlphabet[$71801a0999247337$var$random() * 64 | 0];
    return id;
}


//#region \0rolldown/runtime.js
var $f8f651eebe4ca737$var$__create = Object.create;
var $f8f651eebe4ca737$var$__defProp = Object.defineProperty;
var $f8f651eebe4ca737$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f8f651eebe4ca737$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f8f651eebe4ca737$var$__getProtoOf = Object.getPrototypeOf;
var $f8f651eebe4ca737$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f8f651eebe4ca737$var$__commonJSMin = (cb, mod)=>()=>(mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports);
var $f8f651eebe4ca737$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $f8f651eebe4ca737$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$f8f651eebe4ca737$var$__hasOwnProp.call(to, key) && key !== except) $f8f651eebe4ca737$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $f8f651eebe4ca737$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $f8f651eebe4ca737$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $f8f651eebe4ca737$var$__create($f8f651eebe4ca737$var$__getProtoOf(mod)) : {}, $f8f651eebe4ca737$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $f8f651eebe4ca737$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/compat/index.ts
function $f8f651eebe4ca737$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set (value) {
            if (value) cb();
        },
        configurable: true
    });
}
//#endregion
//#region src/core/component/utils/index.ts
function $f8f651eebe4ca737$var$getComponentTypeName(options) {
    if (typeof options === "function") return options.displayName || options.name || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || "";
    const name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && options.__file?.endsWith("index.vue")) return "";
    return name;
}
function $f8f651eebe4ca737$var$getComponentFileName(options) {
    const file = options.__file;
    if (file) return (0, $7427aa90e0ad70d7$export$b04d9b8d414ba5e8)((0, $7427aa90e0ad70d7$export$9bf319d8f74f51d1)(file, ".vue"));
}
function $f8f651eebe4ca737$var$getComponentName(options) {
    const name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $f8f651eebe4ca737$var$getComponentFileName(options);
}
function $f8f651eebe4ca737$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $f8f651eebe4ca737$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function $f8f651eebe4ca737$var$getComponentId(options) {
    const { app: app, uid: uid, instance: instance } = options;
    try {
        if (instance.__VUE_DEVTOOLS_NEXT_UID__) return instance.__VUE_DEVTOOLS_NEXT_UID__;
        const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
        if (!appRecord) return null;
        const isRoot = appRecord.rootInstance === instance;
        return `${appRecord.id}:${isRoot ? "root" : uid}`;
    } catch (e) {}
}
function $f8f651eebe4ca737$var$isFragment(instance) {
    const subTreeType = instance.subTree?.type;
    const appRecord = $f8f651eebe4ca737$var$getAppRecord(instance);
    if (appRecord) return appRecord?.types?.Fragment === subTreeType;
    return false;
}
function $f8f651eebe4ca737$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
/**
* Get the appropriate display name for an instance.
*
* @param {Vue} instance
* @return {string}
*/ function $f8f651eebe4ca737$var$getInstanceName(instance) {
    const name = $f8f651eebe4ca737$var$getComponentTypeName(instance?.type || {});
    if (name) return name;
    if (instance?.root === instance) return "Root";
    for(const key in instance.parent?.type?.components)if (instance.parent.type.components[key] === instance?.type) return $f8f651eebe4ca737$var$saveComponentGussedName(instance, key);
    for(const key in instance.appContext?.components)if (instance.appContext.components[key] === instance?.type) return $f8f651eebe4ca737$var$saveComponentGussedName(instance, key);
    const fileName = $f8f651eebe4ca737$var$getComponentFileName(instance?.type || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
/**
* Returns a devtools unique id for instance.
* @param {Vue} instance
*/ function $f8f651eebe4ca737$var$getUniqueComponentId(instance) {
    return `${instance?.appContext?.app?.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ ?? 0}:${instance === instance?.root ? "root" : instance.uid}`;
}
function $f8f651eebe4ca737$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return `'${value}'`;
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $f8f651eebe4ca737$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $f8f651eebe4ca737$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || `${appRecord.id}:root`;
    return appRecord.instanceMap.get(instanceId) || appRecord.instanceMap.get(":root");
}
function $f8f651eebe4ca737$var$ensurePropertyExists(obj, key, skipObjCheck = false) {
    return skipObjCheck ? key in obj : typeof obj === "object" && obj !== null ? key in obj : false;
}
//#endregion
//#region src/core/component/state/bounding-rect.ts
function $f8f651eebe4ca737$var$createRect() {
    const rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
let $f8f651eebe4ca737$var$range;
function $f8f651eebe4ca737$var$getTextRect(node) {
    if (!$f8f651eebe4ca737$var$range) $f8f651eebe4ca737$var$range = document.createRange();
    $f8f651eebe4ca737$var$range.selectNode(node);
    return $f8f651eebe4ca737$var$range.getBoundingClientRect();
}
function $f8f651eebe4ca737$var$getFragmentRect(vnode) {
    const rect = $f8f651eebe4ca737$var$createRect();
    if (!vnode.children) return rect;
    for(let i = 0, l = vnode.children.length; i < l; i++){
        const childVnode = vnode.children[i];
        let childRect;
        if (childVnode.component) childRect = $f8f651eebe4ca737$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            const el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $f8f651eebe4ca737$var$getTextRect(el);
        }
        if (childRect) $f8f651eebe4ca737$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $f8f651eebe4ca737$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
const $f8f651eebe4ca737$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $f8f651eebe4ca737$var$getComponentBoundingRect(instance) {
    const el = instance.subTree.el;
    if (typeof window === "undefined") return $f8f651eebe4ca737$var$DEFAULT_RECT;
    if ($f8f651eebe4ca737$var$isFragment(instance)) return $f8f651eebe4ca737$var$getFragmentRect(instance.subTree);
    else if (el?.nodeType === 1) return el?.getBoundingClientRect();
    else if (instance.subTree.component) return $f8f651eebe4ca737$var$getComponentBoundingRect(instance.subTree.component);
    else return $f8f651eebe4ca737$var$DEFAULT_RECT;
}
//#endregion
//#region src/core/component/tree/el.ts
function $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(instance) {
    if ($f8f651eebe4ca737$var$isFragment(instance)) return $f8f651eebe4ca737$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $f8f651eebe4ca737$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    const list = [];
    vnode.children.forEach((childVnode)=>{
        if (childVnode.component) list.push(...$f8f651eebe4ca737$var$getRootElementsFromComponentInstance(childVnode.component));
        else if (childVnode?.el) list.push(childVnode.el);
    });
    return list;
}
//#endregion
//#region src/core/component-highlighter/index.ts
const $f8f651eebe4ca737$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
const $f8f651eebe4ca737$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
const $f8f651eebe4ca737$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
const $f8f651eebe4ca737$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
const $f8f651eebe4ca737$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
const $f8f651eebe4ca737$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
const $f8f651eebe4ca737$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: .7
};
function $f8f651eebe4ca737$var$getContainerElement() {
    return document.getElementById($f8f651eebe4ca737$var$CONTAINER_ELEMENT_ID);
}
function $f8f651eebe4ca737$var$getCardElement() {
    return document.getElementById($f8f651eebe4ca737$var$CARD_ELEMENT_ID);
}
function $f8f651eebe4ca737$var$getIndicatorElement() {
    return document.getElementById($f8f651eebe4ca737$var$INDICATOR_ELEMENT_ID);
}
function $f8f651eebe4ca737$var$getNameElement() {
    return document.getElementById($f8f651eebe4ca737$var$COMPONENT_NAME_ELEMENT_ID);
}
function $f8f651eebe4ca737$var$getStyles(bounds) {
    return {
        left: `${Math.round(bounds.left * 100) / 100}px`,
        top: `${Math.round(bounds.top * 100) / 100}px`,
        width: `${Math.round(bounds.width * 100) / 100}px`,
        height: `${Math.round(bounds.height * 100) / 100}px`
    };
}
function $f8f651eebe4ca737$var$create(options) {
    const containerEl = document.createElement("div");
    containerEl.id = options.elementId ?? $f8f651eebe4ca737$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, {
        ...$f8f651eebe4ca737$var$containerStyles,
        ...$f8f651eebe4ca737$var$getStyles(options.bounds),
        ...options.style
    });
    const cardEl = document.createElement("span");
    cardEl.id = $f8f651eebe4ca737$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, {
        ...$f8f651eebe4ca737$var$cardStyles,
        top: options.bounds.top < 35 ? 0 : "-35px"
    });
    const nameEl = document.createElement("span");
    nameEl.id = $f8f651eebe4ca737$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
    const indicatorEl = document.createElement("i");
    indicatorEl.id = $f8f651eebe4ca737$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    Object.assign(indicatorEl.style, $f8f651eebe4ca737$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $f8f651eebe4ca737$var$update(options) {
    const containerEl = $f8f651eebe4ca737$var$getContainerElement();
    const cardEl = $f8f651eebe4ca737$var$getCardElement();
    const nameEl = $f8f651eebe4ca737$var$getNameElement();
    const indicatorEl = $f8f651eebe4ca737$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, {
            ...$f8f651eebe4ca737$var$containerStyles,
            ...$f8f651eebe4ca737$var$getStyles(options.bounds)
        });
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
        indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    }
}
function $f8f651eebe4ca737$var$highlight(instance) {
    const bounds = $f8f651eebe4ca737$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    const name = $f8f651eebe4ca737$var$getInstanceName(instance);
    $f8f651eebe4ca737$var$getContainerElement() ? $f8f651eebe4ca737$var$update({
        bounds: bounds,
        name: name
    }) : $f8f651eebe4ca737$var$create({
        bounds: bounds,
        name: name
    });
}
function $f8f651eebe4ca737$var$unhighlight() {
    const el = $f8f651eebe4ca737$var$getContainerElement();
    if (el) el.style.display = "none";
}
let $f8f651eebe4ca737$var$inspectInstance = null;
function $f8f651eebe4ca737$var$inspectFn(e) {
    const target = e.target;
    if (target) {
        const instance = target.__vueParentComponent;
        if (instance) {
            $f8f651eebe4ca737$var$inspectInstance = instance;
            if (instance.vnode.el) {
                const bounds = $f8f651eebe4ca737$var$getComponentBoundingRect(instance);
                const name = $f8f651eebe4ca737$var$getInstanceName(instance);
                $f8f651eebe4ca737$var$getContainerElement() ? $f8f651eebe4ca737$var$update({
                    bounds: bounds,
                    name: name
                }) : $f8f651eebe4ca737$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $f8f651eebe4ca737$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($f8f651eebe4ca737$var$inspectInstance) cb($f8f651eebe4ca737$var$getUniqueComponentId($f8f651eebe4ca737$var$inspectInstance));
}
let $f8f651eebe4ca737$var$inspectComponentHighLighterSelectFn = null;
function $f8f651eebe4ca737$var$cancelInspectComponentHighLighter() {
    $f8f651eebe4ca737$var$unhighlight();
    window.removeEventListener("mouseover", $f8f651eebe4ca737$var$inspectFn);
    window.removeEventListener("click", $f8f651eebe4ca737$var$inspectComponentHighLighterSelectFn, true);
    $f8f651eebe4ca737$var$inspectComponentHighLighterSelectFn = null;
}
function $f8f651eebe4ca737$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $f8f651eebe4ca737$var$inspectFn);
    return new Promise((resolve)=>{
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $f8f651eebe4ca737$var$selectComponentFn(e, (id)=>{
                window.removeEventListener("click", onSelect, true);
                $f8f651eebe4ca737$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $f8f651eebe4ca737$var$inspectFn);
                const el = $f8f651eebe4ca737$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $f8f651eebe4ca737$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $f8f651eebe4ca737$var$scrollToComponent(options) {
    const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, options.id);
    if (instance) {
        const [el] = $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(instance);
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            const bounds = $f8f651eebe4ca737$var$getComponentBoundingRect(instance);
            const scrollTarget = document.createElement("div");
            const styles = {
                ...$f8f651eebe4ca737$var$getStyles(bounds),
                position: "absolute"
            };
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(()=>{
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(()=>{
            const bounds = $f8f651eebe4ca737$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                const name = $f8f651eebe4ca737$var$getInstanceName(instance);
                const el = $f8f651eebe4ca737$var$getContainerElement();
                el ? $f8f651eebe4ca737$var$update({
                    ...options,
                    name: name,
                    bounds: bounds
                }) : $f8f651eebe4ca737$var$create({
                    ...options,
                    name: name,
                    bounds: bounds
                });
                setTimeout(()=>{
                    if (el) el.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
//#endregion
//#region src/core/component-inspector/index.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ ??= true;
function $f8f651eebe4ca737$export$56455f68fb6e3b63(enabled) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $f8f651eebe4ca737$var$waitForInspectorInit(cb) {
    let total = 0;
    const timer = setInterval(()=>{
        if ((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= 5e3) clearInterval(timer);
    }, 30);
}
function $f8f651eebe4ca737$var$setupInspector() {
    const inspector = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_INSPECTOR__;
    const _openInEditor = inspector.openInEditor;
    inspector.openInEditor = async (...params)=>{
        inspector.disable();
        _openInEditor(...params);
    };
}
function $f8f651eebe4ca737$var$getComponentInspector() {
    return new Promise((resolve)=>{
        function setup() {
            $f8f651eebe4ca737$var$setupInspector();
            resolve((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_INSPECTOR__);
        }
        if (!(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_INSPECTOR__) $f8f651eebe4ca737$var$waitForInspectorInit(()=>{
            setup();
        });
        else setup();
    });
}
//#endregion
//#region src/shared/stub-vue.ts
/**
* To prevent include a **HUGE** vue package in the final bundle of chrome ext / electron
* we stub the necessary vue module.
* This implementation is based on the 1c3327a0fa5983aa9078e3f7bb2330f572435425 commit
*/ /**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/constants.ts#L17-L23)
*/ let $f8f651eebe4ca737$var$ReactiveFlags = /* @__PURE__ */ function(ReactiveFlags) {
    ReactiveFlags["SKIP"] = "__v_skip";
    ReactiveFlags["IS_REACTIVE"] = "__v_isReactive";
    ReactiveFlags["IS_READONLY"] = "__v_isReadonly";
    ReactiveFlags["IS_SHALLOW"] = "__v_isShallow";
    ReactiveFlags["RAW"] = "__v_raw";
    return ReactiveFlags;
}({});
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L330-L332)
*/ function $f8f651eebe4ca737$var$isReadonly(value) {
    return !!(value && value[$f8f651eebe4ca737$var$ReactiveFlags.IS_READONLY]);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L312-L317)
*/ function $f8f651eebe4ca737$var$isReactive$1(value) {
    if ($f8f651eebe4ca737$var$isReadonly(value)) return $f8f651eebe4ca737$var$isReactive$1(value[$f8f651eebe4ca737$var$ReactiveFlags.RAW]);
    return !!(value && value[$f8f651eebe4ca737$var$ReactiveFlags.IS_REACTIVE]);
}
function $f8f651eebe4ca737$var$isRef$1(r) {
    return !!(r && r.__v_isRef === true);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L372-L375)
*/ function $f8f651eebe4ca737$var$toRaw$1(observed) {
    const raw = observed && observed[$f8f651eebe4ca737$var$ReactiveFlags.RAW];
    return raw ? $f8f651eebe4ca737$var$toRaw$1(raw) : observed;
}
//#endregion
//#region src/core/component/state/editor.ts
var $f8f651eebe4ca737$var$StateEditor = class {
    constructor(){
        this.refEditor = new $f8f651eebe4ca737$var$RefStateEditor();
    }
    set(object, path, value, cb) {
        const sections = Array.isArray(path) ? path : path.split(".");
        while(sections.length > 1){
            const section = sections.shift();
            if (object instanceof Map) object = object.get(section);
            else if (object instanceof Set) object = Array.from(object.values())[section];
            else object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        const field = sections[0];
        const item = this.refEditor.get(object)[field];
        if (cb) cb(object, field, value);
        else if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
        else object[field] = value;
    }
    get(object, path) {
        const sections = Array.isArray(path) ? path : path.split(".");
        for(let i = 0; i < sections.length; i++){
            if (object instanceof Map) object = object.get(sections[i]);
            else object = object[sections[i]];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
            if (!object) return void 0;
        }
        return object;
    }
    has(object, path, parent = false) {
        if (typeof object === "undefined") return false;
        const sections = Array.isArray(path) ? path.slice() : path.split(".");
        const size = !parent ? 1 : 2;
        while(object && sections.length > size){
            const section = sections.shift();
            object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
    }
    createDefaultSetCallback(state) {
        return (object, field, value)=>{
            if (state.remove || state.newKey) {
                if (Array.isArray(object)) object.splice(field, 1);
                else if ($f8f651eebe4ca737$var$toRaw$1(object) instanceof Map) object.delete(field);
                else if ($f8f651eebe4ca737$var$toRaw$1(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                else Reflect.deleteProperty(object, field);
            }
            if (!state.remove) {
                const target = object[state.newKey || field];
                if (this.refEditor.isRef(target)) this.refEditor.set(target, value);
                else if ($f8f651eebe4ca737$var$toRaw$1(object) instanceof Map) object.set(state.newKey || field, value);
                else if ($f8f651eebe4ca737$var$toRaw$1(object) instanceof Set) object.add(value);
                else object[state.newKey || field] = value;
            }
        };
    }
};
var $f8f651eebe4ca737$var$RefStateEditor = class {
    set(ref, value) {
        if ($f8f651eebe4ca737$var$isRef$1(ref)) ref.value = value;
        else {
            if (ref instanceof Set && Array.isArray(value)) {
                ref.clear();
                value.forEach((v)=>ref.add(v));
                return;
            }
            const currentKeys = Object.keys(value);
            if (ref instanceof Map) {
                const previousKeysSet = new Set(ref.keys());
                currentKeys.forEach((key)=>{
                    ref.set(key, Reflect.get(value, key));
                    previousKeysSet.delete(key);
                });
                previousKeysSet.forEach((key)=>ref.delete(key));
                return;
            }
            const previousKeysSet = new Set(Object.keys(ref));
            currentKeys.forEach((key)=>{
                Reflect.set(ref, key, Reflect.get(value, key));
                previousKeysSet.delete(key);
            });
            previousKeysSet.forEach((key)=>Reflect.deleteProperty(ref, key));
        }
    }
    get(ref) {
        return $f8f651eebe4ca737$var$isRef$1(ref) ? ref.value : ref;
    }
    isRef(ref) {
        return $f8f651eebe4ca737$var$isRef$1(ref) || $f8f651eebe4ca737$var$isReactive$1(ref);
    }
};
async function $f8f651eebe4ca737$var$editComponentState(payload, stateEditor) {
    const { path: path, nodeId: nodeId, state: state, type: type } = payload;
    const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, nodeId);
    if (!instance) return;
    const targetPath = path.slice();
    let target;
    if (Object.keys(instance.props).includes(path[0])) target = instance.props;
    else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) target = instance.devtoolsRawSetupState;
    else if (instance.data && Object.keys(instance.data).includes(path[0])) target = instance.data;
    else target = instance.proxy;
    if (target && targetPath) {
        state.type === "object" && type;
        stateEditor.set(target, targetPath, state.value, stateEditor.createDefaultSetCallback(state));
    }
}
const $f8f651eebe4ca737$var$stateEditor = new $f8f651eebe4ca737$var$StateEditor();
async function $f8f651eebe4ca737$var$editState(payload) {
    $f8f651eebe4ca737$var$editComponentState(payload, $f8f651eebe4ca737$var$stateEditor);
}
//#endregion
//#region src/core/timeline/storage.ts
const $f8f651eebe4ca737$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $f8f651eebe4ca737$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $7427aa90e0ad70d7$export$4e09c449d6c407f7) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($f8f651eebe4ca737$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $f8f651eebe4ca737$var$getTimelineLayersStateFromStorage() {
    if (typeof window === "undefined" || !(0, $7427aa90e0ad70d7$export$4e09c449d6c407f7) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    const state = typeof localStorage.getItem !== "undefined" ? localStorage.getItem($f8f651eebe4ca737$var$TIMELINE_LAYERS_STATE_STORAGE_ID) : null;
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
//#endregion
//#region src/ctx/timeline.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS ??= [];
const $f8f651eebe4ca737$var$devtoolsTimelineLayers = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $f8f651eebe4ca737$var$addTimelineLayer(options, descriptor) {
    $f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $f8f651eebe4ca737$var$devtoolsTimelineLayers.push({
        ...options,
        descriptorId: descriptor.id,
        appRecord: $f8f651eebe4ca737$var$getAppRecord(descriptor.app)
    });
}
function $f8f651eebe4ca737$export$736910b7e8839d93(state) {
    const updatedState = {
        ...$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState,
        ...state
    };
    $f8f651eebe4ca737$var$addTimelineLayersStateToStorage(updatedState);
    $f8f651eebe4ca737$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
//#endregion
//#region src/ctx/inspector.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_INSPECTOR__ ??= [];
const $f8f651eebe4ca737$export$996e3c8abad0143f = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
const $f8f651eebe4ca737$export$17f8005932e80cc0 = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(()=>{
    $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHook($f8f651eebe4ca737$export$12aa7e661bddec80.SEND_INSPECTOR_TO_CLIENT, $f8f651eebe4ca737$export$2844c7432ba9d166());
});
function $f8f651eebe4ca737$export$e863e3b6c2ff029b(inspector, descriptor) {
    $f8f651eebe4ca737$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder ?? "Search tree...",
        stateFilterPlaceholder: inspector.stateFilterPlaceholder ?? "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $f8f651eebe4ca737$var$getAppRecord(descriptor.app)
    });
    $f8f651eebe4ca737$export$17f8005932e80cc0();
}
function $f8f651eebe4ca737$export$2844c7432ba9d166() {
    return $f8f651eebe4ca737$export$996e3c8abad0143f.filter((inspector)=>inspector.descriptor.app === $f8f651eebe4ca737$export$162128841a7f2877.value.app).filter((inspector)=>inspector.descriptor.id !== "components").map((inspector)=>{
        const descriptor = inspector.descriptor;
        const options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: `custom-ic-baseline-${options?.icon?.replace(/_/g, "-")}`,
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $f8f651eebe4ca737$export$5042bdc6f02e4304(id) {
    const inspector = $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(id, $f8f651eebe4ca737$export$162128841a7f2877.value.app);
    if (!inspector) return;
    const descriptor = inspector.descriptor;
    const options = inspector.options;
    const timelineLayers = $f8f651eebe4ca737$var$devtoolsTimelineLayers.filter((layer)=>layer.descriptorId === descriptor.id).map((item)=>({
            id: item.id,
            label: item.label,
            color: item.color
        }));
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(id, app) {
    return $f8f651eebe4ca737$export$996e3c8abad0143f.find((inspector)=>inspector.options.id === id && (app ? inspector.descriptor.app === app : true));
}
function $f8f651eebe4ca737$export$54eb86d2eca92815(id) {
    return $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(id)?.options.actions;
}
function $f8f651eebe4ca737$export$eebdca42b352a0b2(id) {
    return $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(id)?.options.nodeActions;
}
//#endregion
//#region src/ctx/hook.ts
let $f8f651eebe4ca737$export$3936435a794cb908 = /* @__PURE__ */ function(DevToolsV6PluginAPIHookKeys) {
    DevToolsV6PluginAPIHookKeys["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys;
}({});
let $f8f651eebe4ca737$export$4c35c03df042a977 = /* @__PURE__ */ function(DevToolsContextHookKeys) {
    DevToolsContextHookKeys["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys;
}({});
let $f8f651eebe4ca737$export$12aa7e661bddec80 = /* @__PURE__ */ function(DevToolsMessagingHookKeys) {
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys;
}({});
function $f8f651eebe4ca737$export$73be3ac6032ad9bb() {
    const hooks = (0, $36697f719f6f561e$export$39c6a2b4dbabca5d)();
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.ADD_INSPECTOR, ({ inspector: inspector, plugin: plugin })=>{
        $f8f651eebe4ca737$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    const debounceSendInspectorTree = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        if (!inspectorId || !plugin?.descriptor?.app || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            filter: inspector?.treeFilter || "",
            rootNodes: []
        };
        await new Promise((resolve)=>{
            hooks.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload)));
                resolve();
            }, $f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_TREE);
        });
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    rootNodes: _payload.rootNodes
                })));
        }, $f8f651eebe4ca737$export$12aa7e661bddec80.SEND_INSPECTOR_TREE_TO_CLIENT);
    }, 120);
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_TREE, debounceSendInspectorTree);
    const debounceSendInspectorState = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        if (!inspectorId || !plugin?.descriptor?.app || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            nodeId: inspector?.selectedNodeId || "",
            state: null
        };
        const ctx = {
            currentTab: `custom-inspector:${inspectorId}`
        };
        if (_payload.nodeId) await new Promise((resolve)=>{
            hooks.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                resolve();
            }, $f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_STATE);
        });
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    nodeId: _payload.nodeId,
                    state: _payload.state
                })));
        }, $f8f651eebe4ca737$export$12aa7e661bddec80.SEND_INSPECTOR_STATE_TO_CLIENT);
    }, 120);
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_STATE, debounceSendInspectorState);
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, ({ inspectorId: inspectorId, nodeId: nodeId, plugin: plugin })=>{
        const inspector = $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, ({ options: options, plugin: plugin })=>{
        $f8f651eebe4ca737$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, ({ options: options, plugin: plugin })=>{
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState?.[plugin.descriptor.id] && ![
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ].includes(options.layerId)) return;
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb(options)));
        }, $f8f651eebe4ca737$export$12aa7e661bddec80.SEND_TIMELINE_EVENT_TO_CLIENT);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, async ({ app: app })=>{
        const appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!appRecord) return null;
        const appId = appRecord.id.toString();
        return [
            ...appRecord.instanceMap
        ].filter(([key])=>key.split(":")[0] === appId).map(([, instance])=>instance);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, async ({ instance: instance })=>{
        return $f8f651eebe4ca737$var$getComponentBoundingRect(instance);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_NAME, ({ instance: instance })=>{
        return $f8f651eebe4ca737$var$getInstanceName(instance);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, ({ uid: uid })=>{
        const instance = $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $f8f651eebe4ca737$var$highlight(instance);
    });
    hooks.hook($f8f651eebe4ca737$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT, ()=>{
        $f8f651eebe4ca737$var$unhighlight();
    });
    return hooks;
}
//#endregion
//#region src/ctx/state.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__ ??= [];
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ ??= {};
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ ??= "";
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ ??= [];
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ ??= [];
const $f8f651eebe4ca737$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $f8f651eebe4ca737$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $f8f651eebe4ca737$var$getTimelineLayersStateFromStorage()
    };
}
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY] ??= $f8f651eebe4ca737$var$initStateFactory();
const $f8f651eebe4ca737$export$ff4fc651602b9735 = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)((state)=>{
    $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHook($f8f651eebe4ca737$export$12aa7e661bddec80.DEVTOOLS_STATE_UPDATED, {
        state: state
    });
});
const $f8f651eebe4ca737$export$ce292af96ab94f7c = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)((state, oldState)=>{
    $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHook($f8f651eebe4ca737$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, {
        state: state,
        oldState: oldState
    });
});
const $f8f651eebe4ca737$export$d3c0473489b1d63b = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
const $f8f651eebe4ca737$export$c1761479e1420543 = (app)=>{
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [
        ...(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__,
        app
    ];
};
const $f8f651eebe4ca737$export$4d20c72f1da170ba = (app)=>{
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $f8f651eebe4ca737$export$d3c0473489b1d63b.value.filter((record)=>record.app !== app);
};
const $f8f651eebe4ca737$export$162128841a7f2877 = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $f8f651eebe4ca737$var$updateAllStates() {
    $f8f651eebe4ca737$export$ff4fc651602b9735({
        ...(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY],
        appRecords: $f8f651eebe4ca737$export$d3c0473489b1d63b.value,
        activeAppRecordId: $f8f651eebe4ca737$export$162128841a7f2877.id,
        tabs: (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
}
function $f8f651eebe4ca737$export$1574774def61bdf9(app) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $f8f651eebe4ca737$var$updateAllStates();
}
function $f8f651eebe4ca737$export$1a7804ab8d8511d1(id) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $f8f651eebe4ca737$var$updateAllStates();
}
const $f8f651eebe4ca737$export$a67dd585df937baa = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY], {
    get (target$3, property) {
        if (property === "appRecords") return $f8f651eebe4ca737$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $f8f651eebe4ca737$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY][property];
    },
    deleteProperty (target, property) {
        delete target[property];
        return true;
    },
    set (target$4, property, value) {
        target$4[property] = value;
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY][property] = value;
        return true;
    }
});
function $f8f651eebe4ca737$export$ed70a0f71250535e() {
    Object.assign((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY], $f8f651eebe4ca737$var$initStateFactory());
}
function $f8f651eebe4ca737$export$ee22a7aaf6b41ce2(state) {
    const oldState = {
        ...(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY],
        appRecords: $f8f651eebe4ca737$export$d3c0473489b1d63b.value,
        activeAppRecordId: $f8f651eebe4ca737$export$162128841a7f2877.id
    };
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $f8f651eebe4ca737$export$ce292af96ab94f7c((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY], oldState);
    Object.assign((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$STATE_KEY], state);
    $f8f651eebe4ca737$var$updateAllStates();
}
function $f8f651eebe4ca737$export$814e9e34f2c01770(fn) {
    return new Promise((resolve)=>{
        if ($f8f651eebe4ca737$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $f8f651eebe4ca737$export$4f1904c03898171b.hooks.hook($f8f651eebe4ca737$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, ({ state: state })=>{
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
const $f8f651eebe4ca737$var$resolveIcon = (icon)=>{
    if (!icon) return;
    if (icon.startsWith("baseline-")) return `custom-ic-${icon}`;
    if (icon.startsWith("i-") || (0, $7427aa90e0ad70d7$export$8092cb61b2731942)(icon)) return icon;
    return `custom-ic-baseline-${icon}`;
};
function $f8f651eebe4ca737$export$9ce008646970742b(tab) {
    const tabs = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some((t)=>t.name === tab.name)) return;
    tabs.push({
        ...tab,
        icon: $f8f651eebe4ca737$var$resolveIcon(tab.icon)
    });
    $f8f651eebe4ca737$var$updateAllStates();
}
function $f8f651eebe4ca737$export$faa8225e4ad5293(action) {
    const commands = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some((t)=>t.id === action.id)) return;
    commands.push({
        ...action,
        icon: $f8f651eebe4ca737$var$resolveIcon(action.icon),
        children: action.children ? action.children.map((child)=>({
                ...child,
                icon: $f8f651eebe4ca737$var$resolveIcon(child.icon)
            })) : void 0
    });
    $f8f651eebe4ca737$var$updateAllStates();
}
function $f8f651eebe4ca737$export$8791c0d68ff21044(actionId) {
    const commands = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    const index = commands.findIndex((t)=>t.id === actionId);
    if (index === -1) return;
    commands.splice(index, 1);
    $f8f651eebe4ca737$var$updateAllStates();
}
function $f8f651eebe4ca737$export$b2de3679515b1d6b(state) {
    $f8f651eebe4ca737$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
//#endregion
//#region src/core/open-in-editor/index.ts
function $f8f651eebe4ca737$export$d4398ad178564033(url) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $f8f651eebe4ca737$var$openInEditor(options = {}) {
    const { file: file, host: host, baseUrl: baseUrl = window.location.origin, line: line = 0, column: column = 0 } = options;
    if (file) {
        if (host === "chrome-extension") {
            const fileName = file.replace(/\\/g, "\\\\");
            const _baseUrl = window.VUE_DEVTOOLS_CONFIG?.openInEditorHost ?? "/";
            fetch(`${_baseUrl}__open-in-editor?file=${encodeURI(file)}`).then((response)=>{
                if (!response.ok) {
                    const msg = `Opening component ${fileName} failed`;
                    console.log(`%c${msg}`, "color:red");
                }
            });
        } else if ($f8f651eebe4ca737$export$a67dd585df937baa.vitePluginDetected) {
            const _baseUrl = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ ?? baseUrl;
            (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_INSPECTOR__.openInEditor(_baseUrl, file, line, column);
        }
    }
}
//#endregion
//#region src/ctx/plugin.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ ??= [];
const $f8f651eebe4ca737$export$df02dcb86618c10f = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $f8f651eebe4ca737$export$5158df7771943590(pluginDescriptor, setupFn) {
    $f8f651eebe4ca737$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
//#endregion
//#region src/core/plugin/plugin-settings.ts
function $f8f651eebe4ca737$var$_getSettings(settings) {
    const _settings = {};
    Object.keys(settings).forEach((key)=>{
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $f8f651eebe4ca737$var$getPluginLocalKey(pluginId) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${pluginId}__`;
}
function $f8f651eebe4ca737$var$getPluginSettingsOptions(pluginId) {
    return ($f8f651eebe4ca737$export$df02dcb86618c10f.find((item)=>item[0].id === pluginId && !!item[0]?.settings)?.[0] ?? null)?.settings ?? null;
}
function $f8f651eebe4ca737$var$getPluginSettings(pluginId, fallbackValue) {
    const localKey = $f8f651eebe4ca737$var$getPluginLocalKey(pluginId);
    if (localKey) {
        const localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    if (pluginId) return $f8f651eebe4ca737$var$_getSettings(($f8f651eebe4ca737$export$df02dcb86618c10f.find((item)=>item[0].id === pluginId)?.[0] ?? null)?.settings ?? {});
    return $f8f651eebe4ca737$var$_getSettings(fallbackValue);
}
function $f8f651eebe4ca737$var$initPluginSettings(pluginId, settings) {
    const localKey = $f8f651eebe4ca737$var$getPluginLocalKey(pluginId);
    if (!localStorage.getItem(localKey)) localStorage.setItem(localKey, JSON.stringify($f8f651eebe4ca737$var$_getSettings(settings)));
}
function $f8f651eebe4ca737$var$setPluginSettings(pluginId, key, value) {
    const localKey = $f8f651eebe4ca737$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    const parsedLocalSettings = JSON.parse(localSettings || "{}");
    const updated = {
        ...parsedLocalSettings,
        [key]: value
    };
    localStorage.setItem(localKey, JSON.stringify(updated));
    $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
        callbacks.forEach((cb)=>cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            }));
    }, $f8f651eebe4ca737$export$3936435a794cb908.SET_PLUGIN_SETTINGS);
}
//#endregion
//#region src/types/hook.ts
let $f8f651eebe4ca737$var$DevToolsHooks = /* @__PURE__ */ function(DevToolsHooks) {
    DevToolsHooks["APP_INIT"] = "app:init";
    DevToolsHooks["APP_UNMOUNT"] = "app:unmount";
    DevToolsHooks["COMPONENT_UPDATED"] = "component:updated";
    DevToolsHooks["COMPONENT_ADDED"] = "component:added";
    DevToolsHooks["COMPONENT_REMOVED"] = "component:removed";
    DevToolsHooks["COMPONENT_EMIT"] = "component:emit";
    DevToolsHooks["PERFORMANCE_START"] = "perf:start";
    DevToolsHooks["PERFORMANCE_END"] = "perf:end";
    DevToolsHooks["ADD_ROUTE"] = "router:add-route";
    DevToolsHooks["REMOVE_ROUTE"] = "router:remove-route";
    DevToolsHooks["RENDER_TRACKED"] = "render:tracked";
    DevToolsHooks["RENDER_TRIGGERED"] = "render:triggered";
    DevToolsHooks["APP_CONNECTED"] = "app:connected";
    DevToolsHooks["SETUP_DEVTOOLS_PLUGIN"] = "devtools-plugin:setup";
    return DevToolsHooks;
}({});
//#endregion
//#region src/hook/index.ts
const $f8f651eebe4ca737$var$devtoolsHooks = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK ??= (0, $36697f719f6f561e$export$39c6a2b4dbabca5d)();
const $f8f651eebe4ca737$var$on = {
    vueAppInit (fn) {
        $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.APP_INIT, fn);
    },
    vueAppUnmount (fn) {
        $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.APP_UNMOUNT, fn);
    },
    vueAppConnected (fn) {
        $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.APP_CONNECTED, fn);
    },
    componentAdded (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_ADDED, fn);
    },
    componentEmit (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_EMIT, fn);
    },
    componentUpdated (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_UPDATED, fn);
    },
    componentRemoved (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_REMOVED, fn);
    },
    setupDevtoolsPlugin (fn) {
        $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, fn);
    },
    perfStart (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_START, fn);
    },
    perfEnd (fn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.hook($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_END, fn);
    }
};
function $f8f651eebe4ca737$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on (event, fn) {
            if (!this.events.has(event)) this.events.set(event, []);
            this.events.get(event)?.push(fn);
            return ()=>this.off(event, fn);
        },
        once (event, fn) {
            const onceFn = (...args)=>{
                this.off(event, onceFn);
                fn(...args);
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off (event, fn) {
            if (this.events.has(event)) {
                const eventCallbacks = this.events.get(event);
                const index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit (event, ...payload) {
            if (this.events.has(event)) this.events.get(event).forEach((fn)=>fn(...payload));
        }
    };
}
function $f8f651eebe4ca737$var$subscribeDevToolsHook(hook) {
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.APP_INIT, (app, version, types)=>{
        if (app?._instance?.type?.devtools?.hide) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.APP_INIT, app, version, types);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.APP_UNMOUNT, (app)=>{
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.APP_UNMOUNT, app);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_ADDED, async (app, uid, parentUid, component)=>{
        if (app?._instance?.type?.devtools?.hide || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        if (!app || typeof uid !== "number" && !uid || !component) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_ADDED, app, uid, parentUid, component);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_UPDATED, (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_UPDATED, app, uid, parentUid, component);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_REMOVED, async (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_REMOVED, app, uid, parentUid, component);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_EMIT, async (app, instance, event, params)=>{
        if (!app || !instance || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_EMIT, app, instance, event, params);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_START, (app, uid, vm, type, time)=>{
        if (!app || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_START, app, uid, vm, type, time);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_END, (app, uid, vm, type, time)=>{
        if (!app || $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.PERFORMANCE_END, app, uid, vm, type, time);
    });
    hook.on($f8f651eebe4ca737$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, (pluginDescriptor, setupFn, options)=>{
        if (options?.target === "legacy") return;
        $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    });
}
const $f8f651eebe4ca737$var$hook = {
    on: $f8f651eebe4ca737$var$on,
    setupDevToolsPlugin (pluginDescriptor, setupFn) {
        return $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    }
};
//#endregion
//#region src/api/v6/index.ts
var $f8f651eebe4ca737$var$DevToolsV6PluginAPI = class {
    constructor({ plugin: plugin, ctx: ctx }){
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    get on() {
        return {
            visitComponentTree: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.VISIT_COMPONENT_TREE, handler);
            },
            inspectComponent: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.INSPECT_COMPONENT, handler);
            },
            editComponentState: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.EDIT_COMPONENT_STATE, handler);
            },
            getInspectorTree: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_TREE, handler);
            },
            getInspectorState: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_STATE, handler);
            },
            editInspectorState: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.EDIT_INSPECTOR_STATE, handler);
            },
            inspectTimelineEvent: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.INSPECT_TIMELINE_EVENT, handler);
            },
            timelineCleared: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.TIMELINE_CLEARED, handler);
            },
            setPluginSettings: (handler)=>{
                this.hooks.hook($f8f651eebe4ca737$export$3936435a794cb908.SET_PLUGIN_SETTINGS, handler);
            }
        };
    }
    notifyComponentUpdate(instance) {
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $f8f651eebe4ca737$export$2844c7432ba9d166().find((i)=>i.packageName === this.plugin.descriptor.packageName);
        if (inspector?.id) {
            if (instance) {
                const args = [
                    instance.appContext.app,
                    instance.uid,
                    instance.parent?.uid,
                    instance
                ];
                $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_UPDATED, ...args);
            } else $f8f651eebe4ca737$var$devtoolsHooks.callHook($f8f651eebe4ca737$var$DevToolsHooks.COMPONENT_UPDATED);
            this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                inspectorId: inspector.id,
                plugin: this.plugin
            });
        }
    }
    addInspector(options) {
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.ADD_INSPECTOR, {
            inspector: options,
            plugin: this.plugin
        });
        if (this.plugin.descriptor.settings) $f8f651eebe4ca737$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
    }
    sendInspectorTree(inspectorId) {
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_TREE, {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    sendInspectorState(inspectorId) {
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    selectInspectorNode(inspectorId, nodeId) {
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, {
            inspectorId: inspectorId,
            nodeId: nodeId,
            plugin: this.plugin
        });
    }
    visitComponentTree(payload) {
        return this.hooks.callHook($f8f651eebe4ca737$export$3936435a794cb908.VISIT_COMPONENT_TREE, payload);
    }
    now() {
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return 0;
        return Date.now();
    }
    addTimelineLayer(options) {
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, {
            options: options,
            plugin: this.plugin
        });
    }
    addTimelineEvent(options) {
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, {
            options: options,
            plugin: this.plugin
        });
    }
    getSettings(pluginId) {
        return $f8f651eebe4ca737$var$getPluginSettings(pluginId ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
    }
    getComponentInstances(app) {
        return this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, {
            app: app
        });
    }
    getComponentBounds(instance) {
        return this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, {
            instance: instance
        });
    }
    getComponentName(instance) {
        return this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.GET_COMPONENT_NAME, {
            instance: instance
        });
    }
    highlightElement(instance) {
        const uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, {
            uid: uid
        });
    }
    unhighlightElement() {
        return this.hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT);
    }
};
//#endregion
//#region src/api/index.ts
const $f8f651eebe4ca737$var$DevToolsPluginAPI = $f8f651eebe4ca737$var$DevToolsV6PluginAPI;
//#endregion
//#region src/core/component/state/constants.ts
const $f8f651eebe4ca737$var$vueBuiltins = new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
const $f8f651eebe4ca737$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
const $f8f651eebe4ca737$var$rawTypeRE = /^\[object (\w+)\]$/;
const $f8f651eebe4ca737$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
const $f8f651eebe4ca737$var$fnTypeRE = /^(?:function|class) (\w+)/;
const $f8f651eebe4ca737$var$MAX_STRING_SIZE = 1e4;
const $f8f651eebe4ca737$var$MAX_ARRAY_SIZE = 5e3;
const $f8f651eebe4ca737$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
const $f8f651eebe4ca737$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
const $f8f651eebe4ca737$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
const $f8f651eebe4ca737$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
const $f8f651eebe4ca737$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "&": "&amp;"
};
//#endregion
//#region src/core/component/state/is.ts
function $f8f651eebe4ca737$var$isVueInstance(value) {
    if (!$f8f651eebe4ca737$var$ensurePropertyExists(value, "_")) return false;
    if (!$f8f651eebe4ca737$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $f8f651eebe4ca737$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $f8f651eebe4ca737$var$isPrimitive$1(data) {
    if (data == null) return true;
    const type = typeof data;
    return type === "string" || type === "number" || type === "boolean";
}
function $f8f651eebe4ca737$var$isRef(raw) {
    return !!raw.__v_isRef;
}
function $f8f651eebe4ca737$var$isComputed(raw) {
    return $f8f651eebe4ca737$var$isRef(raw) && !!raw.effect;
}
function $f8f651eebe4ca737$var$isReactive(raw) {
    return !!raw.__v_isReactive;
}
function $f8f651eebe4ca737$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
//#endregion
//#region src/core/component/state/util.ts
const $f8f651eebe4ca737$var$tokenMap = {
    [$f8f651eebe4ca737$export$6db089fe7b26f5b6]: "undefined",
    [$f8f651eebe4ca737$export$d7ae0f70ebb9e144]: "NaN",
    [$f8f651eebe4ca737$export$b4bf424ed968e242]: "Infinity",
    [$f8f651eebe4ca737$export$95cb88e357cbada8]: "-Infinity"
};
const $f8f651eebe4ca737$var$reversedTokenMap = Object.entries($f8f651eebe4ca737$var$tokenMap).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});
function $f8f651eebe4ca737$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $f8f651eebe4ca737$var$tokenMap[value] || false;
}
function $f8f651eebe4ca737$var$replaceTokenToString(value) {
    const replaceRegex = new RegExp(`"(${Object.keys($f8f651eebe4ca737$var$tokenMap).join("|")})"`, "g");
    return value.replace(replaceRegex, (_, g1)=>$f8f651eebe4ca737$var$tokenMap[g1]);
}
function $f8f651eebe4ca737$var$replaceStringToToken(value) {
    const literalValue = $f8f651eebe4ca737$var$reversedTokenMap[value.trim()];
    if (literalValue) return `"${literalValue}"`;
    const replaceRegex = new RegExp(`:\\s*(${Object.keys($f8f651eebe4ca737$var$reversedTokenMap).join("|")})`, "g");
    return value.replace(replaceRegex, (_, g1)=>`:"${$f8f651eebe4ca737$var$reversedTokenMap[g1]}"`);
}
/**
* Convert prop type constructor to string.
*/ function $f8f651eebe4ca737$var$getPropType(type) {
    if (Array.isArray(type)) return type.map((t)=>$f8f651eebe4ca737$var$getPropType(t)).join(" or ");
    if (type == null) return "null";
    const match = type.toString().match($f8f651eebe4ca737$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
/**
* Sanitize data to be posted to the other side.
* Since the message posted is sent with structured clone,
* we need to filter out any types that might cause an error.
*/ function $f8f651eebe4ca737$var$sanitize(data) {
    if (!$f8f651eebe4ca737$var$isPrimitive$1(data) && !Array.isArray(data) && !$f8f651eebe4ca737$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $f8f651eebe4ca737$var$getSetupStateType(raw) {
    try {
        return {
            ref: $f8f651eebe4ca737$var$isRef(raw),
            computed: $f8f651eebe4ca737$var$isComputed(raw),
            reactive: $f8f651eebe4ca737$var$isReactive(raw),
            readonly: $f8f651eebe4ca737$var$isReadOnly(raw)
        };
    } catch  {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $f8f651eebe4ca737$var$toRaw(value) {
    if (value?.__v_raw) return value.__v_raw;
    return value;
}
function $f8f651eebe4ca737$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, (s)=>{
        return $f8f651eebe4ca737$var$ESC[s] || s;
    });
}
//#endregion
//#region src/core/component/state/process.ts
function $f8f651eebe4ca737$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    const { mixins: mixins, extends: extendsOptions } = from;
    extendsOptions && $f8f651eebe4ca737$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach((m)=>$f8f651eebe4ca737$var$mergeOptions(to, m, instance));
    for (const key of [
        "computed",
        "inject"
    ])if (Object.prototype.hasOwnProperty.call(from, key)) {
        to[key] ??= {};
        Object.assign(to[key], from[key]);
    }
    return to;
}
function $f8f651eebe4ca737$var$resolveMergedOptions(instance) {
    const raw = instance?.type;
    if (!raw) return {};
    const { mixins: mixins, extends: extendsOptions } = raw;
    const globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    const options = {};
    globalMixins.forEach((m)=>$f8f651eebe4ca737$var$mergeOptions(options, m, instance));
    $f8f651eebe4ca737$var$mergeOptions(options, raw, instance);
    return options;
}
/**
* Process the props of an instance.
* Make sure return a plain object because window.postMessage()
* will throw an Error if the passed object contains Functions.
*
*/ function $f8f651eebe4ca737$var$processProps(instance) {
    const props = [];
    const propDefinitions = instance?.type?.props;
    for(const key in instance?.props){
        const propDefinition = propDefinitions ? propDefinitions[key] : null;
        const camelizeKey = (0, $7427aa90e0ad70d7$export$161d051f5dd25de7)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $f8f651eebe4ca737$var$returnError(()=>instance.props[key]),
            editable: true,
            meta: propDefinition ? {
                type: propDefinition.type ? $f8f651eebe4ca737$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required,
                ...propDefinition.default ? {
                    default: propDefinition.default.toString()
                } : {}
            } : {
                type: "invalid"
            }
        });
    }
    return props;
}
/**
* Process state, filtering out props and "clean" the result
* with a JSON dance. This removes functions which can cause
* errors during structured clone used by window.postMessage.
*
*/ function $f8f651eebe4ca737$var$processState(instance) {
    const type = instance.type;
    const props = type?.props;
    const getters = type.vuex && type.vuex.getters;
    const computedDefs = type.computed;
    const data = {
        ...instance.data,
        ...instance.renderContext
    };
    return Object.keys(data).filter((key)=>!(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs)).map((key)=>({
            key: key,
            type: "data",
            value: $f8f651eebe4ca737$var$returnError(()=>data[key]),
            editable: true
        }));
}
function $f8f651eebe4ca737$var$getStateTypeAndName(info) {
    const stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    return {
        stateType: stateType,
        stateTypeName: stateType ? `${stateType.charAt(0).toUpperCase()}${stateType.slice(1)}` : null
    };
}
function $f8f651eebe4ca737$var$processSetupState(instance) {
    const raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter((key)=>!$f8f651eebe4ca737$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use").map((key)=>{
        const value = $f8f651eebe4ca737$var$returnError(()=>$f8f651eebe4ca737$var$toRaw(instance.setupState[key]));
        const accessError = value instanceof Error;
        const rawData = raw[key];
        let result;
        let isOtherType = accessError || typeof value === "function" || $f8f651eebe4ca737$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $f8f651eebe4ca737$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || typeof value === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            const info = $f8f651eebe4ca737$var$getSetupStateType(rawData);
            const { stateType: stateType, stateTypeName: stateTypeName } = $f8f651eebe4ca737$var$getStateTypeAndName(info);
            const isState = info.ref || info.computed || info.reactive;
            const raw = $f8f651eebe4ca737$var$ensurePropertyExists(rawData, "effect") ? rawData.effect?.raw?.toString() || rawData.effect?.fn?.toString() : null;
            if (stateType) isOtherType = false;
            result = {
                ...stateType ? {
                    stateType: stateType,
                    stateTypeName: stateTypeName
                } : {},
                ...raw ? {
                    raw: raw
                } : {},
                editable: isState && !info.readonly
            };
        }
        return {
            key: key,
            value: value,
            type: isOtherType ? "setup (other)" : "setup",
            ...result
        };
    });
}
/**
* Process the computed properties of an instance.
*/ function $f8f651eebe4ca737$var$processComputed(instance, mergedType) {
    const type = mergedType;
    const computed = [];
    const defs = type.computed || {};
    for(const key in defs){
        const def = defs[key];
        const type = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type,
            key: key,
            value: $f8f651eebe4ca737$var$returnError(()=>instance?.proxy?.[key]),
            editable: typeof def.set === "function"
        });
    }
    return computed;
}
function $f8f651eebe4ca737$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map((key)=>({
            type: "attrs",
            key: key,
            value: $f8f651eebe4ca737$var$returnError(()=>instance.attrs[key])
        }));
}
function $f8f651eebe4ca737$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map((key)=>({
            type: "provided",
            key: key.toString(),
            value: $f8f651eebe4ca737$var$returnError(()=>instance.provides[key])
        }));
}
const $f8f651eebe4ca737$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $f8f651eebe4ca737$var$hasOwn = (val, key)=>$f8f651eebe4ca737$var$hasOwnProperty.call(val, key);
function $f8f651eebe4ca737$var$processInject(instance, mergedType) {
    if (!mergedType?.inject) return [];
    let keys;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map((key)=>({
            key: key,
            originalKey: key
        }));
    else keys = Reflect.ownKeys(mergedType.inject).map((key)=>{
        const value = mergedType.inject[key];
        let originalKey;
        if (typeof value === "string" || typeof value === "symbol") originalKey = value;
        else originalKey = value.from ?? key;
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(({ key: key, originalKey: originalKey })=>({
            type: "injected",
            key: key !== originalKey ? `${String(originalKey)} \u{279E} ${String(key)}` : String(key),
            value: $f8f651eebe4ca737$var$returnError(()=>$f8f651eebe4ca737$var$hasOwn(instance.ctx, key) ? instance.ctx[key] : void 0)
        }));
}
function $f8f651eebe4ca737$var$processRefs(instance) {
    return Object.keys(instance.refs).map((key)=>({
            type: "template refs",
            key: key,
            value: $f8f651eebe4ca737$var$returnError(()=>instance.refs[key])
        }));
}
const $f8f651eebe4ca737$var$vnodeEvents = new Set([
    "vnode-before-mount",
    "vnode-mounted",
    "vnode-before-update",
    "vnode-updated",
    "vnode-before-unmount",
    "vnode-unmounted"
]);
function $f8f651eebe4ca737$var$processEventListeners(instance) {
    const emitsDefinition = instance.type.emits;
    const declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition ?? {});
    const keys = Object.keys(instance?.vnode?.props ?? {});
    const result = [];
    for (const key of keys){
        const [prefix, ...eventNameParts] = key.split(/(?=[A-Z])/);
        if (prefix === "on") {
            const eventName = eventNameParts.join("-").toLowerCase();
            const isBuiltIn = $f8f651eebe4ca737$var$vnodeEvents.has(eventName);
            const isDeclared = declaredEmits.includes(eventName) || declaredEmits.includes((0, $7427aa90e0ad70d7$export$161d051f5dd25de7)(eventName));
            const text = isBuiltIn ? "\u2705 Built-in" : isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared";
            result.push({
                type: "event listeners",
                key: eventName,
                value: {
                    _custom: {
                        displayText: text,
                        key: text,
                        value: text,
                        tooltipText: isBuiltIn ? `The event <code>${$f8f651eebe4ca737$export$4e7f196112fea3c5(eventName)}</code> is part of Vue and doesn't need to be declared by the component` : !isDeclared ? `The event <code>${$f8f651eebe4ca737$export$4e7f196112fea3c5(eventName)}</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).` : null
                    }
                }
            });
        }
    }
    return result;
}
function $f8f651eebe4ca737$var$processInstanceState(instance) {
    const mergedType = $f8f651eebe4ca737$var$resolveMergedOptions(instance);
    return $f8f651eebe4ca737$var$processProps(instance).concat($f8f651eebe4ca737$var$processState(instance), $f8f651eebe4ca737$var$processSetupState(instance), $f8f651eebe4ca737$var$processComputed(instance, mergedType), $f8f651eebe4ca737$var$processAttrs(instance), $f8f651eebe4ca737$var$processProvide(instance), $f8f651eebe4ca737$var$processInject(instance, mergedType), $f8f651eebe4ca737$var$processRefs(instance), $f8f651eebe4ca737$var$processEventListeners(instance));
}
//#endregion
//#region src/core/component/state/index.ts
function $f8f651eebe4ca737$var$getInstanceState(params) {
    const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, params.instanceId);
    return {
        id: $f8f651eebe4ca737$var$getUniqueComponentId(instance),
        name: $f8f651eebe4ca737$var$getInstanceName(instance),
        file: instance?.type?.__file,
        state: $f8f651eebe4ca737$var$processInstanceState(instance),
        instance: instance
    };
}
//#endregion
//#region src/core/component/tree/filter.ts
var $f8f651eebe4ca737$var$ComponentFilter = class {
    constructor(filter){
        this.filter = filter || "";
    }
    /**
	* Check if an instance is qualified.
	*
	* @param {Vue|Vnode} instance
	* @return {boolean}
	*/ isQualified(instance) {
        const name = $f8f651eebe4ca737$var$getInstanceName(instance);
        return (0, $7427aa90e0ad70d7$export$b04d9b8d414ba5e8)(name).toLowerCase().includes(this.filter) || (0, $7427aa90e0ad70d7$export$3b2e9c066cbbdd4c)(name).toLowerCase().includes(this.filter);
    }
};
function $f8f651eebe4ca737$var$createComponentFilter(filterText) {
    return new $f8f651eebe4ca737$var$ComponentFilter(filterText);
}
//#endregion
//#region src/core/component/tree/walker.ts
var $f8f651eebe4ca737$var$ComponentWalker = class {
    constructor(options){
        this.captureIds = /* @__PURE__ */ new Map();
        const { filterText: filterText = "", maxDepth: maxDepth, recursively: recursively, api: api } = options;
        this.componentFilter = $f8f651eebe4ca737$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    getComponentTree(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        return this.findQualifiedChildren(instance, 0);
    }
    getComponentParents(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        const parents = [];
        this.captureId(instance);
        let parent = instance;
        while(parent = parent.parent){
            this.captureId(parent);
            parents.push(parent);
        }
        return parents;
    }
    captureId(instance) {
        if (!instance) return null;
        const id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $f8f651eebe4ca737$var$getUniqueComponentId(instance);
        instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
        if (this.captureIds.has(id)) return null;
        else this.captureIds.set(id, void 0);
        this.mark(instance);
        return id;
    }
    /**
	* Capture the meta information of an instance. (recursive)
	*
	* @param {Vue} instance
	* @return {object}
	*/ async capture(instance, depth) {
        if (!instance) return null;
        const id = this.captureId(instance);
        const name = $f8f651eebe4ca737$var$getInstanceName(instance);
        const children = this.getInternalInstanceChildren(instance.subTree).filter((child)=>!$f8f651eebe4ca737$var$isBeingDestroyed(child));
        const parents = this.getComponentParents(instance) || [];
        const inactive = !!instance.isDeactivated || parents.some((parent)=>parent.isDeactivated);
        const treeNode = {
            uid: instance.uid,
            id: id,
            name: name,
            renderKey: $f8f651eebe4ca737$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
            inactive: inactive,
            children: [],
            hasChildren: !!children.length,
            isFragment: $f8f651eebe4ca737$var$isFragment(instance),
            tags: typeof instance.type !== "function" ? [] : [
                {
                    label: "functional",
                    textColor: 5592405,
                    backgroundColor: 15658734
                }
            ],
            autoOpen: this.recursively,
            file: instance.type.__file || ""
        };
        if (depth < this.maxDepth || instance.type.__isKeepAlive || parents.some((parent)=>parent.type.__isKeepAlive)) treeNode.children = await Promise.all(children.map((child)=>this.capture(child, depth + 1)).filter(Boolean));
        if (this.isKeepAlive(instance)) {
            const cachedComponents = this.getKeepAliveCachedInstances(instance);
            const childrenIds = children.map((child)=>child.__VUE_DEVTOOLS_NEXT_UID__);
            for (const cachedChild of cachedComponents)if (!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) {
                const node = await this.capture({
                    ...cachedChild,
                    isDeactivated: true
                }, depth + 1);
                if (node) treeNode.children.push(node);
            }
        }
        const firstElement = $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(instance)[0];
        if (firstElement?.parentElement) {
            const parentInstance = instance.parent;
            const parentRootElements = parentInstance ? $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(parentInstance) : [];
            let el = firstElement;
            const indexList = [];
            do {
                indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                el = el.parentElement;
            }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
            treeNode.domOrder = indexList.reverse();
        } else treeNode.domOrder = [
            -1
        ];
        if (instance.suspense?.suspenseKey) {
            treeNode.tags.push({
                label: instance.suspense.suspenseKey,
                backgroundColor: 14979812,
                textColor: 16777215
            });
            this.mark(instance, true);
        }
        this.api.visitComponentTree({
            treeNode: treeNode,
            componentInstance: instance,
            app: instance.appContext.app,
            filter: this.componentFilter.filter
        });
        return treeNode;
    }
    /**
	* Find qualified children from a single instance.
	* If the instance itself is qualified, just return itself.
	* This is ok because [].concat works in both cases.
	*
	* @param {Vue|Vnode} instance
	* @return {Vue|Array}
	*/ async findQualifiedChildren(instance, depth) {
        if (this.componentFilter.isQualified(instance) && !instance.type.devtools?.hide) return [
            await this.capture(instance, depth)
        ];
        else if (instance.subTree) {
            const list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
            return this.findQualifiedChildrenFromList(list, depth);
        } else return [];
    }
    /**
	* Iterate through an array of instances and flatten it into
	* an array of qualified instances. This is a depth-first
	* traversal - e.g. if an instance is not matched, we will
	* recursively go deeper until a qualified child is found.
	*
	* @param {Array} instances
	* @return {Array}
	*/ async findQualifiedChildrenFromList(instances, depth) {
        instances = instances.filter((child)=>!$f8f651eebe4ca737$var$isBeingDestroyed(child) && !child.type.devtools?.hide);
        if (!this.componentFilter.filter) return Promise.all(instances.map((child)=>this.capture(child, depth)));
        else return Array.prototype.concat.apply([], await Promise.all(instances.map((i)=>this.findQualifiedChildren(i, depth))));
    }
    /**
	* Get children from a component instance.
	*/ getInternalInstanceChildren(subTree, suspense = null) {
        const list = [];
        if (subTree) {
            if (subTree.component) !suspense ? list.push(subTree.component) : list.push({
                ...subTree.component,
                suspense: suspense
            });
            else if (subTree.suspense) {
                const suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                list.push(...this.getInternalInstanceChildren(subTree.suspense.activeBranch, {
                    ...subTree.suspense,
                    suspenseKey: suspenseKey
                }));
            } else if (Array.isArray(subTree.children)) subTree.children.forEach((childSubTree)=>{
                if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push({
                    ...childSubTree.component,
                    suspense: suspense
                });
                else list.push(...this.getInternalInstanceChildren(childSubTree, suspense));
            });
        }
        return list.filter((child)=>!$f8f651eebe4ca737$var$isBeingDestroyed(child) && !child.type.devtools?.hide);
    }
    /**
	* Mark an instance as captured and store it in the instance map.
	*
	* @param {Vue} instance
	*/ mark(instance, force = false) {
        const instanceMap = $f8f651eebe4ca737$var$getAppRecord(instance).instanceMap;
        if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
            instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
            $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap = instanceMap;
        }
    }
    isKeepAlive(instance) {
        return instance.type.__isKeepAlive && instance.__v_cache;
    }
    getKeepAliveCachedInstances(instance) {
        return Array.from(instance.__v_cache.values()).map((vnode)=>vnode.component).filter(Boolean);
    }
};
//#endregion
//#region src/core/timeline/perf.ts
const $f8f651eebe4ca737$var$markEndQueue = /* @__PURE__ */ new Map();
const $f8f651eebe4ca737$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
async function $f8f651eebe4ca737$var$performanceMarkStart(api, app, uid, vm, type, time) {
    const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $f8f651eebe4ca737$var$getInstanceName(vm) || "Unknown Component";
    const groupId = $f8f651eebe4ca737$export$a67dd585df937baa.perfUniqueGroupId++;
    const groupKey = `${uid}-${type}`;
    appRecord.perfGroupIds.set(groupKey, {
        groupId: groupId,
        time: time
    });
    await api.addTimelineEvent({
        layerId: $f8f651eebe4ca737$var$PERFORMANCE_EVENT_LAYER_ID,
        event: {
            time: Date.now(),
            data: {
                component: componentName,
                type: type,
                measure: "start"
            },
            title: componentName,
            subtitle: type,
            groupId: groupId
        }
    });
    if ($f8f651eebe4ca737$var$markEndQueue.has(groupKey)) {
        const { app: app, uid: uid, instance: instance, type: type, time: time } = $f8f651eebe4ca737$var$markEndQueue.get(groupKey);
        $f8f651eebe4ca737$var$markEndQueue.delete(groupKey);
        await $f8f651eebe4ca737$var$performanceMarkEnd(api, app, uid, instance, type, time);
    }
}
function $f8f651eebe4ca737$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    const appRecord = $f8f651eebe4ca737$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $f8f651eebe4ca737$var$getInstanceName(vm) || "Unknown Component";
    const groupKey = `${uid}-${type}`;
    const groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        const groupId = groupInfo.groupId;
        const duration = time - groupInfo.time;
        api.addTimelineEvent({
            layerId: $f8f651eebe4ca737$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: `${duration} ms`
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $f8f651eebe4ca737$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
//#endregion
//#region src/core/timeline/index.ts
const $f8f651eebe4ca737$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $f8f651eebe4ca737$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $7427aa90e0ad70d7$export$4e09c449d6c407f7)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach((eventType)=>{
        if (!$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.recordingState || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, async (event)=>{
            await api.addTimelineEvent({
                layerId: "mouse",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        x: event.clientX,
                        y: event.clientY
                    },
                    title: eventType
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach((eventType)=>{
        window.addEventListener(eventType, async (event)=>{
            if (!$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.recordingState || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return;
            await api.addTimelineEvent({
                layerId: "keyboard",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        key: event.key,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    },
                    title: event.key
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $f8f651eebe4ca737$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $f8f651eebe4ca737$var$hook.on.componentEmit(async (app, instance, event, params)=>{
        if (!$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.recordingState || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return;
        const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
        if (!appRecord) return;
        const componentId = `${appRecord.id}:${instance.uid}`;
        const componentName = $f8f651eebe4ca737$var$getInstanceName(instance) || "Unknown Component";
        api.addTimelineEvent({
            layerId: $f8f651eebe4ca737$var$COMPONENT_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: {
                        _custom: {
                            type: "component-definition",
                            display: componentName
                        }
                    },
                    event: event,
                    params: params
                },
                title: event,
                subtitle: `by ${componentName}`,
                meta: {
                    componentId: componentId
                }
            }
        });
    });
    api.addTimelineLayer({
        id: "performance",
        label: $f8f651eebe4ca737$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $f8f651eebe4ca737$var$hook.on.perfStart((app, uid, vm, type, time)=>{
        if (!$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.recordingState || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $f8f651eebe4ca737$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $f8f651eebe4ca737$var$hook.on.perfEnd((app, uid, vm, type, time)=>{
        if (!$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.recordingState || !$f8f651eebe4ca737$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $f8f651eebe4ca737$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
//#endregion
//#region src/core/vm/index.ts
const $f8f651eebe4ca737$var$MAX_$VM = 10;
const $f8f651eebe4ca737$var$$vmQueue = [];
function $f8f651eebe4ca737$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    const win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($f8f651eebe4ca737$var$$vmQueue[0] !== componentInstance) {
        if ($f8f651eebe4ca737$var$$vmQueue.length >= $f8f651eebe4ca737$var$MAX_$VM) $f8f651eebe4ca737$var$$vmQueue.pop();
        for(let i = $f8f651eebe4ca737$var$$vmQueue.length; i > 0; i--)win[`$vm${i}`] = $f8f651eebe4ca737$var$$vmQueue[i] = $f8f651eebe4ca737$var$$vmQueue[i - 1];
        win.$vm0 = $f8f651eebe4ca737$var$$vmQueue[0] = componentInstance;
    }
}
//#endregion
//#region src/core/plugin/components.ts
const $f8f651eebe4ca737$var$INSPECTOR_ID = "components";
function $f8f651eebe4ca737$export$7e5554ded389d004(app) {
    const descriptor = {
        id: $f8f651eebe4ca737$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    const setupFn = (api)=>{
        api.addInspector({
            id: $f8f651eebe4ca737$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $f8f651eebe4ca737$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $f8f651eebe4ca737$var$INSPECTOR_ID) {
                const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, payload.instanceId);
                if (instance) payload.rootNodes = await new $f8f651eebe4ca737$var$ComponentWalker({
                    filterText: payload.filter,
                    maxDepth: 100,
                    recursively: false,
                    api: api
                }).getComponentTree(instance);
            }
        });
        api.on.getInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $f8f651eebe4ca737$var$INSPECTOR_ID) {
                const result = $f8f651eebe4ca737$var$getInstanceState({
                    instanceId: payload.nodeId
                });
                const componentInstance = result.instance;
                const _payload = {
                    componentInstance: componentInstance,
                    app: result.instance?.appContext.app,
                    instanceData: result
                };
                $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
                    callbacks.forEach((cb)=>cb(_payload));
                }, $f8f651eebe4ca737$export$3936435a794cb908.INSPECT_COMPONENT);
                payload.state = result;
                $f8f651eebe4ca737$var$exposeInstanceToWindow(componentInstance);
            }
        });
        api.on.editInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $f8f651eebe4ca737$var$INSPECTOR_ID) {
                $f8f651eebe4ca737$var$editState(payload);
                await api.sendInspectorState("components");
            }
        });
        const debounceSendInspectorTree = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(()=>{
            api.sendInspectorTree($f8f651eebe4ca737$var$INSPECTOR_ID);
        }, 120);
        const debounceSendInspectorState = (0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(()=>{
            api.sendInspectorState($f8f651eebe4ca737$var$INSPECTOR_ID);
        }, 120);
        $f8f651eebe4ca737$var$hook.on.componentAdded(async (app, uid, parentUid, component)=>{
            if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const id = await $f8f651eebe4ca737$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!appRecord?.instanceMap.has(id)) {
                    appRecord?.instanceMap.set(id, component);
                    if ($f8f651eebe4ca737$export$162128841a7f2877.value.id === appRecord?.id) $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
        });
        $f8f651eebe4ca737$var$hook.on.componentUpdated(async (app, uid, parentUid, component)=>{
            if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const id = await $f8f651eebe4ca737$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!appRecord?.instanceMap.has(id)) {
                    appRecord?.instanceMap.set(id, component);
                    if ($f8f651eebe4ca737$export$162128841a7f2877.value.id === appRecord?.id) $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
            debounceSendInspectorState();
        });
        $f8f651eebe4ca737$var$hook.on.componentRemoved(async (app, uid, parentUid, component)=>{
            if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const appRecord = await $f8f651eebe4ca737$var$getAppRecord(app);
            if (!appRecord) return;
            const id = await $f8f651eebe4ca737$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            appRecord?.instanceMap.delete(id);
            if ($f8f651eebe4ca737$export$162128841a7f2877.value.id === appRecord?.id) $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
            debounceSendInspectorTree();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
//#endregion
//#region src/core/plugin/index.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ ??= /* @__PURE__ */ new Set();
function $f8f651eebe4ca737$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $f8f651eebe4ca737$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $f8f651eebe4ca737$export$873c261f47a243e7(plugin, app) {
    const [pluginDescriptor, setupFn] = plugin;
    if (pluginDescriptor.app !== app) return;
    const api = new $f8f651eebe4ca737$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $f8f651eebe4ca737$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState((payload)=>{
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $f8f651eebe4ca737$export$7f52963080ec618f(app) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $f8f651eebe4ca737$export$c357c87447719db2(app, options) {
    if ((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled && !options?.inspectingComponent) return;
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $f8f651eebe4ca737$export$df02dcb86618c10f.forEach((plugin)=>{
        $f8f651eebe4ca737$export$873c261f47a243e7(plugin, app);
    });
}
//#endregion
//#region src/ctx/router.ts
const $f8f651eebe4ca737$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
const $f8f651eebe4ca737$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$bcb936c2c1e0b8ba] ??= {
    currentRoute: null,
    routes: []
};
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$57206cad6442cbbb] ??= {};
const $f8f651eebe4ca737$export$10a28a01c0e59bea = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$bcb936c2c1e0b8ba], {
    get (target$1, property) {
        return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$bcb936c2c1e0b8ba][property];
    }
});
const $f8f651eebe4ca737$export$73b6e4968c970971 = new Proxy((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$57206cad6442cbbb], {
    get (target$2, property) {
        if (property === "value") return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$57206cad6442cbbb];
    }
});
//#endregion
//#region src/core/router/index.ts
function $f8f651eebe4ca737$var$getRoutes(router) {
    const routesMap = /* @__PURE__ */ new Map();
    return (router?.getRoutes() || []).filter((i)=>!routesMap.has(i.path) && routesMap.set(i.path, 1));
}
function $f8f651eebe4ca737$var$filterRoutes(routes) {
    return routes.map((item)=>{
        let { path: path, name: name, children: children, meta: meta } = item;
        if (children?.length) children = $f8f651eebe4ca737$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $f8f651eebe4ca737$var$filterCurrentRoute(route) {
    if (route) {
        const { fullPath: fullPath, hash: hash, href: href, path: path, name: name, matched: matched, params: params, query: query } = route;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $f8f651eebe4ca737$var$filterRoutes(matched)
        };
    }
    return route;
}
function $f8f651eebe4ca737$var$normalizeRouterInfo(appRecord, activeAppRecord) {
    function init() {
        const router = appRecord.app?.config.globalProperties.$router;
        const currentRoute = $f8f651eebe4ca737$var$filterCurrentRoute(router?.currentRoute.value);
        const routes = $f8f651eebe4ca737$var$filterRoutes($f8f651eebe4ca737$var$getRoutes(router));
        const c = console.warn;
        console.warn = ()=>{};
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $7427aa90e0ad70d7$export$b7d58db314e0ac27)(currentRoute) : {},
            routes: (0, $7427aa90e0ad70d7$export$b7d58db314e0ac27)(routes)
        };
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $f8f651eebe4ca737$var$hook.on.componentUpdated((0, $db82f83da91bd66b$export$61fc7d43ac8f84b0)(()=>{
        if (activeAppRecord.value?.app !== appRecord.app) return;
        init();
        if ($f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled) return;
        $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHook($f8f651eebe4ca737$export$12aa7e661bddec80.ROUTER_INFO_UPDATED, {
            state: (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
//#endregion
//#region src/ctx/api.ts
function $f8f651eebe4ca737$export$bb51459158adb36b(hooks) {
    return {
        async getInspectorTree (payload) {
            const _payload = {
                ...payload,
                app: $f8f651eebe4ca737$export$162128841a7f2877.value.app,
                rootNodes: []
            };
            await new Promise((resolve)=>{
                hooks.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload)));
                    resolve();
                }, $f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_TREE);
            });
            return _payload.rootNodes;
        },
        async getInspectorState (payload) {
            const _payload = {
                ...payload,
                app: $f8f651eebe4ca737$export$162128841a7f2877.value.app,
                state: null
            };
            const ctx = {
                currentTab: `custom-inspector:${payload.inspectorId}`
            };
            await new Promise((resolve)=>{
                hooks.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                    resolve();
                }, $f8f651eebe4ca737$export$3936435a794cb908.GET_INSPECTOR_STATE);
            });
            return _payload.state;
        },
        editInspectorState (payload) {
            const stateEditor = new $f8f651eebe4ca737$var$StateEditor();
            const _payload = {
                ...payload,
                app: $f8f651eebe4ca737$export$162128841a7f2877.value.app,
                set: (obj, path = payload.path, value = payload.state.value, cb)=>{
                    stateEditor.set(obj, path, value, cb || stateEditor.createDefaultSetCallback(payload.state));
                }
            };
            hooks.callHookWith((callbacks)=>{
                callbacks.forEach((cb)=>cb(_payload));
            }, $f8f651eebe4ca737$export$3936435a794cb908.EDIT_INSPECTOR_STATE);
        },
        sendInspectorState (inspectorId) {
            const inspector = $f8f651eebe4ca737$export$aa4140d0f5ce4bbe(inspectorId);
            hooks.callHook($f8f651eebe4ca737$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: ()=>({})
                }
            });
        },
        inspectComponentInspector () {
            return $f8f651eebe4ca737$var$inspectComponentHighLighter();
        },
        cancelInspectComponentInspector () {
            return $f8f651eebe4ca737$var$cancelInspectComponentHighLighter();
        },
        getComponentRenderCode (id) {
            const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, id);
            if (instance) return !(typeof instance?.type === "function") ? instance.render.toString() : instance.type.toString();
        },
        scrollToComponent (id) {
            return $f8f651eebe4ca737$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: $f8f651eebe4ca737$var$openInEditor,
        getVueInspector: $f8f651eebe4ca737$var$getComponentInspector,
        toggleApp (id, options) {
            const appRecord = $f8f651eebe4ca737$export$d3c0473489b1d63b.value.find((record)=>record.id === id);
            if (appRecord) {
                $f8f651eebe4ca737$export$1a7804ab8d8511d1(id);
                $f8f651eebe4ca737$export$1574774def61bdf9(appRecord);
                $f8f651eebe4ca737$var$normalizeRouterInfo(appRecord, $f8f651eebe4ca737$export$162128841a7f2877);
                $f8f651eebe4ca737$export$17f8005932e80cc0();
                $f8f651eebe4ca737$export$c357c87447719db2(appRecord.app, options);
            }
        },
        inspectDOM (instanceId) {
            const instance = $f8f651eebe4ca737$var$getComponentInstance($f8f651eebe4ca737$export$162128841a7f2877.value, instanceId);
            if (instance) {
                const [el] = $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(instance);
                if (el) (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings (pluginId, key, value) {
            $f8f651eebe4ca737$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings (pluginId) {
            return {
                options: $f8f651eebe4ca737$var$getPluginSettingsOptions(pluginId),
                values: $f8f651eebe4ca737$var$getPluginSettings(pluginId)
            };
        }
    };
}
//#endregion
//#region src/ctx/env.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__ ??= {
    vitePluginDetected: false
};
function $f8f651eebe4ca737$export$6fcf3c68ecb51939() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__;
}
function $f8f651eebe4ca737$export$b209b470d7c4ea55(env) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__ = {
        ...(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__,
        ...env
    };
}
//#endregion
//#region src/ctx/index.ts
const $f8f651eebe4ca737$var$hooks = $f8f651eebe4ca737$export$73be3ac6032ad9bb();
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CONTEXT__ ??= {
    hooks: $f8f651eebe4ca737$var$hooks,
    get state () {
        return {
            ...$f8f651eebe4ca737$export$a67dd585df937baa,
            activeAppRecordId: $f8f651eebe4ca737$export$162128841a7f2877.id,
            activeAppRecord: $f8f651eebe4ca737$export$162128841a7f2877.value,
            appRecords: $f8f651eebe4ca737$export$d3c0473489b1d63b.value
        };
    },
    api: $f8f651eebe4ca737$export$bb51459158adb36b($f8f651eebe4ca737$var$hooks)
};
const $f8f651eebe4ca737$export$4f1904c03898171b = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CONTEXT__;
//#endregion
//#region ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $f8f651eebe4ca737$var$require_speakingurl$1 = /* @__PURE__ */ $f8f651eebe4ca737$var$__commonJSMin((exports, module)=>{
    (function(root) {
        "use strict";
        /**
		* charMap
		* @type {Object}
		*/ var charMap = {
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "Ae",
            "\xc5": "A",
            "\xc6": "AE",
            "\xc7": "C",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xd0": "D",
            "\xd1": "N",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "Oe",
            "\u0150": "O",
            "\xd8": "O",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "Ue",
            "\u0170": "U",
            "\xdd": "Y",
            "\xde": "TH",
            "\xdf": "ss",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "ae",
            "\xe5": "a",
            "\xe6": "ae",
            "\xe7": "c",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xf0": "d",
            "\xf1": "n",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "oe",
            "\u0151": "o",
            "\xf8": "o",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "ue",
            "\u0171": "u",
            "\xfd": "y",
            "\xfe": "th",
            "\xff": "y",
            "\u1E9E": "SS",
            "\u0627": "a",
            "\u0623": "a",
            "\u0625": "i",
            "\u0622": "aa",
            "\u0624": "u",
            "\u0626": "e",
            "\u0621": "a",
            "\u0628": "b",
            "\u062A": "t",
            "\u062B": "th",
            "\u062C": "j",
            "\u062D": "h",
            "\u062E": "kh",
            "\u062F": "d",
            "\u0630": "th",
            "\u0631": "r",
            "\u0632": "z",
            "\u0633": "s",
            "\u0634": "sh",
            "\u0635": "s",
            "\u0636": "dh",
            "\u0637": "t",
            "\u0638": "z",
            "\u0639": "a",
            "\u063A": "gh",
            "\u0641": "f",
            "\u0642": "q",
            "\u0643": "k",
            "\u0644": "l",
            "\u0645": "m",
            "\u0646": "n",
            "\u0647": "h",
            "\u0648": "w",
            "\u064A": "y",
            "\u0649": "a",
            "\u0629": "h",
            "\uFEFB": "la",
            "\uFEF7": "laa",
            "\uFEF9": "lai",
            "\uFEF5": "laa",
            "\u06AF": "g",
            "\u0686": "ch",
            "\u067E": "p",
            "\u0698": "zh",
            "\u06A9": "k",
            "\u06CC": "y",
            "\u064E": "a",
            "\u064B": "an",
            "\u0650": "e",
            "\u064D": "en",
            "\u064F": "u",
            "\u064C": "on",
            "\u0652": "",
            "\u0660": "0",
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u06F0": "0",
            "\u06F1": "1",
            "\u06F2": "2",
            "\u06F3": "3",
            "\u06F4": "4",
            "\u06F5": "5",
            "\u06F6": "6",
            "\u06F7": "7",
            "\u06F8": "8",
            "\u06F9": "9",
            "\u1000": "k",
            "\u1001": "kh",
            "\u1002": "g",
            "\u1003": "ga",
            "\u1004": "ng",
            "\u1005": "s",
            "\u1006": "sa",
            "\u1007": "z",
            "\u1005\u103B": "za",
            "\u100A": "ny",
            "\u100B": "t",
            "\u100C": "ta",
            "\u100D": "d",
            "\u100E": "da",
            "\u100F": "na",
            "\u1010": "t",
            "\u1011": "ta",
            "\u1012": "d",
            "\u1013": "da",
            "\u1014": "n",
            "\u1015": "p",
            "\u1016": "pa",
            "\u1017": "b",
            "\u1018": "ba",
            "\u1019": "m",
            "\u101A": "y",
            "\u101B": "ya",
            "\u101C": "l",
            "\u101D": "w",
            "\u101E": "th",
            "\u101F": "h",
            "\u1020": "la",
            "\u1021": "a",
            "\u103C": "y",
            "\u103B": "ya",
            "\u103D": "w",
            "\u103C\u103D": "yw",
            "\u103B\u103D": "ywa",
            "\u103E": "h",
            "\u1027": "e",
            "\u104F": "-e",
            "\u1023": "i",
            "\u1024": "-i",
            "\u1009": "u",
            "\u1026": "-u",
            "\u1029": "aw",
            "\u101E\u103C\u1031\u102C": "aw",
            "\u102A": "aw",
            "\u1040": "0",
            "\u1041": "1",
            "\u1042": "2",
            "\u1043": "3",
            "\u1044": "4",
            "\u1045": "5",
            "\u1046": "6",
            "\u1047": "7",
            "\u1048": "8",
            "\u1049": "9",
            "\u1039": "",
            "\u1037": "",
            "\u1038": "",
            "\u010D": "c",
            "\u010F": "d",
            "\u011B": "e",
            "\u0148": "n",
            "\u0159": "r",
            "\u0161": "s",
            "\u0165": "t",
            "\u016F": "u",
            "\u017E": "z",
            "\u010C": "C",
            "\u010E": "D",
            "\u011A": "E",
            "\u0147": "N",
            "\u0158": "R",
            "\u0160": "S",
            "\u0164": "T",
            "\u016E": "U",
            "\u017D": "Z",
            "\u0780": "h",
            "\u0781": "sh",
            "\u0782": "n",
            "\u0783": "r",
            "\u0784": "b",
            "\u0785": "lh",
            "\u0786": "k",
            "\u0787": "a",
            "\u0788": "v",
            "\u0789": "m",
            "\u078A": "f",
            "\u078B": "dh",
            "\u078C": "th",
            "\u078D": "l",
            "\u078E": "g",
            "\u078F": "gn",
            "\u0790": "s",
            "\u0791": "d",
            "\u0792": "z",
            "\u0793": "t",
            "\u0794": "y",
            "\u0795": "p",
            "\u0796": "j",
            "\u0797": "ch",
            "\u0798": "tt",
            "\u0799": "hh",
            "\u079A": "kh",
            "\u079B": "th",
            "\u079C": "z",
            "\u079D": "sh",
            "\u079E": "s",
            "\u079F": "d",
            "\u07A0": "t",
            "\u07A1": "z",
            "\u07A2": "a",
            "\u07A3": "gh",
            "\u07A4": "q",
            "\u07A5": "w",
            "\u07A6": "a",
            "\u07A7": "aa",
            "\u07A8": "i",
            "\u07A9": "ee",
            "\u07AA": "u",
            "\u07AB": "oo",
            "\u07AC": "e",
            "\u07AD": "ey",
            "\u07AE": "o",
            "\u07AF": "oa",
            "\u07B0": "",
            "\u10D0": "a",
            "\u10D1": "b",
            "\u10D2": "g",
            "\u10D3": "d",
            "\u10D4": "e",
            "\u10D5": "v",
            "\u10D6": "z",
            "\u10D7": "t",
            "\u10D8": "i",
            "\u10D9": "k",
            "\u10DA": "l",
            "\u10DB": "m",
            "\u10DC": "n",
            "\u10DD": "o",
            "\u10DE": "p",
            "\u10DF": "zh",
            "\u10E0": "r",
            "\u10E1": "s",
            "\u10E2": "t",
            "\u10E3": "u",
            "\u10E4": "p",
            "\u10E5": "k",
            "\u10E6": "gh",
            "\u10E7": "q",
            "\u10E8": "sh",
            "\u10E9": "ch",
            "\u10EA": "ts",
            "\u10EB": "dz",
            "\u10EC": "ts",
            "\u10ED": "ch",
            "\u10EE": "kh",
            "\u10EF": "j",
            "\u10F0": "h",
            "\u03B1": "a",
            "\u03B2": "v",
            "\u03B3": "g",
            "\u03B4": "d",
            "\u03B5": "e",
            "\u03B6": "z",
            "\u03B7": "i",
            "\u03B8": "th",
            "\u03B9": "i",
            "\u03BA": "k",
            "\u03BB": "l",
            "\u03BC": "m",
            "\u03BD": "n",
            "\u03BE": "ks",
            "\u03BF": "o",
            "\u03C0": "p",
            "\u03C1": "r",
            "\u03C3": "s",
            "\u03C4": "t",
            "\u03C5": "y",
            "\u03C6": "f",
            "\u03C7": "x",
            "\u03C8": "ps",
            "\u03C9": "o",
            "\u03AC": "a",
            "\u03AD": "e",
            "\u03AF": "i",
            "\u03CC": "o",
            "\u03CD": "y",
            "\u03AE": "i",
            "\u03CE": "o",
            "\u03C2": "s",
            "\u03CA": "i",
            "\u03B0": "y",
            "\u03CB": "y",
            "\u0390": "i",
            "\u0391": "A",
            "\u0392": "B",
            "\u0393": "G",
            "\u0394": "D",
            "\u0395": "E",
            "\u0396": "Z",
            "\u0397": "I",
            "\u0398": "TH",
            "\u0399": "I",
            "\u039A": "K",
            "\u039B": "L",
            "\u039C": "M",
            "\u039D": "N",
            "\u039E": "KS",
            "\u039F": "O",
            "\u03A0": "P",
            "\u03A1": "R",
            "\u03A3": "S",
            "\u03A4": "T",
            "\u03A5": "Y",
            "\u03A6": "F",
            "\u03A7": "X",
            "\u03A8": "PS",
            "\u03A9": "O",
            "\u0386": "A",
            "\u0388": "E",
            "\u038A": "I",
            "\u038C": "O",
            "\u038E": "Y",
            "\u0389": "I",
            "\u038F": "O",
            "\u03AA": "I",
            "\u03AB": "Y",
            "\u0101": "a",
            "\u0113": "e",
            "\u0123": "g",
            "\u012B": "i",
            "\u0137": "k",
            "\u013C": "l",
            "\u0146": "n",
            "\u016B": "u",
            "\u0100": "A",
            "\u0112": "E",
            "\u0122": "G",
            "\u012A": "I",
            "\u0136": "k",
            "\u013B": "L",
            "\u0145": "N",
            "\u016A": "U",
            "\u040C": "Kj",
            "\u045C": "kj",
            "\u0409": "Lj",
            "\u0459": "lj",
            "\u040A": "Nj",
            "\u045A": "nj",
            "\u0422\u0441": "Ts",
            "\u0442\u0441": "ts",
            "\u0105": "a",
            "\u0107": "c",
            "\u0119": "e",
            "\u0142": "l",
            "\u0144": "n",
            "\u015B": "s",
            "\u017A": "z",
            "\u017C": "z",
            "\u0104": "A",
            "\u0106": "C",
            "\u0118": "E",
            "\u0141": "L",
            "\u0143": "N",
            "\u015A": "S",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u0404": "Ye",
            "\u0406": "I",
            "\u0407": "Yi",
            "\u0490": "G",
            "\u0454": "ye",
            "\u0456": "i",
            "\u0457": "yi",
            "\u0491": "g",
            "\u0103": "a",
            "\u0102": "A",
            "\u0219": "s",
            "\u0218": "S",
            "\u021B": "t",
            "\u021A": "T",
            "\u0163": "t",
            "\u0162": "T",
            "\u0430": "a",
            "\u0431": "b",
            "\u0432": "v",
            "\u0433": "g",
            "\u0434": "d",
            "\u0435": "e",
            "\u0451": "yo",
            "\u0436": "zh",
            "\u0437": "z",
            "\u0438": "i",
            "\u0439": "i",
            "\u043A": "k",
            "\u043B": "l",
            "\u043C": "m",
            "\u043D": "n",
            "\u043E": "o",
            "\u043F": "p",
            "\u0440": "r",
            "\u0441": "s",
            "\u0442": "t",
            "\u0443": "u",
            "\u0444": "f",
            "\u0445": "kh",
            "\u0446": "c",
            "\u0447": "ch",
            "\u0448": "sh",
            "\u0449": "sh",
            "\u044A": "",
            "\u044B": "y",
            "\u044C": "",
            "\u044D": "e",
            "\u044E": "yu",
            "\u044F": "ya",
            "\u0410": "A",
            "\u0411": "B",
            "\u0412": "V",
            "\u0413": "G",
            "\u0414": "D",
            "\u0415": "E",
            "\u0401": "Yo",
            "\u0416": "Zh",
            "\u0417": "Z",
            "\u0418": "I",
            "\u0419": "I",
            "\u041A": "K",
            "\u041B": "L",
            "\u041C": "M",
            "\u041D": "N",
            "\u041E": "O",
            "\u041F": "P",
            "\u0420": "R",
            "\u0421": "S",
            "\u0422": "T",
            "\u0423": "U",
            "\u0424": "F",
            "\u0425": "Kh",
            "\u0426": "C",
            "\u0427": "Ch",
            "\u0428": "Sh",
            "\u0429": "Sh",
            "\u042A": "",
            "\u042B": "Y",
            "\u042C": "",
            "\u042D": "E",
            "\u042E": "Yu",
            "\u042F": "Ya",
            "\u0452": "dj",
            "\u0458": "j",
            "\u045B": "c",
            "\u045F": "dz",
            "\u0402": "Dj",
            "\u0408": "j",
            "\u040B": "C",
            "\u040F": "Dz",
            "\u013E": "l",
            "\u013A": "l",
            "\u0155": "r",
            "\u013D": "L",
            "\u0139": "L",
            "\u0154": "R",
            "\u015F": "s",
            "\u015E": "S",
            "\u0131": "i",
            "\u0130": "I",
            "\u011F": "g",
            "\u011E": "G",
            "\u1EA3": "a",
            "\u1EA2": "A",
            "\u1EB3": "a",
            "\u1EB2": "A",
            "\u1EA9": "a",
            "\u1EA8": "A",
            "\u0111": "d",
            "\u0110": "D",
            "\u1EB9": "e",
            "\u1EB8": "E",
            "\u1EBD": "e",
            "\u1EBC": "E",
            "\u1EBB": "e",
            "\u1EBA": "E",
            "\u1EBF": "e",
            "\u1EBE": "E",
            "\u1EC1": "e",
            "\u1EC0": "E",
            "\u1EC7": "e",
            "\u1EC6": "E",
            "\u1EC5": "e",
            "\u1EC4": "E",
            "\u1EC3": "e",
            "\u1EC2": "E",
            "\u1ECF": "o",
            "\u1ECD": "o",
            "\u1ECC": "o",
            "\u1ED1": "o",
            "\u1ED0": "O",
            "\u1ED3": "o",
            "\u1ED2": "O",
            "\u1ED5": "o",
            "\u1ED4": "O",
            "\u1ED9": "o",
            "\u1ED8": "O",
            "\u1ED7": "o",
            "\u1ED6": "O",
            "\u01A1": "o",
            "\u01A0": "O",
            "\u1EDB": "o",
            "\u1EDA": "O",
            "\u1EDD": "o",
            "\u1EDC": "O",
            "\u1EE3": "o",
            "\u1EE2": "O",
            "\u1EE1": "o",
            "\u1EE0": "O",
            "\u1EDE": "o",
            "\u1EDF": "o",
            "\u1ECB": "i",
            "\u1ECA": "I",
            "\u0129": "i",
            "\u0128": "I",
            "\u1EC9": "i",
            "\u1EC8": "i",
            "\u1EE7": "u",
            "\u1EE6": "U",
            "\u1EE5": "u",
            "\u1EE4": "U",
            "\u0169": "u",
            "\u0168": "U",
            "\u01B0": "u",
            "\u01AF": "U",
            "\u1EE9": "u",
            "\u1EE8": "U",
            "\u1EEB": "u",
            "\u1EEA": "U",
            "\u1EF1": "u",
            "\u1EF0": "U",
            "\u1EEF": "u",
            "\u1EEE": "U",
            "\u1EED": "u",
            "\u1EEC": "\u01B0",
            "\u1EF7": "y",
            "\u1EF6": "y",
            "\u1EF3": "y",
            "\u1EF2": "Y",
            "\u1EF5": "y",
            "\u1EF4": "Y",
            "\u1EF9": "y",
            "\u1EF8": "Y",
            "\u1EA1": "a",
            "\u1EA0": "A",
            "\u1EA5": "a",
            "\u1EA4": "A",
            "\u1EA7": "a",
            "\u1EA6": "A",
            "\u1EAD": "a",
            "\u1EAC": "A",
            "\u1EAB": "a",
            "\u1EAA": "A",
            "\u1EAF": "a",
            "\u1EAE": "A",
            "\u1EB1": "a",
            "\u1EB0": "A",
            "\u1EB7": "a",
            "\u1EB6": "A",
            "\u1EB5": "a",
            "\u1EB4": "A",
            "\u24EA": "0",
            "\u2460": "1",
            "\u2461": "2",
            "\u2462": "3",
            "\u2463": "4",
            "\u2464": "5",
            "\u2465": "6",
            "\u2466": "7",
            "\u2467": "8",
            "\u2468": "9",
            "\u2469": "10",
            "\u246A": "11",
            "\u246B": "12",
            "\u246C": "13",
            "\u246D": "14",
            "\u246E": "15",
            "\u246F": "16",
            "\u2470": "17",
            "\u2471": "18",
            "\u2472": "18",
            "\u2473": "18",
            "\u24F5": "1",
            "\u24F6": "2",
            "\u24F7": "3",
            "\u24F8": "4",
            "\u24F9": "5",
            "\u24FA": "6",
            "\u24FB": "7",
            "\u24FC": "8",
            "\u24FD": "9",
            "\u24FE": "10",
            "\u24FF": "0",
            "\u24EB": "11",
            "\u24EC": "12",
            "\u24ED": "13",
            "\u24EE": "14",
            "\u24EF": "15",
            "\u24F0": "16",
            "\u24F1": "17",
            "\u24F2": "18",
            "\u24F3": "19",
            "\u24F4": "20",
            "\u24B6": "A",
            "\u24B7": "B",
            "\u24B8": "C",
            "\u24B9": "D",
            "\u24BA": "E",
            "\u24BB": "F",
            "\u24BC": "G",
            "\u24BD": "H",
            "\u24BE": "I",
            "\u24BF": "J",
            "\u24C0": "K",
            "\u24C1": "L",
            "\u24C2": "M",
            "\u24C3": "N",
            "\u24C4": "O",
            "\u24C5": "P",
            "\u24C6": "Q",
            "\u24C7": "R",
            "\u24C8": "S",
            "\u24C9": "T",
            "\u24CA": "U",
            "\u24CB": "V",
            "\u24CC": "W",
            "\u24CD": "X",
            "\u24CE": "Y",
            "\u24CF": "Z",
            "\u24D0": "a",
            "\u24D1": "b",
            "\u24D2": "c",
            "\u24D3": "d",
            "\u24D4": "e",
            "\u24D5": "f",
            "\u24D6": "g",
            "\u24D7": "h",
            "\u24D8": "i",
            "\u24D9": "j",
            "\u24DA": "k",
            "\u24DB": "l",
            "\u24DC": "m",
            "\u24DD": "n",
            "\u24DE": "o",
            "\u24DF": "p",
            "\u24E0": "q",
            "\u24E1": "r",
            "\u24E2": "s",
            "\u24E3": "t",
            "\u24E4": "u",
            "\u24E6": "v",
            "\u24E5": "w",
            "\u24E7": "x",
            "\u24E8": "y",
            "\u24E9": "z",
            "\u201C": "\"",
            "\u201D": "\"",
            "\u2018": "'",
            "\u2019": "'",
            "\u2202": "d",
            "\u0192": "f",
            "\u2122": "(TM)",
            "\xa9": "(C)",
            "\u0153": "oe",
            "\u0152": "OE",
            "\xae": "(R)",
            "\u2020": "+",
            "\u2120": "(SM)",
            "\u2026": "...",
            "\u02DA": "o",
            "\xba": "o",
            "\xaa": "a",
            "\u2022": "*",
            "\u104A": ",",
            "\u104B": ".",
            "$": "USD",
            "\u20AC": "EUR",
            "\u20A2": "BRN",
            "\u20A3": "FRF",
            "\xa3": "GBP",
            "\u20A4": "ITL",
            "\u20A6": "NGN",
            "\u20A7": "ESP",
            "\u20A9": "KRW",
            "\u20AA": "ILS",
            "\u20AB": "VND",
            "\u20AD": "LAK",
            "\u20AE": "MNT",
            "\u20AF": "GRD",
            "\u20B1": "ARS",
            "\u20B2": "PYG",
            "\u20B3": "ARA",
            "\u20B4": "UAH",
            "\u20B5": "GHS",
            "\xa2": "cent",
            "\xa5": "CNY",
            "\u5143": "CNY",
            "\u5186": "YEN",
            "\uFDFC": "IRR",
            "\u20A0": "EWE",
            "\u0E3F": "THB",
            "\u20A8": "INR",
            "\u20B9": "INR",
            "\u20B0": "PF",
            "\u20BA": "TRY",
            "\u060B": "AFN",
            "\u20BC": "AZN",
            "\u043B\u0432": "BGN",
            "\u17DB": "KHR",
            "\u20A1": "CRC",
            "\u20B8": "KZT",
            "\u0434\u0435\u043D": "MKD",
            "z\u0142": "PLN",
            "\u20BD": "RUB",
            "\u20BE": "GEL"
        };
        /**
		* special look ahead character array
		* These characters form with consonants to become 'single'/consonant combo
		* @type [Array]
		*/ var lookAheadCharArray = [
            "\u103A",
            "\u07B0"
        ];
        /**
		* diatricMap for languages where transliteration changes entirely as more diatrics are added
		* @type {Object}
		*/ var diatricMap = {
            "\u102C": "a",
            "\u102B": "a",
            "\u1031": "e",
            "\u1032": "e",
            "\u102D": "i",
            "\u102E": "i",
            "\u102D\u102F": "o",
            "\u102F": "u",
            "\u1030": "u",
            "\u1031\u102B\u1004\u103A": "aung",
            "\u1031\u102C": "aw",
            "\u1031\u102C\u103A": "aw",
            "\u1031\u102B": "aw",
            "\u1031\u102B\u103A": "aw",
            "\u103A": "\u103A",
            "\u1000\u103A": "et",
            "\u102D\u102F\u1000\u103A": "aik",
            "\u1031\u102C\u1000\u103A": "auk",
            "\u1004\u103A": "in",
            "\u102D\u102F\u1004\u103A": "aing",
            "\u1031\u102C\u1004\u103A": "aung",
            "\u1005\u103A": "it",
            "\u100A\u103A": "i",
            "\u1010\u103A": "at",
            "\u102D\u1010\u103A": "eik",
            "\u102F\u1010\u103A": "ok",
            "\u103D\u1010\u103A": "ut",
            "\u1031\u1010\u103A": "it",
            "\u1012\u103A": "d",
            "\u102D\u102F\u1012\u103A": "ok",
            "\u102F\u1012\u103A": "ait",
            "\u1014\u103A": "an",
            "\u102C\u1014\u103A": "an",
            "\u102D\u1014\u103A": "ein",
            "\u102F\u1014\u103A": "on",
            "\u103D\u1014\u103A": "un",
            "\u1015\u103A": "at",
            "\u102D\u1015\u103A": "eik",
            "\u102F\u1015\u103A": "ok",
            "\u103D\u1015\u103A": "ut",
            "\u1014\u103A\u102F\u1015\u103A": "nub",
            "\u1019\u103A": "an",
            "\u102D\u1019\u103A": "ein",
            "\u102F\u1019\u103A": "on",
            "\u103D\u1019\u103A": "un",
            "\u101A\u103A": "e",
            "\u102D\u102F\u101C\u103A": "ol",
            "\u1009\u103A": "in",
            "\u1036": "an",
            "\u102D\u1036": "ein",
            "\u102F\u1036": "on",
            "\u07A6\u0787\u07B0": "ah",
            "\u07A6\u0781\u07B0": "ah"
        };
        /**
		* langCharMap language specific characters translations
		* @type   {Object}
		*/ var langCharMap = {
            "en": {},
            "az": {
                "\xe7": "c",
                "\u0259": "e",
                "\u011F": "g",
                "\u0131": "i",
                "\xf6": "o",
                "\u015F": "s",
                "\xfc": "u",
                "\xc7": "C",
                "\u018F": "E",
                "\u011E": "G",
                "\u0130": "I",
                "\xd6": "O",
                "\u015E": "S",
                "\xdc": "U"
            },
            "cs": {
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z"
            },
            "fi": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "hu": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O",
                "\xfc": "u",
                "\xdc": "U",
                "\u0171": "u",
                "\u0170": "U"
            },
            "lt": {
                "\u0105": "a",
                "\u010D": "c",
                "\u0119": "e",
                "\u0117": "e",
                "\u012F": "i",
                "\u0161": "s",
                "\u0173": "u",
                "\u016B": "u",
                "\u017E": "z",
                "\u0104": "A",
                "\u010C": "C",
                "\u0118": "E",
                "\u0116": "E",
                "\u012E": "I",
                "\u0160": "S",
                "\u0172": "U",
                "\u016A": "U"
            },
            "lv": {
                "\u0101": "a",
                "\u010D": "c",
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                "\u0161": "s",
                "\u016B": "u",
                "\u017E": "z",
                "\u0100": "A",
                "\u010C": "C",
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "i",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                "\u0160": "S",
                "\u016A": "u",
                "\u017D": "Z"
            },
            "pl": {
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                "\xf3": "o",
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "e",
                "\u0141": "L",
                "\u0143": "N",
                "\xd3": "O",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z"
            },
            "sv": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "sk": {
                "\xe4": "a",
                "\xc4": "A"
            },
            "sr": {
                "\u0459": "lj",
                "\u045A": "nj",
                "\u0409": "Lj",
                "\u040A": "Nj",
                "\u0111": "dj",
                "\u0110": "Dj"
            },
            "tr": {
                "\xdc": "U",
                "\xd6": "O",
                "\xfc": "u",
                "\xf6": "o"
            }
        };
        /**
		* symbolMap language specific symbol translations
		* translations must be transliterated already
		* @type   {Object}
		*/ var symbolMap = {
            "ar": {
                "\u2206": "delta",
                "\u221E": "la-nihaya",
                "\u2665": "hob",
                "&": "wa",
                "|": "aw",
                "<": "aqal-men",
                ">": "akbar-men",
                "\u2211": "majmou",
                "\xa4": "omla"
            },
            "az": {},
            "ca": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "amor",
                "&": "i",
                "|": "o",
                "<": "menys que",
                ">": "mes que",
                "\u2211": "suma dels",
                "\xa4": "moneda"
            },
            "cs": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "nebo",
                "<": "mensi nez",
                ">": "vetsi nez",
                "\u2211": "soucet",
                "\xa4": "mena"
            },
            "de": {
                "\u2206": "delta",
                "\u221E": "unendlich",
                "\u2665": "Liebe",
                "&": "und",
                "|": "oder",
                "<": "kleiner als",
                ">": "groesser als",
                "\u2211": "Summe von",
                "\xa4": "Waehrung"
            },
            "dv": {
                "\u2206": "delta",
                "\u221E": "kolunulaa",
                "\u2665": "loabi",
                "&": "aai",
                "|": "noonee",
                "<": "ah vure kuda",
                ">": "ah vure bodu",
                "\u2211": "jumula",
                "\xa4": "faisaa"
            },
            "en": {
                "\u2206": "delta",
                "\u221E": "infinity",
                "\u2665": "love",
                "&": "and",
                "|": "or",
                "<": "less than",
                ">": "greater than",
                "\u2211": "sum",
                "\xa4": "currency"
            },
            "es": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "y",
                "|": "u",
                "<": "menos que",
                ">": "mas que",
                "\u2211": "suma de los",
                "\xa4": "moneda"
            },
            "fa": {
                "\u2206": "delta",
                "\u221E": "bi-nahayat",
                "\u2665": "eshgh",
                "&": "va",
                "|": "ya",
                "<": "kamtar-az",
                ">": "bishtar-az",
                "\u2211": "majmooe",
                "\xa4": "vahed"
            },
            "fi": {
                "\u2206": "delta",
                "\u221E": "aarettomyys",
                "\u2665": "rakkaus",
                "&": "ja",
                "|": "tai",
                "<": "pienempi kuin",
                ">": "suurempi kuin",
                "\u2211": "summa",
                "\xa4": "valuutta"
            },
            "fr": {
                "\u2206": "delta",
                "\u221E": "infiniment",
                "\u2665": "Amour",
                "&": "et",
                "|": "ou",
                "<": "moins que",
                ">": "superieure a",
                "\u2211": "somme des",
                "\xa4": "monnaie"
            },
            "ge": {
                "\u2206": "delta",
                "\u221E": "usasruloba",
                "\u2665": "siqvaruli",
                "&": "da",
                "|": "an",
                "<": "naklebi",
                ">": "meti",
                "\u2211": "jami",
                "\xa4": "valuta"
            },
            "gr": {},
            "hu": {
                "\u2206": "delta",
                "\u221E": "vegtelen",
                "\u2665": "szerelem",
                "&": "es",
                "|": "vagy",
                "<": "kisebb mint",
                ">": "nagyobb mint",
                "\u2211": "szumma",
                "\xa4": "penznem"
            },
            "it": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amore",
                "&": "e",
                "|": "o",
                "<": "minore di",
                ">": "maggiore di",
                "\u2211": "somma",
                "\xa4": "moneta"
            },
            "lt": {
                "\u2206": "delta",
                "\u221E": "begalybe",
                "\u2665": "meile",
                "&": "ir",
                "|": "ar",
                "<": "maziau nei",
                ">": "daugiau nei",
                "\u2211": "suma",
                "\xa4": "valiuta"
            },
            "lv": {
                "\u2206": "delta",
                "\u221E": "bezgaliba",
                "\u2665": "milestiba",
                "&": "un",
                "|": "vai",
                "<": "mazak neka",
                ">": "lielaks neka",
                "\u2211": "summa",
                "\xa4": "valuta"
            },
            "my": {
                "\u2206": "kwahkhyaet",
                "\u221E": "asaonasme",
                "\u2665": "akhyait",
                "&": "nhin",
                "|": "tho",
                "<": "ngethaw",
                ">": "kyithaw",
                "\u2211": "paungld",
                "\xa4": "ngwekye"
            },
            "mk": {},
            "nl": {
                "\u2206": "delta",
                "\u221E": "oneindig",
                "\u2665": "liefde",
                "&": "en",
                "|": "of",
                "<": "kleiner dan",
                ">": "groter dan",
                "\u2211": "som",
                "\xa4": "valuta"
            },
            "pl": {
                "\u2206": "delta",
                "\u221E": "nieskonczonosc",
                "\u2665": "milosc",
                "&": "i",
                "|": "lub",
                "<": "mniejsze niz",
                ">": "wieksze niz",
                "\u2211": "suma",
                "\xa4": "waluta"
            },
            "pt": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "e",
                "|": "ou",
                "<": "menor que",
                ">": "maior que",
                "\u2211": "soma",
                "\xa4": "moeda"
            },
            "ro": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "dragoste",
                "&": "si",
                "|": "sau",
                "<": "mai mic ca",
                ">": "mai mare ca",
                "\u2211": "suma",
                "\xa4": "valuta"
            },
            "ru": {
                "\u2206": "delta",
                "\u221E": "beskonechno",
                "\u2665": "lubov",
                "&": "i",
                "|": "ili",
                "<": "menshe",
                ">": "bolshe",
                "\u2211": "summa",
                "\xa4": "valjuta"
            },
            "sk": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "alebo",
                "<": "menej ako",
                ">": "viac ako",
                "\u2211": "sucet",
                "\xa4": "mena"
            },
            "sr": {},
            "tr": {
                "\u2206": "delta",
                "\u221E": "sonsuzluk",
                "\u2665": "ask",
                "&": "ve",
                "|": "veya",
                "<": "kucuktur",
                ">": "buyuktur",
                "\u2211": "toplam",
                "\xa4": "para birimi"
            },
            "uk": {
                "\u2206": "delta",
                "\u221E": "bezkinechnist",
                "\u2665": "lubov",
                "&": "i",
                "|": "abo",
                "<": "menshe",
                ">": "bilshe",
                "\u2211": "suma",
                "\xa4": "valjuta"
            },
            "vn": {
                "\u2206": "delta",
                "\u221E": "vo cuc",
                "\u2665": "yeu",
                "&": "va",
                "|": "hoac",
                "<": "nho hon",
                ">": "lon hon",
                "\u2211": "tong",
                "\xa4": "tien te"
            }
        };
        var uricChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ",",
            "/"
        ].join("");
        var uricNoSlashChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ","
        ].join("");
        var markChars = [
            ".",
            "!",
            "~",
            "*",
            "'",
            "(",
            ")"
        ].join("");
        /**
		* getSlug
		* @param  {string} input input string
		* @param  {object|string} opts config object or separator string/char
		* @api    public
		* @return {string}  sluggified string
		*/ var getSlug = function getSlug(input, opts) {
            var separator = "-";
            var result = "";
            var diatricString = "";
            var convertSymbols = true;
            var customReplacements = {};
            var maintainCase;
            var titleCase;
            var truncate;
            var uricFlag;
            var uricNoSlashFlag;
            var markFlag;
            var symbol;
            var langChar;
            var lucky;
            var i;
            var ch;
            var l;
            var lastCharWasSymbol;
            var lastCharWasDiatric;
            var allowedChars = "";
            if (typeof input !== "string") return "";
            if (typeof opts === "string") separator = opts;
            symbol = symbolMap.en;
            langChar = langCharMap.en;
            if (typeof opts === "object") {
                maintainCase = opts.maintainCase || false;
                customReplacements = opts.custom && typeof opts.custom === "object" ? opts.custom : customReplacements;
                truncate = +opts.truncate > 1 && opts.truncate || false;
                uricFlag = opts.uric || false;
                uricNoSlashFlag = opts.uricNoSlash || false;
                markFlag = opts.mark || false;
                convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                separator = opts.separator || separator;
                if (uricFlag) allowedChars += uricChars;
                if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                if (markFlag) allowedChars += markChars;
                symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                    opts.titleCase.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    titleCase = true;
                } else titleCase = !!opts.titleCase;
                if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                    customReplacements[v + ""] = v + "";
                });
                Object.keys(customReplacements).forEach(function(v) {
                    var r;
                    if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                    else r = new RegExp(escapeChars(v), "gi");
                    input = input.replace(r, customReplacements[v]);
                });
                for(ch in customReplacements)allowedChars += ch;
            }
            allowedChars += separator;
            allowedChars = escapeChars(allowedChars);
            input = input.replace(/(^\s+|\s+$)/g, "");
            lastCharWasSymbol = false;
            lastCharWasDiatric = false;
            for(i = 0, l = input.length; i < l; i++){
                ch = input[i];
                if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                else if (langChar[ch]) {
                    ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                    lastCharWasSymbol = false;
                } else if (ch in charMap) {
                    if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                        diatricString += ch;
                        ch = "";
                    } else if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + charMap[ch];
                        diatricString = "";
                    } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                    lastCharWasSymbol = false;
                    lastCharWasDiatric = false;
                } else if (ch in diatricMap) {
                    diatricString += ch;
                    ch = "";
                    if (i === l - 1) ch = diatricMap[diatricString];
                    lastCharWasDiatric = true;
                } else if (symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                    ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                    ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                    lastCharWasSymbol = true;
                } else {
                    if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + ch;
                        diatricString = "";
                        lastCharWasDiatric = false;
                    } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                    lastCharWasSymbol = false;
                }
                result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
            }
            if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : "");
                return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
            });
            result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
            if (truncate && result.length > truncate) {
                lucky = result.charAt(truncate) === separator;
                result = result.slice(0, truncate);
                if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
            }
            if (!maintainCase && !titleCase) result = result.toLowerCase();
            return result;
        };
        /**
		* createSlug curried(opts)(input)
		* @param   {object|string} opts config object or input string
		* @return  {Function} function getSlugWithConfig()
		**/ var createSlug = function createSlug(opts) {
            /**
			* getSlugWithConfig
			* @param   {string} input string
			* @return  {string} slug string
			*/ return function getSlugWithConfig(input) {
                return getSlug(input, opts);
            };
        };
        /**
		* escape Chars
		* @param   {string} input string
		*/ var escapeChars = function escapeChars(input) {
            return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
        };
        /**
		* check if the char is an already converted char from custom list
		* @param   {char} ch character to check
		* @param   {object} customReplacements custom translation map
		*/ var isReplacedCustomChar = function(ch, customReplacements) {
            for(var c in customReplacements)if (customReplacements[c] === ch) return true;
        };
        if (typeof module !== "undefined" && module.exports) {
            module.exports = getSlug;
            module.exports.createSlug = createSlug;
        } else if (typeof define !== "undefined" && define.amd) define([], function() {
            return getSlug;
        });
        else try {
            if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
            else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    })(exports);
});
//#endregion
//#region src/core/app/index.ts
var $f8f651eebe4ca737$var$import_speakingurl = /* @__PURE__ */ $f8f651eebe4ca737$var$__toESM(/* @__PURE__ */ $f8f651eebe4ca737$var$__commonJSMin((exports, module)=>{
    module.exports = $f8f651eebe4ca737$var$require_speakingurl$1();
})(), 1);
const $f8f651eebe4ca737$var$appRecordInfo = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ ??= {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $f8f651eebe4ca737$var$getAppRecordName(app, fallbackName) {
    return app?._component?.name || `App ${fallbackName}`;
}
function $f8f651eebe4ca737$var$getAppRootInstance(app) {
    if (app._instance) return app._instance;
    else if (app._container?._vnode?.component) return app._container?._vnode?.component;
}
function $f8f651eebe4ca737$var$removeAppRecordId(app) {
    const id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $f8f651eebe4ca737$var$appRecordInfo.appIds.delete(id);
        $f8f651eebe4ca737$var$appRecordInfo.id--;
    }
}
function $f8f651eebe4ca737$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    let id = defaultId ?? ($f8f651eebe4ca737$var$appRecordInfo.id++).toString();
    if (defaultId && $f8f651eebe4ca737$var$appRecordInfo.appIds.has(id)) {
        let count = 1;
        while($f8f651eebe4ca737$var$appRecordInfo.appIds.has(`${defaultId}_${count}`))count++;
        id = `${defaultId}_${count}`;
    }
    $f8f651eebe4ca737$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $f8f651eebe4ca737$var$createAppRecord(app, types) {
    const rootInstance = $f8f651eebe4ca737$var$getAppRootInstance(app);
    if (rootInstance) {
        $f8f651eebe4ca737$var$appRecordInfo.id++;
        const name = $f8f651eebe4ca737$var$getAppRecordName(app, $f8f651eebe4ca737$var$appRecordInfo.id.toString());
        const id = $f8f651eebe4ca737$var$getAppRecordId(app, (0, $f8f651eebe4ca737$var$import_speakingurl.default)(name));
        const [el] = $f8f651eebe4ca737$var$getRootElementsFromComponentInstance(rootInstance);
        const record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance,
            iframe: (0, $7427aa90e0ad70d7$export$4e09c449d6c407f7) && document !== el?.ownerDocument ? el?.ownerDocument?.location?.pathname : void 0
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        const rootId = `${record.id}:root`;
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
//#endregion
//#region src/core/iframe/index.ts
function $f8f651eebe4ca737$var$detectIframeApp(target, inIframe = false) {
    if (inIframe) {
        function sendEventToParent(cb) {
            try {
                const hook = window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (hook) cb(hook);
            } catch (e) {}
        }
        const hook = {
            id: "vue-devtools-next",
            devtoolsVersion: "7.0",
            on: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.on(event, cb);
                });
            },
            once: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.once(event, cb);
                });
            },
            off: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.off(event, cb);
                });
            },
            emit: (event, ...payload)=>{
                sendEventToParent((hook)=>{
                    hook.emit(event, ...payload);
                });
            }
        };
        Object.defineProperty(target, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
            get () {
                return hook;
            },
            configurable: true
        });
    }
    function injectVueHookToIframe(iframe) {
        if (iframe.__vdevtools__injected) return;
        try {
            iframe.__vdevtools__injected = true;
            const inject = ()=>{
                try {
                    iframe.contentWindow.__VUE_DEVTOOLS_IFRAME__ = iframe;
                    const script = iframe.contentDocument.createElement("script");
                    script.textContent = `;(${$f8f651eebe4ca737$var$detectIframeApp.toString()})(window, true)`;
                    iframe.contentDocument.documentElement.appendChild(script);
                    script.parentNode.removeChild(script);
                } catch (e) {}
            };
            inject();
            iframe.addEventListener("load", ()=>inject());
        } catch (e) {}
    }
    function injectVueHookToIframes() {
        if (typeof window === "undefined") return;
        const iframes = Array.from(document.querySelectorAll("iframe:not([data-vue-devtools-ignore])"));
        for (const iframe of iframes)injectVueHookToIframe(iframe);
    }
    injectVueHookToIframes();
    let iframeAppChecks = 0;
    const iframeAppCheckTimer = setInterval(()=>{
        injectVueHookToIframes();
        iframeAppChecks++;
        if (iframeAppChecks >= 5) clearInterval(iframeAppCheckTimer);
    }, 1e3);
}
//#endregion
//#region src/core/index.ts
function $f8f651eebe4ca737$export$93f430585c3f6d11() {
    $f8f651eebe4ca737$var$detectIframeApp((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563));
    $f8f651eebe4ca737$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $f8f651eebe4ca737$export$6fcf3c68ecb51939().vitePluginDetected
    });
    const isDevToolsNext = (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__?.id === "vue-devtools-next";
    if ((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    const _devtoolsHook = $f8f651eebe4ca737$var$createDevToolsHook();
    if ((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach((cb)=>cb(_devtoolsHook));
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", (Vue)=>{
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        const legacyChromeUrl = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        const legacyFirefoxUrl = "https://addons.mozilla.org/firefox/addon/vue-js-devtools-v6-legacy";
        console.log(`%cThe legacy version of chrome extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyChromeUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log(`%cThe legacy version of firefox extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyFirefoxUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $f8f651eebe4ca737$var$hook.on.setupDevtoolsPlugin((pluginDescriptor, setupFn)=>{
        $f8f651eebe4ca737$export$5158df7771943590(pluginDescriptor, setupFn);
        const { app: app } = $f8f651eebe4ca737$export$162128841a7f2877 ?? {};
        if (pluginDescriptor.settings) $f8f651eebe4ca737$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $f8f651eebe4ca737$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $f8f651eebe4ca737$var$onLegacyDevToolsPluginApiAvailable(()=>{
        $f8f651eebe4ca737$export$df02dcb86618c10f.filter(([item])=>item.id !== "components").forEach(([pluginDescriptor, setupFn])=>{
            _devtoolsHook.emit($f8f651eebe4ca737$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $f8f651eebe4ca737$var$hook.on.vueAppInit(async (app, version, types)=>{
        const normalizedAppRecord = {
            ...$f8f651eebe4ca737$var$createAppRecord(app, types),
            app: app,
            version: version
        };
        $f8f651eebe4ca737$export$c1761479e1420543(normalizedAppRecord);
        if ($f8f651eebe4ca737$export$d3c0473489b1d63b.value.length === 1) {
            $f8f651eebe4ca737$export$1574774def61bdf9(normalizedAppRecord);
            $f8f651eebe4ca737$export$1a7804ab8d8511d1(normalizedAppRecord.id);
            $f8f651eebe4ca737$var$normalizeRouterInfo(normalizedAppRecord, $f8f651eebe4ca737$export$162128841a7f2877);
            $f8f651eebe4ca737$export$c357c87447719db2(normalizedAppRecord.app);
        }
        $f8f651eebe4ca737$export$1f0daed17c8e64f(...$f8f651eebe4ca737$export$7e5554ded389d004(normalizedAppRecord.app));
        $f8f651eebe4ca737$export$ee22a7aaf6b41ce2({
            connected: true
        });
        _devtoolsHook.apps.push(app);
    });
    $f8f651eebe4ca737$var$hook.on.vueAppUnmount(async (app)=>{
        const activeRecords = $f8f651eebe4ca737$export$d3c0473489b1d63b.value.filter((appRecord)=>appRecord.app !== app);
        if (activeRecords.length === 0) $f8f651eebe4ca737$export$ee22a7aaf6b41ce2({
            connected: false
        });
        $f8f651eebe4ca737$export$4d20c72f1da170ba(app);
        $f8f651eebe4ca737$var$removeAppRecordId(app);
        if ($f8f651eebe4ca737$export$162128841a7f2877.value.app === app) {
            $f8f651eebe4ca737$export$1574774def61bdf9(activeRecords[0]);
            $f8f651eebe4ca737$export$4f1904c03898171b.hooks.callHook($f8f651eebe4ca737$export$12aa7e661bddec80.SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT);
        }
        (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
        $f8f651eebe4ca737$export$7f52963080ec618f(app);
    });
    $f8f651eebe4ca737$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $7427aa90e0ad70d7$export$44271b4f0c6a3563), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get () {
            return _devtoolsHook;
        },
        configurable: true
    });
    else if (!(0, $7427aa90e0ad70d7$export$e34a31924fd64105)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $f8f651eebe4ca737$export$cb42e76452729606(fn) {
    return new Promise((resolve)=>{
        if ($f8f651eebe4ca737$export$a67dd585df937baa.connected && $f8f651eebe4ca737$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $f8f651eebe4ca737$export$4f1904c03898171b.hooks.hook($f8f651eebe4ca737$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, ({ state: state })=>{
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
//#endregion
//#region src/core/high-perf-mode/index.ts
function $f8f651eebe4ca737$export$6f15da7a796da26a(state) {
    $f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled = state ?? !$f8f651eebe4ca737$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $f8f651eebe4ca737$export$162128841a7f2877.value) $f8f651eebe4ca737$export$c357c87447719db2($f8f651eebe4ca737$export$162128841a7f2877.value.app);
}
//#endregion
//#region src/core/component/state/reviver.ts
function $f8f651eebe4ca737$var$reviveSet(val) {
    const result = /* @__PURE__ */ new Set();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const value = list[i];
        result.add($f8f651eebe4ca737$var$revive(value));
    }
    return result;
}
function $f8f651eebe4ca737$var$reviveMap(val) {
    const result = /* @__PURE__ */ new Map();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const { key: key, value: value } = list[i];
        result.set(key, $f8f651eebe4ca737$var$revive(value));
    }
    return result;
}
function $f8f651eebe4ca737$var$revive(val) {
    if (val === "__vue_devtool_undefined__") return;
    else if (val === "__vue_devtool_infinity__") return Number.POSITIVE_INFINITY;
    else if (val === "__vue_devtool_negative_infinity__") return Number.NEGATIVE_INFINITY;
    else if (val === "__vue_devtool_nan__") return NaN;
    else if (val && val._custom) {
        const { _custom: custom } = val;
        if (custom.type === "component") return $f8f651eebe4ca737$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $f8f651eebe4ca737$var$reviveMap(val);
        else if (custom.type === "set") return $f8f651eebe4ca737$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $f8f651eebe4ca737$var$revive(custom.value);
    } else if ($f8f651eebe4ca737$var$symbolRE.test(val)) {
        const [, string] = $f8f651eebe4ca737$var$symbolRE.exec(val);
        return Symbol.for(string);
    } else if ($f8f651eebe4ca737$var$specialTypeRE.test(val)) {
        const [, type, string, , details] = $f8f651eebe4ca737$var$specialTypeRE.exec(val);
        const result = new (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[type](string);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $f8f651eebe4ca737$var$reviver(key, value) {
    return $f8f651eebe4ca737$var$revive(value);
}
//#endregion
//#region src/core/component/state/format.ts
function $f8f651eebe4ca737$export$a2acd0fde5480ad5(value, raw = true) {
    const type = typeof value;
    if (value == null || value === "__vue_devtool_undefined__" || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === "__vue_devtool_infinity__" || value === "__vue_devtool_negative_infinity__" || value === "__vue_devtool_nan__") return "literal";
    else if (value?._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $f8f651eebe4ca737$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        const typeMatch = $f8f651eebe4ca737$var$specialTypeRE.exec(value);
        if (typeMatch) {
            const [, type] = typeMatch;
            return `native ${type}`;
        } else return "string";
    } else if (Array.isArray(value) || value?._isArray) return "array";
    else if ($f8f651eebe4ca737$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $f8f651eebe4ca737$export$6c635c17a78ff695(value, quotes = false, options) {
    const { customClass: customClass } = options ?? {};
    let result;
    const type = $f8f651eebe4ca737$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && value?._custom) value = value._custom.value;
    if (result = $f8f651eebe4ca737$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") return value._custom.value?._custom && $f8f651eebe4ca737$export$6c635c17a78ff695(value._custom.value, quotes, options) || value._custom.displayText || value._custom.display;
    else if (type === "array") return `Array[${value.length}]`;
    else if (type === "plain-object") return `Object${Object.keys(value).length ? "" : " (empty)"}`;
    else if (type?.includes("native")) return $f8f651eebe4ca737$export$4e7f196112fea3c5($f8f651eebe4ca737$var$specialTypeRE.exec(value)?.[2]);
    else if (typeof value === "string") {
        const typeMatch = value.match($f8f651eebe4ca737$var$rawTypeRE);
        if (typeMatch) value = $f8f651eebe4ca737$var$escapeString(typeMatch[1]);
        else if (quotes) value = `<span>"</span>${customClass?.string ? `<span class=${customClass.string}>${$f8f651eebe4ca737$var$escapeString(value)}</span>` : $f8f651eebe4ca737$var$escapeString(value)}<span>"</span>`;
        else value = customClass?.string ? `<span class="${customClass?.string ?? ""}">${$f8f651eebe4ca737$var$escapeString(value)}</span>` : $f8f651eebe4ca737$var$escapeString(value);
    }
    return value;
}
function $f8f651eebe4ca737$var$escapeString(value) {
    return $f8f651eebe4ca737$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $f8f651eebe4ca737$export$d049e3525cb8af5d(value) {
    let customType;
    const isCustom = $f8f651eebe4ca737$export$a2acd0fde5480ad5(value) === "custom";
    let inherit = {};
    if (isCustom) {
        const data = value;
        const customValue = data._custom?.value;
        const currentCustomType = data._custom?.type;
        const nestedCustom = typeof customValue === "object" && customValue !== null && "_custom" in customValue ? $f8f651eebe4ca737$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || data._custom?.fields || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $f8f651eebe4ca737$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $f8f651eebe4ca737$var$replaceTokenToString(JSON.stringify(value));
}
function $f8f651eebe4ca737$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($f8f651eebe4ca737$var$replaceStringToToken(value), $f8f651eebe4ca737$var$reviver);
}
//#endregion
//#region src/core/devtools-client/detected.ts
function $f8f651eebe4ca737$export$2fce292577290205(params) {
    $f8f651eebe4ca737$export$a67dd585df937baa.devtoolsClientDetected = {
        ...$f8f651eebe4ca737$export$a67dd585df937baa.devtoolsClientDetected,
        ...params
    };
    $f8f651eebe4ca737$export$6f15da7a796da26a(!Object.values($f8f651eebe4ca737$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean));
}
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ ??= $f8f651eebe4ca737$export$2fce292577290205;
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
var $f8f651eebe4ca737$var$DoubleIndexedKV = class {
    constructor(){
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    }
    getByKey(key) {
        return this.keyToValue.get(key);
    }
    getByValue(value) {
        return this.valueToKey.get(value);
    }
    clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $f8f651eebe4ca737$var$Registry = class {
    constructor(generateIdentifier){
        this.generateIdentifier = generateIdentifier;
        this.kv = new $f8f651eebe4ca737$var$DoubleIndexedKV();
    }
    register(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    }
    clear() {
        this.kv.clear();
    }
    getIdentifier(value) {
        return this.kv.getByValue(value);
    }
    getValue(identifier) {
        return this.kv.getByKey(identifier);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $f8f651eebe4ca737$var$ClassRegistry = class extends $f8f651eebe4ca737$var$Registry {
    constructor(){
        super((c)=>c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
    }
    register(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            super.register(value, options.identifier);
        } else super.register(value, options);
    }
    getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
function $f8f651eebe4ca737$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    const values = [];
    for(const key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $f8f651eebe4ca737$var$find(record, predicate) {
    const values = $f8f651eebe4ca737$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    const valuesNotNever = values;
    for(let i = 0; i < valuesNotNever.length; i++){
        const value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
}
function $f8f651eebe4ca737$var$forEach(record, run) {
    Object.entries(record).forEach(([key, value])=>run(value, key));
}
function $f8f651eebe4ca737$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $f8f651eebe4ca737$var$findArr(record, predicate) {
    for(let i = 0; i < record.length; i++){
        const value = record[i];
        if (predicate(value)) return value;
    }
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $f8f651eebe4ca737$var$CustomTransformerRegistry = class {
    constructor(){
        this.transfomers = {};
    }
    register(transformer) {
        this.transfomers[transformer.name] = transformer;
    }
    findApplicable(v) {
        return $f8f651eebe4ca737$var$find(this.transfomers, (transformer)=>transformer.isApplicable(v));
    }
    findByName(name) {
        return this.transfomers[name];
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
const $f8f651eebe4ca737$var$getType$1 = (payload)=>Object.prototype.toString.call(payload).slice(8, -1);
const $f8f651eebe4ca737$var$isUndefined$1 = (payload)=>typeof payload === "undefined";
const $f8f651eebe4ca737$var$isNull$1 = (payload)=>payload === null;
const $f8f651eebe4ca737$var$isPlainObject$2 = (payload)=>{
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
const $f8f651eebe4ca737$var$isEmptyObject = (payload)=>$f8f651eebe4ca737$var$isPlainObject$2(payload) && Object.keys(payload).length === 0;
const $f8f651eebe4ca737$var$isArray$2 = (payload)=>Array.isArray(payload);
const $f8f651eebe4ca737$var$isString = (payload)=>typeof payload === "string";
const $f8f651eebe4ca737$var$isNumber = (payload)=>typeof payload === "number" && !isNaN(payload);
const $f8f651eebe4ca737$var$isBoolean = (payload)=>typeof payload === "boolean";
const $f8f651eebe4ca737$var$isRegExp = (payload)=>payload instanceof RegExp;
const $f8f651eebe4ca737$var$isMap = (payload)=>payload instanceof Map;
const $f8f651eebe4ca737$var$isSet = (payload)=>payload instanceof Set;
const $f8f651eebe4ca737$var$isSymbol = (payload)=>$f8f651eebe4ca737$var$getType$1(payload) === "Symbol";
const $f8f651eebe4ca737$var$isDate = (payload)=>payload instanceof Date && !isNaN(payload.valueOf());
const $f8f651eebe4ca737$var$isError = (payload)=>payload instanceof Error;
const $f8f651eebe4ca737$var$isNaNValue = (payload)=>typeof payload === "number" && isNaN(payload);
const $f8f651eebe4ca737$var$isPrimitive = (payload)=>$f8f651eebe4ca737$var$isBoolean(payload) || $f8f651eebe4ca737$var$isNull$1(payload) || $f8f651eebe4ca737$var$isUndefined$1(payload) || $f8f651eebe4ca737$var$isNumber(payload) || $f8f651eebe4ca737$var$isString(payload) || $f8f651eebe4ca737$var$isSymbol(payload);
const $f8f651eebe4ca737$var$isBigint = (payload)=>typeof payload === "bigint";
const $f8f651eebe4ca737$var$isInfinite = (payload)=>payload === Infinity || payload === -Infinity;
const $f8f651eebe4ca737$var$isTypedArray = (payload)=>ArrayBuffer.isView(payload) && !(payload instanceof DataView);
const $f8f651eebe4ca737$var$isURL = (payload)=>payload instanceof URL;
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
const $f8f651eebe4ca737$var$escapeKey = (key)=>key.replace(/\./g, "\\.");
const $f8f651eebe4ca737$var$stringifyPath = (path)=>path.map(String).map($f8f651eebe4ca737$var$escapeKey).join(".");
const $f8f651eebe4ca737$var$parsePath = (string)=>{
    const result = [];
    let segment = "";
    for(let i = 0; i < string.length; i++){
        let char = string.charAt(i);
        if (char === "\\" && string.charAt(i + 1) === ".") {
            segment += ".";
            i++;
            continue;
        }
        if (char === ".") {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    const lastSegment = segment;
    result.push(lastSegment);
    return result;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
function $f8f651eebe4ca737$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
const $f8f651eebe4ca737$var$simpleRules = [
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isUndefined$1, "undefined", ()=>null, ()=>void 0),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isBigint, "bigint", (v)=>v.toString(), (v)=>{
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isDate, "Date", (v)=>v.toISOString(), (v)=>new Date(v)),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isError, "Error", (v, superJson)=>{
        const baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach((prop)=>{
            baseError[prop] = v[prop];
        });
        return baseError;
    }, (v, superJson)=>{
        const e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop)=>{
            e[prop] = v[prop];
        });
        return e;
    }),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isRegExp, "regexp", (v)=>"" + v, (regex)=>{
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isSet, "set", (v)=>[
            ...v.values()
        ], (v)=>new Set(v)),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isMap, "map", (v)=>[
            ...v.entries()
        ], (v)=>new Map(v)),
    $f8f651eebe4ca737$var$simpleTransformation((v)=>$f8f651eebe4ca737$var$isNaNValue(v) || $f8f651eebe4ca737$var$isInfinite(v), "number", (v)=>{
        if ($f8f651eebe4ca737$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $f8f651eebe4ca737$var$simpleTransformation((v)=>v === 0 && 1 / v === -Infinity, "number", ()=>{
        return "-0";
    }, Number),
    $f8f651eebe4ca737$var$simpleTransformation($f8f651eebe4ca737$var$isURL, "URL", (v)=>v.toString(), (v)=>new URL(v))
];
function $f8f651eebe4ca737$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
const $f8f651eebe4ca737$var$symbolRule = $f8f651eebe4ca737$var$compositeTransformation((s, superJson)=>{
    if ($f8f651eebe4ca737$var$isSymbol(s)) return !!superJson.symbolRegistry.getIdentifier(s);
    return false;
}, (s, superJson)=>{
    return [
        "symbol",
        superJson.symbolRegistry.getIdentifier(s)
    ];
}, (v)=>v.description, (_, a, superJson)=>{
    const value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
const $f8f651eebe4ca737$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce((obj, ctor)=>{
    obj[ctor.name] = ctor;
    return obj;
}, {});
const $f8f651eebe4ca737$var$typedArrayRule = $f8f651eebe4ca737$var$compositeTransformation($f8f651eebe4ca737$var$isTypedArray, (v)=>[
        "typed-array",
        v.constructor.name
    ], (v)=>[
        ...v
    ], (v, a)=>{
    const ctor = $f8f651eebe4ca737$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $f8f651eebe4ca737$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass?.constructor) return !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
    return false;
}
const $f8f651eebe4ca737$var$classRule = $f8f651eebe4ca737$var$compositeTransformation($f8f651eebe4ca737$var$isInstanceOfRegisteredClass, (clazz, superJson)=>{
    return [
        "class",
        superJson.classRegistry.getIdentifier(clazz.constructor)
    ];
}, (clazz, superJson)=>{
    const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return {
        ...clazz
    };
    const result = {};
    allowedProps.forEach((prop)=>{
        result[prop] = clazz[prop];
    });
    return result;
}, (v, a, superJson)=>{
    const clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
    return Object.assign(Object.create(clazz.prototype), v);
});
const $f8f651eebe4ca737$var$customRule = $f8f651eebe4ca737$var$compositeTransformation((value, superJson)=>{
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, (value, superJson)=>{
    return [
        "custom",
        superJson.customTransformerRegistry.findApplicable(value).name
    ];
}, (value, superJson)=>{
    return superJson.customTransformerRegistry.findApplicable(value).serialize(value);
}, (v, a, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
const $f8f651eebe4ca737$var$compositeRules = [
    $f8f651eebe4ca737$var$classRule,
    $f8f651eebe4ca737$var$symbolRule,
    $f8f651eebe4ca737$var$customRule,
    $f8f651eebe4ca737$var$typedArrayRule
];
const $f8f651eebe4ca737$var$transformValue = (value, superJson)=>{
    const applicableCompositeRule = $f8f651eebe4ca737$var$findArr($f8f651eebe4ca737$var$compositeRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    const applicableSimpleRule = $f8f651eebe4ca737$var$findArr($f8f651eebe4ca737$var$simpleRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
};
const $f8f651eebe4ca737$var$simpleRulesByAnnotation = {};
$f8f651eebe4ca737$var$simpleRules.forEach((rule)=>{
    $f8f651eebe4ca737$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
const $f8f651eebe4ca737$var$untransformValue = (json, type, superJson)=>{
    if ($f8f651eebe4ca737$var$isArray$2(type)) switch(type[0]){
        case "symbol":
            return $f8f651eebe4ca737$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $f8f651eebe4ca737$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $f8f651eebe4ca737$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $f8f651eebe4ca737$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        const transformation = $f8f651eebe4ca737$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
const $f8f651eebe4ca737$var$getNthKey = (value, n)=>{
    if (n > value.size) throw new Error("index out of bounds");
    const keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $f8f651eebe4ca737$var$validatePath(path) {
    if ($f8f651eebe4ca737$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($f8f651eebe4ca737$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($f8f651eebe4ca737$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
const $f8f651eebe4ca737$var$getDeep = (object, path)=>{
    $f8f651eebe4ca737$var$validatePath(path);
    for(let i = 0; i < path.length; i++){
        const key = path[i];
        if ($f8f651eebe4ca737$var$isSet(object)) object = $f8f651eebe4ca737$var$getNthKey(object, +key);
        else if ($f8f651eebe4ca737$var$isMap(object)) {
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $f8f651eebe4ca737$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
const $f8f651eebe4ca737$var$setDeep = (object, path, mapper)=>{
    $f8f651eebe4ca737$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    let parent = object;
    for(let i = 0; i < path.length - 1; i++){
        const key = path[i];
        if ($f8f651eebe4ca737$var$isArray$2(parent)) {
            const index = +key;
            parent = parent[index];
        } else if ($f8f651eebe4ca737$var$isPlainObject$2(parent)) parent = parent[key];
        else if ($f8f651eebe4ca737$var$isSet(parent)) {
            const row = +key;
            parent = $f8f651eebe4ca737$var$getNthKey(parent, row);
        } else if ($f8f651eebe4ca737$var$isMap(parent)) {
            if (i === path.length - 2) break;
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $f8f651eebe4ca737$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    const lastKey = path[path.length - 1];
    if ($f8f651eebe4ca737$var$isArray$2(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($f8f651eebe4ca737$var$isPlainObject$2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($f8f651eebe4ca737$var$isSet(parent)) {
        const oldValue = $f8f651eebe4ca737$var$getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($f8f651eebe4ca737$var$isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = $f8f651eebe4ca737$var$getNthKey(parent, row);
        switch(+lastKey === 0 ? "key" : "value"){
            case "key":
                {
                    const newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $f8f651eebe4ca737$var$traverse(tree, walker, origin = []) {
    if (!tree) return;
    if (!$f8f651eebe4ca737$var$isArray$2(tree)) {
        $f8f651eebe4ca737$var$forEach(tree, (subtree, key)=>$f8f651eebe4ca737$var$traverse(subtree, walker, [
                ...origin,
                ...$f8f651eebe4ca737$var$parsePath(key)
            ]));
        return;
    }
    const [nodeValue, children] = tree;
    if (children) $f8f651eebe4ca737$var$forEach(children, (child, key)=>{
        $f8f651eebe4ca737$var$traverse(child, walker, [
            ...origin,
            ...$f8f651eebe4ca737$var$parsePath(key)
        ]);
    });
    walker(nodeValue, origin);
}
function $f8f651eebe4ca737$var$applyValueAnnotations(plain, annotations, superJson) {
    $f8f651eebe4ca737$var$traverse(annotations, (type, path)=>{
        plain = $f8f651eebe4ca737$var$setDeep(plain, path, (v)=>$f8f651eebe4ca737$var$untransformValue(v, type, superJson));
    });
    return plain;
}
function $f8f651eebe4ca737$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        const object = $f8f651eebe4ca737$var$getDeep(plain, $f8f651eebe4ca737$var$parsePath(path));
        identicalPaths.map($f8f651eebe4ca737$var$parsePath).forEach((identicalObjectPath)=>{
            plain = $f8f651eebe4ca737$var$setDeep(plain, identicalObjectPath, ()=>object);
        });
    }
    if ($f8f651eebe4ca737$var$isArray$2(annotations)) {
        const [root, other] = annotations;
        root.forEach((identicalPath)=>{
            plain = $f8f651eebe4ca737$var$setDeep(plain, $f8f651eebe4ca737$var$parsePath(identicalPath), ()=>plain);
        });
        if (other) $f8f651eebe4ca737$var$forEach(other, apply);
    } else $f8f651eebe4ca737$var$forEach(annotations, apply);
    return plain;
}
const $f8f651eebe4ca737$var$isDeep = (object, superJson)=>$f8f651eebe4ca737$var$isPlainObject$2(object) || $f8f651eebe4ca737$var$isArray$2(object) || $f8f651eebe4ca737$var$isMap(object) || $f8f651eebe4ca737$var$isSet(object) || $f8f651eebe4ca737$var$isInstanceOfRegisteredClass(object, superJson);
function $f8f651eebe4ca737$var$addIdentity(object, path, identities) {
    const existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $f8f651eebe4ca737$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    const result = {};
    let rootEqualityPaths = void 0;
    identitites.forEach((paths)=>{
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map((path)=>path.map(String)).sort((a, b)=>a.length - b.length);
        const [representativePath, ...identicalPaths] = paths;
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($f8f651eebe4ca737$var$stringifyPath);
        else result[$f8f651eebe4ca737$var$stringifyPath(representativePath)] = identicalPaths.map($f8f651eebe4ca737$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($f8f651eebe4ca737$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $f8f651eebe4ca737$var$isEmptyObject(result) ? void 0 : result;
}
const $f8f651eebe4ca737$var$walker = (object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map())=>{
    const primitive = $f8f651eebe4ca737$var$isPrimitive(object);
    if (!primitive) {
        $f8f651eebe4ca737$var$addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$f8f651eebe4ca737$var$isDeep(object, superJson)) {
        const transformed = $f8f651eebe4ca737$var$transformValue(object, superJson);
        const result = transformed ? {
            transformedValue: transformed.value,
            annotations: [
                transformed.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result);
        return result;
    }
    if ($f8f651eebe4ca737$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    const transformationResult = $f8f651eebe4ca737$var$transformValue(object, superJson);
    const transformed = transformationResult?.value ?? object;
    const transformedValue = $f8f651eebe4ca737$var$isArray$2(transformed) ? [] : {};
    const innerAnnotations = {};
    $f8f651eebe4ca737$var$forEach(transformed, (value, index)=>{
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        const recursiveResult = $f8f651eebe4ca737$var$walker(value, identities, superJson, dedupe, [
            ...path,
            index
        ], [
            ...objectsInThisPath,
            object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($f8f651eebe4ca737$var$isArray$2(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($f8f651eebe4ca737$var$isPlainObject$2(recursiveResult.annotations)) $f8f651eebe4ca737$var$forEach(recursiveResult.annotations, (tree, key)=>{
            innerAnnotations[$f8f651eebe4ca737$var$escapeKey(index) + "." + key] = tree;
        });
    });
    const result = $f8f651eebe4ca737$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};
//#endregion
//#region ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
function $f8f651eebe4ca737$var$getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $f8f651eebe4ca737$var$isArray$1(payload) {
    return $f8f651eebe4ca737$var$getType(payload) === "Array";
}
function $f8f651eebe4ca737$var$isPlainObject$1(payload) {
    if ($f8f651eebe4ca737$var$getType(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $f8f651eebe4ca737$var$isNull(payload) {
    return $f8f651eebe4ca737$var$getType(payload) === "Null";
}
function $f8f651eebe4ca737$var$isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $f8f651eebe4ca737$var$isUndefined(payload) {
    return $f8f651eebe4ca737$var$getType(payload) === "Undefined";
}
$f8f651eebe4ca737$var$isOneOf($f8f651eebe4ca737$var$isNull, $f8f651eebe4ca737$var$isUndefined);
//#endregion
//#region ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $f8f651eebe4ca737$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $f8f651eebe4ca737$var$copy(target, options = {}) {
    if ($f8f651eebe4ca737$var$isArray$1(target)) return target.map((item)=>$f8f651eebe4ca737$var$copy(item, options));
    if (!$f8f651eebe4ca737$var$isPlainObject$1(target)) return target;
    const props = Object.getOwnPropertyNames(target);
    const symbols = Object.getOwnPropertySymbols(target);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ($f8f651eebe4ca737$var$isArray$1(options.props) && !options.props.includes(key)) return carry;
        const val = target[key];
        $f8f651eebe4ca737$var$assignProp(carry, key, $f8f651eebe4ca737$var$copy(val, options), target, options.nonenumerable);
        return carry;
    }, {});
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $f8f651eebe4ca737$var$SuperJSON = class {
    /**
	* @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
	*/ constructor({ dedupe: dedupe = false } = {}){
        this.classRegistry = new $f8f651eebe4ca737$var$ClassRegistry();
        this.symbolRegistry = new $f8f651eebe4ca737$var$Registry((s)=>s.description ?? "");
        this.customTransformerRegistry = new $f8f651eebe4ca737$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = $f8f651eebe4ca737$var$walker(object, identities, this, this.dedupe);
        const res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = {
            ...res.meta,
            values: output.annotations
        };
        const equalityAnnotations = $f8f651eebe4ca737$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
        };
        return res;
    }
    deserialize(payload) {
        const { json: json, meta: meta } = payload;
        let result = $f8f651eebe4ca737$var$copy(json);
        if (meta?.values) result = $f8f651eebe4ca737$var$applyValueAnnotations(result, meta.values, this);
        if (meta?.referentialEqualities) result = $f8f651eebe4ca737$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
        return result;
    }
    stringify(object) {
        return JSON.stringify(this.serialize(object));
    }
    parse(string) {
        return this.deserialize(JSON.parse(string));
    }
    registerClass(v, options) {
        this.classRegistry.register(v, options);
    }
    registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    }
    registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
            name: name,
            ...transformer
        });
    }
    allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
    }
};
$f8f651eebe4ca737$var$SuperJSON.defaultInstance = new $f8f651eebe4ca737$var$SuperJSON();
$f8f651eebe4ca737$var$SuperJSON.serialize = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.serialize.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.deserialize = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.deserialize.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.stringify = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.stringify.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.parse = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.parse.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.registerClass = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.registerClass.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.registerSymbol = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.registerSymbol.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.registerCustom = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.registerCustom.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.allowErrorProps = $f8f651eebe4ca737$var$SuperJSON.defaultInstance.allowErrorProps.bind($f8f651eebe4ca737$var$SuperJSON.defaultInstance);
$f8f651eebe4ca737$var$SuperJSON.serialize;
$f8f651eebe4ca737$var$SuperJSON.deserialize;
$f8f651eebe4ca737$var$SuperJSON.stringify;
$f8f651eebe4ca737$var$SuperJSON.parse;
$f8f651eebe4ca737$var$SuperJSON.registerClass;
$f8f651eebe4ca737$var$SuperJSON.registerCustom;
$f8f651eebe4ca737$var$SuperJSON.registerSymbol;
$f8f651eebe4ca737$var$SuperJSON.allowErrorProps;
//#endregion
//#region src/messaging/presets/broadcast-channel/context.ts
const $f8f651eebe4ca737$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
//#endregion
//#region src/messaging/presets/broadcast-channel/index.ts
const $f8f651eebe4ca737$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $f8f651eebe4ca737$var$createBroadcastChannel() {
    const channel = new BroadcastChannel($f8f651eebe4ca737$var$BROADCAST_CHANNEL_NAME);
    return {
        post: (data)=>{
            channel.postMessage($f8f651eebe4ca737$var$SuperJSON.stringify({
                event: $f8f651eebe4ca737$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: (handler)=>{
            channel.onmessage = (event)=>{
                const parsed = $f8f651eebe4ca737$var$SuperJSON.parse(event.data);
                if (parsed.event === "__devtools-kit-broadcast-messaging-event-key__") handler(parsed.data);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/context.ts
const $f8f651eebe4ca737$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
const $f8f651eebe4ca737$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
const $f8f651eebe4ca737$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
const $f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $f8f651eebe4ca737$var$getElectronClientContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $f8f651eebe4ca737$export$2837faaf25ee2c9a(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $f8f651eebe4ca737$var$getElectronProxyContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $f8f651eebe4ca737$export$f4b34d15f9836c97(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $f8f651eebe4ca737$var$getElectronServerContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_SERVER_CONTEXT__];
}
function $f8f651eebe4ca737$export$d8c81043a9a1bbbe(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/electron/client.ts
function $f8f651eebe4ca737$var$createElectronClientChannel() {
    const socket = $f8f651eebe4ca737$var$getElectronClientContext();
    return {
        post: (data)=>{
            socket.emit($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $f8f651eebe4ca737$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, (e)=>{
                handler($f8f651eebe4ca737$var$SuperJSON.parse(e));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/proxy.ts
function $f8f651eebe4ca737$var$createElectronProxyChannel() {
    const socket = $f8f651eebe4ca737$var$getElectronProxyContext();
    return {
        post: (data)=>{},
        on: (handler)=>{
            socket.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, (data)=>{
                socket.broadcast.emit($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, (data)=>{
                socket.broadcast.emit($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/server.ts
function $f8f651eebe4ca737$var$createElectronServerChannel() {
    const socket = $f8f651eebe4ca737$var$getElectronServerContext();
    return {
        post: (data)=>{
            socket.emit($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $f8f651eebe4ca737$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, (data)=>{
                handler($f8f651eebe4ca737$var$SuperJSON.parse(data));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/context.ts
const $f8f651eebe4ca737$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
const $f8f651eebe4ca737$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $f8f651eebe4ca737$export$6c3de6c2be1b2806() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $f8f651eebe4ca737$export$31a9a778785defb(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/extension/client.ts
function $f8f651eebe4ca737$var$createExtensionClientChannel() {
    let disconnected = false;
    let port = null;
    let reconnectTimer = null;
    let onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: `${chrome.devtools.inspectedWindow.tabId}`
            });
            $f8f651eebe4ca737$export$31a9a778785defb(port);
            disconnected = false;
            port?.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(()=>{
                disconnected = true;
                port?.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: (data)=>{
            if (disconnected) return;
            port?.postMessage($f8f651eebe4ca737$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            onMessageHandler = (data)=>{
                if (disconnected) return;
                handler($f8f651eebe4ca737$var$SuperJSON.parse(data));
            };
            port?.onMessage.addListener(onMessageHandler);
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/proxy.ts
function $f8f651eebe4ca737$var$createExtensionProxyChannel() {
    const port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $f8f651eebe4ca737$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $f8f651eebe4ca737$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(()=>{
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($f8f651eebe4ca737$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($f8f651eebe4ca737$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: (data)=>{},
        on: (handler)=>{}
    };
}
//#endregion
//#region src/messaging/presets/extension/server.ts
function $f8f651eebe4ca737$var$createExtensionServerChannel() {
    return {
        post: (data)=>{
            window.postMessage({
                source: $f8f651eebe4ca737$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $f8f651eebe4ca737$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: (handler)=>{
            const listener = (event)=>{
                if (event.data.source === $f8f651eebe4ca737$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($f8f651eebe4ca737$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return ()=>{
                window.removeEventListener("message", listener);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/iframe/context.ts
const $f8f651eebe4ca737$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
const $f8f651eebe4ca737$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $f8f651eebe4ca737$var$getIframeServerContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__IFRAME_SERVER_CONTEXT__];
}
function $f8f651eebe4ca737$export$918b6d08f99ca1d5(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__IFRAME_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/iframe/client.ts
function $f8f651eebe4ca737$var$createIframeClientChannel() {
    if (!(0, $7427aa90e0ad70d7$export$4e09c449d6c407f7)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>window.parent.postMessage($f8f651eebe4ca737$var$SuperJSON.stringify({
                event: $f8f651eebe4ca737$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*"),
        on: (handler)=>window.addEventListener("message", (event)=>{
                try {
                    const parsed = $f8f651eebe4ca737$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            })
    };
}
//#endregion
//#region src/messaging/presets/iframe/server.ts
function $f8f651eebe4ca737$var$createIframeServerChannel() {
    if (!(0, $7427aa90e0ad70d7$export$4e09c449d6c407f7)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>{
            $f8f651eebe4ca737$var$getIframeServerContext()?.contentWindow?.postMessage($f8f651eebe4ca737$var$SuperJSON.stringify({
                event: $f8f651eebe4ca737$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: (handler)=>{
            window.addEventListener("message", (event)=>{
                const iframe = $f8f651eebe4ca737$var$getIframeServerContext();
                try {
                    const parsed = $f8f651eebe4ca737$var$SuperJSON.parse(event.data);
                    if (event.source === iframe?.contentWindow && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/context.ts
const $f8f651eebe4ca737$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
const $f8f651eebe4ca737$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
const $f8f651eebe4ca737$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $f8f651eebe4ca737$var$getViteClientContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__VITE_CLIENT_CONTEXT__];
}
function $f8f651eebe4ca737$export$8559d72d41937efd(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $f8f651eebe4ca737$var$getViteServerContext() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__VITE_SERVER_CONTEXT__];
}
function $f8f651eebe4ca737$export$4c32fe701137877e(context) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563)[$f8f651eebe4ca737$var$__VITE_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/vite/client.ts
function $f8f651eebe4ca737$var$createViteClientChannel() {
    const client = $f8f651eebe4ca737$var$getViteClientContext();
    return {
        post: (data)=>{
            client?.send($f8f651eebe4ca737$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $f8f651eebe4ca737$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            client?.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($f8f651eebe4ca737$var$SuperJSON.parse(event));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/server.ts
function $f8f651eebe4ca737$var$createViteServerChannel() {
    const viteServer = $f8f651eebe4ca737$var$getViteServerContext();
    const ws = viteServer.hot ?? viteServer.ws;
    return {
        post: (data)=>ws?.send($f8f651eebe4ca737$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $f8f651eebe4ca737$var$SuperJSON.stringify(data)),
        on: (handler)=>ws?.on($f8f651eebe4ca737$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($f8f651eebe4ca737$var$SuperJSON.parse(event));
            })
    };
}
//#endregion
//#region src/messaging/index.ts
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ ??= [];
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ ??= null;
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_SERVER__ ??= null;
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ ??= null;
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ ??= null;
(0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ ??= null;
function $f8f651eebe4ca737$var$setRpcClientToGlobal(rpc) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $f8f651eebe4ca737$export$7f98be55f66c4a0d(rpc) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $f8f651eebe4ca737$export$9362d59e25b9feb1() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $f8f651eebe4ca737$export$380718822fedc343() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $f8f651eebe4ca737$export$5f8b48d38df9666a(rpc) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $f8f651eebe4ca737$export$5105f0908e5b2002(rpc) {
    (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $f8f651eebe4ca737$export$c7310d0d7eeaac08() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $f8f651eebe4ca737$export$97b242d29756c723() {
    return (0, $7427aa90e0ad70d7$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $f8f651eebe4ca737$var$getChannel(preset, host = "client") {
    const channel = {
        iframe: {
            client: $f8f651eebe4ca737$var$createIframeClientChannel,
            server: $f8f651eebe4ca737$var$createIframeServerChannel
        }[host],
        electron: {
            client: $f8f651eebe4ca737$var$createElectronClientChannel,
            proxy: $f8f651eebe4ca737$var$createElectronProxyChannel,
            server: $f8f651eebe4ca737$var$createElectronServerChannel
        }[host],
        vite: {
            client: $f8f651eebe4ca737$var$createViteClientChannel,
            server: $f8f651eebe4ca737$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $f8f651eebe4ca737$var$createBroadcastChannel,
            server: $f8f651eebe4ca737$var$createBroadcastChannel
        }[host],
        extension: {
            client: $f8f651eebe4ca737$var$createExtensionClientChannel,
            proxy: $f8f651eebe4ca737$var$createExtensionProxyChannel,
            server: $f8f651eebe4ca737$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $f8f651eebe4ca737$export$9c13c20c639717e6(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $f8f651eebe4ca737$var$getChannel(preset) : _channel;
    const rpc = (0, $71801a0999247337$export$8de909a09ac6851a)(functions, {
        ..._options,
        ...channel,
        timeout: -1
    });
    if (preset === "vite") {
        $f8f651eebe4ca737$export$5f8b48d38df9666a(rpc);
        return;
    }
    $f8f651eebe4ca737$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $f8f651eebe4ca737$export$fbf8e1689a053c1c(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $f8f651eebe4ca737$var$getChannel(preset, "server") : _channel;
    const rpcServer = $f8f651eebe4ca737$export$380718822fedc343();
    if (!rpcServer) {
        const group = (0, $71801a0999247337$export$ec516731f3c62ae5)(functions, [
            channel
        ], {
            ..._options,
            timeout: -1
        });
        if (preset === "vite") {
            $f8f651eebe4ca737$export$5105f0908e5b2002(group);
            return;
        }
        $f8f651eebe4ca737$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels((channels)=>{
        channels.push(channel);
    });
}
function $f8f651eebe4ca737$export$490df4aa0eb47722(options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $f8f651eebe4ca737$var$getChannel(preset, "proxy") : _channel;
    return (0, $71801a0999247337$export$8de909a09ac6851a)({}, {
        ..._options,
        ...channel,
        timeout: -1
    });
}
//#endregion
//#region src/core/component/state/custom.ts
function $f8f651eebe4ca737$var$getFunctionDetails(func) {
    let string = "";
    let matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    const match = matches && matches[0];
    const args = typeof match === "string" ? match : "(?)";
    return {
        _custom: {
            type: "function",
            displayText: `<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">${$f8f651eebe4ca737$export$4e7f196112fea3c5(typeof func.name === "string" ? func.name : "")}${args}</span>`,
            tooltipText: string.trim() ? `<pre>${$f8f651eebe4ca737$export$4e7f196112fea3c5(string)}</pre>` : null
        }
    };
}
function $f8f651eebe4ca737$var$getBigIntDetails(val) {
    const stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: `BigInt(${stringifiedBigInt})`,
            value: stringifiedBigInt
        }
    };
}
function $f8f651eebe4ca737$var$getDateDetails(val) {
    const date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $f8f651eebe4ca737$var$getMapDetails(val) {
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: Object.fromEntries(val),
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $f8f651eebe4ca737$var$getSetDetails(val) {
    const list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: `Set[${list.length}]`,
            value: list,
            readOnly: true
        }
    };
}
function $f8f651eebe4ca737$var$getCaughtGetters(store) {
    const getters = {};
    const origGetters = store.getters || {};
    const keys = Object.keys(origGetters);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: ()=>{
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    }
    return getters;
}
function $f8f651eebe4ca737$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce((map, item)=>{
        const key = item.type || "data";
        const obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $f8f651eebe4ca737$var$namedNodeMapToObject(map) {
    const result = {};
    const l = map.length;
    for(let i = 0; i < l; i++){
        const node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $f8f651eebe4ca737$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $f8f651eebe4ca737$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $f8f651eebe4ca737$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    const state = $f8f651eebe4ca737$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $f8f651eebe4ca737$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $f8f651eebe4ca737$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $f8f651eebe4ca737$var$getComponentDefinitionDetails(definition) {
    let display = $f8f651eebe4ca737$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += ` <span>(${definition.__file})</span>`;
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: {
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition",
            ...definition.__file ? {
                file: definition.__file
            } : {}
        }
    };
}
function $f8f651eebe4ca737$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="opacity-30">&lt;</span><span class="text-blue-500">${value.tagName.toLowerCase()}</span><span class="opacity-30">&gt;</span>`,
                value: $f8f651eebe4ca737$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="text-blue-500">${String(value)}</span>`
            }
        };
    }
}
/**
* - ObjectRefImpl, toRef({ foo: 'foo' }, 'foo'), `_value` is the actual value, (since 3.5.0)
* - GetterRefImpl, toRef(() => state.foo), `_value` is the actual value, (since 3.5.0)
* - RefImpl, ref('foo') / computed(() => 'foo'), `_value` is the actual value
*/ function $f8f651eebe4ca737$var$tryGetRefValue(ref) {
    if ($f8f651eebe4ca737$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($f8f651eebe4ca737$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $f8f651eebe4ca737$var$getObjectDetails(object) {
    const info = $f8f651eebe4ca737$var$getSetupStateType(object);
    if (info.ref || info.computed || info.reactive) {
        const stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        const value = $f8f651eebe4ca737$var$toRaw(info.reactive ? object : $f8f651eebe4ca737$var$tryGetRefValue(object));
        const raw = $f8f651eebe4ca737$var$ensurePropertyExists(object, "effect") ? object.effect?.raw?.toString() || object.effect?.fn?.toString() : null;
        return {
            _custom: {
                type: stateTypeName?.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value,
                ...raw ? {
                    tooltipText: `<pre>${$f8f651eebe4ca737$export$4e7f196112fea3c5(raw)}</pre>`
                } : {}
            }
        };
    }
    if ($f8f651eebe4ca737$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
//#endregion
//#region src/core/component/state/replacer.ts
function $f8f651eebe4ca737$var$stringifyReplacer(key, _value, depth, seenInstance) {
    if (key === "compilerOptions") return;
    const val = this[key];
    const type = typeof val;
    if (Array.isArray(val)) {
        const l = val.length;
        if (l > 5e3) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $f8f651eebe4ca737$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > 1e4) return `${val.substring(0, $f8f651eebe4ca737$var$MAX_STRING_SIZE)}... (${val.length} total length)`;
        else return val;
    } else if (type === "undefined") return $f8f651eebe4ca737$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $f8f651eebe4ca737$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $f8f651eebe4ca737$export$95cb88e357cbada8;
    else if (typeof val === "function") return $f8f651eebe4ca737$var$getFunctionDetails(val);
    else if (type === "symbol") return `[native Symbol ${Symbol.prototype.toString.call(val)}]`;
    else if (typeof val === "bigint") return $f8f651eebe4ca737$var$getBigIntDetails(val);
    else if (val !== null && typeof val === "object") {
        const proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $f8f651eebe4ca737$var$getMapDetails(val);
        else if (proto === "[object Set]") return $f8f651eebe4ca737$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return `[native RegExp ${RegExp.prototype.toString.call(val)}]`;
        else if (proto === "[object Date]") return $f8f651eebe4ca737$var$getDateDetails(val);
        else if (proto === "[object Error]") return `[native Error ${val.message}<>${val.stack}]`;
        else if ($f8f651eebe4ca737$var$ensurePropertyExists(val, "state", true) && $f8f651eebe4ca737$var$ensurePropertyExists(val, "_vm", true)) return $f8f651eebe4ca737$var$getStoreDetails(val);
        else if ($f8f651eebe4ca737$var$isVueInstance(val)) {
            const componentVal = $f8f651eebe4ca737$var$getInstanceDetails(val);
            const parentInstanceDepth = seenInstance?.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return `[[CircularRef]] <${componentVal._custom.displayText}>`;
            seenInstance?.set(val, depth);
            return componentVal;
        } else if ($f8f651eebe4ca737$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $f8f651eebe4ca737$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return `[native VNode <${val.tag}>]`;
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $f8f651eebe4ca737$var$getHTMLElementDetails(val);
        else if (val.constructor?.name === "Store" && "_wrappedGetters" in val) return "[object Store]";
        const customDetails = $f8f651eebe4ca737$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $f8f651eebe4ca737$export$d7ae0f70ebb9e144;
    return $f8f651eebe4ca737$var$sanitize(val);
}
//#endregion
//#region src/shared/transfer.ts
const $f8f651eebe4ca737$var$MAX_SERIALIZED_SIZE = 2097152;
function $f8f651eebe4ca737$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $f8f651eebe4ca737$var$isArray(_data, proto) {
    return proto === "[object Array]";
}
function $f8f651eebe4ca737$var$isVueReactiveLinkNode(node) {
    const constructorName = node?.constructor?.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
/**
* This function is used to serialize object with handling circular references.
*
* ```ts
* const obj = { a: 1, b: { c: 2 }, d: obj }
* const result = stringifyCircularAutoChunks(obj) // call `encode` inside
* console.log(result) // [{"a":1,"b":2,"d":0},1,{"c":4},2]
* ```
*
* Each object is stored in a list and the index is used to reference the object.
* With seen map, we can check if the object is already stored in the list to avoid circular references.
*
* Note: here we have a special case for Vue instance.
* We check if a vue instance includes itself in its properties and skip it
* by using `seenVueInstance` and `depth` to avoid infinite loop.
*/ function $f8f651eebe4ca737$var$encode(data, replacer, list, seen, depth = 0, seenVueInstance = /* @__PURE__ */ new Map()) {
    let stored;
    let key;
    let value;
    let i;
    let l;
    const seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    const index = list.length;
    const proto = Object.prototype.toString.call(data);
    if ($f8f651eebe4ca737$var$isObject(data, proto)) {
        if ($f8f651eebe4ca737$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        const keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            const isVm = value != null && $f8f651eebe4ca737$var$isObject(value, Object.prototype.toString.call(data)) && $f8f651eebe4ca737$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $f8f651eebe4ca737$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($f8f651eebe4ca737$var$isArray(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $f8f651eebe4ca737$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $f8f651eebe4ca737$var$decode(list, reviver = null) {
    let i = list.length;
    let j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            const keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver) value = reviver.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver) value = reviver.call(data, j, value);
            data[j] = value;
        }
    }
}
function $f8f651eebe4ca737$var$stringifyCircularAutoChunks(data, replacer = null, space = null) {
    let result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, (k, v)=>replacer?.(k, v)?.call(this), space);
    } catch (e) {
        result = $f8f651eebe4ca737$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $f8f651eebe4ca737$var$MAX_SERIALIZED_SIZE) {
        const chunkCount = Math.ceil(result.length / $f8f651eebe4ca737$var$MAX_SERIALIZED_SIZE);
        const chunks = [];
        for(let i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $f8f651eebe4ca737$var$MAX_SERIALIZED_SIZE, (i + 1) * $f8f651eebe4ca737$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $f8f651eebe4ca737$var$stringifyStrictCircularAutoChunks(data, replacer = null, space = null) {
    const list = [];
    $f8f651eebe4ca737$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? ` ${JSON.stringify(list, null, space)}` : ` ${JSON.stringify(list)}`;
}
function $f8f651eebe4ca737$var$parseCircularAutoChunks(data, reviver = null) {
    if (Array.isArray(data)) data = data.join("");
    if (!/^\s/.test(data)) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver);
    else {
        const list = JSON.parse(data);
        $f8f651eebe4ca737$var$decode(list, reviver);
        return list[0];
    }
}
//#endregion
//#region src/shared/util.ts
function $f8f651eebe4ca737$export$fac44ee5b035f737(data) {
    return $f8f651eebe4ca737$var$stringifyCircularAutoChunks(data, $f8f651eebe4ca737$var$stringifyReplacer);
}
function $f8f651eebe4ca737$export$98e6a39c04603d36(data, revive = false) {
    if (data == void 0) return {};
    return revive ? $f8f651eebe4ca737$var$parseCircularAutoChunks(data, $f8f651eebe4ca737$var$reviver) : $f8f651eebe4ca737$var$parseCircularAutoChunks(data);
}
//#endregion
//#region src/index.ts
const $f8f651eebe4ca737$export$6922d3b3a607469e = {
    hook: $f8f651eebe4ca737$var$hook,
    init: ()=>{
        $f8f651eebe4ca737$export$93f430585c3f6d11();
    },
    get ctx () {
        return $f8f651eebe4ca737$export$4f1904c03898171b;
    },
    get api () {
        return $f8f651eebe4ca737$export$4f1904c03898171b.api;
    }
};


//#region src/utils/env.ts
const $89cb8fb509e52b47$export$d66501df72047452 = typeof document !== "undefined";
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $89cb8fb509e52b47$var$HASH_RE = /#/g;
const $89cb8fb509e52b47$var$AMPERSAND_RE = /&/g;
const $89cb8fb509e52b47$var$SLASH_RE = /\//g;
const $89cb8fb509e52b47$var$EQUAL_RE = /=/g;
const $89cb8fb509e52b47$var$IM_RE = /\?/g;
const $89cb8fb509e52b47$export$ebd11618f299a286 = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $89cb8fb509e52b47$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $89cb8fb509e52b47$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $89cb8fb509e52b47$var$ENC_CARET_RE = /%5E/g;
const $89cb8fb509e52b47$var$ENC_BACKTICK_RE = /%60/g;
const $89cb8fb509e52b47$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $89cb8fb509e52b47$var$ENC_PIPE_RE = /%7C/g;
const $89cb8fb509e52b47$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $89cb8fb509e52b47$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $89cb8fb509e52b47$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($89cb8fb509e52b47$var$ENC_PIPE_RE, "|").replace($89cb8fb509e52b47$var$ENC_BRACKET_OPEN_RE, "[").replace($89cb8fb509e52b47$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $89cb8fb509e52b47$export$3a1a48c8f6ef640e(text) {
    return $89cb8fb509e52b47$var$commonEncode(text).replace($89cb8fb509e52b47$var$ENC_CURLY_OPEN_RE, "{").replace($89cb8fb509e52b47$var$ENC_CURLY_CLOSE_RE, "}").replace($89cb8fb509e52b47$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $89cb8fb509e52b47$var$encodeQueryValue(text) {
    return $89cb8fb509e52b47$var$commonEncode(text).replace($89cb8fb509e52b47$export$ebd11618f299a286, "%2B").replace($89cb8fb509e52b47$var$ENC_SPACE_RE, "+").replace($89cb8fb509e52b47$var$HASH_RE, "%23").replace($89cb8fb509e52b47$var$AMPERSAND_RE, "%26").replace($89cb8fb509e52b47$var$ENC_BACKTICK_RE, "`").replace($89cb8fb509e52b47$var$ENC_CURLY_OPEN_RE, "{").replace($89cb8fb509e52b47$var$ENC_CURLY_CLOSE_RE, "}").replace($89cb8fb509e52b47$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $89cb8fb509e52b47$var$encodeQueryKey(text) {
    return $89cb8fb509e52b47$var$encodeQueryValue(text).replace($89cb8fb509e52b47$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $89cb8fb509e52b47$export$56c0d5a1e737357d(text) {
    return $89cb8fb509e52b47$var$commonEncode(text).replace($89cb8fb509e52b47$var$HASH_RE, "%23").replace($89cb8fb509e52b47$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $89cb8fb509e52b47$export$a07804094c3ecf2d(text) {
    return $89cb8fb509e52b47$export$56c0d5a1e737357d(text).replace($89cb8fb509e52b47$var$SLASH_RE, "%2F");
}
function $89cb8fb509e52b47$export$35e795649ee09318(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch  {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $89cb8fb509e52b47$var$TRAILING_SLASH_RE = /\/$/;
const $89cb8fb509e52b47$var$removeTrailingSlash = (path)=>path.replace($89cb8fb509e52b47$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $89cb8fb509e52b47$export$a9c23c6ac3fc3eca(parseQuery, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $89cb8fb509e52b47$export$96f57966bedc81b4(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $89cb8fb509e52b47$export$35e795649ee09318(hash)
    };
}
function $89cb8fb509e52b47$export$d141bba7fdc215a3(stringifyQuery, path, query, hash = "") {
    const searchText = stringifyQuery(query);
    return path + (searchText && "?") + searchText + $89cb8fb509e52b47$export$3a1a48c8f6ef640e(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $89cb8fb509e52b47$export$c4ce752e73470fba(stringifyQuery, location) {
    const query = location.query ? stringifyQuery(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $89cb8fb509e52b47$export$342063e11d6c3cad(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $89cb8fb509e52b47$export$e7094788287c5e9b(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $89cb8fb509e52b47$export$971d5caa766a69d7(a.matched[aLastIndex], b.matched[bLastIndex]) && $89cb8fb509e52b47$export$efccba1c4a2ef57b(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $89cb8fb509e52b47$export$971d5caa766a69d7(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $89cb8fb509e52b47$export$efccba1c4a2ef57b(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$89cb8fb509e52b47$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $89cb8fb509e52b47$var$isSameRouteLocationParamsValue(a, b) {
    return (0, $61ae4f1203339483$export$39b482c5e57630a8)(a) ? $89cb8fb509e52b47$var$isEquivalentArray(a, b) : (0, $61ae4f1203339483$export$39b482c5e57630a8)(b) ? $89cb8fb509e52b47$var$isEquivalentArray(b, a) : (a && a.valueOf()) === (b && b.valueOf());
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $89cb8fb509e52b47$var$isEquivalentArray(a, b) {
    return (0, $61ae4f1203339483$export$39b482c5e57630a8)(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $89cb8fb509e52b47$export$96f57966bedc81b4(to, from) {
    if ((0, $61ae4f1203339483$export$dda1d9f60106f0e9)(to)) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $89cb8fb509e52b47$export$25ce5a424b770e84 = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $89cb8fb509e52b47$export$8b22cf2602fb60ce(base) {
    if (!base) {
        if ($89cb8fb509e52b47$export$d66501df72047452) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $89cb8fb509e52b47$var$removeTrailingSlash(base);
}
const $89cb8fb509e52b47$var$BEFORE_HASH_RE = /^[^#]+#/;
function $89cb8fb509e52b47$export$4a5767248b18ef41(base, location) {
    return base.replace($89cb8fb509e52b47$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $89cb8fb509e52b47$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $89cb8fb509e52b47$export$953cecd6e717a553 = ()=>history.scrollRestoration === "manual" ? {
        left: window.scrollX,
        top: window.scrollY
    } : null;
function $89cb8fb509e52b47$export$90a7f3efeed30595(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $89cb8fb509e52b47$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $89cb8fb509e52b47$export$39b482c5e57630a8(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $89cb8fb509e52b47$var$scrollPositions = /* @__PURE__ */ new Map();
function $89cb8fb509e52b47$export$71511d61b312f219(key) {
    $89cb8fb509e52b47$var$scrollPositions.set(key, $89cb8fb509e52b47$export$953cecd6e717a553());
}
function $89cb8fb509e52b47$export$dda1d9f60106f0e9(key) {
    const scroll = $89cb8fb509e52b47$var$scrollPositions.get(key);
    $89cb8fb509e52b47$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $89cb8fb509e52b47$export$2d1720544b23b823(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $89cb8fb509e52b47$export$ffb5f4729a158638(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $89cb8fb509e52b47$export$3b14a55fb2447963(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($89cb8fb509e52b47$export$ebd11618f299a286, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $89cb8fb509e52b47$export$35e795649ee09318(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $89cb8fb509e52b47$export$35e795649ee09318(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!(0, $61ae4f1203339483$export$39b482c5e57630a8)(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $89cb8fb509e52b47$export$4368d992c4eafac0(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $89cb8fb509e52b47$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ((0, $61ae4f1203339483$export$39b482c5e57630a8)(value) ? value.map((v)=>v && $89cb8fb509e52b47$var$encodeQueryValue(v)) : [
            value && $89cb8fb509e52b47$var$encodeQueryValue(value)
        ]).forEach((value)=>{
            if (value !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $89cb8fb509e52b47$export$882b5998b3b9117c(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = (0, $61ae4f1203339483$export$39b482c5e57630a8)(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $89cb8fb509e52b47$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $89cb8fb509e52b47$var$registerGuard(activeRecordRef, name, guard) {
    const record = activeRecordRef.value;
    if (!record) return;
    let currentRecord = record;
    const removeFromList = ()=>{
        currentRecord[name].delete(guard);
    };
    (0, $3dLyd.onUnmounted)(removeFromList);
    (0, $3dLyd.onDeactivated)(removeFromList);
    (0, $3dLyd.onActivated)(()=>{
        const newRecord = activeRecordRef.value;
        if (newRecord) currentRecord = newRecord;
        currentRecord[name].add(guard);
    });
    currentRecord[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $89cb8fb509e52b47$export$ae1af26003f05816(leaveGuard) {
    $89cb8fb509e52b47$var$registerGuard((0, $3dLyd.inject)((0, $61ae4f1203339483$export$43caf9889c228507), {}), "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $89cb8fb509e52b47$export$2408f22a0fab9ae5(updateGuard) {
    $89cb8fb509e52b47$var$registerGuard((0, $3dLyd.inject)((0, $61ae4f1203339483$export$43caf9889c228507), {}), "updateGuards", updateGuard);
}
function $89cb8fb509e52b47$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject((0, $61ae4f1203339483$export$3b14a55fb2447963)(4, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($89cb8fb509e52b47$export$2d1720544b23b823(valid)) reject((0, $61ae4f1203339483$export$3b14a55fb2447963)(2, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
/**
* Wraps the next callback to warn when it is used. Dev-only: when __DEV__ is
* false (production builds), this branch is dead code and is stripped from the
* bundle.
*
* @internal
*/ function $89cb8fb509e52b47$var$withDeprecationWarning(next) {
    let warned = false;
    return function() {
        if (!warned) {
            warned = true;
            (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0025();
        }
        return next.apply(this, arguments);
    };
}
function $89cb8fb509e52b47$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0024({
            from: from.fullPath,
            to: to.fullPath
        });
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $89cb8fb509e52b47$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ((0, $61ae4f1203339483$export$90a7f3efeed30595)(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($89cb8fb509e52b47$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = (0, $61ae4f1203339483$export$71511d61b312f219)(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $89cb8fb509e52b47$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $89cb8fb509e52b47$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = (0, $61ae4f1203339483$export$71511d61b312f219)(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $89cb8fb509e52b47$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$89cb8fb509e52b47$export$971d5caa766a69d7(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$89cb8fb509e52b47$export$971d5caa766a69d7(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $89cb8fb509e52b47$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$89cb8fb509e52b47$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $89cb8fb509e52b47$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $89cb8fb509e52b47$var$routerId = 0;
function $89cb8fb509e52b47$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $89cb8fb509e52b47$var$routerId++;
    (0, $f8f651eebe4ca737$export$1f0daed17c8e64f)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        api.on.inspectComponent((payload)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $89cb8fb509e52b47$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $89cb8fb509e52b47$var$PINK_500
                });
            }
            if ((0, $61ae4f1203339483$export$39b482c5e57630a8)(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $89cb8fb509e52b47$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $89cb8fb509e52b47$var$RED_100;
                        textColor = $89cb8fb509e52b47$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $89cb8fb509e52b47$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $89cb8fb509e52b47$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $3dLyd.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $89cb8fb509e52b47$var$formatDisplay("beforeEach"),
                from: $89cb8fb509e52b47$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $89cb8fb509e52b47$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $89cb8fb509e52b47$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $89cb8fb509e52b47$var$formatDisplay("\u274C");
            } else data.status = $89cb8fb509e52b47$var$formatDisplay("\u2705");
            data.from = $89cb8fb509e52b47$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $89cb8fb509e52b47$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($89cb8fb509e52b47$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$89cb8fb509e52b47$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$89cb8fb509e52b47$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($89cb8fb509e52b47$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $89cb8fb509e52b47$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $89cb8fb509e52b47$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $89cb8fb509e52b47$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$89cb8fb509e52b47$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $89cb8fb509e52b47$var$PINK_500 = 15485081;
const $89cb8fb509e52b47$var$BLUE_600 = 2450411;
const $89cb8fb509e52b47$var$LIME_500 = 8702998;
const $89cb8fb509e52b47$var$CYAN_400 = 2282478;
const $89cb8fb509e52b47$var$ORANGE_400 = 16486972;
const $89cb8fb509e52b47$var$DARK = 6710886;
const $89cb8fb509e52b47$var$RED_100 = 16704226;
const $89cb8fb509e52b47$var$RED_700 = 12131356;
function $89cb8fb509e52b47$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $89cb8fb509e52b47$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $89cb8fb509e52b47$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $89cb8fb509e52b47$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $89cb8fb509e52b47$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $89cb8fb509e52b47$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $89cb8fb509e52b47$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($89cb8fb509e52b47$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($89cb8fb509e52b47$var$formatRouteRecordForInspector)
    };
}
let $89cb8fb509e52b47$var$routeRecordId = 0;
const $89cb8fb509e52b47$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $89cb8fb509e52b47$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $89cb8fb509e52b47$export$971d5caa766a69d7(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$89cb8fb509e52b47$export$971d5caa766a69d7(match, route.record));
    route.children.forEach((childRoute)=>$89cb8fb509e52b47$var$markRouteRecordActive(childRoute, currentRoute));
}
function $89cb8fb509e52b47$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($89cb8fb509e52b47$var$resetMatchStateOnRouteRecord);
}
function $89cb8fb509e52b47$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($89cb8fb509e52b47$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$89cb8fb509e52b47$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $89cb8fb509e52b47$export$35e795649ee09318(path);
    if (!(0, $61ae4f1203339483$export$dda1d9f60106f0e9)(filter) && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$89cb8fb509e52b47$var$isRouteMatching(child, filter));
}
function $89cb8fb509e52b47$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}



parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
var $SdEQh = parcelRequire("SdEQh");
//#region src/history/html5.ts
let $fa805f2f61c7b43d$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $fa805f2f61c7b43d$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $89cb8fb509e52b47$export$342063e11d6c3cad)(pathFromHash, "");
    }
    return (0, $89cb8fb509e52b47$export$342063e11d6c3cad)(pathname, base) + search + hash;
}
function $fa805f2f61c7b43d$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $fa805f2f61c7b43d$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: "pop",
                direction: delta ? delta > 0 ? "forward" : "back" : ""
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState((0, $61ae4f1203339483$export$ffb5f4729a158638)({}, history1.state, {
            scroll: (0, $89cb8fb509e52b47$export$953cecd6e717a553)()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $fa805f2f61c7b43d$var$buildState(back, current, forward, replaced = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: null
    };
}
function $fa805f2f61c7b43d$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    const currentLocation = {
        value: $fa805f2f61c7b43d$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $fa805f2f61c7b43d$var$createBaseLocation() + base + to;
        try {
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, history1.state, $fa805f2f61c7b43d$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, historyState.value, history1.state, {
            forward: to,
            scroll: (0, $89cb8fb509e52b47$export$953cecd6e717a553)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, $fa805f2f61c7b43d$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $fa805f2f61c7b43d$export$7b4942f78e7b8a49(base) {
    base = (0, $89cb8fb509e52b47$export$8b22cf2602fb60ce)(base);
    const historyNavigation = $fa805f2f61c7b43d$var$useHistoryStateNavigation(base);
    const historyListeners = $fa805f2f61c7b43d$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $61ae4f1203339483$export$ffb5f4729a158638)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $89cb8fb509e52b47$export$4a5767248b18ef41).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $fa805f2f61c7b43d$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $fa805f2f61c7b43d$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $fa805f2f61c7b43d$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            "",
            {}
        ]
    ];
    let position = 0;
    base = (0, $89cb8fb509e52b47$export$8b22cf2602fb60ce)(base);
    function setLocation(location1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: "pop"
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: "",
        state: {},
        base: base,
        createHref: (0, $89cb8fb509e52b47$export$4a5767248b18ef41).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    "",
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? "back" : "forward";
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/matcher/pathTokenizer.ts
const $fa805f2f61c7b43d$var$ROOT_TOKEN = {
    type: 0,
    value: ""
};
const $fa805f2f61c7b43d$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $fa805f2f61c7b43d$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $fa805f2f61c7b43d$var$ROOT_TOKEN
        ]
    ];
    if (!(0, $61ae4f1203339483$export$dda1d9f60106f0e9)(path)) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0) segment.push({
            type: 0,
            value: buffer
        });
        else if (state === 1 || state === 2 || state === 3) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        switch(state){
            case 0:
                if (char === "\\") {
                    previousState = state;
                    state = 4;
                } else if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1;
                } else addCharToBuffer();
                break;
            case 4:
                addCharToBuffer();
                state = previousState;
                break;
            case 1:
                if (char === "(") state = 2;
                else if ($fa805f2f61c7b43d$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3;
                } else customRe += char;
                break;
            case 3:
                consumeBuffer();
                state = 0;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
        }
    }
    if (state === 2) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $fa805f2f61c7b43d$var$BASE_PARAM_PATTERN = "[^/]+?";
const $fa805f2f61c7b43d$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
const $fa805f2f61c7b43d$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $fa805f2f61c7b43d$var$tokensToParser(segments, extraOptions) {
    const options = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, $fa805f2f61c7b43d$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            90
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = 40 + (options.sensitive ? .25 : 0);
            if (token.type === 0) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($fa805f2f61c7b43d$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40;
            } else if (token.type === 1) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $fa805f2f61c7b43d$var$BASE_PARAM_PATTERN;
                if (re !== $fa805f2f61c7b43d$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10;
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20;
                if (optional) subSegmentScore += -8;
                if (repeatable) subSegmentScore += -20;
                if (re === ".*") subSegmentScore += -50;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += .7000000000000001;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === 0) path += token.value;
            else if (token.type === 1) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $61ae4f1203339483$export$39b482c5e57630a8)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $61ae4f1203339483$export$39b482c5e57630a8)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $fa805f2f61c7b43d$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === 80 ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $fa805f2f61c7b43d$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $fa805f2f61c7b43d$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($fa805f2f61c7b43d$var$isLastScoreNegative(aScore)) return 1;
        if ($fa805f2f61c7b43d$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $fa805f2f61c7b43d$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $fa805f2f61c7b43d$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $fa805f2f61c7b43d$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $fa805f2f61c7b43d$var$tokensToParser($fa805f2f61c7b43d$var$tokenizePath(record.path), options);
    const matcher = (0, $61ae4f1203339483$export$ffb5f4729a158638)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $fa805f2f61c7b43d$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $61ae4f1203339483$export$4a5767248b18ef41)($fa805f2f61c7b43d$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $fa805f2f61c7b43d$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $61ae4f1203339483$export$4a5767248b18ef41)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($fa805f2f61c7b43d$var$normalizeRouteRecord((0, $61ae4f1203339483$export$ffb5f4729a158638)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && !(0, $61ae4f1203339483$export$dda1d9f60106f0e9)(path)) {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $fa805f2f61c7b43d$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$fa805f2f61c7b43d$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($fa805f2f61c7b43d$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $61ae4f1203339483$export$8b22cf2602fb60ce);
    }
    function removeRoute(matcherRef) {
        if ((0, $89cb8fb509e52b47$export$ffb5f4729a158638)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $fa805f2f61c7b43d$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$fa805f2f61c7b43d$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw (0, $61ae4f1203339483$export$3b14a55fb2447963)(1, {
                location: location1
            });
            name = matcher.record.name;
            params = (0, $61ae4f1203339483$export$ffb5f4729a158638)($fa805f2f61c7b43d$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location1.params && $fa805f2f61c7b43d$var$pickParams(location1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
                matcher.keys.forEach((key)=>{
                    if (key.optional && !params[key.name]) delete params[key.name];
                });
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $61ae4f1203339483$export$3b14a55fb2447963)(1, {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $fa805f2f61c7b43d$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $fa805f2f61c7b43d$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $fa805f2f61c7b43d$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $fa805f2f61c7b43d$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $fa805f2f61c7b43d$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $fa805f2f61c7b43d$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $fa805f2f61c7b43d$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $61ae4f1203339483$export$ffb5f4729a158638)(meta, record.meta), {});
}
function $fa805f2f61c7b43d$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $fa805f2f61c7b43d$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($fa805f2f61c7b43d$var$isSameParam.bind(null, key))) {
        (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0102({
            alias: b.record.path,
            original: a.record.path,
            name: key.name
        });
        return;
    }
    for (const key of b.keys)if (!key.optional && !a.keys.find($fa805f2f61c7b43d$var$isSameParam.bind(null, key))) {
        (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0102({
            alias: b.record.path,
            original: a.record.path,
            name: key.name
        });
        return;
    }
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $fa805f2f61c7b43d$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path && mainNormalizedRecord.children.length === 0) (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0103({
        name: String(parent.record.name)
    });
}
function $fa805f2f61c7b43d$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $fa805f2f61c7b43d$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($fa805f2f61c7b43d$var$isSameParam.bind(null, key))) {
        (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0104({
            path: record.record.path,
            name: key.name,
            parent: parent.record.path
        });
        return;
    }
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $fa805f2f61c7b43d$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($fa805f2f61c7b43d$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $fa805f2f61c7b43d$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $fa805f2f61c7b43d$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($fa805f2f61c7b43d$var$isMatchable(ancestor) && $fa805f2f61c7b43d$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $fa805f2f61c7b43d$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $fa805f2f61c7b43d$export$dcf14c9974fe2767(props) {
    const router = (0, $3dLyd.inject)((0, $61ae4f1203339483$export$407448d2b89b1813));
    const currentRoute = (0, $3dLyd.inject)((0, $61ae4f1203339483$export$23f2a1d2818174ef));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $3dLyd.computed)(()=>{
        const to = (0, $SdEQh.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $3dLyd.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $89cb8fb509e52b47$export$971d5caa766a69d7).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $fa805f2f61c7b43d$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $fa805f2f61c7b43d$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $89cb8fb509e52b47$export$971d5caa766a69d7).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $3dLyd.computed)(()=>activeRecordIndex.value > -1 && $fa805f2f61c7b43d$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $3dLyd.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $89cb8fb509e52b47$export$efccba1c4a2ef57b)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($fa805f2f61c7b43d$var$guardEvent(e)) {
            const p = router[(0, $SdEQh.unref)(props.replace) ? "replace" : "push"]((0, $SdEQh.unref)(props.to)).catch((0, $61ae4f1203339483$export$8b22cf2602fb60ce));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $89cb8fb509e52b47$export$d66501df72047452)) {
        const instance = (0, $3dLyd.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $3dLyd.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $89cb8fb509e52b47$export$2d1720544b23b823)((0, $SdEQh.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $3dLyd.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $fa805f2f61c7b43d$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
/**
* Component to render a link that triggers a navigation on click.
*/ const $fa805f2f61c7b43d$export$fce709ebdac448ed = /* @__PURE__ */ (0, $3dLyd.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $fa805f2f61c7b43d$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $SdEQh.reactive)($fa805f2f61c7b43d$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $3dLyd.inject)((0, $61ae4f1203339483$export$407448d2b89b1813));
        const elClass = (0, $3dLyd.computed)(()=>({
                [$fa805f2f61c7b43d$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$fa805f2f61c7b43d$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $fa805f2f61c7b43d$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $3dLyd.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
function $fa805f2f61c7b43d$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $fa805f2f61c7b43d$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if ((0, $61ae4f1203339483$export$39b482c5e57630a8)(innerValue)) {
            if (!(0, $61ae4f1203339483$export$39b482c5e57630a8)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
        } else if (innerValue !== outerValue) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $fa805f2f61c7b43d$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $fa805f2f61c7b43d$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $fa805f2f61c7b43d$var$RouterViewImpl = /*#__PURE__*/ (0, $3dLyd.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $3dLyd.inject)((0, $61ae4f1203339483$export$ae1af26003f05816));
        const routeToDisplay = (0, $3dLyd.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $3dLyd.inject)((0, $61ae4f1203339483$export$2408f22a0fab9ae5), 0);
        const depth = (0, $3dLyd.computed)(()=>{
            let initialDepth = (0, $SdEQh.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $3dLyd.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $3dLyd.provide)((0, $61ae4f1203339483$export$2408f22a0fab9ae5), (0, $3dLyd.computed)(()=>depth.value + 1));
        (0, $3dLyd.provide)((0, $61ae4f1203339483$export$43caf9889c228507), matchedRouteRef);
        (0, $3dLyd.provide)((0, $61ae4f1203339483$export$ae1af26003f05816), routeToDisplay);
        const viewRef = (0, $SdEQh.ref)();
        (0, $3dLyd.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, _oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $89cb8fb509e52b47$export$971d5caa766a69d7)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $fa805f2f61c7b43d$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $3dLyd.h)(ViewComponent, (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $89cb8fb509e52b47$export$d66501df72047452) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $61ae4f1203339483$export$39b482c5e57630a8)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    if (instance) instance.__vrv_devtools = info;
                });
            }
            return $fa805f2f61c7b43d$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $fa805f2f61c7b43d$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $fa805f2f61c7b43d$export$d941f00e9b9a537 = $fa805f2f61c7b43d$var$RouterViewImpl;
function $fa805f2f61c7b43d$var$warnDeprecatedUsage() {
    const instance = (0, $3dLyd.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $61ae4f1203339483$export$db3b6bfb95261072).VUE_ROUTER_R0060({
            comp: comp
        });
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $fa805f2f61c7b43d$export$baddd0131ee8c05b(options) {
    const matcher = $fa805f2f61c7b43d$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $89cb8fb509e52b47$export$3b14a55fb2447963);
    const stringifyQuery$1 = options.stringifyQuery || (0, $89cb8fb509e52b47$export$4368d992c4eafac0);
    const routerHistory = options.history;
    const beforeGuards = (0, $89cb8fb509e52b47$export$db3b6bfb95261072)();
    const beforeResolveGuards = (0, $89cb8fb509e52b47$export$db3b6bfb95261072)();
    const afterGuards = (0, $89cb8fb509e52b47$export$db3b6bfb95261072)();
    const currentRoute = (0, $SdEQh.shallowRef)((0, $89cb8fb509e52b47$export$25ce5a424b770e84));
    const routesVersion = (0, $SdEQh.shallowRef)(0);
    let pendingLocation = (0, $89cb8fb509e52b47$export$25ce5a424b770e84);
    if ((0, $89cb8fb509e52b47$export$d66501df72047452) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $61ae4f1203339483$export$2d1720544b23b823).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $61ae4f1203339483$export$2d1720544b23b823).bind(null, (0, $89cb8fb509e52b47$export$a07804094c3ecf2d));
    const decodeParams = (0, $61ae4f1203339483$export$2d1720544b23b823).bind(null, (0, $89cb8fb509e52b47$export$35e795649ee09318));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $89cb8fb509e52b47$export$ffb5f4729a158638)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        const removeRoute = matcher.addRoute(record, parent);
        routesVersion.value++;
        return ()=>{
            removeRoute();
            routesVersion.value++;
        };
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) {
            matcher.removeRoute(recordMatcher);
            routesVersion.value++;
        }
    }
    function clearRoutes() {
        matcher.clearRoutes();
        routesVersion.value++;
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        routesVersion.value;
        if (typeof rawLocation === "string") {
            currentLocation = currentLocation || (rawLocation.startsWith("/") ? (0, $89cb8fb509e52b47$export$25ce5a424b770e84) : currentRoute.value);
            const locationNormalized = (0, $89cb8fb509e52b47$export$a9c23c6ac3fc3eca)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $61ae4f1203339483$export$ffb5f4729a158638)(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                redirectedFrom: void 0,
                href: href
            });
        }
        currentLocation = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, currentLocation || (rawLocation.path != null && rawLocation.path.startsWith("/") && !("name" in rawLocation && rawLocation.name) ? (0, $89cb8fb509e52b47$export$25ce5a424b770e84) : currentRoute.value));
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, rawLocation, {
            path: (0, $89cb8fb509e52b47$export$a9c23c6ac3fc3eca)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $89cb8fb509e52b47$export$c4ce752e73470fba)(stringifyQuery$1, (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, rawLocation, {
            hash: (0, $89cb8fb509e52b47$export$3a1a48c8f6ef640e)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $61ae4f1203339483$export$ffb5f4729a158638)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $89cb8fb509e52b47$export$4368d992c4eafac0) ? (0, $89cb8fb509e52b47$export$882b5998b3b9117c)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $89cb8fb509e52b47$export$a9c23c6ac3fc3eca)(parseQuery$1, to, currentRoute.value.path) : (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $61ae4f1203339483$export$3b14a55fb2447963)(8, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $61ae4f1203339483$export$ffb5f4729a158638)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $61ae4f1203339483$export$ffb5f4729a158638)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $61ae4f1203339483$export$ffb5f4729a158638)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $89cb8fb509e52b47$export$e7094788287c5e9b)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $61ae4f1203339483$export$3b14a55fb2447963)(16, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $61ae4f1203339483$export$4368d992c4eafac0)(error) ? (0, $61ae4f1203339483$export$4368d992c4eafac0)(error, 2) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ((0, $61ae4f1203339483$export$4368d992c4eafac0)(failure, 2)) return pushWithRedirect((0, $61ae4f1203339483$export$ffb5f4729a158638)({
                    replace: replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? (0, $61ae4f1203339483$export$ffb5f4729a158638)({}, data, failure.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $89cb8fb509e52b47$export$7ccc53e8f1e7dfc5)(to, from);
        guards = (0, $89cb8fb509e52b47$export$43caf9889c228507)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $89cb8fb509e52b47$export$43caf9889c228507)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $61ae4f1203339483$export$39b482c5e57630a8)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(beforeEnter, to, from));
                else guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $89cb8fb509e52b47$export$43caf9889c228507)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $89cb8fb509e52b47$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $61ae4f1203339483$export$4368d992c4eafac0)(err, 8) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $89cb8fb509e52b47$export$25ce5a424b770e84);
        const state = !(0, $89cb8fb509e52b47$export$d66501df72047452) ? {} : history.state;
        if (isPush) {
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $61ae4f1203339483$export$ffb5f4729a158638)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $61ae4f1203339483$export$ffb5f4729a158638)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $61ae4f1203339483$export$8b22cf2602fb60ce));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if ((0, $89cb8fb509e52b47$export$d66501df72047452) && info.delta) (0, $89cb8fb509e52b47$export$71511d61b312f219)((0, $89cb8fb509e52b47$export$39b482c5e57630a8)(from.fullPath, info.delta));
            navigate(toLocation, from).catch((error)=>{
                if ((0, $61ae4f1203339483$export$4368d992c4eafac0)(error, 12)) return error;
                if ((0, $61ae4f1203339483$export$4368d992c4eafac0)(error, 2)) {
                    pushWithRedirect((0, $61ae4f1203339483$export$ffb5f4729a158638)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $61ae4f1203339483$export$4368d992c4eafac0)(failure, 20) && !info.delta && info.type === "pop") routerHistory.go(-1, false);
                    }).catch((0, $61ae4f1203339483$export$8b22cf2602fb60ce));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $61ae4f1203339483$export$4368d992c4eafac0)(failure, 8)) routerHistory.go(-info.delta, false);
                    else if (info.type === "pop" && (0, $61ae4f1203339483$export$4368d992c4eafac0)(failure, 20)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $61ae4f1203339483$export$8b22cf2602fb60ce));
        });
    }
    let readyHandlers = (0, $89cb8fb509e52b47$export$db3b6bfb95261072)();
    let errorListeners = (0, $89cb8fb509e52b47$export$db3b6bfb95261072)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $89cb8fb509e52b47$export$25ce5a424b770e84)) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $89cb8fb509e52b47$export$d66501df72047452) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $89cb8fb509e52b47$export$dda1d9f60106f0e9)((0, $89cb8fb509e52b47$export$39b482c5e57630a8)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $3dLyd.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>to === currentRoute.value && position && (0, $89cb8fb509e52b47$export$90a7f3efeed30595)(position)).catch((err)=>to === currentRoute.value && triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $fa805f2f61c7b43d$export$fce709ebdac448ed);
            app.component("RouterView", $fa805f2f61c7b43d$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $SdEQh.unref)(currentRoute)
            });
            if ((0, $89cb8fb509e52b47$export$d66501df72047452) && !started && currentRoute.value === (0, $89cb8fb509e52b47$export$25ce5a424b770e84)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $89cb8fb509e52b47$export$25ce5a424b770e84)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $61ae4f1203339483$export$407448d2b89b1813), router);
            app.provide((0, $61ae4f1203339483$export$23f2a1d2818174ef), (0, $SdEQh.shallowReactive)(reactiveRoute));
            app.provide((0, $61ae4f1203339483$export$ae1af26003f05816), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $89cb8fb509e52b47$export$25ce5a424b770e84);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $89cb8fb509e52b47$export$25ce5a424b770e84);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $89cb8fb509e52b47$export$d66501df72047452) && true) (0, $89cb8fb509e52b47$export$625550452a3fa3ec)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}


parcelRequire("dKmBq");
var $hTNas = parcelRequire("hTNas");
parcelRequire("4Bs72");
var $8se3f = parcelRequire("8se3f");
var $dOOCA = parcelRequire("dOOCA");
var $9SF3p = parcelRequire("9SF3p");
var $8i16b = parcelRequire("8i16b");
parcelRequire("dKmBq");
var $hTNas = parcelRequire("hTNas");
parcelRequire("cjZH9");
var $12X8W = parcelRequire("12X8W");
var $cf40dc541c3cba27$exports = {};


parcelRequire("qHBj0");
var $9MuMq = parcelRequire("9MuMq");
parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
var $055070e3d0465793$var$_TSX;
let $055070e3d0465793$var$_initClass, $055070e3d0465793$var$_msgDecs, $055070e3d0465793$var$_init_msg;
function $055070e3d0465793$var$_applyDecs(e, t, r, n, o, a) {
    function i(e, t, r) {
        return function(n, o) {
            return r && r(n), e[t].call(n, o);
        };
    }
    function c(e, t) {
        for(var r = 0; r < e.length; r++)e[r].call(t);
        return t;
    }
    function s(e, t, r, n) {
        if ("function" != typeof e && (n || void 0 !== e)) throw new TypeError(t + " must " + (r || "be") + " a function" + (n ? "" : " or undefined"));
        return e;
    }
    function applyDec(e, t, r, n, o, a, c, u, l, f, p, d, h) {
        function m(e) {
            if (!h(e)) throw new TypeError("Attempted to access private element on non-instance");
        }
        var y, v = t[0], g = t[3], b = !u;
        if (!b) {
            r || Array.isArray(v) || (v = [
                v
            ]);
            var w = {}, S = [], A = 3 === o ? "get" : 4 === o || d ? "set" : "value";
            f ? (p || d ? w = {
                get: $055070e3d0465793$var$_setFunctionName(function() {
                    return g(this);
                }, n, "get"),
                set: function(e) {
                    t[4](this, e);
                }
            } : w[A] = g, p || $055070e3d0465793$var$_setFunctionName(w[A], n, 2 === o ? "" : A)) : p || (w = Object.getOwnPropertyDescriptor(e, n));
        }
        for(var P = e, j = v.length - 1; j >= 0; j -= r ? 2 : 1){
            var D = v[j], E = r ? v[j - 1] : void 0, I = {}, O = {
                kind: [
                    "field",
                    "accessor",
                    "method",
                    "getter",
                    "setter",
                    "class"
                ][o],
                name: n,
                metadata: a,
                addInitializer: (function(e, t) {
                    if (e.v) throw Error("attempted to call addInitializer after decoration was finished");
                    s(t, "An initializer", "be", !0), c.push(t);
                }).bind(null, I)
            };
            try {
                if (b) (y = s(D.call(E, P, O), "class decorators", "return")) && (P = y);
                else {
                    var k, F;
                    O.static = l, O.private = f, f ? 2 === o ? k = function(e) {
                        return m(e), w.value;
                    } : (o < 4 && (k = i(w, "get", m)), 3 !== o && (F = i(w, "set", m))) : (k = function(e) {
                        return e[n];
                    }, (o < 2 || 4 === o) && (F = function(e, t) {
                        e[n] = t;
                    }));
                    var N = O.access = {
                        has: f ? h.bind() : function(e) {
                            return n in e;
                        }
                    };
                    if (k && (N.get = k), F && (N.set = F), P = D.call(E, d ? {
                        get: w.get,
                        set: w.set
                    } : w[A], O), d) {
                        if ("object" == typeof P && P) (y = s(P.get, "accessor.get")) && (w.get = y), (y = s(P.set, "accessor.set")) && (w.set = y), (y = s(P.init, "accessor.init")) && S.push(y);
                        else if (void 0 !== P) throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
                    } else s(P, (p ? "field" : "method") + " decorators", "return") && (p ? S.push(P) : w[A] = P);
                }
            } finally{
                I.v = !0;
            }
        }
        return (p || d) && u.push(function(e, t) {
            for(var r = S.length - 1; r >= 0; r--)t = S[r].call(e, t);
            return t;
        }), p || b || (f ? d ? u.push(i(w, "get"), i(w, "set")) : u.push(2 === o ? w[A] : i.call.bind(w[A])) : Object.defineProperty(e, n, w)), P;
    }
    function u(e, t) {
        return Object.defineProperty(e, Symbol.metadata || Symbol.for("Symbol.metadata"), {
            configurable: !0,
            enumerable: !0,
            value: t
        });
    }
    if (arguments.length >= 6) var l = a[Symbol.metadata || Symbol.for("Symbol.metadata")];
    var f = Object.create(null == l ? null : l), p = function(e, t, r, n) {
        var o, a, i = [], s = function(t) {
            return $055070e3d0465793$var$_checkInRHS(t) === e;
        }, u = new Map();
        function l(e) {
            e && i.push(c.bind(null, e));
        }
        for(var f = 0; f < t.length; f++){
            var p = t[f];
            if (Array.isArray(p)) {
                var d = p[1], h = p[2], m = p.length > 3, y = 16 & d, v = !!(8 & d), g = 0 == (d &= 7), b = h + "/" + v;
                if (!g && !m) {
                    var w = u.get(b);
                    if (!0 === w || 3 === w && 4 !== d || 4 === w && 3 !== d) throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + h);
                    u.set(b, !(d > 2) || d);
                }
                applyDec(v ? e : e.prototype, p, y, m ? "#" + h : $055070e3d0465793$var$_toPropertyKey(h), d, n, v ? a = a || [] : o = o || [], i, v, m, g, 1 === d, v && m ? s : r);
            }
        }
        return l(o), l(a), i;
    }(e, t, o, f);
    return r.length || u(e, f), {
        e: p,
        get c () {
            var t1 = [];
            return r.length && [
                u(applyDec(e, [
                    r
                ], n, e.name, 5, f, t1), f),
                c.bind(null, t1, e)
            ];
        }
    };
}
function $055070e3d0465793$var$_toPropertyKey(t) {
    var i = $055070e3d0465793$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $055070e3d0465793$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $055070e3d0465793$var$_setFunctionName(e, t, n) {
    "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
    try {
        Object.defineProperty(e, "name", {
            configurable: !0,
            value: n ? n + " " + t : t
        });
    } catch (e) {}
    return e;
}
function $055070e3d0465793$var$_checkInRHS(e) {
    if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
    return e;
}
const $055070e3d0465793$var$_hoisted_1 = [
    "onClick"
];
let $055070e3d0465793$var$_HelloWorld;
class $055070e3d0465793$var$HelloWorld extends ($055070e3d0465793$var$_TSX = (0, $9SF3p.TSX)()((0, $8i16b.Base))) {
    static{
        ({ e: [$055070e3d0465793$var$_init_msg], c: [$055070e3d0465793$var$_HelloWorld, $055070e3d0465793$var$_initClass] } = $055070e3d0465793$var$_applyDecs(this, [
            [
                $055070e3d0465793$var$_msgDecs,
                0,
                "msg"
            ]
        ], [
            (0, $8se3f.ComponentBase),
            (0, $hTNas.observer)
        ], 0, void 0, $055070e3d0465793$var$_TSX));
    }
    [($055070e3d0465793$var$_msgDecs = (0, $dOOCA.decorator)({
        type: String,
        required: true
    }), "msg")] = $055070e3d0465793$var$_init_msg(this);
    count = 0;
    render() {
        return (()=>{
            const _cache = (0, $9MuMq.createVNodeCache)("12d7e2a11fd17a6a");
            return (0, $3dLyd.openBlock)(), (0, $3dLyd.createElementBlock)("div", {
                class: (0, $9MuMq.normalizeClass)($cf40dc541c3cba27$exports)
            }, [
                (0, $3dLyd.createElementVNode)("h1", null, [
                    (0, $9MuMq.normalizeVNode)(()=>this.msg)
                ]),
                _cache[1] || (_cache[1] = (0, $3dLyd.createElementVNode)("p", null, [
                    (0, $9MuMq.normalizeVNode)("See "),
                    (0, $3dLyd.createElementVNode)("code", null, "README.md"),
                    (0, $9MuMq.normalizeVNode)(" for more information.")
                ], -1)),
                _cache[2] || (_cache[2] = (0, $3dLyd.createElementVNode)("p", null, [
                    (0, $3dLyd.createElementVNode)("a", {
                        href: "https://parceljs.org/languages/vue/",
                        target: "_blank"
                    }, "Parcel docs"),
                    (0, $9MuMq.normalizeVNode)(" | "),
                    (0, $3dLyd.createElementVNode)("a", {
                        href: "https://v3.vuejs.org/",
                        target: "_blank"
                    }, "Vue 3 docs")
                ], -1)),
                (0, $3dLyd.createVNode)((0, $12X8W.default), {
                    asChild: true
                }, {
                    default: (0, $3dLyd.withCtx)(()=>[
                            (0, $3dLyd.createElementVNode)("button", {
                                type: "button",
                                onClick: ()=>this.count++
                            }, [
                                _cache[0] || (_cache[0] = (0, $9MuMq.normalizeVNode)("count is: ", -1)),
                                (0, $9MuMq.normalizeVNode)(()=>this.count)
                            ], 8, $055070e3d0465793$var$_hoisted_1)
                        ]),
                    _: 1
                }),
                _cache[3] || (_cache[3] = (0, $3dLyd.createElementVNode)("p", null, [
                    (0, $9MuMq.normalizeVNode)("Edit "),
                    (0, $3dLyd.createElementVNode)("code", null, "components/HelloWorld.vue"),
                    (0, $9MuMq.normalizeVNode)(" to test hot module\n          replacement.")
                ], -1))
            ], 2);
        })();
    }
    static{
        $055070e3d0465793$var$_initClass();
    }
}
var $055070e3d0465793$export$2e2bcd8739ae039 = (0, $8se3f.toNative)($055070e3d0465793$var$_HelloWorld);


parcelRequire("fyBkV");
var $3dLyd = parcelRequire("3dLyd");
const $b2ef96db5c48e8ca$var$_hoisted_1 = {
    class: "home text-center"
};
const $b2ef96db5c48e8ca$var$_hoisted_2 = [
    "src"
];
var $1fd10bde6090c9b7$exports = {};
$1fd10bde6090c9b7$exports = $parcel$resolve("fcSXM");


const $b2ef96db5c48e8ca$var$VueLogo = new URL($1fd10bde6090c9b7$exports) + "";
var $b2ef96db5c48e8ca$export$2e2bcd8739ae039 = (0, $hTNas.observer)(()=>((0, $3dLyd.openBlock)(), (0, $3dLyd.createElementBlock)("div", $b2ef96db5c48e8ca$var$_hoisted_1, [
        (0, $3dLyd.createElementVNode)("img", {
            class: "mx-auto block",
            alt: "Vue logo",
            src: $b2ef96db5c48e8ca$var$VueLogo
        }, null, 8, $b2ef96db5c48e8ca$var$_hoisted_2),
        (0, $3dLyd.createVNode)((0, $055070e3d0465793$export$2e2bcd8739ae039), {
            msg: "Welcome to Your Vue.js + MobX + TypeScript + ShadcnVue App"
        })
    ])));







var $c78cf593db97f1b1$export$2e2bcd8739ae039 = (0, $fa805f2f61c7b43d$export$baddd0131ee8c05b)({
    history: (0, $fa805f2f61c7b43d$export$542bc3a76486c94d)(),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: (0, $b2ef96db5c48e8ca$export$2e2bcd8739ae039)
        },
        {
            path: '/decorator/class',
            component: ()=>(parcelRequire("9zQkT"))
        },
        {
            path: '/decorator/function',
            component: ()=>(parcelRequire("6hmVd"))
        },
        {
            path: '/component',
            component: ()=>(parcelRequire("7uyTa"))
        },
        {
            path: '/chart',
            component: ()=>(parcelRequire("wJQL0"))
        },
        {
            path: '/about',
            name: 'About',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: ()=>(parcelRequire("eRqW7"))
        }
    ]
});



(0, $de9addb89ca41b61$export$dfb5619354ba860)();
(0, $cF2Ke.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', ({ reason: reason })=>{
    const { message: message } = reason;
    if (message) self.alert(message);
});
const { serviceWorker: $92b0511fb3ec8148$var$serviceWorker } = window.navigator, $92b0511fb3ec8148$var$NODE_ENV = "production";
if ($92b0511fb3ec8148$var$NODE_ENV !== 'development') $92b0511fb3ec8148$var$serviceWorker?.register('sw.js').then((0, $5hfm1.serviceWorkerUpdate)).then((worker)=>{
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$92b0511fb3ec8148$var$serviceWorker?.addEventListener('controllerchange', ()=>window.location.reload());
(0, $bmuEm.createApp)((0, $e373b8c25d764efb$export$2e2bcd8739ae039)).use((0, $c78cf593db97f1b1$export$2e2bcd8739ae039)).mount('#app');


//# sourceMappingURL=Vue-MobX-Shadcn-ts.531d57e9.js.map
